(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2030],{

/***/ 33920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61395);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84838);
/* harmony import */ var _NotFoundPage_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77057);
/* harmony import */ var _NotFoundPage_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_NotFoundPage_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57611);







var NotFoundPage = function NotFoundPage(_ref) {
  var data = _ref.data,
      withTranslate = _ref.withTranslate;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var content = {
    title: withTranslate ? t(data === null || data === void 0 ? void 0 : data.title, {
      q: "\"".concat(router.query.q, "\"")
    }) : data === null || data === void 0 ? void 0 : data.title,
    text: withTranslate ? t(data === null || data === void 0 ? void 0 : data.description) : data === null || data === void 0 ? void 0 : data.description,
    buttonText: data === null || data === void 0 ? void 0 : data.button_text
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: (_NotFoundPage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: 'wrapper',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_ui__WEBPACK_IMPORTED_MODULE_3__/* .InformationBlock */ .fW, {
        icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
          src: data === null || data === void 0 ? void 0 : data.icon,
          alt: withTranslate ? t(data === null || data === void 0 ? void 0 : data.title) : data === null || data === void 0 ? void 0 : data.title,
          title: withTranslate ? t(data === null || data === void 0 ? void 0 : data.title) : data === null || data === void 0 ? void 0 : data.title,
          width: 180,
          height: 75,
          loading: "lazy"
        }),
        content: content
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (NotFoundPage);

/***/ }),

/***/ 3686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57611);



var CardShapes = function CardShapes() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    width: "349",
    height: "220",
    viewBox: "0 0 349 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter0_f_1241_697)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M281.114 177.782L269.548 137.918C268.809 135.368 269.748 132.632 271.9 131.06L325.556 91.93C327.847 90.2607 330.975 90.3029 333.223 92.0325L385.679 132.512C389.546 135.495 388.716 141.521 384.188 143.365L289.642 181.88C286.138 183.309 282.162 181.398 281.114 177.776V177.782Z",
        fill: "url(#paint0_linear_1241_697)",
        fillOpacity: "0.6"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter1_f_1241_697)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M174.485 114.135L198.855 132.127C200.995 133.707 201.922 136.451 201.17 138.995L185.421 192.436C184.439 195.777 180.923 197.7 177.558 196.741L127.993 182.632C123.774 181.432 122.01 176.439 124.556 172.876L165.5 115.558C167.568 112.663 171.617 112.024 174.485 114.141V114.135Z",
        fill: "url(#paint1_linear_1241_697)",
        fillOpacity: "0.6"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter2_f_1241_697)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M230.041 163.977L201.864 184.973C199.988 186.372 199.031 188.686 199.37 190.999L211.431 273.001H383.972L237.631 163.977C235.379 162.299 232.292 162.299 230.041 163.977Z",
        fill: "url(#paint2_linear_1241_697)",
        fillOpacity: "0.6"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter3_f_1241_697)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M5 -9L157.587 104.558C159.044 105.647 160.907 106.052 162.691 105.677L207.06 96.2775C209.346 95.7936 211.178 94.0939 211.838 91.8498L241.4 -9H5Z",
        fill: "url(#paint3_linear_1241_697)",
        fillOpacity: "0.6"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter4_f_1241_697)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M320.319 -9L246.981 49.7452C244.96 51.3605 244.124 54.0405 244.863 56.5148L252.192 81.1311C253.136 84.2951 256.35 86.2129 259.582 85.5353L393.151 57.6451V-9H320.319Z",
        fill: "url(#paint4_linear_1241_697)",
        fillOpacity: "0.6"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
        id: "filter0_f_1241_697",
        x: "264.299",
        y: "85.7061",
        width: "128.842",
        height: "101.649",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_1241_697"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
        id: "filter1_f_1241_697",
        x: "118.375",
        y: "107.892",
        width: "88.0527",
        height: "94.0967",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_1241_697"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
        id: "filter2_f_1241_697",
        x: "194.303",
        y: "157.719",
        width: "194.67",
        height: "120.282",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_1241_697"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
        id: "filter3_f_1241_697",
        x: "0",
        y: "-14",
        width: "246.4",
        height: "124.814",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_1241_697"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
        id: "filter4_f_1241_697",
        x: "239.598",
        y: "-14",
        width: "158.553",
        height: "104.671",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_1241_697"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "paint0_linear_1241_697",
        x1: "258.744",
        y1: "130.471",
        x2: "417.34",
        y2: "115.52",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "paint1_linear_1241_697",
        x1: "116.443",
        y1: "149.379",
        x2: "221.055",
        y2: "142.32",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "paint2_linear_1241_697",
        x1: "182.901",
        y1: "210.567",
        x2: "427.903",
        y2: "180.742",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "paint3_linear_1241_697",
        x1: "-15.9962",
        y1: "40.815",
        x2: "295.31",
        y2: "-5.78347",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
        id: "paint4_linear_1241_697",
        x1: "231.404",
        y1: "32.0755",
        x2: "428.842",
        y2: "9.5526",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          stopColor: "white"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CardShapes);

/***/ }),

/***/ 32378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ NewDropdownCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57611);

var NewDropdownCard = function NewDropdownCard() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 7.82843L20 19C20 20.6569 18.6569 22 17 22L7 22C5.34315 22 4 20.6569 4 19L4 5C4 3.34315 5.34315 2 7 2L14.1716 2C14.9672 2 15.7303 2.31607 16.2929 2.87868L19.1213 5.70711C19.6839 6.26972 20 7.03278 20 7.82843ZM18 19L18 7.82843C18 7.56321 17.8946 7.30886 17.7071 7.12132L14.8787 4.29289C14.6911 4.10536 14.4368 4 14.1716 4L7 4C6.44771 4 6 4.44771 6 5L6 19C6 19.5523 6.44771 20 7 20L17 20C17.5523 20 18 19.5523 18 19ZM16 14.5L16 18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18L14 14.5C14 13.9477 14.4477 13.5 15 13.5C15.5523 13.5 16 13.9477 16 14.5ZM15 10C15.5523 10 16 10.4477 16 11L16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12L14 11C14 10.4477 14.4477 10 15 10ZM12 16C12.5523 16 13 16.4477 13 17L13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18L11 17C11 16.4477 11.4477 16 12 16ZM12 10C12.5523 10 13 10.4477 13 11L13 14.5C13 15.0523 12.5523 15.5 12 15.5C11.4477 15.5 11 15.0523 11 14.5L11 11C11 10.4477 11.4477 10 12 10ZM9 10C9.55229 10 10 10.4477 10 11L10 12C10 12.5523 9.55229 13 9 13C8.44772 13 8 12.5523 8 12L8 11C8 10.4477 8.44772 10 9 10ZM9 13.5C9.55229 13.5 10 13.9477 10 14.5L10 18C10 18.5523 9.55229 19 9 19C8.44772 19 8 18.5523 8 18L8 14.5C8 13.9477 8.44772 13.5 9 13.5Z",
      fill: "#200000"
    })
  });
};

/***/ }),

/***/ 85928:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M39.666 5.67H16.333c-7 0-11.667 4.667-11.667 11.667v14c0 7 4.667 11.666 11.667 11.666v4.97c0 1.867 2.076 2.987 3.616 1.937l10.384-6.907h9.333c7 0 11.667-4.666 11.667-11.666v-14c0-7-4.667-11.667-11.667-11.667ZM27.999 34.067c-.98 0-1.75-.794-1.75-1.75 0-.957.77-1.75 1.75-1.75s1.75.793 1.75 1.75c0 .956-.77 1.75-1.75 1.75Zm2.94-9.684c-.91.607-1.19 1.004-1.19 1.657v.49c0 .957-.793 1.75-1.75 1.75-.956 0-1.75-.793-1.75-1.75v-.49c0-2.707 1.984-4.037 2.73-4.55.864-.583 1.144-.98 1.144-1.587a2.131 2.131 0 0 0-2.124-2.123 2.131 2.131 0 0 0-2.123 2.123c0 .957-.793 1.75-1.75 1.75s-1.75-.793-1.75-1.75a5.626 5.626 0 0 1 5.623-5.623 5.626 5.626 0 0 1 5.624 5.623c0 2.66-1.96 3.99-2.684 4.48Z",
      fill: "#E00034"
    })
  }));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SvgQuestion)));

/***/ }),

/***/ 37726:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Additional, AdditionalMini, Bag, Balance, BalanceMini, Call, CallMini, Fire, FireMini, Internet, Money, MoneyMini, Question, Sms, SmsMini, Star

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/SvgComponents/section/AdditionalMini.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgAdditionalMini = function SvgAdditionalMini(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.333 22.333h-3v-3c0-.546-.453-1-1-1-.547 0-1 .454-1 1v3h-3c-.547 0-1 .454-1 1 0 .547.453 1 1 1h3v3c0 .547.453 1 1 1 .547 0 1-.453 1-1v-3h3c.547 0 1-.453 1-1 0-.546-.453-1-1-1ZM29.333 11.36V5.307c0-1.88-.853-2.64-2.973-2.64h-5.387c-2.12 0-2.973.76-2.973 2.64v6.04c0 1.893.853 2.64 2.973 2.64h5.387c2.12.013 2.973-.747 2.973-2.627ZM14 11.36V5.307c0-1.88-.853-2.64-2.973-2.64H5.64c-2.12 0-2.973.76-2.973 2.64v6.04c0 1.893.853 2.64 2.973 2.64h5.387C13.147 14 14 13.24 14 11.36ZM14 26.36v-5.387c0-2.12-.853-2.973-2.973-2.973H5.64c-2.12 0-2.973.853-2.973 2.973v5.387c0 2.12.853 2.973 2.973 2.973h5.387c2.12 0 2.973-.853 2.973-2.973Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var AdditionalMini = ((/* unused pure expression or super */ null && (SvgAdditionalMini)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Additional.js


function Additional_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Additional_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Additional_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Additional_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgAdditional = function SvgAdditional(props) {
  return /*#__PURE__*/_jsx("svg", Additional_objectSpread(Additional_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M47.832 39.083h-5.25v-5.25c0-.956-.793-1.75-1.75-1.75s-1.75.794-1.75 1.75v5.25h-5.25c-.957 0-1.75.794-1.75 1.75 0 .957.793 1.75 1.75 1.75h5.25v5.25c0 .957.793 1.75 1.75 1.75s1.75-.793 1.75-1.75v-5.25h5.25c.957 0 1.75-.793 1.75-1.75 0-.956-.793-1.75-1.75-1.75ZM51.333 19.88V9.287c0-3.29-1.493-4.62-5.203-4.62h-9.427c-3.71 0-5.203 1.33-5.203 4.62v10.57c0 3.313 1.493 4.62 5.203 4.62h9.427c3.71.023 5.203-1.307 5.203-4.597ZM24.501 19.88V9.287c0-3.29-1.493-4.62-5.203-4.62H9.871c-3.71 0-5.203 1.33-5.203 4.62v10.57c0 3.313 1.493 4.62 5.203 4.62h9.427c3.71.023 5.203-1.307 5.203-4.597ZM24.501 46.13v-9.427c0-3.71-1.493-5.203-5.203-5.203H9.871c-3.71 0-5.203 1.493-5.203 5.203v9.427c0 3.71 1.493 5.203 5.203 5.203h9.427c3.71 0 5.203-1.493 5.203-5.203Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var Additional = ((/* unused pure expression or super */ null && (SvgAdditional)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Bag.js


function Bag_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Bag_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Bag_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Bag_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/_jsx("svg", Bag_objectSpread(Bag_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M44.893 13.02h-.933l-7.887-7.887c-.63-.63-1.657-.63-2.31 0-.63.63-.63 1.657 0 2.31l5.577 5.577H16.66l5.576-5.577c.63-.63.63-1.656 0-2.31-.63-.63-1.656-.63-2.31 0l-7.863 7.887h-.933c-2.1 0-6.464 0-6.464 5.973 0 2.264.467 3.757 1.447 4.737.56.583 1.237.887 1.96 1.05.677.163 1.4.187 2.1.187h35.654c.723 0 1.4-.047 2.053-.187 1.96-.467 3.453-1.867 3.453-5.787 0-5.973-4.363-5.973-6.44-5.973ZM44.45 28H11.363a2.33 2.33 0 0 0-2.31 2.707l1.96 11.993c.654 4.013 2.404 8.633 10.174 8.633h13.09c7.863 0 9.263-3.943 10.103-8.353l2.357-12.203A2.325 2.325 0 0 0 44.45 28ZM24.757 43.05c0 .91-.724 1.633-1.61 1.633-.91 0-1.634-.723-1.634-1.633v-7.7c0-.887.724-1.633 1.634-1.633.886 0 1.61.746 1.61 1.633v7.7Zm9.986 0c0 .91-.723 1.633-1.633 1.633a1.638 1.638 0 0 1-1.633-1.633v-7.7c0-.887.746-1.633 1.633-1.633.91 0 1.633.746 1.633 1.633v7.7Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var Bag = ((/* unused pure expression or super */ null && (SvgBag)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/BalanceMini.js


function BalanceMini_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function BalanceMini_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BalanceMini_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BalanceMini_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgBalanceMini = function SvgBalanceMini(props) {
  return /*#__PURE__*/_jsx("svg", BalanceMini_objectSpread(BalanceMini_objectSpread({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M21.04 2.667H10.96c-5.04 0-6.293 1.346-6.293 6.72V24.4c0 3.547 1.947 4.387 4.307 1.853l.013-.013c1.093-1.16 2.76-1.067 3.707.2l1.346 1.8c1.08 1.427 2.827 1.427 3.907 0l1.347-1.8c.96-1.28 2.626-1.373 3.72-.2 2.373 2.533 4.306 1.693 4.306-1.853v-15c.014-5.374-1.24-6.72-6.28-6.72Zm-1.04 13h-8c-.546 0-1-.454-1-1 0-.547.454-1 1-1h8c.547 0 1 .453 1 1 0 .546-.453 1-1 1Zm1.334-5.334H10.667c-.547 0-1-.453-1-1 0-.546.453-1 1-1h10.667c.546 0 1 .454 1 1 0 .547-.454 1-1 1Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var BalanceMini = ((/* unused pure expression or super */ null && (SvgBalanceMini)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Balance.js


function Balance_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Balance_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Balance_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Balance_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgBalance = function SvgBalance(props) {
  return /*#__PURE__*/_jsx("svg", Balance_objectSpread(Balance_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M36.821 4.667h-17.64c-8.82 0-11.013 2.356-11.013 11.76V42.7c0 6.207 3.407 7.677 7.537 3.243l.023-.023c1.913-2.03 4.83-1.867 6.487.35l2.356 3.15c1.89 2.497 4.947 2.497 6.837 0l2.357-3.15c1.68-2.24 4.596-2.403 6.51-.35 4.153 4.433 7.536 2.963 7.536-3.243v-26.25c.024-9.404-2.17-11.76-10.99-11.76Zm-1.82 22.75h-14c-.956 0-1.75-.794-1.75-1.75 0-.957.794-1.75 1.75-1.75h14c.957 0 1.75.793 1.75 1.75 0 .956-.793 1.75-1.75 1.75Zm2.334-9.334H18.668c-.957 0-1.75-.793-1.75-1.75 0-.956.793-1.75 1.75-1.75h18.667c.956 0 1.75.794 1.75 1.75 0 .957-.794 1.75-1.75 1.75Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var Balance = ((/* unused pure expression or super */ null && (SvgBalance)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/CallMini.js


function CallMini_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CallMini_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CallMini_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CallMini_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgCallMini = function SvgCallMini(props) {
  return /*#__PURE__*/_jsx("svg", CallMini_objectSpread(CallMini_objectSpread({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.734 19.933 12.267 22.4a1.34 1.34 0 0 1-1.88.013c-.147-.146-.293-.28-.44-.426a37.888 37.888 0 0 1-3.72-4.36c-1.093-1.52-1.973-3.04-2.613-4.547-.627-1.52-.947-2.973-.947-4.36 0-.907.16-1.773.48-2.573.32-.814.827-1.56 1.533-2.227.854-.84 1.787-1.253 2.774-1.253.373 0 .746.08 1.08.24.346.16.653.4.893.746l3.093 4.36c.24.334.414.64.534.934.12.28.186.56.186.813 0 .32-.093.64-.28.947a4.535 4.535 0 0 1-.746.946L11.2 12.707a.714.714 0 0 0-.213.533c0 .107.013.2.04.307.04.106.08.186.107.266.24.44.653 1.014 1.24 1.707.6.693 1.24 1.4 1.933 2.107.133.133.28.266.413.4.534.52.547 1.373.014 1.906ZM29.293 24.44a3.384 3.384 0 0 1-.333 1.453 5.5 5.5 0 0 1-.907 1.36c-.653.72-1.373 1.24-2.187 1.574-.013 0-.026.013-.04.013-.786.32-1.64.493-2.56.493-1.36 0-2.813-.32-4.346-.973-1.534-.653-3.067-1.533-4.587-2.64-.52-.387-1.04-.773-1.533-1.187l4.36-4.36c.373.28.706.494.986.64.067.027.147.067.24.107a.92.92 0 0 0 .334.053c.227 0 .4-.08.547-.226l1.013-1c.333-.334.653-.587.96-.747.307-.187.613-.28.947-.28.253 0 .52.053.813.173.293.12.6.294.933.52l4.413 3.134c.347.24.587.52.734.853.133.333.213.667.213 1.04Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var CallMini = ((/* unused pure expression or super */ null && (SvgCallMini)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Call.js


function Call_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Call_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Call_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Call_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/_jsx("svg", Call_objectSpread(Call_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.785 34.883 21.468 39.2c-.91.91-2.357.91-3.29.023-.257-.256-.513-.49-.77-.746a66.28 66.28 0 0 1-6.51-7.63c-1.913-2.66-3.453-5.32-4.573-7.957-1.097-2.66-1.657-5.203-1.657-7.63 0-1.587.28-3.103.84-4.503.56-1.424 1.447-2.73 2.683-3.897 1.494-1.47 3.127-2.193 4.854-2.193.653 0 1.306.14 1.89.42.606.28 1.143.7 1.563 1.306l5.413 7.63c.42.584.724 1.12.934 1.634.21.49.326.98.326 1.423 0 .56-.163 1.12-.49 1.657-.303.536-.746 1.096-1.306 1.656L19.6 22.237c-.256.256-.373.56-.373.933 0 .187.023.35.07.537.07.186.14.326.187.466.42.77 1.143 1.774 2.17 2.987a79.758 79.758 0 0 0 3.383 3.687c.233.233.49.466.723.7.934.91.957 2.403.024 3.336ZM51.262 42.77c0 .653-.117 1.33-.35 1.983-.07.187-.14.374-.234.56a9.626 9.626 0 0 1-1.586 2.38c-1.144 1.26-2.404 2.17-3.827 2.754-.023 0-.047.023-.07.023-1.377.56-2.87.863-4.48.863-2.38 0-4.923-.56-7.607-1.703-2.683-1.143-5.366-2.683-8.026-4.62-.91-.677-1.82-1.353-2.684-2.077l7.63-7.63c.654.49 1.237.864 1.727 1.12.117.047.257.117.42.187.187.07.373.093.583.093.397 0 .7-.14.957-.396l1.773-1.75c.584-.584 1.144-1.027 1.68-1.307.537-.327 1.074-.49 1.657-.49.443 0 .91.093 1.423.303.514.21 1.05.514 1.634.91l7.723 5.484c.607.42 1.027.91 1.283 1.493.234.583.374 1.167.374 1.82Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var Call = ((/* unused pure expression or super */ null && (SvgCall)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/FireMini.js


function FireMini_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FireMini_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FireMini_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FireMini_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgFireMini = function SvgFireMini(props) {
  return /*#__PURE__*/_jsx("svg", FireMini_objectSpread(FireMini_objectSpread({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.066 14.674a10.858 10.858 0 0 0-2.591-3.6l-.91-.835a.253.253 0 0 0-.406.103l-.406 1.166c-.253.731-.719 1.478-1.378 2.212a.195.195 0 0 1-.128.063.172.172 0 0 1-.134-.047.184.184 0 0 1-.063-.15c.116-1.881-.447-4.003-1.678-6.313-1.019-1.918-2.434-3.415-4.203-4.459l-1.29-.76a.25.25 0 0 0-.376.229l.069 1.5c.047 1.025-.072 1.931-.353 2.684a8.912 8.912 0 0 1-1.469 2.547 9.234 9.234 0 0 1-1.484 1.44 11.019 11.019 0 0 0-3.135 3.798 10.867 10.867 0 0 0-.265 9.071 10.98 10.98 0 0 0 5.856 5.8c1.356.57 2.794.857 4.278.857a11.05 11.05 0 0 0 4.278-.853 10.895 10.895 0 0 0 3.497-2.335A10.819 10.819 0 0 0 27 19.077c0-1.525-.313-3.007-.934-4.404Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var FireMini = ((/* unused pure expression or super */ null && (SvgFireMini)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Fire.js


function Fire_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Fire_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Fire_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Fire_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/_jsx("svg", Fire_objectSpread(Fire_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M45.615 25.679a19.002 19.002 0 0 0-4.534-6.3l-1.591-1.46a.442.442 0 0 0-.711.18l-.711 2.04c-.443 1.28-1.258 2.586-2.412 3.872a.342.342 0 0 1-.224.109.302.302 0 0 1-.235-.082.321.321 0 0 1-.11-.263c.203-3.292-.782-7.005-2.936-11.046-1.783-3.358-4.26-5.978-7.356-7.804l-2.258-1.33a.438.438 0 0 0-.656.4L22 6.62c.082 1.794-.126 3.38-.618 4.698a15.595 15.595 0 0 1-2.57 4.457 16.165 16.165 0 0 1-2.598 2.52 19.283 19.283 0 0 0-5.485 6.645 19.017 19.017 0 0 0-1.98 8.439c0 2.58.509 5.08 1.515 7.437a19.107 19.107 0 0 0 4.129 6.065 19.212 19.212 0 0 0 6.12 4.085A19.241 19.241 0 0 0 28 52.464c2.598 0 5.113-.503 7.487-1.492a19.065 19.065 0 0 0 6.12-4.086 18.932 18.932 0 0 0 5.643-13.502c0-2.669-.547-5.26-1.635-7.705Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var Fire = ((/* unused pure expression or super */ null && (SvgFire)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Internet.js


function Internet_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Internet_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Internet_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Internet_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgInternet = function SvgInternet(props) {
  return /*#__PURE__*/_jsx("svg", Internet_objectSpread(Internet_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M28 4.667C15.166 4.667 4.666 15.167 4.666 28c0 12.833 10.5 23.333 23.334 23.333 12.833 0 23.333-10.5 23.333-23.333 0-12.833-10.5-23.333-23.333-23.333Zm0 4.666c1.4 0 2.8.234 4.2.467-.467.933-.934 1.633-1.867 2.333-.466.467-1.166.7-1.633 1.167-1.867.933-3.267 2.333-4.433 3.967-1.167 2.333-1.634 5.133-1.4 7.7 0 3.266 0 5.133-2.1 6.766C17.5 34.3 12.6 32.9 9.567 31.5c-.234-1.167-.234-2.333-.234-3.5 0-10.267 8.4-18.667 18.667-18.667ZM39.433 42.7c-.466-.933-.933-1.867-1.4-2.567-.233-.466-.467-.7-.7-1.166-.933-1.634-.466-2.334.934-4.667l.233-.467c.933-1.633 1.4-3.733 1.4-5.6 0-.7 0-1.633.233-2.333.467-1.633 3.967-2.1 6.3-2.333 1.633 7.233-1.166 14.7-7 19.133Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var Internet = ((/* unused pure expression or super */ null && (SvgInternet)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/MoneyMini.js


function MoneyMini_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MoneyMini_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MoneyMini_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MoneyMini_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgMoneyMini = function SvgMoneyMini(props) {
  return /*#__PURE__*/_jsxs("svg", MoneyMini_objectSpread(MoneyMini_objectSpread({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25.56 8.853c-.573-2.893-2.72-4.16-5.706-4.16H8.147c-3.52 0-5.867 1.76-5.867 5.867v6.867c0 2.96 1.214 4.693 3.214 5.44.293.106.613.2.946.253.534.12 1.107.173 1.707.173h11.72c3.52 0 5.867-1.76 5.867-5.866V10.56c0-.627-.054-1.187-.174-1.707ZM7.374 16c0 .547-.454 1-1 1-.547 0-1-.453-1-1v-4c0-.547.453-1 1-1 .546 0 1 .453 1 1v4ZM14 17.52A3.517 3.517 0 0 1 10.48 14 3.517 3.517 0 0 1 14 10.48 3.517 3.517 0 0 1 17.52 14 3.517 3.517 0 0 1 14 17.52ZM22.614 16c0 .547-.454 1-1 1-.547 0-1-.453-1-1v-4c0-.547.453-1 1-1 .546 0 1 .453 1 1v4Z",
      fill: "#E00034"
    }), /*#__PURE__*/_jsx("path", {
      d: "M29.733 14.56v6.867c0 4.106-2.347 5.88-5.88 5.88H12.146c-1 0-1.893-.147-2.666-.44a4.496 4.496 0 0 1-1.614-.987c-.24-.227-.053-.587.28-.587h11.707c4.933 0 7.867-2.933 7.867-7.853v-6.88c0-.32.36-.52.586-.28.907.96 1.427 2.36 1.427 4.28Z",
      fill: "#E00034"
    })]
  }));
};

/* harmony default export */ var MoneyMini = ((/* unused pure expression or super */ null && (SvgMoneyMini)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Money.js


function Money_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Money_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Money_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Money_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/_jsxs("svg", Money_objectSpread(Money_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M44.73 15.493c-1.003-5.063-4.76-7.28-9.986-7.28H14.257c-6.16 0-10.267 3.08-10.267 10.267v12.017c0 5.18 2.124 8.213 5.624 9.52.513.186 1.073.35 1.656.443.934.21 1.937.303 2.987.303h20.51c6.16 0 10.267-3.08 10.267-10.266V18.48c0-1.097-.094-2.077-.304-2.987ZM12.904 28c0 .957-.794 1.75-1.75 1.75-.957 0-1.75-.793-1.75-1.75v-7c0-.957.793-1.75 1.75-1.75.956 0 1.75.793 1.75 1.75v7ZM24.5 30.66a6.154 6.154 0 0 1-6.16-6.16 6.154 6.154 0 0 1 6.16-6.16 6.154 6.154 0 0 1 6.16 6.16 6.154 6.154 0 0 1-6.16 6.16ZM39.574 28c0 .957-.794 1.75-1.75 1.75-.957 0-1.75-.793-1.75-1.75v-7c0-.957.793-1.75 1.75-1.75.956 0 1.75.793 1.75 1.75v7Z",
      fill: "#E00034"
    }), /*#__PURE__*/_jsx("path", {
      d: "M52.033 25.48v12.017c0 7.186-4.107 10.29-10.29 10.29H21.256c-1.75 0-3.313-.257-4.666-.77-1.097-.397-2.054-.98-2.824-1.727-.42-.397-.093-1.027.49-1.027h20.487c8.633 0 13.767-5.133 13.767-13.743V18.48c0-.56.63-.91 1.026-.49 1.587 1.68 2.497 4.13 2.497 7.49Z",
      fill: "#E00034"
    })]
  }));
};

/* harmony default export */ var Money = ((/* unused pure expression or super */ null && (SvgMoney)));
// EXTERNAL MODULE: ./components/SvgComponents/section/Question.js
var Question = __webpack_require__(85928);
;// CONCATENATED MODULE: ./components/SvgComponents/section/SmsMini.js


function SmsMini_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SmsMini_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SmsMini_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SmsMini_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgSmsMini = function SvgSmsMini(props) {
  return /*#__PURE__*/_jsx("svg", SmsMini_objectSpread(SmsMini_objectSpread({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M22.667 4.667H9.334c-4 0-6.667 2-6.667 6.666v9.334c0 4.666 2.667 6.666 6.667 6.666h13.333c4 0 6.667-2 6.667-6.666v-9.334c0-4.666-2.667-6.666-6.667-6.666Zm.627 8.12L19.12 16.12c-.88.707-2 1.053-3.12 1.053s-2.253-.346-3.12-1.053l-4.173-3.333a1.026 1.026 0 0 1-.16-1.414.997.997 0 0 1 1.4-.16l4.173 3.334c1.014.813 2.734.813 3.747 0l4.173-3.334a.984.984 0 0 1 1.4.16c.347.427.28 1.067-.146 1.414Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var SmsMini = ((/* unused pure expression or super */ null && (SvgSmsMini)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Sms.js


function Sms_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Sms_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Sms_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Sms_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/_jsx("svg", Sms_objectSpread(Sms_objectSpread({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M39.668 8.167H16.335c-7 0-11.667 3.5-11.667 11.666v16.334c0 8.166 4.667 11.666 11.667 11.666h23.333c7 0 11.667-3.5 11.667-11.666V19.833c0-8.166-4.667-11.666-11.667-11.666Zm1.097 14.21L33.46 28.21c-1.54 1.237-3.5 1.843-5.46 1.843s-3.943-.606-5.46-1.843l-7.303-5.833a1.795 1.795 0 0 1-.28-2.474c.607-.746 1.703-.886 2.45-.28l7.303 5.834c1.774 1.423 4.784 1.423 6.557 0l7.303-5.834c.747-.606 1.867-.49 2.45.28a1.77 1.77 0 0 1-.256 2.474Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var Sms = ((/* unused pure expression or super */ null && (SvgSms)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/Star.js


function Star_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Star_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Star_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Star_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/_jsx("svg", Star_objectSpread(Star_objectSpread({
    width: 55,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M40.47 52.452c-1.214 0-2.772-.39-4.72-1.535l-6.852-4.057c-.71-.412-2.086-.412-2.773 0l-6.875 4.057c-4.056 2.406-6.44 1.443-7.517.664-1.054-.779-2.704-2.773-1.627-7.356l1.627-7.035c.184-.734-.183-1.994-.733-2.544l-5.683-5.684c-2.842-2.841-2.613-5.27-2.223-6.462.39-1.192 1.627-3.3 5.568-3.965l7.31-1.214c.688-.115 1.674-.848 1.972-1.467L22 7.764c1.833-3.69 4.24-4.24 5.5-4.24 1.26 0 3.667.55 5.5 4.24l4.033 8.067c.321.619 1.306 1.352 1.994 1.467l7.31 1.214c3.965.665 5.202 2.773 5.57 3.965.366 1.192.595 3.62-2.224 6.462L44 34.646c-.55.55-.894 1.787-.733 2.544l1.627 7.035c1.054 4.583-.573 6.577-1.627 7.356-.573.413-1.49.871-2.796.871Z",
      fill: "#E00034"
    })
  }));
};

/* harmony default export */ var Star = ((/* unused pure expression or super */ null && (SvgStar)));
;// CONCATENATED MODULE: ./components/SvgComponents/section/index.js

















/***/ }),

/***/ 46077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s1": function() { return /* reexport */ Facebook; },
  "mr": function() { return /* reexport */ Instagram; },
  "CD": function() { return /* reexport */ Whatsapp; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/SvgComponents/social/light/Facebook.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: 10,
      cy: 10,
      r: 8.75,
      fill: "url(#Facebook_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m13.259 12.676.388-2.47h-2.431V8.604c0-.675.339-1.335 1.428-1.335h1.106V5.167S12.747 5 11.788 5C9.784 5 8.476 6.183 8.476 8.324v1.882H6.25v2.47h2.226v5.97a9.048 9.048 0 0 0 2.74 0v-5.97h2.043Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "Facebook_svg__a",
        x1: 10,
        y1: 1.25,
        x2: 10,
        y2: 18.698,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#18ACFE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#0163E0"
        })]
      })
    })]
  }));
};

/* harmony default export */ var Facebook = (SvgFacebook);
;// CONCATENATED MODULE: ./components/SvgComponents/social/light/Instagram.js


function Instagram_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Instagram_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Instagram_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Instagram_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Instagram_objectSpread(Instagram_objectSpread({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: 1.25,
      y: 1.25,
      width: 17.5,
      height: 17.5,
      rx: 6,
      fill: "url(#instagram_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: 1.25,
      y: 1.25,
      width: 17.5,
      height: 17.5,
      rx: 6,
      fill: "url(#instagram_svg__b)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      x: 1.25,
      y: 1.25,
      width: 17.5,
      height: 17.5,
      rx: 6,
      fill: "url(#instagram_svg__c)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M14.375 6.563a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 13.125a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Zm0-1.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.75 9.75c0-2.1 0-3.15.409-3.952a3.75 3.75 0 0 1 1.639-1.64C6.6 3.75 7.65 3.75 9.75 3.75h.5c2.1 0 3.15 0 3.953.409a3.75 3.75 0 0 1 1.638 1.639c.409.802.409 1.852.409 3.952v.5c0 2.1 0 3.15-.409 3.953a3.75 3.75 0 0 1-1.638 1.638c-.803.409-1.853.409-3.953.409h-.5c-2.1 0-3.15 0-3.952-.409a3.75 3.75 0 0 1-1.64-1.638C3.75 13.4 3.75 12.35 3.75 10.25v-.5Zm6-4.75h.5c1.07 0 1.799.001 2.361.047.548.045.829.126 1.024.225a2.5 2.5 0 0 1 1.092 1.093c.1.196.181.476.226 1.024C15 7.95 15 8.679 15 9.75v.5c0 1.07-.001 1.799-.047 2.361-.045.548-.126.829-.226 1.024a2.5 2.5 0 0 1-1.092 1.092c-.195.1-.476.181-1.024.226-.562.046-1.29.047-2.361.047h-.5c-1.07 0-1.799-.001-2.361-.047-.548-.045-.828-.126-1.024-.226a2.5 2.5 0 0 1-1.093-1.092c-.1-.195-.18-.476-.225-1.024C5 12.05 5 11.321 5 10.25v-.5c0-1.07.001-1.799.047-2.361.045-.548.126-.828.225-1.024a2.5 2.5 0 0 1 1.093-1.093c.196-.1.476-.18 1.024-.225C7.95 5 8.679 5 9.75 5Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "instagram_svg__a",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(-55.376 17.447 .041) scale(15.9498)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#B13589"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.793,
          stopColor: "#C62F94"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#8A3AC8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "instagram_svg__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(-65.136 18.604 4.306) scale(14.1214)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#E0E8B7"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.445,
          stopColor: "#FB8A2E"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.715,
          stopColor: "#E2425C"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#E2425C",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "instagram_svg__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(24.0625 -3.4375 .73525 5.14672 .313 1.875)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.157,
          stopColor: "#406ADC"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 0.468,
          stopColor: "#6A45BE"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#6A45BE",
          stopOpacity: 0
        })]
      })]
    })]
  }));
};

/* harmony default export */ var Instagram = (SvgInstagram);
;// CONCATENATED MODULE: ./components/SvgComponents/social/light/Whatsapp.js


function Whatsapp_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Whatsapp_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Whatsapp_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Whatsapp_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", Whatsapp_objectSpread(Whatsapp_objectSpread({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 19.375a8.75 8.75 0 1 0-7.613-4.434L1.25 19.375l4.572-1.06A8.711 8.711 0 0 0 10 19.375Zm0-1.346a7.404 7.404 0 1 0-6.068-3.16l-.663 2.487 2.531-.633A7.37 7.37 0 0 0 10 18.03Z",
      fill: "#BFC8D0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.5 10a7.5 7.5 0 0 1-11.755 6.177l-2.563.641.672-2.519A7.5 7.5 0 1 1 17.5 10Z",
      fill: "url(#whatsapp_svg__a)"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 18.75a8.75 8.75 0 1 0-7.613-4.434L1.25 18.75l4.572-1.06A8.711 8.711 0 0 0 10 18.75Zm0-1.346a7.404 7.404 0 1 0-6.068-3.16L3.27 16.73l2.531-.633a7.37 7.37 0 0 0 4.2 1.306Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.813 5.938c-.209-.418-.528-.381-.85-.381-.576 0-1.475.69-1.475 1.974 0 1.053.464 2.205 2.027 3.93 1.509 1.663 3.49 2.523 5.136 2.494 1.646-.03 1.984-1.445 1.984-1.923 0-.212-.131-.318-.222-.347-.56-.269-1.595-.77-1.83-.865-.235-.094-.358.034-.435.103-.213.203-.636.803-.78.938-.146.134-.362.066-.451.015-.331-.133-1.228-.531-1.942-1.224-.884-.857-.936-1.152-1.103-1.414-.133-.21-.035-.339.014-.395.19-.22.453-.56.571-.728.118-.168.024-.424-.032-.584-.241-.685-.446-1.26-.612-1.593Z",
      fill: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "whatsapp_svg__a",
        x1: 16.563,
        y1: 4.375,
        x2: 2.5,
        y2: 17.5,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#5BD066"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#27B43E"
        })]
      })
    })]
  }));
};

/* harmony default export */ var Whatsapp = (SvgWhatsapp);
;// CONCATENATED MODULE: ./components/SvgComponents/social/light/index.js




/***/ }),

/***/ 82563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33770);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61395);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84838);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24052);
/* harmony import */ var _ui_BusinessContactForm_ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50838);
/* harmony import */ var _hooks_useSlickPositioning__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25367);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57611);


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var DinamicModal = function DinamicModal(_ref) {
  var className = _ref.className,
      props = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref, _excluded);

  var Component = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23303))["catch"](function () {
      return '';
    });
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(23303)];
      }
    }
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(Component, _objectSpread({
    className: className
  }, props));
};

var BusinessTariffSlider = function BusinessTariffSlider(_ref2) {
  var _data$tariffs;

  var data = _ref2.data;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      modalActive = _useState[0],
      setModalActive = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showSuccess = _useState2[0],
      setShowSuccess = _useState2[1];

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  (0,_hooks_useSlickPositioning__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();

  var closeModal = function closeModal() {
    setModalActive(false);
  };

  var handleConnect = function handleConnect() {
    setModalActive(true);
  };

  var showSuccessModal = function showSuccessModal() {
    closeModal();
    setShowSuccess(true);
  };

  var renderList = function renderList(item, key) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_4__/* .BusinessTariffCard */ .LD, {
      data: item,
      handleConnect: handleConnect
    }, key);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: [!!(data !== null && data !== void 0 && (_data$tariffs = data.tariffs) !== null && _data$tariffs !== void 0 && _data$tariffs.length) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: 'section wrapper',
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_4__/* .SectionTitle */ .NZ, {
        titleModify: 'title--large',
        children: data === null || data === void 0 ? void 0 : data.title
      }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: 'common-description half',
        children: data === null || data === void 0 ? void 0 : data.description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_4__/* .SliderWrapper */ .h2 // className={styles.slider}
      , {
        arrows: true,
        nextArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_5__/* .BrandArrow */ .RJ, {
          width: 17
        }),
        prevArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_5__/* .BrandArrow */ .RJ, {
          width: 17
        }),
        options: {
          infinite: (data === null || data === void 0 ? void 0 : data.tariffs.length) > 3
        },
        children: data === null || data === void 0 ? void 0 : data.tariffs.map(renderList)
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(DinamicModal, {
      active: modalActive,
      setActive: closeModal,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_BusinessContactForm_ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        showSuccess: showSuccessModal
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_4__/* .InformationModal */ .UI, {
      type: 'dark',
      active: showSuccess,
      onClose: function onClose() {
        return setShowSuccess(false);
      },
      description: t('common:successText')
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BusinessTariffSlider);

/***/ }),

/***/ 35819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84838);
/* harmony import */ var _ui_BusinessContactForm_BusinessContactForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77743);
/* harmony import */ var _business_tariffs_BusinessTariffs_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9246);
/* harmony import */ var _business_tariffs_BusinessTariffs_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_business_tariffs_BusinessTariffs_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);







var BusinessTariffSliderWithoutHeader = function BusinessTariffSliderWithoutHeader(_ref) {
  var _data$tariffs, _data$tariffs2;

  var data = _ref.data;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      tariffID = _useState[0],
      setTariffID = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  var closeModal = function closeModal() {
    setModalActive(false);
    setTariffID(null);
  };

  var handleConnect = function handleConnect(id) {
    setModalActive(true);
    setTariffID(id);
  };

  var renderList = function renderList(item, key) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_1__/* .BusinessTariffCardWithoutHeader */ .Bz, {
      data: item,
      handleConnect: handleConnect
    }, key);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: [data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: 'section wrapper',
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_1__/* .SectionTitle */ .NZ, {
        titleModify: 'title--large',
        children: data === null || data === void 0 ? void 0 : data.title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: 'common-description',
        children: data === null || data === void 0 ? void 0 : data.description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_1__/* .SliderWrapper */ .h2, {
        className: (_business_tariffs_BusinessTariffs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().slider),
        arrows: true,
        options: {
          infinite: (data === null || data === void 0 ? void 0 : (_data$tariffs = data.tariffs) === null || _data$tariffs === void 0 ? void 0 : _data$tariffs.length) > 3
        },
        children: data === null || data === void 0 ? void 0 : (_data$tariffs2 = data.tariffs) === null || _data$tariffs2 === void 0 ? void 0 : _data$tariffs2.map(renderList)
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_BusinessContactForm_BusinessContactForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      tariffID: tariffID,
      activeModal: modalActive,
      clearTariff: closeModal,
      hasEmployeesCount: false
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BusinessTariffSliderWithoutHeader);

/***/ }),

/***/ 50723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84838);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24052);
/* harmony import */ var _DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37885);
/* harmony import */ var _DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57611);








var DirectorItem = function DirectorItem(_ref) {
  var item = _ref.item;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: (_DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5___default().directorItem),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: (_DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5___default().image),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
        src: item === null || item === void 0 ? void 0 : item.image,
        alt: item === null || item === void 0 ? void 0 : item.name,
        title: item === null || item === void 0 ? void 0 : item.name,
        layout: "fill",
        objectFit: "cover",
        loading: "lazy"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5___default().info),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5___default().name),
        children: item === null || item === void 0 ? void 0 : item.name
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5___default().position),
        children: item === null || item === void 0 ? void 0 : item.position
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_ui_index__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
      onClick: function onClick() {
        return router.push("/directors/".concat(item === null || item === void 0 ? void 0 : item.slug));
      },
      Component: 'router',
      size: 'normal',
      className: (_DirectorItem_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button),
      children: [item === null || item === void 0 ? void 0 : item.button_text, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRight */ .ol, {
        width: 24
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DirectorItem);

/***/ }),

/***/ 18686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pR": function() { return /* reexport */ Awards_Awards; },
  "WX": function() { return /* reexport */ about_us_ColorCards_ColorCards; },
  "Vh": function() { return /* reexport */ Milestones_Milestones; },
  "Eq": function() { return /* reexport */ TitleBlock_TitleBlock; },
  "ZK": function() { return /* reexport */ Vacancies_Vacancies; }
});

// UNUSED EXPORTS: AboutUsPage

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/SvgComponents/Note.js
var Note = __webpack_require__(43637);
// EXTERNAL MODULE: ./components/ui/DocumentCard/DocumentCard.js
var DocumentCard = __webpack_require__(83797);
// EXTERNAL MODULE: ./components/ui/CoverageMap/CoverageMap.js
var CoverageMap_CoverageMap = __webpack_require__(28053);
// EXTERNAL MODULE: ./components/about-us/DirectorItem/DirectorItem.js
var DirectorItem_DirectorItem = __webpack_require__(50723);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(62049);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/SvgComponents/Download.js


var Download = function Download(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "icon-button",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "overlap-group",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
        className: "functional-icons ".concat(className),
        fill: "none",
        height: "18",
        viewBox: "0 0 18 18",
        width: "18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          className: "path",
          clipRule: "evenodd",
          d: "M9.84663 1.6875L9.84663 15.3532L8.17014 15.3532L8.17014 1.6875L9.84663 1.6875Z",
          fill: "#F4F2F2",
          fillRule: "evenodd"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          className: "path",
          clipRule: "evenodd",
          d: "M9.11978 14.6258L13.4395 10.4004L14.625 11.5599L10.3052 15.7854C9.5844 16.4905 8.41978 16.4846 7.69898 15.7895L7.69474 15.7854L3.375 11.5599L4.56046 10.4004L8.87729 14.6229C8.95003 14.6918 9.05862 14.6856 9.11978 14.6258Z",
          fill: "#F4F2F2",
          fillRule: "evenodd"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          className: "path",
          d: "M8.12776 2.8125L9.81526 2.8125L9.81526 1.6875L8.12776 1.125L8.12776 2.8125Z",
          fill: "#F4F2F2"
        })]
      }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "rectangle"
      })]
    })
  });
};
// EXTERNAL MODULE: ./components/about-us/ColorCards/ColorCards.module.scss
var ColorCards_module = __webpack_require__(55565);
var ColorCards_module_default = /*#__PURE__*/__webpack_require__.n(ColorCards_module);
;// CONCATENATED MODULE: ./components/about-us/ColorCards/ColorCards.js









var ColorCards_ColorCards = function ColorCards(_ref) {
  var _data$items, _data$items2;

  var data = _ref.data,
      className = _ref.className;

  var renderTrueButton = function renderTrueButton(buttonData, index) {
    if (buttonData.button_type === 'download') {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        className: (ColorCards_module_default())["color-card__button"],
        href: buttonData === null || buttonData === void 0 ? void 0 : buttonData.button_download_file,
        download: true,
        children: [buttonData === null || buttonData === void 0 ? void 0 : buttonData.button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(Download, {})]
      }, index);
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: buttonData === null || buttonData === void 0 ? void 0 : buttonData.slug,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        className: classnames_default()((ColorCards_module_default())["color-card__button"], (ColorCards_module_default())["color-card__button--link"]),
        children: [buttonData === null || buttonData === void 0 ? void 0 : buttonData.button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(Download, {})]
      })
    });
  };

  var renderColorCards = function renderColorCards(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
      className: (ColorCards_module_default())["color-card"],
      children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ColorCards_module_default())["color-card__icon-wrapper"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: (ColorCards_module_default())["color-card__icon"],
          src: item === null || item === void 0 ? void 0 : item.icon,
          alt: "icon",
          title: "icon",
          loading: "lazy",
          width: 24,
          height: 24
        })
      }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        titleModify: classnames_default()([(ColorCards_module_default())["color-card__title"], 'title--medium']),
        children: item === null || item === void 0 ? void 0 : item.title
      }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (ColorCards_module_default())["color-card__desc"],
        dangerouslySetInnerHTML: {
          __html: item === null || item === void 0 ? void 0 : item.description
        }
      }), (item === null || item === void 0 ? void 0 : item.button_text) && renderTrueButton(item)]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((ColorCards_module_default())["color-cards"], className),
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: (ColorCards_module_default())["color-cards__title"],
      titleModify: "title--large",
      icon: data === null || data === void 0 ? void 0 : data.icon,
      children: data === null || data === void 0 ? void 0 : data.title
    }), (data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ColorCards_module_default())["color-cards__inner"],
      children: data === null || data === void 0 ? void 0 : (_data$items2 = data.items) === null || _data$items2 === void 0 ? void 0 : _data$items2.map(renderColorCards)
    })]
  });
};

/* harmony default export */ var about_us_ColorCards_ColorCards = (ColorCards_ColorCards);
// EXTERNAL MODULE: ./components/common/index.js + 33 modules
var common = __webpack_require__(51633);
;// CONCATENATED MODULE: ./components/about-us/AboutUsPage/AboutUsPage.js
















var AboutUsPage = function AboutUsPage(_ref) {
  var _companyBlock$tabs, _managementSlider$lis, _managementSlider$lis2, _newsSlider$list;

  var _ref$data = _ref.data,
      companyBlock = _ref$data.companyBlock,
      managementSlider = _ref$data.managementSlider,
      directorsSlider = _ref$data.directorsSlider,
      newsSlider = _ref$data.newsSlider,
      banner = _ref$data.banner,
      colorCards = _ref$data.colorCards,
      infoBlock = _ref$data.infoBlock,
      sustainabilityBlock = _ref$data.sustainabilityBlock;

  var _useState = useState(0),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var sliderOptions1 = {
    slidesToShow: 1,
    infinite: true,
    responsive: [{
      breakpoint: 1400,
      settings: {
        arrows: false
      }
    }]
  };
  var sliderOptions2 = {
    slidesToShow: 3,
    responsive: [{
      breakpoint: 1400,
      settings: {
        arrows: false
      }
    }, {
      breakpoint: 960,
      settings: {
        arrows: false,
        slidesToShow: 2
      }
    }, {
      breakpoint: 640,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }]
  };

  var renderDirectorItem = function renderDirectorItem(item, key) {
    return /*#__PURE__*/_jsx(DirectorItem, {
      item: item
    }, key);
  };

  var renderTab = function renderTab(item, key) {
    return /*#__PURE__*/_jsx(Tab, {
      className: classNames([styles.tab, _defineProperty({}, styles.active, activeTab === key)]),
      onClick: function onClick() {
        return setActiveTab(key);
      },
      children: item.tab
    }, key);
  };

  var renderTabContent = function renderTabContent(item, key) {
    var _item$content, _item$content2, _item$content3, _item$content4, _item$content5;

    return /*#__PURE__*/_jsx(TabContentItem, {
      className: classNames(_defineProperty({}, styles.tabContentItem, activeTab === 0)),
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(styles.infoBlock, " grid-extend equal"),
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.info,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.note,
            children: item === null || item === void 0 ? void 0 : (_item$content = item.content) === null || _item$content === void 0 ? void 0 : _item$content.note
          }), /*#__PURE__*/_jsx("h2", {
            className: styles.title,
            children: item === null || item === void 0 ? void 0 : (_item$content2 = item.content) === null || _item$content2 === void 0 ? void 0 : _item$content2.title
          }), /*#__PURE__*/_jsx("p", {
            className: styles.text,
            children: item === null || item === void 0 ? void 0 : (_item$content3 = item.content) === null || _item$content3 === void 0 ? void 0 : _item$content3.text
          }), /*#__PURE__*/_jsxs(Button, {
            href: item === null || item === void 0 ? void 0 : (_item$content4 = item.content) === null || _item$content4 === void 0 ? void 0 : _item$content4.link,
            Component: 'router',
            className: styles.button,
            children: ["Read more ", /*#__PURE__*/_jsx(Arrow, {
              width: 24
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.image,
          children: /*#__PURE__*/_jsx(Image, {
            src: item === null || item === void 0 ? void 0 : (_item$content5 = item.content) === null || _item$content5 === void 0 ? void 0 : _item$content5.image,
            alt: "Bakcell",
            title: "Bakcell",
            loading: "lazy",
            layout: "fill"
          })
        })]
      })
    }, key);
  };

  var renderManagerCard = function renderManagerCard(item, key) {
    return /*#__PURE__*/_jsx(Banner, {
      item: item,
      note: item.position,
      buttonHide: true,
      type: 'white'
    }, key);
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [!!companyBlock && /*#__PURE__*/_jsxs("div", {
      className: "".concat(styles.companyBlock, " wrapper section"),
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        Icon: Ranking,
        className: styles.title,
        titleModify: "title--large",
        children: companyBlock === null || companyBlock === void 0 ? void 0 : companyBlock.title
      }), !!(companyBlock !== null && companyBlock !== void 0 && (_companyBlock$tabs = companyBlock.tabs) !== null && _companyBlock$tabs !== void 0 && _companyBlock$tabs.length) && /*#__PURE__*/_jsxs(Tabs, {
        active: activeTab,
        children: [/*#__PURE__*/_jsx(TabPanel, {
          className: styles.tabToggles,
          children: companyBlock === null || companyBlock === void 0 ? void 0 : companyBlock.tabs.map(renderTab)
        }), /*#__PURE__*/_jsx(TabContent, {
          children: companyBlock === null || companyBlock === void 0 ? void 0 : companyBlock.tabs.map(renderTabContent)
        })]
      })]
    }), !!(managementSlider !== null && managementSlider !== void 0 && (_managementSlider$lis = managementSlider.list) !== null && _managementSlider$lis !== void 0 && _managementSlider$lis.length) && /*#__PURE__*/_jsx(SliderContainer, {
      title: managementSlider === null || managementSlider === void 0 ? void 0 : managementSlider.title,
      icon: FillUser,
      addClass: styles.bannerSlider,
      options: sliderOptions1,
      children: managementSlider === null || managementSlider === void 0 ? void 0 : (_managementSlider$lis2 = managementSlider.list) === null || _managementSlider$lis2 === void 0 ? void 0 : _managementSlider$lis2.map(renderManagerCard)
    }), !!directorsSlider && /*#__PURE__*/_jsx(SliderContainer, {
      title: directorsSlider === null || directorsSlider === void 0 ? void 0 : directorsSlider.title,
      icon: People,
      options: sliderOptions2,
      addClass: styles.directors,
      children: directorsSlider === null || directorsSlider === void 0 ? void 0 : directorsSlider.list.map(renderDirectorItem)
    }), !!newsSlider && /*#__PURE__*/_jsx(SliderContainer, {
      title: newsSlider === null || newsSlider === void 0 ? void 0 : newsSlider.title,
      linkText: newsSlider === null || newsSlider === void 0 ? void 0 : newsSlider.linkText,
      link: newsSlider === null || newsSlider === void 0 ? void 0 : newsSlider.link,
      icon: SvgNote,
      options: sliderOptions2,
      children: newsSlider === null || newsSlider === void 0 ? void 0 : (_newsSlider$list = newsSlider.list) === null || _newsSlider$list === void 0 ? void 0 : _newsSlider$list.map(function (item, key) {
        return /*#__PURE__*/_jsx(NewsItem, {
          data: item
        }, key);
      })
    }), !!banner && /*#__PURE__*/_jsx(Banner, {
      item: banner,
      type: 'white',
      href: '/about-us/vacancies'
    }), !!colorCards && /*#__PURE__*/_jsx(ColorCards, {
      data: colorCards,
      titleIcon: Bundle,
      className: "wrapper section"
    }), !!infoBlock && /*#__PURE__*/_jsxs("div", {
      className: 'wrapper section',
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        Icon: Photo,
        className: styles.title,
        titleModify: "title--large",
        children: infoBlock === null || infoBlock === void 0 ? void 0 : infoBlock.title
      }), /*#__PURE__*/_jsxs("div", {
        className: "".concat(styles.infoBlock, " grid-extend equal"),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.info,
          dangerouslySetInnerHTML: {
            __html: infoBlock === null || infoBlock === void 0 ? void 0 : infoBlock.content
          }
        }), /*#__PURE__*/_jsx("div", {
          className: styles.image,
          children: /*#__PURE__*/_jsx(Image, {
            src: infoBlock === null || infoBlock === void 0 ? void 0 : infoBlock.image,
            alt: "Bakcell",
            title: "Bakcell",
            loading: "lazy",
            layout: "fill"
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: 'wrapper section',
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        Icon: Coverage,
        className: styles.title,
        titleModify: "title--large",
        children: "Coverage map"
      }), /*#__PURE__*/_jsx(CoverageMap, {})]
    }), !!sustainabilityBlock && /*#__PURE__*/_jsx(CardBlock, {
      Icon: Stability,
      data: sustainabilityBlock,
      className: 'wrapper section'
    })]
  });
};

/* harmony default export */ var AboutUsPage_AboutUsPage = ((/* unused pure expression or super */ null && (AboutUsPage)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./components/about-us/Milestones/Milestones.module.scss
var Milestones_module = __webpack_require__(64199);
var Milestones_module_default = /*#__PURE__*/__webpack_require__.n(Milestones_module);
;// CONCATENATED MODULE: ./components/SvgComponents/MilestoneItem.js


var MilesstoneItem = function MilesstoneItem() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "94",
    height: "59",
    viewBox: "0 0 94 59",
    fill: "none",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M4.5975 9.44513L85.6256 1.24987C87.1386 1.09683 88.6076 1.81506 89.416 3.10316L92.6964 8.32966C93.9377 10.3075 93.228 12.9237 91.1574 14.0031L6.84897 57.9511C4.18597 59.3392 0.999998 57.4071 0.999998 54.4041L0.999999 13.4248C1 11.3715 2.55464 9.65174 4.5975 9.44513Z",
      fill: "#272829",
      stroke: "#3F4042"
    })
  });
};

/* harmony default export */ var MilestoneItem = (MilesstoneItem);
;// CONCATENATED MODULE: ./components/about-us/Milestones/Milestones.js









var Milestones = function Milestones(_ref) {
  var data = _ref.data,
      className = _ref.className,
      isSmall = _ref.isSmall;

  var renderMilestonesListItem = function renderMilestonesListItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: item === null || item === void 0 ? void 0 : item.text
    }, index);
  };

  var renderMilestonesCard = function renderMilestonesCard(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Milestones_module_default())["milestones-item-container"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
        className: (Milestones_module_default())["milestones-item"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Milestones_module_default())["milestones-item_square"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Milestones_module_default())["milestones-item_square_small"]
          })
        }), !!(item !== null && item !== void 0 && item.year) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          className: (Milestones_module_default())["milestones-item__year"],
          children: item.year
        }), !!(item !== null && item !== void 0 && item.items) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* List */.aV, {
          className: (Milestones_module_default())["milestones-item__list"],
          children: item.items.map(renderMilestonesListItem)
        })]
      }, index), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Milestones_module_default())["milestones-item-container_connector"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MilestoneItem, {})
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((Milestones_module_default()).milestones, className),
    children: [!!(data !== null && data !== void 0 && data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: (Milestones_module_default()).milestones__title,
      titleModify: 'title--large',
      children: data.title
    }), !!(data !== null && data !== void 0 && data.years) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(Milestones_module_default()).milestones__three, (0,defineProperty/* default */.Z)({}, (Milestones_module_default())["milestones__three--narrowly"], isSmall)]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Milestones_module_default()).milestones__line
      }), data.years.map(renderMilestonesCard)]
    })]
  });
};

/* harmony default export */ var Milestones_Milestones = (Milestones);
// EXTERNAL MODULE: ./components/about-us/Awards/Awards.module.scss
var Awards_module = __webpack_require__(93226);
var Awards_module_default = /*#__PURE__*/__webpack_require__.n(Awards_module);
;// CONCATENATED MODULE: ./components/about-us/Awards/Awards.js







var Awards = function Awards(_ref) {
  var data = _ref.data;

  var renderAwardsItem = function renderAwardsItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
      className: (Awards_module_default())["awards-element"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Awards_module_default())["awards-element__icon"],
        "data-testid": "award-icon",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Cup */.ip, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Awards_module_default())["awards-element__text"],
        children: item.text
      })]
    }, index);
  };

  var renderAwardsRow = function renderAwardsRow(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Awards_module_default())["awards-item"],
      children: [(item === null || item === void 0 ? void 0 : item.year) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Awards_module_default()).year,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
          titleModify: classnames_default()((Awards_module_default())["awards-item__year"], 'title--medium'),
          children: item.year
        })
      }), (item === null || item === void 0 ? void 0 : item.items) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: (Awards_module_default())["awards-item__list"],
        children: item.items.map(renderAwardsItem)
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()('wrapper', 'section', (Awards_module_default()).custom),
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      titleModify: classnames_default()([(Awards_module_default()).awards__title, 'title--large']),
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.years) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Awards_module_default()).awards__inner,
      children: data.years.map(renderAwardsRow).sort(function (a, b) {
        return b.year - a.year;
      })
    })]
  });
};

/* harmony default export */ var Awards_Awards = (Awards);
// EXTERNAL MODULE: ./components/about-us/TitleBlock/TitleBlock.module.scss
var TitleBlock_module = __webpack_require__(24300);
var TitleBlock_module_default = /*#__PURE__*/__webpack_require__.n(TitleBlock_module);
;// CONCATENATED MODULE: ./components/about-us/TitleBlock/TitleBlock.js






var TitleBlock = function TitleBlock(_ref) {
  var _data$cards;

  var data = _ref.data,
      className = _ref.className;

  var renderCards = function renderCards(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (TitleBlock_module_default())["title-card"],
      "data-testid": "title-card",
      style: {
        backgroundImage: "linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), url(\"".concat(item === null || item === void 0 ? void 0 : item.image, "\")")
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (TitleBlock_module_default())["title-card__counter"],
        children: item === null || item === void 0 ? void 0 : item.title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TitleBlock_module_default())["title-card__content"],
        children: [(item === null || item === void 0 ? void 0 : item.text) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
          titleModify: classnames_default()([(TitleBlock_module_default())["title-card__title"], 'title--medium']),
          children: item === null || item === void 0 ? void 0 : item.text
        }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (TitleBlock_module_default())["title-card__desc"],
          children: item === null || item === void 0 ? void 0 : item.description
        })]
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((TitleBlock_module_default())["title-block"], className),
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: (TitleBlock_module_default())["title-block__title"],
      titleModify: "title--large",
      icon: data === null || data === void 0 ? void 0 : data.icon,
      children: data === null || data === void 0 ? void 0 : data.title
    }), (data === null || data === void 0 ? void 0 : data.cards) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (TitleBlock_module_default())["title-block__inner"],
      children: data === null || data === void 0 ? void 0 : (_data$cards = data.cards) === null || _data$cards === void 0 ? void 0 : _data$cards.map(renderCards)
    })]
  });
};

/* harmony default export */ var TitleBlock_TitleBlock = (TitleBlock);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(24666);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(33770);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(53431);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(48740);
// EXTERNAL MODULE: ./utils/axios.js
var axios = __webpack_require__(82373);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(97043);
// EXTERNAL MODULE: ./components/about-us/Vacancies/Vacancies.module.scss
var Vacancies_module = __webpack_require__(46571);
var Vacancies_module_default = /*#__PURE__*/__webpack_require__.n(Vacancies_module);
;// CONCATENATED MODULE: ./components/about-us/Vacancies/VacanciesListItem.js










var VacanciesListItem = function VacanciesListItem(_ref) {
  var _item$department;

  var item = _ref.item,
      _ref$onApply = _ref.onApply,
      onApply = _ref$onApply === void 0 ? function () {
    return null;
  } : _ref$onApply,
      cities = _ref.cities,
      _ref$setPositionId = _ref.setPositionId,
      setPositionId = _ref$setPositionId === void 0 ? function () {
    return null;
  } : _ref$setPositionId;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var findCity = cities === null || cities === void 0 ? void 0 : cities.find(function (c) {
    return (c === null || c === void 0 ? void 0 : c.id) === (item === null || item === void 0 ? void 0 : item.city_id);
  });

  var openVacancy = function openVacancy(_ref2) {
    var target = _ref2.target;
    if (target.dataset.stop) return onApply(item);
    setPositionId(item === null || item === void 0 ? void 0 : item.id);
    setIsActive(!isActive);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((Vacancies_module_default())["vacancy-item"], (0,defineProperty/* default */.Z)({}, (Vacancies_module_default())["vacancy-item--active"], isActive)),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Vacancies_module_default())["vacancy-item__head"],
      onClick: openVacancy,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Vacancies_module_default())["vacancy-item__content"],
        children: [(item === null || item === void 0 ? void 0 : item.department) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Vacancies_module_default())["vacancy-item__category"],
          children: item === null || item === void 0 ? void 0 : (_item$department = item.department) === null || _item$department === void 0 ? void 0 : _item$department.name
        }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
          titleModify: classnames_default()([(Vacancies_module_default())["vacancy-item__title"], 'title--small']),
          children: item.title
        }), (findCity === null || findCity === void 0 ? void 0 : findCity.name) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Vacancies_module_default())["vacancy-item__city"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Location */.Ye, {
            className: (Vacancies_module_default())["vacancy-item__city-icon"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (Vacancies_module_default())["vacancy-item__city-text"],
            children: findCity === null || findCity === void 0 ? void 0 : findCity.name
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Vacancies_module_default())["vacancy-item__additional"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          className: (Vacancies_module_default())["vacancy-item__button"],
          "data-stop": true,
          onClick: function onClick() {
            return setPositionId(item === null || item === void 0 ? void 0 : item.id);
          },
          children: t('common:Apply')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
          className: (Vacancies_module_default())["vacancy-item__arrow"]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Vacancies_module_default())["vacancy-info"],
      children: !!(item !== null && item !== void 0 && item.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Vacancies_module_default())["vacancy-info__head"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
          className: classnames_default()([(Vacancies_module_default())["vacancy-info__desc"], 'text--medium']),
          isHtml: true,
          children: item === null || item === void 0 ? void 0 : item.description
        })
      })
    })]
  });
};

/* harmony default export */ var Vacancies_VacanciesListItem = (VacanciesListItem);
;// CONCATENATED MODULE: ./components/about-us/Vacancies/Vacancies.js






/* eslint-disable react-hooks/exhaustive-deps */















var Modal = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23303));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(23303)];
    }
  }
});

var Vacancies = function Vacancies(_ref) {
  var data = _ref.data;
  var positionsLength = 10;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var FormSchema = es/* object */.Ry().shape({
    full_name: es/* string */.Z_().required(t('common:Required')).matches(/^[а-яА-ЯёЁa-zA-ZəçğıöşüƏÇĞİÖŞÜ\s]+$/, t('common:OnlyLetters')),
    phone: es/* string */.Z_().required(t('common:Required')).matches(/^994(10|50|51|55|70|77|99)\d{7}$/, t('common:Invalid mobile number')),
    email: es/* string */.Z_().email(t('common:Invalid email')).required(t('common:Invalid email')),
    captcha: es/* string */.Z_().required(t('common:required')),
    file: es/* mixed */.nK().test(t('common:required'), function (file) {
      if (file.length) return true;
      return false;
    })
  });
  var spreadDataForCity = [{
    id: 0,
    name: t('common:All')
  }].concat((0,toConsumableArray/* default */.Z)(data === null || data === void 0 ? void 0 : data.cities));
  var spreadDataForDepartment = [{
    id: 0,
    name: t('common:All')
  }].concat((0,toConsumableArray/* default */.Z)(data === null || data === void 0 ? void 0 : data.departments));

  var _useState = (0,react.useState)(false),
      activeModal = _useState[0],
      setActiveModal = _useState[1];

  var _useState2 = (0,react.useState)(''),
      positionId = _useState2[0],
      setPositionId = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isShow = _useState4[0],
      setIsShow = _useState4[1];

  var _React$useState = react.useState({}),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      sortValueCity = _React$useState2[0],
      setSortValueCity = _React$useState2[1];

  var _React$useState3 = react.useState({}),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      sortValueCategory = _React$useState4[0],
      setSortValueCategory = _React$useState4[1];

  var _React$useState5 = react.useState([]),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      filteredData = _React$useState6[0],
      setFilteredData = _React$useState6[1];

  var _React$useState7 = react.useState(''),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      captcha = _React$useState8[0],
      setCaptcha = _React$useState8[1];

  var _useState5 = (0,react.useState)(false),
      showSuccess = _useState5[0],
      setShowSuccess = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      showError = _useState6[0],
      setShowError = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      agreement = _useState7[0],
      setAgreement = _useState7[1];

  var filteredDataLength = filteredData.length > 0;
  var content = {
    title: t('common:noJobsAvailable'),
    text: t('common:informationBlockDescription'),
    buttonText: t('common:Send')
  };
  (0,react.useEffect)(function () {
    setSortValueCity({
      id: 0,
      name: t('common:All')
    });
    setSortValueCategory({
      id: 0,
      name: t('common:All')
    });
  }, [lang]);
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      full_name: '',
      phone: '',
      email: '',
      file: [],
      position_id: ''
    },
    validationSchema: FormSchema,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
        var formData, response;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();
                formData.append('full_name', values === null || values === void 0 ? void 0 : values.full_name);
                formData.append('phone', values === null || values === void 0 ? void 0 : values.phone);
                formData.append('email', values === null || values === void 0 ? void 0 : values.email);
                formData.append('file', values === null || values === void 0 ? void 0 : values.file[0]);
                formData.append('position_id', positionId);
                formData.append('g-recaptcha-response', captcha);
                _context.prev = 7;
                setLoading(true);
                _context.next = 11;
                return axios/* default.post */.Z.post('job-applications/', formData, {
                  baseURL: constants/* CLIENT_URL */.$p,
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 11:
                response = _context.sent;

                if (response) {
                  setShowSuccess(true);
                }

                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](7);
                setShowError(true);

              case 18:
                _context.prev = 18;
                setLoading(false);
                setActiveModal(false);
                setAgreement(false);
                formik.resetForm();
                return _context.finish(18);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 15, 18, 24]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var modalHandler = function modalHandler() {
    setShowSuccess(false);
    setShowError(false);
  };

  react.useEffect(function () {
    if ((sortValueCity === null || sortValueCity === void 0 ? void 0 : sortValueCity.id) === 0 && (sortValueCategory === null || sortValueCategory === void 0 ? void 0 : sortValueCategory.id) === 0) {
      setFilteredData(data === null || data === void 0 ? void 0 : data.positions);
    } else if ((sortValueCity === null || sortValueCity === void 0 ? void 0 : sortValueCity.id) === 0 && (sortValueCategory === null || sortValueCategory === void 0 ? void 0 : sortValueCategory.id) !== 0) {
      var _data$positions;

      var filterByCategory = data === null || data === void 0 ? void 0 : (_data$positions = data.positions) === null || _data$positions === void 0 ? void 0 : _data$positions.filter(function (item) {
        var _item$department;

        return String(item === null || item === void 0 ? void 0 : (_item$department = item.department) === null || _item$department === void 0 ? void 0 : _item$department.id) === String(sortValueCategory === null || sortValueCategory === void 0 ? void 0 : sortValueCategory.id);
      });
      setFilteredData(filterByCategory);
    } else if ((sortValueCity === null || sortValueCity === void 0 ? void 0 : sortValueCity.id) !== 0 && (sortValueCategory === null || sortValueCategory === void 0 ? void 0 : sortValueCategory.id) === 0) {
      var _data$positions2;

      var filterByCity = data === null || data === void 0 ? void 0 : (_data$positions2 = data.positions) === null || _data$positions2 === void 0 ? void 0 : _data$positions2.filter(function (item) {
        return String(item === null || item === void 0 ? void 0 : item.city_id) === String(sortValueCity === null || sortValueCity === void 0 ? void 0 : sortValueCity.id);
      });
      setFilteredData(filterByCity);
    } else {
      var filtered = data === null || data === void 0 ? void 0 : data.positions.filter(function (item) {
        var _item$department2;

        return String(item === null || item === void 0 ? void 0 : item.city_id) === String(sortValueCity === null || sortValueCity === void 0 ? void 0 : sortValueCity.id) && String(item === null || item === void 0 ? void 0 : (_item$department2 = item.department) === null || _item$department2 === void 0 ? void 0 : _item$department2.id) === String(sortValueCategory === null || sortValueCategory === void 0 ? void 0 : sortValueCategory.id);
      });
      setFilteredData(filtered);
    }
  }, [sortValueCity === null || sortValueCity === void 0 ? void 0 : sortValueCity.id, sortValueCategory === null || sortValueCategory === void 0 ? void 0 : sortValueCategory.id, data]);

  var showElement = function showElement() {
    setIsShow(true);
  };

  var onApply = function onApply() {
    setActiveModal(true);
  };

  var onChange = function onChange(value) {
    formik.setFieldValue('captcha', value);
    setCaptcha(value);
  };

  var onCloseModal = function onCloseModal(value) {
    formik.resetForm();
    setActiveModal(value);
  };

  var renderVacancy = function renderVacancy(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Vacancies_VacanciesListItem, {
      onApply: onApply,
      item: item,
      cities: data === null || data === void 0 ? void 0 : data.cities,
      setPositionId: setPositionId
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "section",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wrapper small-margin",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        className: (Vacancies_module_default()).title,
        children: data === null || data === void 0 ? void 0 : data.title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Vacancies_module_default()).content_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Vacancies_module_default()).titleWrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ScreenLoader */.v$, {
            visible: loading
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Vacancies_module_default()).sorts,
            children: [(data === null || data === void 0 ? void 0 : data.cities) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Select */.Ph, {
              value: sortValueCity,
              data: spreadDataForCity,
              label: t('common:sortByCity'),
              onChange: setSortValueCity
            }), (data === null || data === void 0 ? void 0 : data.departments) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Select */.Ph, {
              value: sortValueCategory,
              data: spreadDataForDepartment,
              label: t('common:sortByCategory'),
              onChange: setSortValueCategory
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
          className: (Vacancies_module_default()).vacancies,
          children: (data === null || data === void 0 ? void 0 : data.positions) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Vacancies_module_default()).vacancies__wrapper,
            children: [filteredDataLength ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()((Vacancies_module_default()).vacancies__list, (0,defineProperty/* default */.Z)({}, (Vacancies_module_default()).show, isShow)),
              children: filteredData === null || filteredData === void 0 ? void 0 : filteredData.map(renderVacancy)
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InformationBlock */.fW, {
              content: content,
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* UsersCircule */.aI, {}),
              onClick: onApply,
              secondary: true,
              noBackgroundImage: true
            }), (data === null || data === void 0 ? void 0 : data.positions) > positionsLength && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()((Vacancies_module_default())["vacancies-opener"], (0,defineProperty/* default */.Z)({}, (Vacancies_module_default()).hide, !!isShow)),
              onClick: showElement,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (Vacancies_module_default())["vacancies-opener__text"],
                children: t('common:See more')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
                width: 24,
                height: 24
              })]
            })]
          })
        })]
      })]
    }), activeModal && /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal, {
      active: activeModal,
      setActive: onCloseModal,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'title',
        children: t('common:Modal title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'note',
        children: t('common:Modal description')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        className: "".concat((Vacancies_module_default()).modalContent, " grid-extend equal"),
        onSubmit: formik.handleSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((Vacancies_module_default()).field, " ").concat((Vacancies_module_default()).half),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            onBlur: formik.handleBlur('full_name'),
            error: formik.touched.full_name && formik.errors.full_name,
            value: formik.values.full_name,
            onChange: function onChange(value) {
              return formik.setFieldValue('full_name', value);
            },
            label: t('common:Full name'),
            placeholder: t('common:fullname')
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((Vacancies_module_default()).field, " ").concat((Vacancies_module_default()).half),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            onBlur: formik.handleBlur('phone'),
            error: formik.touched.phone && formik.errors.phone,
            value: formik.values.phone,
            onChange: function onChange(value) {
              return formik.setFieldValue('phone', value);
            },
            label: t('common:Contact'),
            placeholder: '+994-XX-XXX-XX-XX',
            mask: '+\\9\\9\\4-99-999-99-99'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Vacancies_module_default()).field,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            onBlur: formik.handleBlur('email'),
            error: formik.touched.email && formik.errors.email,
            type: "email",
            value: formik.values.email,
            onChange: function onChange(value) {
              return formik.setFieldValue('email', value);
            },
            label: t('common:Email'),
            placeholder: t('common:Subscribe placeholder')
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Vacancies_module_default()).field,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (Vacancies_module_default()).fileTitle,
            children: t('common:Attach file')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* AttachFiles */.m5, {
            setFiles: function setFiles(file) {
              return formik.setFieldValue('file', file);
            },
            htmlText: data === null || data === void 0 ? void 0 : data.file_browse_text
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Vacancies_module_default()).field,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CheckboxWithText */.EG, {
            className: (Vacancies_module_default()).checkbox,
            name: "agreement",
            checked: agreement,
            onChange: function onChange(e) {
              return setAgreement(e.target.checked);
            },
            isHtml: true,
            children: data === null || data === void 0 ? void 0 : data.agreement_text
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
          sitekey: constants/* envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY */.ie.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default',
          onChange: onChange,
          hl: lang
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Vacancies_module_default()).field,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            className: (Vacancies_module_default()).button,
            type: 'submit',
            disabled: !agreement || !formik.isValid,
            children: t('common:Apply')
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InformationModal */.UI, {
      type: 'white',
      title: t('common:vacancies.title'),
      description: t('common:vacancies.desc'),
      active: showSuccess,
      onClose: modalHandler
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      active: showError,
      setActive: modalHandler,
      children: t('common:vacancies.error')
    })]
  });
};

/* harmony default export */ var Vacancies_Vacancies = (Vacancies);
;// CONCATENATED MODULE: ./components/about-us/index.js







/***/ }),

/***/ 86828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ InfoBlock; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/business-calls/InfoBlock/InfoBlock.module.scss
var InfoBlock_module = __webpack_require__(75044);
var InfoBlock_module_default = /*#__PURE__*/__webpack_require__.n(InfoBlock_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/business-calls/InfoBlock/InfoBlock.js








var InfoTable = function InfoTable(_ref) {
  var data = _ref.data,
      className = _ref.className;

  var renderButtonList = function renderButtonList(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
      className: (InfoBlock_module_default()).info__button,
      variant: "gray",
      Component: 'a',
      href: item === null || item === void 0 ? void 0 : item.link,
      download: true,
      children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item === null || item === void 0 ? void 0 : item.icon,
        alt: item === null || item === void 0 ? void 0 : item.text,
        title: item === null || item === void 0 ? void 0 : item.text,
        height: 24,
        width: 24,
        loading: "lazy"
      }), item === null || item === void 0 ? void 0 : item.text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrRight */.jG, {})]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((InfoBlock_module_default())["info-block"], className),
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      titleModify: classnames_default()((InfoBlock_module_default())["info-block__title"], 'title--large'),
      children: data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (InfoBlock_module_default())["info-block__inner"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (InfoBlock_module_default()).info,
        children: [(data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
          className: classnames_default()((InfoBlock_module_default()).info__text, 'text--large'),
          isHtml: true,
          children: data.description
        }), (data === null || data === void 0 ? void 0 : data.download_buttons) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (InfoBlock_module_default()).info__buttons,
          children: data.download_buttons.map(renderButtonList)
        }), (data === null || data === void 0 ? void 0 : data.note) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
          className: classnames_default()((InfoBlock_module_default())["info__add-text"], 'text--small'),
          children: data.note
        })]
      }), (data === null || data === void 0 ? void 0 : data.image) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (InfoBlock_module_default())["img-block"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: data === null || data === void 0 ? void 0 : data.image,
          alt: data === null || data === void 0 ? void 0 : data.title,
          title: data === null || data === void 0 ? void 0 : data.title,
          layout: "fill",
          loading: "lazy"
        })
      })]
    })]
  });
};

/* harmony default export */ var InfoBlock = (InfoTable);
;// CONCATENATED MODULE: ./components/business-calls/index.js


/***/ }),

/***/ 88426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ business_fix_service_FixService; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/business-services/ServiceFaq/ServiceFaq.js






var ServiceFaq = function ServiceFaq(_ref) {
  var data = _ref.data,
      className = _ref.className,
      Icon = _ref.Icon;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(styles['service-faq'], className),
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx(SectionTitle, {
      className: styles['service-faq__title'],
      titleModify: "title--large",
      Icon: Icon,
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.list) && /*#__PURE__*/_jsx(Faq, {
      className: styles['service-faq__list'],
      items: data.list
    })]
  });
};

/* harmony default export */ var ServiceFaq_ServiceFaq = ((/* unused pure expression or super */ null && (ServiceFaq)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/business-services/InfoTable/InfoTable.module.scss
var InfoTable_module = __webpack_require__(56798);
var InfoTable_module_default = /*#__PURE__*/__webpack_require__.n(InfoTable_module);
;// CONCATENATED MODULE: ./components/business-services/InfoTable/Table.js






var Table = function Table(_ref) {
  var data = _ref.data,
      className = _ref.className;
  (0,react.useEffect)(function () {
    var allWithClass = Array.from(document.querySelectorAll('.InfoTable_table__element__HelTx'));
    allWithClass.forEach(function (element, index) {
      if (index % 2 !== 0) element.classList.add((InfoTable_module_default()).gray);
    });
  }, []);

  var renderTableItem = function renderTableItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (InfoTable_module_default()).table__element,
      children: item === null || item === void 0 ? void 0 : item.text
    }, index);
  };

  var renderTableRow = function renderTableRow(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (InfoTable_module_default()).table__column,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        className: (InfoTable_module_default()).table__title,
        children: item.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (InfoTable_module_default()).table__values,
        children: item.values.map(renderTableItem)
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()((InfoTable_module_default()).table, className),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (InfoTable_module_default()).table__inner,
      children: data.map(renderTableRow)
    })
  });
};

/* harmony default export */ var InfoTable_Table = (Table);
;// CONCATENATED MODULE: ./components/business-services/InfoTable/InfoTable.js










var InfoTable = function InfoTable(_ref) {
  var data = _ref.data,
      className = _ref.className,
      dark = _ref.dark;

  var _useState = (0,react.useState)(false),
      modalActive = _useState[0],
      setModalActive = _useState[1];

  var closeModal = function closeModal() {
    setModalActive(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    "data-testid": "info-table",
    className: classnames_default()([(InfoTable_module_default())["info-table"], className, (0,defineProperty/* default */.Z)({}, (InfoTable_module_default())["info-table--dark"], dark)]),
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      titleModify: classnames_default()((InfoTable_module_default())["info-table__title"], 'title--large'),
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
      className: classnames_default()((InfoTable_module_default())["info-table__text"], 'text--large'),
      children: data.description
    }), (data === null || data === void 0 ? void 0 : data.columns) && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoTable_Table, {
      data: data === null || data === void 0 ? void 0 : data.columns
    }), (data === null || data === void 0 ? void 0 : data.button_text) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
      className: (InfoTable_module_default())["info-table__button"],
      onClick: function onClick() {
        return setModalActive(true);
      },
      children: [data === null || data === void 0 ? void 0 : data.button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
        width: 20
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* BusinessContactForm */.Rm, {
      activeModal: modalActive,
      clearTariff: closeModal
    })]
  });
};

/* harmony default export */ var InfoTable_InfoTable = (InfoTable);
;// CONCATENATED MODULE: ./components/business-services/index.js


// EXTERNAL MODULE: ./components/business-fix-service/FixService.module.scss
var FixService_module = __webpack_require__(25190);
var FixService_module_default = /*#__PURE__*/__webpack_require__.n(FixService_module);
;// CONCATENATED MODULE: ./components/business-fix-service/FixService.js





var FixService = function FixService(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (FixService_module_default()).tables,
    children: data && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "wrapper small-margin",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(InfoTable_InfoTable, {
        data: data,
        dark: true,
        className: (FixService_module_default()).tables__item
      })
    })
  });
};

/* harmony default export */ var business_fix_service_FixService = (FixService);

/***/ }),

/***/ 32030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jt": function() { return /* reexport */ business_join_us_BusinessJoinUs; },
  "Nr": function() { return /* reexport */ ContentList; },
  "CJ": function() { return /* reexport */ WhyBlock_WhyBlock; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/business-join-us/WhyBlock/WhyBlock.module.scss
var WhyBlock_module = __webpack_require__(49807);
var WhyBlock_module_default = /*#__PURE__*/__webpack_require__.n(WhyBlock_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/business-join-us/WhyBlock/WhyBlock.js







var WhyBlock = function WhyBlock(_ref) {
  var _data$items;

  var data = _ref.data,
      className = _ref.className;

  var renderSubtextAlign = function renderSubtextAlign(item) {
    var content = '';

    if ((item === null || item === void 0 ? void 0 : item.subtext_align) === 'left') {
      content = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (WhyBlock_module_default()).why__subtext,
          children: item === null || item === void 0 ? void 0 : item.subtext
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          className: (WhyBlock_module_default()).why__text,
          children: item === null || item === void 0 ? void 0 : item.text
        })]
      });
    } else {
      content = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          className: (WhyBlock_module_default()).why__text,
          children: item === null || item === void 0 ? void 0 : item.text
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (WhyBlock_module_default()).why__subtext,
          children: item === null || item === void 0 ? void 0 : item.subtext
        })]
      });
    }

    return content;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((WhyBlock_module_default())["why-block"], className),
    children: [!!(data !== null && data !== void 0 && data.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (WhyBlock_module_default()).topWrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        titleModify: classnames_default()((WhyBlock_module_default())["why-block__title"], 'title--large'),
        children: data.title
      }), !!(data !== null && data !== void 0 && data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: classnames_default()((WhyBlock_module_default())["why-block__text"], 'text--large'),
        isHtml: true,
        children: data.description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (WhyBlock_module_default())["why-block__content"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (WhyBlock_module_default()).why,
        children: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (WhyBlock_module_default()).why__item,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (WhyBlock_module_default()).why__value,
              children: (item === null || item === void 0 ? void 0 : item.subtext) && renderSubtextAlign(item)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (WhyBlock_module_default()).why__name,
              children: item === null || item === void 0 ? void 0 : item.name
            })]
          }, item === null || item === void 0 ? void 0 : item.id);
        })
      })
    })]
  });
};

/* harmony default export */ var WhyBlock_WhyBlock = (WhyBlock);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/business-join-us/ContentList/ContentList.module.scss
var ContentList_module = __webpack_require__(80455);
var ContentList_module_default = /*#__PURE__*/__webpack_require__.n(ContentList_module);
;// CONCATENATED MODULE: ./components/business-join-us/ContentList/ContentList.js







var InfoTable = function InfoTable(_ref) {
  var _data$linkBlock, _data$linkBlock2, _data$linkBlock2$link;

  var data = _ref.data,
      className = _ref.className;

  var renderListItem = function renderListItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: item
    }, index);
  };

  var renderLinks = function renderLinks(item, index) {
    var renderIsType = function () {
      if (item.type === 'phone') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          title: item.text,
          "aria-label": item.text,
          href: "tel:".concat(item.src),
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: item.text
        });
      }

      if (item.type === 'email') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          title: item.text,
          "aria-label": item.text,
          href: "mailto:".concat(item.src),
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: item.text
        });
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        title: item.text,
        "aria-label": item.text,
        href: item.src,
        children: item.text
      });
    }();

    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: renderIsType
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((ContentList_module_default())["content-list"], className),
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      titleModify: classnames_default()((ContentList_module_default())["content-list__title"], 'title--large'),
      children: data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ContentList_module_default())["content-list__grid"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ContentList_module_default())["content-list__inner"],
        children: [(data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
          className: classnames_default()([(ContentList_module_default())["content-list__text"], 'text--medium', 'text--shadow-black']),
          isHtml: true,
          children: data.description
        }), (data === null || data === void 0 ? void 0 : data.numList) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* NumList */.Xt, {
          className: (ContentList_module_default())["content-list__values"],
          children: data.numList.map(renderListItem)
        }), (data === null || data === void 0 ? void 0 : data.linkBlock) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ContentList_module_default()).links,
          children: [(data === null || data === void 0 ? void 0 : (_data$linkBlock = data.linkBlock) === null || _data$linkBlock === void 0 ? void 0 : _data$linkBlock.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            className: (ContentList_module_default()).links__title,
            children: data.linkBlock.title
          }), (data === null || data === void 0 ? void 0 : (_data$linkBlock2 = data.linkBlock) === null || _data$linkBlock2 === void 0 ? void 0 : (_data$linkBlock2$link = _data$linkBlock2.links) === null || _data$linkBlock2$link === void 0 ? void 0 : _data$linkBlock2$link.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: (ContentList_module_default()).links__list,
            children: data.linkBlock.links.map(renderLinks)
          })]
        })]
      }), (data === null || data === void 0 ? void 0 : data.image) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ContentList_module_default())["img-block"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: (ContentList_module_default())["img-block__elem"],
          src: data.image,
          alt: data === null || data === void 0 ? void 0 : data.title,
          title: data === null || data === void 0 ? void 0 : data.title,
          loading: "lazy",
          layout: "fill"
        })
      })]
    })]
  });
};

/* harmony default export */ var ContentList = (InfoTable);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/business-join-us/BusinessJoinUs.module.scss
var BusinessJoinUs_module = __webpack_require__(59354);
var BusinessJoinUs_module_default = /*#__PURE__*/__webpack_require__.n(BusinessJoinUs_module);
;// CONCATENATED MODULE: ./components/business-join-us/BusinessJoinUs.js











var Card = function Card(_ref) {
  var data = _ref.data,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
    className: (BusinessJoinUs_module_default()).card,
    children: [(data === null || data === void 0 ? void 0 : data.image) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (BusinessJoinUs_module_default())["card__img-wrapper"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: (BusinessJoinUs_module_default()).card__img,
        src: data.image,
        alt: data === null || data === void 0 ? void 0 : data.title,
        title: data === null || data === void 0 ? void 0 : data.title,
        loading: "lazy",
        layout: "fill"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (BusinessJoinUs_module_default()).card__content,
      children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        className: (BusinessJoinUs_module_default()).card__title,
        children: data.title
      }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: classnames_default()((BusinessJoinUs_module_default()).card__text, 'text--medium', 'text--shadow-black'),
        children: data.description
      }), (data === null || data === void 0 ? void 0 : data.button_text) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
        className: (BusinessJoinUs_module_default()).card__button,
        onClick: function onClick() {
          return _onClick(data.id);
        },
        children: [data.button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrRight */.jG, {})]
      })]
    })]
  });
};

var BusinessJoinUs = function BusinessJoinUs(_ref2) {
  var data = _ref2.data,
      className = _ref2.className;

  var _useState = (0,react.useState)(''),
      employee = _useState[0],
      setEmployee = _useState[1];

  var _useState2 = (0,react.useState)(false),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  var handleClick = function handleClick(id) {
    setModalActive(true);
    setEmployee(id);
  };

  var renderCard = function renderCard(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
      data: item,
      onClick: handleClick
    }, index);
  };

  var closeModal = function closeModal() {
    setModalActive(false);
    setEmployee('');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.cards) && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: classnames_default()((BusinessJoinUs_module_default())["content-cards"], 'wrapper section', className),
      children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        titleModify: classnames_default()((BusinessJoinUs_module_default())["content-cards__title"], 'title--large'),
        children: data.title
      }), (data === null || data === void 0 ? void 0 : data.cards) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (BusinessJoinUs_module_default())["content-cards__inner"],
        children: data.cards.map(renderCard)
      })]
    }), (data === null || data === void 0 ? void 0 : data.infoBlock) && /*#__PURE__*/(0,jsx_runtime.jsx)(ContentList, {
      className: "wrapper medium-margin",
      data: data.infoBlock
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* BusinessContactForm */.Rm, {
      employeeID: employee,
      activeModal: modalActive,
      clearTariff: closeModal,
      hasEmployeesCount: true
    })]
  });
};

/* harmony default export */ var business_join_us_BusinessJoinUs = (BusinessJoinUs);
;// CONCATENATED MODULE: ./components/business-join-us/index.js




/***/ }),

/***/ 47433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KU": function() { return /* reexport */ Advantageous_Advantageous; }
});

// UNUSED EXPORTS: Archive, Bundles, Call, InFlight, Internet, Roaming, RoamingMain, Sms

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/ui/PageTabs/PageTabs.js
var PageTabs_PageTabs = __webpack_require__(58148);
// EXTERNAL MODULE: ./components/ui/GridProducts/GridProducts.js
var GridProducts_GridProducts = __webpack_require__(74715);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/business-roaming/Roaming/Roaming.js







var Roaming = function Roaming(_ref) {
  var _data$offers;

  var data = _ref.data;

  var renderTariff = function renderTariff(tariff, index) {
    return /*#__PURE__*/_jsx(TariffCard, {
      item: tariff
    }, "".concat(index, "_tariff"));
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [data.tabs && /*#__PURE__*/_jsx(PageTabs, {
      tabs: data.tabs,
      pathname: 'roaming'
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner
    }), !!(data !== null && data !== void 0 && (_data$offers = data.offers) !== null && _data$offers !== void 0 && _data$offers.length) && /*#__PURE__*/_jsx(GridProducts, {
      children: data.offers.map(renderTariff)
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(Banner, {
      item: data.banner
    })]
  });
};

/* harmony default export */ var Roaming_Roaming = ((/* unused pure expression or super */ null && (Roaming)));
// EXTERNAL MODULE: ./components/roaming/SpecialOffers/SpecialOffers.js + 1 modules
var SpecialOffers_SpecialOffers = __webpack_require__(55438);
// EXTERNAL MODULE: ./components/roaming/index.js + 12 modules
var roaming = __webpack_require__(4538);
// EXTERNAL MODULE: ./components/roaming/InternetActivation/InternetActivation.js + 1 modules
var InternetActivation_InternetActivation = __webpack_require__(57208);
;// CONCATENATED MODULE: ./components/business-roaming/Roaming/RoamingMain.js









var RoamingMain = function RoamingMain(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.breadcrumbs) && /*#__PURE__*/_jsx(Breadcrumbs, {
      data: data.breadcrumbs,
      dark: true
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner,
      dark: true,
      medium: true
    }), (data === null || data === void 0 ? void 0 : data.travel) && /*#__PURE__*/_jsx(SearchTravel, {
      travelData: data.travel
    }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(BusinessTariffsCard, {
      tabs: data.offers,
      title: 'Recommended tariffs',
      buttonText: 'Archive'
    }), (data === null || data === void 0 ? void 0 : data.servicesList) && /*#__PURE__*/_jsx(SpecialOffers, {
      data: data === null || data === void 0 ? void 0 : data.servicesList
    }), (data === null || data === void 0 ? void 0 : data.productStatus) && /*#__PURE__*/_jsx(RoamingActivation, {
      productStatus: data === null || data === void 0 ? void 0 : data.productStatus
    }), (data === null || data === void 0 ? void 0 : data.internetActivation) && /*#__PURE__*/_jsx(InternetActivation, {
      data: data.internetActivation
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(BusinessContactForm, {
      bannerData: data === null || data === void 0 ? void 0 : data.banner
    })]
  });
};

/* harmony default export */ var Roaming_RoamingMain = ((/* unused pure expression or super */ null && (RoamingMain)));
;// CONCATENATED MODULE: ./components/business-roaming/Internet/Internet.js







var Internet = function Internet(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    children: [(data === null || data === void 0 ? void 0 : data.breadcrumbs) && /*#__PURE__*/_jsx(Breadcrumbs, {
      data: data.breadcrumbs,
      dark: true
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner,
      dark: true,
      medium: true
    }), /*#__PURE__*/_jsx("div", {
      className: 'wrapper little-margin',
      children: /*#__PURE__*/_jsx(TextBlock, {
        className: styles.text,
        children: "Stay in contact with your beloved ones without touching your data via the free WhatsApp feature from roaming in more than 40 countries!"
      })
    }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(BusinessTariffsCard, {
      data: data.offers
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Questions, {
      title: null,
      className: 'wrapper section',
      questions: data.questions
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(BusinessContactForm, {
      bannerData: data === null || data === void 0 ? void 0 : data.banner
    })]
  });
};

/* harmony default export */ var Internet_Internet = ((/* unused pure expression or super */ null && (Internet)));
;// CONCATENATED MODULE: ./components/business-roaming/Bundles/Bundles.js







var Bundles = function Bundles(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    children: [(data === null || data === void 0 ? void 0 : data.breadcrumbs) && /*#__PURE__*/_jsx(Breadcrumbs, {
      data: data.breadcrumbs,
      dark: true
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner,
      dark: true,
      medium: true
    }), /*#__PURE__*/_jsx("div", {
      className: 'wrapper',
      children: /*#__PURE__*/_jsx(TextBlock, {
        className: styles.text,
        children: "Choose All-in-One bundles in roaming for your trips to feel the superior benefit of boundless communication!"
      })
    }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(BusinessTariffsCard, {
      data: data.offers
    }), /*#__PURE__*/_jsx("div", {
      className: 'wrapper',
      children: /*#__PURE__*/_jsx(TextBlock, {
        className: styles.text,
        children: "The monthly bundle is provided with 20% OFF (24 AZN) to Business subscribers within the campaign period. The information about expiration will be placed on the website."
      })
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Questions, {
      title: null,
      className: 'wrapper',
      questions: data.questions
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(BusinessContactForm, {
      bannerData: data === null || data === void 0 ? void 0 : data.banner
    })]
  });
};

/* harmony default export */ var Bundles_Bundles = ((/* unused pure expression or super */ null && (Bundles)));
;// CONCATENATED MODULE: ./components/business-roaming/Sms/Sms.js







var Sms = function Sms(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    children: [(data === null || data === void 0 ? void 0 : data.breadcrumbs) && /*#__PURE__*/_jsx(Breadcrumbs, {
      data: data.breadcrumbs,
      dark: true
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner,
      dark: true,
      medium: true
    }), /*#__PURE__*/_jsx("div", {
      className: 'wrapper',
      children: /*#__PURE__*/_jsx(TextBlock, {
        className: styles.text,
        children: "With roaming call packages from Bakcell, you can travel to more than 50 countries and enjoy value-for-money rates every time you make/receive calls. All Bakcell subscribers can benefit from any roaming packages."
      })
    }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(BusinessTariffsCard, {
      data: data.offers
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Questions, {
      title: null,
      className: 'wrapper section',
      questions: data.questions
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(BusinessContactForm, {
      bannerData: data === null || data === void 0 ? void 0 : data.banner
    })]
  });
};

/* harmony default export */ var Sms_Sms = ((/* unused pure expression or super */ null && (Sms)));
;// CONCATENATED MODULE: ./components/business-roaming/Call/Call.js







var Call = function Call(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    children: [(data === null || data === void 0 ? void 0 : data.breadcrumbs) && /*#__PURE__*/_jsx(Breadcrumbs, {
      data: data.breadcrumbs,
      dark: true
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner,
      dark: true,
      medium: true
    }), /*#__PURE__*/_jsx("div", {
      className: 'wrapper',
      children: /*#__PURE__*/_jsx(TextBlock, {
        className: styles.text,
        children: "With roaming call packages from Bakcell, you can travel to more than 50 countries and enjoy value-for-money rates every time you make/receive calls. All Bakcell subscribers can benefit from any roaming packages."
      })
    }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(BusinessTariffsCard, {
      data: data.offers
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Questions, {
      title: null,
      className: 'wrapper section',
      questions: data.questions
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(BusinessContactForm, {
      bannerData: data === null || data === void 0 ? void 0 : data.banner
    })]
  });
};

/* harmony default export */ var Call_Call = ((/* unused pure expression or super */ null && (Call)));
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
;// CONCATENATED MODULE: ./components/business-roaming/InFlight/InFlight.js









var InFlight = function InFlight(_ref) {
  var _data$campaignTable, _data$campaignTable2;

  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    children: [(data === null || data === void 0 ? void 0 : data.mainBanner2) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner2,
      dark: true,
      medium: true,
      isHtml: true
    }), /*#__PURE__*/_jsxs("div", {
      className: 'wrapper little-margin',
      children: [(data === null || data === void 0 ? void 0 : (_data$campaignTable = data.campaignTable) === null || _data$campaignTable === void 0 ? void 0 : _data$campaignTable.mainText) && /*#__PURE__*/_jsx(TextBlock, {
        className: classNames([styles.text, 'text--large']),
        children: data.campaignTable.mainText
      }), (data === null || data === void 0 ? void 0 : (_data$campaignTable2 = data.campaignTable) === null || _data$campaignTable2 === void 0 ? void 0 : _data$campaignTable2.infoTable) && /*#__PURE__*/_jsx(BusinessTable, {
        data: data.campaignTable.infoTable
      }), /*#__PURE__*/_jsxs(Button, {
        className: styles.button,
        children: ["Subscribe ", /*#__PURE__*/_jsx(ArrRight, {
          width: 24
        })]
      })]
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Questions, {
      title: null,
      className: 'wrapper',
      questions: data.questions
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(BusinessContactForm, {
      bannerData: data === null || data === void 0 ? void 0 : data.banner
    })]
  });
};

/* harmony default export */ var InFlight_InFlight = ((/* unused pure expression or super */ null && (InFlight)));
;// CONCATENATED MODULE: ./components/business-roaming/Archive/Archive.js









var Archive = function Archive(_ref) {
  var data = _ref.data;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.breadcrumbs) && /*#__PURE__*/_jsx(Breadcrumbs, {
      data: data.breadcrumbs,
      dark: true
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner,
      dark: true,
      medium: true
    }), /*#__PURE__*/_jsxs(Tabs, {
      active: activeTab,
      children: [/*#__PURE__*/_jsxs(TabPanel, {
        className: 'wrapper',
        children: [/*#__PURE__*/_jsx(Tab, {
          onClick: function onClick() {
            return setActiveTab(0);
          },
          children: "Roaming Internet packages"
        }), /*#__PURE__*/_jsx(Tab, {
          onClick: function onClick() {
            return setActiveTab(1);
          },
          children: "All-in-one"
        }), /*#__PURE__*/_jsx(Tab, {
          onClick: function onClick() {
            return setActiveTab(2);
          },
          children: "\u0421alls"
        })]
      }), /*#__PURE__*/_jsxs(TabContent, {
        children: [/*#__PURE__*/_jsxs(TabContentItem, {
          children: [/*#__PURE__*/_jsx("div", {
            className: 'wrapper',
            children: /*#__PURE__*/_jsx(TextBlock, {
              className: styles.text,
              children: "Choose All-in-One bundles in roaming for your trips to feel the superior benefit of boundless communication!"
            })
          }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(BusinessTariffsCard, {
            data: data.offers
          })]
        }), /*#__PURE__*/_jsxs(TabContentItem, {
          children: [/*#__PURE__*/_jsx("div", {
            className: 'wrapper',
            children: /*#__PURE__*/_jsx(TextBlock, {
              className: styles.text,
              children: "Choose All-in-One bundles in roaming for your trips to feel the superior benefit of boundless communication!"
            })
          }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(BusinessTariffsCard, {
            data: data.offers
          })]
        }), /*#__PURE__*/_jsxs(TabContentItem, {
          children: [/*#__PURE__*/_jsx("div", {
            className: 'wrapper',
            children: /*#__PURE__*/_jsx(TextBlock, {
              className: styles.text,
              children: "Choose All-in-One bundles in roaming for your trips to feel the superior benefit of boundless communication!"
            })
          }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(BusinessTariffsCard, {
            data: data.offers
          })]
        })]
      })]
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Questions, {
      title: null,
      className: 'wrapper section',
      questions: data.questions
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(BusinessContactForm, {
      bannerData: data === null || data === void 0 ? void 0 : data.banner
    })]
  });
};

/* harmony default export */ var Archive_Archive = ((/* unused pure expression or super */ null && (Archive)));
// EXTERNAL MODULE: ./components/business-roaming/Advantageous/Advantageous.module.scss
var Advantageous_module = __webpack_require__(14138);
var Advantageous_module_default = /*#__PURE__*/__webpack_require__.n(Advantageous_module);
;// CONCATENATED MODULE: ./components/business-roaming/Advantageous/Advantageous.js







var Advantageous = function Advantageous(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: 'wrapper small-margin',
      children: [(data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: classnames_default()([(Advantageous_module_default()).text, 'text--large']),
        children: data.description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CallBlock */.Yh, {
        numbers: data === null || data === void 0 ? void 0 : data.items
      })]
    })
  });
};

/* harmony default export */ var Advantageous_Advantageous = (Advantageous);
;// CONCATENATED MODULE: ./components/business-roaming/index.js










/***/ }),

/***/ 91425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ TopUpModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/setLanguage.js
var setLanguage = __webpack_require__(14994);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(53431);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./domains/cabinet/index.js + 1 modules
var cabinet = __webpack_require__(3519);
// EXTERNAL MODULE: ./utils/languageFormat.js
var languageFormat = __webpack_require__(16955);
// EXTERNAL MODULE: ./utils/formatPhoneNumberNew.js
var formatPhoneNumberNew = __webpack_require__(32238);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/SvgComponents/OutlineCheck.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var OutlineCheck = function OutlineCheck(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM16.7372 9.67572C17.1103 9.26861 17.0828 8.63604 16.6757 8.26285C16.2686 7.88965 15.636 7.91716 15.2628 8.32428L10.5359 13.481L8.76822 11.3598C8.41466 10.9355 7.78409 10.8782 7.35982 11.2318C6.93554 11.5853 6.87821 12.2159 7.23178 12.6402L9.73178 15.6402C9.91649 15.8618 10.1879 15.9929 10.4764 15.9997C10.7648 16.0065 11.0422 15.8884 11.2372 15.6757L16.7372 9.67572Z",
      fill: "var(--colorIconPrimary)"
    })
  }));
};
// EXTERNAL MODULE: ./utils/formatPhoneNumber.js
var formatPhoneNumber = __webpack_require__(53836);
// EXTERNAL MODULE: ./components/ui/Modals/Success/SuccessModal.js + 1 modules
var SuccessModal = __webpack_require__(81086);
// EXTERNAL MODULE: ./enums/numberSale.ts
var numberSale = __webpack_require__(56951);
// EXTERNAL MODULE: ./components/cabinet/top-up-modal/index.module.scss
var index_module = __webpack_require__(23484);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/cabinet/top-up-modal/index.js























var TopUpModal = function TopUpModal(_ref) {
  var _accounts$find, _accounts$find$phone, _data$mainBalance;

  var active = _ref.active,
      setTopUpModalActive = _ref.setTopUpModalActive,
      accounts = _ref.accounts,
      selectedAccountId = _ref.selectedAccountId,
      data = _ref.data,
      _ref$isMainPage = _ref.isMainPage,
      isMainPage = _ref$isMainPage === void 0 ? false : _ref$isMainPage;
  var router = (0,next_router.useRouter)();
  var paymentStatus = router.query.paymentStatus;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var formattedLang = (0,languageFormat/* langFormatter */.u)({
    lang: lang
  });
  var numberVariants = {
    EXISTNUMBER: 'EXISTNUMBER',
    OTHERNUMBER: 'OTHERNUMBER'
  };
  var customAmounts = [1, 5, 10];

  var _useState = (0,react.useState)(numberVariants.EXISTNUMBER),
      selectedVariant = _useState[0],
      setSelectedVariant = _useState[1];

  var _useState2 = (0,react.useState)(false),
      succesModalActive = _useState2[0],
      setSuccessModalActive = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      errorModalActive = _useState3[0],
      setErrorModalActive = _useState3[1];

  var _cabinetHooks$useTopU = cabinet/* hooks.useTopUpWithoutCard */.PT.useTopUpWithoutCard(),
      _cabinetHooks$useTopU2 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useTopU, 2),
      topUpTrigger = _cabinetHooks$useTopU2[0],
      _cabinetHooks$useTopU3 = _cabinetHooks$useTopU2[1],
      error = _cabinetHooks$useTopU3.error,
      isLoading = _cabinetHooks$useTopU3.isLoading;

  var number = accounts === null || accounts === void 0 ? void 0 : (_accounts$find = accounts.find(function (account) {
    return (account === null || account === void 0 ? void 0 : account.id) === selectedAccountId;
  })) === null || _accounts$find === void 0 ? void 0 : (_accounts$find$phone = _accounts$find.phone) === null || _accounts$find$phone === void 0 ? void 0 : _accounts$find$phone.number;
  (0,react.useEffect)(function () {
    var lang = sessionStorage.getItem('lang');

    if (lang && lang !== router.locale) {
      (0,setLanguage/* default */.Z)(lang);
    }

    sessionStorage.removeItem('lang');

    var handleWheel = function handleWheel(event) {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };

    window.addEventListener('wheel', handleWheel, {
      passive: true
    });
    return function () {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);
  var FormSchema = es/* object */.Ry().shape({
    amount: es/* number */.Rx().min(1, t('common:AmountMin')).max(250, t('common:AmountWarning')).required(t('common:Required')),
    phone: es/* string */.Z_().matches(/^\+994-\d{2}-\d{3}-\d{2}-\d{2}$/, t('common:Required')).required(t('common:Required'))
  });

  var cleanedPhoneNumber = function cleanedPhoneNumber(value) {
    return value.replace(/[+-]/g, '');
  };

  (0,react.useEffect)(function () {
    if (!router.query.dynamicPage) {
      var statusLower = paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.toLowerCase();

      if (statusLower === numberSale/* PaymentStatus.SUCCESS.toLowerCase */.bG.SUCCESS.toLowerCase()) {
        setSuccessModalActive(true);
      } else if (Object.values(numberSale/* PaymentStatus */.bG).some(function (status) {
        return status.toLowerCase() === statusLower;
      })) {
        setErrorModalActive(true);
      }
    }
  }, [router.isReady, router.pathname]);
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      amount: '',
      phone: (0,formatPhoneNumber/* formatPhoneNumber */.u)("994".concat(number))
    },
    validationSchema: FormSchema,
    validateOnMount: false,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
        var _yield$topUpTrigger$u, url;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return topUpTrigger({
                  lang: formattedLang,
                  amount: Number(values.amount),
                  receiver: selectedVariant === numberVariants.OTHERNUMBER || isMainPage ? cleanedPhoneNumber(values === null || values === void 0 ? void 0 : values.phone) : cleanedPhoneNumber(number)
                }).unwrap();

              case 3:
                _yield$topUpTrigger$u = _context.sent;
                url = _yield$topUpTrigger$u.url;
                sessionStorage.setItem('lang', lang);
                router.replace(url);
                setTopUpModalActive(false);
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setTopUpModalActive(false);
                setErrorModalActive(true);

              case 14:
                _context.prev = 14;
                formik.resetForm();
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10, 14, 17]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var topUpModalHandler = function topUpModalHandler() {
    setTopUpModalActive(false);
    formik.resetForm();
    setSelectedVariant(numberVariants.EXISTNUMBER);
  };

  var handleKeyDown = function handleKeyDown(e) {
    var _ref2 = (formik === null || formik === void 0 ? void 0 : formik.values) || {},
        amount = _ref2.amount;

    if (amount.length === 0 && e.key === '.' || amount.length === 1 && e.key === '0' && amount === '0' || ['-', 'e', 'E'].includes(e.key) || amount.length === 0 && e.key === '0' || amount.length === 0 && e.key === ',') {
      e.preventDefault();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Modal */.u_, {
      className: (index_module_default()).customTopupModal,
      active: active,
      setActive: topUpModalHandler,
      "data-testid": 'topup',
      itemScope: true,
      itemType: "https://schema.org/WebPage",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        children: t('cabinet:topUp')
      }), !isMainPage && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          children: t('cabinet:selectAccount')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (index_module_default()).selections,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onClick: function onClick() {
              setSelectedVariant(numberVariants.EXISTNUMBER);
              formik.setFieldValue('phone', (0,formatPhoneNumber/* formatPhoneNumber */.u)("994".concat(number)));
            },
            className: "".concat((index_module_default()).existNumber, " ").concat(selectedVariant === numberVariants.EXISTNUMBER && (index_module_default()).existNumber__active),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).top,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: (0,formatPhoneNumberNew/* default */.Z)(number)
              }), selectedVariant === numberVariants.EXISTNUMBER && /*#__PURE__*/(0,jsx_runtime.jsx)(OutlineCheck, {})]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).bottom,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (index_module_default()).title,
                children: t('cabinet:balance')
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (index_module_default()).amount,
                children: [(_data$mainBalance = data === null || data === void 0 ? void 0 : data.mainBalance) !== null && _data$mainBalance !== void 0 ? _data$mainBalance : data === null || data === void 0 ? void 0 : data.totalPossibleLimit, " \u20BC"]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onClick: function onClick() {
              setSelectedVariant(numberVariants.OTHERNUMBER);
              formik.setFieldValue('phone', '');
            },
            className: classnames_default()([(index_module_default()).otherNumber, (0,defineProperty/* default */.Z)({}, (index_module_default()).otherNumber__active, selectedVariant === numberVariants.OTHERNUMBER)]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).top,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: t('cabinet:otherNumber')
              }), selectedVariant === numberVariants.OTHERNUMBER && /*#__PURE__*/(0,jsx_runtime.jsx)(OutlineCheck, {})]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).bottom,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (index_module_default()).title,
                children: t('cabinet:otherNumberDesc')
              })
            })]
          })]
        })]
      }), (selectedVariant === numberVariants.OTHERNUMBER || isMainPage) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).otherNumberInput,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
          onBlur: formik.handleBlur('phone'),
          error: formik.touched.phone && formik.errors.phone,
          value: formik.values.phone,
          type: "tel",
          inputMode: "numeric",
          onChange: function onChange(value) {
            var formattedPhone = (0,formatPhoneNumber/* formatPhoneNumber */.u)(value);
            formik.setFieldValue('phone', formattedPhone);
          },
          label: t('cabinet:number'),
          placeholder: '+994-XX-XXX-XX-XX',
          mask: '+\\9\\9\\4-99-999-99-99',
          "data-testid": 'topup-phone-input'
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
        children: t('cabinet:amount')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((index_module_default()).amountInput, " ").concat(isMainPage && (index_module_default()).amountInput__main),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
          onBlur: formik.handleBlur('amount'),
          error: formik.touched.amount && formik.errors.amount,
          value: formik.values.amount,
          onChange: function onChange(value) {
            if (value.includes('.') && value.split('.')[1].length > 2) {
              return;
            }

            formik.setFieldValue('amount', value);
          },
          placeholder: t('cabinet:amountText'),
          type: "number",
          inputMode: "numeric",
          pattern: "[0-9]*",
          onKeyDown: handleKeyDown,
          "data-testid": 'topup-amount-input'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "\u20BC"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).amountOptions,
        children: customAmounts === null || customAmounts === void 0 ? void 0 : customAmounts.map(function (amount) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            onClick: function onClick() {
              return formik.setFieldValue('amount', amount);
            },
            children: [amount, " \u20BC"]
          }, amount);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).redLine
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          "data-testid": 'topup-submit',
          onClick: formik.handleSubmit,
          disabled: !formik.isValid,
          children: t('common:Continue')
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      active: errorModalActive,
      setActive: function setActive() {
        var pathname = router.pathname;
        router.replace({
          pathname: pathname
        }, undefined, {
          shallow: true
        });
        setErrorModalActive(false);
      },
      itemScope: true,
      itemType: "https://schema.org/WebPage",
      children: (error === null || error === void 0 ? void 0 : error.message) || t('common:FailMessage')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessModal/* SuccessModal */.i, {
      active: succesModalActive,
      setSuccessModal: function setSuccessModal() {
        var pathname = router.pathname;
        router.replace({
          pathname: pathname
        }, undefined, {
          shallow: true
        });
        setSuccessModalActive(false);
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ScreenLoader */.v$, {
      visible: isLoading
    })]
  });
};

/***/ }),

/***/ 56936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ir": function() { return /* reexport */ CampaignList_CampaignList; },
  "rc": function() { return /* reexport */ CampaignTable_CampaignTable; }
});

// UNUSED EXPORTS: Campaign, CampaignInfo

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(12420);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(4556);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./enums/theme.ts
var enums_theme = __webpack_require__(29128);
// EXTERNAL MODULE: ./components/campaigns/Campaign/Campaign.module.scss
var Campaign_module = __webpack_require__(48734);
var Campaign_module_default = /*#__PURE__*/__webpack_require__.n(Campaign_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/campaigns/Campaign/Campaign.js











var Campaign = function Campaign(_ref) {
  var data = _ref.data,
      href = _ref.href;

  var _useTheme = (0,index_module/* useTheme */.F)(),
      theme = _useTheme.theme;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isImageLoaded = _React$useState2[0],
      setIsImageLoaded = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Campaign_module_default()).newsItem,
    itemScope: true,
    itemType: "https://schema.org/NewsArticle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
      href: "".concat(href ? "/".concat(href) : '', "/").concat(data === null || data === void 0 ? void 0 : data.slug),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        title: data === null || data === void 0 ? void 0 : data.title,
        "aria-label": data === null || data === void 0 ? void 0 : data.title,
        className: (Campaign_module_default()).imageContainer,
        children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
          width: "100%",
          height: "100%"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: data === null || data === void 0 ? void 0 : data.image,
          alt: data === null || data === void 0 ? void 0 : data.title,
          title: data === null || data === void 0 ? void 0 : data.title,
          layout: "fill",
          loading: "lazy",
          onLoadingComplete: function onLoadingComplete() {
            return setIsImageLoaded(true);
          },
          style: {
            visibility: isImageLoaded ? 'visible' : 'hidden'
          }
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Campaign_module_default()).contentWrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Campaign_module_default()).textWrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Campaign_module_default()).title,
          children: data === null || data === void 0 ? void 0 : data.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Campaign_module_default()).description,
          children: data === null || data === void 0 ? void 0 : data.text
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Campaign_module_default()).link,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
          Component: 'router',
          variant: 'text',
          href: "".concat(href ? "/".concat(href) : '', "/").concat(data === null || data === void 0 ? void 0 : data.slug),
          className: (Campaign_module_default()).goToPost,
          children: [data === null || data === void 0 ? void 0 : data.link_text, ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Campaign_module_default()).arrow,
            children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
              width: 16,
              height: 16,
              style: {
                position: 'absolute',
                top: '24px'
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: theme === enums_theme/* ETheme.LIGHT_MODE */.X.LIGHT_MODE ? '/assets/ArrowRightLight.svg' : '/assets/ArrowRightDark.svg',
              alt: "arrow",
              title: "arrow",
              width: 16,
              height: 16,
              onLoadingComplete: function onLoadingComplete() {
                return setIsImageLoaded(true);
              },
              style: {
                visibility: isImageLoaded ? 'visible' : 'hidden'
              }
            })]
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var Campaign_Campaign = (Campaign);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle_SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./components/ui/GridProducts/GridProducts.js
var GridProducts = __webpack_require__(74715);
// EXTERNAL MODULE: ./components/campaigns/CampaignList/CampaignList.module.scss
var CampaignList_module = __webpack_require__(96725);
var CampaignList_module_default = /*#__PURE__*/__webpack_require__.n(CampaignList_module);
;// CONCATENATED MODULE: ./components/campaigns/CampaignList/CampaignList.js
/* eslint-disable react-hooks/exhaustive-deps */









var CampaignList = function CampaignList(_ref) {
  var _data$items;

  var data = _ref.data,
      href = _ref.href;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'small-margin',
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(['wrapper', (CampaignList_module_default()).titleWrapper]),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
        className: (CampaignList_module_default()).title,
        titleModify: "title--large",
        children: data === null || data === void 0 ? void 0 : data.title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(GridProducts/* default */.Z, {
      className: (CampaignList_module_default()).wrapper,
      children: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Campaign_Campaign, {
          data: item,
          href: href
        }, index);
      })
    })]
  });
};

/* harmony default export */ var CampaignList_CampaignList = (CampaignList);
// EXTERNAL MODULE: ./components/services/index.js + 11 modules
var services = __webpack_require__(972);
// EXTERNAL MODULE: ./components/campaigns/CampaignTable/CampaignTable.module.scss
var CampaignTable_module = __webpack_require__(88583);
var CampaignTable_module_default = /*#__PURE__*/__webpack_require__.n(CampaignTable_module);
;// CONCATENATED MODULE: ./components/campaigns/CampaignTable/CampaignTable.js








var CampaignTable = function CampaignTable(_ref) {
  var data = _ref.data,
      className = _ref.className,
      Icon = _ref.Icon;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((CampaignTable_module_default())["campaign-table"], className),
    itemScope: true,
    itemType: "https://schema.org/Table",
    children: [!!(data !== null && data !== void 0 && data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: classnames_default()((CampaignTable_module_default())["campaign-table__title"], 'title--large'),
      Icon: Icon,
      children: data === null || data === void 0 ? void 0 : data.title
    }), !!(data !== null && data !== void 0 && data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
      className: classnames_default()([(CampaignTable_module_default())["campaign-table__text"], 'text--large']),
      children: data === null || data === void 0 ? void 0 : data.description
    }), !!(data !== null && data !== void 0 && data.columns) && /*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServicesTable */.IC, {
      data: data
    }), !!(data !== null && data !== void 0 && data.rows) && /*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServicesTable */.IC, {
      data: data
    })]
  });
};

/* harmony default export */ var CampaignTable_CampaignTable = (CampaignTable);
;// CONCATENATED MODULE: ./components/campaigns/CampaignInfo/CampaignInfo.js






var CampaignInfo = function CampaignInfo(_ref) {
  var data = _ref.data,
      className = _ref.className,
      Icon = _ref.Icon;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(styles['campaign-info'], className),
    itemScope: true,
    itemType: "https://schema.org/FAQPage",
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx(SectionTitle, {
      className: styles['campaign-info__title'],
      titleModify: "title--large",
      Icon: Icon,
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.list) && /*#__PURE__*/_jsx(Faq, {
      className: styles['campaign-info__list'],
      items: data.list
    })]
  });
};

/* harmony default export */ var CampaignInfo_CampaignInfo = ((/* unused pure expression or super */ null && (CampaignInfo)));
;// CONCATENATED MODULE: ./components/campaigns/index.js





/***/ }),

/***/ 70996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84838);
/* harmony import */ var _support__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64310);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);







var ChooseTopicWidget = function ChooseTopicWidget(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.header) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_1__/* .InternetBanner */ .Jp, {
      bannerData: data.header
    }), data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_support__WEBPACK_IMPORTED_MODULE_2__/* .ChooseTopic */ .sc, {
      pageData: data
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_support__WEBPACK_IMPORTED_MODULE_2__/* .SupportBanner */ .Vj, {
      item: data.banner
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ChooseTopicWidget);

/***/ }),

/***/ 48756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var _react_google_maps_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91259);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97043);
/* harmony import */ var _GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4821);
/* harmony import */ var _GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57611);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var defaultOptions = {
  panControl: true,
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  clickableIcons: false,
  keyboardShortcuts: false,
  scrollWeel: false,
  disableDoubleClickZoom: false,
  fullscreenControl: true
};
var defaultLocation = {
  lat: 40.3763,
  lng: 49.81567
};

var GoogleMaps = function GoogleMaps(_ref) {
  var className = _ref.className,
      _ref$markers = _ref.markers,
      markers = _ref$markers === void 0 ? [] : _ref$markers,
      _ref$defaultCoords = _ref.defaultCoords,
      defaultCoords = _ref$defaultCoords === void 0 ? '' : _ref$defaultCoords,
      _ref$disableMarkerCli = _ref.disableMarkerClick,
      disableMarkerClick = _ref$disableMarkerCli === void 0 ? false : _ref$disableMarkerCli,
      customerLocation = _ref.customerLocation,
      customOptions = _ref.customOptions,
      customPin = _ref.customPin,
      withoutInfoWindow = _ref.withoutInfoWindow,
      customCenter = _ref.customCenter;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      map = _useState[0],
      setMap = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(customCenter !== null && customCenter !== void 0 ? customCenter : defaultLocation),
      center = _useState2[0],
      setCenter = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      activeMarker = _useState3[0],
      setActiveMarker = _useState3[1];

  var _useJsApiLoader = (0,_react_google_maps_api__WEBPACK_IMPORTED_MODULE_5__/* .useJsApiLoader */ .Ji)({
    id: 'google-map-script',
    region: 'AZ'
  }),
      isLoaded = _useJsApiLoader.isLoaded;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    document.body.classList.add('section-small');
    return function () {
      document.body.classList.remove('section-small');
    };
  }, [center]);
  var onLoad = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (map) {
    var bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map);
  }, [center]);
  var onUnmount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    setMap(null);
  }, []);
  var handleActiveMarker = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (marker, coords) {
    var bounds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : map.getBounds();
    setActiveMarker(null);
    setTimeout(function () {
      setActiveMarker(marker);

      if (coords) {
        var span = bounds.toSpan();
        map.panTo(_objectSpread(_objectSpread({}, coords), {}, {
          lat: coords.lat + (span === null || span === void 0 ? void 0 : span.lat()) * 0.28,
          lng: coords.lng + (span === null || span === void 0 ? void 0 : span.lng()) * 0.2
        }));
      }
    }, 50);
  }, [map]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (map && markers.length) {
      var _markers$, _markers$2;

      setCenter(defaultCoords || {
        lat: Number((_markers$ = markers[0]) === null || _markers$ === void 0 ? void 0 : _markers$.lat),
        lng: Number((_markers$2 = markers[0]) === null || _markers$2 === void 0 ? void 0 : _markers$2.lng)
      });
      var bounds = new window.google.maps.LatLngBounds();
      markers.forEach(function (item) {
        bounds.extend({
          lat: Number(item === null || item === void 0 ? void 0 : item.lat),
          lng: Number(item === null || item === void 0 ? void 0 : item.lng)
        });
      });
      map.fitBounds(bounds);
      var span = bounds.toSpan();
      map.panTo(_objectSpread(_objectSpread({}, center), {}, {
        lat: center.lat + (span === null || span === void 0 ? void 0 : span.lat()) * 0.4
      }));
      var ind = 0;

      if (defaultCoords) {
        ind = markers.findIndex(function (marker) {
          return Number(marker.lat) === defaultCoords.lat && Number(marker.lng) === defaultCoords.lng;
        });
      }

      handleActiveMarker(ind, defaultCoords, bounds);
    }
  }, [map, defaultCoords, markers, handleActiveMarker]);

  var renderMarkers = function renderMarkers(item, index) {
    var _item$working_hours, _item$working_hours2;

    var icon = {
      url: customPin || '/assets/mapMarker.png',
      scaledSize: new window.google.maps.Size(50, 50)
    };
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_5__/* .MarkerF */ .jC, {
      onUnmount: function onUnmount() {
        return setActiveMarker(null);
      },
      position: {
        lat: Number(item === null || item === void 0 ? void 0 : item.lat),
        lng: Number(item === null || item === void 0 ? void 0 : item.lng)
      },
      icon: icon,
      onClick: function onClick() {
        setActiveMarker(null);

        if (!disableMarkerClick && item !== null && item !== void 0 && item.lat && item !== null && item !== void 0 && item.lng) {
          handleActiveMarker(index, {
            lat: Number(item === null || item === void 0 ? void 0 : item.lat),
            lng: Number(item === null || item === void 0 ? void 0 : item.lng)
          });
        }
      },
      children: activeMarker === index && !withoutInfoWindow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_5__/* .InfoWindowF */ .kp, {
        options: {
          disableAutoPan: true
        } // onUnmount={() => setActiveMarker(null)}
        ,
        itemScope: true,
        itemType: "https://schema.org/Property",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoWindow),
          children: [!!(item !== null && item !== void 0 && item.name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoWindowTitle),
            children: item === null || item === void 0 ? void 0 : item.name
          }), !!(item !== null && item !== void 0 && item.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoWindowAddress),
            children: item === null || item === void 0 ? void 0 : item.description
          }), (item === null || item === void 0 ? void 0 : (_item$working_hours = item.working_hours) === null || _item$working_hours === void 0 ? void 0 : _item$working_hours.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoWindowBlock),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
              children: t('common:workingHours')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().value),
              children: item === null || item === void 0 ? void 0 : (_item$working_hours2 = item.working_hours) === null || _item$working_hours2 === void 0 ? void 0 : _item$working_hours2.map(function (item) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                  className: "".concat((_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hours), " grid-extend"),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("span", {
                    children: [item === null || item === void 0 ? void 0 : item.days, ":"]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
                    children: item === null || item === void 0 ? void 0 : item.working_hours
                  })]
                }, item === null || item === void 0 ? void 0 : item.id);
              })
            })]
          }), (item === null || item === void 0 ? void 0 : item.email) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoWindowBlock),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
              children: t('common:email')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: "".concat((_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().value), " grid-extend"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                children: item === null || item === void 0 ? void 0 : item.email
              })
            })]
          }), (item === null || item === void 0 ? void 0 : item.phone_number) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoWindowBlock),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: (_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
              children: t('common:phone')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: "".concat((_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().value), " grid-extend"),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                children: item === null || item === void 0 ? void 0 : item.phone_number
              })
            })]
          })]
        })
      })
    }, index);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: "".concat(className, " ").concat((_GoogleMapsClusterer_google_maps_module_scss__WEBPACK_IMPORTED_MODULE_6___default().map)),
    itemScope: true,
    itemType: "https://schema.org/Place",
    children: isLoaded && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_5__/* .GoogleMap */ .b6, {
      mapContainerStyle: {
        width: '100%',
        height: '100%'
      },
      center: Object.keys(customerLocation).length !== 0 ? customerLocation : center,
      zoom: 10,
      onLoad: onLoad,
      onUnmount: onUnmount,
      options: customOptions !== null && customOptions !== void 0 ? customOptions : defaultOptions,
      onClick: function onClick() {
        return setActiveMarker(null);
      },
      children: !!markers.length && markers.map(renderMarkers)
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GoogleMaps);

/***/ }),

/***/ 75482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MapContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(91259);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(97043);
// EXTERNAL MODULE: ./components/common/GoogleMapsClusterer/google-maps.module.scss
var google_maps_module = __webpack_require__(4821);
var google_maps_module_default = /*#__PURE__*/__webpack_require__.n(google_maps_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/common/GoogleMapsClusterer/CustomMarker.js






var options = {
  strokeColor: 'gray',
  strokeOpacity: 0.1,
  strokeWeight: 1,
  fillColor: 'radial-gradient(50% 50% at 50% 50%, rgba(51, 51, 51, 0) 0%, rgba(51, 51, 51, 0.15) 100%)',
  fillOpacity: 0.35,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  zIndex: 1
};
function CustomMarker(_ref) {
  var _position$house, _position$house2, _position$house3, _position$house4, _position$house5, _position$house6, _position$city, _position$house7;

  var position = _ref.position,
      clusterer = _ref.clusterer,
      _onClick = _ref.onClick,
      activeMarker = _ref.activeMarker,
      icon = _ref.icon;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* MarkerF */.jC, {
    icon: icon,
    position: {
      lat: Number(position === null || position === void 0 ? void 0 : (_position$house = position.house) === null || _position$house === void 0 ? void 0 : _position$house.lat),
      lng: Number(position === null || position === void 0 ? void 0 : (_position$house2 = position.house) === null || _position$house2 === void 0 ? void 0 : _position$house2.lng)
    },
    clusterer: clusterer,
    onClick: function onClick() {
      return _onClick(position === null || position === void 0 ? void 0 : position.id);
    },
    children: position.id === activeMarker && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* CircleF */.VM, {
        center: {
          lat: Number(position === null || position === void 0 ? void 0 : (_position$house3 = position.house) === null || _position$house3 === void 0 ? void 0 : _position$house3.lat),
          lng: Number(position === null || position === void 0 ? void 0 : (_position$house4 = position.house) === null || _position$house4 === void 0 ? void 0 : _position$house4.lng)
        },
        options: options,
        radius: Number(position === null || position === void 0 ? void 0 : position.coverage)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* InfoWindowF */.kp, {
        onCloseClick: function onCloseClick() {
          return _onClick(null);
        },
        position: {
          lat: Number(position === null || position === void 0 ? void 0 : (_position$house5 = position.house) === null || _position$house5 === void 0 ? void 0 : _position$house5.lat),
          lng: Number(position === null || position === void 0 ? void 0 : (_position$house6 = position.house) === null || _position$house6 === void 0 ? void 0 : _position$house6.lng)
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (google_maps_module_default()).infoWindow,
          itemScope: true,
          itemType: "https://schema.org/Property",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (google_maps_module_default()).infoWindowCity,
            children: position === null || position === void 0 ? void 0 : (_position$city = position.city) === null || _position$city === void 0 ? void 0 : _position$city.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (google_maps_module_default()).infoWindowStreet,
            children: position === null || position === void 0 ? void 0 : (_position$house7 = position.house) === null || _position$house7 === void 0 ? void 0 : _position$house7.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (google_maps_module_default()).infoWindowCoverage,
            children: position === null || position === void 0 ? void 0 : position.coverage
          })]
        })
      })]
    })
  });
}
;// CONCATENATED MODULE: ./components/common/GoogleMapsClusterer/GoogleMapsClusterer.js







var GoogleMapsClusterer_options = {
  disableDefaultUI: true,
  scaleControl: true,
  mapTypeId: 'roadmap',
  labels: true,
  panControl: true,
  zoomControl: true,
  mapTypeControl: false,
  streetViewControl: false,
  rotateControl: false,
  clickableIcons: false,
  keyboardShortcuts: false,
  scrollWeel: false,
  disableDoubleClickZoom: false,
  fullscreenControl: true
};
function MapContainer(_ref) {
  var data = _ref.data;

  var _useJsApiLoader = (0,esm/* useJsApiLoader */.Ji)({
    id: 'google-map-script',
    region: 'AZ'
  }),
      isLoaded = _useJsApiLoader.isLoaded;

  var _useState = (0,react.useState)(null),
      activeMarker = _useState[0],
      setActiveMarker = _useState[1];

  var mapRef = (0,react.useRef)(undefined);
  var onLoad = (0,react.useCallback)(function (map) {
    var _data$hotspots;

    mapRef.current = map;
    var bounds = new window.google.maps.LatLngBounds();
    data === null || data === void 0 ? void 0 : (_data$hotspots = data.hotspots) === null || _data$hotspots === void 0 ? void 0 : _data$hotspots.forEach(function (item) {
      bounds.extend({
        lat: Number(item.house.lat),
        lng: Number(item.house.lng)
      });
    });
    mapRef.current.fitBounds(bounds);
  }, [data]);
  var onUnmount = (0,react.useCallback)(function () {
    mapRef.current = undefined;
  }, []);

  var handleActiveMarker = function handleActiveMarker(marker) {
    if (marker === activeMarker) {
      return;
    }

    setActiveMarker(marker);
  };

  return isLoaded ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (google_maps_module_default()).wrap,
    itemScope: true,
    itemType: "https://schema.org/Place",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (google_maps_module_default()).map,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* GoogleMap */.b6, {
        mapContainerStyle: {
          height: '100%',
          width: '100%'
        },
        zoom: 10,
        onLoad: onLoad,
        onUnmount: onUnmount,
        options: GoogleMapsClusterer_options,
        onClick: function onClick() {
          return setActiveMarker(null);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* MarkerClusterer */.XL, {
          averageCenter: true,
          enableRetinaIcons: true,
          gridSize: 80,
          maxZoom: 15,
          children: function children(clusterer) {
            return data === null || data === void 0 ? void 0 : data.hotspots.map(function (location, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(CustomMarker, {
                onClick: handleActiveMarker,
                activeMarker: activeMarker,
                position: location,
                clusterer: clusterer,
                icon: data === null || data === void 0 ? void 0 : data.location_icon
              }, index);
            });
          }
        })
      })
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

/***/ }),

/***/ 87777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2844);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62049);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useBusiness__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97367);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24052);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64834);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57611);










var Language = function Language(_ref) {
  var className = _ref.className;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      asPath = _useRouter.asPath,
      locale = _useRouter.locale,
      locales = _useRouter.locales;

  var isBusiness = (0,_hooks_useBusiness__WEBPACK_IMPORTED_MODULE_3__/* .useBusiness */ .i)();

  var renderLanguage = function renderLanguage(item, index) {
    if (item === locale) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active),
        children: item === null || item === void 0 ? void 0 : item.toUpperCase()
      }, index);
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: asPath,
      locale: item,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
        children: item === null || item === void 0 ? void 0 : item.toUpperCase()
      })
    }, index);
  };

  var filterLocales = locales === null || locales === void 0 ? void 0 : locales.filter(function (item) {
    return item !== locale;
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container), className),
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().current),
      children: locale === null || locale === void 0 ? void 0 : locale.toUpperCase()
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .Arrow */ .Eh, {
      width: 16
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().languageList), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().business), isBusiness)),
      children: filterLocales === null || filterLocales === void 0 ? void 0 : filterLocales.map(renderLanguage)
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Language);

/***/ }),

/***/ 41728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var react_countdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99956);
/* harmony import */ var _RecordModal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44575);
/* harmony import */ var _RecordModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_RecordModal_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57611);





var AbsoluteWrapper = function AbsoluteWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: (_RecordModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().face_timer),
    children: children
  });
};

var Completionist = function Completionist() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(AbsoluteWrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      children: "00:00"
    })
  });
};

var renderer = function renderer(_ref2) {
  var seconds = _ref2.seconds,
      completed = _ref2.completed,
      minutes = _ref2.minutes;

  if (completed) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Completionist, {});
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(AbsoluteWrapper, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      children: "".concat((0,react_countdown__WEBPACK_IMPORTED_MODULE_1__/* .zeroPad */ .Bu)(minutes), ":").concat((0,react_countdown__WEBPACK_IMPORTED_MODULE_1__/* .zeroPad */ .Bu)(seconds))
    })
  });
};

var Timer = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref3, ref) {
  var timer = _ref3.timer,
      className = _ref3.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_countdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    date: Date.now() + timer * 1000,
    renderer: renderer,
    ref: ref,
    autoStart: false,
    className: className,
    itemScope: true,
    itemType: "https://schema.org/Property"
  });
});
Timer.displayName = 'Timer';
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(Timer));

/***/ }),

/***/ 91496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RecordModal_Sima; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/react-webcam/dist/react-webcam.js
var react_webcam = __webpack_require__(66683);
var react_webcam_default = /*#__PURE__*/__webpack_require__.n(react_webcam);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(648);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./hooks/index.js + 1 modules
var hooks = __webpack_require__(59748);
;// CONCATENATED MODULE: ./utils/base64ToFile.js
var base64ToFile = function base64ToFile(base64String, fileName) {
  // Check if the base64String is valid
  if (!base64String || typeof base64String !== 'string') {
    throw new Error('Invalid base64 string');
  } // Remove the data URL scheme part if it's included


  var base64Data = base64String !== null && base64String !== void 0 && base64String.includes('base64,') ? base64String === null || base64String === void 0 ? void 0 : base64String.split(',')[1] : base64String; // Further validation on base64Data

  if (!base64Data) {
    throw new Error('Invalid base64 data');
  } // Decode the base64 string


  var byteCharacters = atob(base64Data); // Convert decoded data to a byte array

  var byteNumbers = new Array(byteCharacters.length);

  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  var byteArray = new Uint8Array(byteNumbers); // Create a Blob and File object

  var blob = new Blob([byteArray], {
    type: 'image/jpeg'
  });
  var file = new File([blob], fileName, {
    type: 'image/jpeg'
  });
  return file;
};
// EXTERNAL MODULE: ./components/ui/Modals/Success/SuccessModal.js + 1 modules
var SuccessModal = __webpack_require__(81086);
// EXTERNAL MODULE: ./domains/esim/order/index.js + 3 modules
var order = __webpack_require__(31863);
// EXTERNAL MODULE: ./domains/number-sale/index.js + 4 modules
var number_sale = __webpack_require__(98248);
// EXTERNAL MODULE: ./enums/modal.ts
var modal = __webpack_require__(83136);
// EXTERNAL MODULE: ./components/common/RecordModal/RecordModal.module.scss
var RecordModal_module = __webpack_require__(44575);
var RecordModal_module_default = /*#__PURE__*/__webpack_require__.n(RecordModal_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/common/RecordModal/Sima.js





















var Sima = function Sima(_ref) {
  var active = _ref.active,
      setActiveTab = _ref.setActiveTab,
      handleCheck = _ref.handleCheck,
      isLoading = _ref.isLoading,
      errorText = _ref.errorText,
      modalProps = _ref.modalProps,
      closeModal = _ref.closeModal,
      path = _ref.path;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var webcamRef = (0,react.useRef)(null);

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(null),
      imageSrc = _useState[0],
      setImageSrc = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isCameraActive = _useState2[0],
      setIsCameraActive = _useState2[1];

  var capture = (0,react.useCallback)(function () {
    var imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc) {
      setImageSrc(imageSrc);
      stopCamera();
    }
  }, [webcamRef]);

  var stopCamera = function stopCamera() {
    var _webcamRef$current, _webcamRef$current$vi;

    if (webcamRef !== null && webcamRef !== void 0 && (_webcamRef$current = webcamRef.current) !== null && _webcamRef$current !== void 0 && (_webcamRef$current$vi = _webcamRef$current.video) !== null && _webcamRef$current$vi !== void 0 && _webcamRef$current$vi.srcObject) {
      var stream = webcamRef.current.video.srcObject;
      stream.getTracks().forEach(function (track) {
        return track.stop();
      });
      webcamRef.current.video.srcObject = null;
      setIsCameraActive(false);
    }
  };

  var retakePhoto = function retakePhoto() {
    setImageSrc(null);
    setIsCameraActive(true);
  };

  var closeSima = function closeSima() {
    dispatch(number_sale/* actions.setActiveSima */.Nw.setActiveSima(false));
    dispatch(order/* actions.setActiveSima */.Nw.setActiveSima(false));
  };

  var checkSima = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var image;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              image = base64ToFile(imageSrc, 'image.jpg');
              handleCheck(image);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function checkSima() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSuccess = function handleSuccess() {
    closeModal();
    setActiveTab();
    closeSima();
  };

  var simaErrorHandle = function simaErrorHandle() {
    closeModal();
    closeSima();
    router.replace(path);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [active && !(modalProps !== null && modalProps !== void 0 && modalProps.isOpen) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Modal */.u_, {
      active: active,
      setActive: closeSima,
      className: (RecordModal_module_default()).sima_wrap,
      itemScope: true,
      itemType: "https://schema.org/WebPage",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/assets/esim/scan.svg",
        alt: "check icon",
        width: 51,
        height: 51,
        layout: "fixed"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: (RecordModal_module_default()).text,
        children: [" ", t('esim:common.cameraText')]
      }), isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Loader */.aN, {
        className: (RecordModal_module_default()).sima_loader
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (RecordModal_module_default()).camera_wrap,
        children: [isCameraActive && /*#__PURE__*/(0,jsx_runtime.jsx)((react_webcam_default()), {
          audio: false,
          ref: webcamRef,
          mirrored: true,
          screenshotFormat: "image/jpeg",
          style: {
            width: 'auto',
            height: windowsX <= 480 ? 300 : 428
          }
        }), imageSrc && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: imageSrc,
          alt: "user photo",
          width: 400,
          height: 434,
          objectFit: "cover"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (RecordModal_module_default()).sima_btn__wrapper,
        children: imageSrc ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            Component: 'button',
            variant: "outline",
            onClick: retakePhoto,
            disabled: isLoading,
            children: t('esim:common.retakePhoto')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            Component: 'button',
            variant: "normal",
            onClick: checkSima,
            disabled: isLoading,
            children: t('common:Continue')
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (RecordModal_module_default()).bottom,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/assets/esim/sima.svg",
            alt: "check icon",
            width: 172,
            height: 80,
            layout: "fixed"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            Component: 'button',
            variant: "normal",
            onClick: capture,
            disabled: !isCameraActive,
            children: t('esim:common.takePhoto')
          })]
        })
      })]
    }), (modalProps === null || modalProps === void 0 ? void 0 : modalProps.type) === modal/* EModalType.ERROR */.y.ERROR && (modalProps === null || modalProps === void 0 ? void 0 : modalProps.isOpen) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      active: modalProps.isOpen,
      icon: "/assets/error.png",
      setActive: simaErrorHandle,
      children: errorText !== null && errorText !== void 0 ? errorText : modalProps === null || modalProps === void 0 ? void 0 : modalProps.message
    }), (modalProps === null || modalProps === void 0 ? void 0 : modalProps.type) === modal/* EModalType.SUCCESS */.y.SUCCESS && (modalProps === null || modalProps === void 0 ? void 0 : modalProps.isOpen) && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessModal/* SuccessModal */.i, {
      active: modalProps.isOpen,
      setSuccessModal: handleSuccess,
      children: t('cabinet:common.success')
    })]
  });
};

/* harmony default export */ var RecordModal_Sima = (Sima);

/***/ }),

/***/ 61024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1822);
/* harmony import */ var _tariffs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44952);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57611);








var TariffsFilter = function TariffsFilter(_ref) {
  var _router$query, _router$query2, _router$query3, _router$query4, _router$query5, _data$sliders;

  var data = _ref.data;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(data === null || data === void 0 ? void 0 : data.sliders),
      tariffs = _useState[0],
      setTariffs = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      searchedTariffs = _useState2[0],
      setSearchedTariffs = _useState2[1];

  var typeParam = (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.type;
  var subscriptionParam = (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.subscription;
  var advantagesParam = (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.advantages;
  var priceFrom = (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.priceFrom;
  var priceTo = (_router$query5 = router.query) === null || _router$query5 === void 0 ? void 0 : _router$query5.priceTo;
  var filterTariffs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var priceFrom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -Infinity;
    var priceTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var subscription = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var advantages = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var filtered = tariffs !== null && tariffs !== void 0 ? tariffs : [];
    var filteredTariffs = [];
    filtered.find(function (p) {
      return p.tariffs.some(function (item) {
        return item.tags.some(function (t) {
          if (type.includes(String(t.id))) {
            filteredTariffs.push(item);
          }

          return null;
        });
      });
    });

    if (subscription) {
      filteredTariffs.find(function (item) {
        return item.tags.some(function (t) {
          if (subscription.includes(String(t.id))) {
            filteredTariffs.push(item);
          }

          return null;
        });
      });
    }

    if (advantages) {
      filteredTariffs.find(function (item) {
        return item.tags.some(function (t) {
          if (advantages.includes(String(t.id))) {
            filteredTariffs.push(item);
          }

          return null;
        });
      });
    }

    if (priceFrom || priceTo) {
      filteredTariffs = filteredTariffs.filter(function (item) {
        return (+priceFrom || -Infinity) <= +item.price && +item.price <= (+priceTo || Infinity);
      });
    }

    return filteredTariffs;
  }, [tariffs]);

  var renderTariffs = function renderTariffs(tarif) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_home__WEBPACK_IMPORTED_MODULE_2__/* .Tariffs */ .Qw, {
      data: tarif,
      footerData: tarif === null || tarif === void 0 ? void 0 : tarif.tags,
      title: tarif === null || tarif === void 0 ? void 0 : tarif.title,
      buttonText: tarif === null || tarif === void 0 ? void 0 : tarif.button_text,
      itemScope: true,
      itemType: "https://schema.org/Offer"
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTariffs(data === null || data === void 0 ? void 0 : data.sliders);

    if (priceFrom || priceTo || typeParam || subscriptionParam || advantagesParam) {
      setSearchedTariffs(filterTariffs(priceFrom, priceTo, typeParam, subscriptionParam, advantagesParam));
    } else {
      setSearchedTariffs([]);
    }
  }, [data === null || data === void 0 ? void 0 : data.sliders, typeParam, subscriptionParam, advantagesParam, priceFrom, priceTo, filterTariffs]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tariffs__WEBPACK_IMPORTED_MODULE_3__/* .FiltersBlock */ .eE, {
      type: data.selects.find(function (s) {
        return s.type === 'type';
      }),
      subscription: data.selects.find(function (s) {
        return s.type === 'subscription';
      }),
      advantages: data.selects.find(function (s) {
        return s.type === 'advantages';
      }),
      applyText: data === null || data === void 0 ? void 0 : data.filter_button_text,
      resetText: data === null || data === void 0 ? void 0 : data.reset_button_text,
      maxText: data === null || data === void 0 ? void 0 : data.max_price_text,
      minText: data === null || data === void 0 ? void 0 : data.min_price_text,
      itemScope: true,
      itemType: "https://schema.org/Filter"
    }), searchedTariffs.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_tariffs__WEBPACK_IMPORTED_MODULE_3__/* .SearchResult */ .lt, {
      data: searchedTariffs,
      itemScope: true,
      itemType: "https://schema.org/ItemList"
    }), (data === null || data === void 0 ? void 0 : (_data$sliders = data.sliders) === null || _data$sliders === void 0 ? void 0 : _data$sliders.length) > 0 && !searchedTariffs.length && tariffs.map(renderTariffs)]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TariffsFilter);

/***/ }),

/***/ 51633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ar": function() { return /* reexport */ Layout_Layout; },
  "ns": function() { return /* reexport */ NewsItem_NewsItem; },
  "_v": function() { return /* reexport */ SliderContainer_SliderContainer; }
});

// UNUSED EXPORTS: FaqContainer, GoogleMaps, OfflineLayout, SocialNetwork, TariffsFilter, ToolBar

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9605);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(12420);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./enums/theme.ts
var enums_theme = __webpack_require__(29128);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/ui/Button/Button.tsx
var Button = __webpack_require__(440);
// EXTERNAL MODULE: ./components/ui/DownloadApplication/DownloadApplication.module.scss
var DownloadApplication_module = __webpack_require__(8314);
var DownloadApplication_module_default = /*#__PURE__*/__webpack_require__.n(DownloadApplication_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/ui/DownloadApplication/DownloadApplication.js












var DownloadApplication = function DownloadApplication(_ref) {
  var _ref2;

  var data = _ref.data;

  var _useTheme = (0,index_module/* useTheme */.F)(),
      theme = _useTheme.theme;

  var _useState = (0,react.useState)(true),
      isAvailable = _useState[0],
      setIsAvailable = _useState[1];

  var handleDownload = function handleDownload() {
    if (true) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera; // Windows Phone must come first because its UA also contains "Android"

      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
      }

      if (/huawei/i.test(userAgent)) {
        return window.open(data === null || data === void 0 ? void 0 : data.download_link_huawei, '_blank');
      }

      if (/android/i.test(userAgent)) {
        return window.open(data === null || data === void 0 ? void 0 : data.download_link_android, '_blank');
      } // iOS detection from: http://stackoverflow.com/a/9039885/177710


      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return window.open(data === null || data === void 0 ? void 0 : data.download_link_ios, '_blank');
      }

      return '';
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(DownloadApplication_module_default()).download_app_wrapper, (_ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, (DownloadApplication_module_default()).none, isAvailable !== true), (0,defineProperty/* default */.Z)(_ref2, (DownloadApplication_module_default()).dark, theme === enums_theme/* ETheme.DARK_MODE */.X.DARK_MODE), _ref2)]),
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DownloadApplication_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {
        onClick: function onClick() {
          setIsAvailable(!isAvailable);
        },
        className: (DownloadApplication_module_default()).close_app
      }), (data === null || data === void 0 ? void 0 : data.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: data === null || data === void 0 ? void 0 : data.icon,
        width: 60,
        height: 60,
        alt: "Download Bakcell Application Logo",
        title: "Download Bakcell Application Logo",
        className: (DownloadApplication_module_default()).download_app_logo
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
          className: (DownloadApplication_module_default()).title,
          children: data === null || data === void 0 ? void 0 : data.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (DownloadApplication_module_default()).description,
          children: data === null || data === void 0 ? void 0 : data.description
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
      className: (DownloadApplication_module_default()).download_app_btn,
      onClick: handleDownload,
      children: data === null || data === void 0 ? void 0 : data.button_text
    })]
  });
};

/* harmony default export */ var DownloadApplication_DownloadApplication = (DownloadApplication);
;// CONCATENATED MODULE: ./utils/seo.js
var baseUrl = 'https://www.bakcell.com';
var generateLocaleUrl = function generateLocaleUrl(lang, path) {
  return "".concat(baseUrl).concat(lang === 'az' ? '' : "/".concat(lang)).concat(path);
};
;// CONCATENATED MODULE: ./utils/getBreadcrumbsSchema.js
var breadcrumbSchema = function breadcrumbSchema(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  var schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function (crumb, index) {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.text,
        item: "https://www.bakcell.com/".concat(crumb.slug)
      };
    })
  };
  return JSON.stringify(schema);
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(24666);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(648);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./domains/cabinet/index.js + 1 modules
var cabinet = __webpack_require__(3519);
// EXTERNAL MODULE: ./components/SvgComponents/CardShapes.js
var CardShapes = __webpack_require__(3686);
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle_SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(53431);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(52210);
// EXTERNAL MODULE: ./utils/formatPhoneNumber.js
var formatPhoneNumber = __webpack_require__(53836);
// EXTERNAL MODULE: ./utils/languageFormat.js
var languageFormat = __webpack_require__(16955);
// EXTERNAL MODULE: ./utils/generateInitialToken.js
var generateInitialToken = __webpack_require__(3937);
// EXTERNAL MODULE: ./components/ui/PopUpLogin/PopUpLogin.module.scss
var PopUpLogin_module = __webpack_require__(64908);
var PopUpLogin_module_default = /*#__PURE__*/__webpack_require__.n(PopUpLogin_module);
;// CONCATENATED MODULE: ./components/ui/PopUpLogin/PopUpLogin.js

















var PopUpLogin = function PopUpLogin() {
  var _selectedTariff$event, _selectedTariff$event2;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var _useSelector = (0,es/* useSelector */.v9)(cabinet/* selectors.selectCabinet */.wl.O),
      isLogged = _useSelector.isLogged,
      selectedTariff = _useSelector.selectedTariff;

  var _useState = (0,react.useState)(false),
      showError = _useState[0],
      setShowError = _useState[1];

  var _useState2 = (0,react.useState)(''),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var dispatch = (0,es/* useDispatch */.I0)();
  var formattedLang = (0,languageFormat/* langFormatter */.u)({
    lang: lang
  });

  var _cabinetHooks$useSubs = cabinet/* hooks.useSubscriberCheck */.PT.useSubscriberCheck(),
      _cabinetHooks$useSubs2 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useSubs, 1),
      subscribeTrigger = _cabinetHooks$useSubs2[0];

  var _cabinetHooks$useOtpR = cabinet/* hooks.useOtpRequest */.PT.useOtpRequest(),
      _cabinetHooks$useOtpR2 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useOtpR, 1),
      otpTrigger = _cabinetHooks$useOtpR2[0];

  var cleanedPhoneNumber = function cleanedPhoneNumber(value) {
    return value.replace(/[+-]/g, '');
  };

  var eventName = (selectedTariff === null || selectedTariff === void 0 ? void 0 : (_selectedTariff$event = selectedTariff.event_type) === null || _selectedTariff$event === void 0 ? void 0 : _selectedTariff$event.charAt(0).toUpperCase()) + (selectedTariff === null || selectedTariff === void 0 ? void 0 : (_selectedTariff$event2 = selectedTariff.event_type) === null || _selectedTariff$event2 === void 0 ? void 0 : _selectedTariff$event2.slice(1));
  var FormSchema = yup_es/* object */.Ry().shape({
    phone: yup_es/* string */.Z_().matches(/^\+994-\d{2}-\d{3}-\d{2}-\d{2}$/, t('common:Required')).required(t('common:Required'))
  });
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      phone: ''
    },
    validationSchema: FormSchema,
    isInitialValid: false,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
        var data, initialToken;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  phone: values === null || values === void 0 ? void 0 : values.phone
                };
                dispatch(cabinet/* actions.setPhoneNumber */.Nw.setPhoneNumber(cleanedPhoneNumber(data.phone)));
                _context.prev = 2;
                initialToken = (0,generateInitialToken/* default */.Z)(cleanedPhoneNumber(data.phone), (0,v4/* default */.Z)());
                dispatch(cabinet/* actions.setInitialToken */.Nw.setInitialToken(initialToken));
                sessionStorage.setItem('initialToken', initialToken);
                _context.next = 8;
                return subscribeTrigger({
                  msisdn: cleanedPhoneNumber(data.phone),
                  lang: formattedLang,
                  accessToken: isLogged && sessionStorage.getItem('accessToken'),
                  oneTime: true
                }).unwrap();

              case 8:
                otpStepHandler(cleanedPhoneNumber(data.phone));
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "".concat(eventName, "_number_added")
                });
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                setShowError(true);
                setErrorMessage(_context.t0.message);

              case 17:
                _context.prev = 17;
                setTimeout(formik.resetForm, 300);
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 13, 17, 20]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var submitHandler = function submitHandler(e) {
    e.preventDefault();
    formik.handleSubmit();
  };

  var otpStepHandler = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(number) {
      var res;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return otpTrigger({
                phoneNumber: number,
                lang: formattedLang
              }).unwrap();

            case 3:
              res = _context2.sent;
              dispatch(cabinet/* actions.setUuId */.Nw.setUuId(res.uuid));
              dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(2));
              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              setShowError(true);
              setErrorMessage(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    return function otpStepHandler(_x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (PopUpLogin_module_default()).newLogin,
    itemScope: true,
    itemType: "https://schema.org/CheckInAction",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: t('cabinet:common.EnterNumber')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
      className: (PopUpLogin_module_default()).form,
      onSubmit: function onSubmit(e) {
        return submitHandler(e);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (PopUpLogin_module_default()).loginForm,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
          className: (PopUpLogin_module_default()).input,
          onBlur: formik.handleBlur('phone'),
          error: formik.touched.phone && formik.errors.phone,
          value: formik.values.phone,
          type: "tel",
          onChange: function onChange(value) {
            var formattedPhone = (0,formatPhoneNumber/* formatPhoneNumber */.u)(value);
            formik.setFieldValue('phone', formattedPhone);
          },
          label: t('common:Phone'),
          placeholder: '+994-XX-XXX-XX-XX',
          mask: '+\\9\\9\\4-99-999-99-99',
          "data-testid": "tariff-purchase-input"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (PopUpLogin_module_default()).buttonWrapper,
          children: [isLogged && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            variant: "transparent",
            type: "button",
            onClick: function onClick() {
              dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(0));
            },
            className: (PopUpLogin_module_default()).buttonGoBack,
            children: t('common:Back')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            "data-testid": "tariff-purchase-input",
            className: "".concat(isLogged && (PopUpLogin_module_default()).buttonContinue),
            children: t('common:Continue')
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      active: showError,
      icon: "/assets/error.png",
      setActive: function setActive() {
        return setShowError(false);
      },
      children: errorMessage
    }), !isLogged && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: (PopUpLogin_module_default()).belongsText,
      children: [t('cabinet:common.AlreadyHave'), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        onClick: function onClick() {
          var _window, _window$location;

          dispatch(cabinet/* actions.setTariffModal */.Nw.setTariffModal(false));
          (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.assign('/login');
        },
        className: (PopUpLogin_module_default()).belongsText__inside,
        children: t('cabinet:common.Login')
      })]
    })]
  });
};
// EXTERNAL MODULE: ./components/common/RecordModal/CountDown.js
var CountDown = __webpack_require__(41728);
// EXTERNAL MODULE: ./hooks/useOtpVerification.js
var useOtpVerification = __webpack_require__(66972);
// EXTERNAL MODULE: ./utils/formatTimer.js
var formatTimer = __webpack_require__(67352);
// EXTERNAL MODULE: ./components/ui/PopUpOtp/PopUpOtp.module.scss
var PopUpOtp_module = __webpack_require__(89194);
var PopUpOtp_module_default = /*#__PURE__*/__webpack_require__.n(PopUpOtp_module);
;// CONCATENATED MODULE: ./components/ui/PopUpOtp/PopUpOtp.js










var PopUpOtp = function PopUpOtp() {
  var _useOtpVerification = (0,useOtpVerification/* default */.Z)({
    isPopup: true
  }),
      isLoading = _useOtpVerification.isLoading,
      wrongOtp = _useOtpVerification.wrongOtp,
      otpRequested = _useOtpVerification.otpRequested,
      otpValue = _useOtpVerification.otpValue,
      submitHandler = _useOtpVerification.submitHandler,
      handleChangeOtpInput = _useOtpVerification.handleChangeOtpInput,
      count = _useOtpVerification.count,
      accountsFetching = _useOtpVerification.accountsFetching;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PopUpOtp_module_default()).otpVerify,
      itemScope: true,
      itemType: "https://schema.org/CheckInAction",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ScreenLoader */.v$, {
        visible: isLoading || accountsFetching
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        className: (PopUpOtp_module_default()).otpFormWrapper__form,
        onSubmit: submitHandler,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (PopUpOtp_module_default()).otpText,
          children: t('cabinet:common.OTP')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CountDown/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* OwnPhoneInput */.qG, {
          className: (PopUpOtp_module_default()).otpInput,
          separationPoints: [],
          value: otpValue,
          onChange: handleChangeOtpInput,
          placeholder: "-"
        }), wrongOtp && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (PopUpOtp_module_default()).wrong_otp,
          children: [" ", t('cabinet:common.WrongOtp')]
        }), otpRequested ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
          variant: "outline",
          className: "".concat((PopUpOtp_module_default()).button, " ").concat((PopUpOtp_module_default()).disabled),
          children: [t('cabinet:common.Timer'), " : ", (0,formatTimer/* formatTimer */.N)(count), "s"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          className: "".concat((PopUpOtp_module_default()).button, " ").concat((PopUpOtp_module_default()).resend),
          variant: "normal",
          children: t('cabinet:common.ResendOtp')
        })]
      })]
    })]
  });
};
// EXTERNAL MODULE: ./constants/cabinet.js + 3 modules
var constants_cabinet = __webpack_require__(54861);
// EXTERNAL MODULE: ./components/SvgComponents/NewDropdownCard.js
var NewDropdownCard = __webpack_require__(32378);
// EXTERNAL MODULE: ./utils/formatPhoneNumberNew.js
var formatPhoneNumberNew = __webpack_require__(32238);
// EXTERNAL MODULE: ./components/ui/PopUpList/PopUpList.module.scss
var PopUpList_module = __webpack_require__(11929);
var PopUpList_module_default = /*#__PURE__*/__webpack_require__.n(PopUpList_module);
;// CONCATENATED MODULE: ./components/ui/PopUpList/PopUpList.js



















var PopUpList = function PopUpList() {
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var formattedLang = (0,languageFormat/* langFormatter */.u)({
    lang: lang
  });

  var _useState = (0,react.useState)(null),
      accounts = _useState[0],
      setAccounts = _useState[1];

  var _useSelector = (0,es/* useSelector */.v9)(cabinet/* selectors.selectCabinet */.wl.O),
      selectedAccountId = _useSelector.selectedAccountId;

  var _cabinetHooks$useGetA = cabinet/* hooks.useGetAccounts */.PT.useGetAccounts(),
      _cabinetHooks$useGetA2 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useGetA, 2),
      getAccountsTrigger = _cabinetHooks$useGetA2[0],
      isFetching = _cabinetHooks$useGetA2[1].isFetching;

  var accountFetcher = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var accessToken, _accounts$, _accounts$$phone, _accounts;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              accessToken = sessionStorage.getItem('accessToken');

              if (accessToken) {
                _context.next = 4;
                break;
              }

              dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(1));
              return _context.abrupt("return");

            case 4:
              if (window.location.href.includes('login' || 0)) {
                _context.next = 19;
                break;
              }

              _context.prev = 5;
              _context.next = 8;
              return getAccountsTrigger({
                lang: formattedLang,
                accessToken: sessionStorage.getItem('accessToken')
              }).unwrap();

            case 8:
              _accounts = _context.sent;
              dispatch(cabinet/* actions.setIsLogged */.Nw.setIsLogged(true));
              setAccounts(_accounts);
              dispatch(cabinet/* actions.setSelectedAccountId */.Nw.setSelectedAccountId(_accounts[0].id));
              dispatch(cabinet/* actions.setPhoneNumber */.Nw.setPhoneNumber("994".concat((_accounts$ = _accounts[0]) === null || _accounts$ === void 0 ? void 0 : (_accounts$$phone = _accounts$.phone) === null || _accounts$$phone === void 0 ? void 0 : _accounts$$phone.number)));
              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](5);
              dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(1));
              dispatch(cabinet/* actions.setIsLogged */.Nw.setIsLogged(false));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 15]]);
    }));

    return function accountFetcher() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    accountFetcher();
  }, []);

  var selectHandler = function selectHandler(option) {
    if ((option === null || option === void 0 ? void 0 : option.numberStatus) === 'DEACTIVE') {
      return;
    }

    if ((option === null || option === void 0 ? void 0 : option.numberStatus) !== 'DEACTIVE') {
      var _option$phone;

      dispatch(cabinet/* actions.setSelectedAccountId */.Nw.setSelectedAccountId(accounts === null || accounts === void 0 ? void 0 : accounts.find(function (a) {
        return (a === null || a === void 0 ? void 0 : a.id) === (option === null || option === void 0 ? void 0 : option.id);
      }).id));
      dispatch(cabinet/* actions.setPhoneNumber */.Nw.setPhoneNumber("994".concat(option === null || option === void 0 ? void 0 : (_option$phone = option.phone) === null || _option$phone === void 0 ? void 0 : _option$phone.number)));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ScreenLoader */.v$, {
      visible: isFetching
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PopUpList_module_default()).listWrapper,
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        className: (PopUpList_module_default()).title,
        children: t('common:SelectNumber')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: (PopUpList_module_default()).list,
        children: accounts === null || accounts === void 0 ? void 0 : accounts.map(function (option) {
          var _option$phone2;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: classnames_default()((0,defineProperty/* default */.Z)({}, (PopUpList_module_default()).disabled, (option === null || option === void 0 ? void 0 : option.numberStatus) === 'DEACTIVE')),
            onClick: function onClick() {
              return selectHandler(option);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (PopUpList_module_default()).detail_box,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: constants_cabinet/* statusInfoMap */.e3[(option === null || option === void 0 ? void 0 : option.numberStatus) !== 'DEACTIVE' ? option === null || option === void 0 ? void 0 : option.status : option === null || option === void 0 ? void 0 : option.numberStatus]["class"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewDropdownCard/* NewDropdownCard */.q, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (PopUpList_module_default()).number_detail,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h5", {
                  className: classnames_default()((PopUpList_module_default()).number, {
                    disabled: (option === null || option === void 0 ? void 0 : option.numberStatus) === 'DEACTIVE'
                  }),
                  children: [(0,formatPhoneNumberNew/* default */.Z)(option === null || option === void 0 ? void 0 : (_option$phone2 = option.phone) === null || _option$phone2 === void 0 ? void 0 : _option$phone2.number), (option === null || option === void 0 ? void 0 : option.isPrimary) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (PopUpList_module_default()).label,
                    children: t('cabinet:main')
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: classnames_default()([(PopUpList_module_default()).status, constants_cabinet/* statusInfoMap */.e3[(option === null || option === void 0 ? void 0 : option.numberStatus) === 'ACTIVE' ? option === null || option === void 0 ? void 0 : option.status : option === null || option === void 0 ? void 0 : option.numberStatus]["class"]]),
                  children: t("cabinet:".concat(constants_cabinet/* statusInfoMap */.e3[(option === null || option === void 0 ? void 0 : option.numberStatus) === 'ACTIVE' ? option === null || option === void 0 ? void 0 : option.status : option === null || option === void 0 ? void 0 : option.numberStatus].text))
                }), (option === null || option === void 0 ? void 0 : option.status) === 'ACTIVE' && (option === null || option === void 0 ? void 0 : option.numberStatus) === 'ACTIVE' && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  className: (PopUpList_module_default()).balance,
                  children: ["\u2022 ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: [option === null || option === void 0 ? void 0 : option.balance, " "]
                  }), "azn"]
                })]
              })]
            }), (option === null || option === void 0 ? void 0 : option.id) === Number(selectedAccountId) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/assets/checkMark.svg",
              width: 15,
              height: 10,
              alt: "checkmark icon",
              title: "Checkmark Icon"
            })]
          }, option === null || option === void 0 ? void 0 : option.id);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (PopUpList_module_default()).buttons,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: function onClick() {
            dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(1));
          },
          variant: "outline",
          children: t('common:OtherNumber')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: function onClick() {
            dispatch(cabinet/* actions.setPopUpConfirm */.Nw.setPopUpConfirm(true));
          },
          children: t('common:Continue')
        })]
      })]
    }), "\\", ' ']
  });
};
;// CONCATENATED MODULE: ./components/SvgComponents/Payment.js

var Payment = function Payment() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask0_4347_87107)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M8.00008 53.3337C6.53341 53.3337 5.27786 52.8114 4.23341 51.767C3.18897 50.7225 2.66675 49.467 2.66675 48.0003V21.3337C2.66675 20.5781 2.9223 19.9448 3.43341 19.4337C3.94453 18.9225 4.57786 18.667 5.33341 18.667C6.08897 18.667 6.7223 18.9225 7.23341 19.4337C7.74453 19.9448 8.00008 20.5781 8.00008 21.3337V48.0003H50.6667C51.4223 48.0003 52.0556 48.2559 52.5667 48.767C53.0779 49.2781 53.3334 49.9114 53.3334 50.667C53.3334 51.4226 53.0779 52.0559 52.5667 52.567C52.0556 53.0781 51.4223 53.3337 50.6667 53.3337H8.00008ZM18.6667 42.667C17.2001 42.667 15.9445 42.1448 14.9001 41.1003C13.8556 40.0559 13.3334 38.8003 13.3334 37.3337V16.0003C13.3334 14.5337 13.8556 13.2781 14.9001 12.2337C15.9445 11.1892 17.2001 10.667 18.6667 10.667H56.0001C57.4668 10.667 58.7223 11.1892 59.7668 12.2337C60.8112 13.2781 61.3334 14.5337 61.3334 16.0003V37.3337C61.3334 38.8003 60.8112 40.0559 59.7668 41.1003C58.7223 42.1448 57.4668 42.667 56.0001 42.667H18.6667ZM24.0001 37.3337C24.0001 35.867 23.4779 34.6114 22.4334 33.567C21.389 32.5226 20.1334 32.0003 18.6667 32.0003V37.3337H24.0001ZM50.6667 37.3337H56.0001V32.0003C54.5334 32.0003 53.2779 32.5226 52.2334 33.567C51.189 34.6114 50.6667 35.867 50.6667 37.3337ZM37.3334 34.667C39.5556 34.667 41.4445 33.8892 43.0001 32.3337C44.5556 30.7781 45.3334 28.8892 45.3334 26.667C45.3334 24.4448 44.5556 22.5559 43.0001 21.0003C41.4445 19.4448 39.5556 18.667 37.3334 18.667C35.1112 18.667 33.2223 19.4448 31.6667 21.0003C30.1112 22.5559 29.3334 24.4448 29.3334 26.667C29.3334 28.8892 30.1112 30.7781 31.6667 32.3337C33.2223 33.8892 35.1112 34.667 37.3334 34.667ZM18.6667 21.3337C20.1334 21.3337 21.389 20.8114 22.4334 19.767C23.4779 18.7225 24.0001 17.467 24.0001 16.0003H18.6667V21.3337ZM56.0001 21.3337V16.0003H50.6667C50.6667 17.467 51.189 18.7225 52.2334 19.767C53.2779 20.8114 54.5334 21.3337 56.0001 21.3337Z",
        fill: "#FF1F3F"
      })
    })
  });
};
// EXTERNAL MODULE: ./components/ui/Modals/Success/SuccessModal.js + 1 modules
var SuccessModal = __webpack_require__(81086);
;// CONCATENATED MODULE: ./hooks/useIsLogged.js
var isUserLoggedIn = function isUserLoggedIn() {
  if (true) {
    var accessToken = sessionStorage.getItem('accessToken');
    return Boolean(accessToken);
  }

  return false;
};
// EXTERNAL MODULE: ./components/ui/PopUpConfirm/PopUpConfirm.module.scss
var PopUpConfirm_module = __webpack_require__(73904);
var PopUpConfirm_module_default = /*#__PURE__*/__webpack_require__.n(PopUpConfirm_module);
;// CONCATENATED MODULE: ./components/ui/PopUpConfirm/PopUpConfirm.js





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var PopUpConfirm = function PopUpConfirm() {
  var _selectedTariff$event, _selectedTariff$event2;

  var isLogged = isUserLoggedIn();

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var formattedLang = (0,languageFormat/* langFormatter */.u)({
    lang: lang
  });
  var actionTypes = {
    SET_SUCCESS_MODAL: 'SET_SUCCESS_MODAL',
    SET_ERROR_MODAL: 'SET_ERROR_MODAL',
    SET_INSUFFICIENT: 'SET_INSUFFICIENT',
    SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE'
  };

  var reducer = function reducer(state, action) {
    switch (action.type) {
      case actionTypes.SET_SUCCESS_MODAL:
        return _objectSpread(_objectSpread({}, state), {}, {
          successModal: action.payload
        });

      case actionTypes.SET_ERROR_MODAL:
        return _objectSpread(_objectSpread({}, state), {}, {
          showError: action.payload
        });

      case actionTypes.SET_INSUFFICIENT:
        return _objectSpread(_objectSpread({}, state), {}, {
          isInsufficient: action.payload
        });

      case actionTypes.SET_ERROR_MESSAGE:
        return _objectSpread(_objectSpread({}, state), {}, {
          errorMessage: action.payload
        });

      default:
        return state;
    }
  };

  var initialState = {
    successModal: false,
    showError: false,
    isInsufficient: false,
    errorMessage: ''
  };

  var _useReducer = (0,react.useReducer)(reducer, initialState),
      state = _useReducer[0],
      appDispatch = _useReducer[1];

  var setSuccessModal = function setSuccessModal(value) {
    return appDispatch({
      type: actionTypes.SET_SUCCESS_MODAL,
      payload: value
    });
  };

  var setShowError = function setShowError(value) {
    return appDispatch({
      type: actionTypes.SET_ERROR_MODAL,
      payload: value
    });
  };

  var setIsInsuccifient = function setIsInsuccifient(value) {
    return appDispatch({
      type: actionTypes.SET_INSUFFICIENT,
      payload: value
    });
  };

  var setErrorMessage = function setErrorMessage(message) {
    return appDispatch({
      type: actionTypes.SET_ERROR_MESSAGE,
      payload: message
    });
  };

  var successModal = state.successModal,
      showError = state.showError,
      isInsufficient = state.isInsufficient,
      errorMessage = state.errorMessage;

  var _useSelector = (0,es/* useSelector */.v9)(cabinet/* selectors.selectCabinet */.wl.O),
      phoneNumber = _useSelector.phoneNumber,
      selectedTariff = _useSelector.selectedTariff,
      accessToken = _useSelector.accessToken,
      popUpAccount = _useSelector.popUpAccount,
      isPackageOrTariff = _useSelector.isPackageOrTariff,
      popUpConfirm = _useSelector.popUpConfirm,
      selectedAccountId = _useSelector.selectedAccountId,
      popUpStep = _useSelector.popUpStep;

  var dispatch = (0,es/* useDispatch */.I0)();
  var eventName = (selectedTariff === null || selectedTariff === void 0 ? void 0 : (_selectedTariff$event = selectedTariff.event_type) === null || _selectedTariff$event === void 0 ? void 0 : _selectedTariff$event.charAt(0).toUpperCase()) + (selectedTariff === null || selectedTariff === void 0 ? void 0 : (_selectedTariff$event2 = selectedTariff.event_type) === null || _selectedTariff$event2 === void 0 ? void 0 : _selectedTariff$event2.slice(1));

  var _cabinetHooks$useChan = cabinet/* hooks.useChangeTariff */.PT.useChangeTariff(),
      _cabinetHooks$useChan2 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useChan, 2),
      changeTariffTrigger = _cabinetHooks$useChan2[0],
      tariffLoading = _cabinetHooks$useChan2[1].isLoading;

  var _cabinetHooks$useChan3 = cabinet/* hooks.useChangePackage */.PT.useChangePackage(),
      _cabinetHooks$useChan4 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useChan3, 2),
      changePackageTrigger = _cabinetHooks$useChan4[0],
      packageLoading = _cabinetHooks$useChan4[1].isLoading;

  var formatPhoneNumber = function formatPhoneNumber(phoneNumber) {
    var numericPhoneNumber = phoneNumber.replace(/\D/g, '');
    var formattedPhoneNumber = "+".concat(numericPhoneNumber.slice(0, 3), " ").concat(numericPhoneNumber.slice(3, 5), " ").concat(numericPhoneNumber.slice(5, 8), " ").concat(numericPhoneNumber.slice(8, 10), " ").concat(numericPhoneNumber.slice(10));
    return formattedPhoneNumber;
  };

  var cancelHandler = function cancelHandler() {
    if (!popUpConfirm) {
      return;
    }

    if (popUpConfirm) {
      dispatch(cabinet/* actions.setPopUpConfirm */.Nw.setPopUpConfirm(false));
      dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(isLogged ? 0 : 1));
    }
  };

  var confirmHandler = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var triggerApi, fieldId, _triggerApi, _window$dataLayer$pus;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(cabinet/* actions.setPopUpConfirm */.Nw.setPopUpConfirm(false));
              triggerApi = isPackageOrTariff ? changeTariffTrigger : changePackageTrigger;
              fieldId = isPackageOrTariff ? 'tariffId' : 'packageId';
              _context.prev = 3;
              _context.next = 6;
              return triggerApi((_triggerApi = {
                lang: formattedLang
              }, (0,defineProperty/* default */.Z)(_triggerApi, fieldId, selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.ngbss_id), (0,defineProperty/* default */.Z)(_triggerApi, "accountId", popUpStep === 0 ? selectedAccountId : popUpAccount === null || popUpAccount === void 0 ? void 0 : popUpAccount.id), (0,defineProperty/* default */.Z)(_triggerApi, "accessToken", popUpStep === 0 ? sessionStorage.getItem('accessToken') : accessToken), _triggerApi)).unwrap();

            case 6:
              setSuccessModal(true);
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push((_window$dataLayer$pus = {
                event: "".concat(eventName, "_Purchase_success")
              }, (0,defineProperty/* default */.Z)(_window$dataLayer$pus, selectedTariff.event_type, selectedTariff.name), (0,defineProperty/* default */.Z)(_window$dataLayer$pus, "currency", 'AZN'), (0,defineProperty/* default */.Z)(_window$dataLayer$pus, "value", selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.price), _window$dataLayer$pus));
              window.dataLayer.push({
                event: 'purchase',
                ecommerce: {
                  transaction_id: selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.ngbss_id,
                  value: selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.price,
                  currency: 'AZN',
                  items: [{
                    item_id: selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.id,
                    item_name: selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.name,
                    price: selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.price,
                    quantity: 1,
                    item_category: 'Subscription'
                  }]
                }
              });
              _context.next = 19;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              setErrorMessage(_context.t0.message);
              setShowError(true);
              setIsInsuccifient(_context.t0.code === 'INSUFFICIENT_FUNDS');
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "".concat(eventName, "_Purchase_error")
              });

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));

    return function confirmHandler() {
      return _ref.apply(this, arguments);
    };
  }();

  var successHandler = function successHandler() {
    if (successModal) {
      dispatch(cabinet/* actions.setTariffModal */.Nw.setTariffModal(false));
      dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(isLogged ? 0 : 1));
      setSuccessModal(false);
    }
  };

  var errorHandler = function errorHandler() {
    setShowError(false);
    dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(isLogged ? 0 : 1));

    if (isInsufficient) {
      var _window;

      (_window = window) === null || _window === void 0 ? void 0 : _window.open('https://hesab.az/unregistered/#/direct-pay/mobile/bakcell/parameters', '_blank');
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ScreenLoader */.v$, {
      visible: tariffLoading || packageLoading
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Modal */.u_, {
      className: (PopUpConfirm_module_default()).confirmModalOuter,
      active: popUpConfirm,
      setActive: function setActive() {
        return cancelHandler();
      },
      itemScope: true,
      itemType: "https://schema.org/ConfirmAction",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (PopUpConfirm_module_default()).confirmModal,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Payment, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: formatPhoneNumber(phoneNumber)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: t('cabinet:common.popupConfirm', {
            amount: selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.price,
            name: selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.name
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (PopUpConfirm_module_default()).confirmModal__buttons,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (PopUpConfirm_module_default()).confirmModal__innerDiv,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              onClick: cancelHandler,
              variant: "transparent",
              children: t('common:Cancel')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              onClick: confirmHandler,
              children: t('common:Confirm')
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessModal/* SuccessModal */.i, {
      active: successModal,
      setSuccessModal: successHandler
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      active: showError,
      icon: "/assets/error.png",
      setActive: errorHandler,
      isInsufficient: isInsufficient,
      children: errorMessage
    })]
  });
};
;// CONCATENATED MODULE: ./enums/cabinet.ts
var TariffPurchaseSteps;

(function (TariffPurchaseSteps) {
  TariffPurchaseSteps[TariffPurchaseSteps["List"] = 0] = "List";
  TariffPurchaseSteps[TariffPurchaseSteps["Login"] = 1] = "Login";
  TariffPurchaseSteps[TariffPurchaseSteps["Otp"] = 2] = "Otp";
})(TariffPurchaseSteps || (TariffPurchaseSteps = {}));
// EXTERNAL MODULE: ./components/ui/TariffCard/styles.module.scss
var styles_module = __webpack_require__(14188);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/ui/TariffCard/TariffCardPopup.js

















var TariffCardPopup = function TariffCardPopup() {
  var _stepComponents;

  var _useSelector = (0,es/* useSelector */.v9)(cabinet/* selectors.selectCabinet */.wl.O),
      tariffModal = _useSelector.tariffModal,
      selectedTariff = _useSelector.selectedTariff,
      popUpStep = _useSelector.popUpStep,
      popUpConfirm = _useSelector.popUpConfirm;

  var dispatch = (0,es/* useDispatch */.I0)();
  var stepComponents = (_stepComponents = {}, (0,defineProperty/* default */.Z)(_stepComponents, TariffPurchaseSteps.List, /*#__PURE__*/(0,jsx_runtime.jsx)(PopUpList, {})), (0,defineProperty/* default */.Z)(_stepComponents, TariffPurchaseSteps.Login, /*#__PURE__*/(0,jsx_runtime.jsx)(PopUpLogin, {})), (0,defineProperty/* default */.Z)(_stepComponents, TariffPurchaseSteps.Otp, /*#__PURE__*/(0,jsx_runtime.jsx)(PopUpOtp, {})), _stepComponents);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!popUpConfirm && tariffModal && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Modal */.u_, {
      "data-testid": "tariffPurchaseModal",
      active: !popUpConfirm && tariffModal,
      setActive: function setActive() {
        if (tariffModal) {
          dispatch(cabinet/* actions.setTariffModal */.Nw.setTariffModal(false));
          dispatch(cabinet/* actions.setPopUpStep */.Nw.setPopUpStep(TariffPurchaseSteps.List));
        }
      },
      className: (styles_module_default()).tariffModal,
      itemScope: true,
      itemType: "https://schema.org/Property",
      closeOnOutsideClick: popUpStep !== TariffPurchaseSteps.Otp,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (styles_module_default()).backgroundWrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).top,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (styles_module_default()).titleTop,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
                titleModify: classnames_default()((styles_module_default()).title, 'title--large'),
                children: selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).rectangle
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (styles_module_default()).priceContainer,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (styles_module_default()).price,
                children: [selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.price, " "]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).text,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: ["\u20BC/", selectedTariff === null || selectedTariff === void 0 ? void 0 : selectedTariff.price_text]
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardShapes/* default */.Z, {})]
        }), stepComponents[popUpStep]]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PopUpConfirm, {})]
  });
};
;// CONCATENATED MODULE: ./utils/overflowDocument.js
var overflowDocument = function overflowDocument(active) {
  document.documentElement.classList[active ? 'add' : 'remove']('overflow');
};

/* harmony default export */ var utils_overflowDocument = (overflowDocument);
// EXTERNAL MODULE: ./hooks/index.js + 1 modules
var hooks = __webpack_require__(59748);
// EXTERNAL MODULE: ./components/ui/DayNightSwitch/DayNightSwitch.js
var DayNightSwitch = __webpack_require__(78385);
// EXTERNAL MODULE: ./domains/view/index.js + 2 modules
var view = __webpack_require__(97201);
// EXTERNAL MODULE: ./components/ui/Modal/Modal.tsx
var Modal = __webpack_require__(23303);
// EXTERNAL MODULE: ./components/ui/FindYourTariffModal/FindYourTariffModal.module.scss
var FindYourTariffModal_module = __webpack_require__(56245);
var FindYourTariffModal_module_default = /*#__PURE__*/__webpack_require__.n(FindYourTariffModal_module);
;// CONCATENATED MODULE: ./components/ui/FindYourTariffModal/FindYourTariffModal.js



function FindYourTariffModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FindYourTariffModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FindYourTariffModal_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FindYourTariffModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var FindYourTariffModal = function FindYourTariffModal(_ref) {
  var _data$questions, _data$questions3, _formik$values2, _data$questions4;

  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      data = _ref.data;

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      tariff = _React$useState2[0],
      setTariff = _React$useState2[1];

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      lang = _useTranslation.lang;

  var _viewHooks$useTariff = view/* hooks.useTariff */.PT.useTariff(),
      _viewHooks$useTariff2 = (0,slicedToArray/* default */.Z)(_viewHooks$useTariff, 1),
      tariffMutation = _viewHooks$useTariff2[0];

  var initialRadioValues = data === null || data === void 0 ? void 0 : (_data$questions = data.questions) === null || _data$questions === void 0 ? void 0 : _data$questions.reduce(function (accum, item, index) {
    var _item$answers;

    return FindYourTariffModal_objectSpread(FindYourTariffModal_objectSpread({}, accum), {}, (0,defineProperty/* default */.Z)({}, index, Array((item === null || item === void 0 ? void 0 : (_item$answers = item.answers) === null || _item$answers === void 0 ? void 0 : _item$answers.length) || 2).fill(null)));
  }, {});
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      radio: initialRadioValues
    }
  });
  react.useEffect(function () {
    var _formik$values, _data$questions2;

    var checkedValues = Object.values(formik === null || formik === void 0 ? void 0 : (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.radio).filter(function (item) {
      return typeof item !== 'object';
    });

    if ((data === null || data === void 0 ? void 0 : (_data$questions2 = data.questions) === null || _data$questions2 === void 0 ? void 0 : _data$questions2.length) === (checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.length)) {
      var answers = {
        answers: checkedValues
      };
      tariffMutation({
        data: answers,
        lang: lang
      }).unwrap().then(function (res) {
        setTariff(res);
      });
    }
  }, [data === null || data === void 0 ? void 0 : (_data$questions3 = data.questions) === null || _data$questions3 === void 0 ? void 0 : _data$questions3.length, formik === null || formik === void 0 ? void 0 : (_formik$values2 = formik.values) === null || _formik$values2 === void 0 ? void 0 : _formik$values2.radio, lang]);

  var renderQuestion = function renderQuestion(item, index) {
    var _item$answers2;

    var radioOnChange = function radioOnChange(event, checkboxIndex) {
      formik.setFieldValue("radio.".concat(index), item === null || item === void 0 ? void 0 : item.answers[checkboxIndex].id);
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FindYourTariffModal_module_default()).question,
      itemScope: true,
      itemType: "https://schema.org/Question",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (FindYourTariffModal_module_default()).title,
        children: [index + 1, ". ", item.title]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FindYourTariffModal_module_default()).content,
        children: item === null || item === void 0 ? void 0 : (_item$answers2 = item.answers) === null || _item$answers2 === void 0 ? void 0 : _item$answers2.map(function (checkbox, checkboxIndex) {
          var _formik$values3;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* RadioWithTitle */.Xq, {
            checked: formik === null || formik === void 0 ? void 0 : (_formik$values3 = formik.values) === null || _formik$values3 === void 0 ? void 0 : _formik$values3.radio[index][checkboxIndex],
            onChange: function onChange(event) {
              return radioOnChange(event, checkboxIndex);
            },
            name: "".concat(index, "_question"),
            className: (FindYourTariffModal_module_default()).input,
            classNameTitle: (FindYourTariffModal_module_default()).inputTitle,
            children: checkbox.text
          }, "".concat(checkboxIndex, "_question"));
        })
      })]
    }, index);
  };

  var resetForm = function resetForm() {
    formik.resetForm();
    setTariff(null);
  };

  var closeModal = function closeModal() {
    resetForm();
    setActive(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal["default"], {
    active: active,
    setActive: setActive,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FindYourTariffModal_module_default()).container,
      children: tariff ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: "".concat(tariff === null || tariff === void 0 ? void 0 : tariff.name, " ").concat(data === null || data === void 0 ? void 0 : data.result_title)
          },
          className: (FindYourTariffModal_module_default()).title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (FindYourTariffModal_module_default()).tariff,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TariffCard */.Sk, {
            className: (FindYourTariffModal_module_default()).tariffCard,
            item: tariff,
            onClick: closeModal
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (FindYourTariffModal_module_default()).findAnother,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            "aria-label": data === null || data === void 0 ? void 0 : data.pop_up_bottom_text,
            className: (FindYourTariffModal_module_default()).button,
            onClick: resetForm,
            children: data === null || data === void 0 ? void 0 : data.pop_up_bottom_text
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: data === null || data === void 0 ? void 0 : data.title
          },
          className: (FindYourTariffModal_module_default()).title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (FindYourTariffModal_module_default()).slider,
          children: data === null || data === void 0 ? void 0 : (_data$questions4 = data.questions) === null || _data$questions4 === void 0 ? void 0 : _data$questions4.map(renderQuestion)
        })]
      })
    })
  });
};

/* harmony default export */ var FindYourTariffModal_FindYourTariffModal = (FindYourTariffModal);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(14730);
// EXTERNAL MODULE: ./components/ui/ButtonsSwitch/styles.module.scss
var ButtonsSwitch_styles_module = __webpack_require__(49226);
var ButtonsSwitch_styles_module_default = /*#__PURE__*/__webpack_require__.n(ButtonsSwitch_styles_module);
;// CONCATENATED MODULE: ./components/ui/ButtonsSwitch/ButtonsSwitch.tsx



var _excluded = ["items", "currentIndex"];






var ButtonsSwitch = function ButtonsSwitch(_ref) {
  var items = _ref.items,
      _ref$currentIndex = _ref.currentIndex,
      currentIndex = _ref$currentIndex === void 0 ? 0 : _ref$currentIndex,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _React$useState = react.useState(currentIndex),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

  var renderButton = function renderButton(item, index) {
    var handleClick = function handleClick(event) {
      setActiveIndex(index);
      if (!item.onClick) return;
      return item.onClick(event);
    };

    return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: handleClick,
      className: classnames_default()((0,defineProperty/* default */.Z)({}, (ButtonsSwitch_styles_module_default()).active, activeIndex === index)),
      "aria-label": item.text,
      children: item.text
    }, index);
  };

  var indicatorStyles = {
    width: "calc(100% / ".concat(items.length, ")"),
    transform: "translateX(calc(100% * ".concat(activeIndex, "))")
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(ButtonsSwitch_styles_module_default()).indicator__container, props.className]),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ButtonsSwitch_styles_module_default()).indicator,
      style: indicatorStyles
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ButtonsSwitch_styles_module_default()).indicator__list,
      style: {
        gridTemplateColumns: "repeat(".concat(items.length, ", 1fr)")
      },
      children: items.map(renderButton)
    })]
  });
};

/* harmony default export */ var ButtonsSwitch_ButtonsSwitch = (ButtonsSwitch);
;// CONCATENATED MODULE: ./components/SvgComponents/Burger.js



var BurgerSvg = function BurgerSvg() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.75 3.75H20.25V6H3.75V3.75Z",
      fill: "#E9E6E6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.25 6V3.75H3.75L3 6H5.25Z",
      fill: "#E9E6E6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.75 3.75V6H20.25L21 3.75H18.75Z",
      fill: "#E9E6E6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.75 18H20.25V20.25H3.75V18Z",
      fill: "#E9E6E6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.25 20.25V18H3.75L3 20.25H5.25Z",
      fill: "#E9E6E6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.75 18V20.25H20.25L21 18H18.75Z",
      fill: "#E9E6E6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.75 10.8825H20.25V13.1325H3.75V10.8825Z",
      fill: "#E9E6E6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.25 13.1325V10.8825H3.75L3 13.1325H5.25Z",
      fill: "#E9E6E6"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.75 10.8825V13.1325H20.25L21 10.8825H18.75Z",
      fill: "#E9E6E6"
    })]
  });
};

/* harmony default export */ var Burger = (BurgerSvg);
// EXTERNAL MODULE: ./hooks/useCabinet.js
var useCabinet = __webpack_require__(13245);
// EXTERNAL MODULE: ./components/SvgComponents/User.js
var User = __webpack_require__(56290);
// EXTERNAL MODULE: ./components/SvgComponents/ArrowRightNew.js
var SvgComponents_ArrowRightNew = __webpack_require__(63344);
// EXTERNAL MODULE: ./components/cabinet/top-up-modal/index.js + 1 modules
var top_up_modal = __webpack_require__(91425);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(62049);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/number-sale/ToolbarBanner/index.js





var ToolbarBanner = function ToolbarBanner(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: [/*#__PURE__*/_jsx("h1", {
      children: data === null || data === void 0 ? void 0 : data.title
    }), /*#__PURE__*/_jsx("p", {
      children: data === null || data === void 0 ? void 0 : data.description
    }), /*#__PURE__*/_jsx(Link, {
      href: data === null || data === void 0 ? void 0 : data.button_slug,
      "aria-label": "Buy Number",
      rel: "noopener noreferrer",
      children: /*#__PURE__*/_jsxs("a", {
        children: [data === null || data === void 0 ? void 0 : data.button_text, " ", /*#__PURE__*/_jsx(ArrowRightNew, {})]
      })
    })]
  });
};
// EXTERNAL MODULE: ./constants/media.js
var media = __webpack_require__(98587);
// EXTERNAL MODULE: ./components/common/ToolBar/components/Service/Service.module.scss
var Service_module = __webpack_require__(37688);
var Service_module_default = /*#__PURE__*/__webpack_require__.n(Service_module);
;// CONCATENATED MODULE: ./components/common/ToolBar/components/Service/Service.js







var Service = function Service(_ref) {
  var data = _ref.data,
      onClick = _ref.onClick;

  var _useGetBreakPoints = (0,media/* useGetBreakPoints */.s)(),
      isDesktop = _useGetBreakPoints.isDesktop;

  var iconSize = isDesktop ? 80 : 60;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
    href: "/".concat(data === null || data === void 0 ? void 0 : data.slug),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Service_module_default()).container,
      title: data === null || data === void 0 ? void 0 : data.text,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Service_module_default()).intro,
        onClick: onClick,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Service_module_default()).imageWrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Service_module_default()).image,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: data === null || data === void 0 ? void 0 : data.text,
              title: data === null || data === void 0 ? void 0 : data.text,
              src: data === null || data === void 0 ? void 0 : data.icon,
              width: iconSize,
              height: iconSize,
              loading: "lazy",
              objectFit: "scale-down"
            })
          })
        })
      }), (data === null || data === void 0 ? void 0 : data.text) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Service_module_default()).title,
        children: data === null || data === void 0 ? void 0 : data.text
      })]
    })
  });
};

/* harmony default export */ var Service_Service = (Service);
// EXTERNAL MODULE: ./components/tariffs/index.js + 9 modules
var tariffs = __webpack_require__(44952);
// EXTERNAL MODULE: ./components/common/ToolBar/ToolBar.module.scss
var ToolBar_module = __webpack_require__(2903);
var ToolBar_module_default = /*#__PURE__*/__webpack_require__.n(ToolBar_module);
;// CONCATENATED MODULE: ./components/common/ToolBar/ToolBar.js











var ToolBar = function ToolBar(_ref) {
  var _data$sections, _data$banners;

  var active = _ref.active,
      setActive = _ref.setActive,
      data = _ref.data;

  var onClose = function onClose(event) {
    var target = event.target;

    if (target.classList.contains('toolbar-target')) {
      setActive(false);
    }
  };

  var renderToolBar = function renderToolBar(item, index) {
    var _item$links;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ToolBar_module_default()).mt_2,
      itemScope: true,
      itemType: "https://schema.org/Thing",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ToolbarSectionTitle */.e1, {
        icon: item === null || item === void 0 ? void 0 : item.icon,
        children: item === null || item === void 0 ? void 0 : item.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ToolBar_module_default()).grid,
        children: item === null || item === void 0 ? void 0 : (_item$links = item.links) === null || _item$links === void 0 ? void 0 : _item$links.map(function (link, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Service_Service, {
            onClick: function onClick() {
              return setActive(false);
            },
            data: link
          }, index);
        })
      })]
    }, index);
  };

  var renderBanner = function renderBanner(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(tariffs/* InternetBlock */.B3, {
      contentData: item,
      nonDesktop: true,
      itemScope: true,
      itemType: "https://schema.org/Offer"
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    onClick: onClose,
    className: classnames_default()([(ToolBar_module_default()).wrapper, (0,defineProperty/* default */.Z)({}, (ToolBar_module_default()).active, active), 'toolbar-target']),
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
      className: (ToolBar_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ToolBar_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ToolBar_module_default()).title,
          children: data === null || data === void 0 ? void 0 : data.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (ToolBar_module_default()).close,
          onClick: function onClick() {
            return setActive(false);
          },
          "aria-label": "Bakcell",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseSquare */.s9, {})
        })]
      }), data === null || data === void 0 ? void 0 : (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.map(renderToolBar), data === null || data === void 0 ? void 0 : (_data$banners = data.banners) === null || _data$banners === void 0 ? void 0 : _data$banners.map(renderBanner)]
    })
  });
};

/* harmony default export */ var ToolBar_ToolBar = (ToolBar);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/index.mjs
var dist = __webpack_require__(2969);
// EXTERNAL MODULE: ./hooks/useBusiness.js
var useBusiness = __webpack_require__(97367);
// EXTERNAL MODULE: ./hooks/useClickOutside.js
var useClickOutside = __webpack_require__(95562);
;// CONCATENATED MODULE: ./utils/encodeStr.js
var htmlEncode = function htmlEncode(value) {
  if (!value) {
    throw new Error('Invalid input: value cannot be falsy (null, undefined, etc.)');
  }

  if (typeof value !== 'string') {
    throw new Error('Invalid input: value must be a string.');
  }

  return value.replace(/[^\w. ]/gi, function (c) {
    return "&#".concat(c.charCodeAt(0), ";");
  });
};
var jsEscape = function jsEscape(value) {
  if (!value) {
    throw new Error('Invalid input: value cannot be falsy (null, undefined, etc.)');
  }

  if (typeof value !== 'string') {
    throw new Error('Invalid input: value must be a string.');
  }

  return value.replace(/[^\w. ]/gi, function (c) {
    return "\\u".concat("0000".concat(c.charCodeAt(0).toString(16)).slice(-4));
  });
};
// EXTERNAL MODULE: ./components/common/Header/SearchField/SearchField.module.scss
var SearchField_module = __webpack_require__(80183);
var SearchField_module_default = /*#__PURE__*/__webpack_require__.n(SearchField_module);
;// CONCATENATED MODULE: ./components/common/Header/SearchField/SearchField.js


function SearchField_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SearchField_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SearchField_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SearchField_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var SearchField = function SearchField(_ref) {
  var active = _ref.active,
      setActive = _ref.setActive,
      setOpenMenu = _ref.setOpenMenu;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var router = (0,next_router.useRouter)();
  var isBusiness = (0,useBusiness/* useBusiness */.i)();
  var inputRef = (0,react.useRef)(null);
  var containerRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(''),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isTyping = _useState2[0],
      setIsTyping = _useState2[1];

  var debouncedValue = (0,dist/* useDebounce */.Nr)(value, 800);

  var _viewHooks$useSearchC = view/* hooks.useSearchContent */.PT.useSearchContent({
    q: debouncedValue,
    type: isBusiness ? 'business' : 'individual',
    lang: lang
  }, {
    skip: !debouncedValue
  }),
      data = _viewHooks$useSearchC.data,
      isFetching = _viewHooks$useSearchC.isFetching;

  var handleInputChange = function handleInputChange(newValue) {
    if (newValue) {
      setIsTyping(true);
    }

    setValue(newValue);
  };

  (0,react.useEffect)(function () {
    var _inputRef$current;

    if (active) (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }, [active]);

  var handleClose = function handleClose() {
    setValue('');
  };

  (0,useClickOutside/* default */.Z)(containerRef, function () {
    return setActive(false);
  });

  var handleSearchRedirection = function handleSearchRedirection(item) {
    setOpenMenu();
    router.push(item === null || item === void 0 ? void 0 : item.slug);
    handleClose();
    setActive(!active);
  };

  var endIconClick = function endIconClick() {
    setActive(false);
    router.push("/search?q=".concat(jsEscape(value), "&type=").concat(isBusiness ? 'corporate' : 'individual'));
  };

  (0,react.useEffect)(function () {
    var inputElement = inputRef.current;

    var handleKeyPress = function handleKeyPress(event) {
      if (value && event.key === 'Enter') {
        if (value.trim() !== '') {
          endIconClick();
          setOpenMenu();
          handleClose();
          setActive(!active);
        }
      }
    };

    if (inputElement) {
      inputElement.addEventListener('keypress', handleKeyPress);
    }

    return function () {
      if (inputElement) {
        inputElement.removeEventListener('keypress', handleKeyPress);
      }
    };
  }, [debouncedValue, value]);
  (0,react.useEffect)(function () {
    setIsTyping(false);
  }, [debouncedValue]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(SearchField_module_default()).wrapper, (0,defineProperty/* default */.Z)({}, (SearchField_module_default()).active, active)]),
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: containerRef,
      className: classnames_default()(['wrapper', (SearchField_module_default()).content]),
      itemScope: true,
      itemType: "https://schema.org/SearchAction",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InputAutoComplete */.L$, SearchField_objectSpread(SearchField_objectSpread({
        inputRef: inputRef,
        className: (SearchField_module_default()).input,
        value: value,
        setValue: handleInputChange,
        searchList: data,
        placeholder: t('common:Search'),
        onSelect: handleSearchRedirection,
        endIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Search */.HN, {
          className: (SearchField_module_default()).red_icon
        })
      }, value && {
        endIconClick: endIconClick
      }), {}, {
        loading: isFetching,
        isTyping: isTyping
      }))
    })
  });
};

/* harmony default export */ var SearchField_SearchField = (SearchField);
// EXTERNAL MODULE: ./constants/base.js + 1 modules
var base = __webpack_require__(58165);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(16814);
// EXTERNAL MODULE: ./components/common/Header/styles.module.scss
var Header_styles_module = __webpack_require__(38817);
var Header_styles_module_default = /*#__PURE__*/__webpack_require__.n(Header_styles_module);
;// CONCATENATED MODULE: ./components/common/Header/NavItem/NavItem.js














var NavItem = function NavItem(_ref) {
  var _item$children2, _item$children3;

  var item = _ref.item,
      handleOpenMenu = _ref.handleOpenMenu;
  var router = (0,next_router.useRouter)();

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];

  var _useWindowSize = (0,useWindowSize/* default */.Z)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var toggleSubmenuOrNavigate = function toggleSubmenuOrNavigate(item) {
    var _item$children;

    if ((item === null || item === void 0 ? void 0 : (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0) {
      setActive(function (active) {
        return !active;
      });
    } else {
      handleOpenMenu();
      router.push(item === null || item === void 0 ? void 0 : item.slug);
    }
  };

  var renderItem = function renderItem(subCategory, subCategoryIndex) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
      handleOpenMenu: handleOpenMenu,
      href: "/".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.slug),
      itemScope: true,
      itemType: "https://schema.org/SiteNavigationElement",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        title: subCategory === null || subCategory === void 0 ? void 0 : subCategory.text,
        className: (Header_styles_module_default()).navItem,
        children: subCategory === null || subCategory === void 0 ? void 0 : subCategory.text
      })
    }, subCategoryIndex);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(Header_styles_module_default()).item, (0,defineProperty/* default */.Z)({}, (Header_styles_module_default()).active, active)]),
    itemScope: true,
    itemType: "https://schema.org/SiteNavigationElement",
    onClick: function onClick() {
      return toggleSubmenuOrNavigate(item);
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Header_styles_module_default()).navButton,
      children: (item === null || item === void 0 ? void 0 : (_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [windowsX < base/* breakPoints.md */.Eg.md ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Header_styles_module_default()).dFlex,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            title: item === null || item === void 0 ? void 0 : item.text,
            children: item === null || item === void 0 ? void 0 : item.text
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (Header_styles_module_default()).arrow,
            "aria-label": "Nav item dropdown",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
              width: 12,
              className: (Header_styles_module_default()).arrowSvg
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "/".concat(item === null || item === void 0 ? void 0 : item.slug),
            title: item === null || item === void 0 ? void 0 : item.text,
            children: item === null || item === void 0 ? void 0 : item.text
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (Header_styles_module_default()).arrow,
            "aria-label": "Nav item dropdown",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
              width: 12,
              className: (Header_styles_module_default()).arrowSvg
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Header_styles_module_default()).nav,
          children: item === null || item === void 0 ? void 0 : (_item$children3 = item.children) === null || _item$children3 === void 0 ? void 0 : _item$children3.map(renderItem)
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
        href: "/".concat(item === null || item === void 0 ? void 0 : item.slug),
        handleOpenMenu: handleOpenMenu,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          title: item === null || item === void 0 ? void 0 : item.text,
          children: item === null || item === void 0 ? void 0 : item.text
        })
      })
    })
  });
};

/* harmony default export */ var NavItem_NavItem = (NavItem);
// EXTERNAL MODULE: ./components/common/Header/Language/Language.js
var Language = __webpack_require__(87777);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(72934);
;// CONCATENATED MODULE: ./components/common/Portal/Portal.js


var Portal = function Portal(_ref) {
  var children = _ref.children;

  if (false) {}

  return /*#__PURE__*/ReactDOM.createPortal(children, document.getElementById('modal-root'));
};

/* harmony default export */ var Portal_Portal = ((/* unused pure expression or super */ null && (Portal)));
;// CONCATENATED MODULE: ./components/common/Header/Header.js






/* eslint-disable no-nested-ternary */































var Header = function Header(_ref) {
  var _ref3;

  var navigation = _ref.navigation,
      toolbar = _ref.toolbar,
      bundle = _ref.bundle,
      topLinks = _ref.topLinks,
      marqueeData = _ref.marqueeData,
      join = _ref.join;
  var loggedIn = isUserLoggedIn();
  var route = (0,next_router.useRouter)();

  var _useTranslation = (0,useTranslation/* default */.Z)('common'),
      t = _useTranslation.t;

  var _useTranslation2 = (0,useTranslation/* default */.Z)('cabinet'),
      cabinet = _useTranslation2.t;

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var _useRouter = (0,next_router.useRouter)(),
      push = _useRouter.push;

  var _useTheme = (0,index_module/* useTheme */.F)(),
      theme = _useTheme.theme;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      user = _React$useState2[0],
      setUser = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      openMenu = _React$useState4[0],
      setOpenMenu = _React$useState4[1];

  var _React$useState5 = react.useState(false),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      openToolBar = _React$useState6[0],
      setOpenToolBar = _React$useState6[1];

  var _React$useState7 = react.useState(false),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      openSearch = _React$useState8[0],
      setOpenSearch = _React$useState8[1];

  var _React$useState9 = react.useState(false),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      openLoginModal = _React$useState10[0],
      setOpenLoginModal = _React$useState10[1];

  var _React$useState11 = react.useState(false),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      topUpBalanceModal = _React$useState12[0],
      setTopUpBalanceModal = _React$useState12[1];

  var _React$useState13 = react.useState(false),
      _React$useState14 = (0,slicedToArray/* default */.Z)(_React$useState13, 2),
      openJoinBackcellModal = _React$useState14[0],
      setOpenJoinBackcellModal = _React$useState14[1];

  var _React$useState15 = react.useState(false),
      _React$useState16 = (0,slicedToArray/* default */.Z)(_React$useState15, 2),
      isBusiness = _React$useState16[0],
      setIsBusiness = _React$useState16[1];

  var _React$useState17 = react.useState(false),
      _React$useState18 = (0,slicedToArray/* default */.Z)(_React$useState17, 2),
      findYourTariffModal = _React$useState18[0],
      setFindYourTariffModal = _React$useState18[1];

  var _React$useState19 = react.useState(null),
      _React$useState20 = (0,slicedToArray/* default */.Z)(_React$useState19, 2),
      findYourTariffModalData = _React$useState20[0],
      setFindYourTariffModalData = _React$useState20[1];

  var _useState = (0,react.useState)('light_mode_icon'),
      topIconTheme = _useState[0],
      setTopIconTheme = _useState[1];

  var isCabinetPage = (0,useCabinet/* useIsCabinet */.g)();

  var _useState2 = (0,react.useState)(false),
      topUpModalActive = _useState2[0],
      _setTopUpModalActive = _useState2[1];

  var handleOpenMenu = function handleOpenMenu() {
    utils_overflowDocument(!openMenu);
    setOpenMenu(!openMenu);
  };

  var onLogin = function onLogin() {
    setTopUpBalanceModal(false);
    setOpenLoginModal(true);
  };

  var handleOpenToolBar = react.useCallback(function (value) {
    setOpenMenu(false);
    utils_overflowDocument(false);
    setOpenToolBar(value || !openToolBar);

    if (value) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [openToolBar]);
  react.useEffect(function () {
    var isBusinessPage = route.pathname.startsWith('/business');
    setIsBusiness(isBusinessPage);

    if (isBusinessPage) {
      document.documentElement.classList.add('business');
    } else {
      document.documentElement.classList.remove('business');
    }
  }, [route.pathname]);

  var handleBusinessLogin = function handleBusinessLogin() {
    return route.asPath === '/login' ? window.open('https://my.bakcell.com/', '_blank') : route.push('/business');
  };

  var buttonsSwitch = [{
    text: t('Personal'),
    onClick: function () {
      var _onClick = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                utils_overflowDocument(false);
                document.documentElement.classList.remove('business');
                _context.next = 4;
                return route.push('/');

              case 4:
                setOpenMenu(false);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onClick() {
        return _onClick.apply(this, arguments);
      }

      return onClick;
    }()
  }, {
    text: t('Business'),
    onClick: function () {
      var _onClick2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                utils_overflowDocument(false);
                document.documentElement.classList.add('business');
                _context2.next = 4;
                return handleBusinessLogin();

              case 4:
                setOpenMenu(false);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onClick() {
        return _onClick2.apply(this, arguments);
      }

      return onClick;
    }()
  }];
  (0,react.useEffect)(function () {
    setTopIconTheme(theme === enums_theme/* ETheme.LIGHT_MODE */.X.LIGHT_MODE ? 'light_mode_icon' : 'dark_mode_icon');
  }, [theme]);

  var renderBundle = function renderBundle(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      onClick: function onClick() {
        return handleActions(item, index);
      },
      "aria-label": "Bundle button",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item === null || item === void 0 ? void 0 : item.light_mode_icon,
        alt: "Bundle item image",
        title: item === null || item === void 0 ? void 0 : item.text,
        className: (Header_styles_module_default()).gray_icon,
        width: 20,
        height: 20,
        loading: "lazy"
      }), item === null || item === void 0 ? void 0 : item.text]
    }, index);
  };

  var renderMobileBundle = function renderMobileBundle(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      onClick: function onClick() {
        return handleActions(item, index);
      },
      "aria-label": "Mobile bundle button",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item === null || item === void 0 ? void 0 : item[topIconTheme],
        alt: "Bundle mobile item image",
        title: item === null || item === void 0 ? void 0 : item.text,
        className: (Header_styles_module_default()).gray_icon,
        width: 20,
        height: 20,
        loading: "lazy"
      }), item === null || item === void 0 ? void 0 : item.text]
    }, index);
  };

  var renderTopLinks = function renderTopLinks(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      itemScope: true,
      itemType: "https://schema.org/SiteNavigationElement",
      children: item !== null && item !== void 0 && item.slug ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
        href: "/".concat(item === null || item === void 0 ? void 0 : item.slug),
        handleOpenMenu: handleOpenMenu,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          title: item === null || item === void 0 ? void 0 : item.text,
          className: classnames_default()((0,defineProperty/* default */.Z)({}, (Header_styles_module_default()).active, route.asPath === '/about-us' && item.slug === 'about-us')),
          children: item === null || item === void 0 ? void 0 : item.text
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: item === null || item === void 0 ? void 0 : item.external_link,
        title: item === null || item === void 0 ? void 0 : item.text,
        target: "_blank",
        rel: "noreferrer",
        children: item === null || item === void 0 ? void 0 : item.text
      })
    }, "".concat(index, "_renderTopLinks"));
  };

  var renderHeaderIntro = function renderHeaderIntro(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Header_styles_module_default()).intro__item,
      itemScope: true,
      itemType: "https://schema.org/Organization",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Logo */.TR, {
        width: 17
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: marqueeData === null || marqueeData === void 0 ? void 0 : marqueeData.marquee_icon,
        alt: "marquee icon",
        title: "Marquee",
        width: 17,
        height: 17,
        layout: "responsive",
        loading: "lazy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (Header_styles_module_default()).text,
        children: marqueeData === null || marqueeData === void 0 ? void 0 : marqueeData.marquee_text
      })]
    }, "".concat(index, "_renderHeaderIntro"));
  };

  var renderBottomNav = function renderBottomNav(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem_NavItem, {
      item: item,
      handleOpenMenu: handleOpenMenu,
      itemScope: true,
      itemType: "https://schema.org/SiteNavigationElement"
    }, index);
  };

  var handleActions = function handleActions(data) {
    var _data$tariff_choice;

    if ((data === null || data === void 0 ? void 0 : data.type) === 'external') {
      _setTopUpModalActive(true);

      return;
    }

    if (data !== null && data !== void 0 && (_data$tariff_choice = data.tariff_choice) !== null && _data$tariff_choice !== void 0 && _data$tariff_choice.length) {
      setFindYourTariffModalData(data === null || data === void 0 ? void 0 : data.tariff_choice);
      setFindYourTariffModal(true);
      return;
    }

    if ((data === null || data === void 0 ? void 0 : data.type) === 'external') {
      var _window;

      (_window = window) === null || _window === void 0 ? void 0 : _window.open(data === null || data === void 0 ? void 0 : data.external_link);
      return;
    }

    handleOpenMenu();
    route.push("/".concat(data === null || data === void 0 ? void 0 : data.slug));
  };

  var joinBakcellHandler = function joinBakcellHandler() {
    if (!isBusiness) {
      setOpenJoinBackcellModal(true);
    }
  };

  var headerIndex = 0;

  if (route.asPath.includes('/about-us')) {
    headerIndex = null;
  } else if (route.asPath.includes('/business')) {
    headerIndex = 1;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(Header_styles_module_default()).introWrapper, (0,defineProperty/* default */.Z)({}, (Header_styles_module_default()).business, isBusiness)]),
      itemScope: true,
      itemType: "https://schema.org/Property",
      children: (marqueeData === null || marqueeData === void 0 ? void 0 : marqueeData.show_marquee) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Header_styles_module_default()).intro,
        children: (_ref3 = (0,toConsumableArray/* default */.Z)(Array(20))) === null || _ref3 === void 0 ? void 0 : _ref3.map(renderHeaderIntro)
      })
    }), toolbar &&
    /*#__PURE__*/
    // <Portal>
    (0,jsx_runtime.jsx)(ToolBar_ToolBar, {
      active: openToolBar,
      setActive: handleOpenToolBar,
      data: toolbar
    }) // </Portal>
    , /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      className: classnames_default()([(Header_styles_module_default()).header, (0,defineProperty/* default */.Z)({}, (Header_styles_module_default()).open, openMenu), (0,defineProperty/* default */.Z)({}, (Header_styles_module_default()).business, isBusiness)]),
      itemScope: true,
      itemType: "https://schema.org/WPHeader",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Header_styles_module_default()).header__content, (Header_styles_module_default()).wrapper),
        itemScope: true,
        itemType: "https://schema.org/Organization",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()((Header_styles_module_default()).mobile, 'wrapper', isCabinetPage ? (Header_styles_module_default()).cabinetPage : ''),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Header_styles_module_default()).left,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              variant: 'text',
              size: 'normal',
              Component: isBusiness ? 'router' : 'button',
              className: (Header_styles_module_default()).joinBakcell,
              href: '/business/join-us',
              onClick: joinBakcellHandler,
              "data-testid": 'join-bakcell',
              children: join === null || join === void 0 ? void 0 : join.menu_button_text
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              "aria-label": 'Bakcell',
              className: (Header_styles_module_default()).burgerHolder,
              onClick: handleOpenMenu,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Burger, {})
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Header_styles_module_default()).right,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$ // handleOpenMenu={handleOpenMenu}
            , {
              href: isBusiness ? '/business' : '/',
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                title: "Bakcell",
                "aria-label": "Bakcell",
                className: (Header_styles_module_default()).logo,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (Header_styles_module_default()).bakcell_logo,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: '/data/new-logo.svg',
                    alt: 'Bakcell',
                    title: 'Bakcell',
                    width: 84,
                    height: 16
                  })
                })
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Header_styles_module_default()).navContent,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Header_styles_module_default()).wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Header_styles_module_default()).top,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Header_styles_module_default()).topContent,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "".concat((Header_styles_module_default()).left, " flex-c wrapper"),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonsSwitch_ButtonsSwitch, {
                    className: (Header_styles_module_default()).pageSwitch,
                    items: buttonsSwitch,
                    currentIndex: headerIndex
                  }), (topLinks === null || topLinks === void 0 ? void 0 : topLinks.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                    className: (Header_styles_module_default()).list,
                    children: topLinks === null || topLinks === void 0 ? void 0 : topLinks.map(renderTopLinks)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (Header_styles_module_default()).mobileButtons,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Language/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      className: "".concat((Header_styles_module_default()).button, " ").concat((Header_styles_module_default()).closeMobile),
                      onClick: handleOpenMenu,
                      "aria-label": 'Bakcell',
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (Header_styles_module_default()).right,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (Header_styles_module_default()).buttons,
                    children: bundle === null || bundle === void 0 ? void 0 : bundle.map(renderBundle)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: (Header_styles_module_default()).mobileWrapper,
                    children: [(!loggedIn || isBusiness) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
                      className: (Header_styles_module_default()).singIn,
                      variant: 'border',
                      size: 'normal',
                      Component: 'a',
                      href: "".concat(isBusiness ? 'https://my.bakcell.com/' : '/login'),
                      children: t('Sign in')
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      onClick: handleOpenToolBar,
                      className: (Header_styles_module_default()).menu,
                      "aria-label": "Bakcell",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Menu */.v2, {})
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                    className: (Header_styles_module_default()).list,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Language/* default */.Z, {})
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DayNightSwitch/* default */.Z, {})
                    })]
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat((Header_styles_module_default()).bottom, " ").concat(isCabinetPage ? (Header_styles_module_default()).cabinetPage : ''),
              children: [openSearch && /*#__PURE__*/(0,jsx_runtime.jsx)(SearchField_SearchField, {
                active: openSearch,
                setActive: setOpenSearch,
                setOpenMenu: setOpenMenu
              }), windowsX < 1025 && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InputAutoComplete */.L$, {
                className: classnames_default()((Header_styles_module_default()).mobile_input, (0,defineProperty/* default */.Z)({}, (Header_styles_module_default()).disabled, openSearch)),
                placeholder: t('Search'),
                endIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Search */.HN, {}),
                onClick: function onClick() {
                  return setOpenSearch(true);
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Header_styles_module_default()).wrapper,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (Header_styles_module_default()).left,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
                    href: isBusiness ? '/business' : '/',
                    handleOpenMenu: handleOpenMenu,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      title: "Bakcell",
                      "aria-label": "Bakcell",
                      className: (Header_styles_module_default()).logo,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: (Header_styles_module_default()).bakcell_logo,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                          src: '/data/new-logo.svg',
                          alt: 'Bakcell',
                          title: 'Bakcell',
                          width: 84,
                          height: 16
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
                    className: (Header_styles_module_default()).navBar,
                    children: navigation === null || navigation === void 0 ? void 0 : navigation.map(renderBottomNav)
                  }), !!windowsX && windowsX <= 1024 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (Header_styles_module_default()).buttons,
                    children: bundle === null || bundle === void 0 ? void 0 : bundle.map(renderMobileBundle)
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  className: (Header_styles_module_default()).right,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      className: (Header_styles_module_default()).search,
                      "aria-label": openSearch ? 'Close search' : 'Open search',
                      onClick: function onClick() {
                        return setOpenSearch(!openSearch);
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Search */.HN, {})
                    })
                  }), !isBusiness && toolbar && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                        onClick: handleOpenToolBar,
                        className: (Header_styles_module_default()).menu,
                        "aria-label": "Bakcell",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Menu */.v2, {})
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: (Header_styles_module_default()).contacts,
                    children: user ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* PhoneNumbersDropDown */.QU, {
                      isBusiness: isBusiness
                    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
                        variant: 'text',
                        size: 'normal',
                        Component: isBusiness ? 'router' : 'button',
                        className: (Header_styles_module_default()).joinBakcell,
                        href: '/business/join-us',
                        onClick: function onClick() {
                          handleOpenMenu();

                          if (!isBusiness) {
                            setOpenJoinBackcellModal(true);
                          }
                        },
                        children: join === null || join === void 0 ? void 0 : join.menu_button_text
                      }), loggedIn && !isBusiness ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        onClick: function onClick() {
                          return push('/cabinet');
                        },
                        className: (Header_styles_module_default()).userIcon,
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                            className: (Header_styles_module_default()).userIconDiv,
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)(User/* default */.Z, {})
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: cabinet('breadcrumb.title')
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: (Header_styles_module_default()).arrowDiv,
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents_ArrowRightNew/* default */.Z, {
                            className: (Header_styles_module_default()).arrowIconNew
                          })
                        })]
                      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
                        className: (Header_styles_module_default()).singIn,
                        variant: 'border',
                        size: 'normal',
                        Component: 'a',
                        href: "".concat(isBusiness ? 'https://my.bakcell.com/' : '/login'),
                        children: t('Sign in')
                      })]
                    })
                  })]
                })]
              })]
            })]
          })
        })]
      })
    }), topUpBalanceModal && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TopUpBalanceModal */.UB, {
      user: user,
      setActive: setTopUpBalanceModal,
      active: topUpBalanceModal,
      onLogin: onLogin
    }), openLoginModal && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* LoginModal */._A, {
      setUser: setUser,
      active: openLoginModal,
      setActive: setOpenLoginModal
    }), openJoinBackcellModal && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* JoinBackcellModal */.EP, {
      join: join,
      active: openJoinBackcellModal,
      setActive: setOpenJoinBackcellModal,
      "data-testid": 'join-bakcell-modal'
    }), !!findYourTariffModalData && /*#__PURE__*/(0,jsx_runtime.jsx)(FindYourTariffModal_FindYourTariffModal, {
      data: findYourTariffModalData,
      active: findYourTariffModal,
      setActive: setFindYourTariffModal
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TariffCardPopup, {}), topUpModalActive && /*#__PURE__*/(0,jsx_runtime.jsx)(top_up_modal/* TopUpModal */.Y, {
      active: topUpModalActive,
      setTopUpModalActive: function setTopUpModalActive() {
        return _setTopUpModalActive(false);
      },
      isMainPage: true
    })]
  });
};

/* harmony default export */ var Header_Header = (Header);
// EXTERNAL MODULE: ./utils/axios.js
var axios = __webpack_require__(82373);
// EXTERNAL MODULE: ./utils/handleCheckKey.ts
var handleCheckKey = __webpack_require__(88929);
// EXTERNAL MODULE: ./components/ui/ScreenLoader/ScreenLoader.js
var ScreenLoader = __webpack_require__(78755);
// EXTERNAL MODULE: ./components/ui/InformationModal/InformationModal.js
var InformationModal = __webpack_require__(92603);
// EXTERNAL MODULE: ./components/ui/Subscribe/Subscribe.module.scss
var Subscribe_module = __webpack_require__(91983);
var Subscribe_module_default = /*#__PURE__*/__webpack_require__.n(Subscribe_module);
;// CONCATENATED MODULE: ./components/ui/Subscribe/Subscribe.js


















var FormSchema = yup_es/* object */.Ry().shape({
  email: yup_es/* string */.Z_().required().email()
});

var Subscribe = function Subscribe(_ref) {
  var buttonText = _ref.buttonText,
      title = _ref.title,
      description = _ref.description;

  var _useTranslation = (0,useTranslation/* default */.Z)('common'),
      t = _useTranslation.t;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeModal = _React$useState2[0],
      setActiveModal = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      email: ''
    },
    validationSchema: FormSchema,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
        var formData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = {
                  email: values === null || values === void 0 ? void 0 : values.email
                };
                _context.prev = 1;
                setLoading(true);
                _context.next = 5;
                return axios/* default.post */.Z.post('news-subscriptions/', formData);

              case 5:
                setActiveModal(true);

              case 6:
                _context.prev = 6;
                setLoading(false);
                formik.resetForm();
                return _context.finish(6);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1,, 6, 10]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ScreenLoader/* default */.Z, {
      visible: loading
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Subscribe_module_default()).subscribeWrapper,
      itemScope: true,
      itemType: "https://schema.org/SubscribeAction",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Subscribe_module_default()).title,
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Subscribe_module_default()).description,
        children: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
        className: (Subscribe_module_default()).subscribe,
        onSubmit: formik.handleSubmit,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Subscribe_module_default()).mailForm,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            onKeyDown: handleCheckKey/* handleCheckKeyForMail */.t,
            id: "email",
            onChange: function onChange(event) {
              return formik.setFieldValue('email', event.target.value);
            },
            value: formik.values.email,
            className: classnames_default()([(Subscribe_module_default()).mailForm__input, (0,defineProperty/* default */.Z)({}, (Subscribe_module_default()).error, formik.errors.email)]),
            autoComplete: "off",
            placeholder: t('common:Subscribe placeholder'),
            "aria-label": formik.values.email || t('common:Subscribe placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            "data-testid": 'subscribe-button',
            className: (Subscribe_module_default()).mailForm__button,
            children: buttonText
          })]
        })
      })]
    }), activeModal && /*#__PURE__*/(0,jsx_runtime.jsx)(InformationModal/* default */.Z, {
      active: activeModal,
      onClose: function onClose() {
        return setActiveModal(false);
      },
      description: t('tariffSupport.success.description')
    })]
  });
};

/* harmony default export */ var Subscribe_Subscribe = (Subscribe);
// EXTERNAL MODULE: ./components/common/SocialNetwork/social-network.module.scss
var social_network_module = __webpack_require__(93706);
var social_network_module_default = /*#__PURE__*/__webpack_require__.n(social_network_module);
;// CONCATENATED MODULE: ./components/common/SocialNetwork/SocialNetwork.js




var SocialNetwork = function SocialNetwork(_ref) {
  var data = _ref.data;

  var renderStore = function renderStore(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (social_network_module_default()).item,
      itemScope: true,
      itemType: "https://schema.org/Organization",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        title: item === null || item === void 0 ? void 0 : item.link,
        href: item === null || item === void 0 ? void 0 : item.link,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: item === null || item === void 0 ? void 0 : item.icon,
          className: (social_network_module_default()).icon,
          width: 24,
          height: 24,
          alt: 'social network icons',
          title: 'Social Network Icons',
          loading: "lazy"
        })
      })
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (social_network_module_default()).list,
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: data === null || data === void 0 ? void 0 : data.map(renderStore)
  });
};

/* harmony default export */ var SocialNetwork_SocialNetwork = (SocialNetwork);
// EXTERNAL MODULE: ./components/common/Footer/footer.module.scss
var footer_module = __webpack_require__(36192);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
;// CONCATENATED MODULE: ./components/common/Footer/Footer.js













var redirectAboutUs = ['ABOUT US', 'HAQQIMIZDA', 'О НАС'];
var redirectSupport = ['SUPPORT', 'DƏSTƏK', 'ПОМОЩЬ'];
var currentYear = new Date().getFullYear();

var Footer_Footer = function Footer(_ref) {
  var _data$navigation_link, _data$navigation_link2;

  var data = _ref.data;
  var isBusiness = (0,useBusiness/* useBusiness */.i)();

  var renderFooterMenu = function renderFooterMenu(item) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      itemScope: true,
      itemType: "https://schema.org/SiteNavigationElement",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* FooterLink */.SY, {
        list: item,
        children: [redirectAboutUs.some(function (el) {
          var _item$text;

          return item === null || item === void 0 ? void 0 : (_item$text = item.text) === null || _item$text === void 0 ? void 0 : _item$text.includes(el);
        }) && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: '/about-us',
          children: item === null || item === void 0 ? void 0 : item.text
        }), redirectSupport.some(function (el) {
          var _item$text2;

          return item === null || item === void 0 ? void 0 : (_item$text2 = item.text) === null || _item$text2 === void 0 ? void 0 : _item$text2.includes(el);
        }) && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: '/support',
          children: item === null || item === void 0 ? void 0 : item.text
        }), ![].concat(redirectAboutUs, redirectSupport).some(function (el) {
          var _item$text3;

          return item === null || item === void 0 ? void 0 : (_item$text3 = item.text) === null || _item$text3 === void 0 ? void 0 : _item$text3.includes(el);
        }) && (item === null || item === void 0 ? void 0 : item.text)]
      })
    }, item === null || item === void 0 ? void 0 : item.id);
  };

  var _useTranslation = (0,useTranslation/* default */.Z)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("footer", {
      className: classnames_default()((footer_module_default()).footer, (0,defineProperty/* default */.Z)({}, (footer_module_default()).footer__business, isBusiness)),
      itemScope: true,
      itemType: "https://schema.org/WPFooter",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "wrapper",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (footer_module_default()).topBox,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (footer_module_default()).leftBox,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (footer_module_default()).fistList,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Subscribe_Subscribe, {
                buttonText: data === null || data === void 0 ? void 0 : data.subscribe_button_text,
                title: data === null || data === void 0 ? void 0 : data.subscribe_section_title,
                description: data === null || data === void 0 ? void 0 : data.subscribe_section_description,
                placeholder: data === null || data === void 0 ? void 0 : data.subscribe_input_title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (footer_module_default()).socialLinks,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SocialNetwork_SocialNetwork, {
                  data: data === null || data === void 0 ? void 0 : data.social_media_links
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (footer_module_default()).rightBox,
            children: !!(data !== null && data !== void 0 && (_data$navigation_link = data.navigation_links) !== null && _data$navigation_link !== void 0 && _data$navigation_link.length) && /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: (footer_module_default()).list,
              children: [data === null || data === void 0 ? void 0 : (_data$navigation_link2 = data.navigation_links) === null || _data$navigation_link2 === void 0 ? void 0 : _data$navigation_link2.map(renderFooterMenu), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ContactUs */.Ub, {
                  data: data === null || data === void 0 ? void 0 : data.contact_us
                })
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (footer_module_default()).divider
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (footer_module_default()).bottomBox,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (footer_module_default()).bottomLeftBox,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (footer_module_default()).text,
              children: t('Copyright', {
                year: currentYear
              })
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (footer_module_default()).footerBottomWrapper,
      itemScope: true,
      itemType: "https://schema.org/SiteNavigationElement",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* BakcellFooterLogo */.SP, {
        className: classnames_default()([(footer_module_default()).footerBtmImg, (0,defineProperty/* default */.Z)({}, (footer_module_default()).dark, isBusiness)])
      })
    })]
  });
};

/* harmony default export */ var common_Footer_Footer = (Footer_Footer);
// EXTERNAL MODULE: ./components/common/CheckoutHeader/CheckoutHeader.module.scss
var CheckoutHeader_module = __webpack_require__(45151);
var CheckoutHeader_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutHeader_module);
;// CONCATENATED MODULE: ./components/common/CheckoutHeader/CheckoutHeader.js









var CheckoutHeader = function CheckoutHeader() {
  var route = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (CheckoutHeader_module_default()).wrapper,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wrapper ".concat((CheckoutHeader_module_default()).header),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
        href: '/',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (CheckoutHeader_module_default()).logo,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: '/data/red-logo.svg',
            alt: 'Backcell',
            title: 'Backcell',
            loading: "lazy",
            layout: "fill"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
        href: route.pathname.startsWith('/business') ? '/business/support' : '/support',
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          className: (CheckoutHeader_module_default()).support,
          title: "Bakcell",
          "aria-label": "Bakcell",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Support */.Bt, {
            width: 24
          }), "Support"]
        })
      })]
    })
  });
};

/* harmony default export */ var CheckoutHeader_CheckoutHeader = (CheckoutHeader);
;// CONCATENATED MODULE: ./components/common/Layout/Layout.js












function Layout(_ref) {
  var _metadata$open_graph_, _metadata$open_graph_2, _metadata$open_graph_3, _metadata$open_graph_4, _metadata$open_graph_5, _metadata$open_graph_6, _metadata$open_graph_7, _metadata$open_graph_8, _metadata$open_graph_9, _metadata$open_graph_10, _metadata$open_graph_11, _metadata$open_graph_12, _metadata$open_graph_13, _metadata$open_graph_14, _footer$navigation;

  var navbar = _ref.navbar,
      footer = _ref.footer,
      appDownload = _ref.appDownload,
      metadata = _ref.metadata,
      breadcrumbs = _ref.breadcrumbs,
      children = _ref.children,
      withoutTheme = _ref.withoutTheme;
  var router = (0,next_router.useRouter)();
  var asPath = router.asPath;
  var languages = ['az', 'en', 'ru'];

  var getMarqueeData = function getMarqueeData(navbar) {
    return Object.keys(navbar || {}).filter(function (key) {
      return ['show_marquee', 'marquee_text', 'marquee_icon'].includes(key);
    }).reduce(function (acc, key) {
      acc[key] = navbar[key];
      return acc;
    }, {});
  };

  var generateCanonicalLinks = function generateCanonicalLinks() {
    return languages.map(function (lang) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "alternate",
        href: generateLocaleUrl(lang, asPath),
        hrefLang: lang
      }, lang);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "robots",
        content: (metadata === null || metadata === void 0 ? void 0 : metadata.robots_content) || 'follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "google-site-verification",
        content: "5kO1HJLl47-oXLH6kpDzOfp2rk8tgmPpMyPXqSvxVSM"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: generateLocaleUrl(router.locale, asPath)
      }), generateCanonicalLinks(), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "alternate",
        href: "https://www.bakcell.com/".concat(asPath),
        hrefLang: "x-default"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:locale",
        content: "".concat(router.locale, "_").concat(router.locale.toLocaleUpperCase())
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:type",
        content: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: (metadata === null || metadata === void 0 ? void 0 : (_metadata$open_graph_ = metadata.open_graph_card) === null || _metadata$open_graph_ === void 0 ? void 0 : (_metadata$open_graph_2 = _metadata$open_graph_.properties) === null || _metadata$open_graph_2 === void 0 ? void 0 : _metadata$open_graph_2.title) || (metadata === null || metadata === void 0 ? void 0 : metadata.title)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: (metadata === null || metadata === void 0 ? void 0 : (_metadata$open_graph_3 = metadata.open_graph_card) === null || _metadata$open_graph_3 === void 0 ? void 0 : (_metadata$open_graph_4 = _metadata$open_graph_3.properties) === null || _metadata$open_graph_4 === void 0 ? void 0 : _metadata$open_graph_4.description) || (metadata === null || metadata === void 0 ? void 0 : metadata.description)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: 'https://www.bakcell.com/'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:site_name",
        content: "Bakcell"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: (metadata === null || metadata === void 0 ? void 0 : (_metadata$open_graph_5 = metadata.open_graph_card) === null || _metadata$open_graph_5 === void 0 ? void 0 : (_metadata$open_graph_6 = _metadata$open_graph_5.properties) === null || _metadata$open_graph_6 === void 0 ? void 0 : _metadata$open_graph_6.image) || '/assets/bkc.svg'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:secure_url",
        content: (metadata === null || metadata === void 0 ? void 0 : (_metadata$open_graph_7 = metadata.open_graph_card) === null || _metadata$open_graph_7 === void 0 ? void 0 : (_metadata$open_graph_8 = _metadata$open_graph_7.properties) === null || _metadata$open_graph_8 === void 0 ? void 0 : _metadata$open_graph_8.image_secure_url) || '/assets/bkc.svg'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:width",
        content: (metadata === null || metadata === void 0 ? void 0 : (_metadata$open_graph_9 = metadata.open_graph_card) === null || _metadata$open_graph_9 === void 0 ? void 0 : (_metadata$open_graph_10 = _metadata$open_graph_9.properties) === null || _metadata$open_graph_10 === void 0 ? void 0 : _metadata$open_graph_10.image_width) || '1200'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:height",
        content: (metadata === null || metadata === void 0 ? void 0 : (_metadata$open_graph_11 = metadata.open_graph_card) === null || _metadata$open_graph_11 === void 0 ? void 0 : (_metadata$open_graph_12 = _metadata$open_graph_11.properties) === null || _metadata$open_graph_12 === void 0 ? void 0 : _metadata$open_graph_12.image_height) || '630'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image:type",
        content: (metadata === null || metadata === void 0 ? void 0 : (_metadata$open_graph_13 = metadata.open_graph_card) === null || _metadata$open_graph_13 === void 0 ? void 0 : (_metadata$open_graph_14 = _metadata$open_graph_13.properties) === null || _metadata$open_graph_14 === void 0 ? void 0 : _metadata$open_graph_14.image_type) || 'image/svg'
      }), (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: breadcrumbSchema({
            breadcrumbs: breadcrumbs
          })
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      itemScope: true,
      itemType: "https://schema.org/".concat(metadata === null || metadata === void 0 ? void 0 : metadata.itemtype),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DownloadApplication_DownloadApplication, {
        data: appDownload
      }), navbar ? /*#__PURE__*/(0,jsx_runtime.jsx)(Header_Header, {
        bundle: navbar === null || navbar === void 0 ? void 0 : navbar.top_right_links,
        join: navbar === null || navbar === void 0 ? void 0 : navbar.join_modal,
        navigation: navbar === null || navbar === void 0 ? void 0 : navbar.links,
        toolbar: navbar === null || navbar === void 0 ? void 0 : navbar.additional_menu,
        topLinks: navbar === null || navbar === void 0 ? void 0 : navbar.top_left_links,
        marqueeData: getMarqueeData(navbar),
        withoutTheme: withoutTheme,
        itemScope: true,
        itemType: "https://schema.org/Organization"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CheckoutHeader_CheckoutHeader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'page-wrapper',
        children: children
      }), footer && /*#__PURE__*/(0,jsx_runtime.jsx)(common_Footer_Footer, {
        data: footer,
        navigation: footer === null || footer === void 0 ? void 0 : (_footer$navigation = footer.navigation) === null || _footer$navigation === void 0 ? void 0 : _footer$navigation.top,
        itemScope: true,
        itemType: "https://schema.org/Organization"
      })]
    })]
  });
}

/* harmony default export */ var Layout_Layout = (Layout);
// EXTERNAL MODULE: ./components/common/GoogleMaps/GoogleMaps.js
var GoogleMaps = __webpack_require__(48756);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var react_loading_skeleton_dist = __webpack_require__(4556);
// EXTERNAL MODULE: ./components/common/NewsItem/NewsItem.module.scss
var NewsItem_module = __webpack_require__(89906);
var NewsItem_module_default = /*#__PURE__*/__webpack_require__.n(NewsItem_module);
;// CONCATENATED MODULE: ./components/common/NewsItem/NewsItem.js












var NewsItem = function NewsItem(_ref) {
  var _ref$data = _ref.data,
      _ref$data$image = _ref$data.image,
      image = _ref$data$image === void 0 ? '' : _ref$data$image,
      _ref$data$title = _ref$data.title,
      title = _ref$data$title === void 0 ? '' : _ref$data$title,
      _ref$data$description = _ref$data.description,
      description = _ref$data$description === void 0 ? '' : _ref$data$description,
      _ref$data$slug = _ref$data.slug,
      slug = _ref$data$slug === void 0 ? '' : _ref$data$slug,
      category = _ref$data.category;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isImageLoaded = _React$useState2[0],
      setIsImageLoaded = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (NewsItem_module_default()).newsItem,
    itemScope: true,
    itemType: "https://schema.org/NewsArticle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
      href: "/news/".concat(slug),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (NewsItem_module_default()).imageContainer,
          children: !!image && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
              width: "100%",
              height: "100%"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: image,
              alt: title,
              title: title,
              layout: 'fill',
              loading: "lazy",
              onLoadingComplete: function onLoadingComplete() {
                return setIsImageLoaded(true);
              },
              style: {
                visibility: isImageLoaded ? 'visible' : 'hidden'
              }
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (NewsItem_module_default()).textWrapper,
          children: [!!category && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (NewsItem_module_default()).category,
            children: category
          }), !!title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (NewsItem_module_default()).title,
            children: title
          }), !!description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (NewsItem_module_default()).description,
            dangerouslySetInnerHTML: {
              __html: description
            }
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
      variant: "transparent",
      Component: 'router',
      href: "/news/".concat(slug),
      className: (NewsItem_module_default()).see_more__btn,
      children: [t('common:See more'), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* BrandArrow */.RJ, {
        width: 26
      })]
    })]
  });
};

/* harmony default export */ var NewsItem_NewsItem = (NewsItem);
;// CONCATENATED MODULE: ./components/common/FaqContainer/FaqContainer.js






var FaqContainer = function FaqContainer(_ref) {
  var _ref$data = _ref.data,
      _ref$data$title = _ref$data.title,
      title = _ref$data$title === void 0 ? '' : _ref$data$title,
      _ref$data$faq = _ref$data.faq,
      faq = _ref$data$faq === void 0 ? [] : _ref$data$faq;
  return /*#__PURE__*/_jsxs("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/FAQPage",
    children: [title && /*#__PURE__*/_jsx(SectionTitle, {
      className: styles.title,
      Icon: Support,
      titleModify: "title--large",
      children: title
    }), faq.length && /*#__PURE__*/_jsx(Faq, {
      items: faq
    })]
  });
};

/* harmony default export */ var FaqContainer_FaqContainer = ((/* unused pure expression or super */ null && (FaqContainer)));
// EXTERNAL MODULE: ./components/ui/SliderWrapper/SliderWrapper.js
var SliderWrapper = __webpack_require__(83234);
// EXTERNAL MODULE: ./components/common/SliderContainer/SliderContainer.module.scss
var SliderContainer_module = __webpack_require__(23964);
var SliderContainer_module_default = /*#__PURE__*/__webpack_require__.n(SliderContainer_module);
;// CONCATENATED MODULE: ./components/common/SliderContainer/SliderContainer.js






var SliderContainer = function SliderContainer(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? '' : _ref$icon,
      _ref$linkText = _ref.linkText,
      linkText = _ref$linkText === void 0 ? '' : _ref$linkText,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? '' : _ref$link,
      _ref$addClass = _ref.addClass,
      addClass = _ref$addClass === void 0 ? '' : _ref$addClass,
      options = _ref.options,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "section ".concat(addClass || ''),
    itemScope: true,
    itemType: "https://schema.org/Section",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: 'wrapper',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        icon: icon,
        buttonText: linkText,
        href: link,
        className: (SliderContainer_module_default()).title,
        titleModify: "title--large",
        children: title
      })
    }), !!children && /*#__PURE__*/(0,jsx_runtime.jsx)(SliderWrapper/* default */.Z, {
      options: options,
      arrows: true,
      children: children
    })]
  });
};

/* harmony default export */ var SliderContainer_SliderContainer = (SliderContainer);
;// CONCATENATED MODULE: ./components/common/OfflineHeader/OfflineHeader.js








var OfflineHeader_OfflineHeader = function OfflineHeader() {
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    itemScope: true,
    itemType: "https://schema.org/Organization",
    children: /*#__PURE__*/_jsxs("div", {
      className: "wrapper ".concat(styles.header),
      children: [/*#__PURE__*/_jsx(ActiveLink, {
        href: '/',
        children: /*#__PURE__*/_jsx("a", {
          className: styles.logo,
          title: "Bakcell",
          "aria-label": "Bakcell",
          children: /*#__PURE__*/_jsx(Image, {
            src: '/data/red-logo.svg',
            alt: 'Bakcell',
            title: 'Bakcell',
            loading: "lazy",
            layout: "fill"
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.contacts,
        itemScope: true,
        itemType: "https://schema.org/ContactPoint",
        children: [/*#__PURE__*/_jsxs("a", {
          className: styles.contact,
          href: 'tel:+994-12-498-89-89',
          title: "Bakcell",
          "aria-label": "Bakcell",
          children: [/*#__PURE__*/_jsx(HeaderCall, {
            width: 24
          }), "+994-12-498-89-89"]
        }), /*#__PURE__*/_jsxs("a", {
          className: styles.contact,
          href: 'tel:+994-12-498-89-89',
          children: [/*#__PURE__*/_jsx(HeaderCall, {
            width: 24
          }), "+994-12-498-89-89"]
        })]
      })]
    })
  });
};

/* harmony default export */ var common_OfflineHeader_OfflineHeader = ((/* unused pure expression or super */ null && (OfflineHeader_OfflineHeader)));
;// CONCATENATED MODULE: ./components/common/OfflineLayout/OfflineLayout.js






function OfflineLayout(_ref) {
  var pageProps = _ref.pageProps,
      children = _ref.children;
  var props = pageProps && typeof pageProps.page === 'string' ? JSON.parse(pageProps.page) : pageProps.page;
  return /*#__PURE__*/_jsxs("div", {
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: [/*#__PURE__*/_jsx(OfflineHeader, {}), /*#__PURE__*/_jsx("div", {
      className: 'page-wrapper',
      children: children
    }), (props === null || props === void 0 ? void 0 : props.navigation) && /*#__PURE__*/_jsx(Footer, {
      navigation: props.navigation.top
    })]
  });
}

/* harmony default export */ var OfflineLayout_OfflineLayout = ((/* unused pure expression or super */ null && (OfflineLayout)));
// EXTERNAL MODULE: ./components/common/TariffsFilter/index.js
var TariffsFilter = __webpack_require__(61024);
;// CONCATENATED MODULE: ./components/common/index.js










/***/ }),

/***/ 98778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ OfficesList_OfficesList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/contact-us/Filters/Filters.module.scss
var Filters_module = __webpack_require__(86577);
var Filters_module_default = /*#__PURE__*/__webpack_require__.n(Filters_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/contact-us/Filters/Filters.js
/* eslint-disable react-hooks/exhaustive-deps */






var defaultCityValue = {
  name: 'All',
  value: 'all'
};
var defaultOfficeValue = {
  name: 'All',
  value: 0
};

var Filters = function Filters(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      setTab = _ref.setTab,
      tab = _ref.tab,
      cities = _ref.cities,
      offices = _ref.offices,
      onFilterChange = _ref.onFilterChange;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var mappedData = function mappedData(data) {
    var mapped = data === null || data === void 0 ? void 0 : data.map(function (x) {
      return {
        name: x.name,
        value: x.id
      };
    });
    return mapped;
  };

  var _useState = (0,react.useState)(defaultCityValue),
      city = _useState[0],
      setCity = _useState[1];

  var _useState2 = (0,react.useState)(defaultOfficeValue),
      officeType = _useState2[0],
      setOfficeType = _useState2[1];

  var cityHandler = function cityHandler(city) {
    setCity(city);
    onFilterChange({
      city: city,
      officeType: officeType
    });
  };

  var officeTypeHandler = function officeTypeHandler(office) {
    setOfficeType(office);
    onFilterChange({
      city: city,
      officeType: office
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((Filters_module_default()).wrap, " ").concat(className || '', " flex-c-c"),
    itemScope: true,
    itemType: "https://schema.org/Filter",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Filters_module_default()).filtersBlock,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Filters_module_default()).block,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((Filters_module_default()).filter, " flex-c"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((Filters_module_default()).buttons, " flex-c"),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              onClick: function onClick() {
                return setTab('map');
              },
              className: "".concat((Filters_module_default()).button, " ").concat(tab === 'map' ? (Filters_module_default()).active : ''),
              "data-testid": "office-map",
              children: t('common:map')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              onClick: function onClick() {
                return setTab('list');
              },
              className: "".concat((Filters_module_default()).button, " ").concat(tab === 'list' ? (Filters_module_default()).active : ''),
              "data-testid": "office-list",
              children: t('common:list')
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Filters_module_default()).selects,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Select */.Ph, {
              value: city,
              data: mappedData(cities),
              label: t('common:city'),
              className: (Filters_module_default()).select,
              onChange: cityHandler,
              "data-testid": 'filter-city-input'
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Select */.Ph, {
              value: officeType,
              data: mappedData(offices),
              label: t('common:offices'),
              className: (Filters_module_default()).select,
              onChange: officeTypeHandler
            })]
          })]
        })
      })
    })
  });
};

/* harmony default export */ var Filters_Filters = (Filters);
// EXTERNAL MODULE: ./node_modules/@vis.gl/react-google-maps/dist/index.modern.mjs
var index_modern = __webpack_require__(86800);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(97043);
// EXTERNAL MODULE: ./utils/scrollToTop.ts
var scrollToTop = __webpack_require__(327);
// EXTERNAL MODULE: ./components/contact-us/Map/Map.module.scss
var Map_module = __webpack_require__(38974);
var Map_module_default = /*#__PURE__*/__webpack_require__.n(Map_module);
;// CONCATENATED MODULE: ./components/contact-us/Map/Map.js








var defaultLocation = {
  lat: 40.3763,
  lng: 49.81567
};

var Maps = function Maps(_ref) {
  var className = _ref.className,
      _ref$markers = _ref.markers,
      markers = _ref$markers === void 0 ? [] : _ref$markers,
      _ref$disableMarkerCli = _ref.disableMarkerClick,
      disableMarkerClick = _ref$disableMarkerCli === void 0 ? false : _ref$disableMarkerCli,
      customerLocation = _ref.customerLocation;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(customerLocation || defaultLocation),
      center = _useState[0],
      setCenter = _useState[1];

  var _useState2 = (0,react.useState)(null),
      activeMarker = _useState2[0],
      setActiveMarker = _useState2[1];

  var _useState3 = (0,react.useState)(9),
      zoom = _useState3[0],
      setZoom = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      userDragging = _useState4[0],
      setUserDragging = _useState4[1];

  var onMapDragStart = function onMapDragStart() {
    setUserDragging(true);
  };

  var onMapDrag = function onMapDrag(event) {
    var newCenter = event.map.getCenter().toJSON();
    setCenter(newCenter);
    setUserDragging(false);
  };

  (0,react.useEffect)(function () {
    if (customerLocation) {
      (0,scrollToTop/* scrollToTop */.k)();
      setCenter({
        lat: +customerLocation.lat,
        lng: +customerLocation.lng
      });
      setZoom(15);
    } else if (markers.length > 0) {
      setCenter({
        lat: +markers[0].lat,
        lng: +markers[0].lng
      });
      setZoom(9);
    }

    setActiveMarker(null);
  }, [customerLocation, markers]);

  var renderMarkers = function renderMarkers(item, index) {
    var _item$working_hours, _item$working_hours2;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_modern/* AdvancedMarker */._Q, {
      position: {
        lat: Number(item.lat),
        lng: Number(item.lng)
      },
      onClick: function onClick() {
        if (!disableMarkerClick) setActiveMarker(index);
      },
      title: item.name,
      children: [activeMarker === index && /*#__PURE__*/(0,jsx_runtime.jsx)(index_modern/* InfoWindow */.nx, {
        position: {
          lat: Number(item.lat),
          lng: Number(item.lng)
        },
        onCloseClick: function onCloseClick() {
          return setActiveMarker(null);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Map_module_default()).infoWindow,
          children: [!!(item !== null && item !== void 0 && item.name) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Map_module_default()).infoWindowTitle,
            children: item === null || item === void 0 ? void 0 : item.name
          }), !!(item !== null && item !== void 0 && item.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Map_module_default()).infoWindowAddress,
            children: item === null || item === void 0 ? void 0 : item.description
          }), (item === null || item === void 0 ? void 0 : (_item$working_hours = item.working_hours) === null || _item$working_hours === void 0 ? void 0 : _item$working_hours.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Map_module_default()).infoWindowBlock,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Map_module_default()).label,
              children: t('common:workingHours')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Map_module_default()).value,
              children: item === null || item === void 0 ? void 0 : (_item$working_hours2 = item.working_hours) === null || _item$working_hours2 === void 0 ? void 0 : _item$working_hours2.map(function (item) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "".concat((Map_module_default()).hours, " grid-extend"),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: [item === null || item === void 0 ? void 0 : item.days, ":"]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: item === null || item === void 0 ? void 0 : item.working_hours
                  })]
                }, item === null || item === void 0 ? void 0 : item.id);
              })
            })]
          }), (item === null || item === void 0 ? void 0 : item.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Map_module_default()).infoWindowBlock,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Map_module_default()).label,
              children: t('common:email')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((Map_module_default()).value, " grid-extend"),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: item === null || item === void 0 ? void 0 : item.email
              })
            })]
          }), (item === null || item === void 0 ? void 0 : item.phone_number) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Map_module_default()).infoWindowBlock,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Map_module_default()).label,
              children: t('common:phone')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((Map_module_default()).value, " grid-extend"),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: item === null || item === void 0 ? void 0 : item.phone_number
              })
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/assets/map/AddressMarker.svg",
        alt: item === null || item === void 0 ? void 0 : item.name,
        title: item === null || item === void 0 ? void 0 : item.name,
        width: 50,
        height: 50
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat(className, " ").concat((Map_module_default()).map),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_modern/* Map */.D5, {
      id: "contact-us",
      defaultCenter: center,
      defaultZoom: zoom,
      center: !userDragging ? center : null,
      onDragstart: onMapDragStart,
      onDragend: onMapDrag,
      onClick: function onClick() {
        return setActiveMarker(null);
      },
      mapId: constants/* verticalMapId */.u,
      options: {
        disableDefaultUI: true,
        gestureHandling: 'greedy',
        draggable: true,
        zoomControl: true
      },
      children: markers.map(renderMarkers)
    })
  });
};

/* harmony default export */ var Map = (Maps);
// EXTERNAL MODULE: ./components/contact-us/OfficesList/OfficesList.module.scss
var OfficesList_module = __webpack_require__(98098);
var OfficesList_module_default = /*#__PURE__*/__webpack_require__.n(OfficesList_module);
;// CONCATENATED MODULE: ./components/contact-us/OfficesList/OfficesList.js


/* eslint-disable no-console */

/* eslint-disable no-undef */












var Shop = function Shop(_ref) {
  var _data$working_hours, _data$working_hours2;

  var data = _ref.data,
      _ref$setTab = _ref.setTab,
      setTab = _ref$setTab === void 0 ? function () {
    return null;
  } : _ref$setTab,
      _ref$getCustomerLocat = _ref.getCustomerLocation,
      getCustomerLocation = _ref$getCustomerLocat === void 0 ? function () {
    return null;
  } : _ref$getCustomerLocat;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var setLink = function setLink() {
    setTab('map');
    getCustomerLocation(data);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((OfficesList_module_default()).item, " grid-extend"),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [!!data && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OfficesList_module_default()).col,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (OfficesList_module_default()).label,
        children: data === null || data === void 0 ? void 0 : data.type_name_of_office
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((OfficesList_module_default()).value, " grid-extend"),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (OfficesList_module_default()).title,
          children: data === null || data === void 0 ? void 0 : data.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: data === null || data === void 0 ? void 0 : data.description
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (OfficesList_module_default()).col,
      children: (data === null || data === void 0 ? void 0 : (_data$working_hours = data.working_hours) === null || _data$working_hours === void 0 ? void 0 : _data$working_hours.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (OfficesList_module_default()).label,
          children: t('common:workingHours')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((OfficesList_module_default()).value, " grid-extend"),
          children: data === null || data === void 0 ? void 0 : (_data$working_hours2 = data.working_hours) === null || _data$working_hours2 === void 0 ? void 0 : _data$working_hours2.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "".concat((OfficesList_module_default()).hours, " grid-extend"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: [item === null || item === void 0 ? void 0 : item.days, (item === null || item === void 0 ? void 0 : item.working_hours) && ':']
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: item === null || item === void 0 ? void 0 : item.working_hours
              })]
            }, index);
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (OfficesList_module_default()).col,
      children: (data === null || data === void 0 ? void 0 : data.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (OfficesList_module_default()).label,
          children: t('common:email')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((OfficesList_module_default()).value, " grid-extend"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: data.email
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (OfficesList_module_default()).col,
      children: (data === null || data === void 0 ? void 0 : data.phone_number) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (OfficesList_module_default()).label,
          children: t('common:phone')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((OfficesList_module_default()).value, " grid-extend"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: data === null || data === void 0 ? void 0 : data.phone_number
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (OfficesList_module_default()).col,
      children: (data === null || data === void 0 ? void 0 : data.lat) && (data === null || data === void 0 ? void 0 : data.lng) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
        onClick: setLink,
        className: "".concat((OfficesList_module_default()).link, " flex-c-c"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* OutlineLocation */._t, {})
      })
    })]
  });
};

var OfficesList = function OfficesList(_ref2) {
  var _data$our_offices, _classNames;

  var data = _ref2.data;

  var _useState = (0,react.useState)('map'),
      tab = _useState[0],
      setTab = _useState[1];

  var _useState2 = (0,react.useState)((_data$our_offices = data === null || data === void 0 ? void 0 : data.our_offices) !== null && _data$our_offices !== void 0 ? _data$our_offices : []),
      offices = _useState2[0],
      setOffices = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      customerLocation = _useState3[0],
      setCustomerLocation = _useState3[1];

  var getCustomerLocation = function getCustomerLocation(location) {
    setCustomerLocation({
      lat: location === null || location === void 0 ? void 0 : location.lat,
      lng: location === null || location === void 0 ? void 0 : location.lng
    });
  };

  var onFilterChange = function onFilterChange(_ref3) {
    var _data$our_offices2;

    var city = _ref3.city,
        officeType = _ref3.officeType;
    var filtered = ((_data$our_offices2 = data === null || data === void 0 ? void 0 : data.our_offices) !== null && _data$our_offices2 !== void 0 ? _data$our_offices2 : []).filter(function (office) {
      var matchesCity = (city === null || city === void 0 ? void 0 : city.value) === 'all' || String(office === null || office === void 0 ? void 0 : office.city_id) === String(city === null || city === void 0 ? void 0 : city.value);
      var matchesOfficeType = (officeType === null || officeType === void 0 ? void 0 : officeType.value) === 0 || String(office === null || office === void 0 ? void 0 : office.office_type.id) === String(officeType === null || officeType === void 0 ? void 0 : officeType.value);
      return matchesCity && matchesOfficeType;
    });
    setOffices(filtered);
  };

  return !!data && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (OfficesList_module_default()).wrap,
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Filters_Filters, {
      cities: data === null || data === void 0 ? void 0 : data.cities,
      offices: data === null || data === void 0 ? void 0 : data.office_types,
      tab: tab,
      setTab: setTab,
      className: classnames_default()((_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (OfficesList_module_default()).filterWrap, tab === 'list'), (0,defineProperty/* default */.Z)(_classNames, (OfficesList_module_default()).filterWrapMap, tab === 'map'), _classNames)),
      onFilterChange: onFilterChange
    }), tab === 'map' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Map, {
        markers: offices,
        customerLocation: customerLocation
      })
    }), tab === 'list' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((OfficesList_module_default()).listWrap, " wrapper section"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (OfficesList_module_default()).list,
          children: offices === null || offices === void 0 ? void 0 : offices.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Shop, {
              data: item,
              setTab: setTab,
              getCustomerLocation: getCustomerLocation
            }, index);
          })
        })
      })
    })]
  });
};

/* harmony default export */ var OfficesList_OfficesList = (OfficesList);
;// CONCATENATED MODULE: ./components/contact-us/index.js


/***/ }),

/***/ 57683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62049);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24052);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84838);
/* harmony import */ var _FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9870);
/* harmony import */ var _FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);


/* eslint-disable react-hooks/exhaustive-deps */










var RecognationInfoModal = function RecognationInfoModal(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      handleNext = _ref.handleNext,
      className = _ref.className,
      classNameInner = _ref.classNameInner,
      _ref$isEsim = _ref.isEsim,
      isEsim = _ref$isEsim === void 0 ? true : _ref$isEsim;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrap), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().open), active), className]),
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().faceInfoInner), classNameInner]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().faceInfoContent),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().close),
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .CloseMobile */ .Rt, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h5", {
            className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
            children: t('esim:recognitionInfo.title')
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().legal_text_box),
            dangerouslySetInnerHTML: {
              __html: t('esim:recognitionInfo.rule')
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("p", {
            className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().description),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
              className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text_red),
              children: t('esim:recognitionInfo.first')
            }), t('esim:recognitionInfo.second')]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
            className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().list),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
              children: t('esim:recognitionInfo.rules.first')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
              children: t('esim:recognitionInfo.rules.second')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
              children: t('esim:recognitionInfo.rules.third')
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btn_groups),
          children: [isEsim ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
            href: '/contact-us',
            onClick: function onClick() {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'activatestore'
              });
            },
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
              target: "_blank",
              className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().actiivate_store_btn),
              title: t('esim:recognitionInfo.activation'),
              "aria-label": t('esim:recognitionInfo.activation'),
              children: t('esim:recognitionInfo.activation')
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_ui_index__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
            variant: "normal",
            children: [' ', t('esim:recognitionInfo.startFace')]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
            onClick: isEsim ? handleNext : function () {
              return setActive(false);
            },
            variant: isEsim ? 'normal' : 'transparent',
            className: (_FaceRecognationInfo_module_scss__WEBPACK_IMPORTED_MODULE_7___default().btn),
            children: isEsim ? t('esim:recognitionInfo.startFace') : 'Cancel'
          })]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RecognationInfoModal);

/***/ }),

/***/ 9483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24052);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84838);
/* harmony import */ var _PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60018);
/* harmony import */ var _PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);


/* eslint-disable react-hooks/exhaustive-deps */










var PinModal = function PinModal(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      className = _ref.className,
      classNameInner = _ref.classNameInner;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrap), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().open), active), className]),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pinInner), classNameInner]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pinContent),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h5", {
          className: (_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
          children: t('esim:checkout.modals.pinModal.whatIsPin')
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: (_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().description),
          children: t('esim:checkout.modals.pinModal.pinDescription')
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: (_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().flexed_imgs),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("figure", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("figcaption", {
              children: [' ', t('esim:checkout.modals.pinModal.idCard')]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
              src: "/assets/esim/oldpin.png",
              alt: t('esim:checkout.modals.pinModal.idCard'),
              title: t('esim:checkout.modals.pinModal.idCard'),
              loading: "lazy",
              width: 163,
              height: 62
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("figure", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("figcaption", {
              children: t('esim:checkout.modals.pinModal.newIdCard')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
              src: "/assets/esim/newpin.png",
              alt: t('esim:checkout.modals.pinModal.idCard'),
              title: t('esim:checkout.modals.pinModal.idCard'),
              loading: "lazy",
              width: 163,
              height: 62
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().close),
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .CloseMobile */ .Rt, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
          onClick: function onClick() {
            return setActive(false);
          },
          className: (_PinModal_module_scss__WEBPACK_IMPORTED_MODULE_7___default().close_btn),
          variant: "outline",
          children: t('esim:checkout.actions.close')
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PinModal);

/***/ }),

/***/ 41050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24052);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84838);
/* harmony import */ var _SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75958);
/* harmony import */ var _SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);


/* eslint-disable react-hooks/exhaustive-deps */










var SalesError = function SalesError(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      className = _ref.className,
      classNameInner = _ref.classNameInner;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrap), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().open), active), className]),
    itemScope: true,
    itemType: "https://schema.org/Alret",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pinInner), classNameInner]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pinContent),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
          src: "/assets/warning.png",
          className: (_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon_img),
          alt: t('esim:common.errorTitle'),
          title: t('esim:common.errorTitle'),
          loading: "lazy",
          width: 64,
          height: 64
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h5", {
          className: (_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("center", {
            children: t('esim:common.errorTitle')
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: (_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().description),
          dangerouslySetInnerHTML: {
            __html: t('esim:sales.error')
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().close),
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .CloseMobile */ .Rt, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
          onClick: function onClick() {
            return setActive(false);
          },
          className: (_SalesError_module_scss__WEBPACK_IMPORTED_MODULE_7___default().close_btn),
          variant: "outline",
          children: t('esim:checkout.actions.close')
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SalesError);

/***/ }),

/***/ 31480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var react_qr_code__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57381);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57611);





var QrBlock = function QrBlock(_ref) {
  var _ref$qrCode = _ref.qrCode,
      qrCode = _ref$qrCode === void 0 ? '' : _ref$qrCode,
      qrRef = _ref.qrRef,
      size = _ref.size;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      ref: qrRef,
      itemScope: true,
      itemType: "https://schema.org/Offer",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_qr_code__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        id: "QRCodeScaled",
        size: size || 100,
        value: qrCode
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (QrBlock);

/***/ }),

/***/ 31444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hZ": function() { return /* reexport */ Checkout_Checkout; },
  "HR": function() { return /* reexport */ FindYourEsimFlow_FindYourEsimFlow; },
  "fB": function() { return /* reexport */ Success_Success; }
});

// UNUSED EXPORTS: EsimBanner

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(24666);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(648);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./domains/esim/order/selectors.js
var selectors = __webpack_require__(30125);
// EXTERNAL MODULE: ./domains/esim/order/index.js + 3 modules
var order = __webpack_require__(31863);
// EXTERNAL MODULE: ./hooks/index.js + 1 modules
var hooks = __webpack_require__(59748);
// EXTERNAL MODULE: ./domains/esim/stock/index.js + 3 modules
var stock = __webpack_require__(75104);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/ui/CreateOwnPhoneInput/CreateOwnPhoneInput.js
var CreateOwnPhoneInput = __webpack_require__(94033);
// EXTERNAL MODULE: ./components/esim/FindYourEsimFlow/FindYourEsimFlow.module.scss
var FindYourEsimFlow_module = __webpack_require__(24485);
var FindYourEsimFlow_module_default = /*#__PURE__*/__webpack_require__.n(FindYourEsimFlow_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/esim/FindYourEsimFlow/FindYourEsimFlow.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-unused-expressions */














var FindYourEsimFlow = function FindYourEsimFlow(_ref) {
  var _stockData$metadata, _stockData$metadata$p;

  var data = _ref.data,
      blockRef = _ref.blockRef,
      detail = _ref.detail;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      prefixes = _useState[0],
      setPrefixes = _useState[1];

  (0,react.useEffect)(function () {
    setSortValue({
      name: detail === null || detail === void 0 ? void 0 : detail.all_option_text,
      id: '0'
    });
    setPrefixes([{
      name: detail === null || detail === void 0 ? void 0 : detail.all_option_text,
      id: '0'
    }, {
      name: '055',
      id: '1'
    }, {
      name: '099',
      id: '2'
    }]);
  }, [router === null || router === void 0 ? void 0 : router.locale, detail === null || detail === void 0 ? void 0 : detail.all_option_text]);

  var _useSelector = (0,es/* useSelector */.v9)(stock/* selectors.selectStock */.wl.d),
      page = _useSelector.page;

  var _useSelector2 = (0,es/* useSelector */.v9)(selectors/* selectOrder */.z),
      customerPrefix = _useSelector2.customerPrefix,
      customerNumber = _useSelector2.customerNumber;

  var _React$useState = react.useState(prefixes[0]),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      sortValue = _React$useState2[0],
      setSortValue = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      reset = _React$useState4[0],
      setReset = _React$useState4[1];

  var _React$useState5 = react.useState(data === null || data === void 0 ? void 0 : data.tabs),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 1),
      tabs = _React$useState6[0];

  var _React$useState7 = react.useState(['', '', '', '', '', '', '']),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      value = _React$useState8[0],
      setValue = _React$useState8[1];

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState2 = (0,react.useState)([]),
      allStock = _useState2[0],
      setAllStock = _useState2[1];

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var resetFields = function resetFields() {
    setValue(['', '', '', '', '', '', '']);
    setSortValue({
      name: detail === null || detail === void 0 ? void 0 : detail.all_option_text,
      id: '0'
    });
    dispatch(stock/* actions.setPage */.Nw.setPage(0));
    dispatch(order/* actions.setCustomerNumber */.Nw.setCustomerNumber('*******'));
    setReset(true);
  };

  var _stockHooks$useGetSto = stock/* hooks.useGetStock */.PT.useGetStock({
    page: page,
    number: reset ? null : customerNumber,
    prefix: reset ? null : customerPrefix,
    size: windowsX > 600 ? 10 : 6
  }),
      stockData = _stockHooks$useGetSto.data,
      isLoading = _stockHooks$useGetSto.isLoading,
      status = _stockHooks$useGetSto.status;

  (0,react.useLayoutEffect)(function () {
    setAllStock([]);
  }, []);

  var searchEsim = function searchEsim() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'search'
    });
    dispatch(stock/* actions.setPage */.Nw.setPage(0));
    setReset(false);
  };

  (0,react.useEffect)(function () {
    var _stockData$data;

    if ((stockData === null || stockData === void 0 ? void 0 : (_stockData$data = stockData.data) === null || _stockData$data === void 0 ? void 0 : _stockData$data.length) > 0) {
      var updatedStock = stockData.data.map(function (item) {
        var msisdnStr = String((item === null || item === void 0 ? void 0 : item.msisdn) || '').trim();
        return _objectSpread(_objectSpread({}, item), {}, {
          price: msisdnStr !== null && msisdnStr !== void 0 && msisdnStr.startsWith('1') ? Number(item === null || item === void 0 ? void 0 : item.price) + 4 : item === null || item === void 0 ? void 0 : item.price
        });
      });
      setAllStock(function (prevStock) {
        if (page === 0) {
          return updatedStock;
        }

        var existingMsisdnId = new Set(prevStock === null || prevStock === void 0 ? void 0 : prevStock.map(function (item) {
          return item === null || item === void 0 ? void 0 : item.id;
        }));
        var newUniqueStock = updatedStock === null || updatedStock === void 0 ? void 0 : updatedStock.filter(function (item) {
          return !existingMsisdnId.has(item === null || item === void 0 ? void 0 : item.id);
        });
        return [].concat((0,toConsumableArray/* default */.Z)(prevStock), (0,toConsumableArray/* default */.Z)(newUniqueStock));
      });
    }
  }, [page, stockData]);

  var onReset = function onReset() {
    router.push('/');
  };

  var getPrefix = function getPrefix(e) {
    var _prefixes$, _e$name;

    setSortValue(e);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'search'
    });
    dispatch(order/* actions.setCustomerPrefix */.Nw.setCustomerPrefix((e === null || e === void 0 ? void 0 : e.name) === ((_prefixes$ = prefixes[0]) === null || _prefixes$ === void 0 ? void 0 : _prefixes$.name) ? '' : e === null || e === void 0 ? void 0 : (_e$name = e.name) === null || _e$name === void 0 ? void 0 : _e$name.slice(-2)));
  };

  if (isLoading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Loader */.aN, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper section',
    ref: blockRef,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FindYourEsimFlow_module_default()).intro,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        className: (FindYourEsimFlow_module_default()).title,
        titleModify: 'title--large',
        children: detail === null || detail === void 0 ? void 0 : detail.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: classnames_default()(['text--large', (FindYourEsimFlow_module_default()).description]),
        children: detail === null || detail === void 0 ? void 0 : detail.description
      })]
    }), stockData && /*#__PURE__*/(0,jsx_runtime.jsx)(CreateOwnPhoneInput/* default */.Z, {
      tabs: tabs,
      sortValue: sortValue,
      detail: detail,
      setSortValue: setSortValue,
      onChange: function onChange(val) {
        var _Array$from;

        setValue(val);
        dispatch(order/* actions.setCustomerNumber */.Nw.setCustomerNumber((_Array$from = Array.from(val, function (item) {
          return item || '*';
        })) === null || _Array$from === void 0 ? void 0 : _Array$from.join('')));
      },
      resetFields: resetFields,
      value: value,
      onSubmit: searchEsim,
      onReset: onReset,
      sortData: prefixes,
      data: allStock,
      loadMore: function loadMore() {
        return dispatch(stock/* actions.setPage */.Nw.setPage(page + 1));
      },
      onSelect: getPrefix,
      isLoading: status,
      totalPage: stockData === null || stockData === void 0 ? void 0 : (_stockData$metadata = stockData.metadata) === null || _stockData$metadata === void 0 ? void 0 : (_stockData$metadata$p = _stockData$metadata.pagination) === null || _stockData$metadata$p === void 0 ? void 0 : _stockData$metadata$p.total_page
    })]
  });
};

/* harmony default export */ var FindYourEsimFlow_FindYourEsimFlow = (FindYourEsimFlow);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
;// CONCATENATED MODULE: ./components/esim/EsimBanner/EsimBanner.js








var EsimBanner = function EsimBanner(_ref) {
  var data = _ref.data,
      blockRef = _ref.blockRef;

  var onClick = function onClick() {
    if (!blockRef) return;

    var _blockRef$current$get = blockRef.current.getBoundingClientRect(),
        top = _blockRef$current$get.top;

    if (nextWindowsChecker()) {
      window.scrollTo({
        top: top - 120,
        behavior: 'smooth'
      });
    }
  };

  return /*#__PURE__*/_jsx(InternetBanner, {
    bannerData: data,
    itemScope: true,
    itemType: "https://schema.org/WPAdBlock",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(Button, {
        onClick: onClick,
        className: styles.button,
        variant: 'white',
        children: ["Get eSIM", /*#__PURE__*/_jsx(Arrow, {
          width: 24
        })]
      })
    })
  });
};

/* harmony default export */ var EsimBanner_EsimBanner = ((/* unused pure expression or super */ null && (EsimBanner)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(53431);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./enums/globals.ts
var globals = __webpack_require__(48038);
// EXTERNAL MODULE: ./domains/esim/product/index.js + 1 modules
var product = __webpack_require__(70134);
// EXTERNAL MODULE: ./constants/base.js + 1 modules
var base = __webpack_require__(58165);
// EXTERNAL MODULE: ./components/ui/GoBack/GoBack.js
var GoBack = __webpack_require__(88717);
// EXTERNAL MODULE: ./components/ui/CompatibleDevicesModal/CompatibleDevicesModal.js + 1 modules
var CompatibleDevicesModal = __webpack_require__(54810);
// EXTERNAL MODULE: ./enums/modal.ts
var modal = __webpack_require__(83136);
;// CONCATENATED MODULE: ./utils/getMobileOS.js
var getMobileOperatingSystem = function getMobileOperatingSystem() {
  if (true) {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera; // Windows Phone must come first because its UA also contains "Android"

    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/huawei/i.test(userAgent)) {
      return 'https://appgallery.huawei.com/app/C102156391';
    }

    if (/android/i.test(userAgent)) {
      return 'https://play.google.com/store/apps/details?id=az.kapitalbank.mbanking&hl=az&gl=US&pli=1';
    } // iOS detection from: http://stackoverflow.com/a/9039885/177710


    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'https://apps.apple.com/us/app/birbank/id1293207342';
    }

    return '';
  }
};
;// CONCATENATED MODULE: ./constants/esim.js

var salesStepLabels = ['personal', 'tariffs', 'activation'];
var swapStepSales = ['personal', 'activation'];
var cardDatas = function cardDatas(t) {
  return {
    title: t('esim:cards.title'),
    cards: [{
      id: 0,
      content: [{
        text: 'MilliÖn',
        url: 'https://million.az/attributes/Bakcell'
      }, {
        text: 'eMANAT',
        url: 'https://mpay.az/payments/p/9f8418ca-da26-43a6-abe9-409c42df6b72'
      }, {
        text: 'ExpressPay',
        url: 'https://expresspay.az/login'
      }],
      icon: '/assets/marker.png',
      title: t('esim:cards.terminal')
    }, {
      id: 1,
      content: [{
        text: 'hesab.az',
        url: 'https://hesab.az/unregistered/#/direct-pay/mobile/bakcell/parameters'
      }, {
        text: 'azericard.az',
        url: 'https://bakcell.3dsecure.az/'
      }],
      icon: '/assets/marker.png',
      title: t('esim:cards.platform')
    }, {
      id: 2,
      content: [{
        text: 'BirBank',
        url:  true && window.innerWidth > 600 ? 'https://payments.kapitalbank.az/attributes/information/1102' : getMobileOperatingSystem()
      }],
      icon: '/assets/marker.png',
      title: t('esim:cards.mobileApp')
    }]
  };
};
// EXTERNAL MODULE: ./utils/scrollToTop.ts
var scrollToTop = __webpack_require__(327);
// EXTERNAL MODULE: ./enums/esim.ts
var esim = __webpack_require__(24204);
;// CONCATENATED MODULE: ./hooks/useEsimFlow.js



var useEsimFlow = function useEsimFlow() {
  var _useRouter = (0,next_router.useRouter)(),
      query = _useRouter.query;

  var esimFlowType = (0,react.useMemo)(function () {
    return (query === null || query === void 0 ? void 0 : query.id) === esim/* EsimFlowType.SWAP */.kz.SWAP ? esim/* EsimFlowType.SWAP */.kz.SWAP : esim/* EsimFlowType.ESIM */.kz.ESIM;
  }, [query === null || query === void 0 ? void 0 : query.id]);
  var isSwapFlow = esimFlowType === esim/* EsimFlowType.SWAP */.kz.SWAP;
  var isEsimFlow = esimFlowType === esim/* EsimFlowType.ESIM */.kz.ESIM;
  return {
    esimFlowType: esimFlowType,
    isSwapFlow: isSwapFlow,
    isEsimFlow: isEsimFlow
  };
};
// EXTERNAL MODULE: ./utils/filterDevicesData.js
var filterDevicesData = __webpack_require__(15392);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/esim/Modals/NotInList/NotInList.module.scss
var NotInList_module = __webpack_require__(37050);
var NotInList_module_default = /*#__PURE__*/__webpack_require__.n(NotInList_module);
;// CONCATENATED MODULE: ./components/esim/Modals/NotInList/NotInList.js


/* eslint-disable react-hooks/exhaustive-deps */










var NotInList = function NotInList(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      className = _ref.className,
      classNameInner = _ref.classNameInner;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  react.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(NotInList_module_default()).wrap, (0,defineProperty/* default */.Z)({}, (NotInList_module_default()).open, active), className]),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(NotInList_module_default()).notInListInner, classNameInner]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (NotInList_module_default()).notInListContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (NotInList_module_default()).title_list,
          children: t('esim:checkout.modals.notInList.title')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (NotInList_module_default()).flexed_content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (NotInList_module_default()).content_text,
              dangerouslySetInnerHTML: {
                __html: t('esim:checkout.modals.notInList.content1')
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (NotInList_module_default()).content_text,
              dangerouslySetInnerHTML: {
                __html: t('esim:checkout.modals.notInList.content2')
              }
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/assets/esim/eid.png",
            alt: 'eid code',
            title: 'eid code',
            className: (NotInList_module_default()).eid_img,
            loading: "lazy",
            width: 177,
            height: 368
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (NotInList_module_default()).close,
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: function onClick() {
            return setActive(false);
          },
          className: (NotInList_module_default()).close_btn,
          children: t('esim:checkout.actions.close')
        })]
      })
    })
  });
};

/* harmony default export */ var NotInList_NotInList = (NotInList);
// EXTERNAL MODULE: ./components/esim/Modals/Pin/PinModal.js
var PinModal = __webpack_require__(9483);
// EXTERNAL MODULE: ./components/esim/Modals/FaceRecognationInfo/FaceRecognationInfo.js
var FaceRecognationInfo = __webpack_require__(57683);
// EXTERNAL MODULE: ./components/esim/Modals/SwapInformation/SwapInformation.module.scss
var SwapInformation_module = __webpack_require__(49757);
var SwapInformation_module_default = /*#__PURE__*/__webpack_require__.n(SwapInformation_module);
;// CONCATENATED MODULE: ./components/esim/Modals/SwapInformation/SwapInformation.js


/* eslint-disable react-hooks/exhaustive-deps */









var SwapInformation = function SwapInformation(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      className = _ref.className,
      classNameInner = _ref.classNameInner;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  react.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(SwapInformation_module_default()).wrap, (0,defineProperty/* default */.Z)({}, (SwapInformation_module_default()).open, active), className]),
    itemScope: true,
    itemType: "https://schema.org/Message",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(SwapInformation_module_default()).pinInner, classNameInner]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SwapInformation_module_default()).pinContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (SwapInformation_module_default()).title,
          children: t('esim:checkout.modals.swapInformation.dearCustomer')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (SwapInformation_module_default()).description,
          dangerouslySetInnerHTML: {
            __html: t('esim:common.acceptText')
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SwapInformation_module_default()).close,
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: function onClick() {
            return setActive(false);
          },
          className: (SwapInformation_module_default()).close_btn,
          variant: "outline",
          children: t('esim:checkout.actions.close')
        })]
      })
    })
  });
};

/* harmony default export */ var SwapInformation_SwapInformation = (SwapInformation);
// EXTERNAL MODULE: ./components/esim/Modals/SwapError/SwapError.module.scss
var SwapError_module = __webpack_require__(72868);
var SwapError_module_default = /*#__PURE__*/__webpack_require__.n(SwapError_module);
;// CONCATENATED MODULE: ./components/esim/Modals/SwapError/SwapError.js


/* eslint-disable react-hooks/exhaustive-deps */









var SwapError = function SwapError(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      className = _ref.className,
      classNameInner = _ref.classNameInner;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  react.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(SwapError_module_default()).wrap, (0,defineProperty/* default */.Z)({}, (SwapError_module_default()).open, active), className]),
    itemScope: true,
    itemType: "https://schema.org/Alret",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(SwapError_module_default()).pinInner, classNameInner]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SwapError_module_default()).pinContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (SwapError_module_default()).title,
          children: t('esim:checkout.modals.swapError.attention')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (SwapError_module_default()).description,
          dangerouslySetInnerHTML: {
            __html: t('esim:checkout.modals.swapError.error')
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SwapError_module_default()).close,
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: function onClick() {
            return setActive(false);
          },
          className: (SwapError_module_default()).close_btn,
          variant: "outline",
          children: t('esim:checkout.actions.close')
        })]
      })
    })
  });
};

/* harmony default export */ var SwapError_SwapError = (SwapError);
// EXTERNAL MODULE: ./components/esim/Modals/OtpError/OtpError.module.scss
var OtpError_module = __webpack_require__(23314);
var OtpError_module_default = /*#__PURE__*/__webpack_require__.n(OtpError_module);
;// CONCATENATED MODULE: ./components/esim/Modals/OtpError/OtpError.js


/* eslint-disable react-hooks/exhaustive-deps */










var OtpError = function OtpError(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      className = _ref.className,
      classNameInner = _ref.classNameInner;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  react.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(OtpError_module_default()).wrap, (0,defineProperty/* default */.Z)({}, (OtpError_module_default()).open, active), className]),
    itemScope: true,
    itemType: "https://schema.org/Alret",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(OtpError_module_default()).pinInner, classNameInner]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (OtpError_module_default()).pinContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/assets/error.png",
          className: (OtpError_module_default()).icon_img,
          alt: t('esim:common.errorTitle'),
          title: t('esim:common.errorTitle'),
          loading: "lazy",
          layout: "fill"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (OtpError_module_default()).title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OtpError_module_default()).description,
          dangerouslySetInnerHTML: {
            __html: t('esim:checkout.modals.otpError.content')
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (OtpError_module_default()).close,
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: function onClick() {
            return setActive(false);
          },
          className: (OtpError_module_default()).close_btn,
          variant: "outline",
          children: t('esim:checkout.actions.close')
        })]
      })
    })
  });
};

/* harmony default export */ var OtpError_OtpError = (OtpError);
// EXTERNAL MODULE: ./components/esim/Modals/NotCustomer/NotCustomer.module.scss
var NotCustomer_module = __webpack_require__(8492);
var NotCustomer_module_default = /*#__PURE__*/__webpack_require__.n(NotCustomer_module);
;// CONCATENATED MODULE: ./components/esim/Modals/NotCustomer/NotCustomer.js


/* eslint-disable react-hooks/exhaustive-deps */










var NotCustomer = function NotCustomer(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      className = _ref.className,
      classNameInner = _ref.classNameInner;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  react.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(NotCustomer_module_default()).wrap, (0,defineProperty/* default */.Z)({}, (NotCustomer_module_default()).open, active), className]),
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(NotCustomer_module_default()).pinInner, classNameInner]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (NotCustomer_module_default()).pinContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/assets/warning.png",
          className: (NotCustomer_module_default()).icon_img,
          alt: t('esim:common.notFound'),
          title: t('esim:common.notFound'),
          loading: "lazy",
          layout: "fill"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (NotCustomer_module_default()).title,
          children: t('esim:common.notFound')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (NotCustomer_module_default()).description,
          dangerouslySetInnerHTML: {
            __html: t('esim:common.notCustomer')
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (NotCustomer_module_default()).close,
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: function onClick() {
            return setActive(false);
          },
          className: (NotCustomer_module_default()).close_btn,
          variant: "outline",
          children: t('esim:checkout.actions.close')
        })]
      })
    })
  });
};

/* harmony default export */ var NotCustomer_NotCustomer = (NotCustomer);
// EXTERNAL MODULE: ./components/common/RecordModal/Sima.js + 1 modules
var Sima = __webpack_require__(91496);
// EXTERNAL MODULE: ./node_modules/jspdf/dist/jspdf.es.min.js
var jspdf_es_min = __webpack_require__(55038);
// EXTERNAL MODULE: ./node_modules/html2canvas/dist/html2canvas.js
var html2canvas = __webpack_require__(65439);
var html2canvas_default = /*#__PURE__*/__webpack_require__.n(html2canvas);
// EXTERNAL MODULE: ./components/ui/LinkNumbers/LinkNumbers.module.scss
var LinkNumbers_module = __webpack_require__(59557);
var LinkNumbers_module_default = /*#__PURE__*/__webpack_require__.n(LinkNumbers_module);
;// CONCATENATED MODULE: ./components/ui/LinkNumbers/SplitNumbers.js








var SplitNumbers = function SplitNumbers(_ref) {
  var numbers = _ref.numbers,
      isNotLink = _ref.isNotLink,
      isTel = _ref.isTel,
      className = _ref.className,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      isLight = _ref.isLight;
  var LINK_CONTAINER_CLASS = 'link-numbers';
  var LINK_ITEM_CLASS = 'link-numbers__item';

  var renderNumber = function renderNumber(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: classnames_default()([(LinkNumbers_module_default())[LINK_ITEM_CLASS], (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default()).dark, dark)]),
      itemScope: true,
      itemType: "http://schema.org/Text",
      children: item
    }, index);
  };

  if (isNotLink) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(LinkNumbers_module_default())[LINK_CONTAINER_CLASS], className, (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default())["link-numbers--light"], isLight)]),
      itemScope: true,
      itemType: "http://schema.org/Property",
      children: [(0,toConsumableArray/* default */.Z)(numbers).map(renderNumber), isTel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()([(LinkNumbers_module_default())[LINK_ITEM_CLASS], (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default()).dark, dark)]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Call */.Ig, {})
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
    href: "tel:".concat(numbers),
    className: classnames_default()([(LinkNumbers_module_default())[LINK_CONTAINER_CLASS], className, (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default())["link-numbers--light"], isLight)]),
    itemScope: true,
    itemType: "http://schema.org/Thing",
    children: [(0,toConsumableArray/* default */.Z)(numbers).map(renderNumber), isTel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: classnames_default()([(LinkNumbers_module_default())[LINK_ITEM_CLASS], (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default()).dark, dark)]),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Call */.Ig, {})
    })]
  });
};

/* harmony default export */ var LinkNumbers_SplitNumbers = (SplitNumbers);
// EXTERNAL MODULE: ./components/esim/Qr/Qr.js
var Qr = __webpack_require__(31480);
// EXTERNAL MODULE: ./components/esim/Checkout/Checkout.module.scss
var Checkout_module = __webpack_require__(12153);
var Checkout_module_default = /*#__PURE__*/__webpack_require__.n(Checkout_module);
;// CONCATENATED MODULE: ./components/esim/Checkout/InfoCard/InfoCard.js


function InfoCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function InfoCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InfoCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InfoCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var InfoCard = function InfoCard(_ref) {
  var _numberDetail$data, _numberDetail$data$ms;

  var formikMain = _ref.formikMain,
      activeTab = _ref.activeTab,
      numberDetail = _ref.numberDetail,
      goToNextStep = _ref.goToNextStep;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var qrCodeRef = (0,react.useRef)(null);

  var _useEsimFlow = useEsimFlow(),
      isSwapFlow = _useEsimFlow.isSwapFlow;

  var isSpecialMsisdn = numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data = numberDetail.data) === null || _numberDetail$data === void 0 ? void 0 : (_numberDetail$data$ms = _numberDetail$data.msisdn) === null || _numberDetail$data$ms === void 0 ? void 0 : _numberDetail$data$ms.startsWith('1');

  var _useSelector = (0,es/* useSelector */.v9)(order/* selectors.selectOrder */.wl.z),
      trackId = _useSelector.trackId,
      qrData = _useSelector.qrData,
      tariffPrice = _useSelector.tariffPrice,
      selectedPlan = _useSelector.selectedPlan,
      disabled = _useSelector.disabled;

  var getPhoneNumber = function getPhoneNumber() {
    if (isSwapFlow) {
      return "".concat(formikMain.values.phoneNumberCode.name).concat(formikMain.values.phoneNumber);
    }

    if (numberDetail !== null && numberDetail !== void 0 && numberDetail.data) {
      var phone = "0".concat(numberDetail.data.prefix).concat(numberDetail.data.msisdn);
      localStorage.setItem('tel', phone);
      return phone;
    }

    return '';
  };

  var totalAmount = function totalAmount() {
    var _numberDetail$data2;

    var numberPrice = Number(numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data2 = numberDetail.data) === null || _numberDetail$data2 === void 0 ? void 0 : _numberDetail$data2.price) || 0;
    var additionalCharge = isSpecialMsisdn ? 7 : 0;
    var planCharge = selectedPlan ? Number(tariffPrice) || 0 : 0;
    return numberPrice + additionalCharge + planCharge;
  };

  var isFinalStep = activeTab === esim/* EsimOrderStep.FINAL */.wb.FINAL || isSwapFlow && activeTab === esim/* EsimSwapStep.FINAL */.ZY.FINAL;

  var getQrCode = function getQrCode() {
    if (isSwapFlow) {
      html2canvas_default()(qrCodeRef.current).then(function (canvas) {
        var _formikMain$values, _formikMain$values$ph, _formikMain$values2;

        var imgData = canvas.toDataURL('image/png');
        var pdf = new jspdf_es_min/* default */.ZP();
        pdf.addImage('/assets/leftStar.png', 'png', 0, 0, 50, 90);
        pdf.addImage('/assets/rightStar.png', 'png', 170, 0, 40, 90);
        pdf.addImage('/assets/bottomStar.png', 'png', 0, 251, 80, 45);
        pdf.addImage('/assets/qrContact.png', 'png', 90, 275, 110, 10);
        pdf.addImage('/assets/qrLogo.png', 'png', 80, 20, 60, 12);
        pdf.addImage('/assets/qrButton.png', 'png', 63, 190, 97, 20);
        pdf.addImage(imgData, 'JPEG', 63, 80, 97, 97);
        pdf.setTextColor(255, 255, 255);
        pdf.text("".concat("".concat(formikMain === null || formikMain === void 0 ? void 0 : (_formikMain$values = formikMain.values) === null || _formikMain$values === void 0 ? void 0 : (_formikMain$values$ph = _formikMain$values.phoneNumberCode) === null || _formikMain$values$ph === void 0 ? void 0 : _formikMain$values$ph.name, " ").concat(formikMain === null || formikMain === void 0 ? void 0 : (_formikMain$values2 = formikMain.values) === null || _formikMain$values2 === void 0 ? void 0 : _formikMain$values2.phoneNumber)), 95, 202);
        pdf.setFillColor(255, 255, 255);
        pdf.save('qrCode.pdf');
      });
    } else {
      window.open("https://esim.bakcell.com/api/contract-manager/contract/download?providerId=1&trackId=".concat(trackId, "&token=").concat(qrData === null || qrData === void 0 ? void 0 : qrData.contractToken), '_blank');
    }
  };

  var handleBtnClick = function handleBtnClick() {
    (0,scrollToTop/* scrollToTop */.k)();
    goToNextStep();
  };

  var renderPriceList = function renderPriceList(numberDetail, selectedPlan, tariffPrice) {
    var _numberDetail$data3, _numberDetail$data$pr, _numberDetail$data4;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: (Checkout_module_default()).list,
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Checkout_module_default()).text,
          children: t('esim:checkout.card.esimNum')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (Checkout_module_default()).value,
          children: [isSpecialMsisdn ? Number(numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data3 = numberDetail.data) === null || _numberDetail$data3 === void 0 ? void 0 : _numberDetail$data3.price) + 7 : (_numberDetail$data$pr = numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data4 = numberDetail.data) === null || _numberDetail$data4 === void 0 ? void 0 : _numberDetail$data4.price) !== null && _numberDetail$data$pr !== void 0 ? _numberDetail$data$pr : 0, "AZN"]
        })]
      }), !!selectedPlan && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Checkout_module_default()).text,
          children: t('esim:checkout.card.tariff')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (Checkout_module_default()).value,
          children: [tariffPrice, " AZN"]
        })]
      })]
    });
  };

  var renderTotal = function renderTotal() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Checkout_module_default()).bottom,
      itemScope: true,
      itemType: "https://schema.org/Thing",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (Checkout_module_default()).totalTitle,
        children: [t('esim:checkout.card.total'), ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (Checkout_module_default()).total,
        children: [isSwapFlow ? 0 : totalAmount(), " AZN"]
      })]
    });
  };

  var renderQRDetails = function renderQRDetails(qrData) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Checkout_module_default()).qr_detail_info,
      itemScope: true,
      itemType: "https://schema.org/Thing",
      children: [(qrData === null || qrData === void 0 ? void 0 : qrData.smdp) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: (Checkout_module_default()).info,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Checkout_module_default()).text_red,
          children: "SM-DP:"
        }), " ", qrData === null || qrData === void 0 ? void 0 : qrData.smdp]
      }), (qrData === null || qrData === void 0 ? void 0 : qrData.activationCode) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: (Checkout_module_default()).info,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (Checkout_module_default()).text_red,
          children: [t('esim:common.activationCode'), ":"]
        }), qrData === null || qrData === void 0 ? void 0 : qrData.activationCode]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (Checkout_module_default()).right,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Checkout_module_default()).rightContent,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        className: (Checkout_module_default()).title,
        children: t('esim:checkout.card.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Checkout_module_default()).number,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (Checkout_module_default()).text,
          children: [t('esim:checkout.card.number'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkNumbers_SplitNumbers, {
          className: (Checkout_module_default()).value,
          numbers: getPhoneNumber(),
          isNotLink: true
        })]
      }), isFinalStep && renderQRDetails(qrData), isFinalStep && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Checkout_module_default()).qrBlock,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Checkout_module_default()).qr,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Qr/* default */.Z, InfoCard_objectSpread({
            qrRef: qrCodeRef
          }, qrData))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Checkout_module_default()).text,
          children: t('esim:common.content')
        })]
      }), isFinalStep ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
          variant: "white",
          className: (Checkout_module_default()).download_qr_btn,
          onClick: getQrCode,
          children: [isSwapFlow ? t('esim:common.donwloadQrCode') : t('esim:common.downloadContract'), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/assets/download.png",
            width: 20,
            height: 20,
            alt: t('esim:common.downloadContract'),
            title: t('esim:common.downloadContract'),
            className: (Checkout_module_default()).icon,
            loading: "lazy"
          })]
        }), renderPriceList(numberDetail, selectedPlan, tariffPrice), renderTotal(), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Checkout_module_default()).banner,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* InfoCircleRed */.Eo, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (Checkout_module_default()).bannerText,
            children: t('esim:checkout.card.attention')
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [renderPriceList(numberDetail, selectedPlan, tariffPrice), renderTotal(), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
          type: "submit",
          disabled: !formikMain.isValid || !formikMain.dirty || disabled || !formikMain.values.terms,
          className: (Checkout_module_default()).nextStep,
          onClick: handleBtnClick,
          children: [t('esim:checkout.actions.continue'), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
            width: 24
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var InfoCard_InfoCard = (InfoCard);
// EXTERNAL MODULE: ./components/esim/Modals/SalesError/SalesError.js
var SalesError = __webpack_require__(41050);
// EXTERNAL MODULE: ./components/SvgComponents/social/light/index.js + 3 modules
var light = __webpack_require__(46077);
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./components/ui/ActiveLink/ActiveLink.js
var ActiveLink = __webpack_require__(10411);
// EXTERNAL MODULE: ./components/ui/TariffCardLight/styles.module.scss
var styles_module = __webpack_require__(98458);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/ui/TariffCardLight/TariffCardLight.js











var TariffCardLight = function TariffCardLight(_ref) {
  var _item$tariff_addition, _item$tariff_addition2, _item$tariff_addition3, _item$tariff_addition4, _item$tariff_addition5, _item$tariff_addition6, _item$tariff_addition7;

  var item = _ref.item,
      onClick = _ref.onClick,
      className = _ref.className;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var isMultiSocial = item === null || item === void 0 ? void 0 : (_item$tariff_addition = item.tariff_additional_info) === null || _item$tariff_addition === void 0 ? void 0 : (_item$tariff_addition2 = _item$tariff_addition.map(function (item) {
    return item.key;
  })) === null || _item$tariff_addition2 === void 0 ? void 0 : _item$tariff_addition2.includes('Instagram');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    onClick: onClick,
    className: classnames_default()([(styles_module_default()).card, className]),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (styles_module_default()).top,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
          className: (styles_module_default()).title,
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ActiveLink/* default */.Z, {
          href: item === null || item === void 0 ? void 0 : item.url,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            target: "_blank",
            className: (styles_module_default()).link,
            title: t('esim:common.details'),
            "aria-label": t('esim:common.details'),
            children: [t('esim:common.details'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
              width: 20
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (styles_module_default()).price,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (styles_module_default()).value,
          children: [item === null || item === void 0 ? void 0 : item.price, " AZN"]
        }), " /", t('esim:common.monthly')]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (styles_module_default()).content,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: (styles_module_default()).list,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [" ", item === null || item === void 0 ? void 0 : (_item$tariff_addition3 = item.tariff_additional_info[0]) === null || _item$tariff_addition3 === void 0 ? void 0 : _item$tariff_addition3.key]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (styles_module_default()).value,
            children: item === null || item === void 0 ? void 0 : (_item$tariff_addition4 = item.tariff_additional_info[0]) === null || _item$tariff_addition4 === void 0 ? void 0 : _item$tariff_addition4.value
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [" ", item === null || item === void 0 ? void 0 : (_item$tariff_addition5 = item.tariff_additional_info[1]) === null || _item$tariff_addition5 === void 0 ? void 0 : _item$tariff_addition5.key]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (styles_module_default()).value,
            children: item === null || item === void 0 ? void 0 : (_item$tariff_addition6 = item.tariff_additional_info[1]) === null || _item$tariff_addition6 === void 0 ? void 0 : _item$tariff_addition6.value
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (styles_module_default()).icons,
            children: isMultiSocial ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(light/* Whatsapp */.CD, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(light/* Facebook */.s1, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(light/* Instagram */.mr, {})]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(light/* Whatsapp */.CD, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (styles_module_default()).value,
            children: item === null || item === void 0 ? void 0 : (_item$tariff_addition7 = item.tariff_additional_info[2]) === null || _item$tariff_addition7 === void 0 ? void 0 : _item$tariff_addition7.value
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var TariffCardLight_TariffCardLight = (TariffCardLight);
;// CONCATENATED MODULE: ./components/esim/Checkout/Tariffs/Tariff.js













var EsimTariffs = function EsimTariffs(_ref) {
  var data = _ref.data;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(0),
      activeTabPlan = _useState[0],
      setActiveTabPlan = _useState[1];

  var _useState2 = (0,react.useState)(0),
      activePlan = _useState2[0],
      setActivePlan = _useState2[1];

  var tabList = [{
    label: t('esim:common.all'),
    data: Object.values(data || {}).flat()
  }].concat((0,toConsumableArray/* default */.Z)(Object.keys(data || {}).map(function (key) {
    return {
      label: key.charAt(0).toUpperCase() + key.slice(1),
      data: data[key]
    };
  })));

  var cardClickHandler = function cardClickHandler(item) {
    setActivePlan(item === null || item === void 0 ? void 0 : item.offer_id);
    dispatch(order/* actions.setSelectedPlan */.Nw.setSelectedPlan(item === null || item === void 0 ? void 0 : item.offer_id));
    localStorage.setItem('planID', item === null || item === void 0 ? void 0 : item.offer_id);
    dispatch(order/* actions.setTariffPrice */.Nw.setTariffPrice(item === null || item === void 0 ? void 0 : item.price));
    dispatch(order/* actions.setDisabled */.Nw.setDisabled(false));
  };

  var renderPlan = function renderPlan(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(TariffCardLight_TariffCardLight, {
      onClick: function onClick() {
        return cardClickHandler(item);
      },
      item: item,
      className: classnames_default()([(0,defineProperty/* default */.Z)({}, (Checkout_module_default()).activePlan, (item === null || item === void 0 ? void 0 : item.offer_id) === activePlan)]),
      itemScope: true,
      itemType: "https://schema.org/Product"
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Tabs */.mQ, {
    active: activeTabPlan,
    itemScope: true,
    itemType: "https://schema.org/OfferCatalog",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabPanel */.x4, {
      className: (Checkout_module_default()).planTabPanel,
      children: tabList.map(function (tab, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Tab */.OK, {
          onClick: function onClick() {
            return setActiveTabPlan(index);
          },
          children: tab.label
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabContent */.I5, {
      children: tabList === null || tabList === void 0 ? void 0 : tabList.map(function (tab, index) {
        var _tab$data;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabContentItem */.Wp, {
          className: (Checkout_module_default()).grid,
          index: index,
          children: tab === null || tab === void 0 ? void 0 : (_tab$data = tab.data) === null || _tab$data === void 0 ? void 0 : _tab$data.map(renderPlan)
        }, index);
      })
    })]
  });
};

/* harmony default export */ var Tariff = (EsimTariffs);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(48740);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(97043);
// EXTERNAL MODULE: ./components/ui/CheckboxWithTitle/CheckboxWithTitle.js
var CheckboxWithTitle = __webpack_require__(17974);
;// CONCATENATED MODULE: ./components/esim/ConditionCheck/ConditionCheck.js





var ConditionCheck = function ConditionCheck(_ref) {
  var onChange = _ref.onChange,
      checked = _ref.checked;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxWithTitle/* default */.Z, {
    reverse: true,
    onChange: onChange,
    checked: checked,
    itemScope: true,
    itemType: "https://schema.org/CheckAction",
    children: t('esim:common.termsAndConditions')
  });
};

/* harmony default export */ var ConditionCheck_ConditionCheck = (ConditionCheck);
;// CONCATENATED MODULE: ./components/esim/Checkout/PersonalInfo/PersonalInfo.js












var PersonalInfo = function PersonalInfo(_ref) {
  var formik = _ref.formik,
      stateHandlers = _ref.stateHandlers;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var captchaRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(Date.now()),
      captchaKey = _useState[0],
      setCaptchaKey = _useState[1];

  var setDeviceModal = stateHandlers.setDeviceModal,
      setNotInListModal = stateHandlers.setNotInListModal,
      setPinModal = stateHandlers.setPinModal,
      onChange = stateHandlers.onChange,
      setTermsModal = stateHandlers.setTermsModal;

  var handleCountryCode = function handleCountryCode(value) {
    var _formik$values$county;

    var maxLength = ((_formik$values$county = formik.values.countyCode) === null || _formik$values$county === void 0 ? void 0 : _formik$values$county.name) === base/* serialPrefixes.0.name */.x$[0].name ? 9 : 8;

    if ((value === null || value === void 0 ? void 0 : value.length) < maxLength) {
      formik.setFieldValue('countyCodeValue', value);
    }
  };

  (0,react.useEffect)(function () {
    setCaptchaKey(Date.now());
    captchaRef.current.reset();
  }, [lang]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    className: "".concat((Checkout_module_default()).tabContent, " ").concat((Checkout_module_default()).info),
    onSubmit: formik.handleSubmit,
    itemScope: true,
    itemType: "https://schema.org/Action",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
        readOnly: true,
        onBlur: function onBlur() {
          formik.handleBlur('phoneField');
        },
        error: formik.touched.phoneField && formik.errors.phoneField,
        onClick: setDeviceModal,
        value: formik.values.phoneField,
        label: t('esim:checkout.inputs.mobile'),
        placeholder: t('esim:checkout.inputs.chooseMobile')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Checkout_module_default()).selectError,
        onClick: setNotInListModal,
        children: t('esim:checkout.inputs.doesNotDevice')
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InputWithSelect */.em, {
        onBlur: formik.handleBlur('phoneNumber'),
        type: "tel",
        error: formik.touched.phoneNumber && formik.errors.phoneNumber,
        selected: formik.values.phoneNumberCode.name,
        label: t('esim:checkout.inputs.phoneNumber'),
        placeholder: 'XXX XX XX',
        mask: '999 99 99',
        options: base/* customerPrefixes */.xF,
        value: formik.values.phoneNumber,
        onChange: function onChange(value) {
          return formik.setFieldValue('phoneNumber', value);
        },
        onSelect: function onSelect(value) {
          return formik.setFieldValue('phoneNumberCode', value);
        },
        className: (Checkout_module_default()).customSelect
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InputWithSelect */.em, {
      onBlur: formik.handleBlur('countyCodeValue'),
      error: formik.touched.countyCodeValue && formik.errors.countyCodeValue,
      selected: formik.values.countyCode.name,
      label: t('esim:checkout.inputs.seriaLabel'),
      placeholder: '',
      options: base/* serialPrefixes */.x$,
      value: formik.values.countyCodeValue,
      onChange: handleCountryCode,
      onSelect: function onSelect(value) {
        return formik.setFieldValue('countyCode', value);
      },
      type: "number",
      className: (Checkout_module_default()).customSelect
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
      onBlur: formik.handleBlur('pin'),
      error: formik.touched.pin && formik.errors.pin,
      type: "onlyNumbersLetters",
      onChange: function onChange(value) {
        return formik.setFieldValue('pin', value === null || value === void 0 ? void 0 : value.toUpperCase());
      },
      value: formik.values.pin,
      label: t('esim:checkout.inputs.finNumber'),
      placeholder: t('esim:checkout.inputs.addFin'),
      iconClass: (Checkout_module_default()).pin_input,
      IconRight: SvgComponents/* InfoCircleRed */.Eo,
      onClickRightIcon: setPinModal,
      maxLength: 7
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
      name: "g-recaptcha-response",
      sitekey: constants/* envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY */.ie.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default',
      onChange: onChange,
      hl: lang,
      ref: captchaRef
    }, captchaKey), /*#__PURE__*/(0,jsx_runtime.jsx)(ConditionCheck_ConditionCheck, {
      onChange: setTermsModal,
      checked: formik.values.terms,
      formik: formik
    })]
  });
};

/* harmony default export */ var PersonalInfo_PersonalInfo = (PersonalInfo);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(99956);
;// CONCATENATED MODULE: ./components/esim/Modals/OTP/OtpEsim.js













var OtpEsim = function OtpEsim(_ref) {
  var _formikPhone$values, _formikMain$values$ph;

  var modalProps = _ref.modalProps,
      formikProps = _ref.formikProps,
      otpProps = _ref.otpProps,
      handleApprove = _ref.handleApprove;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var active = modalProps.active,
      _setActive = modalProps.setActive;
  var formikMain = formikProps.formikMain,
      formikPhone = formikProps.formikPhone;
  var timer = otpProps.timer,
      finish = otpProps.finish,
      setFinish = otpProps.setFinish,
      wrongOtp = otpProps.wrongOtp,
      expired = otpProps.expired;

  var _useSelector = (0,es/* useSelector */.v9)(order/* selectors.selectOrder */.wl.z),
      disabled = _useSelector.disabled;

  var Completionist = function Completionist() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: "00:00"
    });
  };

  var renderer = (0,react.useCallback)(function (_ref2) {
    var minutes = _ref2.minutes,
        seconds = _ref2.seconds,
        completed = _ref2.completed;

    if (completed) {
      setFinish(true);
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Completionist, {});
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [(0,index_es/* zeroPad */.Bu)(minutes), ":", (0,index_es/* zeroPad */.Bu)(seconds)]
    });
  }, []);
  var Counter = (0,react.useCallback)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.ZP, {
      date: timer,
      renderer: renderer
    });
  }, [renderer, timer]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Modal */.u_, {
    active: active,
    setActive: function setActive() {
      _setActive(!active);

      dispatch(order/* actions.setDisabled */.Nw.setDisabled(!disabled));
    },
    itemScope: true,
    itemType: "https://schema.org/Property",
    closeOnOutsideClick: false,
    children: !(formikPhone !== null && formikPhone !== void 0 && (_formikPhone$values = formikPhone.values) !== null && _formikPhone$values !== void 0 && _formikPhone$values.error) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        className: 'title',
        children: t('esim:common.otp')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Checkout_module_default()).modalPanel,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "+994 (".concat((_formikMain$values$ph = formikMain.values.phoneNumberCode.name) === null || _formikMain$values$ph === void 0 ? void 0 : _formikMain$values$ph.slice(-2), ") ").concat(formikMain.values.phoneNumber)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        className: (Checkout_module_default()).optInputContainer,
        onSubmit: formikPhone.handleSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* OwnPhoneInput */.qG, {
          inputClass: (Checkout_module_default()).optInput,
          value: formikPhone.values.code,
          separationPoints: [],
          className: (Checkout_module_default()).opt,
          placeholder: '',
          onChange: function onChange(value) {
            return formikPhone.setFieldValue('code', value);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Checkout_module_default()).text,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: classnames_default()({
              disabled_otp_wrapper: !finish
            }),
            children: [t('esim:checkout.inputs.receiveOtp'), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: classnames_default()((Checkout_module_default()).resend, {
                'active-otp': finish,
                'disabled-otp': !finish
              }),
              onClick: handleApprove,
              children: t('esim:checkout.actions.resend')
            })]
          }), active && /*#__PURE__*/(0,jsx_runtime.jsx)(Counter, {})]
        }), wrongOtp && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (Checkout_module_default()).wrong_otp,
          children: [" ", t('esim:common.wrongOtp')]
        }), expired && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (Checkout_module_default()).wrong_otp,
          children: [" ", t('esim:common.attempt')]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
          type: 'submit',
          disabled: !(formikPhone.isValid && formikPhone.dirty),
          className: (Checkout_module_default()).button,
          children: [t('esim:checkout.actions.continue'), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
            width: 24
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var OTP_OtpEsim = (OtpEsim);
;// CONCATENATED MODULE: ./components/esim/Checkout/Checkout.js





function Checkout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Checkout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Checkout_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Checkout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







































var Checkout = function Checkout(_ref) {
  var _router$query, _numberDetail$data2, _numberDetail$data2$m, _ref5;

  var esimBannerData = _ref.esimBannerData;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.order;
  }),
      activeSima = _useSelector.activeSima,
      selectedPlan = _useSelector.selectedPlan,
      disabled = _useSelector.disabled,
      tariffPrice = _useSelector.tariffPrice;

  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();
  var id = router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.id;

  var _useEsimFlow = useEsimFlow(),
      isSwapFlow = _useEsimFlow.isSwapFlow;

  var cardsData = cardDatas(t);
  var result = esimBannerData === null || esimBannerData === void 0 ? void 0 : esimBannerData.filter(function (obj) {
    return obj.type === 'volte_banner';
  });
  var FormSchema = yup_es/* object */.Ry().shape({
    phoneNumber: yup_es/* string */.Z_().min(7, t('esim:checkout.inputs.lengthPhone')).required(t('esim:common.required')),
    phoneField: yup_es/* string */.Z_().required(t('esim:common.required')),
    countyCodeValue: yup_es/* string */.Z_().required(t('esim:common.required')),
    pin: yup_es/* string */.Z_().required(t('esim:common.required')),
    captcha: yup_es/* string */.Z_().required(t('esim:common.required')),
    terms: yup_es/* string */.Z_().required(t('esim:common.required'))
  });
  var FormSchemaForOTP = yup_es/* object */.Ry().shape({
    code: yup_es/* array */.IX().of(yup_es/* string */.Z_().required())
  });

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeTab = _React$useState2[0],
      _setActiveTab = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      isModalActive = _React$useState4[0],
      setIsModalActive = _React$useState4[1];

  var _React$useState5 = react.useState(null),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      trackId = _React$useState6[0],
      setTrackId = _React$useState6[1];

  var _React$useState7 = react.useState(false),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      termsModal = _React$useState8[0],
      setTermsModal = _React$useState8[1];

  var _React$useState9 = react.useState(false),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      notInListModal = _React$useState10[0],
      setNotInListModal = _React$useState10[1];

  var _React$useState11 = react.useState(false),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      pinModal = _React$useState12[0],
      setPinModal = _React$useState12[1];

  var _React$useState13 = react.useState(false),
      _React$useState14 = (0,slicedToArray/* default */.Z)(_React$useState13, 2),
      deviceModal = _React$useState14[0],
      setDeviceModal = _React$useState14[1];

  var _React$useState15 = react.useState(''),
      _React$useState16 = (0,slicedToArray/* default */.Z)(_React$useState15, 2),
      deviceItem = _React$useState16[0],
      setDeviceItem = _React$useState16[1];

  var _React$useState17 = react.useState(false),
      _React$useState18 = (0,slicedToArray/* default */.Z)(_React$useState17, 2),
      isError = _React$useState18[0],
      setError = _React$useState18[1];

  var _React$useState19 = react.useState(t('esim:common.errorTitle')),
      _React$useState20 = (0,slicedToArray/* default */.Z)(_React$useState19, 2),
      errorText = _React$useState20[0],
      setErrorText = _React$useState20[1];

  var _React$useState21 = react.useState(false),
      _React$useState22 = (0,slicedToArray/* default */.Z)(_React$useState21, 2),
      recognationInfo = _React$useState22[0],
      setRecognationInfo = _React$useState22[1];

  var _React$useState23 = react.useState(false),
      _React$useState24 = (0,slicedToArray/* default */.Z)(_React$useState23, 2),
      swapError = _React$useState24[0],
      setSwapError = _React$useState24[1];

  var _React$useState25 = react.useState(false),
      _React$useState26 = (0,slicedToArray/* default */.Z)(_React$useState25, 2),
      otpAttempt = _React$useState26[0],
      setOtpAttempt = _React$useState26[1];

  var _React$useState27 = react.useState(false),
      _React$useState28 = (0,slicedToArray/* default */.Z)(_React$useState27, 2),
      wrongOtp = _React$useState28[0],
      setWrongOtp = _React$useState28[1];

  var _React$useState29 = react.useState(false),
      _React$useState30 = (0,slicedToArray/* default */.Z)(_React$useState29, 2),
      expired = _React$useState30[0],
      setExpired = _React$useState30[1];

  var _React$useState31 = react.useState(true),
      _React$useState32 = (0,slicedToArray/* default */.Z)(_React$useState31, 2),
      accept = _React$useState32[0],
      setAccept = _React$useState32[1];

  var _React$useState33 = react.useState(false),
      _React$useState34 = (0,slicedToArray/* default */.Z)(_React$useState33, 2),
      notCustomer = _React$useState34[0],
      setNotCustomer = _React$useState34[1];

  var interval = 120000;

  var _React$useState35 = react.useState(),
      _React$useState36 = (0,slicedToArray/* default */.Z)(_React$useState35, 2),
      timer = _React$useState36[0],
      setTimer = _React$useState36[1];

  var _React$useState37 = react.useState(false),
      _React$useState38 = (0,slicedToArray/* default */.Z)(_React$useState37, 2),
      finish = _React$useState38[0],
      setFinish = _React$useState38[1];

  var _React$useState39 = react.useState(false),
      _React$useState40 = (0,slicedToArray/* default */.Z)(_React$useState39, 2),
      salesError = _React$useState40[0],
      setSalesError = _React$useState40[1];

  var _React$useState41 = react.useState(false),
      _React$useState42 = (0,slicedToArray/* default */.Z)(_React$useState41, 2),
      reserved = _React$useState42[0],
      setReserved = _React$useState42[1];

  var _React$useState43 = react.useState(''),
      _React$useState44 = (0,slicedToArray/* default */.Z)(_React$useState43, 2),
      errorTextSima = _React$useState44[0],
      setErrorTextSima = _React$useState44[1];

  var _React$useState45 = react.useState({
    isOpen: false,
    type: null
  }),
      _React$useState46 = (0,slicedToArray/* default */.Z)(_React$useState45, 2),
      modalProps = _React$useState46[0],
      setModalProps = _React$useState46[1];

  var closeModal = function closeModal() {
    setModalProps({
      isOpen: false,
      type: null
    });
  };

  (0,react.useEffect)(function () {
    (0,scrollToTop/* scrollToTop */.k)();
  }, []);
  (0,react.useEffect)(function () {
    var sessionAccept = sessionStorage.getItem('accept');

    if (sessionAccept) {
      setAccept(false);
    }
  }, []);
  (0,react.useEffect)(function () {
    dispatch(order/* actions.setDisabled */.Nw.setDisabled(activeTab === 1 && !selectedPlan));
  }, [activeTab, selectedPlan]);

  var onChange = function onChange(value) {
    formikMain.setFieldValue('captcha', value);
  };

  var getDeviceItem = function getDeviceItem(item) {
    setDeviceItem(item);
    formikMain.setFieldValue('phoneField', item);
    setDeviceModal(!deviceModal);
  };

  var _orderHooks$useGetCus = order/* hooks.useGetCustomerContract */.PT.useGetCustomerContract({
    lang: lang
  }),
      contractData = _orderHooks$useGetCus.data;

  var _stockHooks$useGetNum = stock/* hooks.useGetNumberDetails */.PT.useGetNumberDetails(id, {
    skip: isSwapFlow
  }),
      numberDetail = _stockHooks$useGetNum.data;

  var totalAmount = function totalAmount() {
    var _numberDetail$data;

    var numberPrice = Number(numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data = numberDetail.data) === null || _numberDetail$data === void 0 ? void 0 : _numberDetail$data.price) || 0;
    var additionalCharge = isSpecialMsisdn ? 4 : 0;
    var planCharge = selectedPlan ? Number(tariffPrice) || 0 : 0;
    return numberPrice + additionalCharge + planCharge;
  };

  var _orderHooks$useCheckC = order/* hooks.useCheckCustomer */.PT.useCheckCustomer(),
      _orderHooks$useCheckC2 = (0,slicedToArray/* default */.Z)(_orderHooks$useCheckC, 2),
      checkMutation = _orderHooks$useCheckC2[0],
      checkLoading = _orderHooks$useCheckC2[1].isLoading;

  var _orderHooks$useVerify = order/* hooks.useVerifyCustomer */.PT.useVerifyCustomer({
    fixedCacheKey: 'Order'
  }),
      _orderHooks$useVerify2 = (0,slicedToArray/* default */.Z)(_orderHooks$useVerify, 2),
      verifyMutation = _orderHooks$useVerify2[0],
      isLoading = _orderHooks$useVerify2[1].isLoading;

  var _orderHooks$useSwap = order/* hooks.useSwap */.PT.useSwap(),
      _orderHooks$useSwap2 = (0,slicedToArray/* default */.Z)(_orderHooks$useSwap, 2),
      swapMutation = _orderHooks$useSwap2[0],
      swapLoading = _orderHooks$useSwap2[1].isLoading;

  var _orderHooks$useSima = order/* hooks.useSima */.PT.useSima(),
      _orderHooks$useSima2 = (0,slicedToArray/* default */.Z)(_orderHooks$useSima, 2),
      simaMutation = _orderHooks$useSima2[0],
      simaLoading = _orderHooks$useSima2[1].isLoading;

  var _productHooks$useGetP = product/* hooks.useGetProducts */.P.useGetProducts(lang),
      tariffData = _productHooks$useGetP.data;

  var _orderHooks$useGetDev = order/* hooks.useGetDeviceList */.PT.useGetDeviceList(''),
      deviceData = _orderHooks$useGetDev.data;

  var fullDevices = (0,filterDevicesData/* processDeviceData */.e)(deviceData, t);

  var _orderHooks$usePaymen = order/* hooks.usePaymentRequest */.PT.usePaymentRequest(),
      _orderHooks$usePaymen2 = (0,slicedToArray/* default */.Z)(_orderHooks$usePaymen, 1),
      paymentTrigger = _orderHooks$usePaymen2[0];

  var isSpecialMsisdn = numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data2 = numberDetail.data) === null || _numberDetail$data2 === void 0 ? void 0 : (_numberDetail$data2$m = _numberDetail$data2.msisdn) === null || _numberDetail$data2$m === void 0 ? void 0 : _numberDetail$data2$m.startsWith('1');

  if (true) {
    var _numberDetail$data3, _numberDetail$data4;

    localStorage.setItem('tel', "0".concat(numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data3 = numberDetail.data) === null || _numberDetail$data3 === void 0 ? void 0 : _numberDetail$data3.prefix).concat(numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data4 = numberDetail.data) === null || _numberDetail$data4 === void 0 ? void 0 : _numberDetail$data4.msisdn));
  }

  var formikMain = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      phoneField: deviceItem,
      phoneNumberCode: base/* customerPrefixes.0 */.xF[0],
      phoneNumber: '',
      countyCode: base/* serialPrefixes.1 */.x$[1],
      countyCodeValue: '',
      pin: '',
      terms: false
    },
    validationSchema: FormSchema,
    onSubmit: function onSubmit(values) {
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _router$query2, _values$countyCode, _values$phoneNumberCo, _numberDetail$data5, _numberDetail$data6, _numberDetail$data7;

        var checkUserData, _response$data, _response$data2, _response$data3, _response$data4, response;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                checkUserData = {
                  msisdnId: isSwapFlow ? null : router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.id,
                  deviceId: deviceItem,
                  msisdn: '',
                  pinCode: values === null || values === void 0 ? void 0 : values.pin,
                  serialNumber: (values === null || values === void 0 ? void 0 : (_values$countyCode = values.countyCode) === null || _values$countyCode === void 0 ? void 0 : _values$countyCode.name) + (values === null || values === void 0 ? void 0 : values.countyCodeValue),
                  contactNumber: (values === null || values === void 0 ? void 0 : (_values$phoneNumberCo = values.phoneNumberCode) === null || _values$phoneNumberCo === void 0 ? void 0 : _values$phoneNumberCo.name) + (values === null || values === void 0 ? void 0 : values.phoneNumber),
                  transactionType: isSwapFlow ? 'EXISTING_NUMBER_SWAP' : 'SALE_NEW_NUMBER'
                };
                dispatch(order/* actions.setFormData */.Nw.setFormData(Checkout_objectSpread(Checkout_objectSpread({}, values), {}, {
                  selectedNumber: (numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data5 = numberDetail.data) === null || _numberDetail$data5 === void 0 ? void 0 : _numberDetail$data5.prefix) + (numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data6 = numberDetail.data) === null || _numberDetail$data6 === void 0 ? void 0 : _numberDetail$data6.msisdn)
                })));
                dispatch(order/* actions.setInterestedNumberPrefix */.Nw.setInterestedNumberPrefix(numberDetail === null || numberDetail === void 0 ? void 0 : (_numberDetail$data7 = numberDetail.data) === null || _numberDetail$data7 === void 0 ? void 0 : _numberDetail$data7.prefix));
                _context.prev = 3;
                _context.next = 6;
                return checkMutation(checkUserData).unwrap();

              case 6:
                response = _context.sent;
                dispatch(order/* actions.setTrackId */.Nw.setTrackId(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.trackId));
                setTrackId(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.trackId);
                localStorage.setItem('esimTID', response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.trackId);

                if (response !== null && response !== void 0 && (_response$data4 = response.data) !== null && _response$data4 !== void 0 && _response$data4.customerExist) {
                  setIsModalActive(true);
                } else setRecognationInfo(!recognationInfo);

                _context.next = 20;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);

                if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.code) === 142) {
                  setErrorText(t('esim:common.reserved'));
                  setReserved(!reserved);
                  setError(!isError);
                }

                if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.code) === 207) {
                  setNotCustomer(!notCustomer);
                }

                if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.code) === 205) {
                  setOtpAttempt(!otpAttempt);
                }

                if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.code) === 151) {
                  setErrorText(t('esim:common.userNotFound'));
                  setError(true);
                }

                if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.code) === 400) {
                  setErrorText(t('esim:common.userNotFound'));
                  setError(true);
                }

              case 20:
                _context.prev = 20;
                dispatch(order/* actions.setDisabled */.Nw.setDisabled(!disabled));
                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 13, 20, 23]]);
      }))();
    }
  });
  react.useEffect(function () {
    formikMain.validateForm();
  }, [lang]);
  var formikPhone = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      error: false,
      confirmedPhone: false,
      code: ['', '', '', '', '', '']
    },
    validationSchema: FormSchemaForOTP,
    onSubmit: function onSubmit(values, _ref2) {
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _formikMain$values, _formikMain$values$ph, _formikMain$values2, _values$code;

        var setFieldValue, verifyUserData;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setFieldValue = _ref2.setFieldValue;
                setExpired(false);
                verifyUserData = {
                  mobileNumber: (formikMain === null || formikMain === void 0 ? void 0 : (_formikMain$values = formikMain.values) === null || _formikMain$values === void 0 ? void 0 : (_formikMain$values$ph = _formikMain$values.phoneNumberCode) === null || _formikMain$values$ph === void 0 ? void 0 : _formikMain$values$ph.name) + (formikMain === null || formikMain === void 0 ? void 0 : (_formikMain$values2 = formikMain.values) === null || _formikMain$values2 === void 0 ? void 0 : _formikMain$values2.phoneNumber),
                  otp: values === null || values === void 0 ? void 0 : (_values$code = values.code) === null || _values$code === void 0 ? void 0 : _values$code.join(''),
                  trackId: trackId
                };
                _context2.next = 5;
                return verifyMutation(verifyUserData).unwrap().then(function () {
                  setIsModalActive(false);

                  _setActiveTab(1);
                })["catch"](function (err) {
                  if ((err === null || err === void 0 ? void 0 : err.code) === 151) {
                    setErrorText(t('esim:common.errorTitle'));
                    setError(!isError);
                  }

                  if ((err === null || err === void 0 ? void 0 : err.code) === 204) {
                    setExpired(true);
                    setTimer(null);
                    setFinish(true);
                  }

                  if ((err === null || err === void 0 ? void 0 : err.code) === 205) {
                    setOtpAttempt(!otpAttempt);
                    setIsModalActive(false);
                  }

                  if ((err === null || err === void 0 ? void 0 : err.code) === 206) {
                    formikPhone.resetForm();
                    setWrongOtp(!wrongOtp);
                    setFinish(true);
                    setTimer(null);
                  }
                });

              case 5:
                if (isSwapFlow) {
                  swapMutation({
                    trackId: trackId
                  }).unwrap().then(function (res) {
                    dispatch(order/* actions.setQrData */.Nw.setQrData(res === null || res === void 0 ? void 0 : res.data));

                    _setActiveTab(1);

                    setIsModalActive(false);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'purchase'
                    });
                  })["catch"](function (error) {
                    var _error$data, _error$data2;

                    if ((error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.code) === 156) {
                      setSwapError(true);
                      setWrongOtp(true);
                    }

                    if ((error === null || error === void 0 ? void 0 : (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.code) === 154) {
                      setWrongOtp(true);
                    } else setSalesError(true);
                  });
                }

                setFieldValue('confirmedPhone', true);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  });

  var goToNextStep = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var _yield$paymentTrigger, url;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(order/* actions.setDisabled */.Nw.setDisabled(true));
              formikPhone.resetForm();
              setTimer(Date.now() + interval);
              _context3.t0 = activeTab;
              _context3.next = _context3.t0 === 0 ? 6 : _context3.t0 === 1 ? 10 : 21;
              break;

            case 6:
              formikMain.handleSubmit();
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'nextstep'
              });
              return _context3.abrupt("break", 22);

            case 10:
              _context3.prev = 10;
              _context3.next = 13;
              return paymentTrigger({
                amount: totalAmount(),
                redirectUrl: globals/* RedirectUrls.ESIM_PAYMENT_REDIRECT */.O.ESIM_PAYMENT_REDIRECT,
                receiver: "994".concat(formikMain.values.phoneNumberCode.name.replace(/^0+/, '')).concat(formikMain.values.phoneNumber)
              }).unwrap();

            case 13:
              _yield$paymentTrigger = _context3.sent;
              url = _yield$paymentTrigger.url;
              router.replace(url);
              _context3.next = 20;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t1 = _context3["catch"](10);

            case 20:
              return _context3.abrupt("break", 22);

            case 21:
              _setActiveTab(0);

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[10, 18]]);
    }));

    return function goToNextStep() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleApprove = function handleApprove() {
    formikPhone.resetForm();
    setTimer(Date.now() + interval);
    formikMain.handleSubmit();
    setFinish(false);
    setWrongOtp(false);
    setExpired(false);
  };

  var stateHandlers = {
    setDeviceModal: setDeviceModal,
    setNotInListModal: setNotInListModal,
    setPinModal: setPinModal,
    onChange: onChange,
    setTermsModal: setTermsModal
  };

  if (isLoading || swapLoading || checkLoading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Loader */.aN, {
      fullScreen: true
    });
  }

  var handleCheck = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(image) {
      var formData, res;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              formData = new FormData();
              formData.append('imageFile', image);
              _context4.prev = 2;
              _context4.next = 5;
              return simaMutation({
                trackId: trackId,
                formData: formData
              }).unwrap();

            case 5:
              res = _context4.sent;

              if ((res === null || res === void 0 ? void 0 : res.code) === 200) {
                dispatch(order/* actions.setActiveSima */.Nw.setActiveSima(false));
                setModalProps({
                  isOpen: true,
                  type: modal/* EModalType.SUCCESS */.y.SUCCESS
                });
              }

              _context4.next = 14;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](2);
              dispatch(order/* actions.setActiveSima */.Nw.setActiveSima(false));
              setModalProps({
                isOpen: true,
                type: modal/* EModalType.ERROR */.y.ERROR
              });

              if ((_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.code) === 153) {
                setErrorTextSima(t('esim:common.expiredTransaction'));
              }

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 9]]);
    }));

    return function handleCheck(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var swapHandler = function swapHandler() {
    setAccept(function (accept) {
      return !accept;
    });
    sessionStorage.setItem('accept', accept);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper checkout',
    itemScope: true,
    itemType: "https://schema.org/Order",
    children: [isModalActive && /*#__PURE__*/(0,jsx_runtime.jsx)(OTP_OtpEsim, {
      modalProps: {
        active: isModalActive,
        setActive: setIsModalActive
      },
      formikProps: {
        formikMain: formikMain,
        formikPhone: formikPhone
      },
      otpProps: {
        timer: timer,
        finish: finish,
        setFinish: setFinish,
        wrongOtp: wrongOtp,
        expired: expired
      },
      handleApprove: handleApprove
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(GoBack/* default */.Z, {
      children: t('esim:checkout.previousPage')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Checkout_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Checkout_module_default()).left,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
          titleModify: 'title--medium',
          className: (Checkout_module_default()).title,
          children: isSwapFlow ? t('esim:common.swap') : t('esim:checkout.title')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Tabs */.mQ, {
          active: activeTab,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabPanel */.x4, {
            children: (_ref5 = isSwapFlow ? swapStepSales : salesStepLabels) === null || _ref5 === void 0 ? void 0 : _ref5.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Tab */.OK, {
                className: classnames_default()([(Checkout_module_default()).tab, (0,defineProperty/* default */.Z)({}, (Checkout_module_default()).done, activeTab === ++index || activeTab > index)]),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (Checkout_module_default()).tabIndex,
                  children: index
                }), t("esim:checkout.steps.".concat(item))]
              }, index);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* TabContent */.I5, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* TabContentItem */.Wp, {
              className: classnames_default()((0,defineProperty/* default */.Z)({}, (Checkout_module_default()).tabContentItem, activeTab === 0)),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PersonalInfo_PersonalInfo, {
                formik: formikMain,
                stateHandlers: stateHandlers
              }), isSwapFlow && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (Checkout_module_default()).banner,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* InfoCircleRed */.Eo, {})
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (Checkout_module_default()).bannerText,
                  dangerouslySetInnerHTML: {
                    __html: isSwapFlow ? t('esim:checkout.modals.swapInformation.info') + t('esim:checkout.modals.swapInformation.additionalInfo') : t('esim:checkout.modals.swapInformation.info')
                  }
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* TabContentItem */.Wp, {
              children: [isSwapFlow && cardsData && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CardBlock */.qp, {
                className: (Checkout_module_default()).cards,
                linkClassName: true,
                titleClassName: (Checkout_module_default()).cardsTitle,
                data: cardsData,
                gridValue: "2",
                titleIcon: null,
                icon: '/assets/bkc.png'
              }), tariffData && !isSwapFlow && /*#__PURE__*/(0,jsx_runtime.jsx)(Tariff, {
                data: tariffData
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabContentItem */.Wp, {
              children: cardsData && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CardBlock */.qp, {
                className: (Checkout_module_default()).cards,
                titleClassName: (Checkout_module_default()).cardsTitle,
                data: cardsData,
                gridValue: "2",
                titleIcon: null,
                icon: '/assets/bkc.png'
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InfoCard_InfoCard, {
        formikMain: formikMain,
        activeTab: activeTab,
        numberDetail: numberDetail,
        goToNextStep: goToNextStep
      })]
    }), (activeTab === 2 || activeTab === 1 && isSwapFlow) && (result === null || result === void 0 ? void 0 : result.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* StepsBannerWithTabsVolte */.HE, {
      className: "section wrapper",
      data: result[0]
    }), termsModal && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Terms */.Fe, {
      setActive: setTermsModal,
      formik: formikMain,
      active: termsModal,
      data: contractData
    }), notInListModal && /*#__PURE__*/(0,jsx_runtime.jsx)(NotInList_NotInList, {
      active: notInListModal,
      setActive: function setActive() {
        return setNotInListModal(!notInListModal);
      }
    }), pinModal && /*#__PURE__*/(0,jsx_runtime.jsx)(PinModal/* default */.Z, {
      active: pinModal,
      setActive: function setActive() {
        return setPinModal(!pinModal);
      }
    }), (deviceData === null || deviceData === void 0 ? void 0 : deviceData.data) && deviceModal && /*#__PURE__*/(0,jsx_runtime.jsx)(CompatibleDevicesModal/* default */.Z, {
      active: deviceModal,
      setActive: setDeviceModal,
      devices: fullDevices,
      choose: true,
      getItem: getDeviceItem
    }), isError && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      icon: "/assets/error.png",
      active: isError,
      setActive: function setActive() {
        setError(!isError);

        if (reserved) {
          router.replace('/esim');
          setReserved(!reserved);
        }
      },
      children: errorText
    }), recognationInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(FaceRecognationInfo/* default */.Z, {
      active: recognationInfo,
      setActive: function setActive() {
        setRecognationInfo(!recognationInfo);
        dispatch(order/* actions.setDisabled */.Nw.setDisabled(!disabled));
      },
      handleNext: function handleNext() {
        dispatch(order/* actions.setActiveSima */.Nw.setActiveSima(true));
        setRecognationInfo(!recognationInfo);
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Sima/* default */.Z, {
      active: activeSima,
      setActiveTab: function setActiveTab() {
        _setActiveTab(1);
      },
      handleCheck: handleCheck,
      isLoading: simaLoading,
      errorText: errorTextSima,
      modalProps: modalProps,
      closeModal: closeModal,
      path: '/esim'
    }), accept && /*#__PURE__*/(0,jsx_runtime.jsx)(SwapInformation_SwapInformation, {
      active: accept,
      setActive: swapHandler
    }), swapError && /*#__PURE__*/(0,jsx_runtime.jsx)(SwapError_SwapError, {
      active: swapError,
      setActive: function setActive() {
        return setSwapError(!swapError);
      }
    }), otpAttempt && /*#__PURE__*/(0,jsx_runtime.jsx)(OtpError_OtpError, {
      active: otpAttempt,
      setActive: function setActive() {
        return setOtpAttempt(!otpAttempt);
      }
    }), salesError && /*#__PURE__*/(0,jsx_runtime.jsx)(SalesError/* default */.Z, {
      active: salesError,
      setActive: function setActive() {
        return setSalesError(!salesError);
      }
    }), notCustomer && /*#__PURE__*/(0,jsx_runtime.jsx)(NotCustomer_NotCustomer, {
      active: notCustomer,
      setActive: function setActive() {
        setNotCustomer(!notCustomer);
      }
    })]
  });
};

/* harmony default export */ var Checkout_Checkout = (Checkout);
// EXTERNAL MODULE: ./components/SvgComponents/Note.js
var Note = __webpack_require__(43637);
// EXTERNAL MODULE: ./components/common/index.js + 33 modules
var common = __webpack_require__(51633);
// EXTERNAL MODULE: ./components/esim/Success/Success.module.scss
var Success_module = __webpack_require__(31692);
var Success_module_default = /*#__PURE__*/__webpack_require__.n(Success_module);
;// CONCATENATED MODULE: ./components/esim/Success/Success.js








var Success = function Success(_ref) {
  var _data$newsSlider, _data$newsSlider2, _data$newsSlider3, _data$newsSlider4, _data$newsSlider4$lis;

  var data = _ref.data;
  var content = {
    title: 'Success.<br />Thank you for the order',
    text: 'We are working 5 days a week from</br> 9 a.m. to 7 p.m. and will call you back</br> at the first opportunity soon'
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Success_module_default()).container,
    itemScope: true,
    itemType: "https://schema.org/Message",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: 'wrapper',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InformationBlock */.fW, {
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* SuccessTick */.ar, {}),
        content: content
      })
    }), !!(data !== null && data !== void 0 && data.newsSlider) && /*#__PURE__*/(0,jsx_runtime.jsx)(common/* SliderContainer */._v, {
      title: data === null || data === void 0 ? void 0 : (_data$newsSlider = data.newsSlider) === null || _data$newsSlider === void 0 ? void 0 : _data$newsSlider.title,
      linkText: data === null || data === void 0 ? void 0 : (_data$newsSlider2 = data.newsSlider) === null || _data$newsSlider2 === void 0 ? void 0 : _data$newsSlider2.linkText,
      link: data === null || data === void 0 ? void 0 : (_data$newsSlider3 = data.newsSlider) === null || _data$newsSlider3 === void 0 ? void 0 : _data$newsSlider3.link,
      icon: Note/* default */.Z,
      options: data === null || data === void 0 ? void 0 : data.sliderOptions2,
      addClass: (Success_module_default()).newsSlider,
      children: data === null || data === void 0 ? void 0 : (_data$newsSlider4 = data.newsSlider) === null || _data$newsSlider4 === void 0 ? void 0 : (_data$newsSlider4$lis = _data$newsSlider4.list) === null || _data$newsSlider4$lis === void 0 ? void 0 : _data$newsSlider4$lis.map(function (item, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(common/* NewsItem */.ns, {
          data: item
        }, key);
      })
    })]
  });
};

/* harmony default export */ var Success_Success = (Success);
;// CONCATENATED MODULE: ./components/esim/index.js





/***/ }),

/***/ 87776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ FindYourNumberFlow_FindYourNumberFlow; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(14730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
;// CONCATENATED MODULE: ./constants/sortValuesBeautifulPhone.js
var sortValuesBeautifulPhone = function sortValuesBeautifulPhone() {
  return [{
    name: 'All',
    id: '0'
  }, {
    name: '055',
    id: '1'
  }, {
    name: '099',
    id: '2'
  }];
};

/* harmony default export */ var constants_sortValuesBeautifulPhone = (sortValuesBeautifulPhone);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/ui/CreateOwnPhoneInput/CreateOwnPhoneInput.js
var CreateOwnPhoneInput = __webpack_require__(94033);
// EXTERNAL MODULE: ./components/find-your-number/FindYourNumberFlow/FindYourNumberFlow.module.scss
var FindYourNumberFlow_module = __webpack_require__(65151);
var FindYourNumberFlow_module_default = /*#__PURE__*/__webpack_require__.n(FindYourNumberFlow_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/find-your-number/FindYourNumberFlow/FindYourNumberFlow.js


var _excluded = ["title", "description"];








var sortValuesData = constants_sortValuesBeautifulPhone();

var FindYourNumberFlow = function FindYourNumberFlow(_ref) {
  var data = _ref.data;

  var _data$title = data.title,
      title = _data$title === void 0 ? '' : _data$title,
      _data$description = data.description,
      description = _data$description === void 0 ? '' : _data$description,
      rest = (0,objectWithoutProperties/* default */.Z)(data, _excluded);

  var router = (0,next_router.useRouter)();

  var _React$useState = react.useState(['All', 'Bronze']),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 1),
      tabs = _React$useState2[0];

  var _React$useState3 = react.useState(['', '', '', '', '', '', '']),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      value = _React$useState4[0],
      onChange = _React$useState4[1];

  var _React$useState5 = react.useState(sortValuesData[0]),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      sortValue = _React$useState6[0],
      setSortValue = _React$useState6[1]; // React.useEffect(() => {
  //   if (router.isReady) {
  //     if (router.query?.value) onChange(router.query.value);
  //     if (router.query?.sort)
  //       setSortValue(
  //         sortValuesData.find((item) => item.id === router.query.sort),
  //       );
  //   }
  // }, [router.isReady, router.query.sort, router.query.value]);


  var onLoadMore = function onLoadMore() {// router.push({
    //   pathname: router.pathname,
    //   query: {
    //     ...router.query,
    //     value,
    //     sort: sortValue.id,
    //   },
    // });
  };

  var onSubmit = function onSubmit() {// router.push({
    //   pathname: router.pathname,
    //   query: {
    //     ...router.query,
    //     value,
    //     sort: sortValue.id,
    //   },
    // });
  };

  var onReset = function onReset() {
    router.push('/beautiful-number');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper little-margin',
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FindYourNumberFlow_module_default()).intro,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        className: (FindYourNumberFlow_module_default()).title,
        titleModify: 'title--large',
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: 'text--large',
        children: description
      })]
    }), tabs && /*#__PURE__*/(0,jsx_runtime.jsx)(CreateOwnPhoneInput/* default */.Z, {
      titles: rest,
      onLoadMore: onLoadMore,
      tabs: tabs,
      sortValue: sortValue,
      setSortValue: setSortValue,
      onChange: onChange,
      value: value,
      onSubmit: onSubmit,
      onReset: onReset,
      sortData: sortValuesData
    })]
  });
};

/* harmony default export */ var FindYourNumberFlow_FindYourNumberFlow = (FindYourNumberFlow);
;// CONCATENATED MODULE: ./components/find-your-number/index.js


/***/ }),

/***/ 21459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98431);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4556);
/* harmony import */ var _ui_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(440);
/* harmony import */ var _icons_ArrowLeftNew__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6302);
/* harmony import */ var _icons_ArrowRightNew__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63344);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5662);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);













var AppBanner = function AppBanner(_ref) {
  var _item$sections2;

  var item = _ref.item;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(item === null || item === void 0 ? void 0 : item.sections[0]),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(0),
      _React$useState4 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState3, 2),
      activeIndex = _React$useState4[0],
      setActiveIndex = _React$useState4[1];

  var _React$useState5 = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      _React$useState6 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState5, 2),
      isImageLoaded = _React$useState6[0],
      setIsImageLoaded = _React$useState6[1];

  var nextHandler = function nextHandler() {
    var _item$sections;

    if (activeIndex !== (item === null || item === void 0 ? void 0 : (_item$sections = item.sections) === null || _item$sections === void 0 ? void 0 : _item$sections.length) - 1) {
      setIsImageLoaded(false);
      setActiveIndex(activeIndex + 1);
      setActiveTab(item === null || item === void 0 ? void 0 : item.sections[activeIndex + 1]);
    }
  };

  var prevHandler = function prevHandler() {
    if (activeIndex !== 0) {
      setIsImageLoaded(false);
      setActiveIndex(activeIndex - 1);
      setActiveTab(item === null || item === void 0 ? void 0 : item.sections[activeIndex - 1]);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setActiveTab(item === null || item === void 0 ? void 0 : item.sections[0]);
    setActiveIndex(0);
  }, [item]);

  var handleEventAction = function handleEventAction() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'bakcell_app'
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
    className: 'section',
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().container),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().top),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            width: 80,
            height: 80,
            src: "/assets/NewAppLogo.svg",
            alt: "photo"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().subTitle),
          children: item === null || item === void 0 ? void 0 : item.description
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
          dangerouslySetInnerHTML: {
            __html: item === null || item === void 0 ? void 0 : item.title
          }
        }), (item === null || item === void 0 ? void 0 : item.button_slug) && (item === null || item === void 0 ? void 0 : item.button_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ui_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          href: item === null || item === void 0 ? void 0 : item.button_slug,
          size: "shortTrapezoid",
          variant: "trapezoidRed",
          Component: 'router',
          onClick: handleEventAction,
          "data-testid": "app-download-btn",
          children: item === null || item === void 0 ? void 0 : item.button_text
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().bottom)),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().bottomWrapper), " wrapper"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().hidden)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().imageWrapper),
            children: !!activeTab && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
              children: [!isImageLoaded && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                width: 275,
                height: 560,
                style: {
                  position: 'absolute',
                  zIndex: 1
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: activeTab === null || activeTab === void 0 ? void 0 : activeTab.image,
                alt: "bakcell",
                width: 275,
                height: 560,
                "data-testid": 'appbanner-image',
                onLoadingComplete: function onLoadingComplete() {
                  setIsImageLoaded(true);
                },
                style: {
                  visibility: isImageLoaded ? 'visible' : 'hidden'
                }
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slider),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("span", {
              children: [" ", activeTab === null || activeTab === void 0 ? void 0 : activeTab.title]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
              children: activeTab === null || activeTab === void 0 ? void 0 : activeTab.description
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().buttons),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().buttonWrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                  onClick: function onClick() {
                    return prevHandler();
                  },
                  className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().previous),
                  "data-testid": 'appbanner-prev',
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_ArrowLeftNew__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                  "data-testid": 'appbanner-next',
                  onClick: function onClick() {
                    return nextHandler();
                  },
                  className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().next),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_ArrowRightNew__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().query),
                children: [activeIndex + 1, " of ", item === null || item === void 0 ? void 0 : (_item$sections2 = item.sections) === null || _item$sections2 === void 0 ? void 0 : _item$sections2.length]
              })]
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AppBanner);

/***/ }),

/***/ 36896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98431);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33770);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67597);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61395);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4556);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16814);
/* harmony import */ var _ui_Button_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(440);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24052);
/* harmony import */ var _ui_Qr_Qr__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37499);
/* harmony import */ var _ui_BusinessContactForm_ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50838);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84838);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79809);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57611);



var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var DinamicModal = function DinamicModal(_ref) {
  var className = _ref.className,
      props = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_ref, _excluded);

  var Component = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23303))["catch"](function () {
      return '';
    });
  }, {
    ssr: false,
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(23303)];
      }
    }
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(Component, _objectSpread({
    className: className
  }, props));
};

var Banner = function Banner(_ref2) {
  var _item$name, _ref5, _item$button_slug;

  var item = _ref2.item,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'red_banner' : _ref2$type,
      onClick = _ref2.onClick,
      buttonText = _ref2.buttonText,
      buttonHide = _ref2.buttonHide,
      dangerTitle = _ref2.dangerTitle,
      _ref2$titlePosition = _ref2.titlePosition,
      titlePosition = _ref2$titlePosition === void 0 ? 'left' : _ref2$titlePosition,
      isBusiness = _ref2.isBusiness;

  var _useWindowSize = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(),
      _useWindowSize2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_useWindowSize, 1),
      width = _useWindowSize2[0];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      modalActive = _useState[0],
      setModalActive = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      showSuccess = _useState2[0],
      setShowSuccess = _useState2[1];

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isImageLoaded = _useState3[0],
      setIsImageLoaded = _useState3[1];

  var closeModal = function closeModal() {
    setModalActive(false);
  };

  var showSuccessModal = function showSuccessModal() {
    closeModal();
    setShowSuccess(true);
  };

  var nameOrTitle = (_item$name = item === null || item === void 0 ? void 0 : item.name) !== null && _item$name !== void 0 ? _item$name : item === null || item === void 0 ? void 0 : item.title;

  var renderTitleComponent = function () {
    if (dangerTitle) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("h3", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().left), titlePosition === 'left')]),
        dangerouslySetInnerHTML: {
          __html: nameOrTitle
        },
        itemScope: true,
        itemType: "https://schema.org/Title"
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("h3", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().center), titlePosition === 'center')]),
      children: nameOrTitle
    });
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", _objectSpread(_objectSpread({}, ((item === null || item === void 0 ? void 0 : item.type) === 'image_banner' || type === 'image_banner') && width > 768 && {
      style: {
        backgroundImage: "url(\"".concat(item === null || item === void 0 ? void 0 : item.image, "\")")
      }
    }), {}, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().banner), (_ref5 = {}, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().red), type === 'red'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().redBanner), type === 'red_banner'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().white), type === 'white'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().black), type === 'black'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().dark), type === 'dark'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().gray), type === 'gray_banner'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().app), type === 'app'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().imaged), type === 'image_banner'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref5, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().isBusiness), isBusiness), _ref5)]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().top),
          children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
            src: item.icon,
            width: 80,
            height: 80,
            alt: item === null || item === void 0 ? void 0 : item.top_text,
            title: item === null || item === void 0 ? void 0 : item.top_text
          }), (item === null || item === void 0 ? void 0 : item.top_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("span", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().text),
            children: item.top_text
          })]
        }), width <= 768 && type === 'image_banner' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().imageContainer),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
            src: item === null || item === void 0 ? void 0 : item.image,
            alt: item === null || item === void 0 ? void 0 : item.title,
            title: item === null || item === void 0 ? void 0 : item.title,
            loading: "lazy",
            layout: "fill"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().title),
          children: renderTitleComponent
        }), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().text),
          dangerouslySetInnerHTML: {
            __html: item.description
          }
        }), (item === null || item === void 0 ? void 0 : item.qrBlock) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().qrblock),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ui_Qr_Qr__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            data: item.qrBlock
          })
        }), (item === null || item === void 0 ? void 0 : item.qr_image) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().qrblock),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ui_Qr_Qr__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            data: {
              qr: item.qr_image,
              links: item.links
            }
          })
        }), !buttonHide && (item === null || item === void 0 ? void 0 : item.button_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_ui_Button_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          href: (_item$button_slug = item === null || item === void 0 ? void 0 : item.button_slug) !== null && _item$button_slug !== void 0 ? _item$button_slug : item === null || item === void 0 ? void 0 : item.external_link,
          Component: item !== null && item !== void 0 && item.button_slug ? 'router' : 'button',
          onClick: (item === null || item === void 0 ? void 0 : item.action_type) === 'pop-up' ? function () {
            return setModalActive(true);
          } : onClick,
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().button),
          "data-testid": 'iot-services',
          children: [buttonText !== null && buttonText !== void 0 ? buttonText : item === null || item === void 0 ? void 0 : item.button_text, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().iconWrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_8__/* .ArrowRight */ .ol, {
              width: 20,
              height: 20
            })
          })]
        })]
      }), ((item === null || item === void 0 ? void 0 : item.type) === 'black_banner' || (item === null || item === void 0 ? void 0 : item.type) === 'gray_banner' || (item === null || item === void 0 ? void 0 : item.type) === 'red_banner' || type === 'white' || type === 'dark' || type === 'app' || type !== 'image_banner') && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().imageContainer),
        children: [!isImageLoaded && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().skeleton),
          containerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_15___default().skeletonWrapper),
          style: {
            position: 'absolute',
            zIndex: 1
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
          src: item === null || item === void 0 ? void 0 : item.image,
          alt: item === null || item === void 0 ? void 0 : item.title,
          title: item === null || item === void 0 ? void 0 : item.title,
          loading: "lazy",
          layout: "fill",
          onLoadingComplete: function onLoadingComplete() {
            return setIsImageLoaded(true);
          },
          style: {
            visibility: isImageLoaded ? 'visible' : 'hidden'
          }
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(DinamicModal, {
        active: modalActive,
        setActive: closeModal,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ui_BusinessContactForm_ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          showSuccess: showSuccessModal
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_11__/* .InformationModal */ .UI, {
        type: 'dark',
        active: showSuccess,
        onClose: function onClose() {
          return setShowSuccess(false);
        },
        description: t('common:successText')
      })]
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Banner);

/***/ }),

/***/ 65620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98431);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33770);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4556);
/* harmony import */ var _constants_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17501);
/* harmony import */ var _domains_view__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97201);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24052);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84838);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83596);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57611);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable eqeqeq */












var SliderModule = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 46338));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46338)];
    }
  }
});

var BookNumber = function BookNumber(_ref) {
  var _tabs$levels, _levels$;

  var tabs = _ref.tabs;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var levels = tabs === null || tabs === void 0 ? void 0 : (_tabs$levels = tabs.levels) === null || _tabs$levels === void 0 ? void 0 : _tabs$levels.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.levelId) != 11;
  });

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(0),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_React$useState, 2),
      currentTab = _React$useState2[0],
      setCurrentTab = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_1__.useState((_levels$ = levels[0]) === null || _levels$ === void 0 ? void 0 : _levels$.levelId),
      _React$useState4 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_React$useState3, 2),
      levelId = _React$useState4[0],
      setLevelId = _React$useState4[1];

  var _React$useState5 = react__WEBPACK_IMPORTED_MODULE_1__.useState([]),
      _React$useState6 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_React$useState5, 2),
      numberList = _React$useState6[0],
      setNumberList = _React$useState6[1];

  var _React$useState7 = react__WEBPACK_IMPORTED_MODULE_1__.useState(false),
      _React$useState8 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_React$useState7, 2),
      isImageLoaded = _React$useState8[0],
      setIsImageLoaded = _React$useState8[1];

  var changedTag = levels === null || levels === void 0 ? void 0 : levels.map(function (item) {
    if ((item === null || item === void 0 ? void 0 : item.levelId) === '4') {
      return {
        id: item === null || item === void 0 ? void 0 : item.id,
        name: t('common:simple'),
        levelId: item === null || item === void 0 ? void 0 : item.levelId
      };
    }

    return item;
  });
  var sliderSetting = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    focusOnSelect: false,
    pauseOnHover: false,
    draggable: false,
    autoplaySpeed: 5000,
    lazyLoad: 'ondemand'
  };

  var _viewHooks$useBeautif = _domains_view__WEBPACK_IMPORTED_MODULE_5__/* .hooks.useBeautifulNumbers */ .PT.useBeautifulNumbers(),
      _viewHooks$useBeautif2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_viewHooks$useBeautif, 1),
      beautifulNumbersMutation = _viewHooks$useBeautif2[0];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    beautifulNumbersMutation({
      levelId: levelId
    }).unwrap().then(function (res) {
      setNumberList(res === null || res === void 0 ? void 0 : res.data);
    });
  }, [levelId]);

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_7__/* .Tab */ .OK, {
      onClick: function onClick() {
        setCurrentTab(index);
        setLevelId(item === null || item === void 0 ? void 0 : item.levelId);
      },
      itemScope: true,
      itemType: "https://schema.org/Offer",
      children: item === null || item === void 0 ? void 0 : item.name
    }, index);
  };

  var renderTabContent = function renderTabContent(item, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().item),
      itemScope: true,
      itemType: "https://schema.org/Offer",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().number),
        children: [item === null || item === void 0 ? void 0 : item.prefix, "-", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().red),
          children: (0,_constants_helper__WEBPACK_IMPORTED_MODULE_11__/* .numberSplitter */ .pk)(item === null || item === void 0 ? void 0 : item.msisdn)
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().price),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().currentPrice),
          children: [item === null || item === void 0 ? void 0 : item.price, ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_6__/* .CurrencySmall */ .jk, {
            width: 20,
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().red_icon)
          })]
        })
      })]
    }, index);
  };

  if (!numberList || numberList.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/OfferCatalog",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().container),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().left),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().header),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
            dangerouslySetInnerHTML: {
              __html: tabs === null || tabs === void 0 ? void 0 : tabs.title
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
            children: tabs === null || tabs === void 0 ? void 0 : tabs.description
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_ui_index__WEBPACK_IMPORTED_MODULE_7__/* .Tabs */ .mQ, {
          active: currentTab,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_7__/* .TabPanel */ .x4, {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().tabs),
            children: changedTag === null || changedTag === void 0 ? void 0 : changedTag.map(renderTab)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_7__/* .TabContent */ .I5, {
            children: changedTag === null || changedTag === void 0 ? void 0 : changedTag.map(function (item, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_7__/* .TabContentItem */ .Wp, {
                active: currentTab,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().numbers),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                  className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bookNumber),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(SliderModule, _objectSpread(_objectSpread({}, sliderSetting), {}, {
                    className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().slider), " slick-book-number"),
                    children: numberList === null || numberList === void 0 ? void 0 : numberList.map(renderTabContent)
                  })), (numberList === null || numberList === void 0 ? void 0 : numberList.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx, {
                    onClick: function onClick() {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        event: 'beautifulnumber'
                      });
                      window.location.assign('https://nomre.bakcell.com/');
                    },
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().button),
                    Component: 'router',
                    children: tabs === null || tabs === void 0 ? void 0 : tabs.order_button_text
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_7__/* .ActiveLink */ .O$, {
                    href: 'https://nomre.bakcell.com/',
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
                      title: tabs === null || tabs === void 0 ? void 0 : tabs.view_all_text,
                      "aria-label": tabs === null || tabs === void 0 ? void 0 : tabs.view_all_text,
                      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().viewAll),
                      children: tabs === null || tabs === void 0 ? void 0 : tabs.view_all_text
                    })
                  })]
                })
              }, index);
            })
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().right),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
            children: tabs === null || tabs === void 0 ? void 0 : tabs.banner_text
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx, {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().button),
            Component: 'router',
            href: tabs === null || tabs === void 0 ? void 0 : tabs.banner_button_slug,
            children: tabs === null || tabs === void 0 ? void 0 : tabs.banner_button_text
          })]
        }), !isImageLoaded && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          containerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().skeletonContainer),
          height: 450
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("picture", {
          style: {
            visibility: isImageLoaded ? 'visible' : 'hidden',
            width: !isImageLoaded && '0%'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("source", {
            media: "(min-width:1024px)",
            srcSet: tabs === null || tabs === void 0 ? void 0 : tabs.banner_image
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().image),
            src: tabs === null || tabs === void 0 ? void 0 : tabs.banner_image,
            width: 350,
            height: 450,
            layout: "responsive",
            alt: "bakcell",
            title: "bakcell",
            loading: "lazy",
            onLoadingComplete: function onLoadingComplete() {
              return setIsImageLoaded(true);
            }
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BookNumber);

/***/ }),

/***/ 25280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98431);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33770);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4556);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46338);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84838);
/* harmony import */ var _hooks_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59748);
/* harmony import */ var _hooks_useSlickPositioning__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25367);
/* harmony import */ var _constants_base__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58165);
/* harmony import */ var _BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61003);
/* harmony import */ var _BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57611);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var BrandSlider = function BrandSlider(_ref) {
  var _data$items;

  var data = _ref.data,
      business = _ref.business;

  var _useWindowSize = (0,_hooks_index__WEBPACK_IMPORTED_MODULE_7__/* .useWindowSize */ .iP)(),
      _useWindowSize2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var elementRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var isMobile = windowsX < _constants_base__WEBPACK_IMPORTED_MODULE_9__/* .breakPoints.sm */ .Eg.sm;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isImageLoaded = _useState[0],
      setIsImageLoaded = _useState[1];

  (0,_hooks_useSlickPositioning__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (elementRef.current) {
      var elementWidth = elementRef.current.clientWidth;
      document.querySelector('.selector-slick-brand').style.setProperty('--gap', "".concat(elementWidth, "px"));
    }
  }, [elementRef]);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    focusOnSelect: false,
    pauseOnHover: false,
    draggable: true,
    autoplaySpeed: 5000,
    lazyLoad: 'ondemand',
    renderMode: 'performance',
    appendDots: function appendDots(dots) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("ul", {
        ref: elementRef,
        children: dots
      });
    },
    customPaging: function customPaging() {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "ft-slick__dots--custom",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: "loading"
        })
      });
    },
    nextArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_6__/* .NextArrow */ .gV, {
      brand: true
    }),
    prevArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_6__/* .PrevArrow */ .$B, {
      brand: true
    })
  };

  var renderSlider = function renderSlider(item, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().branSlider_wrapper),
      itemScope: true,
      itemType: "https://schema.org/Offer",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()([(_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().content), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().midPosition), !item.heading_text)]),
        children: [(item === null || item === void 0 ? void 0 : item.heading_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
          className: (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().label),
          children: item.heading_text
        }), item !== null && item !== void 0 && item.title && index === 1 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h1", {
          className: (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().title),
          children: item === null || item === void 0 ? void 0 : item.title
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h2", {
          className: (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().title),
          children: item === null || item === void 0 ? void 0 : item.title
        }), ((item === null || item === void 0 ? void 0 : item.button_slug) || (item === null || item === void 0 ? void 0 : item.external_link)) && (item === null || item === void 0 ? void 0 : item.button_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
          size: "shortTrapezoid",
          variant: "trapezoidRed",
          href: (item === null || item === void 0 ? void 0 : item.button_slug) || (item === null || item === void 0 ? void 0 : item.external_link),
          Component: item !== null && item !== void 0 && item.button_slug ? 'router' : 'a',
          target: (item === null || item === void 0 ? void 0 : item.external_link) && '_blank',
          children: item === null || item === void 0 ? void 0 : item.button_text
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()([(_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().slide_img), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().slide_img__hidden), !isImageLoaded)]),
        children: (item === null || item === void 0 ? void 0 : item.mobile_image) && (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wrapperDiv),
          children: [!isImageLoaded && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            width: "100%",
            height: "100%",
            className: (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().skeleton),
            containerClassName: (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().skeletonContainer)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: isMobile && item !== null && item !== void 0 && item.mobile_image ? item === null || item === void 0 ? void 0 : item.mobile_image : item === null || item === void 0 ? void 0 : item.image,
            width: 1440,
            height: 642,
            alt: (item === null || item === void 0 ? void 0 : item.title) || 'Bakcell slide image',
            title: (item === null || item === void 0 ? void 0 : item.title) || 'Bakcell slide image',
            layout: "responsive",
            loading: "eager",
            objectFit: isMobile ? 'unset' : 'cover',
            onLoadingComplete: function onLoadingComplete() {
              return setIsImageLoaded(true);
            }
          })]
        })
      })]
    }, index);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_5__["default"], _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()(['selector-slick-brand', 'slick-brand-slider', (_BrandSlider_module_scss__WEBPACK_IMPORTED_MODULE_12___default().slick_brand)])
  }, settings), {}, {
    children: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(renderSlider)
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (BrandSlider);

/***/ }),

/***/ 7176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98431);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ui_SectionTitle_SectionTitle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66850);
/* harmony import */ var _ui_SliderWrapper_SliderWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83234);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24052);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84838);
/* harmony import */ var _enums_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52325);
/* harmony import */ var _hooks_useSlickPositioning__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25367);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84834);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57611);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var Tariffs = function Tariffs(_ref) {
  var _data$tags, _data$tariffs, _data$tags2, _data$tags3;

  var data = _ref.data,
      title = _ref.title,
      buttonText = _ref.buttonText,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(0),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_React$useState, 2),
      currentTab = _React$useState2[0],
      setCurrentTab = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_1__.useState((data === null || data === void 0 ? void 0 : (_data$tags = data.tags) === null || _data$tags === void 0 ? void 0 : _data$tags[0]) || null),
      _React$useState4 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_React$useState3, 2),
      currentTag = _React$useState4[0],
      setCurrentTag = _React$useState4[1];

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      lang = _useTranslation.lang;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  (0,_hooks_useSlickPositioning__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
  var tariffList = data === null || data === void 0 ? void 0 : (_data$tariffs = data.tariffs) === null || _data$tariffs === void 0 ? void 0 : _data$tariffs.filter(function (element) {
    var _element$tags;

    return element === null || element === void 0 ? void 0 : (_element$tags = element.tags) === null || _element$tags === void 0 ? void 0 : _element$tags.some(function (child) {
      return (child === null || child === void 0 ? void 0 : child.id) === (currentTag === null || currentTag === void 0 ? void 0 : currentTag.id);
    });
  });

  var handleEventAction = function handleEventAction(tariff) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: 'AZN',
        items: [{
          item_id: tariff === null || tariff === void 0 ? void 0 : tariff.ngbss_id,
          item_name: tariff === null || tariff === void 0 ? void 0 : tariff.name,
          price: tariff === null || tariff === void 0 ? void 0 : tariff.price,
          quantity: 1,
          item_category: 'Subscription'
        }]
      }
    });
  };

  var renderSlider = function renderSlider(tariff, index) {
    var isHomePage = router.asPath === '/';
    var isAzerbaijani = lang === 'az';
    var updatedTariff = isHomePage ? _objectSpread(_objectSpread({}, tariff), {}, {
      button_slug: isAzerbaijani ? tariff.button_slug : "".concat(lang, "/").concat(tariff === null || tariff === void 0 ? void 0 : tariff.button_slug)
    }) : tariff;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().sliderItem),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .TariffCard */ .Sk, {
        item: updatedTariff,
        onClick: function onClick() {
          return handleEventAction(updatedTariff);
        }
      })
    }, index);
  };

  if (!(data !== null && data !== void 0 && data.tags) || data.tags.length === 0) {
    var _data$tariffs2, _data$tariffs3;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('wrapper', 'section', (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tariffSliderWrapper)),
      itemScope: true,
      itemType: "https://schema.org/Offer",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_SectionTitle_SectionTitle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        icon: data === null || data === void 0 ? void 0 : data.icon,
        href: data === null || data === void 0 ? void 0 : data.button_slug,
        buttonText: data === null || data === void 0 ? void 0 : data.button_text,
        buttonVariant: _enums_button__WEBPACK_IMPORTED_MODULE_9__/* .ComponentVariants.router */ .Yz.router,
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().panner),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_SliderWrapper_SliderWrapper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
          arrows: true,
          nextArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_7__/* .BrandArrow */ .RJ, {
            width: 17
          }),
          prevArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_7__/* .BrandArrow */ .RJ, {
            width: 17
          }),
          options: {
            infinite: (data === null || data === void 0 ? void 0 : (_data$tariffs2 = data.tariffs) === null || _data$tariffs2 === void 0 ? void 0 : _data$tariffs2.length) >= 3
          },
          children: data === null || data === void 0 ? void 0 : (_data$tariffs3 = data.tariffs) === null || _data$tariffs3 === void 0 ? void 0 : _data$tariffs3.map(renderSlider)
        })
      }), (data === null || data === void 0 ? void 0 : data.button_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zx, {
        href: data === null || data === void 0 ? void 0 : data.button_slug,
        Component: data !== null && data !== void 0 && data.button_slug ? 'router' : 'button',
        onClick: onClick,
        size: "normal",
        variant: _enums_button__WEBPACK_IMPORTED_MODULE_9__/* .ComponentVariants.router */ .Yz.router,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().button), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().buttonTariffsMobile)),
        children: data === null || data === void 0 ? void 0 : data.button_text
      })]
    });
  }

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .Tab */ .OK, {
      onClick: function onClick() {
        setCurrentTab(index);
        setCurrentTag(item);
      },
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.text
    }, index);
  };

  var renderTabItem = function renderTabItem(item, index) {
    var _data$tariffs4;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .TabContentItem */ .Wp, {
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: (data === null || data === void 0 ? void 0 : (_data$tariffs4 = data.tariffs) === null || _data$tariffs4 === void 0 ? void 0 : _data$tariffs4.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_SliderWrapper_SliderWrapper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        arrows: true,
        nextArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_7__/* .BrandArrow */ .RJ, {
          width: 17
        }),
        prevArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_7__/* .BrandArrow */ .RJ, {
          width: 17
        }),
        options: {
          infinite: (tariffList === null || tariffList === void 0 ? void 0 : tariffList.length) > 3
        },
        children: tariffList === null || tariffList === void 0 ? void 0 : tariffList.map(renderSlider)
      })
    }, index);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('wrapper', 'section', (_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tariffSliderWrapper)),
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_SectionTitle_SectionTitle__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      icon: data === null || data === void 0 ? void 0 : data.icon,
      onClick: onClick,
      href: data === null || data === void 0 ? void 0 : data.button_slug,
      buttonText: buttonText,
      buttonVariant: 'router',
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .Tabs */ .mQ, {
      active: currentTab,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .TabPanel */ .x4, {
        className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_13___default().panner), " wrapper"),
        children: data === null || data === void 0 ? void 0 : (_data$tags2 = data.tags) === null || _data$tags2 === void 0 ? void 0 : _data$tags2.map(renderTab)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .TabContent */ .I5, {
        children: data === null || data === void 0 ? void 0 : (_data$tags3 = data.tags) === null || _data$tags3 === void 0 ? void 0 : _data$tags3.map(renderTabItem)
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Tariffs);

/***/ }),

/***/ 28883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _ui_Button_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(440);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52844);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57611);






var VolteBanner = function VolteBanner(_ref) {
  var item = _ref.item,
      buttonHide = _ref.buttonHide;

  var renderTitleComponent = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h3", {
    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
    dangerouslySetInnerHTML: {
      __html: (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.title)
    }
  });

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().banner),
    style: {
      backgroundImage: "url(\"".concat(item === null || item === void 0 ? void 0 : item.image, "\")")
    },
    itemScope: true,
    itemType: "https://schema.org/Offer",
    "data-testid": 'volte-banner',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().top),
        children: [renderTitleComponent, (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
          dangerouslySetInnerHTML: {
            __html: item === null || item === void 0 ? void 0 : item.description
          }
        })]
      }), !buttonHide && (item === null || item === void 0 ? void 0 : item.button_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_ui_Button_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: "shortTrapezoid",
        variant: "trapezoidWhite",
        href: (item === null || item === void 0 ? void 0 : item.button_slug) || (item === null || item === void 0 ? void 0 : item.external_link),
        Component: item !== null && item !== void 0 && item.button_slug ? 'router' : 'button',
        children: item === null || item === void 0 ? void 0 : item.button_text
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (VolteBanner);

/***/ }),

/***/ 1822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yj": function() { return /* reexport */ AppBanner/* default */.Z; },
  "Jx": function() { return /* reexport */ BookNumber/* default */.Z; },
  "kx": function() { return /* reexport */ BrandSlider/* default */.Z; },
  "U7": function() { return /* reexport */ FixServices_FixServices; },
  "pY": function() { return /* reexport */ News_NewsList; },
  "Qw": function() { return /* reexport */ Tariffs/* default */.Z; },
  "BP": function() { return /* reexport */ TechnicalSolutions_TechnicalSolutions; }
});

// UNUSED EXPORTS: HotOffers, InternetBundles, News, Products, Slider, VolteBanner

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46338);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/home/Slider/Slider.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var Slider_Slider = function Slider(_ref) {
  var _data$items;

  var data = _ref.data,
      _ref$black = _ref.black,
      black = _ref$black === void 0 ? false : _ref$black;
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    focusOnSelect: false,
    pauseOnHover: false,
    draggable: true,
    autoplaySpeed: 5000,
    lazyLoad: 'ondemand',
    appendDots: function appendDots(dots) {
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("ul", {
          className: "".concat(styles.dots, " wrapper"),
          children: dots
        })
      });
    },
    customPaging: function customPaging() {
      return /*#__PURE__*/_jsx("div", {
        className: styles.dot,
        children: /*#__PURE__*/_jsx(SliderDotIndicator, {})
      });
    }
  };

  var renderSlid = function renderSlid(item, index) {
    return /*#__PURE__*/_jsxs("div", {
      className: classNames([styles.item, _defineProperty({}, styles.black, black)]),
      itemScope: true,
      itemType: "https://schema.org/CreativeWork",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "wrapper ".concat(styles.content),
        children: [(item === null || item === void 0 ? void 0 : item.heading_text) && /*#__PURE__*/_jsx("h3", {
          className: styles.text,
          dangerouslySetInnerHTML: {
            __html: item === null || item === void 0 ? void 0 : item.heading_text
          }
        }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/_jsx("h3", {
          className: styles.title,
          dangerouslySetInnerHTML: {
            __html: item === null || item === void 0 ? void 0 : item.title
          }
        }), (item === null || item === void 0 ? void 0 : item.button_text) && /*#__PURE__*/_jsxs(Button, {
          className: styles.button,
          Component: item !== null && item !== void 0 && item.button_slug ? 'router' : 'a',
          href: (item === null || item === void 0 ? void 0 : item.button_slug) || (item === null || item === void 0 ? void 0 : item.external_link),
          children: [item === null || item === void 0 ? void 0 : item.button_text, " ", /*#__PURE__*/_jsx(Arrow, {
            width: 16
          })]
        })]
      }), (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/_jsx("div", {
        className: styles.imgWrapper,
        children: /*#__PURE__*/_jsx(Image, {
          src: item === null || item === void 0 ? void 0 : item.image,
          alt: item === null || item === void 0 ? void 0 : item.title,
          title: item === null || item === void 0 ? void 0 : item.title,
          width: 800,
          height: 640,
          className: styles.img
        })
      })]
    }, index);
  };

  return /*#__PURE__*/_jsx("div", {
    className: styles.slider,
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: /*#__PURE__*/_jsx(SliderModule, _objectSpread(_objectSpread({}, settings), {}, {
      children: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(renderSlid)
    }))
  });
};

/* harmony default export */ var home_Slider_Slider = ((/* unused pure expression or super */ null && (Slider_Slider)));
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle_SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./components/SvgComponents/section/index.js + 15 modules
var section = __webpack_require__(37726);
// EXTERNAL MODULE: ./components/ui/SliderWrapper/SliderWrapper.js
var SliderWrapper_SliderWrapper = __webpack_require__(83234);
;// CONCATENATED MODULE: ./components/home/HotOffers/HotOffers.js







var HotOffers = function HotOffers(_ref) {
  var _items$tariffs;

  var items = _ref.items;

  var renderSlider = function renderSlider(tariff, index) {
    return /*#__PURE__*/_jsx(TariffCard, {
      item: tariff
    }, "".concat(index, "_tariff"));
  };

  return /*#__PURE__*/_jsxs("div", {
    className: 'section',
    "data-testid": "hot-offers",
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/_jsx(SectionTitle, {
      Icon: Fire,
      className: 'wrapper',
      titleModify: "title--large",
      children: (items === null || items === void 0 ? void 0 : items.image) || null
    }), /*#__PURE__*/_jsx(SliderWrapper, {
      arrows: true,
      children: items === null || items === void 0 ? void 0 : (_items$tariffs = items.tariffs) === null || _items$tariffs === void 0 ? void 0 : _items$tariffs.map(renderSlider)
    })]
  });
};

/* harmony default export */ var HotOffers_HotOffers = ((/* unused pure expression or super */ null && (HotOffers)));
// EXTERNAL MODULE: ./components/home/AppBanner/AppBanner.js
var AppBanner = __webpack_require__(21459);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./components/ui/Button/Button.tsx
var Button_Button = __webpack_require__(440);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(41548);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(73873);
;// CONCATENATED MODULE: ./components/home/Products/Products.js


function Products_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Products_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Products_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Products_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var ProductItem = function ProductItem(_ref) {
  var _ref$product = _ref.product,
      _ref$product$images = _ref$product.images,
      images = _ref$product$images === void 0 ? [] : _ref$product$images,
      _ref$product$name = _ref$product.name,
      name = _ref$product$name === void 0 ? '' : _ref$product$name,
      _ref$product$price = _ref$product.price,
      price = _ref$product$price === void 0 ? '' : _ref$product$price,
      _ref$product$descript = _ref$product.description,
      description = _ref$product$descript === void 0 ? '' : _ref$product$descript,
      _ref$product$discount = _ref$product.discount,
      discount = _ref$product$discount === void 0 ? '' : _ref$product$discount;
  var settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    customPaging: function customPaging(dots) {
      return /*#__PURE__*/_jsx("div", {
        className: style.dots,
        children: /*#__PURE__*/_jsx("div", {
          className: style.invisible,
          children: dots
        })
      });
    },
    swipe: true,
    swipeToSlide: false,
    touchMove: false,
    draggable: true
  };

  var renderImages = function renderImages(image, key) {
    return /*#__PURE__*/_jsx("div", {
      className: style.imageContainer,
      itemScope: true,
      itemType: "https://schema.org/ImageObject",
      children: /*#__PURE__*/_jsx(Image, {
        src: image,
        alt: name,
        title: name,
        loading: "lazy",
        layout: "fill"
      })
    }, key);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: style.item,
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    children: [!!images.length && /*#__PURE__*/_jsx("div", {
      className: style.imagesWrapper,
      children: /*#__PURE__*/_jsx(Slider, Products_objectSpread(Products_objectSpread({}, settings), {}, {
        className: "product-slider ".concat(style.imagesSlider),
        children: images.map(renderImages)
      }))
    }), !!discount && /*#__PURE__*/_jsx("button", {
      "aria-label": discount,
      className: style.discount,
      children: discount
    }), /*#__PURE__*/_jsxs("div", {
      className: style.bottomWrapper,
      children: [/*#__PURE__*/_jsxs("div", {
        className: style.own_info,
        children: [/*#__PURE__*/_jsxs("span", {
          className: style.name,
          children: [" ", name, " "]
        }), /*#__PURE__*/_jsxs("span", {
          className: style.price,
          children: [" ", price, " $"]
        })]
      }), /*#__PURE__*/_jsxs("span", {
        className: style.description,
        children: [" ", description, " "]
      }), /*#__PURE__*/_jsxs("div", {
        className: style.bottomWrapper__btns,
        children: [/*#__PURE__*/_jsxs(Button, {
          "aria-label": "Bakcell",
          className: style.buy,
          children: ["Buy now ", /*#__PURE__*/_jsx(ArrowRight, {
            width: 20
          })]
        }), /*#__PURE__*/_jsx("button", {
          className: style.basket,
          children: /*#__PURE__*/_jsx(Basket, {})
        })]
      })]
    })]
  });
};

var data = [{
  images: ['/assets/home/appleWatch.png', '/assets/home/appleWatch.png', '/assets/home/appleWatch.png'],
  name: 'Apple Watch',
  price: '5000',
  description: 'Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut.Lorem ipsum dolor sit amet, consectetur',
  id: 'kjkj'
}, {
  images: ['/assets/home/appleWatch.png', '/assets/home/appleWatch.png', '/assets/home/appleWatch.png'],
  name: 'Apple Watch',
  price: '5000',
  description: 'Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut.Lorem ipsum dolor sit amet, consectetur',
  discount: '20% discount',
  id: 'kjkj'
}, {
  images: ['/assets/home/appleWatch.png', '/assets/home/appleWatch.png', '/assets/home/appleWatch.png'],
  name: 'Apple Watch',
  price: '5000',
  description: 'Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut.Lorem ipsum dolor sit amet, consectetur',
  id: 'kjkj'
}, {
  images: ['/assets/home/appleWatch.png', '/assets/home/appleWatch.png', '/assets/home/appleWatch.png'],
  name: 'Apple Watch',
  price: '5000',
  description: 'Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut.Lorem ipsum dolor sit amet, consectetur',
  id: 'kjkj'
}]; // products block

var Products = function Products() {
  var renderItems = function renderItems(item, index) {
    return /*#__PURE__*/_jsx(ProductItem, {
      product: item
    }, index);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: 'section',
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/_jsx(SectionTitle, {
      Icon: Bag,
      buttonText: 'Visit shop',
      className: 'wrapper',
      href: '/shop',
      titleModify: "title--large",
      children: "Bakcell shop"
    }), /*#__PURE__*/_jsx(SliderWrapper, {
      children: data.map(renderItems)
    })]
  });
};

/* harmony default export */ var Products_Products = ((/* unused pure expression or super */ null && (Products)));
;// CONCATENATED MODULE: ./components/home/News/News.js







var News = function News(_ref) {
  var _item$category;

  var item = _ref.item;
  return /*#__PURE__*/_jsx(ActiveLink, {
    href: "news/".concat(item === null || item === void 0 ? void 0 : item.slug),
    itemScope: true,
    itemType: "https://schema.org/NewsArticle",
    children: /*#__PURE__*/_jsxs("a", {
      className: styles.newsItem,
      title: item === null || item === void 0 ? void 0 : item.title,
      "aria-label": item === null || item === void 0 ? void 0 : item.title,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.imageContainer,
        children: /*#__PURE__*/_jsx(Image, {
          src: item === null || item === void 0 ? void 0 : item.image,
          alt: item === null || item === void 0 ? void 0 : item.title,
          title: item === null || item === void 0 ? void 0 : item.title,
          layout: 'fill',
          loading: "lazy"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.textWrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.common,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.theme,
            children: item === null || item === void 0 ? void 0 : (_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category.name
          }), /*#__PURE__*/_jsx("div", {
            className: styles.title,
            children: item === null || item === void 0 ? void 0 : item.title
          }), /*#__PURE__*/_jsx("div", {
            className: styles.description,
            dangerouslySetInnerHTML: {
              __html: item === null || item === void 0 ? void 0 : item.description
            }
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: styles.date,
          children: item === null || item === void 0 ? void 0 : item.date
        })]
      })]
    })
  });
};

/* harmony default export */ var News_News = ((/* unused pure expression or super */ null && (News)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(4556);
// EXTERNAL MODULE: ./components/home/News/news.module.scss
var news_module = __webpack_require__(71384);
var news_module_default = /*#__PURE__*/__webpack_require__.n(news_module);
;// CONCATENATED MODULE: ./components/home/News/NewsList.js














var NewsList = function NewsList(_ref) {
  var _data$items, _data$items4, _data$items5;

  var data = _ref.data;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _React$useState = react.useState(data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items[0]),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  var _React$useState3 = react.useState(0),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      activeIndex = _React$useState4[0],
      setActiveIndex = _React$useState4[1];

  var _useState = (0,react.useState)(false),
      isImageLoaded = _useState[0],
      setIsImageLoaded = _useState[1];

  (0,react.useEffect)(function () {
    var _data$items2;

    setActiveTab(data === null || data === void 0 ? void 0 : (_data$items2 = data.items) === null || _data$items2 === void 0 ? void 0 : _data$items2[activeIndex]);
  }, [router.locale]);

  var nextHandler = function nextHandler() {
    var _data$items3;

    if (activeIndex !== (data === null || data === void 0 ? void 0 : (_data$items3 = data.items) === null || _data$items3 === void 0 ? void 0 : _data$items3.length) - 1) {
      setIsImageLoaded(false);
      setActiveIndex(activeIndex + 1);
      setActiveTab(data === null || data === void 0 ? void 0 : data.items[activeIndex + 1]);
    }
  };

  var prevHandler = function prevHandler() {
    if (activeIndex !== 0) {
      setIsImageLoaded(false);
      setActiveIndex(activeIndex - 1);
      setActiveTab(data === null || data === void 0 ? void 0 : data.items[activeIndex - 1]);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "section wrapper",
    itemScope: true,
    itemType: "https://schema.org/NewsArticle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (news_module_default()).news_slider,
      children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
        containerClassName: (news_module_default()).skeleton,
        className: (news_module_default()).skeletonInner,
        width: '100%',
        height: '669px'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          visibility: isImageLoaded ? 'visible' : 'hidden',
          width: !isImageLoaded && '0%'
        },
        className: (news_module_default()).imageWrapper,
        children: !!activeTab && (activeTab === null || activeTab === void 0 ? void 0 : activeTab.homepage_image) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: (news_module_default()).image,
          src: activeTab === null || activeTab === void 0 ? void 0 : activeTab.homepage_image,
          width: 669,
          height: 668,
          alt: activeTab === null || activeTab === void 0 ? void 0 : activeTab.title,
          title: activeTab === null || activeTab === void 0 ? void 0 : activeTab.title,
          loading: "lazy",
          objectFit: "cover",
          "data-testid": 'news-image-id',
          onLoadingComplete: function onLoadingComplete() {
            return setIsImageLoaded(true);
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (news_module_default()).slider,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (news_module_default()).content_box,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (news_module_default()).top,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (news_module_default()).title,
              children: data === null || data === void 0 ? void 0 : data.title
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: (news_module_default()).content_title,
              children: [" ", activeTab === null || activeTab === void 0 ? void 0 : activeTab.title]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (news_module_default()).content_description,
              children: activeTab === null || activeTab === void 0 ? void 0 : activeTab.description
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
              variant: "transparent",
              Component: 'router',
              href: "/news/".concat(activeTab === null || activeTab === void 0 ? void 0 : activeTab.slug),
              className: (news_module_default()).read_more,
              "data-testid": 'news-link-id',
              children: [t('common:ReadArticle'), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRightNew */.Ni, {})]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (news_module_default()).buttons,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (news_module_default()).buttonWrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                onClick: function onClick() {
                  return prevHandler();
                },
                className: classnames_default()([(news_module_default()).previous, (0,defineProperty/* default */.Z)({}, (news_module_default()).disabled, activeIndex + 1 === 1)]),
                "data-testid": 'news-prev',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowLeftNew */.ah, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                onClick: function onClick() {
                  return nextHandler();
                },
                className: classnames_default()([(news_module_default()).next, (0,defineProperty/* default */.Z)({}, (news_module_default()).disabled, activeIndex + 1 === (data === null || data === void 0 ? void 0 : (_data$items4 = data.items) === null || _data$items4 === void 0 ? void 0 : _data$items4.length))]),
                "data-testid": 'news-next',
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRightNew */.Ni, {})
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (news_module_default()).query,
              children: t('common:PagingWithNumbers', {
                count: data === null || data === void 0 ? void 0 : (_data$items5 = data.items) === null || _data$items5 === void 0 ? void 0 : _data$items5.length,
                current: activeIndex + 1
              })
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var News_NewsList = (NewsList);
// EXTERNAL MODULE: ./components/home/BookNumber/BookNumber.js
var BookNumber = __webpack_require__(65620);
// EXTERNAL MODULE: ./components/home/Tariffs/Tariffs.js
var Tariffs = __webpack_require__(7176);
;// CONCATENATED MODULE: ./components/home/InternetBundles/InternetBundles.js










var InternetBundles = function InternetBundles(_ref) {
  var tabs = _ref.tabs,
      item = _ref.item;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentTab = _React$useState2[0],
      setCurrentTab = _React$useState2[1];

  var renderTab = function renderTab(tab, index) {
    return /*#__PURE__*/_jsx(Tab, {
      onClick: function onClick() {
        return setCurrentTab(index);
      },
      itemScope: true,
      itemType: "https://schema.org/Offer",
      children: (tab === null || tab === void 0 ? void 0 : tab.title) || null
    }, index);
  };

  var renderSlider = function renderSlider(tariff, index) {
    return /*#__PURE__*/_jsx(TariffCard, {
      item: tariff,
      itemScope: true,
      itemType: "https://schema.org/Offer"
    }, "".concat(index, "_tariff"));
  };

  var renderTabItem = function renderTabItem(index) {
    var _tabItem$tariffs;

    var tabItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return /*#__PURE__*/_jsx(TabContentItem, {
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: !!(tabItem !== null && tabItem !== void 0 && (_tabItem$tariffs = tabItem.tariffs) !== null && _tabItem$tariffs !== void 0 && _tabItem$tariffs.length) && /*#__PURE__*/_jsx(SliderWrapper, {
        arrows: true,
        children: tabItem.tariffs.map(renderSlider)
      })
    }, index);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: 'section',
    itemScope: true,
    itemType: "https://schema.org/Service",
    children: [/*#__PURE__*/_jsx(SectionTitle, {
      Icon: Internet,
      buttonText: item === null || item === void 0 ? void 0 : item.button_text,
      className: 'wrapper',
      titleModify: "title--large",
      href: item === null || item === void 0 ? void 0 : item.button_slug,
      children: item === null || item === void 0 ? void 0 : item.title
    }), /*#__PURE__*/_jsxs(Tabs, {
      active: currentTab,
      children: [/*#__PURE__*/_jsx(TabPanel, {
        className: "".concat(styles.panner, " wrapper"),
        children: tabs.map(renderTab)
      }), /*#__PURE__*/_jsx(TabContent, {
        children: tabs.map(renderTabItem)
      })]
    })]
  });
};

/* harmony default export */ var InternetBundles_InternetBundles = ((/* unused pure expression or super */ null && (InternetBundles)));
// EXTERNAL MODULE: ./components/ui/CircleIcon/CircleIcon.js
var CircleIcon = __webpack_require__(57787);
// EXTERNAL MODULE: ./components/home/FixServices/FixServices.module.scss
var FixServices_module = __webpack_require__(61972);
var FixServices_module_default = /*#__PURE__*/__webpack_require__.n(FixServices_module);
;// CONCATENATED MODULE: ./components/home/FixServices/Card.js







var Card = function Card(_ref) {
  var data = _ref.data,
      point = _ref.point;

  var renderIconOrText = function () {
    if (data !== null && data !== void 0 && data.icon) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleIcon/* default */.Z, {
        path: data.icon,
        alt: data.icon.alt
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleIcon/* default */.Z, {
      children: point
    });
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
    className: (FixServices_module_default())["card-item"],
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FixServices_module_default())["card-item__icon-wrapper"],
        children: renderIconOrText
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FixServices_module_default())["card-item__content"],
        children: (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
          titleModify: (FixServices_module_default())["card-item__title"],
          children: data.title
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: data !== null && data !== void 0 && data.slug ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
        href: "/".concat(data.slug),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          title: data === null || data === void 0 ? void 0 : data.link_text,
          "aria-label": data === null || data === void 0 ? void 0 : data.link_text,
          className: (FixServices_module_default()).link,
          children: [data === null || data === void 0 ? void 0 : data.link_text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRightNew */.Ni, {
            width: 18
          })]
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (FixServices_module_default()).rotatedArrow,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data === null || data === void 0 ? void 0 : data.link_text
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRightNew */.Ni, {
          width: 18,
          className: (FixServices_module_default()).scrolly
        })]
      })
    })]
  });
};

/* harmony default export */ var FixServices_Card = (Card);
;// CONCATENATED MODULE: ./components/home/FixServices/FixServices.js






var FixServices = function FixServices(_ref) {
  var _data$sections, _data$sections2;

  var data = _ref.data;

  var renderTopServices = function renderTopServices(item, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* BusinessServicesCardWithImage */.Bo, {
      data: item
    }, key);
  };

  var renderBottomServices = function renderBottomServices(item, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FixServices_Card, {
      data: item
    }, key);
  };

  var dataTop = data === null || data === void 0 ? void 0 : (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.slice(0, 2);
  var dataBottom = data === null || data === void 0 ? void 0 : (_data$sections2 = data.sections) === null || _data$sections2 === void 0 ? void 0 : _data$sections2.slice(2);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      titleModify: 'title--largest',
      children: data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FixServices_module_default()).grid,
      children: [dataTop === null || dataTop === void 0 ? void 0 : dataTop.map(renderTopServices), dataBottom === null || dataBottom === void 0 ? void 0 : dataBottom.map(renderBottomServices)]
    })]
  });
};

/* harmony default export */ var FixServices_FixServices = (FixServices);
// EXTERNAL MODULE: ./components/home/TechnicalSolutions/TechnicalSolutions.module.scss
var TechnicalSolutions_module = __webpack_require__(59617);
var TechnicalSolutions_module_default = /*#__PURE__*/__webpack_require__.n(TechnicalSolutions_module);
;// CONCATENATED MODULE: ./components/home/TechnicalSolutions/TechnicalSolutions.js





var TechnicalSolutions = function TechnicalSolutions(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/Service",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      titleModify: 'title--large',
      children: data === null || data === void 0 ? void 0 : data.title
    }), (data === null || data === void 0 ? void 0 : data.sections) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (TechnicalSolutions_module_default()).grid,
      children: data.sections.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* BusinessTechnicalSolution */.d9, {
          data: item
        }, index);
      })
    })]
  });
};

/* harmony default export */ var TechnicalSolutions_TechnicalSolutions = (TechnicalSolutions);
// EXTERNAL MODULE: ./components/home/BrandSlider/BrandSlider.js
var BrandSlider = __webpack_require__(25280);
// EXTERNAL MODULE: ./components/home/VolteBanner/VolteBanner.jsx
var VolteBanner = __webpack_require__(28883);
;// CONCATENATED MODULE: ./components/home/index.js














/***/ }),

/***/ 38703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99968);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61395);
/* harmony import */ var _utils_axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82373);
/* harmony import */ var _constants_newsFilter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79639);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97043);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84838);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51633);
/* harmony import */ var _NewsList_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78557);
/* harmony import */ var _NewsList_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_NewsList_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57611);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var newsFilterData = (0,_constants_newsFilter__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();

var fetcher = function fetcher(url, _ref) {
  var _ref$queryParams = _ref.queryParams,
      queryParams = _ref$queryParams === void 0 ? '' : _ref$queryParams,
      lang = _ref.lang;
  return _utils_axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("".concat(url).concat(queryParams), {
    headers: {
      'Accept-Language': lang
    },
    baseURL: _constants_index__WEBPACK_IMPORTED_MODULE_7__/* .CLIENT_URL */ .$p
  }).then(function (res) {
    return res.data;
  });
};

var limit = 9;
var defaultQuery = "?per_page=".concat(limit, "&");

var NewsList = function NewsList(_ref2) {
  var _data$news, _data$news2;

  var _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      queryParams = _useState[0],
      setQueryParams = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useSWR = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(["/news/".concat(defaultQuery), {
    queryParams: queryParams,
    lang: lang
  }], fetcher),
      data = _useSWR.data;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(newsFilterData[0].options.find(function (el) {
    return el.value === router.query.month;
  }) || newsFilterData[0].options[0]),
      month = _useState3[0],
      setMonth = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(newsFilterData[1].options.find(function (el) {
    return el.value === router.query.year;
  }) || newsFilterData[1].options[0]),
      year = _useState4[0],
      setYear = _useState4[1];

  var onChangeHandlerMonth = function onChangeHandlerMonth(value, callback) {
    router.push({
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        page: 1,
        month: value.value
      })
    }, undefined, {
      shallow: true
    });
    callback(value);
  };

  var onChangeHandlerYear = function onChangeHandlerYear(value, callback) {
    router.push({
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        page: 1,
        year: value.value
      })
    }, undefined, {
      shallow: true
    });
    callback(value);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var query = {
      page: page,
      year: year.value,
      month: month.value
    };
    setQueryParams(new URLSearchParams(query).toString());
  }, [page, year.value, month.value]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!router.isReady) return;
    setPage(router.query.page || 1);
  }, [router.query.page, router.isReady]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: [!data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .ScreenLoader */ .v$, {
      visible: true
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: "wrapper section",
      itemScope: true,
      itemType: "https://schema.org/NewsArticle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: (_NewsList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().titleWrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .SectionTitle */ .NZ, {
          className: (_NewsList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().title),
          titleModify: 'title--large',
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: (_NewsList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().filters),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .Select */ .Ph, {
            value: month,
            data: newsFilterData[0].options,
            label: t('common:month'),
            onChange: function onChange(value) {
              return onChangeHandlerMonth(value, setMonth);
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .Select */ .Ph, {
            value: year,
            data: newsFilterData[1].options,
            label: t('common:year'),
            onChange: function onChange(value) {
              return onChangeHandlerYear(value, setYear);
            }
          })]
        })]
      }), (data === null || data === void 0 ? void 0 : (_data$news = data.news) === null || _data$news === void 0 ? void 0 : _data$news.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "grid-extend equal ".concat((_NewsList_module_scss__WEBPACK_IMPORTED_MODULE_11___default().list)),
        children: data === null || data === void 0 ? void 0 : (_data$news2 = data.news) === null || _data$news2 === void 0 ? void 0 : _data$news2.map(function (item, key) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_common__WEBPACK_IMPORTED_MODULE_9__/* .NewsItem */ .ns, {
            data: item
          }, key);
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        children: t('common:noNews')
      }), (data === null || data === void 0 ? void 0 : data.news_count) > limit && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl, {
        perpage: limit,
        total: data === null || data === void 0 ? void 0 : data.news_count
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (NewsList);

/***/ }),

/***/ 19673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ui_SliderWrapper_SliderWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83234);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84838);
/* harmony import */ var _NewsSingle_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43407);
/* harmony import */ var _NewsSingle_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_NewsSingle_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);








var NewsSingle = function NewsSingle(_ref) {
  var _ref$data = _ref.data,
      _ref$data$title = _ref$data.title,
      title = _ref$data$title === void 0 ? '' : _ref$data$title,
      _ref$data$date = _ref$data.date,
      date = _ref$data$date === void 0 ? '' : _ref$data$date,
      _ref$data$content_sec = _ref$data.content_sections,
      contentSections = _ref$data$content_sec === void 0 ? [] : _ref$data$content_sec,
      _ref$data$images = _ref$data.images,
      images = _ref$data$images === void 0 ? [] : _ref$data$images;
  var options = {
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    nextArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_2__/* .NextArrow */ .gV, {
      brand: true
    }),
    prevArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_2__/* .PrevArrow */ .$B, {
      brand: true
    }),
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }]
  };

  var renderSlide = function renderSlide(item, key) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
      src: item === null || item === void 0 ? void 0 : item.image,
      alt: item === null || item === void 0 ? void 0 : item.title,
      title: item === null || item === void 0 ? void 0 : item.title,
      loading: "lazy",
      width: 1440,
      height: 585,
      objectFit: "inherit"
    }, key);
  };

  var renderContent = function renderContent(item, key) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: [' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (_NewsSingle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: item === null || item === void 0 ? void 0 : item.content
          }
        })]
      }, key), (item === null || item === void 0 ? void 0 : item.video_youtube_id) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_2__/* .Video */ .nk, {
        video: {
          preview: item === null || item === void 0 ? void 0 : item.video_cover,
          videoId: item === null || item === void 0 ? void 0 : item.video_youtube_id,
          title: item === null || item === void 0 ? void 0 : item.video_title
        }
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "wrapper section ".concat((_NewsSingle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrap)),
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (_NewsSingle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().titleWrap),
        children: [!!title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_2__/* .SectionTitle */ .NZ, {
          titleModify: 'title--medium',
          children: title
        }), !!date && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: (_NewsSingle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().date),
          children: date
        })]
      }), !!(images !== null && images !== void 0 && images.length) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ui_SliderWrapper_SliderWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: (_NewsSingle_module_scss__WEBPACK_IMPORTED_MODULE_4___default().slider),
        options: options,
        children: images.map(renderSlide)
      })]
    }), !!(contentSections !== null && contentSections !== void 0 && contentSections.length) && contentSections.map(renderContent)]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (NewsSingle);

/***/ }),

/***/ 97608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35835);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34587);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53431);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61395);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82065);
/* harmony import */ var _utils_axios__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82373);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24052);
/* harmony import */ var _ui_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84838);
/* harmony import */ var _Form_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94540);
/* harmony import */ var _Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_Form_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57611);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-alert */














var Form = function Form(_ref) {
  var _formik$touched$perso, _formik$errors$person, _formik$touched$perso2, _formik$errors$person2, _formik$touched$perso3, _formik$errors$person3, _formik$touched$perso4, _formik$errors$person4, _formik$touched$gener, _formik$errors$genera, _formik$touched$gener2, _formik$errors$genera2, _formik$touched$gener3, _formik$errors$genera3, _formik$touched$gener4, _formik$errors$genera4, _formik$touched$gener5, _formik$errors$genera5, _formik$touched$gener6, _formik$errors$genera6, _formik$touched$gener7, _formik$errors$genera7;

  var data = _ref.data;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  var FormSchema = yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
    entrepreneur_type: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().required(t('common:required')),
    partner_type: yup__WEBPACK_IMPORTED_MODULE_3__/* .array */ .IX().min(1, t('common:required')).required(t('common:required')),
    personInformation: yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
      full_name: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(2, t('common:required')).max(150, t('common:required')).required(t('common:required')),
      id_number: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(2, t('common:required')).max(11).required(t('common:required')),
      date_of_birthday: yup__WEBPACK_IMPORTED_MODULE_3__/* .date */ .hT('dd.mm.yyyy').required(t('common:required')),
      address: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(2, t('common:required')).max(150, t('common:required')).required(t('common:required'))
    }),
    generalInformation: yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry().shape({
      experience_term: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(6, t('common:required')).required(t('common:required')),
      current_work_activities: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(2, t('common:required')).required(t('common:required')),
      shop_address: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(2, t('common:required')).required(t('common:required')),
      area_of_the_shop: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(2, t('common:required')).required(t('common:required')),
      other_shops_in_vicinity: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(2, t('common:required')).required(t('common:required')),
      contact_phone: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().min(12, t('common:required')).max(12, t('common:required')).required(t('common:required')),
      email: yup__WEBPACK_IMPORTED_MODULE_3__/* .string */ .Z_().email(t('common:Invalid email')).required(t('common:Invalid email'))
    })
  });
  var formik = (0,formik__WEBPACK_IMPORTED_MODULE_7__/* .useFormik */ .TA)({
    initialValues: {
      entrepreneur_type: '',
      partner_type: [],
      personInformation: {
        full_name: '',
        id_number: '',
        date_of_birthday: '',
        address: ''
      },
      generalInformation: {
        experience_term: '',
        current_work_activities: '',
        shop_address: '',
        area_of_the_shop: '',
        other_shops_in_vicinity: '',
        contact_phone: '',
        email: '',
        comments: ''
      }
    },
    validationSchema: FormSchema,
    onSubmit: function () {
      var _onSubmit = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values, _ref2) {
        var resetForm, data;
        return _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resetForm = _ref2.resetForm;
                data = _objectSpread(_objectSpread(_objectSpread({}, values.personInformation), values.generalInformation), {}, {
                  entrepreneur_type: values.entrepreneur_type,
                  partner_type: values.partner_type.join(', ')
                });
                _context.next = 4;
                return onSend(data);

              case 4:
                resetForm();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onSubmit(_x, _x2) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      showSuccess = _useState[0],
      setShowSuccess = _useState[1];

  var onSend = /*#__PURE__*/function () {
    var _ref3 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(data) {
      return _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _utils_axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].post */ .Z.post('partnership-requests/', data);

            case 3:
              setShowSuccess(true);
              _context2.next = 9;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              // eslint-disable-next-line no-console
              console.log(_context2.t0);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));

    return function onSend(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onchangePartnerType = function onchangePartnerType(value, index) {
    if (value === 'Others') {
      formik.setFieldValue('partner_type', formik.values.partner_type.includes(value) ? [] : [value]);
    } else {
      if (formik.values.partner_type.includes('Others')) {
        formik.setFieldValue('partner_type', []);
      }

      formik.setFieldValue("partner_type[".concat(index, "]"), formik.values.partner_type[index] ? null : value);
    }
  };

  var modalHandler = function modalHandler() {
    setShowSuccess(false);
  };

  react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function () {
    formik.validateForm();
  }, [lang]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "dark-form ".concat((_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mainWrapper)),
      itemScope: true,
      itemType: "https://schema.org/Action",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()(['wrapper section', (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper)]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .SectionTitle */ .NZ, {
          titleModify: "title--large",
          children: data === null || data === void 0 ? void 0 : data.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .TextBlock */ .al, {
          className: classnames__WEBPACK_IMPORTED_MODULE_6___default()('text--large', (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text)),
          children: data === null || data === void 0 ? void 0 : data.description
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("form", {
          className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().form),
          onSubmit: formik.handleSubmit,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().item),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .SectionTitle */ .NZ, {
              titleModify: 'title--small',
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title),
              children: t('common:partnership.entrepreneur')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().grid),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .RadioWithTitle */ .Xq, {
                onChange: function onChange() {
                  return formik.setFieldValue('entrepreneur_type', 'Individual');
                },
                name: 'type',
                reverse: true,
                children: t('common:partnership.individual')
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .RadioWithTitle */ .Xq, {
                onChange: function onChange() {
                  return formik.setFieldValue('entrepreneur_type', 'Company');
                },
                name: 'type',
                reverse: true,
                children: t('common:partnership.company')
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().item),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .SectionTitle */ .NZ, {
              titleModify: 'title--small',
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title),
              children: t('common:partnership.partnerType')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().grid), (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().grid3)),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .CheckboxWithTitle */ .kP, {
                reverse: true,
                onChange: function onChange() {
                  return onchangePartnerType('Distributor', 1);
                },
                name: 'Distributor',
                checked: formik.values.partner_type.includes('Distributor'),
                children: t('common:partnership.distributor')
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .CheckboxWithTitle */ .kP, {
                reverse: true,
                onChange: function onChange() {
                  return onchangePartnerType('Dealer', 2);
                },
                name: 'Dealer',
                checked: formik.values.partner_type.includes('Dealer'),
                children: t('common:partnership.dealer')
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .CheckboxWithTitle */ .kP, {
                reverse: true,
                onChange: function onChange() {
                  return onchangePartnerType('Others', 0);
                },
                name: 'Others',
                checked: formik.values.partner_type.includes('Others'),
                children: t('common:partnership.other')
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().item),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .SectionTitle */ .NZ, {
              titleModify: 'title--small',
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title),
              children: t('common:partnership.persoralInformation')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().grid),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('personInformation.full_name'),
                value: formik.values.personInformation.full_name,
                onChange: function onChange(value) {
                  return formik.setFieldValue('personInformation.full_name', value);
                },
                placeholder: t('common:fullname'),
                label: t('common:partnership.fullName'),
                error: ((_formik$touched$perso = formik.touched.personInformation) === null || _formik$touched$perso === void 0 ? void 0 : _formik$touched$perso.full_name) && ((_formik$errors$person = formik.errors.personInformation) === null || _formik$errors$person === void 0 ? void 0 : _formik$errors$person.full_name)
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                maxlength: "11",
                onBlur: formik.handleBlur('personInformation.id_number'),
                value: formik.values.personInformation.id_number,
                type: "number",
                onChange: function onChange(value) {
                  return formik.setFieldValue('personInformation.id_number', value);
                },
                placeholder: 'AA000000',
                label: t('common:partnership.idNumber'),
                error: ((_formik$touched$perso2 = formik.touched.personInformation) === null || _formik$touched$perso2 === void 0 ? void 0 : _formik$touched$perso2.id_number) && ((_formik$errors$person2 = formik.errors.personInformation) === null || _formik$errors$person2 === void 0 ? void 0 : _formik$errors$person2.id_number)
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('personInformation.date_of_birthday'),
                value: formik.values.personInformation.date_of_birthday,
                type: "number",
                onChange: function onChange(value) {
                  return formik.setFieldValue('personInformation.date_of_birthday', value);
                },
                placeholder: '01.01.1980',
                label: t('common:partnership.birth'),
                mask: '99.99.9999',
                error: ((_formik$touched$perso3 = formik.touched.personInformation) === null || _formik$touched$perso3 === void 0 ? void 0 : _formik$touched$perso3.date_of_birthday) && ((_formik$errors$person3 = formik.errors.personInformation) === null || _formik$errors$person3 === void 0 ? void 0 : _formik$errors$person3.date_of_birthday)
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('personInformation.address'),
                value: formik.values.personInformation.address,
                type: "validateGeneralInput",
                onChange: function onChange(value) {
                  return formik.setFieldValue('personInformation.address', value);
                },
                error: ((_formik$touched$perso4 = formik.touched.personInformation) === null || _formik$touched$perso4 === void 0 ? void 0 : _formik$touched$perso4.address) && ((_formik$errors$person4 = formik.errors.personInformation) === null || _formik$errors$person4 === void 0 ? void 0 : _formik$errors$person4.address),
                placeholder: t('common:partnership.addresDetail'),
                label: t('common:partnership.address')
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().item),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .SectionTitle */ .NZ, {
              titleModify: 'title--small',
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title),
              children: t('common:partnership.generalInformation')
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              className: classnames__WEBPACK_IMPORTED_MODULE_6___default()((_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().grid), (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().information)),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('generalInformation.experience_term'),
                value: formik.values.generalInformation.experience_term,
                type: "validateGeneralInput",
                onChange: function onChange(value) {
                  return formik.setFieldValue('generalInformation.experience_term', value);
                },
                error: ((_formik$touched$gener = formik.touched.generalInformation) === null || _formik$touched$gener === void 0 ? void 0 : _formik$touched$gener.experience_term) && ((_formik$errors$genera = formik.errors.generalInformation) === null || _formik$errors$genera === void 0 ? void 0 : _formik$errors$genera.experience_term),
                placeholder: t('common:partnership.experiencePlaceholder'),
                label: t('common:partnership.experience')
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('generalInformation.current_work_activities'),
                value: formik.values.generalInformation.current_work_activities,
                onChange: function onChange(value) {
                  return formik.setFieldValue('generalInformation.current_work_activities', value);
                },
                error: ((_formik$touched$gener2 = formik.touched.generalInformation) === null || _formik$touched$gener2 === void 0 ? void 0 : _formik$touched$gener2.current_work_activities) && ((_formik$errors$genera2 = formik.errors.generalInformation) === null || _formik$errors$genera2 === void 0 ? void 0 : _formik$errors$genera2.current_work_activities),
                placeholder: t('common:partnership.activitiesPlaceholder'),
                label: t('common:partnership.activities')
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('generalInformation.shop_address'),
                value: formik.values.generalInformation.shop_address,
                onChange: function onChange(value) {
                  return formik.setFieldValue('generalInformation.shop_address', value);
                },
                error: ((_formik$touched$gener3 = formik.touched.generalInformation) === null || _formik$touched$gener3 === void 0 ? void 0 : _formik$touched$gener3.shop_address) && ((_formik$errors$genera3 = formik.errors.generalInformation) === null || _formik$errors$genera3 === void 0 ? void 0 : _formik$errors$genera3.shop_address),
                placeholder: t('common:partnership.shopAddressPlaceholder'),
                label: t('common:partnership.shopAddress')
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('generalInformation.area_of_the_shop'),
                value: formik.values.generalInformation.area_of_the_shop,
                onChange: function onChange(value) {
                  return formik.setFieldValue('generalInformation.area_of_the_shop', value);
                },
                error: ((_formik$touched$gener4 = formik.touched.generalInformation) === null || _formik$touched$gener4 === void 0 ? void 0 : _formik$touched$gener4.area_of_the_shop) && ((_formik$errors$genera4 = formik.errors.generalInformation) === null || _formik$errors$genera4 === void 0 ? void 0 : _formik$errors$genera4.area_of_the_shop),
                placeholder: t('common:partnership.areaShopPlaceholder'),
                label: t('common:partnership.areaShop')
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('generalInformation.other_shops_in_vicinity'),
                value: formik.values.generalInformation.other_shops_in_vicinity,
                onChange: function onChange(value) {
                  return formik.setFieldValue('generalInformation.other_shops_in_vicinity', value);
                },
                error: ((_formik$touched$gener5 = formik.touched.generalInformation) === null || _formik$touched$gener5 === void 0 ? void 0 : _formik$touched$gener5.other_shops_in_vicinity) && ((_formik$errors$genera5 = formik.errors.generalInformation) === null || _formik$errors$genera5 === void 0 ? void 0 : _formik$errors$genera5.other_shops_in_vicinity),
                placeholder: t('common:partnership.otherAreaPlaceholder'),
                label: t('common:partnership.otherArea')
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('generalInformation.contact_phone'),
                value: formik.values.generalInformation.contact_phone,
                onChange: function onChange(value) {
                  return formik.setFieldValue('generalInformation.contact_phone', value);
                },
                error: ((_formik$touched$gener6 = formik.touched.generalInformation) === null || _formik$touched$gener6 === void 0 ? void 0 : _formik$touched$gener6.contact_phone) && ((_formik$errors$genera6 = formik.errors.generalInformation) === null || _formik$errors$genera6 === void 0 ? void 0 : _formik$errors$genera6.contact_phone),
                placeholder: t('common:partnership.phonePlaceholder'),
                type: 'tel',
                label: t('common:partnership.phone'),
                mask: '+\\9\\9\\4-99-999-99-99'
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Input */ .II, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                onBlur: formik.handleBlur('generalInformation.email'),
                value: formik.values.generalInformation.email,
                onChange: function onChange(value) {
                  return formik.setFieldValue('generalInformation.email', value);
                },
                error: ((_formik$touched$gener7 = formik.touched.generalInformation) === null || _formik$touched$gener7 === void 0 ? void 0 : _formik$touched$gener7.email) && ((_formik$errors$genera7 = formik.errors.generalInformation) === null || _formik$errors$genera7 === void 0 ? void 0 : _formik$errors$genera7.email),
                placeholder: t('common:partnership.email'),
                type: "email",
                label: 'E-mail'
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Textarea */ .gx, {
                className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().customInput),
                value: formik.values.generalInformation.comments,
                onChange: function onChange(value) {
                  return formik.setFieldValue('generalInformation.comments', value);
                },
                placeholder: t('common:partnership.commentsPlaceholder'),
                label: t('common:partnership.comments')
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .zx, {
              className: (_Form_module_scss__WEBPACK_IMPORTED_MODULE_13___default().submit),
              type: 'submit',
              children: [t('common:partnership.send'), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_9__/* .ArrRight */ .jG, {
                width: 20
              })]
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_ui_index__WEBPACK_IMPORTED_MODULE_10__/* .InformationModal */ .UI, {
      type: 'white',
      description: t('common:partnership.sentsuccess'),
      active: showSuccess,
      onClose: modalHandler
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Form);

/***/ }),

/***/ 57208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InternetActivation_InternetActivation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/roaming/InternetActivation/InternetActivation.module.scss
var InternetActivation_module = __webpack_require__(7338);
var InternetActivation_module_default = /*#__PURE__*/__webpack_require__.n(InternetActivation_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/roaming/InternetActivation/Step.js





var Step = function Step(_ref) {
  var step = _ref.step;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (InternetActivation_module_default()).step,
    itemScope: true,
    itemType: "http://schema.org/HowToStep",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (InternetActivation_module_default()).title,
      dangerouslySetInnerHTML: {
        __html: step === null || step === void 0 ? void 0 : step.title
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (InternetActivation_module_default()).image,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (InternetActivation_module_default()).imageWrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: step === null || step === void 0 ? void 0 : step.image,
          className: (InternetActivation_module_default()).img,
          alt: step === null || step === void 0 ? void 0 : step.title,
          title: step === null || step === void 0 ? void 0 : step.title,
          loading: "lazy",
          layout: "fill"
        })
      })
    })]
  });
};

/* harmony default export */ var InternetActivation_Step = (Step);
;// CONCATENATED MODULE: ./components/roaming/InternetActivation/InternetActivation.js







var InternetActivation = function InternetActivation(_ref) {
  var data = _ref.data;

  var renderStep = function renderStep(step, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(InternetActivation_Step, {
      step: step
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "http://schema.org/Service",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: (InternetActivation_module_default()).title,
      children: data === null || data === void 0 ? void 0 : data.title
    }), (data === null || data === void 0 ? void 0 : data.top_content) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SEOText */.R, {
      className: (InternetActivation_module_default()).text,
      children: data.top_content
    }), !!(data !== null && data !== void 0 && data.steps) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (InternetActivation_module_default()).videoSlider,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((InternetActivation_module_default()).steps, " grid-extend ").concat((InternetActivation_module_default()).steps),
        children: data.steps.map(renderStep)
      })
    }), (data === null || data === void 0 ? void 0 : data.bottom_content) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SEOText */.R, {
      className: (InternetActivation_module_default()).text,
      children: data.bottom_content
    })]
  });
};

/* harmony default export */ var InternetActivation_InternetActivation = (InternetActivation);

/***/ }),

/***/ 55438:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
// EXTERNAL MODULE: ./components/ui/CircleIcon/CircleIcon.js
var CircleIcon_CircleIcon = __webpack_require__(57787);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/roaming/SpecialOffers/Card.js







var Card_Card = function Card(_ref) {
  var _data$foreground, _data$foreground2, _data$foreground3;

  var data = _ref.data,
      point = _ref.point;

  var renderIconOrText = function () {
    var _data$icon;

    if (data !== null && data !== void 0 && (_data$icon = data.icon) !== null && _data$icon !== void 0 && _data$icon.path) {
      return /*#__PURE__*/_jsx(CircleIcon, {
        className: styles.circleIcon,
        path: data.icon.path,
        alt: data.icon.alt
      });
    }

    return /*#__PURE__*/_jsx(CircleIcon, {
      className: styles.circleIcon,
      children: point
    });
  }();

  return /*#__PURE__*/_jsxs("article", {
    className: styles['card-item'],
    itemScope: true,
    itemType: "http://schema.org/Article",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['card-item__icon-wrapper'],
        children: renderIconOrText
      }), /*#__PURE__*/_jsx("div", {
        className: styles['card-item__content'],
        children: (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx(SectionTitle, {
          titleModify: styles['card-item__title'],
          children: data.title
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        variant: 'white',
        Component: 'router',
        href: data.link,
        className: styles.link,
        children: "Details"
      })
    }), (data === null || data === void 0 ? void 0 : (_data$foreground = data.foreground) === null || _data$foreground === void 0 ? void 0 : _data$foreground.path) && /*#__PURE__*/_jsx(Image, {
      src: data.foreground.path,
      alt: (data === null || data === void 0 ? void 0 : (_data$foreground2 = data.foreground) === null || _data$foreground2 === void 0 ? void 0 : _data$foreground2.alt) || (data === null || data === void 0 ? void 0 : data.title),
      title: (data === null || data === void 0 ? void 0 : (_data$foreground3 = data.foreground) === null || _data$foreground3 === void 0 ? void 0 : _data$foreground3.alt) || (data === null || data === void 0 ? void 0 : data.title),
      className: styles.foreground,
      loading: "lazy",
      layout: "fill"
    })]
  });
};

/* harmony default export */ var SpecialOffers_Card = ((/* unused pure expression or super */ null && (Card_Card)));
;// CONCATENATED MODULE: ./components/roaming/SpecialOffers/SpecialOffers.js






var SpecialOffers = function SpecialOffers(_ref) {
  var _data$top, _data$bottom;

  var data = _ref.data;

  var renderTopServices = function renderTopServices(item, key) {
    return /*#__PURE__*/_jsx(Card, {
      data: item
    }, key);
  };

  var renderBottomServices = function renderBottomServices(item, key) {
    return /*#__PURE__*/_jsx(Card, {
      data: item
    }, key);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "http://schema.org/Offer",
    children: [/*#__PURE__*/_jsx(SectionTitle, {
      titleModify: 'title--large',
      children: "Roaming bundles and special offers"
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.grid,
      children: [data === null || data === void 0 ? void 0 : (_data$top = data.top) === null || _data$top === void 0 ? void 0 : _data$top.map(renderTopServices), data === null || data === void 0 ? void 0 : (_data$bottom = data.bottom) === null || _data$bottom === void 0 ? void 0 : _data$bottom.map(renderBottomServices)]
    })]
  });
};

/* harmony default export */ var SpecialOffers_SpecialOffers = ((/* unused pure expression or super */ null && (SpecialOffers)));

/***/ }),

/***/ 4538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jS": function() { return /* reexport */ roaming_BannerAzer_BannerAzer; },
  "kO": function() { return /* reexport */ roaming_GeneralServices_GeneralServices; },
  "YN": function() { return /* reexport */ InternetActivation/* default */.Z; },
  "Gw": function() { return /* reexport */ roaming_Questions_Questions; },
  "Dw": function() { return /* reexport */ RoamingActivation_RoamingActivation; },
  "Rg": function() { return /* reexport */ roaming_Steps_Steps; }
});

// UNUSED EXPORTS: Advantageous, BeforeTrip, DiscountedRoamingCalls, PricesAndCountries, Roaming, RoamingMain, SpecialOffers

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/ui/PageTabs/PageTabs.js
var PageTabs_PageTabs = __webpack_require__(58148);
// EXTERNAL MODULE: ./components/ui/GridProducts/GridProducts.js
var GridProducts_GridProducts = __webpack_require__(74715);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/roaming/Roaming/Roaming.js







var Roaming = function Roaming(_ref) {
  var _data$offers;

  var data = _ref.data;

  var renderTariff = function renderTariff(tariff, index) {
    return /*#__PURE__*/_jsx(TariffCard, {
      item: tariff
    }, "".concat(index, "_tariff"));
  };

  return /*#__PURE__*/_jsxs("div", {
    itemScope: true,
    itemType: "http://schema.org/Offer",
    children: [data.tabs && /*#__PURE__*/_jsx(PageTabs, {
      tabs: data.tabs,
      pathname: 'roaming'
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner
    }), !!(data !== null && data !== void 0 && (_data$offers = data.offers) !== null && _data$offers !== void 0 && _data$offers.length) && /*#__PURE__*/_jsx("div", {
      className: 'small-margin',
      children: /*#__PURE__*/_jsx(GridProducts, {
        children: data.offers.map(renderTariff)
      })
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(Banner, {
      item: data.banner,
      href: '/roaming/prices-and-countries'
    })]
  });
};

/* harmony default export */ var Roaming_Roaming = ((/* unused pure expression or super */ null && (Roaming)));
;// CONCATENATED MODULE: ./components/roaming/DiscountedRoamingCalls/DiscountedRoamingCalls.js




var DiscountedRoamingCalls = function DiscountedRoamingCalls(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsx(Advantageous, {
    advantageousData: data,
    itemScope: true,
    itemType: "http://schema.org/Offer"
  });
};

/* harmony default export */ var DiscountedRoamingCalls_DiscountedRoamingCalls = ((/* unused pure expression or super */ null && (DiscountedRoamingCalls)));
// EXTERNAL MODULE: ./components/SvgComponents/section/Question.js
var Question = __webpack_require__(85928);
// EXTERNAL MODULE: ./components/SvgComponents/section/index.js + 15 modules
var section = __webpack_require__(37726);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/roaming/GeneralServices/GeneralServices.module.scss
var GeneralServices_module = __webpack_require__(70410);
var GeneralServices_module_default = /*#__PURE__*/__webpack_require__.n(GeneralServices_module);
;// CONCATENATED MODULE: ./components/roaming/GeneralServices/GeneralServices.js









var Item = function Item(_ref) {
  var _ref$item = _ref.item,
      text = _ref$item.text,
      icon = _ref$item.icon,
      buttonText = _ref$item.button_text,
      buttonSlug = _ref$item.button_slug;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (GeneralServices_module_default())["service-item"],
    itemScope: true,
    itemType: "http://schema.org/ListItem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (GeneralServices_module_default())["service-item__content"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (GeneralServices_module_default())["service-item__content__iconContainer"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: icon,
          className: (GeneralServices_module_default())["service-item__content__iconContainer__icon"],
          alt: text,
          title: text,
          loading: "lazy",
          width: 40,
          height: 40
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (GeneralServices_module_default())["service-item__title"],
        children: text
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
      className: (GeneralServices_module_default())["service-item__button"],
      variant: "red",
      Component: buttonSlug ? 'router' : 'button',
      href: buttonSlug,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: buttonText
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
        width: 24
      })]
    })]
  });
};

var GeneralServices_GeneralServices = function GeneralServices(_ref2) {
  var _services$sections, _services$sections2, _services$sections2$s;

  var services = _ref2.services;
  var mainBox = (services === null || services === void 0 ? void 0 : (_services$sections = services.sections) === null || _services$sections === void 0 ? void 0 : _services$sections[0]) || {};

  var renderItems = function renderItems(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
      item: item
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()('wrapper', 'section'),
    itemScope: true,
    itemType: "http://schema.org/Service",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      icon: services === null || services === void 0 ? void 0 : services.icon,
      className: (GeneralServices_module_default())["general-service__title-block"],
      titleModify: "title--large",
      children: services === null || services === void 0 ? void 0 : services.text
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (GeneralServices_module_default())["general-service__inner"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (GeneralServices_module_default())["service-item-own"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (GeneralServices_module_default())["service-item-own__caption"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (GeneralServices_module_default())["service-item-own__content"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (GeneralServices_module_default())["service-item-own__iconContainer"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: mainBox === null || mainBox === void 0 ? void 0 : mainBox.icon,
                className: (GeneralServices_module_default())["service-item-own__iconContainer__icon"],
                alt: mainBox === null || mainBox === void 0 ? void 0 : mainBox.text,
                title: mainBox === null || mainBox === void 0 ? void 0 : mainBox.text,
                loading: "lazy",
                width: 56,
                height: 56
              })
            }), (mainBox === null || mainBox === void 0 ? void 0 : mainBox.text) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
              titleModify: classnames_default()((GeneralServices_module_default())["service-item-own__title"], 'title--large'),
              children: mainBox.text
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
            className: (GeneralServices_module_default())["service-item-own__button"],
            variant: "red",
            href: mainBox === null || mainBox === void 0 ? void 0 : mainBox.button_slug,
            Component: "router",
            children: [mainBox === null || mainBox === void 0 ? void 0 : mainBox.button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
              width: 24
            })]
          })]
        })
      }), services === null || services === void 0 ? void 0 : (_services$sections2 = services.sections) === null || _services$sections2 === void 0 ? void 0 : (_services$sections2$s = _services$sections2.slice(1)) === null || _services$sections2$s === void 0 ? void 0 : _services$sections2$s.map(renderItems)]
    })]
  });
};

/* harmony default export */ var roaming_GeneralServices_GeneralServices = (GeneralServices_GeneralServices);
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./components/roaming/Steps/Steps.module.scss
var Steps_module = __webpack_require__(35969);
var Steps_module_default = /*#__PURE__*/__webpack_require__.n(Steps_module);
;// CONCATENATED MODULE: ./components/roaming/Steps/Steps.js










var Step = function Step(_ref) {
  var step = _ref.step,
      number = _ref.number;

  var renderLinkOrText = function renderLinkOrText() {
    if (step !== null && step !== void 0 && step.button_text) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
        href: step.button_slug || '/',
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          title: step.button_text,
          "aria-label": step.button_text,
          className: (Steps_module_default())["step-item__activate"],
          itemScope: true,
          itemType: "https://schema.org/Action",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (Steps_module_default())["step-item__activate-text"],
            children: step.button_text
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Steps_module_default())["step-item__activate-iconContainer"],
            children: (step === null || step === void 0 ? void 0 : step.button_type) === 'tick' ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Tick */.dR, {
              className: (Steps_module_default())["step-item__activate-icon"]
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
              className: (Steps_module_default())["step-item__activate-icon"]
            })
          })]
        })
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
      className: classnames_default()((Steps_module_default())["step-item__content"], 'text--medium'),
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Steps_module_default())["step-item__content-text"],
        children: step.description
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Steps_module_default())["step-item"],
    itemScope: true,
    itemType: "https://schema.org/HowToStep",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Steps_module_default())["step-item__number"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Steps_module_default())["step-item__number-count"],
        children: number
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Steps_module_default())["step-item__img-wrapper"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: step === null || step === void 0 ? void 0 : step.image,
        alt: step.button_text,
        title: step.button_text,
        loading: "lazy",
        layout: "fill"
      })
    }), renderLinkOrText()]
  });
};

var Steps_Steps = function Steps(_ref2) {
  var _data$sections;

  var data = _ref2.data,
      type = _ref2.type;

  var getTypeClass = function () {
    if (type === 'dark') return (Steps_module_default())["steps--dark"];
    if (type === 'fill') return (Steps_module_default())["steps--fill"];
    return '';
  }();

  var renderSteps = function renderSteps(step, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Step, {
      step: step,
      number: index + 1
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()([(Steps_module_default()).steps, 'section wrapper', getTypeClass]),
    itemScope: true,
    itemType: "https://schema.org/HowTo",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Steps_module_default()).steps__head,
      children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
        className: (Steps_module_default()).steps__title,
        titleModify: "title--large",
        icon: data === null || data === void 0 ? void 0 : data.icon,
        children: data.title
      }), (data === null || data === void 0 ? void 0 : data.text) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (Steps_module_default()).steps__text,
        children: data.text
      })]
    }), (data === null || data === void 0 ? void 0 : data.sections) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Steps_module_default()).steps__inner,
      children: (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.map(renderSteps)
    })]
  });
};

/* harmony default export */ var roaming_Steps_Steps = (Steps_Steps);
// EXTERNAL MODULE: ./components/roaming/BannerAzer/BannerAzer.module.scss
var BannerAzer_module = __webpack_require__(31209);
var BannerAzer_module_default = /*#__PURE__*/__webpack_require__.n(BannerAzer_module);
;// CONCATENATED MODULE: ./components/roaming/BannerAzer/BannerAzer.js







var BannerAzer_BannerAzer = function BannerAzer(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('section', 'wrapper'),
    itemScope: true,
    itemType: "http://schema.org/Offer",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (BannerAzer_module_default())["banner-guest"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (BannerAzer_module_default())["banner-guest__content"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (BannerAzer_module_default())["banner-guest__text"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (BannerAzer_module_default())["banner-guest__subtitle"],
            children: data === null || data === void 0 ? void 0 : data.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
            titleModify: classnames_default()((BannerAzer_module_default())["banner-guest__title"], 'title--large'),
            children: data === null || data === void 0 ? void 0 : data.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
            className: classnames_default()((BannerAzer_module_default())["banner-guest__desc"]),
            children: data === null || data === void 0 ? void 0 : data.description
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (BannerAzer_module_default())["banner-guest__tarrif"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TariffCard */.Sk, {
            item: data === null || data === void 0 ? void 0 : data.tariff
          })
        })]
      })
    })
  });
};

/* harmony default export */ var roaming_BannerAzer_BannerAzer = (BannerAzer_BannerAzer);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./components/ui/SectionDescription/description.module.scss
var description_module = __webpack_require__(82740);
var description_module_default = /*#__PURE__*/__webpack_require__.n(description_module);
;// CONCATENATED MODULE: ./components/ui/SectionDescription/SectionDescription.js



var SectionDescription = function SectionDescription(_ref) {
  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? '' : _ref$description,
      _ref$isHtml = _ref.isHtml,
      isHtml = _ref$isHtml === void 0 ? false : _ref$isHtml;

  var renderDescription = function renderDescription(text) {
    if (isHtml) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (description_module_default()).description,
        dangerouslySetInnerHTML: {
          __html: text
        }
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (description_module_default()).description,
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: text
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((description_module_default()).description),
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: renderDescription(description)
  });
};

/* harmony default export */ var SectionDescription_SectionDescription = (SectionDescription);
// EXTERNAL MODULE: ./components/roaming/Questions/Questions.module.scss
var Questions_module = __webpack_require__(91431);
var Questions_module_default = /*#__PURE__*/__webpack_require__.n(Questions_module);
;// CONCATENATED MODULE: ./components/roaming/Questions/Questions.js










var Questions_Question = function Question(_ref) {
  var _classNames;

  var question = _ref.question,
      isSmall = _ref.isSmall;

  var _useState = (0,react.useState)(false),
      isActive = _useState[0],
      setActive = _useState[1];

  var handleClick = function handleClick() {
    return setActive(function (prev) {
      return !prev;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((Questions_module_default())["question-item"], (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (Questions_module_default()).active, isActive), (0,defineProperty/* default */.Z)(_classNames, (Questions_module_default())["question-item--small"], isSmall), _classNames)),
    itemScope: true,
    itemType: "http://schema.org/Question",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Questions_module_default())["question-item__caption"],
      onClick: handleClick,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: (Questions_module_default())["question-item__title"],
        children: question === null || question === void 0 ? void 0 : question.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {})
      })]
    }), isActive && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Questions_module_default())["question-item__desc"],
      dangerouslySetInnerHTML: {
        __html: question === null || question === void 0 ? void 0 : question.content
      }
    })]
  });
};

var Questions_Questions = function Questions(_ref2) {
  var _questions$sections;

  var questions = _ref2.questions,
      className = _ref2.className,
      isSmall = _ref2.isSmall;

  var renderQuestions = function renderQuestions(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Questions_Question, {
      question: item,
      isSmall: isSmall
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(className, 'section'),
    itemScope: true,
    itemType: "http://schema.org/FAQPage",
    children: [(questions === null || questions === void 0 ? void 0 : questions.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      titleModify: classnames_default()((Questions_module_default()).questions_faq__title, 'title--medium'),
      children: questions === null || questions === void 0 ? void 0 : questions.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Questions_module_default()).questions,
      children: [(questions === null || questions === void 0 ? void 0 : questions.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription_SectionDescription, {
        description: questions.description
      }), (questions === null || questions === void 0 ? void 0 : (_questions$sections = questions.sections) === null || _questions$sections === void 0 ? void 0 : _questions$sections.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Questions_module_default()).questions__list,
        children: questions.sections.map(renderQuestions)
      })]
    })]
  });
};

/* harmony default export */ var roaming_Questions_Questions = (Questions_Questions);
;// CONCATENATED MODULE: ./components/roaming/Roaming/RoamingMain.js












var RoamingMain = function RoamingMain(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(data === null || data === void 0 ? void 0 : data.breadcrumbs) && /*#__PURE__*/_jsx(Breadcrumbs, {
      data: data.breadcrumbs,
      itemScope: true,
      itemType: "http://schema.org/BreadcrumbList"
    }), /*#__PURE__*/_jsx("div", {
      className: 'small-margin',
      itemScope: true,
      itemType: "http://schema.org/Service",
      children: (data === null || data === void 0 ? void 0 : data.services) && /*#__PURE__*/_jsx(GeneralServices, {
        services: data.services
      })
    }), (data === null || data === void 0 ? void 0 : data.steps) && /*#__PURE__*/_jsx(Steps, {
      data: data.steps,
      Icon: Money,
      itemScope: true,
      itemType: "http://schema.org/HowToStep"
    }), (data === null || data === void 0 ? void 0 : data.banner) && /*#__PURE__*/_jsx(Banner, {
      item: data.banner,
      href: '/roaming/prices-and-countries',
      itemScope: true,
      itemType: "http://schema.org/CreativeWork"
    }), (data === null || data === void 0 ? void 0 : data.guestTariff) && /*#__PURE__*/_jsx(BannerAzer, {
      data: data.guestTariff,
      itemScope: true,
      itemType: "http://schema.org/Offer"
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Questions, {
      questions: data.questions,
      className: "wrapper section",
      Icon: SvgQuestion,
      titleModify: "title--large",
      itemScope: true,
      itemType: "http://schema.org/Question"
    })]
  });
};

/* harmony default export */ var Roaming_RoamingMain = ((/* unused pure expression or super */ null && (RoamingMain)));
;// CONCATENATED MODULE: ./components/roaming/Before-trip/Before-trip.js







var BeforeTrip = function BeforeTrip(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    itemScope: true,
    itemType: "http://schema.org/Product",
    children: [(data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner
    }), (data === null || data === void 0 ? void 0 : data.productStatus) && /*#__PURE__*/_jsx(ProductStatus, {
      statusData: data.productStatus,
      className: "wrapper small-margin",
      isBlock: true,
      titleModify: "title--large",
      Icon: InfoQuestion
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Questions, {
      questions: data.questions,
      Icon: InfoCircle,
      titleModify: "title--large",
      className: "wrapper section"
    })]
  });
};

/* harmony default export */ var Before_trip = ((/* unused pure expression or super */ null && (BeforeTrip)));
// EXTERNAL MODULE: ./components/home/index.js + 9 modules
var home = __webpack_require__(1822);
;// CONCATENATED MODULE: ./components/roaming/PricesAndCountries/PricesAndCountries.js






var PricesAndCountries = function PricesAndCountries(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    itemScope: true,
    itemType: "http://schema.org/Offer",
    children: [(data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner
    }), (data === null || data === void 0 ? void 0 : data.travel) && /*#__PURE__*/_jsx(SearchTravel, {
      travelData: data.travel
    }), (data === null || data === void 0 ? void 0 : data.offers) && /*#__PURE__*/_jsx(Tariffs, {
      tabs: data.offers,
      title: 'Recommended tariffs',
      buttonText: 'Archive'
    })]
  });
};

/* harmony default export */ var PricesAndCountries_PricesAndCountries = ((/* unused pure expression or super */ null && (PricesAndCountries)));
// EXTERNAL MODULE: ./components/roaming/SpecialOffers/SpecialOffers.js + 1 modules
var SpecialOffers = __webpack_require__(55438);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./components/roaming/RoamingActivation/RoamingActivation.module.scss
var RoamingActivation_module = __webpack_require__(5379);
var RoamingActivation_module_default = /*#__PURE__*/__webpack_require__.n(RoamingActivation_module);
;// CONCATENATED MODULE: ./components/roaming/RoamingActivation/RoamingActivation.js








var RoamingActivation = function RoamingActivation(_ref) {
  var _data$sections, _data$sections2, _data$sections$active, _data$sections$active2, _data$sections$active3;

  var data = _ref.data;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  var renderTabs = function renderTabs(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Tab */.OK, {
      onClick: function onClick() {
        return setActiveTab(index);
      },
      className: (RoamingActivation_module_default()).customTab,
      itemScope: true,
      itemType: "http://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.title
    }, index);
  };

  var renderTabContents = function renderTabContents(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabContentItem */.Wp, {
      itemScope: true,
      itemType: "http://schema.org/ItemList",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ProductStatus */.Pt, {
        dark: true,
        statusData: item,
        className: classnames_default()(['small-margin', (RoamingActivation_module_default()).productStatus]),
        isBlock: true
      })
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(['wrapper', 'section', (RoamingActivation_module_default()).roaming_activation]),
    itemScope: true,
    itemType: "http://schema.org/CheckOutAction",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        className: (RoamingActivation_module_default()).title,
        children: data === null || data === void 0 ? void 0 : data.title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Tabs */.mQ, {
        active: activeTab,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabPanel */.x4, {
          children: data === null || data === void 0 ? void 0 : (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.map(renderTabs)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabContent */.I5, {
          children: data === null || data === void 0 ? void 0 : (_data$sections2 = data.sections) === null || _data$sections2 === void 0 ? void 0 : _data$sections2.map(renderTabContents)
        })]
      })]
    }), !!(data !== null && data !== void 0 && (_data$sections$active = data.sections[activeTab]) !== null && _data$sections$active !== void 0 && (_data$sections$active2 = _data$sections$active.accordion) !== null && _data$sections$active2 !== void 0 && _data$sections$active2.sections) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Faq */.By, {
      items: data === null || data === void 0 ? void 0 : (_data$sections$active3 = data.sections[activeTab]) === null || _data$sections$active3 === void 0 ? void 0 : _data$sections$active3.accordion,
      className: (RoamingActivation_module_default()).faq
    })]
  });
};

/* harmony default export */ var RoamingActivation_RoamingActivation = (RoamingActivation);
;// CONCATENATED MODULE: ./components/roaming/Advantageous/Advantageous.js








var Advantageous_Advantageous = function Advantageous(_ref) {
  var _data$campaignTable;

  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [(data === null || data === void 0 ? void 0 : data.breadcrumbs) && /*#__PURE__*/_jsx(Breadcrumbs, {
      data: data.breadcrumbs
    }), (data === null || data === void 0 ? void 0 : data.mainBanner) && /*#__PURE__*/_jsx(InternetBanner, {
      bannerData: data.mainBanner,
      medium: true
    }), /*#__PURE__*/_jsxs("div", {
      className: 'wrapper little-margin',
      children: [(data === null || data === void 0 ? void 0 : (_data$campaignTable = data.campaignTable) === null || _data$campaignTable === void 0 ? void 0 : _data$campaignTable.mainText) && /*#__PURE__*/_jsx(TextBlock, {
        className: classNames([styles.text, 'text--large']),
        children: data.campaignTable.mainText
      }), /*#__PURE__*/_jsx(CallBlock, {})]
    }), (data === null || data === void 0 ? void 0 : data.questions2) && /*#__PURE__*/_jsx(Questions, {
      title: null,
      className: classNames([styles.faq, 'wrapper']),
      questions: data.questions2
    }), (data === null || data === void 0 ? void 0 : data.banner2) && /*#__PURE__*/_jsx(Banner, {
      item: data.banner2
    })]
  });
};

/* harmony default export */ var roaming_Advantageous_Advantageous = ((/* unused pure expression or super */ null && (Advantageous_Advantageous)));
// EXTERNAL MODULE: ./components/roaming/InternetActivation/InternetActivation.js + 1 modules
var InternetActivation = __webpack_require__(57208);
;// CONCATENATED MODULE: ./components/roaming/index.js














/***/ }),

/***/ 84439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ServicesGrid_ServicesGrid; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(4556);
// EXTERNAL MODULE: ./components/services/ServicesGrid/ServicesGrid.module.scss
var ServicesGrid_module = __webpack_require__(62717);
var ServicesGrid_module_default = /*#__PURE__*/__webpack_require__.n(ServicesGrid_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/services/ServicesGrid/Service.js










var Service = function Service(_ref) {
  var item = _ref.item,
      _ref$popular = _ref.popular,
      popular = _ref$popular === void 0 ? false : _ref$popular;

  var _useState = (0,react.useState)(false),
      isImageLoaded = _useState[0],
      setIsImageLoaded = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(ServicesGrid_module_default()).service, (0,defineProperty/* default */.Z)({}, (ServicesGrid_module_default()).popular, popular)]),
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ServicesGrid_module_default()).image,
      children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
        width: 90,
        height: 90
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: (ServicesGrid_module_default()).imageMain,
        src: item === null || item === void 0 ? void 0 : item.image,
        alt: item === null || item === void 0 ? void 0 : item.title,
        title: item === null || item === void 0 ? void 0 : item.title,
        width: 90,
        height: 90,
        loading: "lazy",
        onLoadingComplete: function onLoadingComplete() {
          return setIsImageLoaded(true);
        },
        style: {
          visibility: isImageLoaded ? 'visible' : 'hidden'
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ServicesGrid_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ServicesGrid_module_default()).title,
        children: item === null || item === void 0 ? void 0 : item.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ServicesGrid_module_default()).text,
        children: item === null || item === void 0 ? void 0 : item.description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ServicesGrid_module_default()).button,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
        href: item === null || item === void 0 ? void 0 : item.slug,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          title: item === null || item === void 0 ? void 0 : item.button_text,
          "aria-label": item === null || item === void 0 ? void 0 : item.button_text,
          className: (ServicesGrid_module_default()).link,
          children: [item === null || item === void 0 ? void 0 : item.button_text, /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (ServicesGrid_module_default()).arrow,
            children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
              width: 24,
              height: 24
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/assets/ArrowRightNew.svg",
              alt: "arrow icon",
              title: "Arrow Icon",
              width: 24,
              height: 24,
              onLoadingComplete: function onLoadingComplete() {
                return setIsImageLoaded(true);
              },
              style: {
                visibility: isImageLoaded ? 'visible' : 'hidden'
              }
            })]
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var ServicesGrid_Service = (Service);
;// CONCATENATED MODULE: ./components/services/ServicesGrid/ServicesGrid.js









var ServicesGrid = function ServicesGrid(_ref) {
  var _data$sections;

  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: data === null || data === void 0 ? void 0 : (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.map(function (item, index) {
      var _item$cards, _item$cards2, _item$cards3, _item$cards4, _ref2, _item$cards5;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: 'wrapper section',
        itemScope: true,
        itemType: "https://schema.org/Service",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
          icon: item === null || item === void 0 ? void 0 : item.icon,
          titleModify: "title--large",
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()([(ServicesGrid_module_default()).grid, (_ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, (ServicesGrid_module_default()).baseGrid, (item === null || item === void 0 ? void 0 : (_item$cards = item.cards) === null || _item$cards === void 0 ? void 0 : _item$cards.length) === 3), (0,defineProperty/* default */.Z)(_ref2, (ServicesGrid_module_default()).row, !((item === null || item === void 0 ? void 0 : (_item$cards2 = item.cards) === null || _item$cards2 === void 0 ? void 0 : _item$cards2.length) % 2) && (item === null || item === void 0 ? void 0 : (_item$cards3 = item.cards) === null || _item$cards3 === void 0 ? void 0 : _item$cards3.length) <= 4), (0,defineProperty/* default */.Z)(_ref2, (ServicesGrid_module_default()).mix, (item === null || item === void 0 ? void 0 : (_item$cards4 = item.cards) === null || _item$cards4 === void 0 ? void 0 : _item$cards4.length) > 4), _ref2)]),
          children: item === null || item === void 0 ? void 0 : (_item$cards5 = item.cards) === null || _item$cards5 === void 0 ? void 0 : _item$cards5.map(function (element, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(ServicesGrid_Service, {
              item: element,
              popular: (item === null || item === void 0 ? void 0 : item.color) === 'gray'
            }, index);
          })
        })]
      }, index);
    })
  });
};

/* harmony default export */ var ServicesGrid_ServicesGrid = (ServicesGrid);

/***/ }),

/***/ 972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HG": function() { return /* reexport */ CheckCompatibility_CheckCompatibility; },
  "B$": function() { return /* reexport */ ServiceContent_ServiceContent; },
  "Su": function() { return /* reexport */ ServiceFiveGOperations_ServiceFiveGOperations; },
  "er": function() { return /* reexport */ ServiceReverse_ServiceReverse; },
  "yi": function() { return /* reexport */ ServiceSlider_ServiceSlider; },
  "am": function() { return /* reexport */ ServiceVideo_ServiceVideo; },
  "jW": function() { return /* reexport */ ServicesGrid/* default */.Z; },
  "bi": function() { return /* reexport */ ServicesOperations_ServicesOperations; },
  "IC": function() { return /* reexport */ ServicesTable_ServicesTable; }
});

// UNUSED EXPORTS: ServicesFaq, TextSection

// EXTERNAL MODULE: ./components/services/ServicesGrid/ServicesGrid.js + 1 modules
var ServicesGrid = __webpack_require__(84439);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/services/ServicesTable/ServicesTable.module.scss
var ServicesTable_module = __webpack_require__(62978);
var ServicesTable_module_default = /*#__PURE__*/__webpack_require__.n(ServicesTable_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/services/ServicesTable/ServicesTable.js






var ServicesTable = function ServicesTable(_ref) {
  var data = _ref.data,
      className = _ref.className,
      isHorisontal = _ref.isHorisontal;

  var renderTableItem = function renderTableItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ServicesTable_module_default()).table__elem,
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.text
    }, index);
  };

  var renderColumns = function renderColumns(item, index) {
    var _item$rows;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ServicesTable_module_default()).table__column,
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ServicesTable_module_default()).table__head,
        children: item === null || item === void 0 ? void 0 : item.title
      }), !!(item !== null && item !== void 0 && item.rows) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ServicesTable_module_default()).table__items,
        children: item === null || item === void 0 ? void 0 : (_item$rows = item.rows) === null || _item$rows === void 0 ? void 0 : _item$rows.map(renderTableItem)
      })]
    }, index);
  };

  var renderRows = function renderRows(item, index) {
    var _item$columns;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ServicesTable_module_default()).table__column,
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ServicesTable_module_default()).table__head,
        children: item === null || item === void 0 ? void 0 : item.title
      }), !!(item !== null && item !== void 0 && item.columns) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ServicesTable_module_default()).table__items,
        children: item === null || item === void 0 ? void 0 : (_item$columns = item.columns) === null || _item$columns === void 0 ? void 0 : _item$columns.map(renderTableItem)
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()([(ServicesTable_module_default()).table, className, (0,defineProperty/* default */.Z)({}, (ServicesTable_module_default())["table--horisontal"], isHorisontal)]),
    itemScope: true,
    itemType: "https://schema.org/Serivce",
    children: [!isHorisontal && (data === null || data === void 0 ? void 0 : data.columns) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ServicesTable_module_default()).table__inner,
      children: data.columns.map(renderColumns)
    }), (data === null || data === void 0 ? void 0 : data.rows) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ServicesTable_module_default()).table__inner,
      children: data.rows.map(renderRows)
    })]
  });
};

/* harmony default export */ var ServicesTable_ServicesTable = (ServicesTable);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
;// CONCATENATED MODULE: ./components/services/ServicesFaq/ServicesFaq.js







var ServicesFaq = function ServicesFaq(_ref) {
  var data = _ref.data,
      className = _ref.className;
  return /*#__PURE__*/_jsxs("section", {
    className: classNames(styles['service-faq'], className),
    itemScope: true,
    itemType: "https://schema.org/FAQPage",
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx(SectionTitle, {
      className: styles['service-faq__title'],
      titleModify: "title--large",
      Icon: InfoQuestion,
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.questions) && /*#__PURE__*/_jsx(Faq, {
      className: styles['service-faq__list'],
      items: data.questions
    })]
  });
};

/* harmony default export */ var ServicesFaq_ServicesFaq = ((/* unused pure expression or super */ null && (ServicesFaq)));
// EXTERNAL MODULE: ./components/services/ServicesOperations/ServicesOperations.module.scss
var ServicesOperations_module = __webpack_require__(29617);
var ServicesOperations_module_default = /*#__PURE__*/__webpack_require__.n(ServicesOperations_module);
;// CONCATENATED MODULE: ./components/services/ServicesOperations/ServicesOperations.js






var ServicesOperations = function ServicesOperations(_ref) {
  var _data$operations;

  var data = _ref.data,
      className = _ref.className;

  var renderOperationsItem = function renderOperationsItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (ServicesOperations_module_default()).operations__element,
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.text
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((ServicesOperations_module_default()).operations, className),
    itemScope: true,
    itemType: "https://schema.org/Service",
    children: [(data === null || data === void 0 ? void 0 : data.text) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
      className: classnames_default()((ServicesOperations_module_default()).operations__top_text),
      isHtml: true,
      children: data.text
    }), (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: (ServicesOperations_module_default()).operations__title,
      isHtml: true,
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
      className: classnames_default()((ServicesOperations_module_default()).operations__text, 'text--large'),
      isHtml: true,
      children: data.description
    }), (data === null || data === void 0 ? void 0 : data.operations) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: (ServicesOperations_module_default()).operations__list,
      children: data === null || data === void 0 ? void 0 : (_data$operations = data.operations) === null || _data$operations === void 0 ? void 0 : _data$operations.map(renderOperationsItem)
    })]
  });
};

/* harmony default export */ var ServicesOperations_ServicesOperations = (ServicesOperations);
// EXTERNAL MODULE: ./hooks/useBusiness.js
var useBusiness = __webpack_require__(97367);
// EXTERNAL MODULE: ./components/services/ServiceReverse/ServiceReverse.module.scss
var ServiceReverse_module = __webpack_require__(44684);
var ServiceReverse_module_default = /*#__PURE__*/__webpack_require__.n(ServiceReverse_module);
;// CONCATENATED MODULE: ./components/services/ServiceReverse/ServiceReverse.js









var ServiceReverse = function ServiceReverse(_ref) {
  var _data$items;

  var data = _ref.data,
      className = _ref.className,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? false : _ref$background;
  var isBusiness = (0,useBusiness/* useBusiness */.i)();

  var renderReverseItem = function renderReverseItem(item, index) {
    var _item$external_link, _classNames2;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
      className: classnames_default()((ServiceReverse_module_default())["reverse-item"], (0,defineProperty/* default */.Z)({}, (ServiceReverse_module_default()).business, isBusiness)),
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ServiceReverse_module_default())["reverse-item__content"],
        children: [(item === null || item === void 0 ? void 0 : item.top_text) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ServiceReverse_module_default())["reverse-item__category"],
          children: item.top_text
        }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
          titleModify: classnames_default()((ServiceReverse_module_default())["reverse-item__title"], 'title--medium'),
          icon: item === null || item === void 0 ? void 0 : item.icon,
          children: item.title
        }), (item === null || item === void 0 ? void 0 : item.content) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* TextBlock */.al, {
          className: (ServiceReverse_module_default()).description,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
              __html: item.content
            }
          }), (item === null || item === void 0 ? void 0 : item.button_text) && ((item === null || item === void 0 ? void 0 : item.slug) || (item === null || item === void 0 ? void 0 : item.external_link)) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
            Component: item !== null && item !== void 0 && item.external_link ? 'a' : 'router',
            size: 'normal',
            className: (ServiceReverse_module_default()).services_button,
            href: (_item$external_link = item === null || item === void 0 ? void 0 : item.external_link) !== null && _item$external_link !== void 0 ? _item$external_link : item === null || item === void 0 ? void 0 : item.slug,
            hasTarget: Boolean(item === null || item === void 0 ? void 0 : item.external_link),
            children: [item.button_text, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
              width: 24
            })]
          })]
        })]
      }), (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ServiceReverse_module_default())["reverse-item__img-wrap"], (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, (ServiceReverse_module_default()).dark, dark), (0,defineProperty/* default */.Z)(_classNames2, (ServiceReverse_module_default()).background, !background), _classNames2)),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ServiceReverse_module_default())["reverse-item__img"],
          style: {
            backgroundImage: "url(\"".concat(item.image, "\")")
          }
        }), Boolean(background) && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ServiceLogoBg */.qw, {
          className: (ServiceReverse_module_default())["reverse-item__bg"]
        })]
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((ServiceReverse_module_default())["service-reverse"], className),
    itemScope: true,
    itemType: "https://schema.org/Service",
    children: [(data === null || data === void 0 ? void 0 : data.text) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: (ServiceReverse_module_default())["service-reverse__title"],
      isHtml: true,
      icon: data === null || data === void 0 ? void 0 : data.icon,
      children: data.text
    }), (data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ServiceReverse_module_default())["service-reverse__inner"],
      children: data.items.map(renderReverseItem)
    })]
  });
};

/* harmony default export */ var ServiceReverse_ServiceReverse = (ServiceReverse);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
;// CONCATENATED MODULE: ./components/SvgComponents/PlayIcon.js


var PlayIcon = function PlayIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_2530_112419)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "60",
        cy: "60",
        r: "60",
        fill: "white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M70.9183 59.197C71.4569 59.5969 71.4569 60.4031 70.9183 60.803L54.9294 72.6717C54.2695 73.1615 53.3333 72.6905 53.3333 71.8687V48.1313C53.3333 47.3095 54.2695 46.8385 54.9294 47.3283L70.9183 59.197Z",
        fill: "#FF0037"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_2530_112419",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "120",
          height: "120",
          fill: "white"
        })
      })
    })]
  });
};
// EXTERNAL MODULE: ./components/services/ServiceVideo/ServiceVideo.module.scss
var ServiceVideo_module = __webpack_require__(65978);
var ServiceVideo_module_default = /*#__PURE__*/__webpack_require__.n(ServiceVideo_module);
;// CONCATENATED MODULE: ./components/services/ServiceVideo/ServiceVideo.js










var ServiceVideo = function ServiceVideo(_ref) {
  var data = _ref.data;
  var videoRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(true),
      visible = _useState[0],
      setVisible = _useState[1];

  var playHandler = function playHandler() {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setVisible(false);
    } else {
      videoRef.current.pause();
      setVisible(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ServiceVideo_module_default()).customWrapper,
    itemScope: true,
    itemType: "https://schema.org/VideoObject",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: classnames_default()([(ServiceVideo_module_default()).cover_youtube_video], 'wrapper'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ServiceVideo_module_default()).videoWrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("video", {
          onClick: playHandler,
          ref: videoRef,
          className: (ServiceVideo_module_default()).customVideo,
          width: "900",
          height: "560",
          poster: "/videoThumbnail.png",
          onEnded: function onEnded() {
            return setVisible(true);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
            src: "/assets/5gVideo.mp4"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: playHandler,
          className: classnames_default()((ServiceVideo_module_default()).controls, (0,defineProperty/* default */.Z)({}, (ServiceVideo_module_default()).hidden, !visible)),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlayIcon, {})
        })]
      }), (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* SectionTitle */.NZ, {
        titleModify: 'title--medium',
        className: (ServiceVideo_module_default()).title,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: data === null || data === void 0 ? void 0 : data.icon,
          height: 24,
          width: 24,
          alt: data === null || data === void 0 ? void 0 : data.title,
          title: data === null || data === void 0 ? void 0 : data.title
        }), data === null || data === void 0 ? void 0 : data.title]
      })]
    })
  });
};

/* harmony default export */ var ServiceVideo_ServiceVideo = (ServiceVideo);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(24666);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./components/ui/InputAutoComplete/InputAutoComplete.js
var InputAutoComplete = __webpack_require__(48807);
// EXTERNAL MODULE: ./components/services/CheckCompatibility/CheckCompatibility.module.scss
var CheckCompatibility_module = __webpack_require__(35414);
var CheckCompatibility_module_default = /*#__PURE__*/__webpack_require__.n(CheckCompatibility_module);
;// CONCATENATED MODULE: ./components/services/CheckCompatibility/CheckCompatibility.js












var CheckCompatibility = function CheckCompatibility(_ref) {
  var data = _ref.data,
      className = _ref.className;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(''),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = (0,react.useState)(null),
      available = _useState2[0],
      setAvailable = _useState2[1];

  var modelsNames = (0,react.useMemo)(function () {
    var _data$brands;

    var models = [];
    data === null || data === void 0 ? void 0 : (_data$brands = data.brands) === null || _data$brands === void 0 ? void 0 : _data$brands.map(function (item) {
      return item.models.forEach(function (model) {
        models = [].concat((0,toConsumableArray/* default */.Z)(models), [model]);
      });
    });
    return models;
  }, [data]);

  var onCheck = function onCheck() {
    setAvailable(modelsNames === null || modelsNames === void 0 ? void 0 : modelsNames.map(function (item) {
      var _item$name;

      return item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase();
    }).includes(value === null || value === void 0 ? void 0 : value.toLowerCase()));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(CheckCompatibility_module_default()).container, className, (CheckCompatibility_module_default()).volte__search]),
    itemScope: true,
    itemType: "https://schema.org/CheckAction",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: (CheckCompatibility_module_default()).volte__search__title,
      children: data === null || data === void 0 ? void 0 : data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
      className: (CheckCompatibility_module_default()).text,
      children: data === null || data === void 0 ? void 0 : data.description
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CheckCompatibility_module_default()).find,
      children: [available === null ? /*#__PURE__*/(0,jsx_runtime.jsx)(InputAutoComplete/* default */.Z, {
        setValue: setValue,
        value: value,
        onSelect: setValue,
        className: (CheckCompatibility_module_default()).input,
        models: modelsNames,
        placeholder: t('common:Device'),
        highlight: true
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()([(CheckCompatibility_module_default()).available, (0,defineProperty/* default */.Z)({}, (CheckCompatibility_module_default()).notAvailable, !available)]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(['label', (CheckCompatibility_module_default()).inputLabel]),
          children: data === null || data === void 0 ? void 0 : data.input_label
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (CheckCompatibility_module_default()).content,
          children: [available ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* AvailablePhone */.hy, {
            className: (CheckCompatibility_module_default()).active_check
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* NotAvailablePhone */.gH, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (CheckCompatibility_module_default()).title,
            children: value
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (CheckCompatibility_module_default()).close,
          "aria-label": "Bakcell",
          onClick: function onClick() {
            return setAvailable(null);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseSquare */.s9, {
            width: 15,
            height: 15
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
        disabled: !value,
        className: (CheckCompatibility_module_default()).button,
        onClick: onCheck,
        children: data === null || data === void 0 ? void 0 : data.button_text
      })]
    })]
  });
};

/* harmony default export */ var CheckCompatibility_CheckCompatibility = (CheckCompatibility);
// EXTERNAL MODULE: ./components/services/ServiceSlider/ServiceSlider.module.scss
var ServiceSlider_module = __webpack_require__(74568);
var ServiceSlider_module_default = /*#__PURE__*/__webpack_require__.n(ServiceSlider_module);
;// CONCATENATED MODULE: ./components/services/ServiceSlider/ServiceSlider.js







var ServiceSlider = function ServiceSlider(_ref) {
  var _data$images;

  var data = _ref.data,
      className = _ref.className;

  var renderSlide = function renderSlide(item, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: item === null || item === void 0 ? void 0 : item.image,
      alt: "icon",
      title: "icon",
      loading: "lazy",
      layout: "fill",
      itemScope: true,
      itemType: "https://schema.org/ImageObject"
    }, key);
  };

  var options = {
    slidesToShow: 1,
    infinite: true
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((ServiceSlider_module_default())["service-slider"], className),
    itemScope: true,
    itemType: "https://schema.org/ImageGallery",
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      titleModify: classnames_default()([(ServiceSlider_module_default())["service-slider__title"], 'title--medium']),
      children: data === null || data === void 0 ? void 0 : data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SliderWrapper */.h2, {
      arrows: true,
      options: options,
      children: data === null || data === void 0 ? void 0 : (_data$images = data.images) === null || _data$images === void 0 ? void 0 : _data$images.map(renderSlide)
    })]
  });
};

/* harmony default export */ var ServiceSlider_ServiceSlider = (ServiceSlider);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(4556);
// EXTERNAL MODULE: ./components/services/ServiceContent/ServiceContent.module.scss
var ServiceContent_module = __webpack_require__(33242);
var ServiceContent_module_default = /*#__PURE__*/__webpack_require__.n(ServiceContent_module);
;// CONCATENATED MODULE: ./components/services/ServiceContent/ServiceContent.js












var ServiceContent = function ServiceContent(_ref) {
  var data = _ref.data,
      className = _ref.className;
  var isImg = false;
  var router = (0,next_router.useRouter)();
  var isInternationalPage = router.query.dynamicPage.includes('international-calls');

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isImageLoaded = _React$useState2[0],
      setIsImageLoaded = _React$useState2[1];

  var renderListItem = function renderListItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (ServiceContent_module_default()).list_item,
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item
    }, index);
  };

  var renderAdditionalBlock = function () {
    var _data$additional, _data$additional$bull, _data$additional2, _data$additional2$num;

    if (data !== null && data !== void 0 && data.text) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: classnames_default()((ServiceContent_module_default())["service-content__text"], 'text--large'),
        itemScope: true,
        itemType: "https://schema.org/Text",
        children: data.text
      });
    }

    if ((data === null || data === void 0 ? void 0 : (_data$additional = data.additional) === null || _data$additional === void 0 ? void 0 : (_data$additional$bull = _data$additional.bulletList) === null || _data$additional$bull === void 0 ? void 0 : _data$additional$bull.length) > 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* List */.aV, {
        itemScope: true,
        itemType: "https://schema.org/ItemList",
        children: data.additional.bulletList.map(renderListItem)
      });
    }

    if ((data === null || data === void 0 ? void 0 : (_data$additional2 = data.additional) === null || _data$additional2 === void 0 ? void 0 : (_data$additional2$num = _data$additional2.numList) === null || _data$additional2$num === void 0 ? void 0 : _data$additional2$num.length) > 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* NumList */.Xt, {
        className: (ServiceContent_module_default())["service-content__num-list"],
        itemScope: true,
        itemType: "https://schema.org/ItemList",
        children: data.additional.numList.map(renderListItem)
      });
    }

    if (data !== null && data !== void 0 && data.image) {
      isImg = true;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ServiceContent_module_default())["service-content__img-wrapper"],
        itemScope: true,
        itemType: "https://schema.org/ImageGallery",
        children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
          width: 250,
          height: 250
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: (ServiceContent_module_default())["service-content__img"],
          src: data.image,
          alt: "icon",
          loading: "lazy",
          layout: "fill",
          onLoadingComplete: function onLoadingComplete() {
            return setIsImageLoaded(true);
          },
          style: {
            visibility: isImageLoaded ? 'visible' : 'hidden'
          }
        })]
      });
    }

    return false;
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()([(ServiceContent_module_default())["service-content"], className, 'section']),
    itemScope: true,
    itemType: "https://schema.org/Service",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(ServiceContent_module_default())["service-content__wrapper"], (0,defineProperty/* default */.Z)({}, (ServiceContent_module_default())["service-content__wrapper--row"], isImg)]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
          titleModify: classnames_default()((ServiceContent_module_default())["service-content__title"], 'title--medium'),
          icon: data === null || data === void 0 ? void 0 : data.icon,
          children: data.title
        }), (data === null || data === void 0 ? void 0 : data.content) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
          className: classnames_default()((ServiceContent_module_default())["service-content__text"], 'text--large', (0,defineProperty/* default */.Z)({}, (ServiceContent_module_default()).callPage, isInternationalPage)),
          isHtml: true,
          children: data.content
        })]
      }), renderAdditionalBlock]
    })
  });
};

/* harmony default export */ var ServiceContent_ServiceContent = (ServiceContent);
;// CONCATENATED MODULE: ./components/services/TextSection/TextSection.js







var TextSection = function TextSection(_ref) {
  var data = _ref.data,
      className = _ref.className;
  return /*#__PURE__*/_jsx("section", {
    className: classNames(styles['text-section'], className),
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['text-section__wrapper'],
      children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx(SectionTitle, {
        className: classNames(styles['text-section__title']),
        titleModify: 'title--large',
        Icon: Flash,
        children: data === null || data === void 0 ? void 0 : data.title
      }), (data === null || data === void 0 ? void 0 : data.text) && /*#__PURE__*/_jsx(TextBlock, {
        className: classNames(styles['text-section__content'], 'text--large'),
        isHtml: true,
        children: data.text
      })]
    })
  });
};

/* harmony default export */ var TextSection_TextSection = ((/* unused pure expression or super */ null && (TextSection)));
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle_SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./components/ui/TextBlock/TextBlock.js
var TextBlock_TextBlock = __webpack_require__(46202);
// EXTERNAL MODULE: ./components/services/ServiceFiveGOperations/ServiceFiveGOperations.module.scss
var ServiceFiveGOperations_module = __webpack_require__(94253);
var ServiceFiveGOperations_module_default = /*#__PURE__*/__webpack_require__.n(ServiceFiveGOperations_module);
;// CONCATENATED MODULE: ./components/services/ServiceFiveGOperations/ServiceFiveGOperations.js







var ServiceFiveGOperations = function ServiceFiveGOperations(_ref) {
  var _data$operations;

  var data = _ref.data,
      className = _ref.className;

  var renderOperationsItem = function renderOperationsItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (ServiceFiveGOperations_module_default()).operations__element,
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.text
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()(className),
    itemScope: true,
    itemType: "https://schema.org/Service",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ServiceFiveGOperations_module_default()).operations,
      children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
        className: (ServiceFiveGOperations_module_default()).operations__title,
        titleModify: "title--large",
        isHtml: true,
        children: data.title
      }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
        className: classnames_default()((ServiceFiveGOperations_module_default()).operations__text, 'text--large'),
        isHtml: true,
        children: data.description
      }), (data === null || data === void 0 ? void 0 : data.operations) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: (ServiceFiveGOperations_module_default()).operations__list,
        children: data === null || data === void 0 ? void 0 : (_data$operations = data.operations) === null || _data$operations === void 0 ? void 0 : _data$operations.map(renderOperationsItem)
      })]
    })
  });
};

/* harmony default export */ var ServiceFiveGOperations_ServiceFiveGOperations = (ServiceFiveGOperations);
;// CONCATENATED MODULE: ./components/services/index.js












/***/ }),

/***/ 64310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ho": function() { return /* reexport */ ChooseCategory_ChooseCategory; },
  "sc": function() { return /* reexport */ ChooseTopic_ChooseTopic; },
  "Vj": function() { return /* reexport */ SupportBanner_SupportBanner; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/support/ChooseCategory/ChooseCategory.module.scss
var ChooseCategory_module = __webpack_require__(57259);
var ChooseCategory_module_default = /*#__PURE__*/__webpack_require__.n(ChooseCategory_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/support/ChooseCategory/ChooseCategory.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var renderCategory = function renderCategory(item, key) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ChooseCategory_module_default()).category,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
      href: item === null || item === void 0 ? void 0 : item.slug,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        className: (ChooseCategory_module_default()).link,
        title: item === null || item === void 0 ? void 0 : item.title,
        "aria-label": item === null || item === void 0 ? void 0 : item.title,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ChooseCategory_module_default()).name,
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ChooseCategory_module_default()).arrow,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {})
        })]
      })
    })
  }, key);
};

var RenderItem = function RenderItem(item, key) {
  var _item$groups, _router$asPath;

  var router = (0,next_router.useRouter)();
  var categories = item === null || item === void 0 ? void 0 : (_item$groups = item.groups) === null || _item$groups === void 0 ? void 0 : _item$groups.map(function (cat) {
    return _objectSpread(_objectSpread({}, cat), {}, {
      link: "".concat(router.asPath, "/").concat(item === null || item === void 0 ? void 0 : item.slug, "/").concat(cat === null || cat === void 0 ? void 0 : cat.id)
    });
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ChooseCategory_module_default()).item,
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((ChooseCategory_module_default()).titleBlock, " grid-extend"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ChooseCategory_module_default()).icon,
        style: {
          background: router !== null && router !== void 0 && (_router$asPath = router.asPath) !== null && _router$asPath !== void 0 && _router$asPath.startsWith('/business') ? '#333' : '#f4f4f4'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: item === null || item === void 0 ? void 0 : item.icon,
          alt: "icon",
          title: "icon",
          loading: "lazy",
          layout: "fill"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ChooseCategory_module_default()).name,
        children: item === null || item === void 0 ? void 0 : item.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ChooseCategory_module_default()).link,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
          href: "".concat(router.asPath, "/").concat(item === null || item === void 0 ? void 0 : item.slug),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (ChooseCategory_module_default()).link,
            title: item === null || item === void 0 ? void 0 : item.button_text,
            "aria-label": item === null || item === void 0 ? void 0 : item.button_text,
            children: item === null || item === void 0 ? void 0 : item.button_text
          })
        })
      })]
    }), (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((ChooseCategory_module_default()).categories, " grid-extend"),
      children: categories.map(renderCategory)
    })]
  }, key);
};

var ChooseCategory = function ChooseCategory(_ref) {
  var _data$items;

  var data = _ref.data,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: className,
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
      className: (ChooseCategory_module_default()).title,
      icon: data === null || data === void 0 ? void 0 : data.icon,
      titleModify: "title--large",
      children: data === null || data === void 0 ? void 0 : data.title
    }), (data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(ChooseCategory_module_default()).list, 'grid-extend', 'equal', (0,defineProperty/* default */.Z)({}, (ChooseCategory_module_default()).dark, dark)]),
      children: data.items.map(RenderItem)
    })]
  });
};

/* harmony default export */ var ChooseCategory_ChooseCategory = (ChooseCategory);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./components/ui/SliderWrapper/SliderWrapper.js
var SliderWrapper = __webpack_require__(83234);
// EXTERNAL MODULE: ./components/support/ChooseTopic/ChooseTopic.module.scss
var ChooseTopic_module = __webpack_require__(71434);
var ChooseTopic_module_default = /*#__PURE__*/__webpack_require__.n(ChooseTopic_module);
;// CONCATENATED MODULE: ./components/support/ChooseTopic/ContentBlock.js










var SlickArrow = function SlickArrow(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: className,
    onClick: onClick,
    itemScope: true,
    itemType: "https://schema.org/NavigationElement",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (ChooseTopic_module_default()).arrowBlock,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {})
    })
  });
};

var Step = function Step(_ref2) {
  var step = _ref2.step;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.step,
    itemScope: true,
    itemType: "https://schema.org/HowToStep",
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: step.title
    }), /*#__PURE__*/_jsx("div", {
      className: styles.image,
      children: /*#__PURE__*/_jsx(Image, {
        src: step.img,
        alt: step.title,
        title: step.title,
        loading: "lazy",
        layout: "fill"
      })
    })]
  });
};

var ContentBlock = function ContentBlock(_ref3) {
  var _ref3$data = _ref3.data,
      _ref3$data$title = _ref3$data.title,
      name = _ref3$data$title === void 0 ? '' : _ref3$data$title,
      videos = _ref3$data.videos,
      _ref3$dark = _ref3.dark,
      dark = _ref3$dark === void 0 ? false : _ref3$dark;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ChooseTopic_module_default()).contentInner,
    itemScope: true,
    itemType: "https://schema.org/CreativeWork",
    children: [!!name && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (ChooseTopic_module_default()).title,
      children: name
    }), videos.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ChooseTopic_module_default()).videoSlider,
      itemScope: true,
      itemType: "https://schema.org/VideoGallery",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SliderWrapper/* default */.Z, {
        className: classnames_default()((ChooseTopic_module_default()).slider, (0,defineProperty/* default */.Z)({}, (ChooseTopic_module_default()).dark, dark)),
        options: {
          autoplay: false,
          slidesToShow: 1,
          infinite: true,
          arrows: true,
          dots: false,
          nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(SlickArrow, {
            className: 'slick-arrow slick-next'
          }),
          prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(SlickArrow, {
            className: 'slick-arrow slick-prev'
          }),
          responsive: null
        },
        children: videos.map(function (video, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Video */.nk, {
            video: video,
            className: (ChooseTopic_module_default()).video,
            icon: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* PlayEmpty */.$E, {})
          }, key);
        })
      })
    })]
  });
};

/* harmony default export */ var ChooseTopic_ContentBlock = (ContentBlock);
;// CONCATENATED MODULE: ./components/support/ChooseTopic/EmptyBlock.js





var EmptyBlock = function EmptyBlock() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ChooseTopic_module_default()).emptyBlock,
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ChooseTopic_module_default()).icon,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* List */.aV, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: 'Choose the topic'
    })]
  });
};

/* harmony default export */ var ChooseTopic_EmptyBlock = (EmptyBlock);
;// CONCATENATED MODULE: ./components/support/ChooseTopic/ChooseTopic.js











var ChooseTopic = function ChooseTopic(_ref) {
  var _pageData$subsections;

  var pageData = _ref.pageData,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark;

  var _useState = (0,react.useState)(),
      topics = _useState[0],
      setTopics = _useState[1];

  var _useState2 = (0,react.useState)(),
      topic = _useState2[0],
      setTopic = _useState2[1];

  var renderLinks = function renderLinks(list, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((ChooseTopic_module_default()).list, " grid-extend"),
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: list.map(function (item, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((ChooseTopic_module_default()).link, " ").concat(topic === item.id ? (ChooseTopic_module_default()).active : ''),
            onClick: function onClick() {
              setTopic(item.id);
              setTopics(item);
            },
            children: item.title
          }, (item === null || item === void 0 ? void 0 : item.id) || key), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            dangerouslySetInnerHTML: {
              __html: item.content
            }
          })]
        });
      })
    }, key);
  };

  var renderCategory = function renderCategory(item, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CollapsibleItem */.nu, {
      toggle: item === null || item === void 0 ? void 0 : item.title,
      content: renderLinks(item === null || item === void 0 ? void 0 : item.topics) // defaultStatus={category === item.link}
      ,
      className: classnames_default()([(ChooseTopic_module_default()).item, (0,defineProperty/* default */.Z)({}, (ChooseTopic_module_default()).dark, dark)]),
      itemScope: true,
      itemType: "https://schema.org/ItemList"
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ChooseTopic_module_default()).title,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        titleModify: "title--large",
        children: 'Choose the topic'
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((ChooseTopic_module_default()).container, " grid-extend"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat((ChooseTopic_module_default()).categories, " grid-extend"),
        children: pageData === null || pageData === void 0 ? void 0 : (_pageData$subsections = pageData.subsections) === null || _pageData$subsections === void 0 ? void 0 : _pageData$subsections.map(renderCategory)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()([(ChooseTopic_module_default()).content, (0,defineProperty/* default */.Z)({}, (ChooseTopic_module_default()).empty, !topic)]),
        itemScope: true,
        itemType: "https://schema.org/CreativeWork",
        children: topic ? /*#__PURE__*/(0,jsx_runtime.jsx)(ChooseTopic_ContentBlock, {
          dark: dark,
          data: topics
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ChooseTopic_EmptyBlock, {})
      })]
    })]
  });
};

/* harmony default export */ var ChooseTopic_ChooseTopic = (ChooseTopic);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(53431);
// EXTERNAL MODULE: ./domains/support/index.js + 1 modules
var support = __webpack_require__(13204);
// EXTERNAL MODULE: ./components/support/SupportBanner/SupportBanner.module.scss
var SupportBanner_module = __webpack_require__(29931);
var SupportBanner_module_default = /*#__PURE__*/__webpack_require__.n(SupportBanner_module);
;// CONCATENATED MODULE: ./components/support/SupportBanner/SupportBanner.js


/* eslint-disable no-alert */












var SupportBanner = function SupportBanner(_ref) {
  var item = _ref.item,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'white' : _ref$type;
  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,useTranslation/* default */.Z)('common'),
      t = _useTranslation.t;

  var _supportHooks$usePost = support/* hooks.usePostComment */.P.usePostComment(),
      _supportHooks$usePost2 = (0,slicedToArray/* default */.Z)(_supportHooks$usePost, 1),
      commentMutation = _supportHooks$usePost2[0];

  var FormSchema = es/* object */.Ry().shape({
    full_name: es/* string */.Z_().required(t('tariffSupport.fullName.placeHolder')),
    phone: es/* string */.Z_().required(t('tariffSupport.number.placeHolder')).length(12),
    email: es/* string */.Z_().required(t('tariffSupport.email.placeHolder')),
    agreement: es/* boolean */.O7().oneOf([true], t('tariffSupport.fullName.placeHolder'))
  });

  var _useState = (0,react.useState)(false),
      showSuccess = _useState[0],
      setShowSuccess = _useState[1];

  var _useState2 = (0,react.useState)(false),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  react.useEffect(function () {
    if (!router.isReady) return;
    setModalActive(!!router.query.openModal);
  }, [router.isReady, router.query.openModal, router.pathname]);
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      full_name: '',
      phone: '',
      email: '',
      comment: '',
      agreement: true
    },
    validationSchema: FormSchema,
    onSubmit: function onSubmit(values) {
      commentMutation(values).unwrap().then(function () {
        setModalActive(false);
        formik.resetForm();
        setShowSuccess(true);
      });
    }
  });

  var onCloseModal = function onCloseModal() {
    formik.resetForm();
    setModalActive(false);
  }; // console.log(formik.isValid);


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Banner */.jL, {
      item: item,
      onClick: function onClick() {
        return setModalActive(true);
      },
      type: type,
      itemScope: true,
      itemType: "https://schema.org/Offer"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Modal */.u_, {
      active: modalActive,
      setActive: onCloseModal,
      itemScope: true,
      itemType: "https://schema.org/ContactPage",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'title',
        children: t('tariffSupport.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'note',
        children: t('tariffSupport.desctription')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        className: "".concat((SupportBanner_module_default()).modalContent, " grid-extend equal"),
        onSubmit: formik.handleSubmit,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((SupportBanner_module_default()).field, " ").concat((SupportBanner_module_default()).half),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            onBlur: formik.handleBlur('full_name'),
            error: formik.touched.name && formik.errors.name,
            value: formik.values.name,
            onChange: function onChange(value) {
              return formik.setFieldValue('full_name', value);
            },
            label: t('tariffSupport.fullName.label'),
            placeholder: t('tariffSupport.fullName.placeHolder')
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((SupportBanner_module_default()).field, " ").concat((SupportBanner_module_default()).half),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            onBlur: formik.handleBlur('phone'),
            error: formik.touched.phone && formik.errors.phone,
            value: formik.values.phone,
            type: "tel",
            onChange: function onChange(value) {
              return formik.setFieldValue('phone', value);
            },
            label: t('tariffSupport.number.label'),
            placeholderMask: '+994',
            mask: '+\\9\\9\\4-99-999-99-99'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SupportBanner_module_default()).field,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            onBlur: formik.handleBlur('email'),
            error: formik.touched.email && formik.errors.email,
            value: formik.values.email,
            type: "email",
            onChange: function onChange(value) {
              return formik.setFieldValue('email', value);
            },
            label: t('tariffSupport.email.label'),
            placeholder: t('tariffSupport.email.placeHolder')
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((SupportBanner_module_default()).field, " ").concat((SupportBanner_module_default()).textarea),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Textarea */.gx, {
            onBlur: formik.handleBlur('comment'),
            error: formik.touched.comment && formik.errors.comment,
            value: formik.values.comment,
            onChange: function onChange(value) {
              return formik.setFieldValue('comment', value);
            },
            label: t('tariffSupport.comment.label'),
            placeholder: t('tariffSupport.comment.placeHolder')
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SupportBanner_module_default()).checkboxContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CheckboxWithTitle */.kP, {
            reverse: true,
            className: (SupportBanner_module_default()).checkbox,
            checked: formik.values.agreement,
            onChange: function onChange() {
              return formik.setFieldValue('agreement', !formik.values.agreement);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: {
                __html: t('tariffSupport.accept')
              }
            })
          }), formik.touched.agreement && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (SupportBanner_module_default()).error,
            children: formik.errors.agreement
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SupportBanner_module_default()).field,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            className: (SupportBanner_module_default()).button,
            type: 'submit',
            disabled: !formik.isValid,
            children: t('tariffSupport.send')
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InformationModal */.UI, {
      type: type,
      active: showSuccess,
      onClose: function onClose() {
        return setShowSuccess(false);
      },
      title: t('tariffSupport.success.title'),
      description: t('tariffSupport.success.description')
    })]
  });
};

/* harmony default export */ var SupportBanner_SupportBanner = (SupportBanner);
;// CONCATENATED MODULE: ./components/support/index.js




/***/ }),

/***/ 44952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eE": function() { return /* reexport */ FiltersBlock_FiltersBlock; },
  "Kp": function() { return /* reexport */ FindBundle_FindBundle; },
  "B3": function() { return /* reexport */ tariffs_InternetBlock_InternetBlock; },
  "lt": function() { return /* reexport */ SearchResult_SearchResult; },
  "Gn": function() { return /* reexport */ SingleTariffsContent_SingleTariffsContent; },
  "YF": function() { return /* reexport */ SingleTariffsTabs_SingleTariffsTabs; }
});

// UNUSED EXPORTS: TariffsBlock

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/tariffs/FiltersBlock/styles.module.scss
var styles_module = __webpack_require__(91265);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/tariffs/FiltersBlock/FiltersBlock.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react-hooks/exhaustive-deps */










var FiltersBlock = function FiltersBlock(_ref) {
  var type = _ref.type,
      subscription = _ref.subscription,
      advantages = _ref.advantages,
      applyText = _ref.applyText,
      resetText = _ref.resetText,
      maxText = _ref.maxText,
      minText = _ref.minText;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      from: '',
      to: '',
      type: '',
      subscription: '',
      advantages: ''
    },
    onSubmit: function onSubmit(values) {
      var type = values.type.map(function (item) {
        return item.id;
      });
      var subscription = values.subscription.map(function (item) {
        return item.id;
      });
      var advantages = values.advantages.map(function (item) {
        return item.id;
      });
      setOpen(false);
      router.push({
        pathname: router.pathname,
        query: _objectSpread(_objectSpread({}, router.query), {}, {
          priceFrom: values.from,
          priceTo: values.to,
          type: type.join(','),
          subscription: subscription.join(','),
          advantages: advantages.join(',')
        })
      }, undefined, {
        shallow: true
      });
    }
  });
  (0,react.useEffect)(function () {
    document.documentElement.classList[open ? 'add' : 'remove']('overflow');
  }, [open]);

  var getValueByType = function getValueByType(select, valueType) {
    var value = router.query[valueType];

    if (value) {
      return select.filter(function (item) {
        return value.includes(String(item.id));
      });
    }

    return [];
  };

  (0,react.useEffect)(function () {
    if (router.isReady) {
      formik.setValues({
        from: router.query.priceFrom || '',
        to: router.query.priceTo || '',
        type: getValueByType(type === null || type === void 0 ? void 0 : type.tags, 'type'),
        subscription: getValueByType(subscription === null || subscription === void 0 ? void 0 : subscription.tags, 'subscription'),
        advantages: getValueByType(advantages === null || advantages === void 0 ? void 0 : advantages.tags, 'advantages')
      });
    }
  }, [router.isReady, router.query]);

  var onCloseModal = function onCloseModal(event) {
    if (event.target.classList.contains((styles_module_default()).modal)) {
      setOpen(false);
    }
  };

  var resetForm = function resetForm() {
    router.replace({
      pathname: router.pathname,
      query: {
        dynamicPage: router.query.dynamicPage
      }
    }, undefined, {
      shallow: true
    });
    formik.resetForm({
      values: {
        from: '',
        to: '',
        type: [type[0]],
        subscription: [subscription[0]],
        advantages: [advantages[0]]
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (styles_module_default()).container,
    itemScope: true,
    itemType: "http://schema.org/ItemList",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: 'wrapper',
      onClick: onCloseModal,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
        "aria-label": "Bakcell",
        className: (styles_module_default()).filters,
        onClick: function onClick() {
          return setOpen(true);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Filter */.wn, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "Filter tariffs"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()([(styles_module_default()).modal, (0,defineProperty/* default */.Z)({}, (styles_module_default()).active, open)]),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (styles_module_default()).content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            "aria-label": "Bakcell",
            className: (styles_module_default()).close,
            onClick: function onClick() {
              return setOpen(false);
            },
            children: "Close"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (styles_module_default()).title,
            children: "Filters"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).dropdown,
            children: [type && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* DropDownFilter */.rc, {
              title: type.title,
              onSelect: function onSelect(item) {
                return formik.setFieldValue('type', item);
              },
              data: type.tags,
              active: formik.values.type
            }), subscription && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* DropDownFilter */.rc, {
              title: subscription.title,
              onSelect: function onSelect(item) {
                return formik.setFieldValue('subscription', item);
              },
              data: subscription.tags,
              active: formik.values.subscription
            }), advantages && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* DropDownFilter */.rc, {
              title: advantages.title,
              onSelect: function onSelect(item) {
                return formik.setFieldValue('advantages', item);
              },
              data: advantages.tags,
              active: formik.values.advantages
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (styles_module_default()).subtitle,
            children: "Price range"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((styles_module_default()).priceRange, " ").concat((styles_module_default()).separator),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
              title: minText,
              IconRight: SvgComponents/* Currency */.F,
              placeholder: '10',
              onChange: function onChange(value) {
                return formik.setFieldValue('from', value);
              },
              value: formik.values.from
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
              title: maxText,
              IconRight: SvgComponents/* Currency */.F,
              placeholder: '100',
              onChange: function onChange(value) {
                return formik.setFieldValue('to', value);
              },
              value: formik.values.to
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((styles_module_default()).buttons, " ").concat((styles_module_default()).separator),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              onClick: formik.handleSubmit,
              children: applyText
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              className: (styles_module_default()).reset,
              variant: 'text',
              onClick: resetForm,
              children: resetText
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var FiltersBlock_FiltersBlock = (FiltersBlock);
// EXTERNAL MODULE: ./components/home/index.js + 9 modules
var home = __webpack_require__(1822);
;// CONCATENATED MODULE: ./components/tariffs/TariffsBlock/TariffsBlock.js





var TariffsBlock = function TariffsBlock(_ref) {
  var tariffs = _ref.tariffs;

  var renderTariff = function renderTariff(item, index) {
    return item.tariffs && /*#__PURE__*/_jsx(Tariffs, {
      data: item.tariffs,
      title: item.title,
      itemScope: true,
      itemType: "http://schema.org/ListItem"
    }, index);
  };

  return /*#__PURE__*/_jsx("div", {
    className: classNames([styles.container, 'little-margin']),
    itemScope: true,
    itemType: "http://schema.org/ItemList",
    children: tariffs && tariffs.map(renderTariff)
  });
};

/* harmony default export */ var TariffsBlock_TariffsBlock = ((/* unused pure expression or super */ null && (TariffsBlock)));
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./components/tariffs/SearchResult/styles.module.scss
var SearchResult_styles_module = __webpack_require__(35239);
var SearchResult_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchResult_styles_module);
;// CONCATENATED MODULE: ./components/tariffs/SearchResult/SearchResult.js







var SearchResult = function SearchResult(_ref) {
  var data = _ref.data;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var renderTariff = function renderTariff(tariff, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TariffCard */.Sk, {
      item: tariff,
      itemScope: true,
      itemType: "http://schema.org/ListItem"
    }, "".concat(index, "_tariff"));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper',
    itemScope: true,
    itemType: "http://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SearchResult_styles_module_default()).title,
      children: t('common:searchResult')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SearchResult_styles_module_default()).content,
      children: data.map(renderTariff)
    })]
  });
};

/* harmony default export */ var SearchResult_SearchResult = (SearchResult);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./utils/axios.js
var axios = __webpack_require__(82373);
// EXTERNAL MODULE: ./components/tariffs/FindBundle/styles.module.scss
var FindBundle_styles_module = __webpack_require__(12514);
var FindBundle_styles_module_default = /*#__PURE__*/__webpack_require__.n(FindBundle_styles_module);
;// CONCATENATED MODULE: ./components/tariffs/FindBundle/FindBundleForm.js












var FindBundleForm = function FindBundleForm(_ref) {
  var _data$questions2, _formik$values3, _data$questions3;

  var data = _ref.data;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      lang = _useTranslation.lang;

  var questionsRef = react.useRef({});

  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      tariff = _React$useState2[0],
      setTariff = _React$useState2[1];

  var scrollToNextPage = react.useCallback(function () {
    var _questionsRef$current;

    questionsRef.current.gallery.scrollBy({
      top: 0,
      left: (_questionsRef$current = questionsRef.current['0']) === null || _questionsRef$current === void 0 ? void 0 : _questionsRef$current.clientWidth,
      behavior: 'smooth'
    });
  }, [questionsRef]);
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      answers: []
    }
  });

  var getFittedTariff = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var _tariff;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return axios/* default.post */.Z.post('tariffs/choice/', {
                answers: data
              }, {
                headers: {
                  'Accept-Language': lang
                }
              });

            case 3:
              _tariff = _context.sent;
              setTariff(_tariff.data);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              // eslint-disable-next-line no-console
              console.log(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function getFittedTariff(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  react.useEffect(function () {
    var _data$questions, _formik$values, _formik$values$answer;

    if ((data === null || data === void 0 ? void 0 : (_data$questions = data.questions) === null || _data$questions === void 0 ? void 0 : _data$questions.length) === (formik === null || formik === void 0 ? void 0 : (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : (_formik$values$answer = _formik$values.answers) === null || _formik$values$answer === void 0 ? void 0 : _formik$values$answer.length)) {
      var _formik$values2;

      getFittedTariff(formik === null || formik === void 0 ? void 0 : (_formik$values2 = formik.values) === null || _formik$values2 === void 0 ? void 0 : _formik$values2.answers);
    }
  }, [data === null || data === void 0 ? void 0 : (_data$questions2 = data.questions) === null || _data$questions2 === void 0 ? void 0 : _data$questions2.length, formik === null || formik === void 0 ? void 0 : (_formik$values3 = formik.values) === null || _formik$values3 === void 0 ? void 0 : _formik$values3.answers]);

  var renderQuestion = function renderQuestion(item, index) {
    var radioOnChange = function radioOnChange(id) {
      formik.setFieldValue("answers.".concat(index), id);
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: function ref(_ref3) {
        return questionsRef.current[index] = _ref3;
      },
      className: (FindBundle_styles_module_default()).question,
      itemScope: true,
      itemType: "http://schema.org/Article",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (FindBundle_styles_module_default()).title,
        children: item.text
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FindBundle_styles_module_default()).content,
        children: item.answers.map(function (checkbox, checkboxIndex) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* RadioWithTitle */.Xq, {
            checked: formik.values.answers.includes(checkbox.id),
            onChange: function onChange() {
              return radioOnChange(checkbox.id);
            },
            name: "".concat(index, "_question"),
            className: (FindBundle_styles_module_default()).input,
            children: checkbox.text
          }, "".concat(checkboxIndex, "_question"));
        })
      })]
    }, index);
  };

  if (tariff) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      itemScope: true,
      itemType: "http://schema.org/Offer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (FindBundle_styles_module_default()).title,
        children: [tariff.name, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (FindBundle_styles_module_default()).red,
          children: data === null || data === void 0 ? void 0 : data.result_title
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FindBundle_styles_module_default()).tariff,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TariffCard */.Sk, {
          item: tariff
        })
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    itemScope: true,
    itemType: "http://schema.org/WebPage",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (FindBundle_styles_module_default()).title,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        dangerouslySetInnerHTML: {
          __html: data === null || data === void 0 ? void 0 : data.title
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FindBundle_styles_module_default()).slider,
      ref: function ref(_ref4) {
        return questionsRef.current.gallery = _ref4;
      },
      children: data === null || data === void 0 ? void 0 : (_data$questions3 = data.questions) === null || _data$questions3 === void 0 ? void 0 : _data$questions3.map(renderQuestion)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FindBundle_styles_module_default()).button,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
        onClick: scrollToNextPage,
        children: "Next"
      })
    })]
  });
};

/* harmony default export */ var FindBundle_FindBundleForm = (FindBundleForm);
;// CONCATENATED MODULE: ./components/tariffs/FindBundle/FindBundle.js







var FindBundle = function FindBundle(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "http://schema.org/ItemList",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FindBundle_styles_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FindBundle_FindBundleForm, {
        data: data
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FindBundle_styles_module_default()).image,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: data === null || data === void 0 ? void 0 : data.image,
          alt: "bakcell",
          title: "bakcell",
          loading: "lazy",
          layout: "fill"
        })
      })]
    })
  });
};

/* harmony default export */ var FindBundle_FindBundle = (FindBundle);
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./components/ui/TextBlock/TextBlock.js
var TextBlock = __webpack_require__(46202);
// EXTERNAL MODULE: ./components/ui/AdditionalInformation/AdditionalInformation.module.scss
var AdditionalInformation_module = __webpack_require__(98260);
var AdditionalInformation_module_default = /*#__PURE__*/__webpack_require__.n(AdditionalInformation_module);
;// CONCATENATED MODULE: ./components/ui/AdditionalInformation/AdditionalInformation.js






var AdditionalInformation = function AdditionalInformation(_ref) {
  var _items$sections;

  var items = _ref.items;

  var renderItem = function renderItem(item, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((AdditionalInformation_module_default()).item, " ").concat((AdditionalInformation_module_default())[items.type]),
      itemScope: true,
      itemType: "https://schema.org/Information",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(['characteristics--image', (AdditionalInformation_module_default()).icon]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (AdditionalInformation_module_default()).nameBlock,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (AdditionalInformation_module_default()).name,
            children: item === null || item === void 0 ? void 0 : item.text
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (AdditionalInformation_module_default()).value,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (AdditionalInformation_module_default()).right_text,
          children: item === null || item === void 0 ? void 0 : item.right_text
        }), (item === null || item === void 0 ? void 0 : item.price_icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: item === null || item === void 0 ? void 0 : item.price_icon,
          alt: "price icon",
          title: "Price icon",
          width: 20,
          height: 20,
          loading: "lazy"
        })]
      })]
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (AdditionalInformation_module_default()).characteristics,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (AdditionalInformation_module_default()).containerTitle,
      children: items === null || items === void 0 ? void 0 : items.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (AdditionalInformation_module_default()).list,
      children: items === null || items === void 0 ? void 0 : (_items$sections = items.sections) === null || _items$sections === void 0 ? void 0 : _items$sections.map(renderItem)
    })]
  });
};

/* harmony default export */ var AdditionalInformation_AdditionalInformation = (AdditionalInformation);
// EXTERNAL MODULE: ./components/roaming/index.js + 12 modules
var roaming = __webpack_require__(4538);
// EXTERNAL MODULE: ./components/tariffs/SingleTariffsContent/styles.module.scss
var SingleTariffsContent_styles_module = __webpack_require__(58470);
var SingleTariffsContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(SingleTariffsContent_styles_module);
;// CONCATENATED MODULE: ./components/tariffs/SingleTariffsContent/SingleTariffsContent.js













var CaptionBlock = function CaptionBlock(_ref) {
  var captionData = _ref.captionData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SingleTariffsContent_styles_module_default())["caption-block"],
    itemScope: true,
    itemType: "http://schema.org/Article",
    children: [(captionData === null || captionData === void 0 ? void 0 : captionData.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
      titleModify: classnames_default()(['title--medium', (SingleTariffsContent_styles_module_default())["caption-block__title"]]),
      children: captionData.title
    }), (captionData === null || captionData === void 0 ? void 0 : captionData.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock/* default */.Z, {
      className: classnames_default()(['text--large', 'text--shadow-black', (SingleTariffsContent_styles_module_default())["caption-block__text"]]),
      children: captionData.description
    })]
  });
};

var InternetBlock = function InternetBlock(_ref2) {
  var contentData = _ref2.contentData;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SingleTariffsContent_styles_module_default()).internetContainer,
    itemScope: true,
    itemType: "http://schema.org/Service",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SingleTariffsContent_styles_module_default()).containerTitle,
      children: contentData === null || contentData === void 0 ? void 0 : contentData.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SingleTariffsContent_styles_module_default()).internetBlock,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SingleTariffsContent_styles_module_default()).internetInfo,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SingleTariffsContent_styles_module_default()).internetDescription,
          children: contentData === null || contentData === void 0 ? void 0 : contentData.description
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
          className: (SingleTariffsContent_styles_module_default()).button,
          Component: 'router',
          href: contentData === null || contentData === void 0 ? void 0 : contentData.button_slug,
          children: [contentData === null || contentData === void 0 ? void 0 : contentData.button_text, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
            width: 20
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SingleTariffsContent_styles_module_default()).internetImage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: contentData === null || contentData === void 0 ? void 0 : contentData.image,
          alt: contentData === null || contentData === void 0 ? void 0 : contentData.description,
          title: contentData === null || contentData === void 0 ? void 0 : contentData.description,
          loading: "lazy",
          layout: "fill"
        })
      })]
    })]
  });
};

var SingleTariffsContent = function SingleTariffsContent(_ref3) {
  var _data$general_informa, _data$general_informa2, _Object$keys, _data$general_informa3, _Object$keys2, _Object$keys3, _Object$keys4, _Object$keys5, _data$additional_info, _Object$keys6, _data$additional_info2, _data$special_notes, _Object$keys7, _data$special_notes2, _Object$keys8, _data$tariff;

  var data = _ref3.data;
  var isDataAvailable = !Object.values(data === null || data === void 0 ? void 0 : data.activation).every(function (value) {
    return !value;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (SingleTariffsContent_styles_module_default()).container,
    itemScope: true,
    itemType: "http://schema.org/Service",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: 'wrapper',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SingleTariffsContent_styles_module_default()).block,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SingleTariffsContent_styles_module_default()).infoBlock,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()([(SingleTariffsContent_styles_module_default()).characteristicsList, (0,defineProperty/* default */.Z)({}, (SingleTariffsContent_styles_module_default())["characteristicsList--small"], data.characteristics.caption)]),
            children: [(data === null || data === void 0 ? void 0 : (_data$general_informa = data.general_information) === null || _data$general_informa === void 0 ? void 0 : _data$general_informa.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(CaptionBlock, {
              captionData: data === null || data === void 0 ? void 0 : data.general_information
            }), (data === null || data === void 0 ? void 0 : (_data$general_informa2 = data.general_information) === null || _data$general_informa2 === void 0 ? void 0 : _data$general_informa2.sections) && ((_Object$keys = Object.keys(data === null || data === void 0 ? void 0 : (_data$general_informa3 = data.general_information) === null || _data$general_informa3 === void 0 ? void 0 : _data$general_informa3.sections)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(roaming/* Questions */.Gw, {
              questions: data === null || data === void 0 ? void 0 : data.general_information,
              className: "questions--small",
              titleModify: "title--medium",
              isSmall: true,
              hasGeneralInfo: true
            }), (data === null || data === void 0 ? void 0 : data.terms) && ((_Object$keys2 = Object.keys(data === null || data === void 0 ? void 0 : data.terms)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ProductStatus */.Pt, {
              statusData: data.terms,
              titleModify: "title--medium"
            }), (data === null || data === void 0 ? void 0 : data.quick_commands) && ((_Object$keys3 = Object.keys(data === null || data === void 0 ? void 0 : data.quick_commands)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ProductStatus */.Pt, {
              statusData: data === null || data === void 0 ? void 0 : data.quick_commands,
              titleModify: "title--medium"
            }), (data === null || data === void 0 ? void 0 : data.characteristics) && ((_Object$keys4 = Object.keys(data === null || data === void 0 ? void 0 : data.characteristics)) === null || _Object$keys4 === void 0 ? void 0 : _Object$keys4.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Characteristics */.Mt, {
              items: data.characteristics
            }), (data === null || data === void 0 ? void 0 : data.additional_information) && ((_Object$keys5 = Object.keys(data === null || data === void 0 ? void 0 : data.additional_information)) === null || _Object$keys5 === void 0 ? void 0 : _Object$keys5.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(AdditionalInformation_AdditionalInformation, {
              items: data === null || data === void 0 ? void 0 : data.additional_information
            }), (data === null || data === void 0 ? void 0 : (_data$additional_info = data.additional_information) === null || _data$additional_info === void 0 ? void 0 : _data$additional_info.points) && ((_Object$keys6 = Object.keys(data === null || data === void 0 ? void 0 : (_data$additional_info2 = data.additional_information) === null || _data$additional_info2 === void 0 ? void 0 : _data$additional_info2.points)) === null || _Object$keys6 === void 0 ? void 0 : _Object$keys6.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* HiddenList */.VC, {
              items: data === null || data === void 0 ? void 0 : data.additional_information
            }), (data === null || data === void 0 ? void 0 : (_data$special_notes = data.special_notes) === null || _data$special_notes === void 0 ? void 0 : _data$special_notes.sections) && ((_Object$keys7 = Object.keys(data === null || data === void 0 ? void 0 : (_data$special_notes2 = data.special_notes) === null || _data$special_notes2 === void 0 ? void 0 : _data$special_notes2.sections)) === null || _Object$keys7 === void 0 ? void 0 : _Object$keys7.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(roaming/* Questions */.Gw, {
              questions: data === null || data === void 0 ? void 0 : data.special_notes,
              titleModify: "title--medium",
              isSmall: true
            }), ((_Object$keys8 = Object.keys(data === null || data === void 0 ? void 0 : data.learn_more_banner)) === null || _Object$keys8 === void 0 ? void 0 : _Object$keys8.length) !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(InternetBlock, {
              contentData: data.learn_more_banner
            })]
          })
        }), isDataAvailable && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SingleTariffsContent_styles_module_default()).actionsBlock,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActivateBlock */.Fj, {
            data: data === null || data === void 0 ? void 0 : data.activation,
            tariff: data === null || data === void 0 ? void 0 : data.tariff,
            isSubscrable: data === null || data === void 0 ? void 0 : (_data$tariff = data.tariff) === null || _data$tariff === void 0 ? void 0 : _data$tariff.isSubscribable
          })
        })]
      })
    })
  });
};

/* harmony default export */ var SingleTariffsContent_SingleTariffsContent = (SingleTariffsContent);
// EXTERNAL MODULE: ./components/tariffs/SingleTariffsTabs/styles.module.scss
var SingleTariffsTabs_styles_module = __webpack_require__(41288);
var SingleTariffsTabs_styles_module_default = /*#__PURE__*/__webpack_require__.n(SingleTariffsTabs_styles_module);
;// CONCATENATED MODULE: ./components/tariffs/SingleTariffsTabs/SingleTariffsTabs.js







var SingleTariffsTabs = function SingleTariffsTabs(_ref) {
  var tabs = _ref.tabs;
  var router = (0,next_router.useRouter)();

  var renderTab = function renderTab(tab, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(SingleTariffsTabs_styles_module_default()).item, (0,defineProperty/* default */.Z)({}, (SingleTariffsTabs_styles_module_default()).active, router.asPath.substring(1) === (tab === null || tab === void 0 ? void 0 : tab.slug))]),
      itemScope: true,
      itemType: "http://schema.org/ListItem",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ActiveLink */.O$, {
        href: tab === null || tab === void 0 ? void 0 : tab.slug,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          title: tab === null || tab === void 0 ? void 0 : tab.text,
          "aria-label": tab === null || tab === void 0 ? void 0 : tab.text,
          children: tab === null || tab === void 0 ? void 0 : tab.text
        })
      })
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (SingleTariffsTabs_styles_module_default()).container,
    itemScope: true,
    itemType: "http://schema.org/ItemList",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: 'wrapper',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SingleTariffsTabs_styles_module_default()).list,
        children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab, key) {
          return renderTab(tab, key);
        })
      })
    })
  });
};

/* harmony default export */ var SingleTariffsTabs_SingleTariffsTabs = (SingleTariffsTabs);
// EXTERNAL MODULE: ./components/tariffs/InternetBlock/InternetBlock.module.scss
var InternetBlock_module = __webpack_require__(64357);
var InternetBlock_module_default = /*#__PURE__*/__webpack_require__.n(InternetBlock_module);
;// CONCATENATED MODULE: ./components/tariffs/InternetBlock/InternetBlock.js









var InternetBlock_InternetBlock = function InternetBlock(_ref) {
  var contentData = _ref.contentData,
      nonDesktop = _ref.nonDesktop;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(InternetBlock_module_default()).wrapper, (0,defineProperty/* default */.Z)({}, (InternetBlock_module_default()).nonDesktop, nonDesktop)]),
    itemScope: true,
    itemType: "http://schema.org/Service",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (InternetBlock_module_default()).internetBlock,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (InternetBlock_module_default()).internetInfo,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [(contentData === null || contentData === void 0 ? void 0 : contentData.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (InternetBlock_module_default()).internetTitle,
            children: contentData === null || contentData === void 0 ? void 0 : contentData.title
          }), (contentData === null || contentData === void 0 ? void 0 : contentData.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (InternetBlock_module_default()).internetDescription,
            children: contentData === null || contentData === void 0 ? void 0 : contentData.description
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
          className: (InternetBlock_module_default()).button,
          href: contentData === null || contentData === void 0 ? void 0 : contentData.button_slug,
          Component: contentData !== null && contentData !== void 0 && contentData.button_slug ? 'router' : 'button',
          children: [contentData === null || contentData === void 0 ? void 0 : contentData.button_text, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
            width: 20
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (InternetBlock_module_default()).internetImage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: contentData === null || contentData === void 0 ? void 0 : contentData.image,
          alt: "Bakcell",
          title: "Bakcell",
          loading: "lazy",
          layout: "fill"
        })
      })]
    })
  });
};

/* harmony default export */ var tariffs_InternetBlock_InternetBlock = (InternetBlock_InternetBlock);
;// CONCATENATED MODULE: ./components/tariffs/index.js








/***/ }),

/***/ 10411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14730);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62049);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57611);


var _excluded = ["children", "handleOpenMenu"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ActiveLink = function ActiveLink(_ref) {
  var children = _ref.children,
      handleOpenMenu = _ref.handleOpenMenu,
      props = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var child = react__WEBPACK_IMPORTED_MODULE_3__.Children.only(children);
  var className = child.props.className || '';

  if (router.asPath === props.href || !(props !== null && props !== void 0 && props.href)) {
    className = "".concat(className, " ").concat(props.activeClassName ? props.activeClassName : '').trim();
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
      className: className,
      children: child.props.children
    });
  }

  var _onClick = function onClick() {
    handleOpenMenu === null || handleOpenMenu === void 0 ? void 0 : handleOpenMenu();
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread(_objectSpread({}, props), {}, {
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.cloneElement(child, {
      className: className,
      onClick: function onClick() {
        return _onClick();
      }
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (ActiveLink);

/***/ }),

/***/ 39092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _about_us_DirectorItem_DirectorItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50723);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51633);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);




var sliderOptions = {
  slidesToShow: 3,
  infinite: true,
  responsive: [{
    breakpoint: 1400,
    settings: {
      arrows: false
    }
  }, {
    breakpoint: 960,
    settings: {
      arrows: false,
      slidesToShow: 2
    }
  }, {
    breakpoint: 640,
    settings: {
      arrows: false,
      slidesToShow: 1
    }
  }]
};

var BoardOfDirectors = function BoardOfDirectors(_ref) {
  var data = _ref.data;

  var renderDirectorItem = function renderDirectorItem(item, key) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_about_us_DirectorItem_DirectorItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      item: item,
      itemScope: true,
      itemType: "https://schema.org/Person"
    }, key);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_common__WEBPACK_IMPORTED_MODULE_2__/* .SliderContainer */ ._v, {
    title: data === null || data === void 0 ? void 0 : data.title,
    icon: data === null || data === void 0 ? void 0 : data.icon,
    options: sliderOptions,
    addClass: data.directors,
    itemScope: true,
    itemType: "https://schema.org/Organization",
    children: data === null || data === void 0 ? void 0 : data.directors.map(renderDirectorItem)
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BoardOfDirectors);

/***/ }),

/***/ 77743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33770);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _home_Banner_Banner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36896);
/* harmony import */ var _InformationModal_InformationModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92603);
/* harmony import */ var _ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50838);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57611);


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var DinamicModal = function DinamicModal(_ref) {
  var className = _ref.className,
      props = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var Component = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23303))["catch"](function () {
      return '';
    });
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(23303)];
      }
    }
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Component, _objectSpread({
    className: className,
    "data-testid": "modal"
  }, props));
};

var BusinessContactForm = function BusinessContactForm(_ref2) {
  var bannerData = _ref2.bannerData,
      _ref2$tariffID = _ref2.tariffID,
      tariffID = _ref2$tariffID === void 0 ? null : _ref2$tariffID,
      _ref2$employeeID = _ref2.employeeID,
      employeeID = _ref2$employeeID === void 0 ? '' : _ref2$employeeID,
      _ref2$activeModal = _ref2.activeModal,
      activeModal = _ref2$activeModal === void 0 ? false : _ref2$activeModal,
      _ref2$clearTariff = _ref2.clearTariff,
      clearTariff = _ref2$clearTariff === void 0 ? function () {
    return null;
  } : _ref2$clearTariff,
      _ref2$hasEmployeesCou = _ref2.hasEmployeesCount,
      hasEmployeesCount = _ref2$hasEmployeesCou === void 0 ? false : _ref2$hasEmployeesCou;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      modalActive = _useState[0],
      setModalActive = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showSuccess = _useState2[0],
      setShowSuccess = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (activeModal) {
      setModalActive(true);
    }
  }, [activeModal]);

  var closeModal = function closeModal() {
    setModalActive(false);
    clearTariff();
  };

  var showSuccessModal = function showSuccessModal() {
    closeModal();
    setShowSuccess(true);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: [bannerData && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_home_Banner_Banner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      buttonText: bannerData === null || bannerData === void 0 ? void 0 : bannerData.button_text,
      type: 'dark',
      item: bannerData,
      itemScope: true,
      itemType: "https://schema.org/Offer"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DinamicModal, {
      active: modalActive,
      setActive: closeModal,
      itemScope: true,
      itemType: "https://schema.org/ContactPage",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ContactForm_ContactForm__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        tariffID: tariffID,
        employeeID: employeeID,
        showSuccess: showSuccessModal,
        hasEmployeesCount: hasEmployeesCount
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_InformationModal_InformationModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      type: hasEmployeesCount ? 'dark' : 'white',
      active: showSuccess,
      onClose: function onClose() {
        return setShowSuccess(false);
      },
      description: t('common:successText'),
      itemScope: true,
      itemType: "https://schema.org/Information"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BusinessContactForm);

/***/ }),

/***/ 50838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35835);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34587);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61395);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67385);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53431);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82065);
/* harmony import */ var _utils_axios__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82373);
/* harmony import */ var _constants_base__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58165);
/* harmony import */ var _Input_Input__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88228);
/* harmony import */ var _Textarea_Textarea__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2158);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(440);
/* harmony import */ var _CheckboxWithTitle_CheckboxWithTitle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17974);
/* harmony import */ var _ScreenLoader_ScreenLoader__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78755);
/* harmony import */ var _InputWithSelect_InputWithSelect__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45604);
/* harmony import */ var _ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44114);
/* harmony import */ var _ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(57611);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var employees = [{
  id: 3,
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    i18nKey: 'common:Up to'
  }),
  value: 'up_to_10'
}, {
  id: 4,
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    i18nKey: 'common:From to'
  }),
  value: 'from_10'
}];

var ContactForm = function ContactForm(_ref) {
  var _ref$tariffID = _ref.tariffID,
      tariffID = _ref$tariffID === void 0 ? null : _ref$tariffID,
      _ref$showSuccess = _ref.showSuccess,
      showSuccess = _ref$showSuccess === void 0 ? function () {
    return null;
  } : _ref$showSuccess,
      _ref$employeeID = _ref.employeeID,
      employeeID = _ref$employeeID === void 0 ? '' : _ref$employeeID,
      _ref$hasEmployeesCoun = _ref.hasEmployeesCount,
      hasEmployeesCount = _ref$hasEmployeesCoun === void 0 ? true : _ref$hasEmployeesCoun;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(),
      asPath = _useRouter.asPath,
      route = _useRouter.route;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var isBusinessPage = route.startsWith('/business');
  var FormSchema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape(_objectSpread(_objectSpread({
    fullName: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().min(1).max(150).required(t('common:Required')),
    phone: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required(t('common:Required'))
  }, isBusinessPage && {
    company: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().min(1).max(150).required(t('common:Required'))
  }), {}, {
    email: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().email(t('common:Invalid email')).required(t('common:Invalid email')),
    comment: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_(),
    agreement: yup__WEBPACK_IMPORTED_MODULE_6__/* .boolean */ .O7().oneOf([true], t('common:Required'))
  }));
  var formik = (0,formik__WEBPACK_IMPORTED_MODULE_7__/* .useFormik */ .TA)({
    initialValues: _objectSpread(_objectSpread({
      fullName: '',
      phone: '',
      phoneNumberCode: _constants_base__WEBPACK_IMPORTED_MODULE_9__/* .customerPrefixes[0] */ .xF[0]
    }, isBusinessPage && {
      company: ''
    }), {}, {
      employees: employeeID || '',
      email: '',
      comment: '',
      tariff_id: '',
      agreement: true,
      path: asPath,
      employees_count: ''
    }, tariffID !== null ? {
      tariffID: tariffID
    } : {}),
    validationSchema: FormSchema,
    onSubmit: function () {
      var _onSubmit = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
        var _values$phoneNumberCo;

        var data, response;
        return _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  fullname: values === null || values === void 0 ? void 0 : values.fullName,
                  phone: "".concat(values === null || values === void 0 ? void 0 : (_values$phoneNumberCo = values.phoneNumberCode) === null || _values$phoneNumberCo === void 0 ? void 0 : _values$phoneNumberCo.name).concat(values === null || values === void 0 ? void 0 : values.phone),
                  title_of_company: (values === null || values === void 0 ? void 0 : values.company) || '',
                  email: values === null || values === void 0 ? void 0 : values.email,
                  comment: values === null || values === void 0 ? void 0 : values.comment,
                  employees_count: values === null || values === void 0 ? void 0 : values.employeesCount
                };
                _context.prev = 1;
                setLoading(true);
                _context.next = 5;
                return _utils_axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].post */ .Z.post('subscription-request', data);

              case 5:
                response = _context.sent;

                if (response) {
                  showSuccess();
                }

                _context.next = 11;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);

              case 11:
                _context.prev = 11;
                setLoading(false);
                setTimeout(formik.resetForm, 300);
                return _context.finish(11);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9, 11, 15]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var onClickHandler = function onClickHandler(id, value) {
    formik.setFieldValue('employees', id);
    formik.setFieldValue('employeesCount', value);
  };

  var renderEmployees = function renderEmployees(_ref2, key) {
    var _formik$values;

    var _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title,
        _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? '' : _ref2$value,
        _ref2$id = _ref2.id,
        id = _ref2$id === void 0 ? '' : _ref2$id;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("li", {
      className: ((_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.employees) === id ? (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().active) : '',
      onClick: function onClick() {
        return onClickHandler(id, value);
      },
      itemScope: true,
      itemType: "https://schema.org/Person",
      children: title
    }, key);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
    itemScope: true,
    itemType: "https://schema.org/Action",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_ScreenLoader_ScreenLoader__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
      visible: loading
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
      className: 'title',
      children: t('common:Contact')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
      className: 'note',
      children: t('common:Contact description')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
      className: (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_Input_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        onBlur: formik.handleBlur('fullName'),
        value: formik.values.fullName,
        onChange: function onChange(value) {
          return formik.setFieldValue('fullName', value);
        },
        placeholder: t('common:Fullname placeholder'),
        label: t('common:Fullname'),
        error: formik.touched.fullName && formik.errors.fullName
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_InputWithSelect_InputWithSelect__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        onBlur: formik.handleBlur('phone'),
        error: formik.touched.phone && formik.errors.phone,
        selected: formik.values.phoneNumberCode.name,
        label: t('common:Phone'),
        placeholder: 'XXX-XX-XX',
        mask: '999 99 99',
        options: _constants_base__WEBPACK_IMPORTED_MODULE_9__/* .customerPrefixes.slice */ .xF.slice(0, 2),
        value: formik.values.phoneNumber,
        onChange: function onChange(value) {
          return formik.setFieldValue('phone', value);
        },
        onSelect: function onSelect(value) {
          return formik.setFieldValue('phoneNumberCode', value);
        }
      }), isBusinessPage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_Input_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        onBlur: formik.handleBlur('company'),
        value: formik.values.company,
        onChange: function onChange(value) {
          return formik.setFieldValue('company', value);
        },
        placeholder: t('common:Company placeholder'),
        label: t('common:Company'),
        error: formik.touched.company && formik.errors.company
      }), !!employees.length && hasEmployeesCount && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
        className: (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().employees),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
          children: t('common:Employee count')
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("ul", {
          children: employees.map(renderEmployees)
        }), formik.touched.employees && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
          className: (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().error),
          children: formik.errors.employees
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_Input_Input__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        onBlur: formik.handleBlur('email'),
        value: formik.values.email,
        onChange: function onChange(value) {
          return formik.setFieldValue('email', value);
        },
        error: formik.touched.email && formik.errors.email,
        placeholder: t('common:Email placeholder'),
        type: 'email',
        label: t('common:Email')
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
        className: (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().textarea),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_Textarea_Textarea__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          value: formik.values.comment,
          error: formik.touched.comment && formik.errors.comment,
          onChange: function onChange(value) {
            return formik.setFieldValue('comment', value);
          },
          placeholder: t('common:Addition placeholder'),
          label: t('common:Additon')
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_CheckboxWithTitle_CheckboxWithTitle__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          reverse: true,
          className: (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().checkbox),
          checked: formik.values.agreement,
          onChange: function onChange() {
            return formik.setFieldValue('agreement', !formik.values.agreement);
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: t('common:tariffSupport.accept')
            }
          })
        }), formik.touched.agreement && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
          className: (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().error),
          children: formik.errors.agreement
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
        className: (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().buttonHolder),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          className: (_ContactForm_module_scss__WEBPACK_IMPORTED_MODULE_18___default().button),
          onClick: formik.handleSubmit,
          children: t('common:Send')
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ContactForm);

/***/ }),

/***/ 440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Variants */
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62049);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9536);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Button_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57611);


var _excluded = ["Component", "loading", "variant", "children", "size", "className", "onClick", "hasTarget", "download", "ariaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Variants;

(function (Variants) {
  Variants["trapezoidWhite"] = "trapezoidWhite";
  Variants["trapezoidRed"] = "trapezoidRed";
  Variants["trapezoid"] = "trapezoid";
  Variants["pill"] = "pill";
  Variants["secondary"] = "secondary";
  Variants["outline"] = "outline";
  Variants["text"] = "text";
  Variants["white"] = "white";
  Variants["gray"] = "gray";
  Variants["border"] = "border";
  Variants["black"] = "black";
  Variants["blocked"] = "blocked";
  Variants["transparent"] = "transparent";
})(Variants || (Variants = {}));

var ComponentVariants;

(function (ComponentVariants) {
  ComponentVariants["button"] = "button";
  ComponentVariants["a"] = "a";
  ComponentVariants["router"] = "router";
})(ComponentVariants || (ComponentVariants = {}));

var Size;

(function (Size) {
  Size["normal"] = "normal";
  Size["small"] = "small";
  Size["shortTrapezoid"] = "shortTrapezoid";
  Size["longTrapezoid"] = "longTrapezoid";
  Size["big"] = "big";
})(Size || (Size = {}));

var Button = function Button(_ref) {
  var _ref2;

  var _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? ComponentVariants.button : _ref$Component,
      loading = _ref.loading,
      variant = _ref.variant,
      children = _ref.children,
      size = _ref.size,
      className = _ref.className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick,
      _ref$hasTarget = _ref.hasTarget,
      hasTarget = _ref$hasTarget === void 0 ? false : _ref$hasTarget,
      _ref$download = _ref.download,
      download = _ref$download === void 0 ? false : _ref$download,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? children || 'Bakcell' : _ref$ariaLabel,
      restProps = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var classes = classnames__WEBPACK_IMPORTED_MODULE_3___default()([(_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button), (_ref2 = {}, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().trapezoidShort), size === Size.shortTrapezoid), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().trapezoidLong), size === Size.longTrapezoid), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().trapezoidWhite), variant === Variants.trapezoidWhite), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().trapezoidRed), variant === Variants.trapezoidRed), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().trapezoid), variant === Variants.trapezoid), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loading), loading), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pill), variant === Variants.pill), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondary), variant === Variants.secondary), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().outline), variant === Variants.outline), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().small), size === Size.small), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().normal), size === Size.normal), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().big), size === Size.big), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().textVariant), variant === Variants.text), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().white), variant === Variants.white), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().gray), variant === Variants.gray), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().border), variant === Variants.border), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().black), variant === Variants.black), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blocked), variant === Variants.blocked), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_6___default().transparent), variant === Variants.transparent), _ref2), className]);

  if (Component === ComponentVariants.router && restProps.href) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      href: "/".concat(restProps.href),
      itemScope: true,
      itemType: "https://schema.org/Property",
      children: hasTarget ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", _objectSpread(_objectSpread({
        className: classes,
        onClick: onClick,
        target: '_blank',
        download: download,
        title: 'Bakcell',
        "aria-label": "Bakcell"
      }, restProps), {}, {
        children: children
      })) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", _objectSpread(_objectSpread({
        className: classes,
        onClick: onClick,
        download: download,
        title: 'Bakcell',
        "aria-label": "Bakcell"
      }, restProps), {}, {
        children: children
      }))
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Component, _objectSpread(_objectSpread({
    className: classes,
    onClick: onClick
  }, restProps), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 67769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2844);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CheckboxWithText_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73137);
/* harmony import */ var _CheckboxWithText_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_CheckboxWithText_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);






var CheckboxWithText = function CheckboxWithText(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      checked = _ref.checked,
      name = _ref.name,
      className = _ref.className,
      titleClassName = _ref.titleClassName,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      isHtml = _ref.isHtml;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_CheckboxWithText_module_scss__WEBPACK_IMPORTED_MODULE_2___default().radio), className], (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_CheckboxWithText_module_scss__WEBPACK_IMPORTED_MODULE_2___default().large), size === 'large')),
    itemScope: true,
    itemType: "https://schema.org/CheckAction",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
      name: name,
      type: 'checkbox',
      onChange: onChange,
      checked: checked,
      "aria-label": name
    }), isHtml ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_CheckboxWithText_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkBoxTitle), titleClassName]),
      dangerouslySetInnerHTML: {
        __html: children
      }
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_CheckboxWithText_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkBoxTitle), titleClassName]),
      children: children
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CheckboxWithText);

/***/ }),

/***/ 17974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2844);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CheckboxWithTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86099);
/* harmony import */ var _CheckboxWithTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_CheckboxWithTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);






var CheckboxWithTitle = function CheckboxWithTitle(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      checked = _ref.checked,
      name = _ref.name,
      reverse = _ref.reverse,
      className = _ref.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_CheckboxWithTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().radio), className, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_CheckboxWithTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().reverse), reverse)),
    itemScope: true,
    itemType: "https://schema.org/CheckAction",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
      name: name,
      type: 'checkbox',
      onChange: onChange,
      value: false,
      checked: checked,
      "aria-label": name
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_CheckboxWithTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        children: children
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CheckboxWithTitle);

/***/ }),

/***/ 57787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2844);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _CircleIcon_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32388);
/* harmony import */ var _CircleIcon_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CircleIcon_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57611);






var CircleIcon = function CircleIcon(_ref) {
  var small = _ref.small,
      path = _ref.path,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'icon' : _ref$alt,
      isSmall = _ref.isSmall,
      className = _ref.className,
      children = _ref.children;

  var renderImgOrText = function () {
    if (children) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        className: (_CircleIcon_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["circle-icon__text"]),
        itemScope: true,
        itemType: "https://schema.org/Text",
        children: children
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([{
        'circle-icon--small': isSmall
      }, (_CircleIcon_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["circle-icon"])]),
      src: path,
      alt: alt,
      title: alt,
      width: 32,
      height: 32,
      loading: "lazy",
      itemScope: true,
      itemType: "https://schema.org/ImageObject"
    });
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, (_CircleIcon_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["circle-icon__wrapper"]), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_CircleIcon_module_scss__WEBPACK_IMPORTED_MODULE_3___default().small), small)),
    itemScope: true,
    itemType: "https://schema.org/Property",
    "data-testid": "circle-icon",
    children: renderImgOrText
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CircleIcon);

/***/ }),

/***/ 17783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84838);
/* harmony import */ var _Tabs_Tab__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15051);
/* harmony import */ var _Company_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35751);
/* harmony import */ var _Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Company_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57611);










var Company = function Company(_ref) {
  var _data$tabs$activeTab, _data$tabs;

  var data = _ref.data;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var renderTab = function renderTab(item, key) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Tabs_Tab__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().tab), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active), activeTab === key)]),
      onClick: function onClick() {
        return setActiveTab(key);
      },
      children: item.title
    }, key);
  };

  var renderTabContent = function renderTabContent(item, key) {
    var _item$items;

    var tabData = (item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items[0]) || {};
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .TabContentItem */ .Wp, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().tabContentItem), activeTab === 0)),
      itemScope: true,
      itemType: "https://schema.org/Article",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().info),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
          className: (_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: tabData === null || tabData === void 0 ? void 0 : tabData.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
          children: tabData === null || tabData === void 0 ? void 0 : tabData.content
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(___WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
          href: tabData === null || tabData === void 0 ? void 0 : tabData.slug,
          Component: 'router',
          size: "big",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            style: {
              marginRight: '10px'
            },
            children: tabData === null || tabData === void 0 ? void 0 : tabData.button_text
          }), ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: "/assets/ArrowRightDark.svg",
            alt: "arrow",
            title: "Arrow",
            width: 16,
            height: 16
          })]
        })]
      })
    }, key);
  };

  var curentTab = data === null || data === void 0 ? void 0 : (_data$tabs$activeTab = data.tabs[activeTab]) === null || _data$tabs$activeTab === void 0 ? void 0 : _data$tabs$activeTab.items[0];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: "".concat((_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().companyBlock), " wrapper section"),
    itemScope: true,
    itemType: "https://schema.org/Organization",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: (_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().note),
      children: curentTab === null || curentTab === void 0 ? void 0 : curentTab.name
    }), !!(data !== null && data !== void 0 && (_data$tabs = data.tabs) !== null && _data$tabs !== void 0 && _data$tabs.length) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(___WEBPACK_IMPORTED_MODULE_3__/* .Tabs */ .mQ, {
      active: activeTab,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .TabPanel */ .x4, {
        className: (_Company_module_scss__WEBPACK_IMPORTED_MODULE_6___default().tabToggles),
        children: data === null || data === void 0 ? void 0 : data.tabs.map(renderTab)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(___WEBPACK_IMPORTED_MODULE_3__/* .TabContent */ .I5, {
        children: data === null || data === void 0 ? void 0 : data.tabs.map(renderTabContent)
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Company);

/***/ }),

/***/ 54810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompatibleDevicesModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/ui/Modal/Modal.tsx
var Modal = __webpack_require__(23303);
// EXTERNAL MODULE: ./components/ui/Tabs/Tabs.js
var Tabs = __webpack_require__(5738);
// EXTERNAL MODULE: ./components/ui/Tabs/TabPanel.js
var TabPanel = __webpack_require__(59883);
// EXTERNAL MODULE: ./components/ui/Tabs/Tab.js
var Tab = __webpack_require__(15051);
// EXTERNAL MODULE: ./components/ui/Tabs/TabContent.js
var TabContent = __webpack_require__(17413);
// EXTERNAL MODULE: ./components/ui/Tabs/TabContentItem.js
var TabContentItem = __webpack_require__(42069);
// EXTERNAL MODULE: ./components/ui/CompatibleDevicesModal/Search.module.scss
var Search_module = __webpack_require__(44680);
var Search_module_default = /*#__PURE__*/__webpack_require__.n(Search_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/ui/CompatibleDevicesModal/SearchDevice.tsx
/* eslint-disable import/no-unresolved */





var Search = function Search(_ref) {
  var _onChange = _ref.onChange,
      value = _ref.value;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var inputEl = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    inputEl.current.focus();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
    className: (Search_module_default()).searchInput,
    itemScope: true,
    itemType: "https://schema.org/Action",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-100 d-flex align-items-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        "data-testid": 'search-input',
        autoFocus: true,
        ref: inputEl,
        type: "text",
        placeholder: t('esim:checkout.modals.devices.search'),
        value: value,
        className: "w-100",
        onChange: function onChange(e) {
          _onChange(e.target.value);
        },
        "aria-label": value
      })
    })
  });
};

/* harmony default export */ var SearchDevice = (Search);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/ui/CompatibleDevicesModal/CompatibleDevicesModal.module.scss
var CompatibleDevicesModal_module = __webpack_require__(88155);
var CompatibleDevicesModal_module_default = /*#__PURE__*/__webpack_require__.n(CompatibleDevicesModal_module);
;// CONCATENATED MODULE: ./components/ui/CompatibleDevicesModal/CompatibleDevicesModal.js



/* eslint-disable eqeqeq */

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable no-unused-expressions */















var CompatibleDevicesModalEsim = function CompatibleDevicesModalEsim(_ref) {
  var active = _ref.active,
      setActive = _ref.setActive,
      devices = _ref.devices,
      getItem = _ref.getItem,
      choose = _ref.choose;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  var _useState = (0,react.useState)(''),
      searchText = _useState[0],
      setSearchText = _useState[1];

  var _useState2 = (0,react.useState)(false),
      notFound = _useState2[0],
      setNotFound = _useState2[1];

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var devicesData = (0,react.useMemo)(function () {
    var result = devices === null || devices === void 0 ? void 0 : devices.map(function (item) {
      var _item$supportedDevice, _item$supportedDevice2, _item$name$toLowerCas2;

      var mutationData = item === null || item === void 0 ? void 0 : (_item$supportedDevice = item.supportedDevicesResponseList) === null || _item$supportedDevice === void 0 ? void 0 : _item$supportedDevice.filter(function (item) {
        var _item$name, _item$name$toLowerCas;

        return item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : (_item$name$toLowerCas = _item$name.toLowerCase()) === null || _item$name$toLowerCas === void 0 ? void 0 : _item$name$toLowerCas.includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase());
      });

      if ((item === null || item === void 0 ? void 0 : (_item$supportedDevice2 = item.supportedDevicesResponseList) === null || _item$supportedDevice2 === void 0 ? void 0 : _item$supportedDevice2.length) > 0 && (mutationData === null || mutationData === void 0 ? void 0 : mutationData.length) > 0) {
        setActiveTab(item === null || item === void 0 ? void 0 : item.id);
      }

      searchText ? (item === null || item === void 0 ? void 0 : (_item$name$toLowerCas2 = item.name.toLowerCase()) === null || _item$name$toLowerCas2 === void 0 ? void 0 : _item$name$toLowerCas2.startsWith(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) && setActiveTab(item === null || item === void 0 ? void 0 : item.id) : setActiveTab(0);
      return {
        name: item === null || item === void 0 ? void 0 : item.name,
        supportedDevicesResponseList: mutationData
      };
    });

    if (result !== null && result !== void 0 && result.every(function (item) {
      var _item$supportedDevice3;

      return (item === null || item === void 0 ? void 0 : (_item$supportedDevice3 = item.supportedDevicesResponseList) === null || _item$supportedDevice3 === void 0 ? void 0 : _item$supportedDevice3.length) === 0;
    })) {
      setNotFound(true);
    } else {
      setNotFound(false);
    }

    return result;
  }, [devices, searchText]);

  var handleChange = function handleChange(event, newValue) {
    setActiveTab(newValue);
  };

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tab/* default */.Z, {
      className: classnames_default()((CompatibleDevicesModal_module_default()).tab, (0,defineProperty/* default */.Z)({}, (CompatibleDevicesModal_module_default()).tab__notFound, notFound && activeTab === index)),
      onClick: function onClick() {
        setActiveTab(index);
        setSearchText('');
      },
      children: item === null || item === void 0 ? void 0 : item.name
    }, index);
  };

  var renderListItem = function renderListItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CompatibleDevicesModal_module_default()).item,
      onClick: function onClick() {
        setSearchText(item === null || item === void 0 ? void 0 : item.name);
        choose && getItem(item === null || item === void 0 ? void 0 : item.name);
      },
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.name
    }, index);
  };

  var renderTabContent = function renderTabContent(item, index) {
    var _item$supportedDevice4, _item$supportedDevice5;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(TabContentItem/* default */.Z, {
      "data-testid": 'device-modal-content',
      className: (CompatibleDevicesModal_module_default()).content,
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: (item === null || item === void 0 ? void 0 : (_item$supportedDevice4 = item.supportedDevicesResponseList) === null || _item$supportedDevice4 === void 0 ? void 0 : _item$supportedDevice4.length) > 0 ? item === null || item === void 0 ? void 0 : (_item$supportedDevice5 = item.supportedDevicesResponseList) === null || _item$supportedDevice5 === void 0 ? void 0 : _item$supportedDevice5.map(renderListItem) : /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: 'text--large no-data',
        children: t('esim:common.deviceNotFound')
      })
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal["default"], {
    active: active,
    setActive: setActive,
    classNameInner: (CompatibleDevicesModal_module_default()).modal,
    itemScope: true,
    itemType: "https://schema.org/Product",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
      className: 'title',
      children: t('esim:checkout.modals.devices.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchDevice, {
      onChange: function onChange(e) {
        setSearchText(e);
      },
      value: searchText
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
      active: activeTab,
      onChange: handleChange,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TabPanel/* default */.Z, {
        className: (CompatibleDevicesModal_module_default()).panel,
        children: devicesData === null || devicesData === void 0 ? void 0 : devicesData.map(renderTab)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabContent/* default */.Z, {
        children: devicesData === null || devicesData === void 0 ? void 0 : devicesData.map(renderTabContent)
      })]
    })]
  });
};

/* harmony default export */ var CompatibleDevicesModal = (CompatibleDevicesModalEsim);

/***/ }),

/***/ 28053:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9605);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CheckboxWithText_CheckboxWithText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67769);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57611);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @next/next/no-sync-scripts */









var initData = function initData() {
  var _window$mapboxgl;

  if (!((_window$mapboxgl = window.mapboxgl) !== null && _window$mapboxgl !== void 0 && _window$mapboxgl.Map)) return; // todo: move to environments

  window.mapboxgl.accessToken = 'pk.eyJ1IjoiYXJ0ZWZhbiIsImEiOiJjbDhkZHE3MTIxOWdpM3FuMzcxbDZxNHJqIn0.5GN-r6qgMwLriHS6pfmIxw'; // innit map, set default configuration

  var map = new window.mapboxgl.Map({
    container: 'coverage-map',
    style: 'mapbox://styles/mapbox/light-v10',
    maxZoom: 13,
    minZoom: 9,
    zoom: 11,
    center: [49.81567, 40.3763]
  }); // event

  map.on('load', function () {
    // add source
    map.addSource('3g', {
      type: 'image',
      url: 'https://i.imgur.com/znmJXGh.png',
      coordinates: [[49.646483, 40.504969], [50.116149, 40.512278], [50.131942, 40.270141], [49.663239, 40.273333]]
    }); // add layer. source is "map.addSource( this -> '3g'....."

    map.addLayer({
      id: '3g',
      type: 'raster',
      source: '3g',
      paint: {
        'raster-fade-duration': 0
      }
    }); // another source and layer ....

    map.addSource('4g', {
      type: 'image',
      url: 'https://i.imgur.com/c9atFqV.png',
      coordinates: [[49.469969, 40.565722], [50.341146, 40.609576], [50.351046, 40.304505], [49.619662, 40.281301]]
    });
    map.addLayer({
      id: '4g',
      type: 'raster',
      source: '4g',
      paint: {
        'raster-fade-duration': 0
      }
    });
  });
  return map;
};

var CoverageMap = function CoverageMap() {
  var router = useRouter();
  var mapRef = React.useRef(null); // todo: replace to data from backend

  var _React$useState = React.useState({
    '3g': true,
    '4g': true
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeState = _React$useState2[0],
      setActiveState = _React$useState2[1];

  React.useEffect(function () {
    if (!router.isReady) return;
    setTimeout(function () {
      mapRef.current = initData();
    }, 1000);
    return function () {
      mapRef.current = null;
    };
  }, [router.isReady]); // todo: type === key from activeState === layer id

  var _onClick = function onClick(type) {
    if (activeState[type]) {
      mapRef.current.setLayoutProperty(type, 'visibility', 'none');
    } else {
      mapRef.current.setLayoutProperty(type, 'visibility', 'visible');
    }

    setActiveState(_objectSpread(_objectSpread({}, activeState), {}, _defineProperty({}, type, !activeState[type])));
  }; // todo: create renderLayerButton method


  return /*#__PURE__*/_jsxs("div", {
    className: styles.map,
    itemScope: true,
    itemType: "https://schema.org/Map",
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "initial-scale=1"
      }), /*#__PURE__*/_jsx("link", {
        href: "https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.css",
        rel: "stylesheet"
      }), /*#__PURE__*/_jsx("script", {
        src: "https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.js"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.buttons,
        children: [/*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            return _onClick('3g');
          },
          className: classNames([styles.button, _defineProperty({}, styles.active, activeState['3g'])]),
          "aria-label": "3G",
          children: /*#__PURE__*/_jsx(CheckboxWithText, {
            titleClassName: styles.checkboxTitle,
            className: styles.checkbox,
            checked: activeState['3g'],
            children: /*#__PURE__*/_jsx("span", {
              className: styles.text,
              children: "3G"
            })
          })
        }), /*#__PURE__*/_jsx("button", {
          onClick: function onClick() {
            return _onClick('4g');
          },
          className: classNames([styles.button, _defineProperty({}, styles.active, activeState['4g'])]),
          "aria-label": "4G",
          children: /*#__PURE__*/_jsx(CheckboxWithText, {
            titleClassName: styles.checkboxTitle,
            className: styles.checkbox,
            checked: activeState['4g'],
            children: /*#__PURE__*/_jsx("span", {
              className: styles.text,
              children: "4G"
            })
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.map,
        id: "coverage-map"
      })]
    })]
  });
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CoverageMap)));

/***/ }),

/***/ 94033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61395);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24052);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(440);
/* harmony import */ var _Select_Select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54713);
/* harmony import */ var _OwnPhoneInput_OwnPhoneInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13507);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84838);
/* harmony import */ var _CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76823);
/* harmony import */ var _CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57611);











var CreateOwnPhoneInput = function CreateOwnPhoneInput(_ref) {
  var _detail$search_button;

  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      _onChange = _ref.onChange,
      sortValue = _ref.sortValue,
      onSelect = _ref.onSelect,
      sortData = _ref.sortData,
      onSubmit = _ref.onSubmit,
      tabs = _ref.tabs,
      loadMore = _ref.loadMore,
      data = _ref.data,
      isLoading = _ref.isLoading,
      totalPage = _ref.totalPage,
      detail = _ref.detail,
      resetFields = _ref.resetFields,
      _ref$isEsim = _ref.isEsim,
      isEsim = _ref$isEsim === void 0 ? true : _ref$isEsim;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: (_CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8___default().container),
    itemScope: true,
    itemType: "http://schema.org/CreativeWork",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: (_CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sortContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sortInput),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          className: (_CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8___default().select),
          value: sortValue,
          data: sortData,
          onChange: function onChange(e) {
            return onSelect(e);
          }
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_OwnPhoneInput_OwnPhoneInput__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        inputClass: (_CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8___default().search_input_number),
        value: value,
        onChange: function onChange(val) {
          return _onChange(val);
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8___default().buttons),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          "data-testid": 'numbersale-submit',
          onClick: onSubmit,
          children: (_detail$search_button = detail === null || detail === void 0 ? void 0 : detail.search_button_text) !== null && _detail$search_button !== void 0 ? _detail$search_button : t('common:Search')
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          "data-testid": 'numbersale-refresh',
          className: (_CreateOwnPhoneInput_module_scss__WEBPACK_IMPORTED_MODULE_8___default().refresh),
          onClick: resetFields,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_2__/* .Refresh */ .hY, {})
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      children: (data === null || data === void 0 ? void 0 : data.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_index__WEBPACK_IMPORTED_MODULE_6__/* .YourNumberList */ .YO, {
        titles: true,
        tabs: tabs !== null && tabs !== void 0 ? tabs : [],
        list: data,
        loadMore: loadMore,
        isLoading: isLoading,
        totalPage: totalPage,
        detail: detail,
        isEsim: isEsim
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_index__WEBPACK_IMPORTED_MODULE_6__/* .TextBlock */ .al, {
        className: 'text--large no-data',
        children: t('esim:common.numberNotFound')
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CreateOwnPhoneInput);

/***/ }),

/***/ 78385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12420);
/* harmony import */ var _enums_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29128);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24052);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29305);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57611);


/* eslint-disable react/jsx-key */









var DayNightSwitch = function DayNightSwitch() {
  var themeIcons = [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .Sun */ .kO, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .Moon */ .JF, {})];

  var _useTheme = (0,next_themes__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .F)(),
      theme = _useTheme.theme,
      setTheme = _useTheme.setTheme;

  var isLightMode = theme === _enums_theme__WEBPACK_IMPORTED_MODULE_3__/* .ETheme.LIGHT_MODE */ .X.LIGHT_MODE;

  if (false) {}

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
    itemScope: true,
    itemType: "http://schema.org/Thing",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().indicator))
    }), themeIcons.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("button", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button)], (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active), index === 0 && isLightMode || index === 1 && !isLightMode)),
        onClick: function onClick() {
          setTheme(theme === _enums_theme__WEBPACK_IMPORTED_MODULE_3__/* .ETheme.LIGHT_MODE */ .X.LIGHT_MODE ? _enums_theme__WEBPACK_IMPORTED_MODULE_3__/* .ETheme.DARK_MODE */ .X.DARK_MODE : _enums_theme__WEBPACK_IMPORTED_MODULE_3__/* .ETheme.LIGHT_MODE */ .X.LIGHT_MODE);
        },
        "data-testid": "switch-".concat(index === 0 ? 'light' : 'dark'),
        "aria-label": item,
        children: item
      }, index);
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (DayNightSwitch);

/***/ }),

/***/ 83797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98431);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24052);
/* harmony import */ var _SectionTitle_SectionTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66850);
/* harmony import */ var _TextBlock_TextBlock__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46202);
/* harmony import */ var _Tabs_Tabs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5738);
/* harmony import */ var _Tabs_TabPanel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59883);
/* harmony import */ var _Tabs_Tab__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15051);
/* harmony import */ var _Tabs_TabContent__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17413);
/* harmony import */ var _Tabs_TabContentItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42069);
/* harmony import */ var _SliderWrapper_SliderWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83234);
/* harmony import */ var _DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8283);
/* harmony import */ var _DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57611);

















var CardBlock = function CardBlock(_ref) {
  var data = _ref.data,
      className = _ref.className;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(0),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  var renderButtonsList = function renderButtonsList(item, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("a", {
      title: item === null || item === void 0 ? void 0 : item.text,
      "aria-label": item === null || item === void 0 ? void 0 : item.text,
      href: item === null || item === void 0 ? void 0 : item.file,
      download: true,
      className: (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default().button),
      itemScope: true,
      itemType: "https://schema.org/ImageGallery",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("span", {
        className: (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default().documentIcon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
          src: item === null || item === void 0 ? void 0 : item.icon,
          width: 24,
          height: 24,
          alt: item.text,
          title: item.text,
          loading: "lazy"
        })
      }), item.text, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("span", {
        className: (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default().arrowIcon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_3__/* .ArrRight */ .jG, {
          width: 24
        })
      })]
    }, index);
  };

  var renderCardItem = function renderCardItem(item, index) {
    var _item$buttons;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("article", {
      className: (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["document-card"]),
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["document-card__content"]),
        children: [(item === null || item === void 0 ? void 0 : item.year) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_SectionTitle_SectionTitle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          titleModify: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["document-card__year"]), 'title--medium'),
          children: item.year
        }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_TextBlock_TextBlock__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["document-card__desc"]), 'text--large'),
          children: item.title
        })]
      }), (item === null || item === void 0 ? void 0 : (_item$buttons = item.buttons) === null || _item$buttons === void 0 ? void 0 : _item$buttons.length) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        className: (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["document-card__buttons"]),
        children: item === null || item === void 0 ? void 0 : item.buttons.map(renderButtonsList)
      })]
    }, index);
  };

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_Tabs_Tab__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      onClick: function onClick() {
        return setActiveTab(index);
      },
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: item.title
    }, index);
  };

  var renderContent = function renderContent(item, index) {
    var _data$tariffs, _item$items;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_Tabs_TabContentItem__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      className: (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tabContent),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_SliderWrapper_SliderWrapper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        className: (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["document-cards__slider"]),
        options: {
          infinite: (data === null || data === void 0 ? void 0 : (_data$tariffs = data.tariffs) === null || _data$tariffs === void 0 ? void 0 : _data$tariffs.length) > 2
        },
        arrows: true,
        children: item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.map(renderCardItem)
      })
    }, index);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["document-cards"]), className),
    itemScope: true,
    itemType: "https://schema.org/Information",
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_SectionTitle_SectionTitle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('wrapper', (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["document-cards__title"]), 'title--large'),
      icon: data === null || data === void 0 ? void 0 : data.icon,
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.tabs) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_Tabs_Tabs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      active: activeTab,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_Tabs_TabPanel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(['wrapper', (_DocumentCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tabPanel)]),
        children: data === null || data === void 0 ? void 0 : data.tabs.map(renderTab)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_Tabs_TabContent__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        children: data === null || data === void 0 ? void 0 : data.tabs.map(renderContent)
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CardBlock);

/***/ }),

/***/ 88717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24052);
/* harmony import */ var _GoBack_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21784);
/* harmony import */ var _GoBack_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_GoBack_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);







var GoBack = function GoBack(_ref) {
  var children = _ref.children,
      goBack = _ref.goBack,
      className = _ref.className;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("button", {
    "aria-label": "Bakcell",
    onClick: goBack || router.back,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_GoBack_module_scss__WEBPACK_IMPORTED_MODULE_4___default().goBack), className]),
    itemScope: true,
    itemType: "http://schema.org/Thing",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_2__/* .ArrowRight */ .ol, {
      width: 16
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      children: children
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GoBack);

/***/ }),

/***/ 74715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _GridProducts_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95177);
/* harmony import */ var _GridProducts_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_GridProducts_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);




var GridProducts = function GridProducts(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(['wrapper', className]),
    itemScope: true,
    itemType: "http://schema.org/Product",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_GridProducts_module_scss__WEBPACK_IMPORTED_MODULE_2___default().grid),
      children: children
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GridProducts);

/***/ }),

/***/ 31111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98431);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12420);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16814);
/* harmony import */ var _constants_media__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98587);
/* harmony import */ var _enums_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29128);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(440);
/* harmony import */ var _InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73069);
/* harmony import */ var _InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57611);














var InformationBlock = function InformationBlock(_ref) {
  var icon = _ref.icon,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? {} : _ref$content,
      secondary = _ref.secondary,
      _ref$noBackgroundImag = _ref.noBackgroundImage,
      noBackgroundImage = _ref$noBackgroundImag === void 0 ? false : _ref$noBackgroundImag,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? undefined : _ref$onClick;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var title = content.title,
      text = content.text,
      _content$buttonText = content.buttonText,
      buttonText = _content$buttonText === void 0 ? t('common:toHomePage') : _content$buttonText,
      buttonIcon = content.buttonIcon,
      fileLink = content.fileLink;

  var _useTheme = (0,next_themes__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .F)(),
      theme = _useTheme.theme;

  var _useWindowSize = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      _useWindowSize2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var _useGetBreakPoints = (0,_constants_media__WEBPACK_IMPORTED_MODULE_9__/* .useGetBreakPoints */ .s)(),
      isMobile = _useGetBreakPoints.isMobile;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default().container), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default().secondary), secondary)]),
    itemScope: true,
    itemType: "http://schema.org/Article",
    children: [!noBackgroundImage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
      src: "/assets/".concat(theme === _enums_theme__WEBPACK_IMPORTED_MODULE_5__/* .ETheme.LIGHT_MODE */ .X.LIGHT_MODE ? 'Shapes.png' : 'ShapesDark.png'),
      layout: 'fill',
      className: (_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default().img),
      alt: "Background image",
      title: "Background image",
      loading: "lazy"
    }), !noBackgroundImage && windowsX < isMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
      src: "/assets/".concat(theme === _enums_theme__WEBPACK_IMPORTED_MODULE_5__/* .ETheme.LIGHT_MODE */ .X.LIGHT_MODE ? 'ShapesMobile.png' : 'ShapesMobileDark.png'),
      layout: 'fill',
      className: (_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mobileImg),
      alt: "Background image",
      title: "Background image",
      loading: "lazy"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: (_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
      children: [!!icon && icon, !!title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
        dangerouslySetInnerHTML: {
          __html: title
        }
      }), !!text && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
        dangerouslySetInnerHTML: {
          __html: text
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        onClick: onClick,
        Component: onClick ? 'button' : 'router',
        href: fileLink !== null && fileLink !== void 0 ? fileLink : '/',
        className: (_InformationBlock_module_scss__WEBPACK_IMPORTED_MODULE_10___default().customBtn),
        download: !!fileLink,
        children: [!!buttonIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
          src: buttonIcon,
          alt: "button icon",
          title: "button icon",
          width: 24,
          height: 24
        }), buttonText]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (InformationBlock);

/***/ }),

/***/ 92603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33770);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67385);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24052);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(440);
/* harmony import */ var _InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74113);
/* harmony import */ var _InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);


var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var DinamicModal = function DinamicModal(_ref) {
  var className = _ref.className,
      props = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  var Component = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 23303))["catch"](function () {
      return '';
    });
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(23303)];
      }
    }
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Component, _objectSpread({
    className: className
  }, props));
};

var InformationModal = function InformationModal(_ref2) {
  var _classNames;

  var _ref2$active = _ref2.active,
      active = _ref2$active === void 0 ? false : _ref2$active,
      _ref2$onClose = _ref2.onClose,
      onClose = _ref2$onClose === void 0 ? function () {
    return null;
  } : _ref2$onClose,
      title = _ref2.title,
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    i18nKey: 'common:successText'
  }) : _ref2$description,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'white' : _ref2$type,
      Icon = _ref2.Icon;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(DinamicModal, {
    active: active,
    setActive: onClose,
    itemScope: true,
    itemType: "http://schema.org/Thing",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().successPopup),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        "data-testid": "icon",
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().icon), (_classNames = {}, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_classNames, (_InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().white), type === 'white'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_classNames, (_InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().dark), type === 'dark'), _classNames)),
        children: Icon !== null && typeof Icon === 'undefined' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .SuccessIcon */ .tm, {
          width: 54
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Icon, {})
      }), title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: (_InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: (_InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().text),
        children: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onClick: onClose,
        className: (_InformationModal_module_scss__WEBPACK_IMPORTED_MODULE_8___default().button),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          i18nKey: 'common:tariffSupport.success.button'
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (InformationModal);

/***/ }),

/***/ 88228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98431);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69987);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_input_mask__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18528);
/* harmony import */ var _Input_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28834);
/* harmony import */ var _Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Input_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);



var _excluded = ["label", "error", "mask", "title", "IconRight", "onChange", "inputRef", "className", "tooltip", "onClickRightIcon", "placeholderMask", "iconClass", "animatedLabel", "id", "value", "onFocus", "onBlur", "type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var Input = function Input(_ref) {
  var label = _ref.label,
      error = _ref.error,
      mask = _ref.mask,
      title = _ref.title,
      IconRight = _ref.IconRight,
      onChange = _ref.onChange,
      inputRef = _ref.inputRef,
      className = _ref.className,
      tooltip = _ref.tooltip,
      onClickRightIcon = _ref.onClickRightIcon,
      placeholderMask = _ref.placeholderMask,
      iconClass = _ref.iconClass,
      animatedLabel = _ref.animatedLabel,
      id = _ref.id,
      value = _ref.value,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return null;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return null;
  } : _ref$onBlur,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      restProps = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(!!placeholderMask),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_React$useState, 2),
      visibleMask = _React$useState2[0],
      setVisibleMask = _React$useState2[1];

  var handleChange = function handleChange(event) {
    var value = event.target.value;

    switch (type) {
      case 'text':
        value = value.replace(/[^a-zA-Zа-яА-ЯəöğüşçƏÖĞÜŞÇıİ0-9\s,.()"'-]/g, '');
        break;

      case 'number':
        value = value.replace(/[^0-9.]/g, '');
        break;

      case 'email':
        value = value.replace(/[^a-zA-Z0-9@._-]/g, '');
        break;

      case 'validateGeneralInput':
        value = value.replace(/[^a-zA-Zа-яА-ЯəöğüşçƏÖĞÜŞÇıİ0-9\s,.:"'_;()-]/g, '');
        break;

      case 'onlyNumbersLetters':
        value = value.replace(/[^a-zA-Zа-яА-ЯəöğüşçƏÖĞÜŞÇıİ0-9]/g, '');
        break;

      default:
        break;
    }

    if (mask) {
      var unmask = value.replace(/[^\d]/g, '');
      return !!onChange && onChange(unmask);
    }

    return !!onChange && onChange(value);
  };

  var handleFocus = function handleFocus(event) {
    if (placeholderMask) setVisibleMask(false);
    return onFocus(event);
  };

  var handleBlur = function handleBlur(event) {
    if (placeholderMask && !value) setVisibleMask(true);
    return onBlur(event);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "input-field ".concat((_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().inputField)),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [!!title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
      className: (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title),
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_input_mask__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread({
      inputRef: inputRef,
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(['input', (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().inputFieldItem), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().rightIcon), !!IconRight || !!tooltip), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().errorInput), !!error), className]),
      mask: mask,
      autoComplete: "off",
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      value: value,
      id: id
    }, restProps)), !!label && animatedLabel ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("label", {
      htmlFor: id,
      "data-title": label,
      title: label,
      className: (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().animated__label)
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
      className: "label ".concat((_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().inputLabel)),
      children: label
    }), !!placeholderMask && visibleMask && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().placeholderMask),
      children: placeholderMask
    }), !!tooltip && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([(_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon), (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().right), (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().tooltip), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().iconWithTitle), !!title)]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Tooltip_Tooltip__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: tooltip
      })
    }), !!IconRight && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([(_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon), (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().right), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().iconWithTitle), !!title)]),
      onClick: onClickRightIcon,
      children: typeof IconRight === 'string' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
        src: IconRight,
        className: 'inputRightIcon',
        alt: 'input rightIcon',
        title: 'input rightIcon',
        loading: "lazy",
        width: 24,
        height: 24
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(IconRight, {
        className: iconClass
      })
    }), typeof error === 'boolean' ? null : !!error && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_Input_module_scss__WEBPACK_IMPORTED_MODULE_9___default().error),
      children: error
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Input);

/***/ }),

/***/ 48807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61395);
/* harmony import */ var _utils_handleCheckKey__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88929);
/* harmony import */ var _hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95562);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24052);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4897);
/* harmony import */ var _InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4523);
/* harmony import */ var _InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57611);














var InputAutoComplete = function InputAutoComplete(_ref) {
  var _data$bottom_countrie, _searchList$data, _searchList$data2;

  var className = _ref.className,
      data = _ref.data,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Baku' : _ref$placeholder,
      value = _ref.value,
      _ref$setValue = _ref.setValue,
      setValue = _ref$setValue === void 0 ? function () {
    return null;
  } : _ref$setValue,
      setOptionValue = _ref.setOptionValue,
      cleanText = _ref.cleanText,
      inputRef = _ref.inputRef,
      label = _ref.label,
      onSelect = _ref.onSelect,
      models = _ref.models,
      highlight = _ref.highlight,
      searchList = _ref.searchList,
      endIcon = _ref.endIcon,
      endIconClick = _ref.endIconClick,
      onClick = _ref.onClick,
      loading = _ref.loading,
      withoutPopulars = _ref.withoutPopulars,
      withoutIcons = _ref.withoutIcons,
      animatedLabel = _ref.animatedLabel,
      required = _ref.required,
      id = _ref.id,
      defaultModels = _ref.defaultModels,
      disabled = _ref.disabled,
      isTyping = _ref.isTyping;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      searchResult = _useState[0],
      setSearchResult = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      active = _useState2[0],
      setActive = _useState2[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var outsideRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var getTopValue = function getTopValue() {
    switch (true) {
      case withoutPopulars:
        return '90%';

      case data === null || data === void 0 ? void 0 : data.countries:
        return 'calc(90% - 65px)';

      default:
        return 'auto';
    }
  };

  var topValue = getTopValue();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setValue('');
  }, [router.isReady]);

  var highlightText = function highlightText(text) {
    if (!value) return text;
    var regex = new RegExp("(".concat(value, ")"), 'gi');
    return text === null || text === void 0 ? void 0 : text.replace(regex, '<span class="highlight">$1</span>');
  };

  var inputOnChange = function inputOnChange(e) {
    var _data$countries;

    var inputValue = e.target.value;
    setValue(inputValue);

    if (inputValue === '') {
      setValue(inputValue);
      setActive(false);
      setSearchResult([]); // reset();

      return;
    }

    var result = data === null || data === void 0 ? void 0 : (_data$countries = data.countries) === null || _data$countries === void 0 ? void 0 : _data$countries.filter(function (item) {
      if ((item.name.startsWith('İ') ? item.name.toLowerCase().replace('i̇', 'i') : item.name.toLowerCase()).indexOf(inputValue.toLowerCase()) !== -1) {
        return item.name;
      }

      return null;
    });
    var resultModels = models === null || models === void 0 ? void 0 : models.filter(function (item) {
      var _item$name;

      return item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(inputValue.toLowerCase());
    });
    setSearchResult(result || (defaultModels ? models : resultModels));
    setActive(true);
  };

  var popularCountries = function popularCountries(item) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
      className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().country),
      onClick: function onClick() {
        return onSelect(item === null || item === void 0 ? void 0 : item.name);
      },
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: item === null || item === void 0 ? void 0 : item.name
    }, item === null || item === void 0 ? void 0 : item.id);
  };

  var renderSearchContent = function renderSearchContent(item) {
    var _item$title;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
      className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().country),
      onClick: function onClick() {
        return onSelect(item);
      },
      dangerouslySetInnerHTML: {
        __html: highlightText((_item$title = item === null || item === void 0 ? void 0 : item.title) !== null && _item$title !== void 0 ? _item$title : item === null || item === void 0 ? void 0 : item.description)
      }
    }, item === null || item === void 0 ? void 0 : item.title);
  };

  var renderOptions = function renderOptions(option, index) {
    var handleSelect = function handleSelect() {
      if (setValue) setValue(option.name);
      if (setOptionValue) setOptionValue(option);
      if (onSelect) onSelect(option.name);
      setActive(false);
      setSearchResult([]);
    };

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("li", {
      onClick: handleSelect,
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
        className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active),
        children: Array.isArray(active) ? active[0] : active
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
        dangerouslySetInnerHTML: {
          __html: highlight ? highlightText(option.name) : option.name
        }
      })]
    }, index);
  };

  (0,_hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(outsideRef, function () {
    return setActive(false);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    ref: outsideRef,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputDropDown), className, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active), active)]),
    itemScope: true,
    itemType: "https://schema.org/SearchAction" // onBlur={() => setActive(false)}
    ,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputWrapper),
      children: [!!label && !animatedLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
        className: "label ".concat((_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputLabel)),
        children: label
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", {
        ref: inputRef,
        className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().input),
        onChange: inputOnChange,
        placeholder: placeholder,
        value: value,
        onFocus: function onFocus() {
          return setActive(true);
        },
        onClick: onClick,
        required: required,
        disabled: disabled,
        id: id,
        onKeyDown: _utils_handleCheckKey__WEBPACK_IMPORTED_MODULE_10__/* .validateGeneral */ .F // Browsers on Android and IOS use  different engines which ones may handle input clearing and autocomplete differently!
        ,
        autoComplete: "off",
        "aria-label": label || placeholder
      }), animatedLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
        htmlFor: id,
        children: label
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btnsWrapper),
        children: [!!value && !withoutIcons && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
          "aria-label": cleanText || 'Bakcell',
          onClick: function onClick() {
            return setValue('');
          },
          className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().close),
          children: cleanText || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_5__/* .CloseSquare */ .s9, {})
        }), !!endIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: "endIcon",
          onClick: endIconClick,
          children: endIcon
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("ul", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().dropDown), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().hidden), !(searchResult !== null && searchResult !== void 0 && searchResult.length))]),
      style: {
        top: topValue
      },
      children: searchResult === null || searchResult === void 0 ? void 0 : searchResult.map(renderOptions)
    }), !withoutPopulars && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
      children: [!!(data !== null && data !== void 0 && data.bottom_countries_title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("h6", {
        className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
        children: [data === null || data === void 0 ? void 0 : data.bottom_countries_title, ":"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().popularBox),
        children: data === null || data === void 0 ? void 0 : (_data$bottom_countrie = data.bottom_countries) === null || _data$bottom_countrie === void 0 ? void 0 : _data$bottom_countrie.map(popularCountries)
      })]
    }), loading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().searchContentList), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().searchContentList__loader), loading)]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_Loader_Loader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    }), searchList && (searchList === null || searchList === void 0 ? void 0 : (_searchList$data = searchList.data) === null || _searchList$data === void 0 ? void 0 : _searchList$data.length) > 0 ? !loading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().searchContentList),
      children: searchList === null || searchList === void 0 ? void 0 : (_searchList$data2 = searchList.data) === null || _searchList$data2 === void 0 ? void 0 : _searchList$data2.map(renderSearchContent)
    }) : !isTyping && !loading && value && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
      className: (_InputAutoComplete_module_scss__WEBPACK_IMPORTED_MODULE_8___default().info),
      children: t('esim:common.notFound')
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (InputAutoComplete);

/***/ }),

/***/ 45604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputWithSelect; }
/* harmony export */ });
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98431);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24052);
/* harmony import */ var _hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95562);
/* harmony import */ var _Input_Input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88228);
/* harmony import */ var _InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85070);
/* harmony import */ var _InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);



var _excluded = ["label", "placeholder", "options", "onSelect", "onChange", "className", "selected", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function InputWithSelect(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {
    return null;
  } : _ref$onSelect,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      className = _ref.className,
      selected = _ref.selected,
      value = _ref.value,
      props = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(false),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_React$useState, 2),
      isListShown = _React$useState2[0],
      setIsListShown = _React$useState2[1];

  var listRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var toggleRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var renderOptions = function renderOptions(item, key) {
    var handleSelect = function handleSelect() {
      onSelect(item);
      setIsListShown(false);
    };

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
      onClick: handleSelect,
      children: item.name
    }, key);
  };

  var onClose = function onClose() {
    setIsListShown(function (prev) {
      return !prev;
    });
  };

  (0,_hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(listRef, function (event) {
    if (toggleRef.current && toggleRef.current.contains(event.target)) {
      return;
    }

    if (isListShown) {
      setIsListShown(false);
    }
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([(_InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9___default().searchSelect), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9___default().searchSelect__selectActive), isListShown), className]),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      ref: toggleRef,
      onClick: onClose,
      className: (_InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9___default().list),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("span", {
        className: (_InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9___default().value),
        children: [selected, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_3__/* .Arrow */ .Eh, {
          width: 18
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
      ref: listRef,
      className: (_InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9___default().selectList),
      children: !!options.length && options.map(renderOptions)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Input_Input__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread({
      className: (_InputWithSelect_module_scss__WEBPACK_IMPORTED_MODULE_9___default().input),
      label: label,
      type: "text",
      value: value,
      onFocus: function onFocus() {
        return setIsListShown(false);
      },
      onChange: onChange,
      placeholder: placeholder
    }, props))]
  });
}

/***/ }),

/***/ 85712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98431);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4556);
/* harmony import */ var _hooks_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59748);
/* harmony import */ var _constants_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58165);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(440);
/* harmony import */ var _InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1354);
/* harmony import */ var _InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);













var InternetBanner = function InternetBanner(_ref) {
  var _bannerData$countries, _ref2, _bannerData$slug, _bannerData$slug2, _bannerData$countries2;

  var bannerData = _ref.bannerData,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '' : _ref$size,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$isHtml = _ref.isHtml,
      isHtml = _ref$isHtml === void 0 ? false : _ref$isHtml,
      children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isImageLoaded = _useState[0],
      setIsImageLoaded = _useState[1];

  var _useWindowSize = (0,_hooks_index__WEBPACK_IMPORTED_MODULE_3__/* .useWindowSize */ .iP)(),
      _useWindowSize2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var isRoamingHeader = !!(bannerData !== null && bannerData !== void 0 && bannerData.countries.length);

  var renderTitleContent = function renderTitleContent() {
    if (isHtml) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h2", {
        className: (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
        dangerouslySetInnerHTML: {
          __html: bannerData === null || bannerData === void 0 ? void 0 : bannerData.text
        }
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("h2", {
      className: (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
      children: bannerData === null || bannerData === void 0 ? void 0 : bannerData.text
    });
  };

  var headerStyle = isRoamingHeader ? {} : {
    backgroundImage: "url(".concat(windowsX <= _constants_base__WEBPACK_IMPORTED_MODULE_4__/* .breakPoints.sm */ .Eg.sm && bannerData !== null && bannerData !== void 0 && bannerData.mobile_background_image ? bannerData === null || bannerData === void 0 ? void 0 : bannerData.mobile_background_image : bannerData === null || bannerData === void 0 ? void 0 : bannerData.background_image, ")"),
    backgroundSize: bannerData !== null && bannerData !== void 0 && bannerData.mobile_background_imag ? '100% 100%' : 'cover',
    backgroundPosition: 'center'
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    style: headerStyle,
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner), (_ref2 = {}, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().big), size === 'L'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().medium), size === 'M'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().small), size === 'S'), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().children), (bannerData === null || bannerData === void 0 ? void 0 : (_bannerData$countries = bannerData.countries) === null || _bannerData$countries === void 0 ? void 0 : _bannerData$countries.length) > 0), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().dark), dark), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().redBanner), isRoamingHeader), _ref2), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().qr), bannerData === null || bannerData === void 0 ? void 0 : bannerData.qrBlock)]),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "wrapper ".concat((_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content),
        children: [(bannerData === null || bannerData === void 0 ? void 0 : bannerData.top_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().topText),
          children: bannerData === null || bannerData === void 0 ? void 0 : bannerData.top_text
        }), renderTitleContent(), (bannerData === null || bannerData === void 0 ? void 0 : bannerData.bottom_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().bottomText),
          children: bannerData === null || bannerData === void 0 ? void 0 : bannerData.bottom_text
        }), ((_bannerData$slug = bannerData === null || bannerData === void 0 ? void 0 : bannerData.slug) !== null && _bannerData$slug !== void 0 ? _bannerData$slug : bannerData === null || bannerData === void 0 ? void 0 : bannerData.external_link) && (bannerData === null || bannerData === void 0 ? void 0 : bannerData.button_text) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          size: "shortTrapezoid",
          variant: "trapezoidRed",
          href: (_bannerData$slug2 = bannerData === null || bannerData === void 0 ? void 0 : bannerData.slug) !== null && _bannerData$slug2 !== void 0 ? _bannerData$slug2 : bannerData === null || bannerData === void 0 ? void 0 : bannerData.external_link,
          Component: bannerData !== null && bannerData !== void 0 && bannerData.slug ? 'router' : 'a',
          children: bannerData === null || bannerData === void 0 ? void 0 : bannerData.button_text
        }), (bannerData === null || bannerData === void 0 ? void 0 : (_bannerData$countries2 = bannerData.countries) === null || _bannerData$countries2 === void 0 ? void 0 : _bannerData$countries2.length) > 0 && children]
      })
    }), (bannerData === null || bannerData === void 0 ? void 0 : bannerData.image) && !isRoamingHeader && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image),
      children: [!isImageLoaded && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        width: "100%",
        height: "100%"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        src: bannerData === null || bannerData === void 0 ? void 0 : bannerData.image,
        alt: bannerData === null || bannerData === void 0 ? void 0 : bannerData.top_text,
        title: bannerData === null || bannerData === void 0 ? void 0 : bannerData.top_text,
        layout: "fill",
        onLoadingComplete: function onLoadingComplete() {
          return setIsImageLoaded(true);
        },
        style: {
          visibility: isImageLoaded ? 'visible' : 'hidden'
        }
      })]
    }), isRoamingHeader && (bannerData === null || bannerData === void 0 ? void 0 : bannerData.background_image) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_InternetBanner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().roamingImage),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        src: bannerData === null || bannerData === void 0 ? void 0 : bannerData.background_image,
        alt: bannerData === null || bannerData === void 0 ? void 0 : bannerData.top_text,
        title: bannerData === null || bannerData === void 0 ? void 0 : bannerData.top_text,
        layout: "fill"
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (InternetBanner);

/***/ }),

/***/ 4897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2844);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12988);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Loader_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);







var Loader = function Loader(_ref) {
  var fullScreen = _ref.fullScreen,
      className = _ref.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_Loader_module_scss__WEBPACK_IMPORTED_MODULE_4___default().loader_wrap), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_4___default().fullScreen), fullScreen === true), className]),
    "data-testid": "loader",
    itemScope: true,
    itemType: "https://schema.org/ImageObject",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
      src: "/assets/load.png",
      alt: "loader icon",
      title: "Loader Icon",
      width: 56,
      height: 56,
      layout: "fixed",
      className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
      loading: "lazy"
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Loader);

/***/ }),

/***/ 30979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61395);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var _hooks_useBusiness__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97367);
/* harmony import */ var _InputAutoComplete_InputAutoComplete__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48807);
/* harmony import */ var _InternetBanner_InternetBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85712);
/* harmony import */ var _Banner_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7944);
/* harmony import */ var _Banner_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Banner_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57611);









var MainBanner = function MainBanner(_ref) {
  var data = _ref.data,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark;

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      value = _useState[0],
      setValue = _useState[1];

  var isBusiness = (0,_hooks_useBusiness__WEBPACK_IMPORTED_MODULE_3__/* .useBusiness */ .i)();

  var handleSetValue = function handleSetValue(value) {
    router.push({
      pathname: "/".concat(isBusiness ? 'business/business-roaming' : 'prices-and-countries'),
      query: {
        country: value
      }
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_InternetBanner_InternetBanner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    bannerData: data,
    dark: dark,
    size: data === null || data === void 0 ? void 0 : data.size,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().inputContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_InputAutoComplete_InputAutoComplete__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        value: value,
        setValue: setValue,
        onSelect: handleSetValue,
        className: (_Banner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().input),
        data: data,
        placeholder: t('common:Enter Country')
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MainBanner);

/***/ }),

/***/ 13212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98431);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4556);
/* harmony import */ var _constants_media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98587);
/* harmony import */ var _MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15996);
/* harmony import */ var _MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);











var MediaInquire = function MediaInquire(_ref) {
  var data = _ref.data;

  var _useGetBreakPoints = (0,_constants_media__WEBPACK_IMPORTED_MODULE_4__/* .useGetBreakPoints */ .s)(),
      isDesktop = _useGetBreakPoints.isDesktop;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(false),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState, 2),
      isImageLoaded = _React$useState2[0],
      setIsImageLoaded = _React$useState2[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: 'wrapper section',
    "data-testid": "media-inquire",
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().infoBlock), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().reverse), data.reverse)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().info),
        children: [isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: (_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: data === null || data === void 0 ? void 0 : data.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: data === null || data === void 0 ? void 0 : data.description
          }
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: (_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image),
        children: [!isDesktop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: (_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
          children: data === null || data === void 0 ? void 0 : data.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageWrapper),
          children: [!isImageLoaded && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            width: 670,
            height: 500,
            className: (_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().skeleton)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
            src: data === null || data === void 0 ? void 0 : data.image,
            width: 670,
            height: 500,
            alt: data === null || data === void 0 ? void 0 : data.title,
            title: data === null || data === void 0 ? void 0 : data.title,
            "data-testid": "mocked-image",
            className: (_MediaInquire_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainImage),
            onLoadingComplete: function onLoadingComplete() {
              return setIsImageLoaded(true);
            },
            style: {
              visibility: isImageLoaded ? 'visible' : 'hidden'
            }
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MediaInquire);

/***/ }),

/***/ 23303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24052);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77011);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57611);


var _excluded = ["active", "setActive", "children", "className", "classNameInner", "showCloseIcon", "closeOnOutsideClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var Modal = function Modal(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      children = _ref.children,
      className = _ref.className,
      classNameInner = _ref.classNameInner,
      _ref$showCloseIcon = _ref.showCloseIcon,
      showCloseIcon = _ref$showCloseIcon === void 0 ? true : _ref$showCloseIcon,
      _ref$closeOnOutsideCl = _ref.closeOnOutsideClick,
      closeOnOutsideClick = _ref$closeOnOutsideCl === void 0 ? true : _ref$closeOnOutsideCl,
      restProps = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var closeModal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  }, [setActive]);
  var handleClickOutside = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (event) {
    if (closeOnOutsideClick && modalRef.current && !modalRef.current.contains(event.target)) {
      setActive(false);
    }
  }, [setActive, closeOnOutsideClick]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    document.addEventListener('keydown', closeModal);
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('keydown', closeModal);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeModal, handleClickOutside]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (active) {
      document.documentElement.classList.add('overflow');
    } else {
      document.documentElement.classList.remove('overflow');
    }

    return function () {
      document.documentElement.classList.remove('overflow');
    };
  }, [active]);
  var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    setActive(false);
  }, [setActive]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrap), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().open), active), className]),
    itemScope: true,
    itemType: "https://schema.org/Property"
  }, restProps), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      ref: modalRef,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inner), classNameInner]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
        children: [showCloseIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          "data-testid": "modal-close".concat(restProps['data-testid'] ? "-".concat(restProps['data-testid']) : ''),
          className: (_Modal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().close),
          onClick: handleClose,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_3__/* .CloseMobile */ .Rt, {})
        }), children]
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (Modal);

/***/ }),

/***/ 81086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ SuccessModal; }
});

// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./components/ui/Modal/Modal.tsx
var Modal = __webpack_require__(23303);
// EXTERNAL MODULE: ./components/ui/Button/Button.tsx
var Button = __webpack_require__(440);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/SvgComponents/RedSuccess.js

var RedSuccess = function RedSuccess() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M31.9999 5.33325C17.3066 5.33325 5.33325 17.3066 5.33325 31.9999C5.33325 46.6933 17.3066 58.6666 31.9999 58.6666C46.6933 58.6666 58.6666 46.6933 58.6666 31.9999C58.6666 17.3066 46.6933 5.33325 31.9999 5.33325ZM44.7466 25.8666L29.6266 40.9866C29.2533 41.3599 28.7466 41.5733 28.2133 41.5733C27.6799 41.5733 27.1733 41.3599 26.7999 40.9866L19.2533 33.4399C18.4799 32.6666 18.4799 31.3866 19.2533 30.6133C20.0266 29.8399 21.3066 29.8399 22.0799 30.6133L28.2133 36.7466L41.9199 23.0399C42.6933 22.2666 43.9733 22.2666 44.7466 23.0399C45.5199 23.8133 45.5199 25.0666 44.7466 25.8666Z",
      fill: "#FF0037"
    })
  });
};
// EXTERNAL MODULE: ./components/ui/Modals/Success/SuccessModal.module.scss
var SuccessModal_module = __webpack_require__(17005);
var SuccessModal_module_default = /*#__PURE__*/__webpack_require__.n(SuccessModal_module);
;// CONCATENATED MODULE: ./components/ui/Modals/Success/SuccessModal.js








var SuccessModal = function SuccessModal(_ref) {
  var active = _ref.active,
      _ref$setSuccessModal = _ref.setSuccessModal,
      setSuccessModal = _ref$setSuccessModal === void 0 ? function () {
    return null;
  } : _ref$setSuccessModal,
      title = _ref.title,
      description = _ref.description,
      buttonTxt = _ref.buttonTxt,
      buttonVariant = _ref.buttonVariant,
      href = _ref.href;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var clickHandler = function clickHandler() {
    setSuccessModal(false);

    if (buttonVariant === 'Router') {
      router.push(href);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Modal["default"], {
    className: (SuccessModal_module_default()).modalCustom,
    active: active,
    setActive: function setActive() {
      return setSuccessModal(false);
    },
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SuccessModal_module_default()).successModal,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RedSuccess, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: title || t('cabinet:common.Success')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: description || t('cabinet:common.TariffSuccess')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SuccessModal_module_default()).successModal__buttons,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SuccessModal_module_default()).successModal__innerDiv,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function onClick() {
              return clickHandler();
            },
            children: buttonTxt || t('common:Ok')
          })
        })
      })]
    })
  });
};

/***/ }),

/***/ 32879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98431);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4556);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51633);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(440);
/* harmony import */ var _OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47998);
/* harmony import */ var _OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57611);









var sliderOptions1 = {
  slidesToShow: 1,
  infinite: true,
  responsive: [{
    breakpoint: 1400,
    settings: {
      arrows: false
    }
  }]
};

var OurManagement = function OurManagement(_ref) {
  var _data$items, _data$items2, _data$items3;

  var data = _ref.data;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState, 2),
      isImageLoaded = _React$useState2[0],
      setIsImageLoaded = _React$useState2[1];

  var renderManagerCard = function renderManagerCard(item) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().background),
      itemScope: true,
      itemType: "https://schema.org/Organization",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageWrapper),
          children: [!isImageLoaded && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            width: 250,
            height: 250,
            className: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().skeleton)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: item === null || item === void 0 ? void 0 : item.image,
            width: 670,
            height: 670,
            alt: item.name,
            title: item.name,
            onLoadingComplete: function onLoadingComplete() {
              return setIsImageLoaded(true);
            },
            style: {
              visibility: isImageLoaded ? 'visible' : 'hidden'
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
            children: item.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().name),
            children: item.name
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description),
            dangerouslySetInnerHTML: {
              __html: item.description
            }
          }), (item === null || item === void 0 ? void 0 : item.button_text) && (item === null || item === void 0 ? void 0 : item.button_slug) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "normal",
            variant: "outline",
            Component: "router",
            href: item === null || item === void 0 ? void 0 : item.button_slug,
            className: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().managment_btn),
            children: item === null || item === void 0 ? void 0 : item.button_text
          })]
        })]
      })
    });
  };

  return (data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.length) >= 2 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_common__WEBPACK_IMPORTED_MODULE_2__/* .SliderContainer */ ._v, {
    title: data === null || data === void 0 ? void 0 : data.title,
    icon: data === null || data === void 0 ? void 0 : data.icon,
    addClass: (_OurManagement_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bannerSlider),
    options: sliderOptions1,
    children: data === null || data === void 0 ? void 0 : (_data$items2 = data.items) === null || _data$items2 === void 0 ? void 0 : _data$items2.map(renderManagerCard)
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
    className: "section",
    children: data === null || data === void 0 ? void 0 : (_data$items3 = data.items) === null || _data$items3 === void 0 ? void 0 : _data$items3.map(renderManagerCard)
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OurManagement);

/***/ }),

/***/ 13507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OwnPhoneInput_OwnPhoneInput; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(24666);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(14730);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./hooks/useCabinet.js
var useCabinet = __webpack_require__(13245);
// EXTERNAL MODULE: ./components/ui/OwnPhoneInput/OwnPhoneInput.module.scss
var OwnPhoneInput_module = __webpack_require__(20218);
var OwnPhoneInput_module_default = /*#__PURE__*/__webpack_require__.n(OwnPhoneInput_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/ui/OwnPhoneInput/SinglePhoneInput.js


var _excluded = ["value", "focus", "inputClass"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var SinglePhoneInput = function SinglePhoneInput(_ref) {
  var value = _ref.value,
      focus = _ref.focus,
      inputClass = _ref.inputClass,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var router = (0,next_router.useRouter)();
  var inputRef = react.useRef(null);
  var isCabinet = (0,useCabinet/* useIsCabinet */.g)();
  react.useEffect(function () {
    if (router.isReady && focus) inputRef.current.focus();
  }, [router.isReady, focus]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(OwnPhoneInput_module_default()).inputContainer, (0,defineProperty/* default */.Z)({}, (OwnPhoneInput_module_default()).active, !!value), (0,defineProperty/* default */.Z)({}, (OwnPhoneInput_module_default()).cabinetInput, isCabinet)]),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
      ref: inputRef,
      autoComplete: "off",
      type: 'number',
      maxLength: "1",
      value: value || '',
      className: classnames_default()([(OwnPhoneInput_module_default()).input, inputClass]),
      "aria-label": value
    }, restProps))
  });
};

/* harmony default export */ var OwnPhoneInput_SinglePhoneInput = (SinglePhoneInput);
;// CONCATENATED MODULE: ./components/ui/OwnPhoneInput/OwnPhoneInput.js








var BACKSPACE = 8;
var LEFT_ARROW = 37;
var RIGHT_ARROW = 39;
var DELETE = 46;
var SPACEBAR = 32;

var OwnPhoneInput = function OwnPhoneInput(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? ['', '', '', '', '', '', ''] : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$separationPoints = _ref.separationPoints,
      separationPoints = _ref$separationPoints === void 0 ? [2, 4] : _ref$separationPoints,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'X' : _ref$placeholder,
      inputClass = _ref.inputClass,
      className = _ref.className;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeInput = _React$useState2[0],
      setActiveInput = _React$useState2[1];

  var validateSeparationPoints = separationPoints.map(Number);

  var isInputValueValid = function isInputValueValid(currentValue) {
    var isTypeValid = !Number.isNaN(parseInt(currentValue, 10));
    return isTypeValid && currentValue.trim().length === 1;
  };

  var focusInput = function focusInput(input) {
    var active = Math.max(Math.min(value.length - 1, input), 0);
    setActiveInput(active);
  };

  var handlePhoneChange = function handlePhoneChange(phone) {
    onChange(phone);
  };

  var changePhoneAtFocus = function changePhoneAtFocus(inputValue) {
    var instance = (0,toConsumableArray/* default */.Z)(value);

    instance[activeInput] = inputValue;
    handlePhoneChange(instance);
  };

  var handleOnChange = function handleOnChange(event) {
    var value = event.target.value.replace(/\D/g, '');

    if (isInputValueValid(value)) {
      changePhoneAtFocus(value);
    }
  }; // Focus on next input


  var focusNextInput = function focusNextInput() {
    focusInput(activeInput + 1);
  }; // Focus on previous input


  var focusPrevInput = function focusPrevInput() {
    focusInput(activeInput - 1);
  };

  var handleOnInput = function handleOnInput(event) {
    if (isInputValueValid(event.target.value)) focusNextInput();
  };

  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (event.keyCode === BACKSPACE || event.key === 'Backspace') {
      event.preventDefault();
      changePhoneAtFocus('');
      focusPrevInput();
    } else if (event.keyCode === DELETE || event.key === 'Delete') {
      event.preventDefault();
      changePhoneAtFocus('');
    } else if (event.keyCode === LEFT_ARROW || event.key === 'ArrowLeft') {
      event.preventDefault();
      focusPrevInput();
    } else if (event.keyCode === RIGHT_ARROW || event.key === 'ArrowRight') {
      event.preventDefault();
      focusNextInput();
    } else if (event.keyCode === SPACEBAR || event.key === ' ' || event.key === 'Spacebar' || event.key === 'Space' || event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === ',' || event.key === '.' || event.key === '-') {
      event.preventDefault();
    }
  };

  var handleOnPaste = function handleOnPaste(event) {
    event.preventDefault();
    var nextActiveInput = activeInput;
    var pastedData = event.clipboardData.getData('text/plain').slice(0, value.length - activeInput).split('');

    for (var pos = 0; pos < value.length; ++pos) {
      if (pos >= activeInput && pastedData.length > 0) {
        value[pos] = pastedData.shift();
        nextActiveInput++;
      }
    }

    setActiveInput(nextActiveInput);
    focusInput(nextActiveInput);
    handlePhoneChange(value);
  };

  var renderInputs = function renderInputs(item, index) {
    var showSeparator = validateSeparationPoints.includes(index);
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OwnPhoneInput_SinglePhoneInput, {
        "data-testid": "single-input-".concat(index),
        inputClass: inputClass,
        placeholder: placeholder,
        focus: activeInput === index,
        value: item,
        onChange: handleOnChange,
        onKeyDown: handleOnKeyDown,
        onInput: handleOnInput,
        onPaste: handleOnPaste,
        inputMode: "numeric",
        onFocus: function onFocus(event) {
          setActiveInput(index);
          event.target.select();
        },
        onBlur: function onBlur() {
          return setActiveInput(-1);
        }
      }), showSeparator && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (OwnPhoneInput_module_default()).separator,
        children: "-"
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(OwnPhoneInput_module_default()).container, className]),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: value.map(renderInputs)
  });
};

/* harmony default export */ var OwnPhoneInput_OwnPhoneInput = (OwnPhoneInput);

/***/ }),

/***/ 58148:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84838);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);




var PageTabs = function PageTabs(_ref) {
  var tabs = _ref.tabs,
      _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === void 0 ? '' : _ref$pathname;

  var renderTab = function renderTab(tab, index) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.item,
      itemScope: true,
      itemType: "https://schema.org/LinkRole",
      children: /*#__PURE__*/_jsx(ActiveLink, {
        activeClassName: styles.active,
        className: 'disabled',
        href: (tab === null || tab === void 0 ? void 0 : tab.href) || "/".concat(pathname, "/").concat(tab.id),
        children: /*#__PURE__*/_jsx("a", {
          title: tab === null || tab === void 0 ? void 0 : tab.name,
          "aria-label": tab === null || tab === void 0 ? void 0 : tab.name,
          children: tab.name
        })
      }, index)
    }, index);
  };

  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: /*#__PURE__*/_jsx("div", {
      className: 'wrapper',
      children: /*#__PURE__*/_jsx("div", {
        className: styles.list,
        children: tabs === null || tabs === void 0 ? void 0 : tabs.map(renderTab)
      })
    })
  });
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (PageTabs)));

/***/ }),

/***/ 37499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12420);
/* harmony import */ var _enums_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29128);
/* harmony import */ var _Qr_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46979);
/* harmony import */ var _Qr_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Qr_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57611);









var handleDownloadEvent = function handleDownloadEvent() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'App_click'
  });
};

var Qr = function Qr(_ref) {
  var data = _ref.data,
      className = _ref.className;

  var _useTheme = (0,next_themes__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .F)(),
      theme = _useTheme.theme;

  var renderLinks = function renderLinks(item) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
      className: (_Qr_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["qr-link"]),
      href: item.link,
      target: "".concat(data === null || data === void 0 ? void 0 : data.target),
      onClick: handleDownloadEvent,
      itemScope: true,
      itemType: "https://schema.org/LinkR\u0449\u0434\u0443",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        className: (_Qr_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["qr-link__logo"]),
        src: item !== null && item !== void 0 && item.dark_mode_image && theme === _enums_theme__WEBPACK_IMPORTED_MODULE_4__/* .ETheme.DARK_MODE */ .X.DARK_MODE ? item === null || item === void 0 ? void 0 : item.dark_mode_image : item.image,
        alt: "qr link logo",
        title: "Qr Link Logo",
        width: 148,
        height: 48,
        loading: "lazy"
      })
    }, item === null || item === void 0 ? void 0 : item.id);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
    "data-testid": "qr-section",
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Qr_module_scss__WEBPACK_IMPORTED_MODULE_6___default().qr), className),
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: (_Qr_module_scss__WEBPACK_IMPORTED_MODULE_6___default().qr__inner),
      children: [!!(data !== null && data !== void 0 && data.links) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_Qr_module_scss__WEBPACK_IMPORTED_MODULE_6___default().qr__links),
        children: data.links.map(renderLinks)
      }), !!(data !== null && data !== void 0 && data.qr) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_Qr_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["qr-item"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
          className: (_Qr_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["qr-item__pic"]),
          src: data.qr,
          alt: data.qr,
          width: 168,
          height: 168,
          loading: "lazy"
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Qr);

/***/ }),

/***/ 78755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26913);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ScreenLoader_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30220);
/* harmony import */ var _ScreenLoader_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ScreenLoader_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);







function ScreenLoader(_ref) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    "data-testid": 'screen-loader',
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([(_ScreenLoader_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_ScreenLoader_module_scss__WEBPACK_IMPORTED_MODULE_4___default().visible), visible)]),
    itemScope: true,
    itemType: "https://schema.org/ImageObject",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      className: (_ScreenLoader_module_scss__WEBPACK_IMPORTED_MODULE_4___default().loader),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: '/assets/loader.svg',
        alt: "Loading...",
        title: "Loading...",
        loading: "lazy",
        layout: "fill"
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (ScreenLoader);

/***/ }),

/***/ 66850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icons_ArrowRightNew__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63344);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(440);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73160);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);







var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      buttonText = _ref.buttonText,
      className = _ref.className,
      href = _ref.href,
      titleModify = _ref.titleModify,
      isHtml = _ref.isHtml,
      buttonVariant = _ref.buttonVariant,
      icon = _ref.icon;

  var renderTitleVariant = function renderTitleVariant(text) {
    if (isHtml) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("strong", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(['title', titleModify, className]),
        dangerouslySetInnerHTML: {
          __html: text
        }
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("strong", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(['title', titleModify, className]),
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: text
    });
  };

  if (!icon && !buttonText) {
    return renderTitleVariant(children);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title__container),
    itemScope: true,
    itemType: "https://schema.org/Property",
    "data-testid": "section-title",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title__inner),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("strong", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('title', titleModify, className),
        children: children
      })
    }), buttonText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      href: href,
      Component: href ? 'router' : 'button',
      onClick: onClick,
      size: 'normal',
      variant: buttonVariant,
      className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button),
      children: [buttonText, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_icons_ArrowRightNew__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SectionTitle);

/***/ }),

/***/ 54713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98431);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61395);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24052);
/* harmony import */ var _constants_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58165);
/* harmony import */ var _hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95562);
/* harmony import */ var _Select_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63686);
/* harmony import */ var _Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_Select_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57611);



var _excluded = ["label", "placeholder", "onChange", "value", "onBlur", "data", "className", "withoutIcon", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function Select(_ref) {
  var _ref2;

  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      onChange = _ref.onChange,
      value = _ref.value,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return null;
  } : _ref$onBlur,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      className = _ref.className,
      withoutIcon = _ref.withoutIcon,
      disabled = _ref.disabled,
      props = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      t = _useTranslation.t;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1__.useState(false),
      _React$useState2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_React$useState, 2),
      isListShown = _React$useState2[0],
      setIsListShown = _React$useState2[1];

  var listRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var selectRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var changeValue = function changeValue(currentValue) {
    onChange(currentValue);
    setIsListShown(false);
  };

  var outsideClickHandler = function outsideClickHandler(event) {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsListShown(false);
    }
  };

  (0,_hooks_useClickOutside__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(listRef, outsideClickHandler);

  var renderOptions = function renderOptions(item, key) {
    var val = value !== null && value !== void 0 && value.id ? 'id' : 'name';
    var valInsideOfValue = value === null || value === void 0 ? void 0 : value[val];
    var valInsideOfItem = item === null || item === void 0 ? void 0 : item[val];
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("li", {
      onMouseDown: function onMouseDown() {
        return changeValue(item);
      },
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [t(item === null || item === void 0 ? void 0 : item.name), valInsideOfValue === valInsideOfItem && !withoutIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .FieldChecked */ .xw, {})]
    }, key);
  };

  var handleBlur = function handleBlur(event) {
    setIsListShown(false);
    return onBlur(event);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([(_Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default().searchSelect), (_ref2 = {}, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default().selectActive), isListShown), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default().haveValue), !!(value !== null && value !== void 0 && value.name)), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default().disabled), disabled), _ref2)]),
    onBlur: handleBlur,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      onClick: function onClick() {
        return setIsListShown(!isListShown);
      },
      className: (_Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default().searchSelectField),
      ref: selectRef,
      children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
        className: "label ".concat((_Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default().inputLabel)),
        children: label
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", _objectSpread({
        placeholder: placeholder,
        autoComplete: "off",
        type: "text",
        value: _constants_base__WEBPACK_IMPORTED_MODULE_5__/* .allValues.includes */ .bD.includes(value === null || value === void 0 ? void 0 : value.value) || (value === null || value === void 0 ? void 0 : value.name) === 'All' ? t('common:All') : t(value === null || value === void 0 ? void 0 : value.name),
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(['input', (_Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default().input), className]),
        onChange: function onChange() {
          return null;
        },
        readOnly: true,
        "aria-label": value === null || value === void 0 ? void 0 : value.name
      }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_4__/* .Arrow */ .Eh, {
        width: 14
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("ul", {
      ref: listRef,
      className: (_Select_module_scss__WEBPACK_IMPORTED_MODULE_10___default().selectList),
      children: !!data.length && data.map(renderOptions)
    })]
  });
}

/***/ }),

/***/ 49733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24052);
/* harmony import */ var _Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10983);
/* harmony import */ var _Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57611);





var NextArrow = function NextArrow(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      brand = _ref.brand,
      width = _ref.width;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(['slick-arrow slick-next', (_Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow), className]),
    onClick: onClick,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrowBlock),
      children: brand ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_1__/* .BrandArrow */ .RJ, {
        width: width !== null && width !== void 0 ? width : 26
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_1__/* .Arrow */ .Eh, {
        width: width !== null && width !== void 0 ? width : 26
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (NextArrow);

/***/ }),

/***/ 83197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _icons_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24052);
/* harmony import */ var _Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10983);
/* harmony import */ var _Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57611);





var PrevArrow = function PrevArrow(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      brand = _ref.brand;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(['slick-arrow', (_Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow), className]),
    onClick: onClick,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_Arrows_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrowBlock),
      children: brand ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_1__/* .BrandArrow */ .RJ, {
        width: 26
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_icons_index__WEBPACK_IMPORTED_MODULE_1__/* .Arrow */ .Eh, {
        width: 26
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PrevArrow);

/***/ }),

/***/ 83234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46338);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useBusiness__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97367);
/* harmony import */ var _SliderArrows_PrevArrow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83197);
/* harmony import */ var _SliderArrows_NextArrow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49733);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72719);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57611);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var SliderWrapper = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref2;

  var children = _ref.children,
      options = _ref.options,
      className = _ref.className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      arrows = _ref.arrows,
      nextArrow = _ref.nextArrow,
      prevArrow = _ref.prevArrow,
      shadow = _ref.shadow;
  var business = (0,_hooks_useBusiness__WEBPACK_IMPORTED_MODULE_5__/* .useBusiness */ .i)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();

  var settings = _objectSpread({
    infinite: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 1500,
    pauseOnHover: true,
    // variableWidth: true,
    lazyLoad: 'ondemand',
    responsive: [{
      breakpoint: 1025,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 1
      }
    }]
  }, options);

  if (arrows) {
    settings.nextArrow = nextArrow !== null && nextArrow !== void 0 ? nextArrow : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_SliderArrows_NextArrow__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      className: 'slick-next'
    });
    settings.prevArrow = prevArrow !== null && prevArrow !== void 0 ? prevArrow : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_SliderArrows_PrevArrow__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      className: 'slick-prev'
    });
    settings.infinite = options === null || options === void 0 ? void 0 : options.infinite;
    settings.arrows = true;
    settings.autoplay = true;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().slider__wrapper), 'wrapper', (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().slider__wrapper__business), business)),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__["default"], _objectSpread(_objectSpread({}, settings), {}, {
      style: style,
      ref: ref,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(['autoplay', (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().slider), className, (_ref2 = {}, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrows), !!arrows), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().shadow), !!shadow), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref2, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrowsWhite), !router.pathname.includes('/business')), _ref2)]),
      children: children
    }))
  });
});
SliderWrapper.displayName = 'SliderWrapper';
/* harmony default export */ __webpack_exports__["Z"] = (SliderWrapper);

/***/ }),

/***/ 15051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2844);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64973);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);





var Tab = function Tab(_ref) {
  var _ref2;

  var children = _ref.children,
      active = _ref.active,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    "aria-label": "Bakcell",
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tab), (_ref2 = {}, (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref2, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active), active), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref2, "active", active), _ref2), className]),
    onClick: onClick,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Tab);

/***/ }),

/***/ 17413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57611);



var TabContent = function TabContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TabContent);

/***/ }),

/***/ 42069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64973);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57611);


var _excluded = ["children", "active", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var TabContent = function TabContent(_ref) {
  var children = _ref.children,
      active = _ref.active,
      className = _ref.className,
      restProps = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  if (!active) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().activeContent), active), className]),
    itemScope: true,
    itemType: "https://schema.org/Property"
  }, restProps), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (TabContent);

/***/ }),

/***/ 59883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14730);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64973);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);


var _excluded = ["children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      restProps = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", _objectSpread(_objectSpread({
    className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().panel), " ").concat(className)
  }, restProps), {}, {
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (TabPanel);

/***/ }),

/***/ 5738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57611);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Tabs = function Tabs(_ref) {
  var _children$, _children$$props, _children$props, _children$2, _children$2$props, _children$3, _children$4;

  var children = _ref.children,
      active = _ref.active;
  var tabs = ((_children$ = children[0]) === null || _children$ === void 0 ? void 0 : (_children$$props = _children$.props) === null || _children$$props === void 0 ? void 0 : _children$$props.children) || (children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.children);
  var content = (_children$2 = children[1]) === null || _children$2 === void 0 ? void 0 : (_children$2$props = _children$2.props) === null || _children$2$props === void 0 ? void 0 : _children$2$props.children;
  var object = Array.isArray(children) ? [_objectSpread(_objectSpread({}, children[0]), {}, {
    props: _objectSpread(_objectSpread({}, (_children$3 = children[0]) === null || _children$3 === void 0 ? void 0 : _children$3.props), {}, {
      children: null
    })
  }), _objectSpread(_objectSpread({}, children[1]), {}, {
    props: _objectSpread(_objectSpread({}, (_children$4 = children[1]) === null || _children$4 === void 0 ? void 0 : _children$4.props), {}, {
      children: null
    })
  })] : _objectSpread(_objectSpread({}, children), {}, {
    props: _objectSpread(_objectSpread({}, children === null || children === void 0 ? void 0 : children.props), {}, {
      children: null
    })
  });

  if (!content && !tabs) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("b", {
      style: {
        color: 'red'
      },
      children: "Missing TabPanel or TabContent items"
    });
  }

  if (content && Array.isArray(content)) {
    object[1].props.children = content.map(function (tab, index) {
      if (typeof active !== 'undefined') {
        var _tab;

        tab = _objectSpread(_objectSpread({}, tab), {}, {
          props: _objectSpread(_objectSpread({}, (_tab = tab) === null || _tab === void 0 ? void 0 : _tab.props), {}, {
            active: active === index
          })
        });
      }

      return tab;
    });
  }

  if (tabs && Array.isArray(tabs)) {
    var mappedTabs = tabs === null || tabs === void 0 ? void 0 : tabs.map(function (item, index) {
      if (typeof active !== 'undefined') {
        var _item;

        item = _objectSpread(_objectSpread({}, item), {}, {
          props: _objectSpread(_objectSpread({}, (_item = item) === null || _item === void 0 ? void 0 : _item.props), {}, {
            active: active === index
          })
        });
      }

      return item;
    });

    if (Array.isArray(object)) {
      object[0].props.children = mappedTabs;
    } else {
      object.props.children = mappedTabs;
    }
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: object
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Tabs);

/***/ }),

/***/ 46202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);



var TextBlock = function TextBlock(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isHtml = _ref.isHtml;

  var checkViewText = function checkViewText() {
    if (isHtml) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('text', className),
        dangerouslySetInnerHTML: {
          __html: children
        }
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('text', className),
      itemScope: true,
      itemType: "https://schema.org/Text",
      "data-testid": "text-block",
      children: children
    });
  };

  return children ? checkViewText() : null;
};

/* harmony default export */ __webpack_exports__["Z"] = (TextBlock);

/***/ }),

/***/ 2158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2844);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72179);
/* harmony import */ var _Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);


var _excluded = ["label", "error", "title", "onChange", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Textarea = function Textarea(_ref) {
  var label = _ref.label,
      error = _ref.error,
      title = _ref.title,
      onChange = _ref.onChange,
      className = _ref.className,
      restProps = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    value = value.replace(/[<>/\\|^&]/g, '');
    return !!onChange && onChange(value);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(['input-field', (_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inputField), className]),
    itemScope: true,
    itemType: "https://schema.org/Text",
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      className: (_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
      children: title
    }), label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      className: "label ".concat((_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inputLabel)),
      children: label
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("textarea", _objectSpread(_objectSpread({
      "aria-label": label
    }, restProps), {}, {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(['input', (_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inputFieldItem), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5___default().errorInput), !!error)]),
      onChange: handleChange
    })), error && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_5___default().error),
      children: error
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Textarea);

/***/ }),

/***/ 18528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var react_tooltip_lite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97281);
/* harmony import */ var _icons_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95463);
/* harmony import */ var _tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95289);
/* harmony import */ var _tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57611);





function Tooltip(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_tooltip_lite__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    tipContentClassName: (_tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tip),
    effect: "solid",
    content: children,
    itemScope: true,
    itemType: "http://schema.org/Property",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
      className: (_tooltip_module_scss__WEBPACK_IMPORTED_MODULE_4___default().block),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_icons_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    })
  });
}

/***/ }),

/***/ 25469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2844);
/* harmony import */ var react_youtube__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27511);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9134);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Video_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78390);
/* harmony import */ var _Video_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Video_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);







var Video = function Video(_ref) {
  var _ref$video = _ref.video,
      _ref$video$title = _ref$video.title,
      title = _ref$video$title === void 0 ? '' : _ref$video$title,
      _ref$video$videoId = _ref$video.videoId,
      videoId = _ref$video$videoId === void 0 ? '' : _ref$video$videoId,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_Video_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrap), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_Video_module_scss__WEBPACK_IMPORTED_MODULE_2___default().show), true), className]),
    itemScope: true,
    itemType: "http://schema.org/VideoObject",
    children: [!!title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_Video_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
      children: title
    }), !!videoId && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_youtube__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      className: (_Video_module_scss__WEBPACK_IMPORTED_MODULE_2___default().frame),
      videoId: videoId
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Video);

/***/ }),

/***/ 61621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VideoBlock_VideoBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/ui/TextBlock/TextBlock.js
var TextBlock = __webpack_require__(46202);
// EXTERNAL MODULE: ./components/ui/Video/Video.js
var Video = __webpack_require__(25469);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/business-testimonials/PersonCard/PersonCard.module.scss
var PersonCard_module = __webpack_require__(87570);
var PersonCard_module_default = /*#__PURE__*/__webpack_require__.n(PersonCard_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/business-testimonials/PersonCard/PersonCard.js







var PersonCard = function PersonCard(_ref) {
  var _data$video_link;

  var data = _ref.data,
      _ref$showVideo = _ref.showVideo,
      showVideo = _ref$showVideo === void 0 ? function () {
    return null;
  } : _ref$showVideo,
      _ref$setVideoPreview = _ref.setVideoPreview,
      setVideoPreview = _ref$setVideoPreview === void 0 ? function () {
    return null;
  } : _ref$setVideoPreview;
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = data === null || data === void 0 ? void 0 : (_data$video_link = data.video_link) === null || _data$video_link === void 0 ? void 0 : _data$video_link.match(regExp);
  var videoId = match && match[7].length === 11 ? match[7] : false;

  if (!videoId) {
    return '';
  }

  var onClickHandler = function onClickHandler() {
    showVideo(videoId);
    setVideoPreview(data === null || data === void 0 ? void 0 : data.video_thumbnail);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (PersonCard_module_default()).person,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PersonCard_module_default()).image,
      onClick: onClickHandler,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: data === null || data === void 0 ? void 0 : data.video_thumbnail,
        alt: data === null || data === void 0 ? void 0 : data.full_name,
        title: data === null || data === void 0 ? void 0 : data.full_name,
        loading: "lazy",
        layout: "fill",
        unoptimized: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PersonCard_module_default()).play,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Play */.sh, {})
      })]
    }), (data === null || data === void 0 ? void 0 : data.full_name) && data.full_name.trim() !== '' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PersonCard_module_default()).name,
      children: data.full_name
    }), (data === null || data === void 0 ? void 0 : data.title) && data.title.trim() !== '' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PersonCard_module_default()).position,
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.description) && data.description.trim() !== '' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PersonCard_module_default()).description,
      children: data.description
    })]
  });
};

/* harmony default export */ var PersonCard_PersonCard = (PersonCard);
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./components/ui/VideoBlock/VideoBlock.module.scss
var VideoBlock_module = __webpack_require__(3866);
var VideoBlock_module_default = /*#__PURE__*/__webpack_require__.n(VideoBlock_module);
;// CONCATENATED MODULE: ./components/ui/VideoBlock/VideoBlock.jsx












var VideoBlock = function VideoBlock(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(false),
      videoId = _useState[0],
      setVideoId = _useState[1];

  var _useState2 = (0,react.useState)(''),
      videoPreview = _useState2[0],
      setVideoPreview = _useState2[1];

  var renderItems = function renderItems(item, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(PersonCard_PersonCard, {
      data: item,
      showVideo: function showVideo(id) {
        return setVideoId(id);
      },
      setVideoPreview: setVideoPreview,
      itemScope: true,
      itemType: "http://schema.org/Person"
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wrapper",
      "data-testid": "video-element",
      itemScope: true,
      itemType: "http://schema.org/CreativeWork",
      children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
        titleModify: classnames_default()((VideoBlock_module_default())["page-title"], 'title--large'),
        children: data.title
      }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock/* default */.Z, {
        className: classnames_default()((VideoBlock_module_default())["page-text"], 'text--large'),
        children: data.description
      }), !!(data !== null && data !== void 0 && data.items) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (VideoBlock_module_default()).peoplesList,
        children: data.items.map(renderItems)
      })]
    }), videoId && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (VideoBlock_module_default()).video,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (VideoBlock_module_default()).videoContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (VideoBlock_module_default()).close,
          onClick: function onClick() {
            return setVideoId(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Video/* default */.Z, {
          className: (VideoBlock_module_default()).videoItem,
          video: {
            preview: videoPreview,
            videoId: videoId
          }
        })]
      })
    })]
  });
};

/* harmony default export */ var VideoBlock_VideoBlock = (VideoBlock);

/***/ }),

/***/ 84838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fj": function() { return /* reexport */ ActivateBlock_ActivateBlock; },
  "O$": function() { return /* reexport */ ActiveLink/* default */.Z; },
  "d5": function() { return /* reexport */ AddressCards_AddressCards; },
  "qo": function() { return /* reexport */ AddressModal_AddressModal; },
  "KU": function() { return /* reexport */ Advantageous_Advantageous; },
  "m5": function() { return /* reexport */ AttachFiles_AttachFiles; },
  "jL": function() { return /* reexport */ Banner/* default */.Z; },
  "nX": function() { return /* reexport */ ui_BranchModal; },
  "Oo": function() { return /* reexport */ Breadcrumbs; },
  "gl": function() { return /* reexport */ Bundles_Bundles; },
  "Rm": function() { return /* reexport */ BusinessContactForm_BusinessContactForm/* default */.Z; },
  "CW": function() { return /* reexport */ BusinessSectionBannersWithIcon_BusinessSectionBannersWithIcon; },
  "Bo": function() { return /* reexport */ BusinessServicesCardWithImage_BusinessServicesCardWithImage; },
  "LD": function() { return /* reexport */ ui_BusinessTariffCard_BusinessTariffCard; },
  "Bz": function() { return /* reexport */ BusinessTariffCard_BusinessTariffCardWithoutHeader; },
  "d9": function() { return /* reexport */ BusinessTechnicalSolution_BusinessTechnicalSolution; },
  "zx": function() { return /* reexport */ Button_Button/* default */.Z; },
  "Yh": function() { return /* reexport */ CallBlock_CallBlock; },
  "qp": function() { return /* reexport */ CardBlock_CardBlock; },
  "Mt": function() { return /* reexport */ Characteristics_Characteristics; },
  "EG": function() { return /* reexport */ CheckboxWithText/* default */.Z; },
  "kP": function() { return /* reexport */ CheckboxWithTitle/* default */.Z; },
  "nu": function() { return /* reexport */ CollapsibleItem_CollapsibleItem; },
  "Ub": function() { return /* reexport */ ContactUs_ContactUs; },
  "M9": function() { return /* reexport */ DeliveryAddressBranch_DeliveryAddressBranch; },
  "z4": function() { return /* reexport */ DocumentCard/* default */.Z; },
  "rc": function() { return /* reexport */ DropDownFilter_DropDownFilter; },
  "Lt": function() { return /* reexport */ Dropdown_Dropdown; },
  "Cv": function() { return /* reexport */ Error_ErrorModal; },
  "By": function() { return /* reexport */ Faq_Faq; },
  "SY": function() { return /* reexport */ FooterLink_FooterLink; },
  "Q1": function() { return /* reexport */ FullBanner_FullBanner; },
  "VC": function() { return /* reexport */ HiddenList_HiddenList; },
  "fW": function() { return /* reexport */ InformationBlock/* default */.Z; },
  "UI": function() { return /* reexport */ InformationModal/* default */.Z; },
  "II": function() { return /* reexport */ Input/* default */.Z; },
  "L$": function() { return /* reexport */ InputAutoComplete/* default */.Z; },
  "WK": function() { return /* reexport */ InputAutoCompleteForCheckout; },
  "em": function() { return /* reexport */ InputWithSelect/* default */.Z; },
  "Jp": function() { return /* reexport */ InternetBanner/* default */.Z; },
  "EP": function() { return /* reexport */ JoinBackcellModal_JoinBackcellModal; },
  "aV": function() { return /* reexport */ ui_List_List; },
  "aN": function() { return /* reexport */ Loader/* default */.Z; },
  "_A": function() { return /* reexport */ LoginModal_LoginModal; },
  "D5": function() { return /* reexport */ Map; },
  "u_": function() { return /* reexport */ Modal["default"]; },
  "gV": function() { return /* reexport */ NextArrow/* default */.Z; },
  "Xt": function() { return /* reexport */ NumList_NumList; },
  "qG": function() { return /* reexport */ OwnPhoneInput/* default */.Z; },
  "tl": function() { return /* reexport */ Pagination_Pagination; },
  "fP": function() { return /* reexport */ PaymentCards_PaymentCards; },
  "QU": function() { return /* reexport */ PhoneNumbersDropDown_PhoneNumbersDropDown; },
  "$B": function() { return /* reexport */ PrevArrow/* default */.Z; },
  "Pt": function() { return /* reexport */ ProductStatus_ProductStatus; },
  "uN": function() { return /* reexport */ ProductsSectionFiber_ProductsSectionFiber; },
  "Xq": function() { return /* reexport */ RadioWithTitle_RadioWithTitle; },
  "hD": function() { return /* reexport */ RightImageBanner_RightImageBanner; },
  "R": function() { return /* reexport */ SEOText_SEOText; },
  "v$": function() { return /* reexport */ ScreenLoader/* default */.Z; },
  "Dl": function() { return /* reexport */ SearchList_SearchList; },
  "Ym": function() { return /* reexport */ SearchTravel_SearchTravel; },
  "NZ": function() { return /* reexport */ SectionTitle_SectionTitle/* default */.Z; },
  "Ph": function() { return /* reexport */ Select/* default */.Z; },
  "zJ": function() { return /* reexport */ ui_SelectDateTime; },
  "h2": function() { return /* reexport */ SliderWrapper_SliderWrapper/* default */.Z; },
  "HE": function() { return /* reexport */ StepsBannerVolte_StepsBannerWithTabs; },
  "zC": function() { return /* reexport */ ui_StepsWithImage; },
  "Dz": function() { return /* reexport */ StoreList_StoreList; },
  "OK": function() { return /* reexport */ Tabs_Tab/* default */.Z; },
  "I5": function() { return /* reexport */ Tabs_TabContent/* default */.Z; },
  "Wp": function() { return /* reexport */ Tabs_TabContentItem/* default */.Z; },
  "x4": function() { return /* reexport */ Tabs_TabPanel/* default */.Z; },
  "mQ": function() { return /* reexport */ Tabs_Tabs/* default */.Z; },
  "Sk": function() { return /* reexport */ TariffCard_TariffCard; },
  "Fe": function() { return /* reexport */ TermsConditions; },
  "al": function() { return /* reexport */ TextBlock_TextBlock/* default */.Z; },
  "gx": function() { return /* reexport */ Textarea/* default */.Z; },
  "Gi": function() { return /* reexport */ TitledBanner_TitledBanner; },
  "e1": function() { return /* reexport */ ToolbarSectionTitle_ToolbarSectionTitle; },
  "UB": function() { return /* reexport */ TopUpBalanceModal_TopUpBalanceModal; },
  "nk": function() { return /* reexport */ Video/* default */.Z; },
  "mx": function() { return /* reexport */ WhoWeAre_WhoWeAre; },
  "YO": function() { return /* reexport */ YourNumberList_YourNumberList; }
});

// UNUSED EXPORTS: BannerWithForegroundImage, BlockLink, BusinessLargeProduct, BusinessTable, BusinessTariffsCard, BusinessWifiInternetCard, CompatibleDevicesModal, CoverageMap, ImageMask, LinkNumbers, PageBanner, Qr, QrBanner, ReverseBlock, StepsBanner, StepsBannerWithTabs, Tooltip, VideoModal

// EXTERNAL MODULE: ./components/ui/Button/Button.tsx
var Button_Button = __webpack_require__(440);
// EXTERNAL MODULE: ./components/ui/Input/Input.tsx
var Input = __webpack_require__(88228);
// EXTERNAL MODULE: ./components/ui/Loader/Loader.js
var Loader = __webpack_require__(4897);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ui/BusinessTariffCard/styles.module.scss
var styles_module = __webpack_require__(51323);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/ui/BusinessTariffCard/CellData.js






var CellData_CellData = function CellData(_ref) {
  var _ref$data = _ref.data,
      leftIcon = _ref$data.left_icon,
      leftHeading = _ref$data.left_heading,
      rightHeading = _ref$data.right_heading,
      leftText = _ref$data.left_text,
      rightText = _ref$data.right_text,
      icons = _ref$data.icons;
  // const renderList = ({ title = '', value = '', media }, key) => (
  //   <li key={key}>
  //     <div className={styles.info}>
  //       {title && <div className={styles.title}>{title}</div>}
  //       {value && <div className={styles.text}>{value}</div>}
  //     </div>
  //     <span className={styles.icons}>
  //       {media?.instagram && <Instagram />}
  //       {media?.whatsapp && <Whatsapp />}
  //       {media?.facebook && <Facebook />}
  //     </span>
  //   </li>
  // );
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (styles_module_default()).cell,
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: [leftIcon && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (styles_module_default()).icon_container,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: leftIcon,
        alt: "leftIcon",
        title: "leftIcon",
        loading: "lazy",
        width: 24,
        height: 24
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (styles_module_default()).info,
      children: [leftHeading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).title,
        children: leftHeading
      }), leftText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).text,
        children: leftText
      })]
    }), rightText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (styles_module_default()).info,
      children: [leftHeading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).title,
        children: rightHeading
      }), leftText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).text,
        children: rightText
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (styles_module_default()).icons,
      children: (icons === null || icons === void 0 ? void 0 : icons.length) > 0 && icons.map(function (icon) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: icon,
          alt: "card icon",
          title: "card icon",
          loading: "lazy",
          width: 24,
          height: 24
        }, icon);
      })
    })]
  });
};

/* harmony default export */ var BusinessTariffCard_CellData = (CellData_CellData);
;// CONCATENATED MODULE: ./components/ui/BusinessTariffCard/BusinessTariffCardWithoutHeader.js
/* eslint-disable no-alert */









var BusinessTariffCardWithoutHeader = function BusinessTariffCardWithoutHeader(_ref) {
  var _data$sections;

  var data = _ref.data,
      handleConnect = _ref.handleConnect;
  // const [active, setActive] = useState(false);
  // const tariffDetails = useRef();
  // const showDetails = () => {
  //   const { scrollHeight } = tariffDetails.current;
  //   if (scrollHeight > sliderHeight) {
  //     changeSliderHeight(scrollHeight);
  //   }
  //   setActive(true);
  // };
  // const hideDetails = () => {
  //   setActive(false);
  // };
  // const renderPrices = ({ title = '', price = '' }, key) => (
  //   <div className={styles['price-box']} key={key}>
  //     {/* {title && <div className={styles['price-box__title']}>{title}</div>} */}
  //     {price && (
  //       <div className={styles['price-box__content']}>
  //         <span className={styles.price}>{price}</span>
  //         <span className={styles.currency}>
  //           <span className='currency'>
  //             <Currency />
  //           </span>
  //           Month
  //         </span>
  //       </div>
  //     )}
  //   </div>
  // );
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(styles_module_default()).tariff]),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [((data === null || data === void 0 ? void 0 : data.name) || data.ussd) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (styles_module_default())["tariff-head"]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (styles_module_default()).tariff__content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).cellContainer,
        children: !!((_data$sections = data.sections) !== null && _data$sections !== void 0 && _data$sections.length) && data.sections.map(function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessTariffCard_CellData, {
            data: item
          }, key);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).bottom,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
          className: (styles_module_default()).button,
          onClick: function onClick() {
            return handleConnect(data.id);
          },
          children: [data === null || data === void 0 ? void 0 : data.button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrRight */.jG, {
            width: 24
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var BusinessTariffCard_BusinessTariffCardWithoutHeader = (BusinessTariffCardWithoutHeader);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./components/ui/Modals/Error/ErrorModal.module.scss
var ErrorModal_module = __webpack_require__(97542);
var ErrorModal_module_default = /*#__PURE__*/__webpack_require__.n(ErrorModal_module);
;// CONCATENATED MODULE: ./components/ui/Modals/Error/ErrorModal.js


/* eslint-disable react-hooks/exhaustive-deps */










var ErrorModal = function ErrorModal(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$classNameInner = _ref.classNameInner,
      classNameInner = _ref$classNameInner === void 0 ? '' : _ref$classNameInner,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? '' : _ref$children,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? '' : _ref$icon,
      _ref$isInsufficient = _ref.isInsufficient,
      isInsufficient = _ref$isInsufficient === void 0 ? '' : _ref$isInsufficient;

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  react.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(ErrorModal_module_default()).wrap, (0,defineProperty/* default */.Z)({}, (ErrorModal_module_default()).open, active), className]),
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(ErrorModal_module_default()).errorInner, classNameInner]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ErrorModal_module_default()).errorContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ErrorModal_module_default()).close,
          onClick: function onClick() {
            return setActive(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        }), icon && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: (ErrorModal_module_default()).icon_img,
          src: icon,
          alt: t('cabinet:common.Error'),
          title: t('cabinet:common.Error'),
          loading: "lazy",
          width: 64,
          height: 64
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (ErrorModal_module_default()).errorText,
          children: t('cabinet:common.Error')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
          className: "soft ".concat((ErrorModal_module_default()).title),
          children: children
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
          onClick: function onClick() {
            setActive(false);
          },
          className: (ErrorModal_module_default()).close_btn,
          children: !isInsufficient ? t('esim:checkout.actions.close') : t('cabinet:common.TopUp')
        })]
      })
    })
  });
};

/* harmony default export */ var Error_ErrorModal = (ErrorModal);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(62049);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/ui/BlockLink/BlockLink.js

var _excluded = (/* unused pure expression or super */ null && (["href", "icon", "alt"]));







var BlockLink = function BlockLink(_ref) {
  var href = _ref.href,
      icon = _ref.icon,
      alt = _ref.alt,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Link, {
    href: href,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/_jsxs("a", {
      title: 'Bakcell',
      "aria-label": "Bakcell",
      className: styles.link,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.icon,
          children: /*#__PURE__*/_jsx(Image, {
            src: icon,
            alt: alt,
            loading: "lazy",
            layout: "fill"
          })
        }), restProps.children]
      }), /*#__PURE__*/_jsx(ArrowRight, {
        className: styles.arrow
      })]
    })
  });
};

/* harmony default export */ var BlockLink_BlockLink = ((/* unused pure expression or super */ null && (BlockLink)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(14730);
// EXTERNAL MODULE: ./components/ui/ActiveLink/ActiveLink.js
var ActiveLink = __webpack_require__(10411);
// EXTERNAL MODULE: ./components/ui/BusinessContactForm/BusinessContactForm.js
var BusinessContactForm_BusinessContactForm = __webpack_require__(77743);
// EXTERNAL MODULE: ./components/ui/FooterLink/FooterLink.module.scss
var FooterLink_module = __webpack_require__(56974);
var FooterLink_module_default = /*#__PURE__*/__webpack_require__.n(FooterLink_module);
;// CONCATENATED MODULE: ./components/ui/FooterLink/FooterLink.js

var FooterLink_excluded = ["list"];










var FooterLink = function FooterLink(_ref) {
  var _list$children;

  var list = _ref.list,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, FooterLink_excluded);

  var _useState = (0,react.useState)(false),
      activeModal = _useState[0],
      setActiveModal = _useState[1];

  var openModal = function openModal() {
    setActiveModal(true);
  };

  var closeModal = function closeModal() {
    setActiveModal(false);
  };

  var renderSwitch = function renderSwitch(item) {
    switch (item === null || item === void 0 ? void 0 : item.type) {
      case 'download':
        return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (FooterLink_module_default()).droppedLink,
          href: item === null || item === void 0 ? void 0 : item.button_download_file,
          itemScope: true,
          itemType: "http://schema.org/DownloadAction",
          title: item === null || item === void 0 ? void 0 : item.text,
          "aria-label": item === null || item === void 0 ? void 0 : item.text,
          children: item === null || item === void 0 ? void 0 : item.text
        });

      case 'pop-up':
        return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (FooterLink_module_default()).write_us,
          onClick: openModal,
          itemScope: true,
          itemType: "http://schema.org/Action",
          title: item === null || item === void 0 ? void 0 : item.text,
          "aria-label": item === null || item === void 0 ? void 0 : item.text,
          children: item === null || item === void 0 ? void 0 : item.text
        });

      default:
        return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/".concat(item === null || item === void 0 ? void 0 : item.slug),
          itemScope: true,
          itemType: "http://schema.org/WebPage",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (FooterLink_module_default()).droppedLink,
            title: item === null || item === void 0 ? void 0 : item.text,
            "aria-label": item === null || item === void 0 ? void 0 : item.text,
            children: item === null || item === void 0 ? void 0 : item.text
          })
        });
    }
  };

  var renderChildList = function renderChildList(item) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: (FooterLink_module_default()).link,
      children: renderSwitch(item)
    }, item.id);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    itemScope: true,
    itemType: "http://schema.org/Action",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FooterLink_module_default()).linkContainer,
      children: !(list !== null && list !== void 0 && list.slug) ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()((FooterLink_module_default()).link),
        children: restProps.children
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ActiveLink/* default */.Z, {
          href: "/".concat(list === null || list === void 0 ? void 0 : list.slug),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: classnames_default()("".concat((FooterLink_module_default()).link, " ").concat((FooterLink_module_default()).linkActive)),
            style: {
              cursor: 'pointer'
            },
            title: 'Bakcell',
            "aria-label": 'Bakcell',
            children: restProps.children
          })
        })
      })
    }), (list === null || list === void 0 ? void 0 : list.children) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: (FooterLink_module_default()).listItem,
      children: (_list$children = list.children) === null || _list$children === void 0 ? void 0 : _list$children.map(renderChildList)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessContactForm_BusinessContactForm/* default */.Z, {
      activeModal: activeModal,
      clearTariff: closeModal,
      hasEmployeesCount: false
    })]
  });
};

/* harmony default export */ var FooterLink_FooterLink = (FooterLink);
// EXTERNAL MODULE: ./components/ui/OwnPhoneInput/OwnPhoneInput.js + 1 modules
var OwnPhoneInput = __webpack_require__(13507);
;// CONCATENATED MODULE: ./components/SvgComponents/BredcrumbsIcon.js



var BredcrumbsIcon = function BredcrumbsIcon() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "5",
    height: "8",
    viewBox: "0 0 5 8",
    fill: "none",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M0.749675 7.58268C0.638563 7.58268 0.541341 7.54449 0.458008 7.4681C0.374674 7.39171 0.333008 7.29102 0.333008 7.16602V0.832682C0.333008 0.707682 0.374674 0.606988 0.458008 0.530599C0.541341 0.45421 0.638563 0.416016 0.749675 0.416016C0.777452 0.416016 0.874674 0.457682 1.04134 0.541016L4.06217 3.56185C4.13162 3.63129 4.18023 3.70074 4.20801 3.77018C4.23579 3.83963 4.24967 3.91602 4.24967 3.99935C4.24967 4.08268 4.23579 4.15907 4.20801 4.22852C4.18023 4.29796 4.13162 4.3674 4.06217 4.43685L1.04134 7.45768C0.999675 7.49935 0.954536 7.5306 0.905924 7.55143C0.857313 7.57227 0.80523 7.58268 0.749675 7.58268Z",
      fill: "#ACA6A6"
    })
  });
};

/* harmony default export */ var SvgComponents_BredcrumbsIcon = (BredcrumbsIcon);
// EXTERNAL MODULE: ./components/ui/Breadcrumbs/Breadcrumbs.module.scss
var Breadcrumbs_module = __webpack_require__(48999);
var Breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumbs_module);
;// CONCATENATED MODULE: ./components/ui/Breadcrumbs/Breadcrumbs.js








function Breadcrumbs(_ref) {
  var data = _ref.data,
      itemFullDetails = _ref.itemFullDetails,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      className = _ref.className;
  if (!(data !== null && data !== void 0 && data.length)) return null;

  var renderList = function renderList(item, key) {
    if (item !== null && item !== void 0 && item.slug) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ActiveLink/* default */.Z, {
        href: "/".concat(item === null || item === void 0 ? void 0 : item.slug),
        itemScope: true,
        itemType: "https://schema.org/Property",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          title: item === null || item === void 0 ? void 0 : item.text,
          "aria-label": item === null || item === void 0 ? void 0 : item.text,
          className: (Breadcrumbs_module_default()).item,
          children: item === null || item === void 0 ? void 0 : item.text
        })
      }, key);
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (Breadcrumbs_module_default()).item,
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: item === null || item === void 0 ? void 0 : item.text
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(Breadcrumbs_module_default()).breadcrumbs, className, (0,defineProperty/* default */.Z)({}, (Breadcrumbs_module_default()).dark, dark)]),
    itemScope: true,
    itemType: "https://schema.org/Bredcrumb",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()(['wrapper', (Breadcrumbs_module_default()).wrapper]),
      children: [data === null || data === void 0 ? void 0 : data.map(function (item, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [renderList(item, key), key < data.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (Breadcrumbs_module_default()).icon,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents_BredcrumbsIcon, {})
          })]
        }, key);
      }), itemFullDetails && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Breadcrumbs_module_default()).icon,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents_BredcrumbsIcon, {})
      })]
    })
  });
}
// EXTERNAL MODULE: ./components/ui/ContactUs/ContactUs.module.scss
var ContactUs_module = __webpack_require__(4147);
var ContactUs_module_default = /*#__PURE__*/__webpack_require__.n(ContactUs_module);
;// CONCATENATED MODULE: ./components/ui/ContactUs/ContactUs.js






var ContactUs = function ContactUs(data) {
  var _data$data;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.map(function (item, index) {
      var _item$contacts;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ContactUs_module_default()).contactUs,
        itemScope: true,
        itemType: "https://schema.org/ContactOption",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ContactUs_module_default()).title,
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ContactUs_module_default()).contactListWrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: (ContactUs_module_default()).contactList,
            children: item === null || item === void 0 ? void 0 : (_item$contacts = item.contacts) === null || _item$contacts === void 0 ? void 0 : _item$contacts.map(function (contact, index) {
              if ((contact === null || contact === void 0 ? void 0 : contact.type) === 'phone') {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    href: "tel:".concat(item === null || item === void 0 ? void 0 : item.value),
                    target: "_blank",
                    rel: "nofollow noopener noreferrer",
                    className: (ContactUs_module_default()).contactItems,
                    children: contact === null || contact === void 0 ? void 0 : contact.text
                  })
                }, index);
              }

              if ((contact === null || contact === void 0 ? void 0 : contact.type) === 'email') {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    href: "mailto:".concat(item === null || item === void 0 ? void 0 : item.value),
                    className: (ContactUs_module_default()).contactItems,
                    target: "_blank",
                    rel: "nofollow noopener noreferrer",
                    children: contact === null || contact === void 0 ? void 0 : contact.text
                  })
                }, index);
              }

              return null;
            })
          })
        })]
      }, index);
    })
  });
};

/* harmony default export */ var ContactUs_ContactUs = (ContactUs);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./components/SvgComponents/Arrow.js
var Arrow = __webpack_require__(22183);
// EXTERNAL MODULE: ./components/ui/PhoneNumbersDropDown/styles.module.scss
var PhoneNumbersDropDown_styles_module = __webpack_require__(19290);
var PhoneNumbersDropDown_styles_module_default = /*#__PURE__*/__webpack_require__.n(PhoneNumbersDropDown_styles_module);
;// CONCATENATED MODULE: ./components/ui/PhoneNumbersDropDown/PhoneNumbersDropDown.js











var PhoneNumbersDropDown = function PhoneNumbersDropDown(_ref) {
  var _ref2;

  var isBusiness = _ref.isBusiness;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(PhoneNumbersDropDown_styles_module_default()).container, (_ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, (PhoneNumbersDropDown_styles_module_default()).active, active), (0,defineProperty/* default */.Z)(_ref2, (PhoneNumbersDropDown_styles_module_default()).business, isBusiness), _ref2)]),
    itemScope: true,
    itemType: "https://schema.org/Property",
    "data-testid": "dropdown-container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PhoneNumbersDropDown_styles_module_default()).wrapper,
      onClick: function onClick() {
        return setActive(!active);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (PhoneNumbersDropDown_styles_module_default()).left,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (PhoneNumbersDropDown_styles_module_default()).user,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* FillUser */.Qc, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (PhoneNumbersDropDown_styles_module_default()).content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "+994 555 55 55"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (PhoneNumbersDropDown_styles_module_default()).price,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "15"
            }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Currency */.F, {
              className: (PhoneNumbersDropDown_styles_module_default()).svgCurrency
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Arrow/* default */.Z, {
        className: (PhoneNumbersDropDown_styles_module_default()).svg
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PhoneNumbersDropDown_styles_module_default()).listWrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: (PhoneNumbersDropDown_styles_module_default()).list,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ActiveLink/* default */.Z, {
            href: '/cabinet',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: "My bakcell"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ActiveLink/* default */.Z, {
            href: '/services/my-card',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: "My cart (0)"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            "aria-label": "Sign out",
            className: (PhoneNumbersDropDown_styles_module_default()).signOut,
            children: "Sign out"
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var PhoneNumbersDropDown_PhoneNumbersDropDown = (PhoneNumbersDropDown);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(12420);
// EXTERNAL MODULE: ./components/SvgComponents/CardShapes.js
var CardShapes = __webpack_require__(3686);
;// CONCATENATED MODULE: ./utils/toCapitalise.js
var toCapitalise = function toCapitalise(str) {
  return (str === null || str === void 0 ? void 0 : str.charAt(0).toUpperCase()) + (str === null || str === void 0 ? void 0 : str.slice(1));
};
// EXTERNAL MODULE: ./enums/theme.ts
var enums_theme = __webpack_require__(29128);
// EXTERNAL MODULE: ./components/ui/SectionTitle/SectionTitle.js
var SectionTitle_SectionTitle = __webpack_require__(66850);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(24666);
// EXTERNAL MODULE: ./components/ui/LinkNumbers/LinkNumbers.module.scss
var LinkNumbers_module = __webpack_require__(59557);
var LinkNumbers_module_default = /*#__PURE__*/__webpack_require__.n(LinkNumbers_module);
;// CONCATENATED MODULE: ./components/ui/LinkNumbers/LinkNumbers.js









var bgVariants = {
  bgWhite: 'link-numbers__item',
  bgTransparent: 'link-numbers__item--blurred'
};

var LinkNumbers_LinkNumbers = function LinkNumbers(_ref) {
  var _itemClass, _ussd$, _ref8;

  var numbers = _ref.numbers,
      isNotLink = _ref.isNotLink,
      isTel = _ref.isTel,
      className = _ref.className,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      isLight = _ref.isLight,
      _ref$bgVariant = _ref.bgVariant,
      bgVariant = _ref$bgVariant === void 0 ? bgVariants.bgTransparent : _ref$bgVariant;

  var _useState = (0,react.useState)(false),
      activateTelIcon = _useState[0],
      setActivateTelIcon = _useState[1];

  var _useState2 = (0,react.useState)(''),
      ussd = _useState2[0],
      setUssd = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      middleDesc = _useState3[0],
      setMiddleDesc = _useState3[1];

  var itemClass = (_itemClass = {}, (0,defineProperty/* default */.Z)(_itemClass, (LinkNumbers_module_default())[bgVariants.bgWhite], bgVariant === bgVariants.bgWhite), (0,defineProperty/* default */.Z)(_itemClass, (LinkNumbers_module_default())[bgVariants.bgTransparent], bgVariant === bgVariants.bgTransparent), _itemClass);

  var replaceHandle = function replaceHandle(arr) {
    return arr === null || arr === void 0 ? void 0 : arr.map(function (item) {
      return item === null || item === void 0 ? void 0 : item.substring(3, item.length - 3);
    });
  };

  (0,react.useEffect)(function () {
    var newUssd = Array.isArray(numbers) ? numbers === null || numbers === void 0 ? void 0 : numbers.join('') : numbers; // setUssd(newUssd.match(/(?<=<-\s+).*?(?=\s+->)/g));
    // setMiddleDesc(newUssd.match(/(?<==>\s+).*?(?=\s+<=)/g));

    setUssd(replaceHandle(newUssd.match(/<-.*?->/g)));
    setMiddleDesc(replaceHandle(newUssd.match(/=>.*?<=/g)));
    setActivateTelIcon(numbers.indexOf('yes') > -1);
  }, [numbers]);
  var LINK_CONTAINER_CLASS = 'link-numbers';
  var FULL = 'link-numbers__full';

  var renderNumber = function renderNumber(item) {
    return (0,toConsumableArray/* default */.Z)(item.join('').replace('yes', '')).map(function (str, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()([itemClass, (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default()).dark, dark)]),
        itemScope: true,
        itemType: "http://schema.org/Text",
        children: str
      }, index);
    });
  };

  if (isNotLink || middleDesc) {
    var _ref4;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(LinkNumbers_module_default())[LINK_CONTAINER_CLASS], className, (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default())["link-numbers--light"], isLight)]),
      itemScope: true,
      itemType: "http://schema.org/Property",
      children: [ussd && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: (_ref4 = [ussd]) === null || _ref4 === void 0 ? void 0 : _ref4.map(renderNumber)
      }), middleDesc && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()([itemClass, (LinkNumbers_module_default())[FULL], (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default()).dark, dark)]),
        children: middleDesc
      }), isTel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()([itemClass, (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default()).dark, dark)]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Call */.Ig, {})
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: ussd && /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      href: "tel:".concat((_ussd$ = ussd[0]) === null || _ussd$ === void 0 ? void 0 : _ussd$.replace('yes', '').replace(/#/g, '%23')),
      className: classnames_default()([(LinkNumbers_module_default())[LINK_CONTAINER_CLASS], className, (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default())["link-numbers--light"], isLight)]),
      itemScope: true,
      itemType: "http://schema.org/Thing",
      children: [ussd && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (LinkNumbers_module_default())["inner-container"],
        children: (_ref8 = [ussd]) === null || _ref8 === void 0 ? void 0 : _ref8.map(renderNumber)
      }), activateTelIcon && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()([itemClass, (0,defineProperty/* default */.Z)({}, (LinkNumbers_module_default()).dark, dark)]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Call */.Ig, {})
      })]
    })
  });
};

/* harmony default export */ var ui_LinkNumbers_LinkNumbers = (LinkNumbers_LinkNumbers);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(648);
// EXTERNAL MODULE: ./domains/cabinet/index.js + 1 modules
var cabinet = __webpack_require__(3519);
// EXTERNAL MODULE: ./components/ui/TariffCard/TariffContent/styles.module.scss
var TariffContent_styles_module = __webpack_require__(7802);
var TariffContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(TariffContent_styles_module);
;// CONCATENATED MODULE: ./components/ui/TariffCard/TariffContent/TariffContent.js












var TariffContent = function TariffContent(_ref) {
  var _item$sections, _item$additions, _item$external_link;

  var item = _ref.item,
      theme = _ref.theme,
      onClick = _ref.onClick;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var dispatch = (0,es/* useDispatch */.I0)();
  var clickHandler = react.useCallback(function () {
    dispatch(cabinet/* actions.setTariffModal */.Nw.setTariffModal(true));
    dispatch(cabinet/* actions.setIsPackageOrTariff */.Nw.setIsPackageOrTariff((item === null || item === void 0 ? void 0 : item.type) === 'tariff'));
    dispatch(cabinet/* actions.setSelectedTariff */.Nw.setSelectedTariff(item));
  }, [item]);

  var renderAdditions = function renderAdditions(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (TariffContent_styles_module_default()).infoText,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (TariffContent_styles_module_default()).plus,
        children: "+"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: item
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (TariffContent_styles_module_default()).content,
    children: [!!(item !== null && item !== void 0 && item.sections) && (item === null || item === void 0 ? void 0 : (_item$sections = item.sections) === null || _item$sections === void 0 ? void 0 : _item$sections.map(function (section) {
      var _section$right_icons;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TariffContent_styles_module_default()).itemContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: (theme === null || theme === void 0 ? void 0 : theme.resolvedTheme) === enums_theme/* ETheme.DARK_MODE */.X.DARK_MODE && section !== null && section !== void 0 && section.dark_mode_left_icon ? section === null || section === void 0 ? void 0 : section.dark_mode_left_icon : section === null || section === void 0 ? void 0 : section.left_icon,
          alt: section.heading_text,
          title: section.heading_text,
          height: 24,
          width: 24,
          loading: "lazy"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (TariffContent_styles_module_default()).info,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (TariffContent_styles_module_default()).itemIcon,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (TariffContent_styles_module_default()).tariff,
              children: section === null || section === void 0 ? void 0 : section.text
            }), (section === null || section === void 0 ? void 0 : section.right_icons) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: section === null || section === void 0 ? void 0 : (_section$right_icons = section.right_icons) === null || _section$right_icons === void 0 ? void 0 : _section$right_icons.map(function (icon, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: icon,
                  alt: section.heading_text,
                  title: section.heading_text,
                  height: 24,
                  width: 24,
                  loading: "lazy"
                }, index);
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (TariffContent_styles_module_default()).text,
            children: section === null || section === void 0 ? void 0 : section.heading_text
          })]
        })]
      }, section.heading_text);
    })), !!(item !== null && item !== void 0 && item.additions) && (item === null || item === void 0 ? void 0 : (_item$additions = item.additions) === null || _item$additions === void 0 ? void 0 : _item$additions.map(function (item, index) {
      return renderAdditions(item, index);
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((TariffContent_styles_module_default()).contentBottom, " ").concat((item === null || item === void 0 ? void 0 : item.button_slug) && (TariffContent_styles_module_default()).contentBottom__popUp),
      children: [(item === null || item === void 0 ? void 0 : item.button_slug) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        Component: 'a',
        variant: 'outline',
        size: 'normal',
        onClick: onClick,
        href: item !== null && item !== void 0 && item.button_slug ? item === null || item === void 0 ? void 0 : item.button_slug : item === null || item === void 0 ? void 0 : (_item$external_link = item.external_link) === null || _item$external_link === void 0 ? void 0 : _item$external_link.concat("?___store=".concat(lang)),
        className: "".concat((item === null || item === void 0 ? void 0 : item.button_slug) && (TariffContent_styles_module_default()).seeMore),
        "data-testid": 'tariff-see-more',
        children: t('common:See more')
      }), (item === null || item === void 0 ? void 0 : item.isSubscribable) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        size: 'normal',
        onClick: clickHandler,
        "data-testid": "tariff-subscribe-button",
        className: "bkc-gtm_tracking\n        ".concat(!(item !== null && item !== void 0 && item.button_slug) ? 'external_link' : '', " ").concat(item === null || item === void 0 ? void 0 : item.name, " ").concat((TariffContent_styles_module_default()).button, "\n          ").concat((item === null || item === void 0 ? void 0 : item.button_slug) && (TariffContent_styles_module_default()).button__tariffButton, "\n          "),
        children: t('common:Subscribe')
      })]
    })]
  });
};

/* harmony default export */ var TariffContent_TariffContent = (/*#__PURE__*/react.memo(TariffContent));
// EXTERNAL MODULE: ./components/ui/TariffCard/styles.module.scss
var TariffCard_styles_module = __webpack_require__(14188);
var TariffCard_styles_module_default = /*#__PURE__*/__webpack_require__.n(TariffCard_styles_module);
;// CONCATENATED MODULE: ./components/ui/TariffCard/TariffCard.js















var TariffCard = function TariffCard(_ref) {
  var _ref2;

  var item = _ref.item,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick,
      className = _ref.className;
  var theme = (0,index_module/* useTheme */.F)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(TariffCard_styles_module_default()).card, (_ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, (TariffCard_styles_module_default()).black, item === null || item === void 0 ? void 0 : item.black), (0,defineProperty/* default */.Z)(_ref2, (TariffCard_styles_module_default()).hot, item === null || item === void 0 ? void 0 : item.hot_icon), (0,defineProperty/* default */.Z)(_ref2, (TariffCard_styles_module_default()).mascotSmall, (item === null || item === void 0 ? void 0 : item.mascot_position) === 'top'), (0,defineProperty/* default */.Z)(_ref2, (TariffCard_styles_module_default()).mascotMiddle, (item === null || item === void 0 ? void 0 : item.mascot_position) === 'middle'), (0,defineProperty/* default */.Z)(_ref2, (TariffCard_styles_module_default()).mascotBottom, (item === null || item === void 0 ? void 0 : item.mascot_position) === 'bottom'), _ref2), className]),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [(item === null || item === void 0 ? void 0 : item.hot_icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (TariffCard_styles_module_default()).hotIcon,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item.hot_icon,
        alt: "Hot tariff",
        title: "Hot tariff",
        loading: "lazy",
        layout: "fill"
      })
    }), (item === null || item === void 0 ? void 0 : item.mascot_icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (TariffCard_styles_module_default()).mascot,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item.mascot_icon,
        alt: "Mascot",
        title: "Mascot",
        loading: "lazy",
        layout: "fill"
      })
    }), (item === null || item === void 0 ? void 0 : item.corner_text) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (TariffCard_styles_module_default()).profitableCorner,
      children: item.corner_text
    }), (item === null || item === void 0 ? void 0 : item.ussd) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (TariffCard_styles_module_default()).backgroundWrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TariffCard_styles_module_default()).tag,
        children: [(item === null || item === void 0 ? void 0 : item.top_icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: (theme === null || theme === void 0 ? void 0 : theme.resolvedTheme) === enums_theme/* ETheme.DARK_MODE */.X.DARK_MODE && item !== null && item !== void 0 && item.dark_mode_top_icon ? item === null || item === void 0 ? void 0 : item.dark_mode_top_icon : item === null || item === void 0 ? void 0 : item.top_icon,
          width: 20,
          height: 20,
          alt: "tariff tag icon",
          title: "tariff tag icon"
        }), toCapitalise(item === null || item === void 0 ? void 0 : item.type)]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TariffCard_styles_module_default()).top,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (TariffCard_styles_module_default()).titleTop,
          children: [(item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
            titleModify: classnames_default()((TariffCard_styles_module_default()).title, 'title--large'),
            children: item === null || item === void 0 ? void 0 : item.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (TariffCard_styles_module_default()).rectangle
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (TariffCard_styles_module_default()).priceContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (TariffCard_styles_module_default()).price,
            children: [item === null || item === void 0 ? void 0 : item.price, " "]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (TariffCard_styles_module_default()).text,
            children: ["\u20BC/", item === null || item === void 0 ? void 0 : item.price_text]
          })]
        }), !!(item !== null && item !== void 0 && item.ussd) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (TariffCard_styles_module_default()).number,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
            numbers: item === null || item === void 0 ? void 0 : item.ussd
          }), (item === null || item === void 0 ? void 0 : item.text_after_ussd) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (TariffCard_styles_module_default()).ussd_label,
            children: item.text_after_ussd
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardShapes/* default */.Z, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TariffContent_TariffContent, {
      item: item,
      theme: theme,
      onClick: onClick
    })]
  });
};

/* harmony default export */ var TariffCard_TariffCard = (TariffCard);
// EXTERNAL MODULE: ./components/home/Banner/Banner.js
var Banner = __webpack_require__(36896);
// EXTERNAL MODULE: ./components/ui/StoreList/store-list.module.scss
var store_list_module = __webpack_require__(53510);
var store_list_module_default = /*#__PURE__*/__webpack_require__.n(store_list_module);
;// CONCATENATED MODULE: ./components/ui/StoreList/StoreList.js





var StoreList = function StoreList(_ref) {
  var links = _ref.links;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var renderStore = function renderStore(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: (store_list_module_default()).link,
      href: item === null || item === void 0 ? void 0 : item.link,
      target: '_blank',
      rel: "noopener noreferrer",
      itemScope: true,
      itemType: "https://schema.org/LinkRole",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item.image,
        alt: t('common:Download our app'),
        title: t('common:Download our app'),
        loading: "lazy",
        width: 148,
        height: 48
      })
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (store_list_module_default()).list,
    children: links === null || links === void 0 ? void 0 : links.map(renderStore)
  });
};

/* harmony default export */ var StoreList_StoreList = (StoreList);
// EXTERNAL MODULE: ./components/ui/Tabs/Tab.js
var Tabs_Tab = __webpack_require__(15051);
// EXTERNAL MODULE: ./components/ui/Tabs/TabPanel.js
var Tabs_TabPanel = __webpack_require__(59883);
// EXTERNAL MODULE: ./components/ui/Tabs/TabContent.js
var Tabs_TabContent = __webpack_require__(17413);
// EXTERNAL MODULE: ./components/ui/Tabs/Tabs.js
var Tabs_Tabs = __webpack_require__(5738);
// EXTERNAL MODULE: ./components/ui/Tabs/TabContentItem.js
var Tabs_TabContentItem = __webpack_require__(42069);
;// CONCATENATED MODULE: ./components/ui/PageBanner/PageBanner.js





var PageBanner = function PageBanner(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      text = _ref.text;
  return /*#__PURE__*/_jsx("div", {
    className: styles.banner,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/_jsxs("div", {
      className: "wrapper ".concat(styles.wrapper),
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [subtitle && /*#__PURE__*/_jsx("h2", {
          className: styles.subtitle,
          dangerouslySetInnerHTML: {
            __html: subtitle
          }
        }), /*#__PURE__*/_jsx("h2", {
          className: styles.title,
          dangerouslySetInnerHTML: {
            __html: title
          }
        }), text && /*#__PURE__*/_jsx("span", {
          className: styles.text,
          children: text
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.image,
        children: /*#__PURE__*/_jsx(BakcellPageBanner, {})
      })]
    })
  });
};

/* harmony default export */ var PageBanner_PageBanner = ((/* unused pure expression or super */ null && (PageBanner)));
// EXTERNAL MODULE: ./components/ui/DropDownFilter/styles.module.scss
var DropDownFilter_styles_module = __webpack_require__(2849);
var DropDownFilter_styles_module_default = /*#__PURE__*/__webpack_require__.n(DropDownFilter_styles_module);
;// CONCATENATED MODULE: ./components/ui/DropDownFilter/DropDownFilter.js









var DropDownFilter = function DropDownFilter(_ref) {
  var active = _ref.active,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {
    return null;
  } : _ref$onSelect,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      title = _ref.title;

  var renderTab = function renderTab(item, index) {
    var isActive;

    if (active.length) {
      isActive = active.find(function (activeItem) {
        return (activeItem === null || activeItem === void 0 ? void 0 : activeItem.id) === item.id;
      });
    }

    var arraysAreEqual = active.length === data.length && active.every(function (v, i) {
      return v.id === data[i].id;
    });

    var onClick = function onClick() {
      if (item.id === 0) {
        if (arraysAreEqual) return onSelect([]);
        return onSelect(data);
      }

      if (isActive) {
        var array = active.filter(function (activeItem) {
          if (activeItem.id === 0) return false;
          return activeItem.id !== item.id;
        });
        return onSelect(array);
      }

      return onSelect([].concat((0,toConsumableArray/* default */.Z)(active), [item]));
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      className: classnames_default()([(DropDownFilter_styles_module_default()).tab, (0,defineProperty/* default */.Z)({}, (DropDownFilter_styles_module_default()).active, isActive)]),
      onClick: onClick,
      "aria-label": item.text,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (DropDownFilter_styles_module_default()).icon,
        children: isActive ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Check */.Jr, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Close */.x8, {})
      }), item.text]
    }, index);
  };

  var inputTitle = react.useMemo(function () {
    var items = [];

    for (var i = 0; i <= active.length; i++) {
      var _active$i, _active$i3;

      if (((_active$i = active[i]) === null || _active$i === void 0 ? void 0 : _active$i.id) === 0) {
        var _active$i2;

        items.push((_active$i2 = active[i]) === null || _active$i2 === void 0 ? void 0 : _active$i2.text);
        break;
      }

      items.push((_active$i3 = active[i]) === null || _active$i3 === void 0 ? void 0 : _active$i3.text);
    }

    return items;
  }, [active]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (DropDownFilter_styles_module_default()).container,
    itemScope: true,
    itemType: "https://schema.org/Action",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (DropDownFilter_styles_module_default()).title,
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DropDownFilter_styles_module_default()).input,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        disabled: true,
        value: inputTitle.filter(function (item) {
          return !!item;
        }).join(', '),
        "aria-label": title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
        width: 14
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (DropDownFilter_styles_module_default()).panel,
      children: data.map(renderTab)
    })]
  });
};

/* harmony default export */ var DropDownFilter_DropDownFilter = (DropDownFilter);
// EXTERNAL MODULE: ./components/ui/RadioWithTitle/styles.module.scss
var RadioWithTitle_styles_module = __webpack_require__(72503);
var RadioWithTitle_styles_module_default = /*#__PURE__*/__webpack_require__.n(RadioWithTitle_styles_module);
;// CONCATENATED MODULE: ./components/ui/RadioWithTitle/RadioWithTitle.tsx







var RadioWithTitle = function RadioWithTitle(_ref) {
  var _classNames;

  var children = _ref.children,
      onChange = _ref.onChange,
      checked = _ref.checked,
      name = _ref.name,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      className = _ref.className,
      classNameTitle = _ref.classNameTitle,
      size = _ref.size;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
    className: classnames_default()((RadioWithTitle_styles_module_default()).radio, className, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (RadioWithTitle_styles_module_default()).reverse, reverse), (0,defineProperty/* default */.Z)(_classNames, (RadioWithTitle_styles_module_default()).medium, size === 'medium'), _classNames)),
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      name: name,
      type: 'radio',
      onChange: onChange,
      value: checked ? 'true' : 'false',
      checked: checked
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((RadioWithTitle_styles_module_default()).title, classNameTitle),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: children
      })
    })]
  });
};

/* harmony default export */ var RadioWithTitle_RadioWithTitle = (RadioWithTitle);
// EXTERNAL MODULE: ./components/ui/Characteristics/Characteristics.module.scss
var Characteristics_module = __webpack_require__(99170);
var Characteristics_module_default = /*#__PURE__*/__webpack_require__.n(Characteristics_module);
;// CONCATENATED MODULE: ./components/ui/Characteristics/Characteristics.js









var Characteristics = function Characteristics(_ref) {
  var _items$sections;

  var items = _ref.items;

  var _useTheme = (0,index_module/* useTheme */.F)(),
      theme = _useTheme.theme;

  var renderIcon = function renderIcon(icon, key) {
    if (icon.length > 0) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Characteristics_module_default()).socIcon,
        itemScope: true,
        itemType: "https://schema.org/ImageObject",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: icon,
          alt: "social media icon",
          title: "Social Media Icon",
          width: 56,
          height: 56,
          loading: "lazy"
        })
      }, key);
    }

    return null;
  };

  var renderItem = function renderItem(item, key) {
    var _item$right_icons, _item$right_icons2;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((Characteristics_module_default()).item, " ").concat((Characteristics_module_default())[items.type]),
      itemScope: true,
      itemType: "https://schema.org/Article",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(['characteristics--image', (Characteristics_module_default()).icon]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: theme === enums_theme/* ETheme.LIGHT_MODE */.X.LIGHT_MODE ? item === null || item === void 0 ? void 0 : item.light_mode_icon : item === null || item === void 0 ? void 0 : item.dark_mode_icon,
            alt: item === null || item === void 0 ? void 0 : item.text,
            title: item === null || item === void 0 ? void 0 : item.text,
            className: theme === enums_theme/* ETheme.LIGHT_MODE */.X.LIGHT_MODE ? 'white' : '',
            width: 24,
            height: 24,
            loading: "lazy"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Characteristics_module_default()).nameBlock,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (Characteristics_module_default()).name,
            children: item === null || item === void 0 ? void 0 : item.text
          }), (item === null || item === void 0 ? void 0 : item.tooltip) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (Characteristics_module_default()).tooltip,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (Characteristics_module_default()).tooltipIcon,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: item === null || item === void 0 ? void 0 : item.tooltip_icon,
                alt: item === null || item === void 0 ? void 0 : item.tooltip_icon,
                title: item === null || item === void 0 ? void 0 : item.tooltip_icon,
                width: 42,
                height: 42,
                loading: "lazy"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (Characteristics_module_default()).tooltipContent,
              children: item === null || item === void 0 ? void 0 : item.tooltip
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Characteristics_module_default()).value,
        children: [(item === null || item === void 0 ? void 0 : item.right_text) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: item === null || item === void 0 ? void 0 : item.right_text
        }), (item === null || item === void 0 ? void 0 : (_item$right_icons = item.right_icons) === null || _item$right_icons === void 0 ? void 0 : _item$right_icons.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: item === null || item === void 0 ? void 0 : (_item$right_icons2 = item.right_icons) === null || _item$right_icons2 === void 0 ? void 0 : _item$right_icons2.map(renderIcon)
        })]
      })]
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Characteristics_module_default()).characteristics,
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Characteristics_module_default()).containerTitle,
      children: items === null || items === void 0 ? void 0 : items.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Characteristics_module_default()).list,
      children: items === null || items === void 0 ? void 0 : (_items$sections = items.sections) === null || _items$sections === void 0 ? void 0 : _items$sections.map(renderItem)
    })]
  });
};

/* harmony default export */ var Characteristics_Characteristics = (Characteristics);
// EXTERNAL MODULE: ./components/ui/ActivateBlock/ActivateBlock.module.scss
var ActivateBlock_module = __webpack_require__(92341);
var ActivateBlock_module_default = /*#__PURE__*/__webpack_require__.n(ActivateBlock_module);
;// CONCATENATED MODULE: ./components/ui/ActivateBlock/ActivateBlock.js











var ActivateBlock = function ActivateBlock(_ref) {
  var _data$ussd;

  var data = _ref.data,
      tariff = _ref.tariff,
      isSubscrable = _ref.isSubscrable;
  var dispatch = (0,es/* useDispatch */.I0)();

  var tariffHandler = function tariffHandler() {
    dispatch(cabinet/* actions.setTariffModal */.Nw.setTariffModal(true));
    dispatch(cabinet/* actions.setIsPackageOrTariff */.Nw.setIsPackageOrTariff((tariff === null || tariff === void 0 ? void 0 : tariff.type) === 'tariff'));
    dispatch(cabinet/* actions.setSelectedTariff */.Nw.setSelectedTariff(tariff));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ActivateBlock_module_default()).container,
    itemScope: true,
    itemType: "http://schema.org/Product",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ActivateBlock_module_default()).containerTitle,
      children: data === null || data === void 0 ? void 0 : data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((ActivateBlock_module_default()).block, " ").concat((ActivateBlock_module_default()).payment),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ActivateBlock_module_default()).price,
        children: [data === null || data === void 0 ? void 0 : data.price, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "currency",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Currency */.F, {
            "data-testid": "currency"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ActivateBlock_module_default()).title,
        children: data === null || data === void 0 ? void 0 : data.description
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ActivateBlock_module_default()).codeBlock,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ActivateBlock_module_default()).note,
          children: "".concat(data === null || data === void 0 ? void 0 : data.text_before_ussd, " ").concat(data === null || data === void 0 ? void 0 : data.text_after_ussd)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ActivateBlock_module_default())["note-inline"],
          children: data === null || data === void 0 ? void 0 : data.text_before_ussd
        }), (data === null || data === void 0 ? void 0 : (_data$ussd = data.ussd) === null || _data$ussd === void 0 ? void 0 : _data$ussd.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
          numbers: data === null || data === void 0 ? void 0 : data.ussd,
          isTel: true,
          isLight: true,
          bgVariant: bgVariants.bgWhite,
          "data-testid": "link-numbers"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ActivateBlock_module_default())["note-inline"],
          children: data === null || data === void 0 ? void 0 : data.text_after_ussd
        })]
      }), isSubscrable && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ActivateBlock_module_default()).action,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
          className: (ActivateBlock_module_default()).button,
          onClick: tariffHandler,
          children: data === null || data === void 0 ? void 0 : data.button_text
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(ActivateBlock_module_default()).block, (ActivateBlock_module_default()).qrCodeBlock]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ActivateBlock_module_default()).qrTextContainer,
        children: [(data === null || data === void 0 ? void 0 : data.qr_title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ActivateBlock_module_default()).title,
          children: data === null || data === void 0 ? void 0 : data.qr_title
        }), (data === null || data === void 0 ? void 0 : data.qr_description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ActivateBlock_module_default()).qrTooltip,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (ActivateBlock_module_default()).text,
            dangerouslySetInnerHTML: {
              __html: data === null || data === void 0 ? void 0 : data.qr_description
            }
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ActivateBlock_module_default()).qrCode,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ActivateBlock_module_default()).image,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: data === null || data === void 0 ? void 0 : data.qr_image,
            alt: data === null || data === void 0 ? void 0 : data.qr_title,
            title: data === null || data === void 0 ? void 0 : data.qr_title,
            loading: "lazy",
            layout: "fill",
            "data-testid": "next-image"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ActivateBlock_module_default()).mobileLinks,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          title: data === null || data === void 0 ? void 0 : data.title,
          "aria-label": data === null || data === void 0 ? void 0 : data.title,
          href: "https://onelink.to/3shfk7",
          target: "_blank",
          rel: "noreferrer",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ActivateBlock_module_default()).logo,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/assets/play-store.svg",
              alt: "play-store",
              title: "Play-Store",
              width: 120,
              height: 40,
              "data-testid": "next-image"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ActivateBlock_module_default()).logo,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/assets/app-store.svg",
              alt: "app-store",
              title: "App-Store",
              width: 120,
              height: 40,
              "data-testid": "next-image"
            })
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var ActivateBlock_ActivateBlock = (ActivateBlock);
// EXTERNAL MODULE: ./components/ui/HiddenList/HiddenList.module.scss
var HiddenList_module = __webpack_require__(50234);
var HiddenList_module_default = /*#__PURE__*/__webpack_require__.n(HiddenList_module);
;// CONCATENATED MODULE: ./components/ui/HiddenList/HiddenList.js






var HiddenList = function HiddenList(_ref) {
  var _items$points;

  var items = _ref.items;

  var _useState = (0,react.useState)(false),
      isShowAll = _useState[0],
      setIsShowAll = _useState[1];

  var _useState2 = (0,react.useState)(true),
      listButtonText = _useState2[0],
      setListButtonText = _useState2[1];

  var listBlock = (0,react.useRef)(null);
  var innerBlock = (0,react.useRef)(null);
  var textIsButton = listButtonText ? 'See All' : 'Hide All';

  var renderItem = function renderItem(item, key) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (HiddenList_module_default()).item,
      itemScope: true,
      itemType: "http://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.text
    }, key);
  };

  var toggleList = function toggleList() {
    listBlock.current.style.setProperty('--height', "".concat(innerBlock.current.offsetHeight, "px"));
    setIsShowAll(!isShowAll);
    setListButtonText(!listButtonText);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((HiddenList_module_default()).wrap, " ").concat(isShowAll ? (HiddenList_module_default()).open : ''),
    ref: listBlock,
    itemScope: true,
    itemType: "http://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (HiddenList_module_default()).inner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (HiddenList_module_default()).list,
        ref: innerBlock,
        children: items === null || items === void 0 ? void 0 : (_items$points = items.points) === null || _items$points === void 0 ? void 0 : _items$points.map(function (item, key) {
          return renderItem(item, key);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (HiddenList_module_default()).showAll,
      onClick: toggleList,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        className: (HiddenList_module_default()).button,
        children: textIsButton
      })
    })]
  });
};

/* harmony default export */ var HiddenList_HiddenList = (HiddenList);
// EXTERNAL MODULE: ./components/ui/InternetBanner/InternetBanner.js
var InternetBanner = __webpack_require__(85712);
// EXTERNAL MODULE: ./components/ui/InputAutoComplete/InputAutoComplete.js
var InputAutoComplete = __webpack_require__(48807);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./utils/handleCheckKey.ts
var handleCheckKey = __webpack_require__(88929);
// EXTERNAL MODULE: ./hooks/useClickOutside.js
var useClickOutside = __webpack_require__(95562);
// EXTERNAL MODULE: ./components/ui/InputAutoComplete/InputAutoComplete.module.scss
var InputAutoComplete_module = __webpack_require__(4523);
var InputAutoComplete_module_default = /*#__PURE__*/__webpack_require__.n(InputAutoComplete_module);
;// CONCATENATED MODULE: ./components/ui/InputAutoComplete/InputAutoCompleteForCheckout.js














var InputAutoCompleteForCheckout_InputAutoComplete = function InputAutoComplete(_ref) {
  var _data$bottom_countrie;

  var className = _ref.className,
      data = _ref.data,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      value = _ref.value,
      _ref$setValue = _ref.setValue,
      setValue = _ref$setValue === void 0 ? function () {
    return null;
  } : _ref$setValue,
      setOptionValue = _ref.setOptionValue,
      cleanText = _ref.cleanText,
      inputRef = _ref.inputRef,
      label = _ref.label,
      onSelect = _ref.onSelect,
      models = _ref.models,
      highlight = _ref.highlight,
      searchList = _ref.searchList,
      endIcon = _ref.endIcon,
      endIconClick = _ref.endIconClick,
      onClick = _ref.onClick,
      loading = _ref.loading,
      withoutPopulars = _ref.withoutPopulars,
      withoutIcons = _ref.withoutIcons,
      animatedLabel = _ref.animatedLabel,
      required = _ref.required,
      id = _ref.id,
      disabled = _ref.disabled,
      dataTestId = _ref.dataTestId;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(models),
      searchResult = _useState[0],
      setSearchResult = _useState[1];

  var _useState2 = (0,react.useState)(false),
      active = _useState2[0],
      setActive = _useState2[1];

  var outsideRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    setSearchResult(models);
  }, [models]);

  var highlightText = function highlightText(text) {
    if (!value) return text;
    var regex = new RegExp("(".concat(value, ")"), 'gi');
    return text === null || text === void 0 ? void 0 : text.replace(regex, '<span class="highlight">$1</span>');
  };

  var inputOnChange = function inputOnChange(e) {
    var inputValue = e.target.value;
    setValue(inputValue);

    if (inputValue === '') {
      setActive(true);
      setSearchResult(models);
      return;
    }

    var resultModels = models === null || models === void 0 ? void 0 : models.filter(function (item) {
      var _item$name;

      return item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(inputValue.toLowerCase());
    });
    setSearchResult(resultModels);
    setActive(true);
  };

  var popularCountries = function popularCountries(item) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (InputAutoComplete_module_default()).country,
      onClick: function onClick() {
        return onSelect(item === null || item === void 0 ? void 0 : item.name);
      },
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: item === null || item === void 0 ? void 0 : item.name
    }, item === null || item === void 0 ? void 0 : item.id);
  };

  var renderSearchContent = function renderSearchContent(item) {
    var _item$title;

    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (InputAutoComplete_module_default()).country,
      onClick: function onClick() {
        return onSelect(item);
      },
      dangerouslySetInnerHTML: {
        __html: highlightText((_item$title = item === null || item === void 0 ? void 0 : item.title) !== null && _item$title !== void 0 ? _item$title : item === null || item === void 0 ? void 0 : item.description)
      }
    }, item === null || item === void 0 ? void 0 : item.title);
  };

  var renderOptions = function renderOptions(option, index) {
    var handleSelect = function handleSelect() {
      if (setValue) setValue(option.name);
      if (setOptionValue) setOptionValue(option);
      if (onSelect) onSelect(option.name);
      setActive(false);
      setSearchResult([]);
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
      onClick: handleSelect,
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (InputAutoComplete_module_default()).active,
        children: Array.isArray(active) ? active[0] : active
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        dangerouslySetInnerHTML: {
          __html: highlight ? highlightText(option.name) : option.name
        }
      })]
    }, index);
  };

  (0,useClickOutside/* default */.Z)(outsideRef, function () {
    return setActive(false);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: outsideRef,
    className: classnames_default()([(InputAutoComplete_module_default()).inputDropDown, className, (0,defineProperty/* default */.Z)({}, (InputAutoComplete_module_default()).active, active)]),
    itemScope: true,
    itemType: "https://schema.org/CheckoutPage" // onBlur={() => setActive(false)}
    ,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (InputAutoComplete_module_default()).inputWrapper,
      children: [!!label && !animatedLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "label ".concat((InputAutoComplete_module_default()).inputLabel),
        children: label
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        ref: inputRef,
        className: (InputAutoComplete_module_default()).input,
        onChange: inputOnChange,
        placeholder: placeholder,
        value: value,
        onFocus: function onFocus() {
          return setActive(true);
        },
        onClick: onClick,
        required: required,
        disabled: disabled,
        onKeyDown: handleCheckKey/* validateGeneral */.F,
        id: id,
        "data-testid": dataTestId,
        "aria-label": label || placeholder
      }), animatedLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        htmlFor: id,
        children: label
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (InputAutoComplete_module_default()).btnsWrapper,
        children: [!!value && !withoutIcons && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return setValue('');
          },
          className: (InputAutoComplete_module_default()).close,
          children: cleanText || /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseSquare */.s9, {})
        }), !!endIcon && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "endIcon",
          onClick: endIconClick,
          children: endIcon
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: classnames_default()([(InputAutoComplete_module_default()).dropDown, (0,defineProperty/* default */.Z)({}, (InputAutoComplete_module_default()).hidden, !(searchResult !== null && searchResult !== void 0 && searchResult.length))]),
      style: withoutPopulars && {
        top: '100%'
      },
      children: searchResult === null || searchResult === void 0 ? void 0 : searchResult.map(renderOptions)
    }), !withoutPopulars && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [!!(data !== null && data !== void 0 && data.bottom_countries_title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("h6", {
        className: (InputAutoComplete_module_default()).title,
        children: [data === null || data === void 0 ? void 0 : data.bottom_countries_title, ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (InputAutoComplete_module_default()).popularBox,
        children: data === null || data === void 0 ? void 0 : (_data$bottom_countrie = data.bottom_countries) === null || _data$bottom_countrie === void 0 ? void 0 : _data$bottom_countrie.map(popularCountries)
      })]
    })]
  });
};

/* harmony default export */ var InputAutoCompleteForCheckout = (InputAutoCompleteForCheckout_InputAutoComplete);
// EXTERNAL MODULE: ./components/ui/TextBlock/TextBlock.js
var TextBlock_TextBlock = __webpack_require__(46202);
// EXTERNAL MODULE: ./components/ui/Advantageous/Advantageous.module.scss
var Advantageous_module = __webpack_require__(29573);
var Advantageous_module_default = /*#__PURE__*/__webpack_require__.n(Advantageous_module);
;// CONCATENATED MODULE: ./components/ui/Advantageous/Advantageous.js


/* eslint-disable prefer-regex-literals */








var Advantageous = function Advantageous(_ref) {
  var _advantageousData$sec;

  var advantageousData = _ref.advantageousData;

  var renderCardItem = function renderCardItem(item, index) {
    var splitUssdCode = function splitUssdCode(text) {
      var regExp = new RegExp(/[\^*].*#/gm, 'gi');
      return text === null || text === void 0 ? void 0 : text.toString().replace(regExp, function (match) {
        return (0,toConsumableArray/* default */.Z)(match).map(function (item) {
          return "<a title='Bakcell' arial-label='Bakcell' href='tel:".concat(match.replace(/#/g, '%23'), "' class='number_item' key={index}>").concat(item, "</a>");
        }).join(' ');
      });
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
      className: (Advantageous_module_default())["advantageous-card"],
      itemScope: true,
      itemType: "https://schema.org/Article",
      children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item === null || item === void 0 ? void 0 : item.icon,
        alt: item === null || item === void 0 ? void 0 : item.title,
        title: item === null || item === void 0 ? void 0 : item.title,
        className: (Advantageous_module_default())["advantageous-card__icon-wrapper"],
        loading: "lazy",
        width: 24,
        height: 24
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Advantageous_module_default())["advantageous-card__content"],
        children: [(item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: classnames_default()('title', 'title--extend', (Advantageous_module_default())["advantageous-card__title"]),
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('text', 'text--lite-gray', 'text--small', (Advantageous_module_default())["advantageous-card__text"]),
          dangerouslySetInnerHTML: {
            __html: splitUssdCode(item === null || item === void 0 ? void 0 : item.description)
          }
        })]
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "wrapper small-margin",
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (Advantageous_module_default()).advantageous,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Advantageous_module_default())["advantageous__title-block"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
          className: (Advantageous_module_default()).advantageous__title,
          titleModify: "title--large",
          children: advantageousData === null || advantageousData === void 0 ? void 0 : advantageousData.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
          isHtml: true,
          className: classnames_default()('text--large', (Advantageous_module_default()).advantageous__text),
          children: advantageousData === null || advantageousData === void 0 ? void 0 : advantageousData.description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Advantageous_module_default()).advantageous__inner, 'small-margin'),
        children: advantageousData === null || advantageousData === void 0 ? void 0 : (_advantageousData$sec = advantageousData.sections) === null || _advantageousData$sec === void 0 ? void 0 : _advantageousData$sec.map(renderCardItem)
      })]
    })
  });
};

/* harmony default export */ var Advantageous_Advantageous = (Advantageous);
// EXTERNAL MODULE: ./components/ui/ProductStatus/ProductStatus.module.scss
var ProductStatus_module = __webpack_require__(23804);
var ProductStatus_module_default = /*#__PURE__*/__webpack_require__.n(ProductStatus_module);
;// CONCATENATED MODULE: ./components/ui/ProductStatus/ProductStatus.js










var StatusTable = function StatusTable(_ref) {
  var _dataItem$ussd;

  var dataItem = _ref.dataItem,
      dark = _ref.dark;

  var renderLinkOrText = function renderLinkOrText(ussd) {
    if (ussd) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
        numbers: ussd,
        dark: dark,
        isTel: true
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (ProductStatus_module_default())["status-item__value"],
      children: dataItem === null || dataItem === void 0 ? void 0 : dataItem.text
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(ProductStatus_module_default())["status-item"], 'status-item']),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductStatus_module_default())["status-item__content"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductStatus_module_default())["status-item__img"],
        children: [(dataItem === null || dataItem === void 0 ? void 0 : dataItem.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: (ProductStatus_module_default())["status-item__icon"],
          src: dataItem === null || dataItem === void 0 ? void 0 : dataItem.icon,
          alt: dataItem === null || dataItem === void 0 ? void 0 : dataItem.title,
          title: dataItem === null || dataItem === void 0 ? void 0 : dataItem.title,
          loading: "lazy",
          width: 32,
          height: 32
        }), (dataItem === null || dataItem === void 0 ? void 0 : dataItem.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          className: classnames_default()((ProductStatus_module_default())["status-item__key"]),
          children: dataItem === null || dataItem === void 0 ? void 0 : dataItem.title
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductStatus_module_default()).ussdCode,
        children: [(dataItem === null || dataItem === void 0 ? void 0 : dataItem.right_text) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          className: classnames_default()((ProductStatus_module_default())["status-item__key"]),
          children: dataItem === null || dataItem === void 0 ? void 0 : dataItem.right_text
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: renderLinkOrText(dataItem === null || dataItem === void 0 ? void 0 : (_dataItem$ussd = dataItem.ussd) === null || _dataItem$ussd === void 0 ? void 0 : _dataItem$ussd.join(''))
        })]
      })]
    })
  });
};

var ProductStatus = function ProductStatus(_ref2) {
  var _statusData$sections, _statusData$sections2;

  var statusData = _ref2.statusData,
      className = _ref2.className,
      isBlock = _ref2.isBlock,
      _ref2$dark = _ref2.dark,
      dark = _ref2$dark === void 0 ? false : _ref2$dark;
  var router = (0,next_router.useRouter)();
  var isBusiness = router.asPath.startsWith('/business');

  var renderStatusItems = function renderStatusItems(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(StatusTable, {
      dark: dark,
      dataItem: item
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(ProductStatus_module_default())["product-status"], className]),
    itemScope: true,
    itemType: "https://schema.org/Product",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(ProductStatus_module_default())["product-status__inner"], (0,defineProperty/* default */.Z)({}, (ProductStatus_module_default())["product-status__inner--block"], isBlock)]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductStatus_module_default())["product-status__content"],
        children: (statusData === null || statusData === void 0 ? void 0 : statusData.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
          isHtml: true,
          className: classnames_default()('text--large', (ProductStatus_module_default())["product-status__text"]),
          children: statusData === null || statusData === void 0 ? void 0 : statusData.description
        })
      }), (statusData === null || statusData === void 0 ? void 0 : (_statusData$sections = statusData.sections) === null || _statusData$sections === void 0 ? void 0 : _statusData$sections.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()([(ProductStatus_module_default())["product-status__table"], 'product-status__table', (0,defineProperty/* default */.Z)({}, (ProductStatus_module_default()).productStatusTableBusiness, isBusiness)]),
        children: statusData === null || statusData === void 0 ? void 0 : (_statusData$sections2 = statusData.sections) === null || _statusData$sections2 === void 0 ? void 0 : _statusData$sections2.map(renderStatusItems)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductStatus_module_default()).bottomContent,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
          isHtml: true,
          className: classnames_default()('text--large', (ProductStatus_module_default())["product-status__text"]),
          children: statusData === null || statusData === void 0 ? void 0 : statusData.text2
        })
      })]
    })
  });
};

/* harmony default export */ var ProductStatus_ProductStatus = (ProductStatus);
// EXTERNAL MODULE: ./components/ui/Select/Select.js
var Select = __webpack_require__(54713);
// EXTERNAL MODULE: ./domains/individual/index.js + 1 modules
var individual = __webpack_require__(6049);
;// CONCATENATED MODULE: ./components/ui/TravelCountryTable/TableItem.js




var TableItem = function TableItem(_ref) {
  var children = _ref.children,
      path = _ref.path,
      alt = _ref.alt,
      className = _ref.className;

  if (path) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: className,
      itemScope: true,
      itemType: "http://schema.org/ListItem",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: path,
        alt: alt,
        title: alt,
        loading: "lazy",
        layout: "fill"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: children
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: className,
    children: children
  });
};

/* harmony default export */ var TravelCountryTable_TableItem = (TableItem);
// EXTERNAL MODULE: ./components/ui/SearchTravel/SearchTravel.module.scss
var SearchTravel_module = __webpack_require__(78852);
var SearchTravel_module_default = /*#__PURE__*/__webpack_require__.n(SearchTravel_module);
;// CONCATENATED MODULE: ./components/ui/TravelCountryTable/CountryTable.js









var TravelCountryTable = function TravelCountryTable(_ref) {
  var _data$country, _data$table2, _data$table2$titleIco, _data$table3, _data$table4, _data$table4$values, _data$table5, _data$table5$operator, _data$table6, _data$table6$values;

  var data = _ref.data;

  var _useState = (0,react.useState)(false),
      boolClass = _useState[0],
      setBoolClass = _useState[1];

  var renderTableItems = function renderTableItems(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(TravelCountryTable_TableItem, {
      className: (SearchTravel_module_default()).item,
      itemScope: true,
      itemType: "http://schema.org/ListItem",
      children: item
    }, index);
  };

  var renderTypes = function renderTypes(item) {
    var _item$icon;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(TravelCountryTable_TableItem, {
      className: (SearchTravel_module_default()).item,
      // path={item?.icon?.path}
      alt: item === null || item === void 0 ? void 0 : (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.alt,
      itemScope: true,
      itemType: "http://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.type
    }, item === null || item === void 0 ? void 0 : item.type);
  };

  var handlerScroll = function handlerScroll(_ref2) {
    var target = _ref2.target;
    var scrollLeft = target.scrollLeft;
    setBoolClass(scrollLeft > 30);
  };

  var renderTableRows = function renderTableRows(item) {
    var _data$table, _data$table$operators;

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SearchTravel_module_default()).prices,
      itemScope: true,
      itemType: "http://schema.org/ItemList",
      children: data === null || data === void 0 ? void 0 : (_data$table = data.table) === null || _data$table === void 0 ? void 0 : (_data$table$operators = _data$table.operators) === null || _data$table$operators === void 0 ? void 0 : _data$table$operators.map(function (operator, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TravelCountryTable_TableItem, {
          className: (SearchTravel_module_default()).item,
          children: item[operator] ? item[operator] : 'x'
        }, index);
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()((SearchTravel_module_default())["country-block"], 'small-margin'),
    itemScope: true,
    itemType: "http://schema.org/Table",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SearchTravel_module_default())["country-block__inner"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SearchTravel_module_default())["country-block__head"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (SearchTravel_module_default())["country-block__caption"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
            titleModify: classnames_default()('title--large', (SearchTravel_module_default())["country-block__subtitle"]),
            children: data === null || data === void 0 ? void 0 : (_data$country = data.country) === null || _data$country === void 0 ? void 0 : _data$country.name
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()((SearchTravel_module_default())["country-table"], (0,defineProperty/* default */.Z)({}, (SearchTravel_module_default())["country-table__scrolled"], boolClass)),
        onScroll: handlerScroll,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SearchTravel_module_default()).roamingResultTable,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (SearchTravel_module_default()).types,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravelCountryTable_TableItem, {
              className: classnames_default()((SearchTravel_module_default()).item, (SearchTravel_module_default()).firstType) // path={data?.table?.titleIcon?.path}
              ,
              alt: data === null || data === void 0 ? void 0 : (_data$table2 = data.table) === null || _data$table2 === void 0 ? void 0 : (_data$table2$titleIco = _data$table2.titleIcon) === null || _data$table2$titleIco === void 0 ? void 0 : _data$table2$titleIco.alt,
              children: data === null || data === void 0 ? void 0 : (_data$table3 = data.table) === null || _data$table3 === void 0 ? void 0 : _data$table3.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (SearchTravel_module_default()).typesSecondary,
              children: data === null || data === void 0 ? void 0 : (_data$table4 = data.table) === null || _data$table4 === void 0 ? void 0 : (_data$table4$values = _data$table4.values) === null || _data$table4$values === void 0 ? void 0 : _data$table4$values.map(renderTypes)
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (SearchTravel_module_default()).scrollable,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (SearchTravel_module_default()).header,
              children: data === null || data === void 0 ? void 0 : (_data$table5 = data.table) === null || _data$table5 === void 0 ? void 0 : (_data$table5$operator = _data$table5.operators) === null || _data$table5$operator === void 0 ? void 0 : _data$table5$operator.map(renderTableItems)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (SearchTravel_module_default()).pricesWrapper,
              children: data === null || data === void 0 ? void 0 : (_data$table6 = data.table) === null || _data$table6 === void 0 ? void 0 : (_data$table6$values = _data$table6.values) === null || _data$table6$values === void 0 ? void 0 : _data$table6$values.map(renderTableRows)
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var CountryTable = (TravelCountryTable);
// EXTERNAL MODULE: ./components/widget-wrapper/WidgetWrapper.jsx + 33 modules
var WidgetWrapper = __webpack_require__(56090);
;// CONCATENATED MODULE: ./components/ui/SearchTravel/SearchTravel.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var SearchTravel = function SearchTravel(_ref) {
  var _data$countries2, _router$query$country;

  var data = _ref.data;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(''),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = (0,react.useState)(null),
      id = _useState2[0],
      setId = _useState2[1];

  var lang = (router === null || router === void 0 ? void 0 : router.locale) || 'az';
  var pageType = router.pathname.startsWith('/business') ? 'business' : 'individual';
  var idRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (id) {
      idRef.current = id;
    }
  }, [id]);
  (0,react.useEffect)(function () {
    if (router.isReady && router.query.country) {
      var _data$countries, _data$countries$filte;

      setValue(router.query.country);
      setId(data === null || data === void 0 ? void 0 : (_data$countries = data.countries) === null || _data$countries === void 0 ? void 0 : (_data$countries$filte = _data$countries.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.name) === router.query.country;
      })[0]) === null || _data$countries$filte === void 0 ? void 0 : _data$countries$filte.id);
    }
  }, [router.isReady, router.query, router.locale, data === null || data === void 0 ? void 0 : data.countries]);
  (0,react.useEffect)(function () {
    setValue('');
  }, [router.locale]);

  var _individualHooks$useG = individual/* hooks.useGetCountries */.PT.useGetCountries({
    widgetId: data === null || data === void 0 ? void 0 : data.id,
    id: id || idRef.current,
    pageType: pageType,
    lang: lang
  }),
      list = _individualHooks$useG.data;

  var filteredCountries = data === null || data === void 0 ? void 0 : (_data$countries2 = data.countries) === null || _data$countries2 === void 0 ? void 0 : _data$countries2.filter(function (item) {
    var _item$name;

    return item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(value === null || value === void 0 ? void 0 : value.toLowerCase());
  });

  var search = function search(event) {
    event.preventDefault();
    if (!value || !filteredCountries.length) return;
    router.push({
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        country: value
      })
    }, undefined, {
      scroll: false
    });
  };

  var queryHandler = function queryHandler(value) {
    router.push({
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        country: value
      })
    }, undefined, {
      scroll: false
    });
  };

  var renderPopularCountries = function renderPopularCountries(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SearchTravel_module_default()).bottom_country_box,
      onClick: function onClick() {
        return queryHandler(item === null || item === void 0 ? void 0 : item.name);
      },
      children: item === null || item === void 0 ? void 0 : item.name
    }, index);
  };

  var shouldRenderCountryTable = !!list && !!((_router$query$country = router.query.country) !== null && _router$query$country !== void 0 && _router$query$country.trim()) && filteredCountries.length > 0;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('wrapper little-margin'),
      itemScope: true,
      itemType: "https://schema.org/Service",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        className: (SearchTravel_module_default()).travel,
        style: {
          backgroundImage: "url(\"".concat(data === null || data === void 0 ? void 0 : data.background_image, "\")")
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SearchTravel_module_default()).travel__desc,
          children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
            titleModify: classnames_default()('title--large', (SearchTravel_module_default()).travel__title),
            children: data === null || data === void 0 ? void 0 : data.title
          }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
            className: classnames_default()((SearchTravel_module_default()).travel__text, 'text--large'),
            children: data === null || data === void 0 ? void 0 : data.description
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SearchTravel_module_default()).travel__content,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
            className: (SearchTravel_module_default()).travel__form,
            onSubmit: search,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputAutoComplete/* default */.Z, {
              label: data === null || data === void 0 ? void 0 : data.input_label,
              setValue: setValue,
              value: value,
              data: data,
              classname: (SearchTravel_module_default()).travel__input,
              placeholder: t('common:Enter Country'),
              withoutPopulars: true
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
              className: (SearchTravel_module_default()).travel__button,
              type: 'submit',
              children: data === null || data === void 0 ? void 0 : data.button_text
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (SearchTravel_module_default()).travel__popular,
            children: [(data === null || data === void 0 ? void 0 : data.bottom_countries_title) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (SearchTravel_module_default())["travel__popular-label"],
              children: data === null || data === void 0 ? void 0 : data.bottom_countries_title
            }), !!(data !== null && data !== void 0 && data.bottom_countries) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (SearchTravel_module_default())["travel__popular-list"],
              children: data.bottom_countries.map(renderPopularCountries)
            })]
          })]
        })]
      })
    }), shouldRenderCountryTable && /*#__PURE__*/(0,jsx_runtime.jsx)(CountryTable, {
      table: data,
      data: list
    }), !!list && !!list.widgets && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "wrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(WidgetWrapper/* default */.Z, {
        widgets: list.widgets
      })
    })]
  });
};

/* harmony default export */ var SearchTravel_SearchTravel = (SearchTravel);
// EXTERNAL MODULE: ./components/ui/ToolbarSectionTitle/ToolbarSectionTitle.module.scss
var ToolbarSectionTitle_module = __webpack_require__(72493);
var ToolbarSectionTitle_module_default = /*#__PURE__*/__webpack_require__.n(ToolbarSectionTitle_module);
;// CONCATENATED MODULE: ./components/ui/ToolbarSectionTitle/ToolbarSectionTitle.js




var ToolbarSectionTitle = function ToolbarSectionTitle(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(ToolbarSectionTitle_module_default()).container, className]),
    itemScope: true,
    itemType: "https://schema.org/Text",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ToolbarSectionTitle_module_default()).title,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: children
      })
    })
  });
};

/* harmony default export */ var ToolbarSectionTitle_ToolbarSectionTitle = (ToolbarSectionTitle);
// EXTERNAL MODULE: ./components/ui/List/List.module.scss
var List_module = __webpack_require__(73926);
var List_module_default = /*#__PURE__*/__webpack_require__.n(List_module);
;// CONCATENATED MODULE: ./components/ui/List/List.js




var List_List = function List(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: classnames_default()((List_module_default()).list, className),
    itemScope: true,
    itemType: "http://schema.org/ItemList",
    children: children
  });
};

/* harmony default export */ var ui_List_List = (List_List);
// EXTERNAL MODULE: ./components/ui/CheckboxWithTitle/CheckboxWithTitle.js
var CheckboxWithTitle = __webpack_require__(17974);
// EXTERNAL MODULE: ./components/ui/Textarea/Textarea.tsx
var Textarea = __webpack_require__(2158);
// EXTERNAL MODULE: ./components/ui/CollapsibleItem/CollapsibleItem.module.scss
var CollapsibleItem_module = __webpack_require__(13445);
var CollapsibleItem_module_default = /*#__PURE__*/__webpack_require__.n(CollapsibleItem_module);
;// CONCATENATED MODULE: ./components/ui/CollapsibleItem/CollapsibleItem.js







var CollapsibleItem = function CollapsibleItem(_ref) {
  var _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === void 0 ? '' : _ref$toggle,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? '' : _ref$content,
      _ref$toggleRightText = _ref.toggleRightText,
      toggleRightText = _ref$toggleRightText === void 0 ? '' : _ref$toggleRightText,
      _ref$defaultStatus = _ref.defaultStatus,
      defaultStatus = _ref$defaultStatus === void 0 ? false : _ref$defaultStatus,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      customToggleHandler = _ref.customToggleHandler;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(defaultStatus),
      isShowAll = _useState[0],
      setIsShowAll = _useState[1];

  var block = (0,react.useRef)(null);
  var contentInner = (0,react.useRef)(null);

  var toggleItem = function toggleItem() {
    block.current.style.setProperty('--answerHeight', "".concat(contentInner.current.offsetHeight, "px"));
    setIsShowAll(!isShowAll);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((CollapsibleItem_module_default()).item, " ").concat(isShowAll ? (CollapsibleItem_module_default()).open : '', " ").concat(className || ''),
    ref: block,
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CollapsibleItem_module_default()).toggle,
      onClick: toggleItem,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CollapsibleItem_module_default()).label,
        children: toggle
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CollapsibleItem_module_default()).right,
        children: [!!toggleRightText && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [toggleRightText, "\u20BC/ ", t('common:month')]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CollapsibleItem_module_default()).icon,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* FaqArrow */.g7, {})
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CollapsibleItem_module_default()).content,
      children: !!content && typeof content === 'string' ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CollapsibleItem_module_default()).contentInner,
        ref: contentInner,
        dangerouslySetInnerHTML: {
          __html: content
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CollapsibleItem_module_default()).contentInner,
        ref: contentInner,
        onClick: customToggleHandler && toggleItem,
        children: content
      })
    })]
  });
};

/* harmony default export */ var CollapsibleItem_CollapsibleItem = (CollapsibleItem);
// EXTERNAL MODULE: ./components/ui/Faq/Faq.module.scss
var Faq_module = __webpack_require__(14883);
var Faq_module_default = /*#__PURE__*/__webpack_require__.n(Faq_module);
;// CONCATENATED MODULE: ./components/ui/Faq/Faq.js





var Faq = function Faq(_ref) {
  var _items$sections;

  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()((Faq_module_default()).wrap, className),
    itemScope: true,
    itemType: "https://schema.org/FAQPage",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Faq_module_default()).inner,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Faq_module_default()).list,
        children: items === null || items === void 0 ? void 0 : (_items$sections = items.sections) === null || _items$sections === void 0 ? void 0 : _items$sections.map(function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CollapsibleItem_CollapsibleItem, {
            toggle: item === null || item === void 0 ? void 0 : item.title,
            content: item === null || item === void 0 ? void 0 : item.content
          }, key);
        })
      })
    })
  });
};

/* harmony default export */ var Faq_Faq = (Faq);
// EXTERNAL MODULE: ./hooks/index.js + 1 modules
var hooks = __webpack_require__(59748);
// EXTERNAL MODULE: ./domains/number-sale/index.js + 4 modules
var number_sale = __webpack_require__(98248);
// EXTERNAL MODULE: ./constants/helper.js
var helper = __webpack_require__(17501);
;// CONCATENATED MODULE: ./components/SvgComponents/Delivery.js


var Delivery = function Delivery() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      mask: "url(#mask0_7401_21683)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M18.7499 7.49979H16.495L15.3277 4.44285C15.0263 3.65465 14.2575 3.12549 13.4138 3.12549H6.58669C5.74294 3.12549 4.97419 3.65465 4.6728 4.44285L3.50475 7.49979H1.8728L1.2478 9.37479H2.49989V12.3262C2.49989 12.9033 2.74016 13.4248 3.12489 13.797V16.2498H4.99989V14.3748H14.9999V16.2498H16.8749V13.797C17.2596 13.4241 17.4999 12.9026 17.4999 12.3262V9.37479H18.1249L18.7499 7.49979ZM4.37489 12.3262V9.37479H15.6249V12.3262C15.6249 12.422 15.5471 12.4998 15.4513 12.4998H4.5485C4.45266 12.4998 4.37489 12.422 4.37489 12.3262ZM6.58669 5.00049H13.4138C13.4853 5.00049 13.5506 5.04563 13.5763 5.11229L14.4881 7.49979H5.51239L6.42419 5.11229C6.44989 5.04424 6.51377 5.00049 6.58669 5.00049Z",
        fill: "var(--colorIconPrimary)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M11.875 11.875H14.375L15 10H12.5L11.875 11.875Z",
        fill: "var(--colorIconPrimary)"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5 10L5.625 11.875H8.125L7.5 10H5Z",
        fill: "var(--colorIconPrimary)"
      })]
    })
  });
};
// EXTERNAL MODULE: ./constants/base.js + 1 modules
var base = __webpack_require__(58165);
// EXTERNAL MODULE: ./components/ui/YourNumberList/YourNumberList.module.scss
var YourNumberList_module = __webpack_require__(93545);
var YourNumberList_module_default = /*#__PURE__*/__webpack_require__.n(YourNumberList_module);
;// CONCATENATED MODULE: ./components/ui/YourNumberList/YourNumberListItem.js











var YourNumberListItem = function YourNumberListItem(_ref) {
  var _ref2, _detail$order_button_;

  var data = _ref.data,
      _onClick = _ref.onClick,
      detail = _ref.detail,
      isEsim = _ref.isEsim;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((YourNumberList_module_default()).item, " ").concat(!isEsim && (YourNumberList_module_default()).item__sim),
    itemScope: true,
    itemType: "http://schema.org/ListItem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (YourNumberList_module_default()).left_side,
      children: [(data === null || data === void 0 ? void 0 : data.levelName) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isEsim ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "".concat((YourNumberList_module_default()).type, " ").concat(!isEsim && (YourNumberList_module_default()).type__sim),
          children: (_ref2 = data.levelName === 'Simple' ? 'Simple 55' : data.levelName) === null || _ref2 === void 0 ? void 0 : _ref2.replace('Simple', t('common:simple'))
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (YourNumberList_module_default()).simLabels,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "".concat((YourNumberList_module_default()).type, " ").concat(!isEsim && (YourNumberList_module_default()).type__sim),
            children: (data === null || data === void 0 ? void 0 : data.levelName) === 'Simple' ? t('common:simple') : data === null || data === void 0 ? void 0 : data.levelName
          }), (data === null || data === void 0 ? void 0 : data.price) >= base/* freeDeliveryPrice */.Xo && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((YourNumberList_module_default()).rectangle__freeDelivery, " ").concat((YourNumberList_module_default()).rectangle),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "".concat((YourNumberList_module_default()).type, " ").concat(!isEsim && (YourNumberList_module_default()).type__sim),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Delivery, {}), t('numbersale:freeDelivery')]
            })
          })]
        })
      }), (data === null || data === void 0 ? void 0 : data.msisdn) && (data === null || data === void 0 ? void 0 : data.prefix) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (YourNumberList_module_default()).number,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (YourNumberList_module_default()).selected,
          children: ["0", data === null || data === void 0 ? void 0 : data.prefix]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,helper/* numberSpliter */.Oq)(data === null || data === void 0 ? void 0 : data.msisdn)
        })]
      }), !isEsim && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (YourNumberList_module_default()).simLabelsMobile,
        children: (data === null || data === void 0 ? void 0 : data.price) >= base/* freeDeliveryPrice */.Xo && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((YourNumberList_module_default()).rectangle__freeDelivery, " ").concat((YourNumberList_module_default()).rectangle),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "".concat((YourNumberList_module_default()).type, " ").concat(!isEsim && (YourNumberList_module_default()).type__sim),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Delivery, {}), t('numbersale:freeDelivery')]
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((YourNumberList_module_default()).info, " ").concat(!isEsim && (YourNumberList_module_default()).info__sim),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: data !== null && data !== void 0 && data.price ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: (YourNumberList_module_default()).price,
            children: [data === null || data === void 0 ? void 0 : data.price, " \u20BC"]
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (YourNumberList_module_default()).price,
          children: [" ", t('esim:common.free')]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        className: (YourNumberList_module_default()).button,
        variant: 'transparent',
        onClick: function onClick() {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;

          _onClick(data);
        },
        children: (_detail$order_button_ = detail === null || detail === void 0 ? void 0 : detail.order_button_text) !== null && _detail$order_button_ !== void 0 ? _detail$order_button_ : t('numbersale:orderNumber')
      })]
    })]
  });
};

/* harmony default export */ var YourNumberList_YourNumberListItem = (YourNumberListItem);
;// CONCATENATED MODULE: ./components/ui/YourNumberList/YourNumberList.js
















var YourNumberList = function YourNumberList(_ref) {
  var _detail$show_more_but;

  var list = _ref.list,
      loadMore = _ref.loadMore,
      isLoading = _ref.isLoading,
      totalPage = _ref.totalPage,
      detail = _ref.detail,
      tabs = _ref.tabs,
      isEsim = _ref.isEsim;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useSelector = (0,es/* useSelector */.v9)(number_sale/* selectors.selectNumberSale */.wl.Q),
      activeTab = _useSelector.activeTab;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var router = (0,next_router.useRouter)();
  var limit = windowsX > 600 ? 10 : 6;

  var handleListItemClick = function handleListItemClick(item) {
    if (isEsim) {
      router.push({
        pathname: '/esim/checkout',
        query: {
          id: item === null || item === void 0 ? void 0 : item.id,
          msisdn: item === null || item === void 0 ? void 0 : item.msisdn
        }
      });
    } else {
      router.push("/number-sale/checkout/".concat(item === null || item === void 0 ? void 0 : item.msisdn, "/").concat(item === null || item === void 0 ? void 0 : item.levelName, "/").concat(item === null || item === void 0 ? void 0 : item.prefix, "/").concat(item === null || item === void 0 ? void 0 : item.price));
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ordernumber'
    });
  };

  var renderList = function renderList(item, index) {
    if (!item) return;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(YourNumberList_YourNumberListItem, {
      titles: true,
      detail: detail,
      data: item,
      isEsim: isEsim,
      onClick: function onClick() {
        return handleListItemClick(item);
      },
      itemScope: true,
      itemType: "http://schema.org/ItemList"
    }, index);
  };

  var tabHandler = function tabHandler(i) {
    dispatch(number_sale/* actions.setActiveTab */.Nw.setActiveTab(i));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (YourNumberList_module_default()).container,
      itemScope: true,
      itemType: "http://schema.org/Offer",
      children: [tabs && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (YourNumberList_module_default()).tabs,
        children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            variant: (tab === null || tab === void 0 ? void 0 : tab.value) === (activeTab === null || activeTab === void 0 ? void 0 : activeTab.value) ? 'normal' : 'transparent',
            onClick: function onClick() {
              return tabHandler(tab);
            },
            "data-testid": "number-level-".concat(tab.value),
            children: (tab === null || tab === void 0 ? void 0 : tab.name) === 'All' ? t('common:All') : tab === null || tab === void 0 ? void 0 : tab.name
          }, tab === null || tab === void 0 ? void 0 : tab.value);
        })
      }), totalPage < 1 && !isEsim && !isLoading && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (YourNumberList_module_default()).notFound,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/assets/notFound.png",
          width: 180,
          height: 180,
          alt: "Not found image"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: t('esim:common.numberNotFound')
        })]
      }), isLoading && !isEsim && /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}), list === null || list === void 0 ? void 0 : list.map(renderList), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (YourNumberList_module_default()).loadMoreContainer,
        children: isLoading === 'pending' ? t('common:loading') : (list === null || list === void 0 ? void 0 : list.length) >= limit && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (YourNumberList_module_default()).loadMore,
          onClick: loadMore,
          "aria-label": "detail?.show_more_button_text",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [(_detail$show_more_but = detail === null || detail === void 0 ? void 0 : detail.show_more_button_text) !== null && _detail$show_more_but !== void 0 ? _detail$show_more_but : t('numbersale:loadMore'), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
              width: 18
            })]
          })
        })
      })]
    })
  });
};

/* harmony default export */ var YourNumberList_YourNumberList = (YourNumberList);
// EXTERNAL MODULE: ./components/ui/CircleIcon/CircleIcon.js
var CircleIcon = __webpack_require__(57787);
// EXTERNAL MODULE: ./components/ui/CardBlock/CardBlock.module.scss
var CardBlock_module = __webpack_require__(44752);
var CardBlock_module_default = /*#__PURE__*/__webpack_require__.n(CardBlock_module);
;// CONCATENATED MODULE: ./components/ui/CardBlock/Card.js











var Card = function Card(_ref) {
  var _data$content;

  var data = _ref.data,
      point = _ref.point,
      icon = _ref.icon,
      linkClassName = _ref.linkClassName;
  var theme = (0,index_module/* useTheme */.F)();

  var renderIconOrText = function () {
    switch (true) {
      case !!(data !== null && data !== void 0 && data.icon):
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleIcon/* default */.Z, {
          path: theme.theme === 'dark' && data !== null && data !== void 0 && data.dark_mode_icon ? data.dark_mode_icon : data.icon,
          alt: data === null || data === void 0 ? void 0 : data.icon,
          className: data !== null && data !== void 0 && data.icon_background ? (CardBlock_module_default()).gray_icon_wrapper : (CardBlock_module_default()).icons_wrapper
        });

      case !!(data !== null && data !== void 0 && data.image):
        return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: data === null || data === void 0 ? void 0 : data.image,
          className: (CardBlock_module_default()).custom_icon,
          alt: "icon",
          title: "icon",
          loading: "lazy",
          width: 24,
          height: 24
        });

      default:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleIcon/* default */.Z, {
          className: (CardBlock_module_default()).gray_icon_wrapper,
          children: point
        });
    }
  }();

  var renderContent = function renderContent(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: item === null || item === void 0 ? void 0 : item.url,
      target: "_blank",
      rel: "noreferrer",
      className: classnames_default()([(CardBlock_module_default()).card_external_link, (0,defineProperty/* default */.Z)({}, (CardBlock_module_default()).linkClassName, linkClassName === true)]),
      children: item === null || item === void 0 ? void 0 : item.text
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
    className: (CardBlock_module_default())["card-item"],
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CardBlock_module_default())["card-item__icon-wrapper"],
      children: icon ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: icon,
        className: (CardBlock_module_default()).custom_icon,
        alt: "icon",
        title: "icon",
        loading: "lazy",
        width: 24,
        height: 24
      }) : renderIconOrText
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CardBlock_module_default())["card-item__content"],
      children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
        titleModify: (CardBlock_module_default())["card-item__title"],
        children: data.title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [data !== null && data !== void 0 && data.content && Array.isArray(data.content) ? data === null || data === void 0 ? void 0 : (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.map(renderContent) : (data === null || data === void 0 ? void 0 : data.content) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
          titleModify: classnames_default()([(CardBlock_module_default())["card-item__desc"]]),
          isHtml: true,
          children: data.content
        }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
          titleModify: classnames_default()([(CardBlock_module_default())["card-item__desc"]]),
          isHtml: true,
          children: data.description
        })]
      })]
    })]
  });
};

/* harmony default export */ var CardBlock_Card = (Card);
;// CONCATENATED MODULE: ./components/ui/CardBlock/CardBlock.js









var CardBlock = function CardBlock(_ref) {
  var _ref2;

  var data = _ref.data,
      className = _ref.className,
      gridValue = _ref.gridValue,
      icon = _ref.icon,
      linkClassName = _ref.linkClassName,
      withoutTitle = _ref.withoutTitle;

  var getGridClass = function () {
    var formattedString = String(gridValue);

    switch (formattedString) {
      case '3':
        return (CardBlock_module_default())["card-block__inner--three"];

      case '4':
        return (CardBlock_module_default())["card-block__inner--four"];

      default:
        return '';
    }
  }();

  var renderCardItem = function renderCardItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CardBlock_Card, {
      data: item,
      point: index + 1,
      icon: icon,
      linkClassName: linkClassName
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()([(CardBlock_module_default())["card-block"], className]),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [!withoutTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
        className: (CardBlock_module_default()).cardTitle,
        isHtml: true,
        children: data.title
      }), (data === null || data === void 0 ? void 0 : data.description) && data.description.trim() !== '' && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
        titleModify: classnames_default()([(CardBlock_module_default())["card-block_title_desc"]]),
        isHtml: true,
        children: data.description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(CardBlock_module_default())["card-block__inner"], getGridClass]),
      children: (_ref2 = (data === null || data === void 0 ? void 0 : data.items) || (data === null || data === void 0 ? void 0 : data.cards)) === null || _ref2 === void 0 ? void 0 : _ref2.map(renderCardItem)
    })]
  });
};

/* harmony default export */ var CardBlock_CardBlock = (CardBlock);
// EXTERNAL MODULE: ./components/ui/DocumentCard/DocumentCard.js
var DocumentCard = __webpack_require__(83797);
// EXTERNAL MODULE: ./components/ui/AddressCards/AddressCards.module.scss
var AddressCards_module = __webpack_require__(9472);
var AddressCards_module_default = /*#__PURE__*/__webpack_require__.n(AddressCards_module);
;// CONCATENATED MODULE: ./components/ui/AddressCards/AddressCards.js








var AddressCards = function AddressCards(_ref) {
  var _data$cards;

  var data = _ref.data,
      className = _ref.className;

  var renderPhoneLinks = function renderPhoneLinks(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      className: (AddressCards_module_default())["address-card__link"],
      href: "tel:".concat(item === null || item === void 0 ? void 0 : item.text),
      itemScope: true,
      itemType: "https://schema.org/Organization",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Calls */.IK, {
        className: (AddressCards_module_default())["address-card__link-icon"]
      }), item === null || item === void 0 ? void 0 : item.text]
    }, index);
  };

  var renderEmailLinks = function renderEmailLinks(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      className: (AddressCards_module_default())["address-card__link"],
      href: "mailto:".concat(item === null || item === void 0 ? void 0 : item.text),
      itemScope: true,
      itemType: "https://schema.org/Organization",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Email */.GT, {
        className: (AddressCards_module_default())["address-card__link-icon"]
      }), item === null || item === void 0 ? void 0 : item.text]
    }, index);
  };

  var renderNetLinks = function renderNetLinks(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      className: (AddressCards_module_default())["address-card__link"],
      href: item === null || item === void 0 ? void 0 : item.text,
      target: "_blank",
      rel: "noreferrer",
      itemScope: true,
      itemType: "https://schema.org/Organization",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Net */.R3, {
        className: (AddressCards_module_default())["address-card__link-icon"]
      }), item === null || item === void 0 ? void 0 : item.text]
    }, index);
  };

  var renderAddressItem = function renderAddressItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("acticle", {
      className: (AddressCards_module_default())["address-card"],
      itemScope: true,
      itemType: "https://schema.org/Organization",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (AddressCards_module_default())["address-card__content"],
        children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)(CircleIcon/* default */.Z, {
          className: (AddressCards_module_default())["address-card__icon"],
          path: item === null || item === void 0 ? void 0 : item.icon,
          alt: 'icon'
        }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
          titleModify: classnames_default()((AddressCards_module_default())["address-card__title"], 'title--medium'),
          children: item === null || item === void 0 ? void 0 : item.title
        }), !!item.addresses && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (AddressCards_module_default())["address-card__path"],
          itemScope: true,
          itemType: "https://schema.org/PostalAddress",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Location */.Ye, {
            className: (AddressCards_module_default())["address-card__path-icon"]
          }), item.addresses.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (AddressCards_module_default())["address-card__path-text"],
              children: item === null || item === void 0 ? void 0 : item.text
            }, '');
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (AddressCards_module_default())["address-card__links"],
        children: [(item === null || item === void 0 ? void 0 : item.phones) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (AddressCards_module_default())["address-card__row"],
          children: item.phones.map(renderPhoneLinks)
        }), (item === null || item === void 0 ? void 0 : item.emails) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (AddressCards_module_default())["address-card__row"],
          children: item.emails.map(renderEmailLinks)
        }), (item === null || item === void 0 ? void 0 : item.sites) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (AddressCards_module_default())["address-card__row"],
          children: item.sites.map(renderNetLinks)
        })]
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((AddressCards_module_default())["address-cards"], className),
    itemScope: true,
    itemType: "https://schema.org/Organization",
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
      className: classnames_default()((AddressCards_module_default())["address-cards__title"], 'title--large'),
      icon: data === null || data === void 0 ? void 0 : data.icon,
      children: data === null || data === void 0 ? void 0 : data.title
    }), (data === null || data === void 0 ? void 0 : data.cards) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (AddressCards_module_default())["address-cards__inner"],
      children: data === null || data === void 0 ? void 0 : (_data$cards = data.cards) === null || _data$cards === void 0 ? void 0 : _data$cards.map(renderAddressItem)
    })]
  });
};

/* harmony default export */ var AddressCards_AddressCards = (AddressCards);
// EXTERNAL MODULE: ./components/ui/PaymentCards/PaymentCards.module.scss
var PaymentCards_module = __webpack_require__(3366);
var PaymentCards_module_default = /*#__PURE__*/__webpack_require__.n(PaymentCards_module);
;// CONCATENATED MODULE: ./components/ui/PaymentCards/PaymentCards.js








var PaymentCards = function PaymentCards(_ref) {
  var data = _ref.data,
      className = _ref.className;

  var renderPaymentCard = function renderPaymentCard(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      className: (PaymentCards_module_default())["payments-card"],
      href: item === null || item === void 0 ? void 0 : item.link,
      target: '_blank',
      rel: "noopener noreferrer",
      itemScope: true,
      itemType: "https://schema.org/PaymentCard",
      children: [(item === null || item === void 0 ? void 0 : item.logo) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PaymentCards_module_default())["payments-card__logo-wrap"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: (PaymentCards_module_default())["payments-card__logo"],
          src: item.logo,
          alt: item === null || item === void 0 ? void 0 : item.title,
          title: item === null || item === void 0 ? void 0 : item.title,
          loading: "lazy",
          width: 160,
          height: 64,
          layout: "responsive",
          objectFit: "contain"
        })
      }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (PaymentCards_module_default())["payments-card__content"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
          titleModify: classnames_default()((PaymentCards_module_default())["payments-card__title"], 'title--medium'),
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrRight */.jG, {
          className: (PaymentCards_module_default())["payments-card__icon"]
        })]
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((PaymentCards_module_default())["payments-cards"], className),
    itemScope: true,
    itemType: "https://schema.org/PaymentCard",
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
      className: classnames_default()((PaymentCards_module_default())["payments-cards__title"], 'title--large'),
      icon: data === null || data === void 0 ? void 0 : data.icon,
      children: data === null || data === void 0 ? void 0 : data.title
    }), (data === null || data === void 0 ? void 0 : data.cards) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PaymentCards_module_default())["payments-cards__inner"],
      children: data.cards.map(renderPaymentCard)
    })]
  });
};

/* harmony default export */ var PaymentCards_PaymentCards = (PaymentCards);
// EXTERNAL MODULE: ./components/ui/CompatibleDevicesModal/CompatibleDevicesModal.js + 1 modules
var CompatibleDevicesModal_CompatibleDevicesModal = __webpack_require__(54810);
// EXTERNAL MODULE: ./components/ui/Video/Video.js
var Video = __webpack_require__(25469);
// EXTERNAL MODULE: ./components/ui/VideoModal/VideoModal.module.scss
var VideoModal_module = __webpack_require__(49958);
var VideoModal_module_default = /*#__PURE__*/__webpack_require__.n(VideoModal_module);
;// CONCATENATED MODULE: ./components/ui/VideoModal/VideoModal.js






var VideoModal_VideoModal = function VideoModal(_ref) {
  var videoId = _ref.videoId,
      onClose = _ref.onClose;
  return !!videoId && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (VideoModal_module_default()).video,
    itemScope: true,
    itemType: "http://schema.org/CreativeWork",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (VideoModal_module_default()).videoContent,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (VideoModal_module_default()).close,
        onClick: onClose,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Video/* default */.Z, {
        className: (VideoModal_module_default()).videoItem,
        video: {
          preview: videoId,
          videoId: videoId
        }
      })]
    })
  });
};

/* harmony default export */ var ui_VideoModal_VideoModal = (VideoModal_VideoModal);
;// CONCATENATED MODULE: ./components/ui/StepsBanner/StepsBanner.js













var StepsBanner = function StepsBanner(_ref) {
  var _data$stepList$, _data$stepList$$scree, _data$stepList$2, _data$stepList$2$alt;

  var data = _ref.data,
      className = _ref.className;

  var _useState = useState({
    url: data === null || data === void 0 ? void 0 : (_data$stepList$ = data.stepList[0]) === null || _data$stepList$ === void 0 ? void 0 : (_data$stepList$$scree = _data$stepList$.screen) === null || _data$stepList$$scree === void 0 ? void 0 : _data$stepList$$scree.path,
    alt: data === null || data === void 0 ? void 0 : (_data$stepList$2 = data.stepList[0]) === null || _data$stepList$2 === void 0 ? void 0 : (_data$stepList$2$alt = _data$stepList$2.alt) === null || _data$stepList$2$alt === void 0 ? void 0 : _data$stepList$2$alt.path
  }),
      imageData = _useState[0],
      setImageData = _useState[1];

  var _useState2 = useState(0),
      activeClass = _useState2[0],
      setActiveClass = _useState2[1];

  var _useState3 = useState(0),
      activeModal = _useState3[0],
      setActiveModal = _useState3[1];

  var _useState4 = useState(0),
      activeVideoModal = _useState4[0],
      setActiveVideoModal = _useState4[1];

  var popup = function popup() {
    setActiveVideoModal('teyhlo_cDGo');
  };

  var setActiveScreen = function setActiveScreen(index) {
    var _data$stepList$index, _data$stepList$index$, _data$stepList$index2, _data$stepList$index3;

    setActiveClass(index);
    setImageData({
      url: data === null || data === void 0 ? void 0 : (_data$stepList$index = data.stepList[index]) === null || _data$stepList$index === void 0 ? void 0 : (_data$stepList$index$ = _data$stepList$index.screen) === null || _data$stepList$index$ === void 0 ? void 0 : _data$stepList$index$.path,
      alt: data === null || data === void 0 ? void 0 : (_data$stepList$index2 = data.stepList[index]) === null || _data$stepList$index2 === void 0 ? void 0 : (_data$stepList$index3 = _data$stepList$index2.alt) === null || _data$stepList$index3 === void 0 ? void 0 : _data$stepList$index3.path
    });
  };

  var renderSteps = function renderSteps(item, index) {
    var updateIndex = index + 1;
    var currentActiveElement = activeClass === index ? styles['step-item--active'] : '';
    return /*#__PURE__*/_jsxs("div", {
      className: classNames(styles['step-item'], currentActiveElement),
      onClick: function onClick() {
        return setActiveScreen(index);
      },
      itemScope: true,
      itemType: "https://schema.org/Property",
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['step-item__count'],
        children: "".concat(updateIndex, " ").concat(item.title)
      }), /*#__PURE__*/_jsx("div", {
        className: styles['step-item__text'],
        children: item.desc
      })]
    }, index);
  };

  return /*#__PURE__*/_jsxs("section", {
    className: classNames(styles['step-banner'], className),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['step-banner__wrapper'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['step-banner__content'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['step-banner__head'],
          children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx(SectionTitle, {
            titleModify: classNames(styles['step-banner__title'], 'title--large'),
            children: data.title
          }), (data === null || data === void 0 ? void 0 : data.numbers) && /*#__PURE__*/_jsxs("div", {
            className: styles['step-banner__link'],
            children: ["Dial", /*#__PURE__*/_jsx(LinkNumbers, {
              numbers: data.numbers,
              isTel: true
            }), "to activate"]
          }), (data === null || data === void 0 ? void 0 : data.desc) && /*#__PURE__*/_jsx(TextBlock, {
            className: classNames(styles['step-banner__text'], 'text--medium'),
            children: data.desc
          })]
        }), (data === null || data === void 0 ? void 0 : data.stepList) && /*#__PURE__*/_jsx("div", {
          className: styles['step-banner__steps'],
          children: data.stepList.map(renderSteps)
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['step-banner__buttons'],
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: popup,
            className: styles.button,
            children: "Watch the Video"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "border",
            className: styles.button,
            onClick: function onClick() {
              return setActiveModal(true);
            },
            children: "Compatible Devices"
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles['step-banner__phone-wrapper'],
        children: /*#__PURE__*/_jsxs("div", {
          className: styles['step-banner__phone'],
          children: [/*#__PURE__*/_jsx(Image, {
            className: styles['step-banner__phone-frame'],
            src: "/assets/services/phone-frame.png",
            alt: "screen",
            loading: "lazy",
            layout: "fill"
          }), /*#__PURE__*/_jsx(Image, {
            className: styles['step-banner__phone-screen'],
            src: imageData.url,
            alt: imageData.alt,
            loading: "lazy",
            layout: "fill"
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(CompatibleDevicesModal, {
      active: activeModal,
      setActive: setActiveModal
    }), /*#__PURE__*/_jsx(VideoModal, {
      videoId: activeVideoModal,
      onClose: function onClose() {
        return setActiveVideoModal(null);
      }
    })]
  });
};

/* harmony default export */ var StepsBanner_StepsBanner = ((/* unused pure expression or super */ null && (StepsBanner)));
;// CONCATENATED MODULE: ./components/ui/ReverseBlock/ReverseBlock.js










var ReverseBlock = function ReverseBlock(_ref) {
  var _data$items;

  var data = _ref.data,
      className = _ref.className;

  var renderLiItem = function renderLiItem(item, index) {
    return /*#__PURE__*/_jsx("li", {
      className: styles['reverse-item__list-element'],
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item.text
    }, index);
  };

  var renderReverseItem = function renderReverseItem(item, index) {
    var _item$items, _item$items2;

    return /*#__PURE__*/_jsxs("div", {
      className: styles['reverse-item'],
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['reverse-item__inner'],
        children: [(item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/_jsx(SectionTitle, {
          titleModify: classNames([styles['reverse-item__title'], 'title--medium']),
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['reverse-item__content'],
          children: [(item === null || item === void 0 ? void 0 : item.top_text) && /*#__PURE__*/_jsx(TextBlock, {
            className: classNames([styles['reverse-item__text'], 'text--medium']),
            children: item === null || item === void 0 ? void 0 : item.top_text
          }), Boolean(item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length) && /*#__PURE__*/_jsx(List, {
            children: item === null || item === void 0 ? void 0 : (_item$items2 = item.items) === null || _item$items2 === void 0 ? void 0 : _item$items2.map(renderLiItem)
          })]
        })]
      }), (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/_jsx("div", {
        className: styles['reverse-item__img-wrap'],
        children: /*#__PURE__*/_jsx(Image, {
          className: styles['reverse-item__img'],
          src: item === null || item === void 0 ? void 0 : item.image,
          alt: item === null || item === void 0 ? void 0 : item.title,
          title: item === null || item === void 0 ? void 0 : item.title,
          loading: "lazy",
          layout: "fill"
        })
      })]
    }, index);
  };

  return /*#__PURE__*/_jsxs("section", {
    className: classNames(styles['reverse-block'], className),
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [(data === null || data === void 0 ? void 0 : data.text) && /*#__PURE__*/_jsx(SectionTitle, {
      className: classNames(styles['reverse-block__title'], 'title--large'),
      Icon: Ranking,
      isHtml: true,
      children: data === null || data === void 0 ? void 0 : data.text
    }), (data === null || data === void 0 ? void 0 : data.items) && /*#__PURE__*/_jsx("div", {
      className: styles['reverse-block__inner'],
      children: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(renderReverseItem)
    })]
  });
};

/* harmony default export */ var ReverseBlock_ReverseBlock = ((/* unused pure expression or super */ null && (ReverseBlock)));
// EXTERNAL MODULE: ./components/ui/Modal/Modal.tsx
var Modal = __webpack_require__(23303);
// EXTERNAL MODULE: ./components/ui/Pagination/Pagination.module.scss
var Pagination_module = __webpack_require__(10607);
var Pagination_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_module);
;// CONCATENATED MODULE: ./components/ui/Pagination/Pagination.js


function Pagination_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Pagination_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Pagination_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Pagination_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var Pagination = function Pagination(_ref) {
  var _ref$perPage = _ref.perPage,
      perPage = _ref$perPage === void 0 ? 12 : _ref$perPage,
      _ref$total = _ref.total,
      total = _ref$total === void 0 ? 0 : _ref$total;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(+router.query.page || 1),
      currentPage = _useState[0],
      setCurrentPage = _useState[1];

  var displayedItemsCount = 3;
  var pagesCount = Math.ceil(total / perPage);
  var pages = Array.from({
    length: pagesCount
  }, function (_, i) {
    return i + 1;
  });
  (0,react.useEffect)(function () {
    router.push({
      query: Pagination_objectSpread(Pagination_objectSpread({}, router.query), {}, {
        page: currentPage
      })
    }, undefined, {
      scroll: true,
      scrollOptions: {
        behavior: 'smooth'
      }
    });
  }, [currentPage]);
  (0,react.useEffect)(function () {
    setCurrentPage(+router.query.page || 1);
  }, [pagesCount, router.query.page]);

  var getShowedItems = function getShowedItems(array) {
    var showed = [];

    if (array.length <= displayedItemsCount) {
      showed = array;
    } else {
      if (currentPage <= 4) {
        showed = array.slice(0, 5);
      } else if (currentPage > pagesCount - 4) {
        showed = array.slice(pagesCount - 5);
      } else {
        showed = [currentPage - 1, currentPage, currentPage + 1];
      }

      if (currentPage > 4 && showed[0] > 2) {
        showed.unshift(1, '...');
      } else if (showed[0] === 2) {
        showed.unshift(1);
      }

      if (currentPage < pagesCount - 3 && showed[showed.length - 1] < pagesCount - 1) {
        showed.push('...', pagesCount);
      } else if (showed[showed.length - 1] === pagesCount - 1) {
        showed.push(pagesCount);
      }
    }

    return showed;
  };

  var renderItem = function renderItem(item, key) {
    var page;
    var pageLabel;

    if (item === '...') {
      pageLabel = item;
      page = key === 1 ? currentPage - 2 : currentPage + 2;
    } else {
      page = item;
      pageLabel = page;
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((Pagination_module_default()).item, " ").concat(currentPage === page ? (Pagination_module_default()).active : ''),
      onClick: function onClick() {
        return setCurrentPage(page);
      },
      children: pageLabel
    }, key);
  };

  return !!pages.length && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (Pagination_module_default()).pagination,
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((Pagination_module_default()).item, " ").concat((Pagination_module_default()).nav, " ").concat(currentPage === 1 ? (Pagination_module_default()).disabled : ''),
      onClick: function onClick() {
        return setCurrentPage(currentPage - 1);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
        className: "".concat((Pagination_module_default()).icon, " ").concat((Pagination_module_default()).prev)
      })
    }), getShowedItems(pages).map(renderItem), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((Pagination_module_default()).item, " ").concat((Pagination_module_default()).nav, " ").concat(currentPage === pagesCount ? (Pagination_module_default()).disabled : ''),
      onClick: function onClick() {
        return setCurrentPage(currentPage + 1);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
        className: "".concat((Pagination_module_default()).icon, " ").concat((Pagination_module_default()).next)
      })
    })]
  });
};

/* harmony default export */ var Pagination_Pagination = (Pagination);
// EXTERNAL MODULE: ./components/ui/Qr/Qr.js
var Qr_Qr = __webpack_require__(37499);
;// CONCATENATED MODULE: ./components/ui/QrBanner/QrBanner.js









var QrBlock = function QrBlock(_ref) {
  var data = _ref.data,
      className = _ref.className,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark;
  return /*#__PURE__*/_jsx("section", {
    className: classNames(styles['qr-banner'], className, _defineProperty({}, styles.dark, dark)),
    "data-testid": "qrBlock",
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['qr-banner__overflow'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['qr-banner__inner'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['qr-banner__content'],
          children: [(data === null || data === void 0 ? void 0 : data.pageCategory) && /*#__PURE__*/_jsx("span", {
            className: styles['qr-banner__category'],
            children: data.pageCategory
          }), (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx("strong", {
            className: styles['qr-banner__title'],
            children: data.title
          })]
        }), (data === null || data === void 0 ? void 0 : data.qrBlock) && /*#__PURE__*/_jsx(Qr, {
          className: styles['qr-banner__links'],
          data: data.qrBlock
        })]
      }), /*#__PURE__*/_jsx(QrBannerLogo, {
        className: styles['qr-banner__bg']
      })]
    })
  });
};

/* harmony default export */ var QrBanner = ((/* unused pure expression or super */ null && (QrBlock)));
;// CONCATENATED MODULE: ./components/ui/StepsBanner/StepsBannerWithTabs.js



















var StepsBannerWithTabs = function StepsBannerWithTabs(_ref) {
  var _data$tabs$, _data$tabs$$list$, _data$tabs$$list$$scr, _data$tabs$2, _data$tabs$2$list$, _data$tabs$2$list$$al, _data$tabs, _data$tabs2;

  var data = _ref.data,
      className = _ref.className,
      devices = _ref.devices;

  var _useState = useState(false),
      isImageLoaded = _useState[0],
      setIsImageLoaded = _useState[1];

  var initialState = {
    url: (_data$tabs$ = data.tabs[0]) === null || _data$tabs$ === void 0 ? void 0 : (_data$tabs$$list$ = _data$tabs$.list[0]) === null || _data$tabs$$list$ === void 0 ? void 0 : (_data$tabs$$list$$scr = _data$tabs$$list$.screen) === null || _data$tabs$$list$$scr === void 0 ? void 0 : _data$tabs$$list$$scr.path,
    alt: (_data$tabs$2 = data.tabs[0]) === null || _data$tabs$2 === void 0 ? void 0 : (_data$tabs$2$list$ = _data$tabs$2.list[0]) === null || _data$tabs$2$list$ === void 0 ? void 0 : (_data$tabs$2$list$$al = _data$tabs$2$list$.alt) === null || _data$tabs$2$list$$al === void 0 ? void 0 : _data$tabs$2$list$$al.path
  };

  var _useState2 = useState(initialState),
      imageData = _useState2[0],
      setImageData = _useState2[1];

  var _useState3 = useState(0),
      activeClass = _useState3[0],
      setActiveClass = _useState3[1];

  var _useState4 = useState(0),
      activeTab = _useState4[0],
      setActiveTab = _useState4[1];

  var _useState5 = useState(0),
      activeModal = _useState5[0],
      setActiveModal = _useState5[1];

  var _useState6 = useState(0),
      activeVideoModal = _useState6[0],
      setActiveVideoModal = _useState6[1];

  var handleChangeTab = function handleChangeTab(index) {
    setImageData(initialState);
    setActiveTab(index);
    setActiveClass(0);
  };

  var popup = function popup() {
    setActiveVideoModal('teyhlo_cDGo');
  };

  var setActiveScreen = function setActiveScreen(index) {
    var _data$tabs$activeTab, _data$tabs$activeTab$, _data$tabs$activeTab$2, _data$tabs$activeTab2, _data$tabs$activeTab3, _data$tabs$activeTab4;

    setActiveClass(index);
    setImageData({
      url: (_data$tabs$activeTab = data.tabs[activeTab]) === null || _data$tabs$activeTab === void 0 ? void 0 : (_data$tabs$activeTab$ = _data$tabs$activeTab.list[index]) === null || _data$tabs$activeTab$ === void 0 ? void 0 : (_data$tabs$activeTab$2 = _data$tabs$activeTab$.screen) === null || _data$tabs$activeTab$2 === void 0 ? void 0 : _data$tabs$activeTab$2.path,
      alt: (_data$tabs$activeTab2 = data.tabs[activeTab]) === null || _data$tabs$activeTab2 === void 0 ? void 0 : (_data$tabs$activeTab3 = _data$tabs$activeTab2.list[index]) === null || _data$tabs$activeTab3 === void 0 ? void 0 : (_data$tabs$activeTab4 = _data$tabs$activeTab3.alt) === null || _data$tabs$activeTab4 === void 0 ? void 0 : _data$tabs$activeTab4.path
    });
  };

  var renderSteps = function renderSteps(item, index) {
    var currentActiveElement = activeClass === index ? styles['step-item--active'] : '';
    return /*#__PURE__*/_jsxs("div", {
      className: classNames(styles['step-item'], currentActiveElement),
      onClick: function onClick() {
        return setActiveScreen(index);
      },
      itemScope: true,
      itemType: "https://schema.org/Property",
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['step-item__count'],
        children: "".concat(index + 1, " ").concat(item.title)
      }), /*#__PURE__*/_jsx("div", {
        className: styles['step-item__text'],
        children: item.desc
      })]
    }, index);
  };

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/_jsx(Tab, {
      onClick: function onClick() {
        return handleChangeTab(index);
      },
      children: item.name
    }, index);
  };

  var renderContent = function renderContent(item, index) {
    var _item$list;

    return /*#__PURE__*/_jsx(TabContentItem, {
      children: item === null || item === void 0 ? void 0 : (_item$list = item.list) === null || _item$list === void 0 ? void 0 : _item$list.map(renderSteps)
    }, index);
  };

  return /*#__PURE__*/_jsxs("section", {
    className: classNames(styles['step-banner'], className),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['step-banner__wrapper'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['step-banner__content'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['step-banner__head'],
          children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx(SectionTitle, {
            titleModify: classNames(styles['step-banner__title'], 'title--large'),
            children: data.title
          }), (data === null || data === void 0 ? void 0 : data.numbers) && /*#__PURE__*/_jsxs("div", {
            className: styles['step-banner__link'],
            children: ["Dial", /*#__PURE__*/_jsx(LinkNumbers, {
              numbers: data.numbers,
              isTel: true
            }), "to activate"]
          }), (data === null || data === void 0 ? void 0 : data.desc) && /*#__PURE__*/_jsx(TextBlock, {
            className: classNames(styles['step-banner__text'], 'text--medium'),
            children: data.desc
          })]
        }), /*#__PURE__*/_jsxs(Tabs, {
          active: activeTab,
          children: [/*#__PURE__*/_jsx(TabPanel, {
            className: styles.tabs,
            children: data === null || data === void 0 ? void 0 : (_data$tabs = data.tabs) === null || _data$tabs === void 0 ? void 0 : _data$tabs.map(renderTab)
          }), /*#__PURE__*/_jsx(TabContent, {
            children: data === null || data === void 0 ? void 0 : (_data$tabs2 = data.tabs) === null || _data$tabs2 === void 0 ? void 0 : _data$tabs2.map(renderContent)
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['step-banner__buttons'],
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: popup,
            children: "Watch the Video"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "border",
            onClick: function onClick() {
              return setActiveModal(true);
            },
            children: "Compatible Devices"
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles['step-banner__phone-wrapper'],
        children: /*#__PURE__*/_jsxs("div", {
          className: styles['step-banner__phone'],
          children: [!isImageLoaded && /*#__PURE__*/_jsx(Skeleton, {
            width: "100%",
            height: "100%"
          }), /*#__PURE__*/_jsx(Image, {
            className: styles['step-banner__phone-frame'],
            src: "/assets/services/phone-frame.png",
            alt: "screen",
            loading: "lazy",
            layout: "fill",
            onLoadingComplete: function onLoadingComplete() {
              return setIsImageLoaded(true);
            },
            style: {
              visibility: isImageLoaded ? 'visible' : 'hidden'
            }
          }), /*#__PURE__*/_jsx(Image, {
            className: styles['step-banner__phone-screen'],
            src: imageData.url,
            alt: imageData.alt,
            loading: "lazy",
            layout: "fill",
            onLoadingComplete: function onLoadingComplete() {
              return setIsImageLoaded(true);
            },
            style: {
              visibility: isImageLoaded ? 'visible' : 'hidden'
            }
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(CompatibleDevicesModal, {
      active: activeModal,
      setActive: setActiveModal,
      devices: devices
    }), /*#__PURE__*/_jsx(VideoModal, {
      videoId: activeVideoModal,
      onClose: function onClose() {
        return setActiveVideoModal(null);
      }
    })]
  });
};

/* harmony default export */ var StepsBanner_StepsBannerWithTabs = ((/* unused pure expression or super */ null && (StepsBannerWithTabs)));
// EXTERNAL MODULE: ./domains/esim/order/index.js + 3 modules
var order = __webpack_require__(31863);
// EXTERNAL MODULE: ./utils/filterDevicesData.js
var filterDevicesData = __webpack_require__(15392);
// EXTERNAL MODULE: ./components/ui/CompatibleDevicesModalVolte/CompatibleDevicesModalVolte.module.scss
var CompatibleDevicesModalVolte_module = __webpack_require__(41242);
var CompatibleDevicesModalVolte_module_default = /*#__PURE__*/__webpack_require__.n(CompatibleDevicesModalVolte_module);
;// CONCATENATED MODULE: ./components/ui/CompatibleDevicesModalVolte/CompatibleDevicesModalVolte.js


















var CompatibleDevicesModalVolte_CompatibleDevicesModal = function CompatibleDevicesModal(_ref) {
  var active = _ref.active,
      setActive = _ref.setActive,
      devices = _ref.devices,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      data = _ref.data;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  var _useState = (0,react.useState)(null),
      available = _useState[0],
      setAvailable = _useState[1];

  var _useState2 = (0,react.useState)(''),
      value = _useState2[0],
      setValue = _useState2[1];

  var modelsNames = (0,react.useMemo)(function () {
    var models = [];
    devices === null || devices === void 0 ? void 0 : devices.map(function (item) {
      var _item$models;

      return item === null || item === void 0 ? void 0 : (_item$models = item.models) === null || _item$models === void 0 ? void 0 : _item$models.forEach(function (model) {
        models = [].concat((0,toConsumableArray/* default */.Z)(models), [model]);
      });
    });
    return models;
  }, [devices]);

  var onCheck = function onCheck() {
    var _modelsNames$map;

    setAvailable(modelsNames === null || modelsNames === void 0 ? void 0 : (_modelsNames$map = modelsNames.map(function (item) {
      return item === null || item === void 0 ? void 0 : item.name;
    })) === null || _modelsNames$map === void 0 ? void 0 : _modelsNames$map.includes(value));
  };

  var tabClickHandler = function tabClickHandler(index) {
    setActiveTab(index);

    if (activeTab !== index) {
      setValue('');
    }
  };

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_Tab/* default */.Z, {
      className: (CompatibleDevicesModalVolte_module_default()).tab,
      onClick: function onClick() {
        return tabClickHandler(index);
      },
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: item === null || item === void 0 ? void 0 : item.name
    }, index);
  };

  var renderListItem = function renderListItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CompatibleDevicesModalVolte_module_default()).item,
      onClick: function onClick() {
        return setValue(item === null || item === void 0 ? void 0 : item.name);
      },
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item === null || item === void 0 ? void 0 : item.name
    }, index);
  };

  var renderTabContent = function renderTabContent(item, index) {
    var _item$models2;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_TabContentItem/* default */.Z, {
      className: (CompatibleDevicesModalVolte_module_default()).content,
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: item === null || item === void 0 ? void 0 : (_item$models2 = item.models) === null || _item$models2 === void 0 ? void 0 : _item$models2.map(renderListItem)
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal["default"], {
    active: active,
    setActive: setActive,
    classNameInner: (CompatibleDevicesModalVolte_module_default()).modal,
    itemScope: true,
    itemType: "https://schema.org/Product",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
      className: 'title',
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CompatibleDevicesModalVolte_module_default()).find,
      children: [available === null ? /*#__PURE__*/(0,jsx_runtime.jsx)(InputAutoComplete/* default */.Z, {
        setValue: setValue,
        value: value,
        filter: modelsNames,
        onSelect: setValue,
        className: (CompatibleDevicesModalVolte_module_default()).input,
        placeholder: data === null || data === void 0 ? void 0 : data.devices_modal_input_label,
        models: modelsNames,
        highlight: true
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()([(CompatibleDevicesModalVolte_module_default()).available, (0,defineProperty/* default */.Z)({}, (CompatibleDevicesModalVolte_module_default()).notAvailable, !available)]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: classnames_default()(['label', (CompatibleDevicesModalVolte_module_default()).inputLabel]),
          children: data === null || data === void 0 ? void 0 : data.devices_modal_input_label
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (CompatibleDevicesModalVolte_module_default()).content,
          children: [available ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* AvailablePhone */.hy, {
            className: (CompatibleDevicesModalVolte_module_default()).available_device
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* NotAvailablePhone */.gH, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (CompatibleDevicesModalVolte_module_default()).title,
            children: value
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          "aria-label": "Bakcell",
          className: (CompatibleDevicesModalVolte_module_default()).close,
          onClick: function onClick() {
            return setAvailable(null);
          },
          "data-testid": "modal-close",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseSquare */.s9, {
            width: 15,
            height: 15
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        disabled: !value,
        className: (CompatibleDevicesModalVolte_module_default()).button,
        onClick: onCheck,
        children: data === null || data === void 0 ? void 0 : data.devices_modal_button_text
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs_Tabs/* default */.Z, {
      active: activeTab,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_TabPanel/* default */.Z, {
        className: (CompatibleDevicesModalVolte_module_default()).panel,
        children: devices === null || devices === void 0 ? void 0 : devices.map(renderTab)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_TabContent/* default */.Z, {
        children: devices === null || devices === void 0 ? void 0 : devices.map(renderTabContent)
      })]
    })]
  });
};

/* harmony default export */ var CompatibleDevicesModalVolte = (CompatibleDevicesModalVolte_CompatibleDevicesModal);
// EXTERNAL MODULE: ./components/ui/StepsBannerVolte/StepsBanner.module.scss
var StepsBanner_module = __webpack_require__(44708);
var StepsBanner_module_default = /*#__PURE__*/__webpack_require__.n(StepsBanner_module);
;// CONCATENATED MODULE: ./components/ui/StepsBannerVolte/StepsBannerWithTabs.js
/* eslint-disable no-unused-expressions */
























var StepsBannerWithTabs_StepsBannerWithTabs = function StepsBannerWithTabs(_ref) {
  var _data$sections$active, _data$sections$active2, _data$sections$active3, _data$sections$active4, _data$sections, _data$sections2, _data$brands, _data$brands$filter, _data$brands2;

  var data = _ref.data,
      className = _ref.className;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(0),
      activeClass = _useState[0],
      setActiveClass = _useState[1];

  var _useState2 = (0,react.useState)(0),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = (0,react.useState)({
    url: (_data$sections$active = data.sections[activeTab]) === null || _data$sections$active === void 0 ? void 0 : (_data$sections$active2 = _data$sections$active.steps[0]) === null || _data$sections$active2 === void 0 ? void 0 : _data$sections$active2.image,
    alt: (_data$sections$active3 = data.sections[activeTab]) === null || _data$sections$active3 === void 0 ? void 0 : (_data$sections$active4 = _data$sections$active3.steps[0]) === null || _data$sections$active4 === void 0 ? void 0 : _data$sections$active4.image
  }),
      imageData = _useState3[0],
      setImageData = _useState3[1];

  var _useState4 = (0,react.useState)(0),
      activeModal = _useState4[0],
      setActiveModal = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      activeVideoModal = _useState5[0],
      setActiveVideoModal = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      deviceModal = _useState6[0],
      setDeviceModal = _useState6[1];

  var router = (0,next_router.useRouter)();
  var isEsim = router.pathname === '/esim' || router.asPath.startsWith('/esim');

  var handleChangeTab = function handleChangeTab(index) {
    var _data$sections$index, _data$sections$index$, _data$sections$index2, _data$sections$index3;

    setActiveTab(index);
    setActiveClass(0);
    setImageData({
      url: (_data$sections$index = data.sections[index]) === null || _data$sections$index === void 0 ? void 0 : (_data$sections$index$ = _data$sections$index.steps[0]) === null || _data$sections$index$ === void 0 ? void 0 : _data$sections$index$.image,
      alt: (_data$sections$index2 = data.sections[index]) === null || _data$sections$index2 === void 0 ? void 0 : (_data$sections$index3 = _data$sections$index2.steps[0]) === null || _data$sections$index3 === void 0 ? void 0 : _data$sections$index3.image
    });
  };

  var popup = function popup() {
    return data !== null && data !== void 0 && data.playlist_link ? window.open(data === null || data === void 0 ? void 0 : data.playlist_link, '_blank') : setActiveVideoModal(data.youtube_id);
  };

  var setActiveScreen = (0,react.useCallback)(function (index) {
    var _data$sections$active5, _data$sections$active6, _data$sections$active7, _data$sections$active8;

    setActiveClass(index);
    setImageData({
      url: (_data$sections$active5 = data.sections[activeTab]) === null || _data$sections$active5 === void 0 ? void 0 : (_data$sections$active6 = _data$sections$active5.steps[index]) === null || _data$sections$active6 === void 0 ? void 0 : _data$sections$active6.image,
      alt: (_data$sections$active7 = data.sections[activeTab]) === null || _data$sections$active7 === void 0 ? void 0 : (_data$sections$active8 = _data$sections$active7.steps[index]) === null || _data$sections$active8 === void 0 ? void 0 : _data$sections$active8.image
    });
  }, [data, activeTab]);

  var _orderHooks$useGetDev = order/* hooks.useGetDeviceList */.PT.useGetDeviceList(''),
      deviceData = _orderHooks$useGetDev.data;

  var fullDevices = (0,filterDevicesData/* processDeviceData */.e)(deviceData, t);

  var renderSteps = function renderSteps(item, index) {
    var currentActiveElement = activeClass === index ? (StepsBanner_module_default())["step-item--active"] : '';
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()((StepsBanner_module_default())["step-item"], currentActiveElement),
      onMouseOver: function onMouseOver() {
        return setActiveScreen(index);
      },
      itemScope: true,
      itemType: "https://schema.org/Property",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (StepsBanner_module_default())["step-item__count"],
        children: [t('common:Step'), " ", "".concat(item.title)]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (StepsBanner_module_default())["step-item__text"],
        children: item.description
      })]
    }, index);
  };

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_Tab/* default */.Z, {
      onClick: function onClick() {
        return handleChangeTab(index);
      },
      children: item.title
    }, index);
  };

  var renderContent = function renderContent(item, index) {
    var _item$steps;

    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_TabContentItem/* default */.Z, {
      children: item === null || item === void 0 ? void 0 : (_item$steps = item.steps) === null || _item$steps === void 0 ? void 0 : _item$steps.map(renderSteps)
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: data === null || data === void 0 ? void 0 : data.scroll_id,
    className: classnames_default()((StepsBanner_module_default())["step-banner"], className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (StepsBanner_module_default())["step-banner__wrapper"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (StepsBanner_module_default())["step-banner__content"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (StepsBanner_module_default())["step-banner__head"],
          children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
            className: (StepsBanner_module_default()).step_banner_title,
            children: data.title
          }), (data === null || data === void 0 ? void 0 : data.ussd) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (StepsBanner_module_default())["step-banner__link"],
              children: [data === null || data === void 0 ? void 0 : data.text_before_ussd, data === null || data === void 0 ? void 0 : data.text_after_ussd]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
              numbers: data.ussd,
              isTel: true,
              className: (StepsBanner_module_default()).links
            })]
          }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
            className: classnames_default()((StepsBanner_module_default())["step-banner__text"], 'text--medium'),
            children: data.description
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (StepsBanner_module_default())["step-banner__buttons"],
          children: [((data === null || data === void 0 ? void 0 : data.video_button_text) || (data === null || data === void 0 ? void 0 : data.playlist_link)) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            onClick: popup,
            children: data === null || data === void 0 ? void 0 : data.video_button_text
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            variant: "outline",
            onClick: function onClick() {
              isEsim ? setDeviceModal(true) : setActiveModal(true);
            },
            className: (StepsBanner_module_default()).steps_btn,
            children: data === null || data === void 0 ? void 0 : data.devices_button_text
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (StepsBanner_module_default())["step-banner__phone-wrapper"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (StepsBanner_module_default())["step-banner__phone"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            className: (StepsBanner_module_default())["step-banner__phone-screen"],
            src: imageData.url,
            alt: imageData.url,
            title: imageData.url,
            loading: "lazy",
            width: 248,
            height: 430
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs_Tabs/* default */.Z, {
          active: activeTab,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_TabPanel/* default */.Z, {
            className: (StepsBanner_module_default()).tabs,
            children: data === null || data === void 0 ? void 0 : (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.map(renderTab)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_TabContent/* default */.Z, {
            children: data === null || data === void 0 ? void 0 : (_data$sections2 = data.sections) === null || _data$sections2 === void 0 ? void 0 : _data$sections2.map(renderContent)
          })]
        })
      })]
    }), isEsim ? /*#__PURE__*/(0,jsx_runtime.jsx)(CompatibleDevicesModal_CompatibleDevicesModal/* default */.Z, {
      active: deviceModal,
      setActive: setDeviceModal,
      devices: fullDevices,
      className: (StepsBanner_module_default()).volte_modal_inner
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CompatibleDevicesModalVolte, {
      active: activeModal,
      setActive: setActiveModal,
      devices: data === null || data === void 0 ? void 0 : (_data$brands = data.brands) === null || _data$brands === void 0 ? void 0 : (_data$brands$filter = _data$brands.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.id) === 2;
      })) === null || _data$brands$filter === void 0 ? void 0 : _data$brands$filter.concat(data === null || data === void 0 ? void 0 : (_data$brands2 = data.brands) === null || _data$brands2 === void 0 ? void 0 : _data$brands2.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== 2;
      })),
      title: data === null || data === void 0 ? void 0 : data.devices_modal_title,
      data: data,
      className: (StepsBanner_module_default()).volte_modal_inner
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui_VideoModal_VideoModal, {
      videoId: activeVideoModal,
      onClose: function onClose() {
        return setActiveVideoModal(null);
      }
    })]
  });
};

/* harmony default export */ var StepsBannerVolte_StepsBannerWithTabs = (StepsBannerWithTabs_StepsBannerWithTabs);
// EXTERNAL MODULE: ./components/ui/InputWithSelect/InputWithSelect.js
var InputWithSelect = __webpack_require__(45604);
// EXTERNAL MODULE: ./components/ui/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(18528);
// EXTERNAL MODULE: ./components/ui/BusinessSectionBannersWithIcon/BusinessSectionBannersWithIcon.module.scss
var BusinessSectionBannersWithIcon_module = __webpack_require__(70704);
var BusinessSectionBannersWithIcon_module_default = /*#__PURE__*/__webpack_require__.n(BusinessSectionBannersWithIcon_module);
;// CONCATENATED MODULE: ./components/ui/BusinessSectionBannersWithIcon/Card.js










var Card_Card = function Card(_ref) {
  var data = _ref.data,
      point = _ref.point;

  var renderIconOrText = function () {
    if (data !== null && data !== void 0 && data.icon) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleIcon/* default */.Z, {
        path: data === null || data === void 0 ? void 0 : data.icon,
        alt: data === null || data === void 0 ? void 0 : data.title,
        className: (BusinessSectionBannersWithIcon_module_default())["card-item__circleIcon"],
        width: 40,
        height: 40,
        itemScope: true,
        itemType: "https://schema.org/Thing"
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(CircleIcon/* default */.Z, {
      children: point
    });
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
    className: (BusinessSectionBannersWithIcon_module_default())["card-item"],
    itemScope: true,
    itemType: "https://schema.org/Product",
    children: [!!(data !== null && data !== void 0 && data.image) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      alt: data === null || data === void 0 ? void 0 : data.title,
      title: data === null || data === void 0 ? void 0 : data.title,
      src: data === null || data === void 0 ? void 0 : data.image,
      className: (BusinessSectionBannersWithIcon_module_default()).image,
      loading: "lazy",
      layout: 'fill'
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (BusinessSectionBannersWithIcon_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (BusinessSectionBannersWithIcon_module_default()).inner,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (BusinessSectionBannersWithIcon_module_default())["card-item__icon-wrapper"],
          children: renderIconOrText
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (BusinessSectionBannersWithIcon_module_default())["card-item__content"],
          children: [!!(data !== null && data !== void 0 && data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
            titleModify: (BusinessSectionBannersWithIcon_module_default())["card-item__title"],
            children: data.title
          }), !!(data !== null && data !== void 0 && data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
            className: (BusinessSectionBannersWithIcon_module_default())["card-item__desc"],
            children: data.description
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: !!(data !== null && data !== void 0 && data.button_text) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
          Component: data !== null && data !== void 0 && data.slug ? 'router' : 'button',
          href: data === null || data === void 0 ? void 0 : data.slug,
          className: (BusinessSectionBannersWithIcon_module_default()).button,
          "data-testid": "next-internet",
          children: [data === null || data === void 0 ? void 0 : data.button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRightNew */.Ni, {
            width: 20
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var BusinessSectionBannersWithIcon_Card = (Card_Card);
;// CONCATENATED MODULE: ./components/ui/BusinessSectionBannersWithIcon/BusinessSectionBannersWithIcon.js







var BusinessSectionBannersWithIcon = function BusinessSectionBannersWithIcon(_ref) {
  var _data$sections;

  var data = _ref.data,
      className = _ref.className;

  var renderCardItem = function renderCardItem(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessSectionBannersWithIcon_Card, {
      data: item,
      point: index + 1
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()([(BusinessSectionBannersWithIcon_module_default())["card-block"], className]),
    "data-testId": "section",
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: [!!(data !== null && data !== void 0 && data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
      titleModify: "title--large",
      className: (BusinessSectionBannersWithIcon_module_default())["card-block__title"],
      children: data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(BusinessSectionBannersWithIcon_module_default())["card-block__inner"]]),
      children: data === null || data === void 0 ? void 0 : (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.map(renderCardItem)
    })]
  });
};

/* harmony default export */ var BusinessSectionBannersWithIcon_BusinessSectionBannersWithIcon = (BusinessSectionBannersWithIcon);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(4556);
// EXTERNAL MODULE: ./components/ui/BusinessServicesCardWithImage/BusinessServicesCardWithImage.module.scss
var BusinessServicesCardWithImage_module = __webpack_require__(40892);
var BusinessServicesCardWithImage_module_default = /*#__PURE__*/__webpack_require__.n(BusinessServicesCardWithImage_module);
;// CONCATENATED MODULE: ./components/ui/BusinessServicesCardWithImage/BusinessServicesCardWithImage.js












var BusinessServicesCardWithImage = function BusinessServicesCardWithImage(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(false),
      isImageLoaded = _useState[0],
      setIsImageLoaded = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ActiveLink/* default */.Z, {
    href: data === null || data === void 0 ? void 0 : data.link,
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      title: data === null || data === void 0 ? void 0 : data.title,
      "aria-label": data === null || data === void 0 ? void 0 : data.title,
      className: (BusinessServicesCardWithImage_module_default())["card-item"],
      children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
        width: "100%",
        height: "100%"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: (BusinessServicesCardWithImage_module_default()).shape,
        src: "/assets/serviceShape.png",
        alt: "shape",
        title: "shape",
        layout: "fill",
        onLoadingComplete: function onLoadingComplete() {
          return setIsImageLoaded(true);
        },
        style: {
          visibility: isImageLoaded ? 'visible' : 'hidden'
        }
      }), (data === null || data === void 0 ? void 0 : data.image) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        alt: data === null || data === void 0 ? void 0 : data.title,
        title: data === null || data === void 0 ? void 0 : data.title,
        src: data.image,
        className: (BusinessServicesCardWithImage_module_default()).image,
        layout: 'fill',
        loading: "lazy",
        onLoadingComplete: function onLoadingComplete() {
          return setIsImageLoaded(true);
        },
        style: {
          visibility: isImageLoaded ? 'visible' : 'hidden'
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (BusinessServicesCardWithImage_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (BusinessServicesCardWithImage_module_default()).inner,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (BusinessServicesCardWithImage_module_default())["card-item__content"],
            children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
              titleModify: (BusinessServicesCardWithImage_module_default())["card-item__title"],
              children: data.title
            }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
              className: (BusinessServicesCardWithImage_module_default())["card-item__desc"],
              children: data.description
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (BusinessServicesCardWithImage_module_default()).link,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/".concat(data === null || data === void 0 ? void 0 : data.slug),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              title: data === null || data === void 0 ? void 0 : data.title,
              "aria-label": data === null || data === void 0 ? void 0 : data.title,
              "data-testid": "fiber-optik-internet",
              children: [data === null || data === void 0 ? void 0 : data.link_text, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRightNew */.Ni, {
                width: 18
              })]
            })
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var BusinessServicesCardWithImage_BusinessServicesCardWithImage = (BusinessServicesCardWithImage);
// EXTERNAL MODULE: ./components/ui/SliderArrows/PrevArrow.js
var PrevArrow = __webpack_require__(83197);
// EXTERNAL MODULE: ./components/ui/SliderArrows/NextArrow.js
var NextArrow = __webpack_require__(49733);
// EXTERNAL MODULE: ./components/ui/SliderWrapper/SliderWrapper.js
var SliderWrapper_SliderWrapper = __webpack_require__(83234);
// EXTERNAL MODULE: ./components/ui/NumList/NumList.module.scss
var NumList_module = __webpack_require__(16980);
var NumList_module_default = /*#__PURE__*/__webpack_require__.n(NumList_module);
;// CONCATENATED MODULE: ./components/ui/NumList/NumList.js




var NumList = function NumList(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ol", {
    className: classnames_default()([(NumList_module_default())["num-list"], className]),
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: children
  });
};

/* harmony default export */ var NumList_NumList = (NumList);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(67385);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var dist_es = __webpack_require__(91242);
// EXTERNAL MODULE: ./components/ui/AttachFiles/AttachFiles.module.scss
var AttachFiles_module = __webpack_require__(38857);
var AttachFiles_module_default = /*#__PURE__*/__webpack_require__.n(AttachFiles_module);
;// CONCATENATED MODULE: ./components/ui/AttachFiles/AttachFiles.js


function AttachFiles_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AttachFiles_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AttachFiles_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AttachFiles_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function AttachFiles(_ref) {
  var setFiles = _ref.setFiles,
      htmlText = _ref.htmlText,
      onClearFiles = _ref.onClearFiles;

  var _useState = (0,react.useState)([]),
      acceptedFiles = _useState[0],
      setAcceptedFiles = _useState[1];

  var handleDropAccepted = function handleDropAccepted(files) {
    setAcceptedFiles(files);
    setFiles(files);
  };

  var handleDeleteFile = function handleDeleteFile() {
    setAcceptedFiles([]);
    setFiles([]);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_es/* default */.ZP, {
    accept: {
      'application/pdf': ['.pdf', '.doc', '.docx']
    },
    noKeyboard: true,
    maxSize: 1.875e6,
    onDropAccepted: handleDropAccepted,
    "data-testid": "dropzone",
    children: function children(_ref2) {
      var getRootProps = _ref2.getRootProps,
          getInputProps = _ref2.getInputProps;
      var hasFiles = acceptedFiles.length > 0;
      var fileName = hasFiles ? acceptedFiles[0].name : null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        itemScope: true,
        itemType: "https://schema.org/DigitalDocument",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", AttachFiles_objectSpread(AttachFiles_objectSpread({}, getRootProps({
          className: (AttachFiles_module_default()).dropzone
        })), {}, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", AttachFiles_objectSpread({
            "aria-label": "Bakcell"
          }, getInputProps())), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: hasFiles ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Delete */.HG, {
              onClick: handleDeleteFile
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* FileIcon */.aA, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (AttachFiles_module_default()).content,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (AttachFiles_module_default()).text,
              dangerouslySetInnerHTML: {
                __html: hasFiles ? fileName : htmlText
              }
            }), !hasFiles && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (AttachFiles_module_default()).desc,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Trans/* default */.Z, {
                i18nKey: 'common:File size'
              })
            }), (onClearFiles === null || onClearFiles === void 0 ? void 0 : onClearFiles.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: (AttachFiles_module_default()).files,
              children: acceptedFiles.map(function (file) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: file.path
                }, file.path);
              })
            })]
          })]
        }))
      });
    }
  });
}

/* harmony default export */ var AttachFiles_AttachFiles = (AttachFiles);
// EXTERNAL MODULE: ./components/ui/CheckboxWithText/CheckboxWithText.js
var CheckboxWithText = __webpack_require__(67769);
// EXTERNAL MODULE: ./components/ui/BusinessTechnicalSolution/BusinessTechnicalSolution.module.scss
var BusinessTechnicalSolution_module = __webpack_require__(38662);
var BusinessTechnicalSolution_module_default = /*#__PURE__*/__webpack_require__.n(BusinessTechnicalSolution_module);
;// CONCATENATED MODULE: ./components/ui/BusinessTechnicalSolution/BusinessTechnicalSolution.js





var BusinessTechnicalSolution = function BusinessTechnicalSolution(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    "data-testid": 'technical-solution',
    className: (BusinessTechnicalSolution_module_default()).container,
    itemScope: true,
    itemType: "https://schema.org/Service",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (BusinessTechnicalSolution_module_default()).top,
      children: [(data === null || data === void 0 ? void 0 : data.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (BusinessTechnicalSolution_module_default())["icon-wrapper"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircleIcon/* default */.Z, {
          small: true,
          path: data.icon,
          alt: data.icon.alt
        })
      }), (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (BusinessTechnicalSolution_module_default()).title,
        children: data.title
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (BusinessTechnicalSolution_module_default()).list,
      dangerouslySetInnerHTML: {
        __html: data === null || data === void 0 ? void 0 : data.description
      }
    })]
  });
};

/* harmony default export */ var BusinessTechnicalSolution_BusinessTechnicalSolution = (BusinessTechnicalSolution);
;// CONCATENATED MODULE: ./components/SvgComponents/business/products/Chat.js


function Chat_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Chat_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Chat_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Chat_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/_jsxs("svg", Chat_objectSpread(Chat_objectSpread({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12.688 14c0-.725.587-1.313 1.312-1.313h7a1.312 1.312 0 1 1 0 2.626h-7A1.312 1.312 0 0 1 12.687 14ZM12.688 21c0-.725.587-1.313 1.312-1.313h14a1.312 1.312 0 1 1 0 2.625H14A1.312 1.312 0 0 1 12.687 21Z",
      fill: "#858585"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.441 2.188h7.118c2.4 0 4.282 0 5.795.123 1.54.126 2.813.386 3.964.973a10.063 10.063 0 0 1 4.398 4.398c.587 1.151.847 2.424.973 3.964.123 1.513.123 3.395.123 5.795v2.389c0 2.71.001 4.363-.406 5.751a10.063 10.063 0 0 1-6.825 6.825c-1.388.407-3.042.407-5.752.407h-1.322a7.437 7.437 0 0 0-4.237 1.357l-.086.061-4.569 3.264c-2.633 1.88-6.092-.835-4.89-3.84a.615.615 0 0 0-.572-.843H10.1A7.913 7.913 0 0 1 2.188 24.9V17.44c0-2.4 0-4.282.123-5.795.126-1.54.386-2.813.973-3.964a10.062 10.062 0 0 1 4.398-4.398c1.151-.587 2.424-.847 3.964-.973 1.513-.124 3.395-.124 5.795-.123Zm-5.581 2.74c-1.378.112-2.267.328-2.987.695a7.437 7.437 0 0 0-3.25 3.25c-.367.72-.583 1.609-.696 2.987-.113 1.393-.114 3.168-.114 5.64v7.4a5.288 5.288 0 0 0 5.287 5.288h1.053c2.292 0 3.86 2.314 3.008 4.442-.227.57.429 1.086.928.729l4.57-3.264.099-.07a10.063 10.063 0 0 1 5.732-1.837H26.572c3.049 0 4.291-.014 5.27-.301a7.437 7.437 0 0 0 5.045-5.044c.287-.98.3-2.222.3-5.27V17.5c0-2.472 0-4.247-.114-5.64-.113-1.378-.33-2.267-.696-2.987a7.438 7.438 0 0 0-3.25-3.25c-.72-.367-1.609-.583-2.987-.696-1.393-.113-3.168-.114-5.64-.114h-7c-2.472 0-4.247 0-5.64.114Z",
      fill: "#858585"
    })]
  }));
};

/* harmony default export */ var Chat = ((/* unused pure expression or super */ null && (SvgChat)));
;// CONCATENATED MODULE: ./components/SvgComponents/business/products/Internet.js


function Internet_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Internet_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Internet_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Internet_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgInternet = function SvgInternet(props) {
  return /*#__PURE__*/_jsxs("svg", Internet_objectSpread(Internet_objectSpread({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#Internet_svg__a)",
      fill: "#858585",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21 39.813C10.623 39.813 2.187 31.377 2.187 21 2.188 10.623 10.623 2.187 21 2.187c10.378 0 18.813 8.436 18.813 18.813 0 10.378-8.436 18.813-18.813 18.813Zm0-35C12.075 4.813 4.812 12.075 4.812 21S12.075 37.188 21 37.188c8.925 0 16.188-7.263 16.188-16.188 0-8.925-7.263-16.188-16.188-16.188Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.75 38.063H14a1.322 1.322 0 0 1-1.313-1.313c0-.718.56-1.295 1.278-1.313a51.608 51.608 0 0 1 0-28.874 1.303 1.303 0 0 1-1.278-1.313c0-.718.595-1.313 1.313-1.313h1.75c.42 0 .822.21 1.067.543.245.35.315.787.175 1.19-3.29 9.887-3.29 20.773 0 30.677.14.403.07.84-.175 1.19a1.378 1.378 0 0 1-1.067.526ZM26.25 38.062c-.14 0-.28-.018-.42-.07-.682-.228-1.067-.98-.822-1.663 3.29-9.887 3.29-20.772 0-30.677a1.31 1.31 0 1 1 2.485-.84c3.482 10.43 3.482 21.91 0 32.322-.175.578-.7.928-1.243.928Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21 30.1c-4.883 0-9.748-.683-14.438-2.066a1.315 1.315 0 0 1-1.312 1.278 1.322 1.322 0 0 1-1.313-1.313v-1.75c0-.42.21-.822.543-1.067.35-.245.787-.315 1.19-.175 9.887 3.29 20.79 3.29 30.677 0 .403-.14.84-.07 1.19.175s.543.647.543 1.067V28c0 .718-.595 1.313-1.313 1.313-.717 0-1.295-.56-1.312-1.278A51.268 51.268 0 0 1 21 30.1ZM36.75 17.063c-.14 0-.28-.017-.42-.07-9.887-3.29-20.79-3.29-30.677 0a1.31 1.31 0 0 1-1.663-.822c-.21-.7.158-1.435.84-1.663 10.43-3.482 21.91-3.482 32.323 0 .682.228 1.067.98.822 1.663-.157.542-.682.892-1.225.892Z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "Internet_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h42v42H0z"
        })
      })
    })]
  }));
};

/* harmony default export */ var products_Internet = ((/* unused pure expression or super */ null && (SvgInternet)));
;// CONCATENATED MODULE: ./components/SvgComponents/business/products/Gps.js


function Gps_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Gps_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Gps_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Gps_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgGps = function SvgGps(props) {
  return /*#__PURE__*/_jsxs("svg", Gps_objectSpread(Gps_objectSpread({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#gps_svg__a)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M26.25 39.813h-10.5c-7.717 0-10.063-2.346-10.063-10.063v-17.5c0-7.718 2.346-10.063 10.063-10.063h10.5c7.718 0 10.063 2.345 10.063 10.063v17.5c0 7.718-2.346 10.063-10.063 10.063Zm-10.5-35c-6.265 0-7.438 1.19-7.438 7.437v17.5c0 6.248 1.173 7.438 7.438 7.438h10.5c6.265 0 7.438-1.19 7.438-7.438v-17.5c0-6.247-1.173-7.438-7.438-7.438h-10.5Z",
        fill: "#858585"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.261 10.938H15.99c-.848 0-1.552-.596-1.552-1.313s.704-1.313 1.552-1.313h8.272c.848 0 1.552.596 1.552 1.313s-.704 1.313-1.552 1.313ZM21 34.755a4.026 4.026 0 1 1 .001-8.051 4.026 4.026 0 0 1 0 8.051Zm0-5.442c-.77 0-1.4.63-1.4 1.4 0 .77.63 1.4 1.4 1.4.77 0 1.4-.63 1.4-1.4 0-.77-.63-1.4-1.4-1.4Z",
        fill: "#858585"
      }), /*#__PURE__*/_jsx("path", {
        d: "M31.5 1.75c-4.883 0-8.75 4.289-8.75 9.46 0 1.659.815 3.612 1.84 5.445 1.043 1.862 2.373 3.721 3.539 5.225l.039.05c.57.734 1.054 1.359 1.524 1.79.513.472 1.079.78 1.808.78.73 0 1.295-.308 1.808-.78.47-.431.955-1.056 1.524-1.79l.039-.05c1.166-1.504 2.496-3.363 3.538-5.225 1.026-1.833 1.841-3.786 1.841-5.445 0-5.171-3.867-9.46-8.75-9.46Z",
        fill: "#E9E9E9"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.25 11.21c0-6.815 5.157-12.96 12.25-12.96s12.25 6.145 12.25 12.96c0 2.615-1.215 5.24-2.286 7.154-1.162 2.077-2.61 4.09-3.828 5.661m0 0-.038.05-.089.114c-.493.637-1.14 1.472-1.834 2.11l-2.367-2.578c.47-.432.955-1.057 1.524-1.791l.039-.05c1.166-1.504 2.496-3.363 3.538-5.225 1.026-1.833 1.841-3.786 1.841-5.445 0-5.171-3.867-9.46-8.75-9.46s-8.75 4.289-8.75 9.46c0 1.659.815 3.612 1.84 5.445 1.043 1.862 2.373 3.721 3.539 5.225l.039.05c.57.734 1.054 1.359 1.524 1.79L27.325 26.3c-.694-.638-1.341-1.473-1.834-2.11l-.089-.114m0 0-.038-.05c-1.219-1.57-2.666-3.584-3.828-5.661-1.07-1.914-2.286-4.54-2.286-7.154m10.442 12.51c.513.472 1.079.78 1.808.78.73 0 1.295-.308 1.808-.78l2.367 2.579C34.748 27.15 33.376 28 31.5 28s-3.248-.85-4.175-1.701l2.367-2.578Z",
        fill: "#E9E9E9"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E9E9E9",
        d: "M33.25 21h3.5v3.5h-3.5z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.5 3.063c-4.055 0-7.438 3.592-7.438 8.147 0 1.3.665 3.001 1.674 4.804.997 1.782 2.284 3.583 3.43 5.061l.039.05c.594.766 1.005 1.289 1.375 1.629.358.328.621.433.92.433.299 0 .562-.105.92-.433.37-.34.781-.863 1.375-1.629l.039-.05c1.146-1.478 2.433-3.28 3.43-5.061 1.008-1.803 1.673-3.503 1.673-4.804 0-4.555-3.383-8.148-7.437-8.148ZM21.437 11.21C21.438 5.422 25.788.437 31.5.437c5.712 0 10.063 4.985 10.063 10.773 0 2.017-.966 4.222-2.008 6.086-1.087 1.942-2.461 3.86-3.647 5.388m0 0-.039.05-.049.064c-.529.682-1.072 1.382-1.624 1.89-.669.613-1.537 1.125-2.696 1.125-1.16 0-2.027-.512-2.695-1.126-.553-.507-1.096-1.207-1.625-1.89l-.05-.063-.038-.05c-1.186-1.528-2.56-3.446-3.647-5.388-1.042-1.864-2.008-4.069-2.008-6.086",
        fill: "#858585"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.5 8.313a2.188 2.188 0 1 0 0 4.375 2.188 2.188 0 0 0 0-4.376ZM26.687 10.5a4.812 4.812 0 1 1 9.625 0 4.812 4.812 0 0 1-9.624 0Z",
        fill: "#858585"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "gps_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h42v42H0z"
        })
      })
    })]
  }));
};

/* harmony default export */ var products_Gps = ((/* unused pure expression or super */ null && (SvgGps)));
;// CONCATENATED MODULE: ./components/SvgComponents/business/products/Phone.js


function Phone_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Phone_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Phone_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Phone_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/_jsxs("svg", Phone_objectSpread(Phone_objectSpread({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#phone_svg__a)",
      fill: "#858585",
      children: /*#__PURE__*/_jsx("path", {
        d: "M30.538 39.813c-1.978 0-4.06-.473-6.213-1.383-2.1-.892-4.217-2.117-6.282-3.605a54.625 54.625 0 0 1-5.898-5.023 52.283 52.283 0 0 1-5.022-5.88c-1.506-2.1-2.713-4.2-3.57-6.23-.91-2.17-1.365-4.27-1.365-6.247 0-1.365.244-2.66.717-3.868.49-1.242 1.278-2.397 2.345-3.394 1.348-1.33 2.887-1.995 4.533-1.995.682 0 1.382.157 1.977.437.683.315 1.26.788 1.68 1.418l4.06 5.722c.367.508.648.997.84 1.487.227.525.35 1.05.35 1.558 0 .665-.193 1.313-.56 1.925-.262.473-.665.98-1.172 1.488l-1.19 1.242a.853.853 0 0 0 .052.122c.21.368.63.998 1.435 1.943a65.75 65.75 0 0 0 2.468 2.695c1.032 1.015 1.89 1.82 2.695 2.485.997.84 1.645 1.26 2.03 1.453l-.035.087 1.277-1.26c.543-.542 1.067-.945 1.575-1.207.962-.596 2.188-.7 3.412-.193.456.192.945.455 1.47.823l5.81 4.13c.648.437 1.12.997 1.4 1.662.263.665.386 1.278.386 1.89 0 .84-.193 1.68-.56 2.468a8.15 8.15 0 0 1-1.4 2.1c-.998 1.102-2.083 1.89-3.343 2.397-1.207.49-2.52.752-3.902.752Zm-20.756-35c-.962 0-1.854.42-2.712 1.26-.805.752-1.365 1.574-1.715 2.467a7.657 7.657 0 0 0-.543 2.905c0 1.627.385 3.395 1.155 5.215.788 1.855 1.89 3.78 3.29 5.705A48.416 48.416 0 0 0 14 27.93a49.274 49.274 0 0 0 5.582 4.76c1.89 1.383 3.833 2.503 5.758 3.308 2.992 1.277 5.793 1.575 8.103.612.892-.367 1.68-.928 2.397-1.733.402-.437.717-.91.98-1.47a3.1 3.1 0 0 0 .315-1.347c0-.28-.052-.56-.192-.875-.053-.105-.158-.297-.49-.525l-5.81-4.13a5.017 5.017 0 0 0-.963-.543c-.385-.157-.543-.314-1.137.053-.35.175-.665.438-1.015.788l-1.33 1.312c-.683.665-1.733.822-2.538.525l-.473-.21c-.717-.385-1.557-.98-2.485-1.767a54.874 54.874 0 0 1-2.852-2.643 61.13 61.13 0 0 1-2.608-2.835c-.822-.963-1.417-1.785-1.785-2.468l-.21-.524c-.104-.403-.14-.63-.14-.875 0-.63.228-1.19.666-1.628l1.312-1.365c.35-.35.612-.682.787-.98.14-.227.193-.42.193-.595 0-.14-.053-.35-.14-.56a5.02 5.02 0 0 0-.56-.928l-4.06-5.74a1.613 1.613 0 0 0-.647-.542 2.191 2.191 0 0 0-.875-.192Zm14.63 21.454-.28 1.19.473-1.224c-.088-.018-.157 0-.192.034ZM32.375 17.063a1.322 1.322 0 0 1-1.313-1.313c0-.63-.63-1.943-1.68-3.063-1.032-1.102-2.17-1.75-3.132-1.75a1.322 1.322 0 0 1-1.313-1.312c0-.717.595-1.313 1.313-1.313 1.698 0 3.483.91 5.04 2.573 1.453 1.558 2.398 3.465 2.398 4.865 0 .718-.596 1.313-1.313 1.313ZM38.5 17.063a1.322 1.322 0 0 1-1.313-1.313c0-6.037-4.9-10.938-10.937-10.938A1.322 1.322 0 0 1 24.937 3.5c0-.717.595-1.313 1.313-1.313 7.472 0 13.563 6.09 13.563 13.563 0 .718-.596 1.313-1.313 1.313Z"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "phone_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h42v42H0z"
        })
      })
    })]
  }));
};

/* harmony default export */ var products_Phone = ((/* unused pure expression or super */ null && (SvgPhone)));
;// CONCATENATED MODULE: ./components/SvgComponents/business/products/index.js




// EXTERNAL MODULE: ./components/SvgComponents/social/light/index.js + 3 modules
var light = __webpack_require__(46077);
;// CONCATENATED MODULE: ./components/ui/BusinessLargeProduct/BusinessLargeProduct.js



function BusinessLargeProduct_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function BusinessLargeProduct_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BusinessLargeProduct_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BusinessLargeProduct_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var BusinessLargeProduct = function BusinessLargeProduct(_ref) {
  var _data$internet, _data$internet2, _data$internet3, _data$internet4, _data$calls, _data$calls2, _data$calls3, _data$calls4, _data$gps, _data$gps2, _data$gps3, _data$gps4, _data$chat, _data$chat2, _data$chat3, _data$chat$social, _data$chat$social2, _data$chat$social3, _data$chat$social4, _data$chat$social5;

  var data = _ref.data,
      onApply = _ref.onApply;

  var _React$useState = React.useState({
    memory: data === null || data === void 0 ? void 0 : data.memorySize[0],
    month: data === null || data === void 0 ? void 0 : data.availableMonth[0],
    currentImg: data === null || data === void 0 ? void 0 : data.availableColors[0]
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var onClick = function onClick() {
    onApply(state);
  };

  var renderColor = function renderColor(item, index) {
    var changeProduct = function changeProduct() {
      setState(BusinessLargeProduct_objectSpread(BusinessLargeProduct_objectSpread({}, state), {}, {
        currentImg: item
      }));
    };

    return /*#__PURE__*/_jsx("button", {
      className: classNames([styles.color, _defineProperty({}, styles.active, item.id === state.currentImg.id)]),
      onClick: changeProduct,
      "aria-label": "Bakcell",
      itemScope: true,
      itemType: "https://schema.org/Offer",
      children: /*#__PURE__*/_jsx(Image, {
        src: item.src,
        layout: 'fill',
        alt: "img",
        loading: "lazy"
      })
    }, index);
  };

  var renderMemorySizeItem = function renderMemorySizeItem(item, index) {
    var changeMemorySize = function changeMemorySize() {
      setState(BusinessLargeProduct_objectSpread(BusinessLargeProduct_objectSpread({}, state), {}, {
        memory: item
      }));
    };

    return /*#__PURE__*/_jsx(Tab, {
      className: styles.tab,
      active: item.id === state.memory.id,
      onClick: changeMemorySize,
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: item.name
    }, index);
  };

  var renderAvailableMonthItem = function renderAvailableMonthItem(item, index) {
    var changeAvailableMonth = function changeAvailableMonth() {
      setState(BusinessLargeProduct_objectSpread(BusinessLargeProduct_objectSpread({}, state), {}, {
        month: item
      }));
    };

    return /*#__PURE__*/_jsx(Tab, {
      className: styles.tab,
      active: item.id === state.month.id,
      onClick: changeAvailableMonth,
      itemScope: true,
      itemType: "https://schema.org/Text",
      children: item.name
    }, index);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.item,
    itemScope: true,
    itemType: "https://schema.org/Product",
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.left,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.title,
        children: "Apple iPhone 13 Pro Max 128GB Graphite"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.imageContainer,
        children: /*#__PURE__*/_jsx(Image, {
          className: styles.image,
          src: state.currentImg.img,
          layout: 'fill',
          alt: "img",
          loading: "lazy"
        })
      }), (data === null || data === void 0 ? void 0 : data.availableColors) && /*#__PURE__*/_jsx("div", {
        className: styles.colors,
        children: data.availableColors.map(renderColor)
      }), (data === null || data === void 0 ? void 0 : data.memorySize) && /*#__PURE__*/_jsx(Tabs, {
        children: /*#__PURE__*/_jsx(TabPanel, {
          className: styles.tabPanel,
          children: data.memorySize.map(renderMemorySizeItem)
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.right,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.top,
        children: [(data === null || data === void 0 ? void 0 : data.internet) && /*#__PURE__*/_jsxs("div", {
          className: styles.item,
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Internet, {})
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.wrapper,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.title,
                children: (_data$internet = data.internet) === null || _data$internet === void 0 ? void 0 : _data$internet.title1
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: (_data$internet2 = data.internet) === null || _data$internet2 === void 0 ? void 0 : _data$internet2.value1
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.title,
                children: (_data$internet3 = data.internet) === null || _data$internet3 === void 0 ? void 0 : _data$internet3.title2
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: (_data$internet4 = data.internet) === null || _data$internet4 === void 0 ? void 0 : _data$internet4.value2
              })]
            })]
          })]
        }), (data === null || data === void 0 ? void 0 : data.calls) && /*#__PURE__*/_jsxs("div", {
          className: styles.item,
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Phone, {})
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.wrapper,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.title,
                children: (_data$calls = data.calls) === null || _data$calls === void 0 ? void 0 : _data$calls.title1
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: (_data$calls2 = data.calls) === null || _data$calls2 === void 0 ? void 0 : _data$calls2.value1
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.title,
                children: (_data$calls3 = data.calls) === null || _data$calls3 === void 0 ? void 0 : _data$calls3.title2
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: (_data$calls4 = data.calls) === null || _data$calls4 === void 0 ? void 0 : _data$calls4.value2
              })]
            })]
          })]
        }), (data === null || data === void 0 ? void 0 : data.gps) && /*#__PURE__*/_jsxs("div", {
          className: styles.item,
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Gps, {})
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.wrapper,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.title,
                children: (_data$gps = data.gps) === null || _data$gps === void 0 ? void 0 : _data$gps.title1
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: (_data$gps2 = data.gps) === null || _data$gps2 === void 0 ? void 0 : _data$gps2.value1
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.title,
                children: (_data$gps3 = data.gps) === null || _data$gps3 === void 0 ? void 0 : _data$gps3.title2
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: (_data$gps4 = data.gps) === null || _data$gps4 === void 0 ? void 0 : _data$gps4.value2
              })]
            })]
          })]
        }), (data === null || data === void 0 ? void 0 : data.chat) && /*#__PURE__*/_jsxs("div", {
          className: styles.item,
          children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsxs("div", {
            className: styles.wrapper,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.title,
                children: (_data$chat = data.chat) === null || _data$chat === void 0 ? void 0 : _data$chat.title1
              }), /*#__PURE__*/_jsx("div", {
                className: styles.desc,
                children: (_data$chat2 = data.chat) === null || _data$chat2 === void 0 ? void 0 : _data$chat2.value1
              })]
            }), ((_data$chat3 = data.chat) === null || _data$chat3 === void 0 ? void 0 : _data$chat3.social) && /*#__PURE__*/_jsxs("div", {
              className: styles.content,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.title,
                children: (_data$chat$social = data.chat.social) === null || _data$chat$social === void 0 ? void 0 : _data$chat$social.title
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.desc,
                children: [/*#__PURE__*/_jsxs("span", {
                  className: styles.icons,
                  children: [((_data$chat$social2 = data.chat.social) === null || _data$chat$social2 === void 0 ? void 0 : _data$chat$social2.instagram) && /*#__PURE__*/_jsx(Instagram, {}), ((_data$chat$social3 = data.chat.social) === null || _data$chat$social3 === void 0 ? void 0 : _data$chat$social3.whatsapp) && /*#__PURE__*/_jsx(Whatsapp, {}), ((_data$chat$social4 = data.chat.social) === null || _data$chat$social4 === void 0 ? void 0 : _data$chat$social4.facebook) && /*#__PURE__*/_jsx(Facebook, {})]
                }), (_data$chat$social5 = data.chat.social) === null || _data$chat$social5 === void 0 ? void 0 : _data$chat$social5.text]
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.bottom,
        children: [(data === null || data === void 0 ? void 0 : data.availableMonth) && /*#__PURE__*/_jsx(Tabs, {
          children: /*#__PURE__*/_jsx(TabPanel, {
            className: styles.tabPanel,
            children: data.availableMonth.map(renderAvailableMonthItem)
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.total,
          children: ["2 135 \u20BC ", /*#__PURE__*/_jsx("span", {
            children: "| month"
          })]
        }), /*#__PURE__*/_jsxs(Button, {
          className: styles.button,
          onClick: onClick,
          children: ["Buy now ", /*#__PURE__*/_jsx(ArrowRight, {
            width: 22
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var BusinessLargeProduct_BusinessLargeProduct = ((/* unused pure expression or super */ null && (BusinessLargeProduct)));
;// CONCATENATED MODULE: ./components/ui/BannerWithForegroundImage/BannerWithForegroundImage.js







var BannerWithForegroundImage = function BannerWithForegroundImage(_ref) {
  var item = _ref.item,
      onClick = _ref.onClick,
      buttonText = _ref.buttonText,
      href = _ref.href,
      buttonHide = _ref.buttonHide;
  return /*#__PURE__*/_jsx("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.banner,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [item.title && /*#__PURE__*/_jsx("h3", {
          className: styles.title,
          children: item.title
        }), /*#__PURE__*/_jsx("p", {
          className: styles.text,
          children: item.text
        }), !buttonHide && /*#__PURE__*/_jsxs(Button, {
          href: href,
          Component: href ? 'router' : 'button',
          onClick: onClick,
          variant: 'white',
          className: styles.button,
          children: [buttonText || (item === null || item === void 0 ? void 0 : item.buttonText), /*#__PURE__*/_jsx(ArrowRight, {
            width: 20
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.imageContainer,
        children: /*#__PURE__*/_jsx(Image, {
          src: item.image,
          layout: 'fill',
          className: styles.image,
          alt: item.text,
          title: item.text,
          loading: "lazy"
        })
      })]
    })
  });
};

/* harmony default export */ var BannerWithForegroundImage_BannerWithForegroundImage = ((/* unused pure expression or super */ null && (BannerWithForegroundImage)));
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var hooks_useWindowSize = __webpack_require__(16814);
;// CONCATENATED MODULE: ./components/SvgComponents/CardShapesBusiness.js



var CardShapesBusiness = function CardShapesBusiness() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "369",
    height: "228",
    viewBox: "0 0 369 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter0_f_199_4073)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M273.281 151.483L262.044 112.75C261.326 110.273 262.239 107.615 264.329 106.086L316.463 68.0669C318.689 66.4449 321.728 66.4859 323.913 68.1665L374.88 107.497C378.638 110.396 377.831 116.251 373.431 118.043L281.568 155.465C278.164 156.853 274.3 154.997 273.281 151.478V151.483Z",
        fill: "url(#paint0_linear_199_4073)",
        fillOpacity: "0.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter1_f_199_4073)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M169.677 89.6411L193.356 107.123C195.435 108.658 196.336 111.324 195.606 113.796L180.303 165.721C179.349 168.967 175.933 170.836 172.663 169.904L124.505 156.195C120.405 155.029 118.691 150.178 121.165 146.716L160.948 91.0238C162.956 88.2116 166.891 87.5906 169.677 89.647V89.6411Z",
        fill: "url(#paint1_linear_199_4073)",
        fillOpacity: "0.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter2_f_199_4073)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M223.657 138.069L196.279 158.47C194.457 159.829 193.527 162.077 193.856 164.325L205.575 244H373.221L231.032 138.069C228.844 136.439 225.845 136.439 223.657 138.069Z",
        fill: "url(#paint2_linear_199_4073)",
        fillOpacity: "0.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter3_f_199_4073)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M5 -30L153.258 80.3367C154.674 81.3946 156.484 81.7883 158.217 81.4239L201.327 72.2907C203.548 71.8206 205.329 70.1691 205.969 67.9886L234.693 -30H5Z",
        fill: "url(#paint3_linear_199_4073)",
        fillOpacity: "0.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      opacity: "0.9",
      filter: "url(#filter4_f_199_4073)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M311.372 -30L240.115 27.0785C238.15 28.648 237.339 31.252 238.056 33.6561L245.178 57.574C246.095 60.6483 249.217 62.5116 252.358 61.8533L382.137 34.7544V-30H311.372Z",
        fill: "url(#paint4_linear_199_4073)",
        fillOpacity: "0.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "filter0_f_199_4073",
        x: "256.802",
        y: "61.8777",
        width: "125.471",
        height: "99.0496",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_199_4073"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "filter1_f_199_4073",
        x: "115.018",
        y: "83.4333",
        width: "85.8389",
        height: "91.7102",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_199_4073"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "filter2_f_199_4073",
        x: "188.791",
        y: "131.847",
        width: "189.43",
        height: "117.153",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_199_4073"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "filter3_f_199_4073",
        x: "0",
        y: "-35",
        width: "239.693",
        height: "121.557",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_199_4073"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "filter4_f_199_4073",
        x: "232.799",
        y: "-35",
        width: "154.339",
        height: "101.985",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: "2.5",
          result: "effect1_foregroundBlur_199_4073"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint0_linear_199_4073",
        x1: "251.546",
        y1: "105.514",
        x2: "405.643",
        y2: "90.9875",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FC2E2E"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "1",
          stopColor: "#FF8E8E",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint1_linear_199_4073",
        x1: "113.282",
        y1: "123.885",
        x2: "214.926",
        y2: "117.027",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FC2E2E"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "1",
          stopColor: "#FF8E8E",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint2_linear_199_4073",
        x1: "177.855",
        y1: "183.338",
        x2: "415.906",
        y2: "154.359",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FC2E2E"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "1",
          stopColor: "#FF8E8E",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint3_linear_199_4073",
        x1: "-15.4005",
        y1: "18.4017",
        x2: "287.074",
        y2: "-26.8747",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FC2E2E"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "1",
          stopColor: "#FF8E8E",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint4_linear_199_4073",
        x1: "224.979",
        y1: "9.91017",
        x2: "416.816",
        y2: "-11.9738",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#FC2E2E"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "1",
          stopColor: "#FF8E8E",
          stopOpacity: "0"
        })]
      })]
    })]
  });
};

/* harmony default export */ var SvgComponents_CardShapesBusiness = (CardShapesBusiness);
;// CONCATENATED MODULE: ./components/ui/BusinessTariffCard/Details.js





var Details = function Details(_ref) {
  var _ref$data = _ref.data,
      _ref$data$sections = _ref$data.sections,
      sections = _ref$data$sections === void 0 ? [] : _ref$data$sections,
      _ref$data$bottom_text = _ref$data.bottom_text,
      description = _ref$data$bottom_text === void 0 ? '' : _ref$data$bottom_text,
      className = _ref.className,
      forwardRef = _ref.forwardRef;

  var renderList = function renderList(_ref2, key) {
    var _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title,
        _ref2$price = _ref2.price,
        price = _ref2$price === void 0 ? '' : _ref2$price;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).title,
        children: title
      }), price && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).text,
        children: price
      })]
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((styles_module_default()).details, " ").concat(className),
    ref: forwardRef,
    "data-testId": "details-container",
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (styles_module_default()).details__content,
      children: [!!sections.length && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        children: sections.map(renderList)
      }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).description,
        children: description
      })]
    })
  });
};

/* harmony default export */ var BusinessTariffCard_Details = (Details);
;// CONCATENATED MODULE: ./components/ui/BusinessTariffCard/BusinessTariffCard.js



/* eslint-disable no-alert */















var BusinessTariffCard_BusinessTariffCard = function BusinessTariffCard(_ref) {
  var _data$sections, _data$details, _data$additions, _data$additions2, _data$details2, _data$details3, _data$details3$sectio;

  var data = _ref.data,
      handleConnect = _ref.handleConnect;

  var _useWindowSize = (0,hooks_useWindowSize/* default */.Z)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      width = _useWindowSize2[0];

  var _useState = (0,react.useState)(false),
      active = _useState[0],
      setActive = _useState[1];

  var tariffDetails = (0,react.useRef)();

  var showDetails = function showDetails() {
    setActive(!active);
  };

  var renderPrice = function renderPrice() {
    if ((data === null || data === void 0 ? void 0 : data.button_type) === 'pop-up') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        size: 'normal',
        Component: 'button',
        onClick: handleConnect,
        className: "bkc-gtm_business_tracking ".concat((styles_module_default()).button),
        name: data === null || data === void 0 ? void 0 : data.name,
        children: data === null || data === void 0 ? void 0 : data.button_text
      });
    }

    return width > 768 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
      size: 'normal',
      Component: data !== null && data !== void 0 && data.button_slug ? 'a' : 'router',
      href: data !== null && data !== void 0 && data.button_slug ? data === null || data === void 0 ? void 0 : data.button_slug : data === null || data === void 0 ? void 0 : data.external_link,
      className: (styles_module_default()).button,
      children: data === null || data === void 0 ? void 0 : data.button_text
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
      size: 'normal',
      Component: 'a',
      href: "tel:".concat(data === null || data === void 0 ? void 0 : data.ussd),
      className: "bkc-gtm_business_tracking ".concat((styles_module_default()).button),
      name: data === null || data === void 0 ? void 0 : data.name,
      children: data === null || data === void 0 ? void 0 : data.button_text
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(styles_module_default()).tariff, (0,defineProperty/* default */.Z)({}, (styles_module_default()).active, active)]),
    itemScope: true,
    itemType: "https://schema.org/Product",
    children: [((data === null || data === void 0 ? void 0 : data.name) || data.ussd) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (styles_module_default())["tariff-head"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default())["tariff-head__content"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (styles_module_default()).topWrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [" ", (data === null || data === void 0 ? void 0 : data.name) && (data === null || data === void 0 ? void 0 : data.name)]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).rectangle
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents_CardShapesBusiness, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()((styles_module_default())["price-box"], (0,defineProperty/* default */.Z)({}, (styles_module_default()).line, data.individual_customers_price)),
          children: ((data === null || data === void 0 ? void 0 : data.corporate_customers_price) || (data === null || data === void 0 ? void 0 : data.individual_customers_price)) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [data.individual_customers_price && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (styles_module_default())["price-box__content"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).title,
                children: data === null || data === void 0 ? void 0 : data.individual_customers_price_title
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).all,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (styles_module_default()).price,
                  children: data === null || data === void 0 ? void 0 : data.individual_customers_price
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (styles_module_default()).currency,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "currency",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Currency */.F, {})
                  }), data === null || data === void 0 ? void 0 : data.price_text]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()((styles_module_default())["price-box__content"], !(data !== null && data !== void 0 && data.individual_customers_price) && (styles_module_default())["price-box__content__hidden"]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).title,
                children: data === null || data === void 0 ? void 0 : data.corporate_customers_price_title
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).all,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (styles_module_default()).price,
                  children: data === null || data === void 0 ? void 0 : data.corporate_customers_price
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (styles_module_default()).currency,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "currency",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Currency */.F, {})
                  }), data === null || data === void 0 ? void 0 : data.price_text]
                })]
              })]
            })]
          })
        }), !!data.ussd && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (styles_module_default()).numbers,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
            numbers: data.ussd,
            isTel: true
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (styles_module_default()).tariff__content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).cellContainer,
        children: [!!((_data$sections = data.sections) !== null && _data$sections !== void 0 && _data$sections.length) && data.sections.map(function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessTariffCard_CellData, {
            data: item
          }, key);
        }), (data === null || data === void 0 ? void 0 : (_data$details = data.details) === null || _data$details === void 0 ? void 0 : _data$details.sections) && active && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()([(styles_module_default()).detailsContainer]),
          ref: tariffDetails,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessTariffCard_Details, {
            data: data === null || data === void 0 ? void 0 : data.details
          })
        })]
      }), (data === null || data === void 0 ? void 0 : (_data$additions = data.additions) === null || _data$additions === void 0 ? void 0 : _data$additions.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).additional,
        children: data === null || data === void 0 ? void 0 : (_data$additions2 = data.additions) === null || _data$additions2 === void 0 ? void 0 : _data$additions2.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: item
          }, item);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).bottom,
        children: [(data === null || data === void 0 ? void 0 : (_data$details2 = data.details) === null || _data$details2 === void 0 ? void 0 : _data$details2.button_text) && (data === null || data === void 0 ? void 0 : (_data$details3 = data.details) === null || _data$details3 === void 0 ? void 0 : (_data$details3$sectio = _data$details3.sections) === null || _data$details3$sectio === void 0 ? void 0 : _data$details3$sectio.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          onClick: showDetails,
          className: (styles_module_default()).bottom__content,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default())["details-button"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Arrow/* default */.Z, {
              className: active && (styles_module_default()).active
            }), data === null || data === void 0 ? void 0 : data.details.button_text]
          })
        }), renderPrice()]
      })]
    })]
  });
};

/* harmony default export */ var ui_BusinessTariffCard_BusinessTariffCard = (BusinessTariffCard_BusinessTariffCard);
// EXTERNAL MODULE: ./components/ui/InformationModal/InformationModal.js
var InformationModal = __webpack_require__(92603);
// EXTERNAL MODULE: ./components/ui/Bundles/Bundles.module.scss
var Bundles_module = __webpack_require__(33025);
var Bundles_module_default = /*#__PURE__*/__webpack_require__.n(Bundles_module);
;// CONCATENATED MODULE: ./components/ui/Bundles/BundlesTable.js







var BundlesTable = function BundlesTable(_ref) {
  var _data$left_card_colum;

  var data = _ref.data,
      className = _ref.className;

  var renderTableTd = function renderTableTd(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Bundles_module_default()).table__td,
      itemScope: true,
      itemType: "https://schema.org/OfferCatalog",
      children: item === null || item === void 0 ? void 0 : item.text
    }, index);
  };

  var renderTableColumn = function renderTableColumn(item, index) {
    var _item$rows;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Bundles_module_default()).table__column,
      itemScope: true,
      itemType: "https://schema.org/Offer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Bundles_module_default()).table__th,
        children: item === null || item === void 0 ? void 0 : item.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Bundles_module_default()).table__values,
        children: item === null || item === void 0 ? void 0 : (_item$rows = item.rows) === null || _item$rows === void 0 ? void 0 : _item$rows.map(renderTableTd)
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((Bundles_module_default()).table, className),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [(data === null || data === void 0 ? void 0 : data.left_card_title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
      titleModify: classnames_default()((Bundles_module_default()).table__title, 'title--large'),
      "data-testid": "section-title",
      children: data.left_card_title
    }), (data === null || data === void 0 ? void 0 : data.left_card_description) && /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
      className: classnames_default()((Bundles_module_default()).table__text, 'text--large'),
      "data-testid": "text-block",
      children: data.left_card_description
    }), (data === null || data === void 0 ? void 0 : data.left_card_columns) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (Bundles_module_default()).table__inner,
      children: data === null || data === void 0 ? void 0 : (_data$left_card_colum = data.left_card_columns) === null || _data$left_card_colum === void 0 ? void 0 : _data$left_card_colum.map(renderTableColumn)
    })]
  });
};

/* harmony default export */ var Bundles_BundlesTable = (BundlesTable);
;// CONCATENATED MODULE: ./components/ui/Bundles/Mounthly.js










var Mounthly = function Mounthly(_ref) {
  var _data$right_card_sect;

  var data = _ref.data,
      className = _ref.className;

  var _useState = (0,react.useState)(false),
      activeModal = _useState[0],
      setActiveModal = _useState[1];

  var openModal = function openModal() {
    setActiveModal(true);
  };

  var closeModal = function closeModal() {
    setActiveModal(false);
  };

  var renderMountlyTable = function renderMountlyTable(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Bundles_module_default())["mounthly-table__row"],
      itemScope: true,
      itemType: "https://schema.org/FinancialProduct",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Bundles_module_default())["mounthly-table__item"],
        children: [(item === null || item === void 0 ? void 0 : item.left_heading) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Bundles_module_default())["mounthly-table__title"],
          children: item.left_heading
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Bundles_module_default())["mounthly-table__currency"],
          children: item.left_text
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Bundles_module_default())["mounthly-table__item"],
        children: [(item === null || item === void 0 ? void 0 : item.right_heading) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (Bundles_module_default())["mounthly-table__title"],
          children: item.right_heading
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Bundles_module_default())["mounthly-table__currency"],
          children: item.right_text
        })]
      })]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((Bundles_module_default()).mounthly, className),
    itemScope: true,
    itemType: "https://schema.org/FinancialProduct",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Bundles_module_default()).mounthly__inner,
      children: [(data === null || data === void 0 ? void 0 : data.right_card_title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
        titleModify: classnames_default()((Bundles_module_default()).mounthly__title, 'title--large'),
        children: data === null || data === void 0 ? void 0 : data.right_card_title
      }), (data === null || data === void 0 ? void 0 : data.right_card_sections) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Bundles_module_default())["mounthly-table"],
        children: data === null || data === void 0 ? void 0 : (_data$right_card_sect = data.right_card_sections) === null || _data$right_card_sect === void 0 ? void 0 : _data$right_card_sect.map(renderMountlyTable)
      }), (data === null || data === void 0 ? void 0 : data.right_card_action_type) === 'pop-up' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
        className: (Bundles_module_default()).mounthly__button,
        onClick: function onClick() {
          return openModal();
        },
        Component: 'button',
        children: [data === null || data === void 0 ? void 0 : data.right_card_button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
          width: 20
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
        className: (Bundles_module_default()).mounthly__button,
        Component: 'router',
        href: data === null || data === void 0 ? void 0 : data.right_card_page_slug,
        children: [data === null || data === void 0 ? void 0 : data.right_card_button_text, /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
          width: 20
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BusinessContactForm_BusinessContactForm/* default */.Z, {
      activeModal: activeModal,
      clearTariff: closeModal,
      hasEmployeesCount: true
    })]
  });
};

/* harmony default export */ var Bundles_Mounthly = (Mounthly);
;// CONCATENATED MODULE: ./components/ui/Bundles/Bundles.js








var Bundles = function Bundles(_ref) {
  var data = _ref.data,
      className = _ref.className,
      _ref$handleConnect = _ref.handleConnect,
      handleConnect = _ref$handleConnect === void 0 ? function () {
    return null;
  } : _ref$handleConnect;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((Bundles_module_default()).bundles, className),
    itemScope: true,
    itemType: "https://schema.org/OfferCatalog",
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
      titleModify: classnames_default()((Bundles_module_default()).bundles__title, 'title--large'),
      children: data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Bundles_module_default()).bundles__inner,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Bundles_BundlesTable, {
        data: data
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bundles_Mounthly, {
        handleConnect: handleConnect,
        data: data
      })]
    })]
  });
};

/* harmony default export */ var Bundles_Bundles = (Bundles);
;// CONCATENATED MODULE: ./components/ui/BusinessWifiInternetCard/CellData.js






var BusinessWifiInternetCard_CellData_CellData = function CellData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.cell,
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [!!data.left_icon && /*#__PURE__*/_jsx(Image, {
      src: data === null || data === void 0 ? void 0 : data.left_icon,
      alt: "left icon",
      title: "left icon",
      loading: "lazy",
      layout: "fill"
    }), /*#__PURE__*/_jsx("ul", {
      children: /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsxs("div", {
          children: [data.left_heading && /*#__PURE__*/_jsx("div", {
            className: styles.title,
            children: data.left_heading
          }), data.left_text && /*#__PURE__*/_jsx("div", {
            className: styles.text,
            children: data.left_text
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.right,
          children: [data.right_heading && /*#__PURE__*/_jsx("div", {
            className: styles.title,
            children: data.right_heading
          }), data.right_text && /*#__PURE__*/_jsx("div", {
            className: styles.text,
            children: data.right_text
          })]
        })]
      })
    }), !!data.icons && data.icons.map(function (icon) {
      return /*#__PURE__*/_jsx("div", {
        className: styles.icon,
        children: /*#__PURE__*/_jsx(Image, {
          src: icon,
          alt: 'icon',
          title: "icon",
          loading: "lazy",
          layout: "fill"
        })
      }, '');
    })]
  });
};

/* harmony default export */ var BusinessWifiInternetCard_CellData = ((/* unused pure expression or super */ null && (BusinessWifiInternetCard_CellData_CellData)));
;// CONCATENATED MODULE: ./components/ui/BusinessWifiInternetCard/BusinessWifiInternetCard.js









var BusinessWifiInternetCard = function BusinessWifiInternetCard(_ref) {
  var _data$sections;

  var _ref$handleConnect = _ref.handleConnect,
      handleConnect = _ref$handleConnect === void 0 ? function () {
    return null;
  } : _ref$handleConnect,
      data = _ref.data;
  var tariffItem = useRef();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.tariff,
    ref: tariffItem,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [(data === null || data === void 0 ? void 0 : data.name) && (data === null || data === void 0 ? void 0 : data.show_tariff_names) && /*#__PURE__*/_jsx("div", {
      className: styles['tariff-head'],
      children: /*#__PURE__*/_jsx("div", {
        className: styles['tariff-head__content'],
        children: data === null || data === void 0 ? void 0 : data.name
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.tariff__content,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.inner,
        children: [!!((_data$sections = data.sections) !== null && _data$sections !== void 0 && _data$sections.length) && data.sections.map(function (item, key) {
          return /*#__PURE__*/_jsx(CellData, {
            data: item
          }, key);
        }), !!(data !== null && data !== void 0 && data.additions.length) && /*#__PURE__*/_jsx("div", {
          className: styles.additions,
          children: data.additions.map(function (addition) {
            return /*#__PURE__*/_jsx("div", {
              className: styles.adds,
              children: addition
            }, '');
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.bottom,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.bottom__content,
          children: /*#__PURE__*/_jsx("div", {
            className: styles['price-box'],
            children: (data === null || data === void 0 ? void 0 : data.corporate_customers_price) && (data === null || data === void 0 ? void 0 : data.individual_customers_price) && /*#__PURE__*/_jsxs(_Fragment, {
              children: [!data.show_individual_prices && /*#__PURE__*/_jsxs("div", {
                className: styles['price-box__content'],
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.title,
                  children: data === null || data === void 0 ? void 0 : data.individual_customers_price_title
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.all,
                  children: [/*#__PURE__*/_jsx("span", {
                    className: styles.price,
                    children: data === null || data === void 0 ? void 0 : data.individual_customers_price
                  }), /*#__PURE__*/_jsxs("span", {
                    className: styles.currency,
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "currency",
                      children: /*#__PURE__*/_jsx(Currency, {})
                    }), data === null || data === void 0 ? void 0 : data.price_text]
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles['price-box__content'],
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.title,
                  children: data === null || data === void 0 ? void 0 : data.corporate_customers_price_title
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.all,
                  children: [/*#__PURE__*/_jsx("span", {
                    className: styles.price,
                    children: data === null || data === void 0 ? void 0 : data.corporate_customers_price
                  }), /*#__PURE__*/_jsxs("span", {
                    className: styles.currency,
                    children: [/*#__PURE__*/_jsx("span", {
                      className: "currency",
                      children: /*#__PURE__*/_jsx(Currency, {})
                    }), data === null || data === void 0 ? void 0 : data.price_text]
                  })]
                })]
              })]
            })
          })
        }), /*#__PURE__*/_jsxs(Button, {
          className: styles.button,
          onClick: function onClick(id) {
            return handleConnect(id);
          },
          children: [data === null || data === void 0 ? void 0 : data.button_text, /*#__PURE__*/_jsx(ArrRight, {
            width: 24
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var BusinessWifiInternetCard_BusinessWifiInternetCard = ((/* unused pure expression or super */ null && (BusinessWifiInternetCard)));
// EXTERNAL MODULE: ./components/ui/ScreenLoader/ScreenLoader.js
var ScreenLoader = __webpack_require__(78755);
;// CONCATENATED MODULE: ./components/ui/BusinessTariffsCard/BusinessTariffsCard.js
















var BusinessTariffsCard = function BusinessTariffsCard(_ref) {
  var data = _ref.data,
      tabs = _ref.tabs,
      title = _ref.title,
      buttonText = _ref.buttonText;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentTab = _React$useState2[0],
      setCurrentTab = _React$useState2[1];

  var _useState = useState(false),
      modalActive = _useState[0],
      setModalActive = _useState[1];

  var _useState2 = useState(0),
      sliderHeight = _useState2[0],
      setSliderHeight = _useState2[1];

  var _useState3 = useState(null),
      tariffID = _useState3[0],
      setTariffID = _useState3[1];

  var closeModal = function closeModal() {
    setModalActive(false);
    setTariffID(null);
  };

  var renderList = function renderList(item, key) {
    return /*#__PURE__*/_jsx(BusinessTariffCard, {
      changeSliderHeight: setSliderHeight,
      sliderHeight: sliderHeight,
      data: item,
      itemScope: true,
      itemType: "https://schema.org/Product"
    }, key);
  };

  if (data) {
    var _data$tariffs;

    return !!(data !== null && data !== void 0 && data.length) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: 'wrapper section',
        itemScope: true,
        itemType: "https://schema.org/ItemList",
        children: title && /*#__PURE__*/_jsx(SectionTitle, {
          titleModify: "title--large",
          className: styles.title,
          children: title
        })
      }), /*#__PURE__*/_jsx(SliderWrapper, {
        className: styles.slider,
        arrows: true,
        options: {
          infinite: (data === null || data === void 0 ? void 0 : (_data$tariffs = data.tariffs) === null || _data$tariffs === void 0 ? void 0 : _data$tariffs.length) > 2
        },
        children: data.map(renderList)
      }), /*#__PURE__*/_jsx(BusinessContactForm, {
        tariffID: tariffID,
        activeModal: modalActive,
        clearTariff: closeModal
      })]
    });
  }

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/_jsx(Tab, {
      onClick: function onClick() {
        return setCurrentTab(index);
      },
      children: item.title
    }, index);
  };

  var renderTabItem = function renderTabItem(item, index) {
    var _item$items, _data$tariffs2;

    return /*#__PURE__*/_jsx(TabContentItem, {
      itemScope: true,
      itemType: "https://schema.org/ItemList",
      children: !!((_item$items = item.items) !== null && _item$items !== void 0 && _item$items.length) && /*#__PURE__*/_jsx(SliderWrapper, {
        arrows: true,
        options: {
          infinite: (data === null || data === void 0 ? void 0 : (_data$tariffs2 = data.tariffs) === null || _data$tariffs2 === void 0 ? void 0 : _data$tariffs2.length) > 2
        },
        className: styles.slider,
        children: item.items.map(renderList)
      })
    }, index);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: [title && /*#__PURE__*/_jsx(SectionTitle, {
      titleModify: "title--large",
      className: styles.title,
      buttonText: buttonText,
      children: title
    }), /*#__PURE__*/_jsxs(Tabs, {
      active: currentTab,
      children: [/*#__PURE__*/_jsx(TabPanel, {
        children: tabs.map(renderTab)
      }), /*#__PURE__*/_jsx(TabContent, {
        children: tabs.map(renderTabItem)
      })]
    }), /*#__PURE__*/_jsx(BusinessContactForm, {
      tariffID: tariffID,
      activeModal: modalActive,
      clearTariff: closeModal
    })]
  });
};

/* harmony default export */ var BusinessTariffsCard_BusinessTariffsCard = ((/* unused pure expression or super */ null && (BusinessTariffsCard)));
// EXTERNAL MODULE: ./components/ui/SEOText/SEOText.module.scss
var SEOText_module = __webpack_require__(16988);
var SEOText_module_default = /*#__PURE__*/__webpack_require__.n(SEOText_module);
;// CONCATENATED MODULE: ./components/ui/SEOText/SEOText.js




var SEOText = function SEOText(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(SEOText_module_default()).content, className]),
    dangerouslySetInnerHTML: {
      __html: children
    },
    "data-testid": "seo-text",
    itemScope: true,
    itemType: "https://schema.org/Person"
  });
};

/* harmony default export */ var SEOText_SEOText = (SEOText);
;// CONCATENATED MODULE: ./components/ui/BusinessTable/BusinessTable.js







var BusinessTable = function BusinessTable(_ref) {
  var data = _ref.data,
      className = _ref.className,
      isHorisontal = _ref.isHorisontal,
      Icon = _ref.Icon;

  var renderTableItem = function renderTableItem(item, index) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.table__elem,
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: item
    }, index);
  };

  var renderCulumns = function renderCulumns(item, index) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.table__column,
      itemScope: true,
      itemType: "https://schema.org/TableColumn",
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.table__head,
        children: item.title
      }), (item === null || item === void 0 ? void 0 : item.values) && /*#__PURE__*/_jsx("div", {
        className: styles.table__items,
        children: item.values.map(renderTableItem)
      })]
    }, index);
  };

  return /*#__PURE__*/_jsxs("section", {
    className: classNames([styles.table, className, _defineProperty({}, styles['table--horisontal'], isHorisontal)]),
    itemScope: true,
    itemType: "https://schema.org/Table",
    children: [(data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/_jsx(SectionTitle, {
      titleModify: classNames([styles.table__title, 'title--medium']),
      Icon: Icon,
      children: data.title
    }), (data === null || data === void 0 ? void 0 : data.tableItems) && /*#__PURE__*/_jsx("div", {
      className: styles.table__inner,
      children: data.tableItems.map(renderCulumns)
    })]
  });
};

/* harmony default export */ var BusinessTable_BusinessTable = ((/* unused pure expression or super */ null && (BusinessTable)));
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(53431);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(48740);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(97043);
;// CONCATENATED MODULE: ./components/ui/PasswordInput/PasswordInput.tsx



function PasswordInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PasswordInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PasswordInput_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PasswordInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PasswordInput = function PasswordInput(props) {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      show = _React$useState2[0],
      setShow = _React$useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, PasswordInput_objectSpread(PasswordInput_objectSpread({
    type: show ? 'text' : 'password',
    IconRight: show ? '/assets/EyePasswordHide.svg' : '/assets/EyePassword.svg',
    onClickRightIcon: function onClickRightIcon() {
      return setShow(!show);
    }
  }, props), {}, {
    itemScope: true,
    itemType: "https://schema.org/Thing"
  }));
};

/* harmony default export */ var PasswordInput_PasswordInput = (PasswordInput);
// EXTERNAL MODULE: ./components/ui/LoginModal/LoginModal.module.scss
var LoginModal_module = __webpack_require__(48044);
var LoginModal_module_default = /*#__PURE__*/__webpack_require__.n(LoginModal_module);
;// CONCATENATED MODULE: ./components/ui/LoginModal/LoginModal.js


/* eslint-disable no-console */















var FormSchema = yup_es/* object */.Ry().shape({
  phone: yup_es/* string */.Z_().required('Required').length(13),
  password: yup_es/* string */.Z_().required('No password provided.').min(8, 'Password is too short - should be 8 chars minimum.').matches(/[a-zA-Z]/, 'Password can only contain Latin letters.')
});
var FormSchemaPassword = yup_es/* object */.Ry().shape({
  phone: yup_es/* string */.Z_().required('Required').length(13),
  password: yup_es/* string */.Z_().required('No password provided.').min(8, 'Password is too short - should be 8 chars minimum.').matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
  password2: yup_es/* string */.Z_().required('No password provided.').min(8, 'Password is too short - should be 8 chars minimum.').matches(/[a-zA-Z]/, 'Password can only contain Latin letters.')
});

var LoginModal = function LoginModal(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      _ref$setUser = _ref.setUser,
      setUser = _ref$setUser === void 0 ? function () {
    return null;
  } : _ref$setUser;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      signUp = _React$useState2[0],
      setSignUp = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      passwordRestore = _React$useState4[0],
      setPasswordRestore = _React$useState4[1];

  var _React$useState5 = react.useState('phone'),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      passwordRestoreFlow = _React$useState6[0],
      setPasswordRestoreFlow = _React$useState6[1];

  var onChangeCaptcha = function onChangeCaptcha(value) {
    console.log('Captcha value:', value);
  };

  react.useEffect(function () {
    setTimeout(function () {
      setPasswordRestoreFlow('phone');
    }, 300);
  }, [passwordRestore]);
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      phone: '',
      password: ''
    },
    validationSchema: FormSchema,
    onSubmit: function onSubmit() {
      setUser(true);
    }
  });
  var formikSingUp = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      phone: '',
      password: '',
      password2: ''
    },
    validationSchema: FormSchemaPassword,
    onSubmit: function onSubmit() {
      setUser(true);
    }
  });
  var formikPasswordFlowPhone = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      phone: ''
    },
    onSubmit: function onSubmit() {
      setPasswordRestoreFlow('code');
    }
  });
  var formikPasswordFlowCode = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      code: ''
    },
    onSubmit: function onSubmit() {
      setPasswordRestoreFlow('password');
    }
  });
  var formikPasswordFlowPassword = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      password: '',
      password1: ''
    },
    onSubmit: function onSubmit() {
      setPasswordRestore(false);
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Modal["default"], {
      active: active,
      setActive: setActive,
      className: (LoginModal_module_default()).modal,
      itemScope: true,
      itemType: "https://schema.org/CheckInAction",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: 'title',
        children: ["Login ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (LoginModal_module_default()).title,
          children: "Bakcell"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LoginModal_module_default()).form,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z // error
        , {
          value: formik.values.phone,
          onBlur: formik.handleBlur('phone'),
          onChange: function onChange(value) {
            return formik.setFieldValue('phone', value);
          },
          label: 'Phone',
          type: "tel",
          placeholderMask: '+994',
          placeholder: '+994 (XXX) XXX XX-XX',
          mask: '+\\9\\9\\4-999-999-99-99'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordInput_PasswordInput // error={<span className={styles.error}>Incorrect phone or password</span>}
        , {
          onBlur: formik.handleBlur('password'),
          onChange: function onChange(value) {
            return formik.setFieldValue('password', value);
          },
          placeholder: 'Password'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LoginModal_module_default()).forgotPassword,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (LoginModal_module_default()).button,
            onClick: function onClick() {
              setPasswordRestore(true);
              setSignUp(false);
              setActive(false);
            },
            children: "Forgot password?"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (LoginModal_module_default()).reCAPTCHA,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (LoginModal_module_default()).text,
            children: "Please check box below to proceed."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
            sitekey: constants/* envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY */.ie.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default',
            onChange: onChangeCaptcha
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
          className: (LoginModal_module_default()).login,
          onClick: function onClick() {
            setUser(true);
            setActive(false);
          },
          children: ["Login ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrRight */.jG, {
            width: 24
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LoginModal_module_default()).signUpContainer,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: ["Don't have an account yet?", /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: (LoginModal_module_default()).signUp,
              onClick: function onClick() {
                setSignUp(true);
                setActive(false);
              },
              children: "Sign up"
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal["default"], {
      active: signUp,
      setActive: setSignUp,
      className: (LoginModal_module_default()).modal,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: 'title',
        children: ["Sign up ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (LoginModal_module_default()).title,
          children: "Bakcell"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LoginModal_module_default()).form,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
          value: formikSingUp.values.phone,
          onBlur: formikSingUp.handleBlur('phone'),
          onChange: function onChange(value) {
            return formikSingUp.setFieldValue('phone', value);
          },
          label: 'Phone',
          type: "tel",
          placeholderMask: '+994',
          placeholder: '+994 (XXX) XXX XX-XX',
          mask: '+\\9\\9\\4-999-999-99-99'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordInput_PasswordInput, {
          onBlur: formikSingUp.handleBlur('password'),
          onChange: function onChange(value) {
            return formikSingUp.setFieldValue('password', value);
          },
          placeholder: 'Password'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordInput_PasswordInput, {
          onBlur: formikSingUp.handleBlur('password2'),
          onChange: function onChange(value) {
            return formikSingUp.setFieldValue('password2', value);
          },
          placeholder: 'Repeat password'
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (LoginModal_module_default()).reCAPTCHA,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (LoginModal_module_default()).text,
            children: "Please check box below to proceed."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
            sitekey: constants/* envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY */.ie.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default',
            onChange: onChangeCaptcha
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
          className: (LoginModal_module_default()).login,
          onClick: function onClick() {
            setUser(true);
            setSignUp(false);
          },
          children: ["Sign up ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrRight */.jG, {
            width: 24
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LoginModal_module_default()).signUpContainer,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: ["Don't have an account yet?", /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: (LoginModal_module_default()).signUp,
              onClick: function onClick() {
                setActive(true);
                setSignUp(false);
              },
              children: "Login"
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal["default"], {
      active: passwordRestore,
      setActive: setPasswordRestore,
      className: (LoginModal_module_default()).modal,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: 'title',
        children: ["Password ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (LoginModal_module_default()).title,
          children: "Recovery"
        })]
      }), passwordRestoreFlow === 'phone' && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LoginModal_module_default()).form,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
          value: formikPasswordFlowPhone.values.phone,
          onBlur: formikPasswordFlowPhone.handleBlur('phone'),
          onChange: function onChange(value) {
            return formikPasswordFlowPhone.setFieldValue('phone', value);
          },
          label: 'Phone',
          type: "tel",
          placeholderMask: '+994',
          placeholder: '+994 (XXX) XXX XX-XX',
          mask: '+\\9\\9\\4-999-999-99-99'
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
          className: classnames_default()([(LoginModal_module_default()).login, (LoginModal_module_default()).password]),
          onClick: formikPasswordFlowPhone.handleSubmit,
          children: ["Next ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrRight */.jG, {
            width: 24
          })]
        })]
      }), passwordRestoreFlow === 'code' && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LoginModal_module_default()).form,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PasswordInput_PasswordInput, {
          label: 'SMS-Code',
          onBlur: formikPasswordFlowCode.handleBlur('code'),
          onChange: function onChange(value) {
            return formikPasswordFlowCode.setFieldValue('code', value);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: classnames_default()([(LoginModal_module_default()).code, (LoginModal_module_default()).codeAgain]),
          children: "Send code again"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
          className: classnames_default()([(LoginModal_module_default()).login, (LoginModal_module_default()).loginCode]),
          onClick: formikPasswordFlowCode.handleSubmit,
          children: ["Next ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrRight */.jG, {
            width: 24
          })]
        })]
      }), passwordRestoreFlow === 'password' && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LoginModal_module_default()).form,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PasswordInput_PasswordInput, {
          label: 'New Password',
          onBlur: formikPasswordFlowPassword.handleBlur('password'),
          onChange: function onChange(value) {
            return formikPasswordFlowPassword.setFieldValue('password', value);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordInput_PasswordInput, {
          label: 'Confirm Password',
          onBlur: formikPasswordFlowPassword.handleBlur('password1'),
          onChange: function onChange(value) {
            return formikPasswordFlowPassword.setFieldValue('password1', value);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
          className: classnames_default()([(LoginModal_module_default()).login, (LoginModal_module_default()).password]),
          onClick: formikPasswordFlowPassword.handleSubmit,
          children: "Save New Password"
        })]
      })]
    })]
  });
};

/* harmony default export */ var LoginModal_LoginModal = (LoginModal);
// EXTERNAL MODULE: ./components/ui/JoinBackcellModal/JoinBackcellModal.module.scss
var JoinBackcellModal_module = __webpack_require__(30844);
var JoinBackcellModal_module_default = /*#__PURE__*/__webpack_require__.n(JoinBackcellModal_module);
;// CONCATENATED MODULE: ./components/ui/JoinBackcellModal/JoinBackcellModal.js


var JoinBackcellModal_excluded = ["active", "setActive", "join"];

function JoinBackcellModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function JoinBackcellModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { JoinBackcellModal_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { JoinBackcellModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var JoinBackcellModal = function JoinBackcellModal(_ref) {
  var _join$buttons;

  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      join = _ref.join,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, JoinBackcellModal_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal["default"], JoinBackcellModal_objectSpread(JoinBackcellModal_objectSpread({}, restProps), {}, {
    active: active,
    setActive: setActive,
    className: (JoinBackcellModal_module_default()).modal,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: 'title',
      dangerouslySetInnerHTML: {
        __html: join === null || join === void 0 ? void 0 : join.title
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (JoinBackcellModal_module_default()).text,
      children: join === null || join === void 0 ? void 0 : join.description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (JoinBackcellModal_module_default()).form,
      children: (join === null || join === void 0 ? void 0 : (_join$buttons = join.buttons) === null || _join$buttons === void 0 ? void 0 : _join$buttons.length) > 0 && join.buttons.map(function (el) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
          Component: !(el !== null && el !== void 0 && el.external_link) ? 'router' : 'a',
          onClick: function onClick() {
            return setActive(false);
          },
          href: !(el !== null && el !== void 0 && el.external_link) ? el === null || el === void 0 ? void 0 : el.slug : el.external_link,
          variant: 'outline',
          hasTarget: el.external_link && true,
          children: el === null || el === void 0 ? void 0 : el.text
        }, el === null || el === void 0 ? void 0 : el.id);
      })
    })]
  }));
};

/* harmony default export */ var JoinBackcellModal_JoinBackcellModal = (JoinBackcellModal);
// EXTERNAL MODULE: ./components/ui/InformationBlock/InformationBlock.js
var InformationBlock = __webpack_require__(31111);
// EXTERNAL MODULE: ./components/ui/TopUpBalanceModal/TopUpBalanceModal.module.scss
var TopUpBalanceModal_module = __webpack_require__(86401);
var TopUpBalanceModal_module_default = /*#__PURE__*/__webpack_require__.n(TopUpBalanceModal_module);
;// CONCATENATED MODULE: ./components/ui/TopUpBalanceModal/TopUpBalanceModal.js
















var strategy = {
  chooseMethod: 'chooseMethod',
  onlineTopUp: 'onlineTopUp',
  cinKredit: 'cinKredit',
  klassKredit: 'klassKredit',
  moneyTransfer: 'moneyTransfer'
};
var paymentMethodData = [{
  name: 'Banking card',
  value: 'banking-card'
}, {
  name: 'VAT transfer',
  value: 'vat-transfer'
}];
var amountData = [{
  amount: 1
}, {
  amount: 2
}, {
  amount: 3
}];

var TopUpBalanceModal = function TopUpBalanceModal(_ref) {
  var active = _ref.active,
      setActive = _ref.setActive,
      onLogin = _ref.onLogin,
      user = _ref.user;
  var route = (0,next_router.useRouter)();

  var _React$useState = react.useState(strategy.chooseMethod),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      flowStage = _React$useState2[0],
      setFlowStage = _React$useState2[1];

  var _React$useState3 = react.useState(paymentMethodData[0]),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      paymentMethod = _React$useState4[0],
      setPaymentMethodData = _React$useState4[1];

  var _React$useState5 = react.useState(false),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      successModal = _React$useState6[0],
      setSuccessModal = _React$useState6[1];

  var _React$useState7 = react.useState(false),
      _React$useState8 = (0,slicedToArray/* default */.Z)(_React$useState7, 2),
      errorModal = _React$useState8[0],
      setErrorModal = _React$useState8[1];

  var _React$useState9 = react.useState(amountData[1]),
      _React$useState10 = (0,slicedToArray/* default */.Z)(_React$useState9, 2),
      selectAmount = _React$useState10[0],
      setSelectAmount = _React$useState10[1];

  var _React$useState11 = react.useState(false),
      _React$useState12 = (0,slicedToArray/* default */.Z)(_React$useState11, 2),
      isBusiness = _React$useState12[0],
      setIsBusiness = _React$useState12[1];

  react.useEffect(function () {
    var isBusinessPage = route.pathname.startsWith('/business');
    setIsBusiness(isBusinessPage);
  }, [route.pathname]);

  var onApply = function onApply() {
    setActive(false);
    setSuccessModal(true);
    setFlowStage(strategy.chooseMethod);
  };

  var onError = function onError() {
    setActive(false);
    setErrorModal(true);
    setFlowStage(strategy.chooseMethod);
  };

  var selectType = function selectType(type) {
    return function () {
      setFlowStage(type);
    };
  };

  var onClose = function onClose(value) {
    setActive(value);
    setTimeout(function () {
      setFlowStage(strategy.chooseMethod);
    }, 300);
  };

  var renderAmount = function renderAmount(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      "aria-label": item.amount,
      onClick: function onClick() {
        return setSelectAmount(item);
      },
      className: classnames_default()([(TopUpBalanceModal_module_default()).amount, (0,defineProperty/* default */.Z)({}, (TopUpBalanceModal_module_default()).amountSelect, item.amount === selectAmount.amount)]),
      children: [item.amount, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CurrencyBig */.Xt, {})]
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Modal["default"], {
      active: active,
      setActive: onClose,
      classNameInner: (TopUpBalanceModal_module_default()).modalInner,
      itemScope: true,
      itemType: "http://schema.org/Property",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TopUpBalanceModal_module_default()).modalContent,
        children: [flowStage === strategy.chooseMethod && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: 'title',
            children: "Top-up your balance"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()([(TopUpBalanceModal_module_default()).content, (0,defineProperty/* default */.Z)({}, (TopUpBalanceModal_module_default()).contentUser, !!user)]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
              variant: 'outline',
              onClick: function onClick() {
                return setFlowStage(strategy.onlineTopUp);
              },
              children: "Online top-up"
            }), !user && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (TopUpBalanceModal_module_default()).separation,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (TopUpBalanceModal_module_default()).text,
                children: ["Available after", /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  "aria-label": "Sign In",
                  className: (TopUpBalanceModal_module_default()).button,
                  onClick: onLogin,
                  children: "Sign In"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (TopUpBalanceModal_module_default()).actions,
              children: [!isBusiness && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                  variant: user ? 'outline' : 'blocked',
                  className: (TopUpBalanceModal_module_default()).action,
                  onClick: user ? selectType(strategy.cinKredit) : onLogin,
                  children: [!user && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Lock */.HE, {}), "CINKredit"]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                  variant: user ? 'outline' : 'blocked',
                  className: (TopUpBalanceModal_module_default()).action,
                  onClick: user ? selectType(strategy.klassKredit) : onLogin,
                  children: [!user && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Lock */.HE, {}), "KlassKredit"]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                variant: user ? 'outline' : 'blocked',
                className: (TopUpBalanceModal_module_default()).action,
                onClick: user ? selectType(strategy.moneyTransfer) : onLogin,
                children: [!user && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Lock */.HE, {}), "Money transfer"]
              })]
            })]
          })]
        }), flowStage === strategy.onlineTopUp && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
              "aria-label": "Back",
              onClick: function onClick() {
                return setFlowStage(strategy.chooseMethod);
              },
              className: (TopUpBalanceModal_module_default()).goBack,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
                width: 22
              }), " Back"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: 'title',
            children: "Online top-up"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (TopUpBalanceModal_module_default()).contentOnlinePayment,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (TopUpBalanceModal_module_default()).first,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
                className: (TopUpBalanceModal_module_default()).phone,
                label: 'Phone number',
                placeholderMask: '+994',
                placeholder: '+994 (XXX) XXX XX-XX',
                mask: '+\\9\\9\\4-999-999-99-99',
                type: "tel"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
                label: 'Amount',
                placeholder: '5 AZN'
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (TopUpBalanceModal_module_default()).second,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
                value: paymentMethod,
                data: paymentMethodData,
                label: 'Payment method',
                onChange: setPaymentMethodData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (TopUpBalanceModal_module_default()).third,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
                label: 'Card number',
                placeholder: 'XXXX XXXX XXXX XXXX',
                mask: '9999 9999 9999 9999',
                type: "number"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
                label: 'Expiry date',
                placeholder: 'MM/YY',
                mask: '99/99',
                IconRight: SvgComponents/* Calendar */.f
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
                label: 'CVC/CVV',
                placeholder: '•••',
                mask: '999'
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                onClick: onApply,
                children: "Pay now"
              })
            })]
          })]
        }), flowStage === strategy.cinKredit && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
              "aria-label": "Back",
              onClick: function onClick() {
                return setFlowStage(strategy.chooseMethod);
              },
              className: (TopUpBalanceModal_module_default()).goBack,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
                width: 22
              }), " Back"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: 'title',
            children: "CinKredit"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (TopUpBalanceModal_module_default()).contentCinKredit,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (TopUpBalanceModal_module_default()).banner,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (TopUpBalanceModal_module_default()).price,
                children: ["1 ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Currency */.F, {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
                className: (TopUpBalanceModal_module_default()).text,
                children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus et sagittis neque, magna quis mattis diam in aliquam."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (TopUpBalanceModal_module_default()).warning,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (TopUpBalanceModal_module_default()).icon,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Warning */.v3, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (TopUpBalanceModal_module_default()).text,
                children: ["Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non Nemo enim", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (TopUpBalanceModal_module_default()).red,
                  children: "fee 0.2\u20BC"
                }), " voluptatem quia voluptas sit"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                onClick: onError,
                children: "Get it now"
              })
            })]
          })]
        }), flowStage === strategy.klassKredit && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
              "aria-label": "Back",
              onClick: function onClick() {
                return setFlowStage(strategy.chooseMethod);
              },
              className: (TopUpBalanceModal_module_default()).goBack,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
                width: 22
              }), " Back"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: 'title',
            children: "KlassKredit"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (TopUpBalanceModal_module_default()).klassKreditInfo,
            children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus et sagittis neque, magna quis mattis diam in aliquam."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (TopUpBalanceModal_module_default()).contentKlassKreditInfo,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (TopUpBalanceModal_module_default()).amountTitle,
              children: "Amount"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (TopUpBalanceModal_module_default()).amounts,
              children: amountData.map(renderAmount)
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (TopUpBalanceModal_module_default()).warning,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (TopUpBalanceModal_module_default()).icon,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Warning */.v3, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (TopUpBalanceModal_module_default()).text,
                children: ["Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non Nemo enim", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (TopUpBalanceModal_module_default()).red,
                  children: "fee 0.2\u20BC"
                }), " voluptatem quia voluptas sit"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                onClick: onApply,
                children: "Get it now"
              })
            })]
          })]
        }), flowStage === strategy.moneyTransfer && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
              onClick: function onClick() {
                return setFlowStage(strategy.chooseMethod);
              },
              className: (TopUpBalanceModal_module_default()).goBack,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
                width: 22
              }), " Back"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: 'title',
            children: "Money transfer"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (TopUpBalanceModal_module_default()).contentKlassKreditInfo,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (TopUpBalanceModal_module_default()).contentOnlinePayment,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (TopUpBalanceModal_module_default()).first,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
                  className: (TopUpBalanceModal_module_default()).phone,
                  label: 'Phone number',
                  placeholderMask: '+994',
                  placeholder: '+994 (XXX) XXX XX-XX',
                  mask: '+\\9\\9\\4-999-999-99-99',
                  type: "tel"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (TopUpBalanceModal_module_default()).banner,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (TopUpBalanceModal_module_default()).price,
                children: ["0.2 ", /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Currency */.F, {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextBlock_TextBlock/* default */.Z, {
                className: (TopUpBalanceModal_module_default()).text,
                children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus et sagittis neque, magna quis mattis diam in aliquam."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (TopUpBalanceModal_module_default()).warning,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (TopUpBalanceModal_module_default()).icon,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Warning */.v3, {})
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (TopUpBalanceModal_module_default()).text,
                children: ["Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non Nemo enim", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (TopUpBalanceModal_module_default()).red,
                  children: "fee 0.2\u20BC"
                }), " voluptatem quia voluptas sit"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                onClick: onApply,
                children: "Submit"
              })
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(InformationModal/* default */.Z, {
      onClose: function onClose() {
        return setErrorModal(false);
      },
      active: errorModal,
      title: 'Error',
      description: "You don't have enough money to pay the fee",
      Icon: SvgComponents/* CloseCircle */.Pb
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(InformationModal/* default */.Z, {
      title: 'Success',
      description: 'Online payment was successfully received',
      active: successModal,
      onClose: function onClose() {
        return setSuccessModal(false);
      }
    })]
  });
};

/* harmony default export */ var TopUpBalanceModal_TopUpBalanceModal = (TopUpBalanceModal);
// EXTERNAL MODULE: ./components/ui/CoverageMap/CoverageMap.js
var CoverageMap = __webpack_require__(28053);
// EXTERNAL MODULE: ./components/ui/CallBlock/CallBlock.module.scss
var CallBlock_module = __webpack_require__(64866);
var CallBlock_module_default = /*#__PURE__*/__webpack_require__.n(CallBlock_module);
;// CONCATENATED MODULE: ./components/ui/CallBlock/CallBlock.js





var CallBlock = function CallBlock() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (CallBlock_module_default()).container,
    itemScope: true,
    itemType: "https://schema.org/ContactPoint",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CallBlock_module_default()).item,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CallBlock_module_default()).title,
        children: "To call Bakcell number dial"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CallBlock_module_default()).numbers,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
          className: (CallBlock_module_default()).call,
          dark: true,
          numbers: '*135*',
          isNotLink: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (CallBlock_module_default()).number,
          children: "055 XXX XX XX"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
          className: (CallBlock_module_default()).call,
          dark: true,
          isNotLink: true,
          isTel: true,
          numbers: '#'
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CallBlock_module_default()).item,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CallBlock_module_default()).title,
        children: "To call other operators or city numbers in Azerbaijan dial"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CallBlock_module_default()).numbers,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
          className: (CallBlock_module_default()).call,
          dark: true,
          numbers: '*135*',
          isNotLink: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (CallBlock_module_default()).number,
          children: "Operator or city code"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (CallBlock_module_default()).number,
          children: "055 XXX XX XX"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
          className: (CallBlock_module_default()).call,
          dark: true,
          isNotLink: true,
          isTel: true,
          numbers: '#'
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CallBlock_module_default()).item,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CallBlock_module_default()).title,
        children: "To call international numbers dial"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CallBlock_module_default()).numbers,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
          className: (CallBlock_module_default()).call,
          dark: true,
          numbers: '*135*',
          isNotLink: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (CallBlock_module_default()).number,
          children: "country code"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (CallBlock_module_default()).number,
          children: "operator or city code"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (CallBlock_module_default()).number,
          children: "055 XXX XX XX"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui_LinkNumbers_LinkNumbers, {
          className: (CallBlock_module_default()).call,
          dark: true,
          isNotLink: true,
          isTel: true,
          numbers: '#'
        })]
      })]
    })]
  });
};

/* harmony default export */ var CallBlock_CallBlock = (CallBlock);
;// CONCATENATED MODULE: ./components/ui/ImageMask/ImageMask.js






var ImageMask = function ImageMask(_ref) {
  var children = _ref.children,
      className = _ref.className,
      desktop = _ref.desktop,
      mobile = _ref.mobile;

  var _useWindowSize = useWindowSize(),
      _useWindowSize2 = _slicedToArray(_useWindowSize, 1),
      x = _useWindowSize2[0];

  var maskImage = {
    desktop: "url(".concat(desktop || '/assets/image-masks/big-star-2.png', ")"),
    mobile: "url(".concat(mobile || '/assets/image-masks/big-star.png', ")")
  };
  return /*#__PURE__*/_jsx("div", {
    style: {
      WebkitMaskImage: x > 1024 ? maskImage.desktop : maskImage.mobile,
      maskImage: x > 1024 ? maskImage.desktop : maskImage.mobile
    },
    className: classNames([styles.mask, className]),
    itemScope: true,
    itemType: "http://schema.org/ImageObject",
    children: children
  });
};

/* harmony default export */ var ImageMask_ImageMask = ((/* unused pure expression or super */ null && (ImageMask)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(52210);
// EXTERNAL MODULE: ./constants/cabinet.js + 3 modules
var constants_cabinet = __webpack_require__(54861);
// EXTERNAL MODULE: ./utils/languageFormat.js
var languageFormat = __webpack_require__(16955);
// EXTERNAL MODULE: ./hooks/useCabinetMenu.js
var useCabinetMenu = __webpack_require__(45204);
// EXTERNAL MODULE: ./components/SvgComponents/NewDropdownCard.js
var NewDropdownCard = __webpack_require__(32378);
// EXTERNAL MODULE: ./utils/formatPhoneNumberNew.js
var formatPhoneNumberNew = __webpack_require__(32238);
// EXTERNAL MODULE: ./utils/generateInitialToken.js
var generateInitialToken = __webpack_require__(3937);
// EXTERNAL MODULE: ./domains/cabinet/slice.js
var slice = __webpack_require__(63797);
// EXTERNAL MODULE: ./components/ui/Dropdown/Dropdown.module.scss
var Dropdown_module = __webpack_require__(67886);
var Dropdown_module_default = /*#__PURE__*/__webpack_require__.n(Dropdown_module);
;// CONCATENATED MODULE: ./components/ui/Dropdown/Dropdown.js























var Dropdown = function Dropdown(_ref) {
  var label = _ref.label,
      className = _ref.className;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var dispatch = (0,es/* useDispatch */.I0)();
  var formattedLang = (0,languageFormat/* langFormatter */.u)({
    lang: lang
  });

  var _cabinetHooks$useGetA = cabinet/* hooks.useGetAccountsQuery */.PT.useGetAccountsQuery({
    lang: formattedLang
  }),
      accounts = _cabinetHooks$useGetA.data;

  var _cabinetHooks$useSeco = cabinet/* hooks.useSecondarySubscriberCheck */.PT.useSecondarySubscriberCheck(),
      _cabinetHooks$useSeco2 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useSeco, 1),
      subscribeTrigger = _cabinetHooks$useSeco2[0];

  var toggleDropdown = function toggleDropdown() {
    setIsOpen(!isOpen);
  };

  var signInHandler = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var _data$phone, _data$phone2;

      var phoneNumber, initialToken;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              phoneNumber = "994".concat(data === null || data === void 0 ? void 0 : (_data$phone = data.phone) === null || _data$phone === void 0 ? void 0 : _data$phone.number);
              initialToken = (0,generateInitialToken/* default */.Z)(phoneNumber, (0,v4/* default */.Z)());
              dispatch(slice/* actions.setInitialToken */.N.setInitialToken(initialToken));
              sessionStorage.setItem('initialToken', initialToken);
              _context.next = 6;
              return subscribeTrigger({
                msisdn: phoneNumber,
                lang: formattedLang,
                initialToken: initialToken
              }).unwrap();

            case 6:
              setActiveAddAccount(true);
              dispatch(slice/* actions.setAdditionalNumber */.N.setAdditionalNumber(data === null || data === void 0 ? void 0 : (_data$phone2 = data.phone) === null || _data$phone2 === void 0 ? void 0 : _data$phone2.number));
              dispatch(slice/* actions.setSignInModal */.N.setSignInModal(true));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function signInHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useCabinetMenu = (0,useCabinetMenu/* useCabinetMenu */.K)(),
      setActiveAddAccount = _useCabinetMenu.setActiveAddAccount;

  var selectOption = function selectOption(id) {
    if ( true && sessionStorage.getItem('refreshToken') && sessionStorage.getItem('accountId') && (accounts === null || accounts === void 0 ? void 0 : accounts.find(function (el) {
      return (el === null || el === void 0 ? void 0 : el.id) === id;
    }).numberStatus) === 'ACTIVE') {
      sessionStorage.setItem('accountId', id);
      dispatch(cabinet/* actions.setSelectedAccountId */.Nw.setSelectedAccountId(id));
      setIsOpen(false);
    }

    if ( true && sessionStorage.getItem('refreshToken') && sessionStorage.getItem('accountId') && (accounts === null || accounts === void 0 ? void 0 : accounts.find(function (el) {
      return (el === null || el === void 0 ? void 0 : el.id) === id;
    }).numberStatus) === 'DEACTIVE') {
      signInHandler(accounts === null || accounts === void 0 ? void 0 : accounts.find(function (el) {
        return (el === null || el === void 0 ? void 0 : el.id) === id;
      }));
    }
  };

  var openAddAcount = function openAddAcount() {
    setIsOpen(false);
    setActiveAddAccount(true);
  };

  var _useSelector = (0,es/* useSelector */.v9)(cabinet/* selectors.selectCabinet */.wl.O),
      selectedAccountId = _useSelector.selectedAccountId;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(Dropdown_module_default()).dropdown_container, className]),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      "aria-label": label,
      className: (Dropdown_module_default()).toggle,
      onClick: toggleDropdown,
      children: ["".concat(label, " ").concat(accounts === null || accounts === void 0 ? void 0 : accounts.length), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Arrow */.Eh, {
        width: 16
      })]
    }), isOpen && /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      className: (Dropdown_module_default()).list,
      children: [accounts === null || accounts === void 0 ? void 0 : accounts.map(function (option) {
        var _option$phone;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: classnames_default()((0,defineProperty/* default */.Z)({}, (Dropdown_module_default()).disabled, (option === null || option === void 0 ? void 0 : option.numberStatus) === 'DEACTIVE')),
          onClick: function onClick() {
            return selectOption(option === null || option === void 0 ? void 0 : option.id);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Dropdown_module_default()).detail_box,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: constants_cabinet/* statusInfoMap */.e3[(option === null || option === void 0 ? void 0 : option.numberStatus) !== 'DEACTIVE' ? option === null || option === void 0 ? void 0 : option.status : option === null || option === void 0 ? void 0 : option.numberStatus]["class"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewDropdownCard/* NewDropdownCard */.q, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (Dropdown_module_default()).number_detail,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h5", {
                className: classnames_default()((Dropdown_module_default()).number, {
                  disabled: (option === null || option === void 0 ? void 0 : option.numberStatus) === 'DEACTIVE'
                }),
                children: [(0,formatPhoneNumberNew/* default */.Z)(option === null || option === void 0 ? void 0 : (_option$phone = option.phone) === null || _option$phone === void 0 ? void 0 : _option$phone.number), (option === null || option === void 0 ? void 0 : option.isPrimary) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (Dropdown_module_default()).label,
                  children: t('cabinet:main')
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: classnames_default()([(Dropdown_module_default()).status, constants_cabinet/* statusInfoMap */.e3[(option === null || option === void 0 ? void 0 : option.numberStatus) === 'ACTIVE' ? option === null || option === void 0 ? void 0 : option.status : option === null || option === void 0 ? void 0 : option.numberStatus]["class"]]),
                children: t("cabinet:".concat(constants_cabinet/* statusInfoMap */.e3[(option === null || option === void 0 ? void 0 : option.numberStatus) === 'ACTIVE' ? option === null || option === void 0 ? void 0 : option.status : option === null || option === void 0 ? void 0 : option.numberStatus].text))
              }), (option === null || option === void 0 ? void 0 : option.status) === 'ACTIVE' && (option === null || option === void 0 ? void 0 : option.numberStatus) === 'ACTIVE' && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (Dropdown_module_default()).balance,
                children: ["\u2022 ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [option === null || option === void 0 ? void 0 : option.balance, " "]
                }), "azn"]
              })]
            })]
          }), (option === null || option === void 0 ? void 0 : option.id) === Number(selectedAccountId) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/assets/checkMark.svg",
            width: 15,
            height: 10,
            alt: "checkmark icon",
            title: "checkmark icon"
          })]
        }, option === null || option === void 0 ? void 0 : option.id);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        onClick: openAddAcount,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Dropdown_module_default()).detail_box,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* PlusPrimary */.KV, {
            className: (Dropdown_module_default()).add_icon
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (Dropdown_module_default()).add_new,
            children: t('cabinet:accounts.AddNewNumber')
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var Dropdown_Dropdown = (Dropdown);
// EXTERNAL MODULE: ./components/ui/WhoWeAre/WhoWeAre.module.scss
var WhoWeAre_module = __webpack_require__(10812);
var WhoWeAre_module_default = /*#__PURE__*/__webpack_require__.n(WhoWeAre_module);
;// CONCATENATED MODULE: ./components/ui/WhoWeAre/WhoWeAre.js






var WhoWeAre = function WhoWeAre(_ref) {
  var _data$title;

  var data = _ref.data;
  var scrollRef = (0,react.useRef)(null);

  var handleScroll = function handleScroll() {
    if (scrollRef.current) {
      document.body.scrollTop = 800;
      document.documentElement.scrollTop = 800;
    }
  };

  var renderTitle = function renderTitle(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (WhoWeAre_module_default()).text_item,
      children: item
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (WhoWeAre_module_default()).who_we_are,
    ref: scrollRef,
    itemScope: true,
    itemType: "http://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (WhoWeAre_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (WhoWeAre_module_default()).decorated_title,
        children: data === null || data === void 0 ? void 0 : (_data$title = data.title) === null || _data$title === void 0 ? void 0 : _data$title.map(renderTitle)
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (WhoWeAre_module_default()).imageWrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: data === null || data === void 0 ? void 0 : data.image,
          alt: "banner image",
          width: 1130,
          height: 646
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (WhoWeAre_module_default()).btn_box,
          onClick: function onClick() {
            return handleScroll();
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Explore */.r3, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: data === null || data === void 0 ? void 0 : data.button_text
          })]
        })]
      })]
    })
  });
};
/* harmony default export */ var WhoWeAre_WhoWeAre = (WhoWeAre);
// EXTERNAL MODULE: ./components/ui/FullBanner/FullBanner.module.scss
var FullBanner_module = __webpack_require__(85258);
var FullBanner_module_default = /*#__PURE__*/__webpack_require__.n(FullBanner_module);
;// CONCATENATED MODULE: ./components/ui/FullBanner/FullBanner.js





var FullBanner = function FullBanner(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (FullBanner_module_default()).full_banner_wrapper,
    style: {
      backgroundImage: "url(".concat(data === null || data === void 0 ? void 0 : data.image, ")")
    },
    role: "banner",
    itemScope: true,
    itemType: "http://schema.org/Offer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FullBanner_module_default()).content,
      children: [(data === null || data === void 0 ? void 0 : data.top_text) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (FullBanner_module_default()).top_text,
        children: data.top_text
      }), (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
        className: (FullBanner_module_default()).title,
        children: [" ", data.title]
      }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: (FullBanner_module_default()).description,
        children: [" ", data.description]
      }), (data === null || data === void 0 ? void 0 : data.button_text) && (data === null || data === void 0 ? void 0 : data.button_slug) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        Component: 'router',
        href: data === null || data === void 0 ? void 0 : data.button_slug,
        className: (FullBanner_module_default()).content_btn,
        children: data === null || data === void 0 ? void 0 : data.button_text
      })]
    })
  });
};

/* harmony default export */ var FullBanner_FullBanner = (FullBanner);
// EXTERNAL MODULE: ./domains/view/index.js + 2 modules
var view = __webpack_require__(97201);
// EXTERNAL MODULE: ./hooks/usePagination.js
var usePagination = __webpack_require__(27577);
// EXTERNAL MODULE: ./components/404/NotFoundPage/NotFoundPage.js
var NotFoundPage = __webpack_require__(33920);
;// CONCATENATED MODULE: ./constants/search.js
var searchNotFoundData = {
  title: 'common:emptySearchTitle',
  description: 'common:emptySearchDescription',
  icon: '/assets/error-icon.svg'
};
// EXTERNAL MODULE: ./components/ui/SearchList/SearchList.module.scss
var SearchList_module = __webpack_require__(43175);
var SearchList_module_default = /*#__PURE__*/__webpack_require__.n(SearchList_module);
;// CONCATENATED MODULE: ./components/ui/SearchList/SearchList.js



function SearchList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SearchList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SearchList_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SearchList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var SearchList = function SearchList() {
  var _searchList$data, _searchList$data2, _searchList$data3;

  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var itemsPerPage = 12;

  var _viewHooks$useSearchC = view/* hooks.useSearchContent */.PT.useSearchContent({
    q: router.query.q,
    type: router.query.type,
    lang: lang
  }),
      searchList = _viewHooks$useSearchC.data;

  var _usePaginatedData = (0,usePagination/* default */.Z)(searchList === null || searchList === void 0 ? void 0 : searchList.data, itemsPerPage),
      slicedData = _usePaginatedData.slicedData;

  var redirectToSlug = function redirectToSlug(item) {
    return router.push(item === null || item === void 0 ? void 0 : item.slug);
  };

  var renderList = function renderList(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SearchList_module_default()).list_item,
      itemScope: true,
      itemType: "https://schema.org/ListItem",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", SearchList_objectSpread(SearchList_objectSpread({
          className: (SearchList_module_default()).list_item__title
        }, windowsX < 768 && {
          onClick: function onClick() {
            return redirectToSlug(item);
          }
        }), {}, {
          children: item === null || item === void 0 ? void 0 : item.title
        })), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          dangerouslySetInnerHTML: {
            __html: item === null || item === void 0 ? void 0 : item.description
          },
          className: (SearchList_module_default()).list_item__desc
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs, {
          className: (SearchList_module_default()).search_breadcrumbs,
          data: item === null || item === void 0 ? void 0 : item.breadcrumbs
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SearchList_module_default()).arrow,
        onClick: function onClick() {
          return redirectToSlug(item);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowRight */.ol, {
          width: 24
        })
      })]
    }, index);
  };

  return (searchList === null || searchList === void 0 ? void 0 : (_searchList$data = searchList.data) === null || _searchList$data === void 0 ? void 0 : _searchList$data.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SearchList_module_default()).search_wrapper,
    itemScope: true,
    itemType: "https://schema.org/SearchResultsPage",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_SectionTitle/* default */.Z, {
      titleModify: "title--large",
      children: t('common:SearchResult', {
        searchText: router.query.q,
        count: searchList === null || searchList === void 0 ? void 0 : (_searchList$data2 = searchList.data) === null || _searchList$data2 === void 0 ? void 0 : _searchList$data2.length
      })
    }), slicedData === null || slicedData === void 0 ? void 0 : slicedData.map(renderList), /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination_Pagination, {
      perpage: itemsPerPage,
      total: searchList === null || searchList === void 0 ? void 0 : (_searchList$data3 = searchList.data) === null || _searchList$data3 === void 0 ? void 0 : _searchList$data3.length
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NotFoundPage/* default */.Z, {
    data: searchNotFoundData,
    withTranslate: true,
    customIcon: true
  });
};

/* harmony default export */ var SearchList_SearchList = (SearchList);
;// CONCATENATED MODULE: ./hooks/useTextSplitter.js


var useTextSplitter = function useTextSplitter(initialText) {
  var _useState = (0,react.useState)([]),
      text = _useState[0],
      setText = _useState[1];

  (0,react.useEffect)(function () {
    if (initialText) {
      var newText = initialText.split('\r\n');
      setText(newText);
    }
  }, [initialText]);
  return text;
};

/* harmony default export */ var hooks_useTextSplitter = (useTextSplitter);
// EXTERNAL MODULE: ./components/ui/TitledBanner/TitledBanner.module.scss
var TitledBanner_module = __webpack_require__(14733);
var TitledBanner_module_default = /*#__PURE__*/__webpack_require__.n(TitledBanner_module);
;// CONCATENATED MODULE: ./components/ui/TitledBanner/TitledBanner.js






var TitledBanner = function TitledBanner(_ref) {
  var _useTextSplitter;

  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (TitledBanner_module_default()).titled_banner,
    style: {
      background: "url(".concat(data === null || data === void 0 ? void 0 : data.image, ") no-repeat 72%/cover var(--color-band-800)")
    },
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (TitledBanner_module_default()).content_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (TitledBanner_module_default()).title,
        children: data === null || data === void 0 ? void 0 : data.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (TitledBanner_module_default()).description,
        children: (_useTextSplitter = hooks_useTextSplitter(data === null || data === void 0 ? void 0 : data.text)) === null || _useTextSplitter === void 0 ? void 0 : _useTextSplitter.map(function (des, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (TitledBanner_module_default()).containers,
            children: des === null || des === void 0 ? void 0 : des.trim()
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var TitledBanner_TitledBanner = (TitledBanner);
// EXTERNAL MODULE: ./components/ui/ProductsSectionFiber/ProductsSectionFiber.module.scss
var ProductsSectionFiber_module = __webpack_require__(35126);
var ProductsSectionFiber_module_default = /*#__PURE__*/__webpack_require__.n(ProductsSectionFiber_module);
;// CONCATENATED MODULE: ./components/ui/ProductsSectionFiber/ProductsSectionFiber.js






var ProductsSectionFiber = function ProductsSectionFiber(_ref) {
  var _data$title, _data$devices;

  var data = _ref.data;
  var text = data === null || data === void 0 ? void 0 : (_data$title = data.title) === null || _data$title === void 0 ? void 0 : _data$title.split(' ');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "wrapper",
    itemScope: true,
    itemType: "https://schema.org/Product",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductsSectionFiber_module_default()).inner_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductsSectionFiber_module_default()).top_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ProductsSectionFiber_module_default()).title_container,
          children: text === null || text === void 0 ? void 0 : text.map(function (des, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (ProductsSectionFiber_module_default()).titles,
              children: des === null || des === void 0 ? void 0 : des.trim()
            }, index);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (ProductsSectionFiber_module_default()).info_text,
          children: data === null || data === void 0 ? void 0 : data.description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ProductsSectionFiber_module_default()).bottom_wrapper,
        children: data === null || data === void 0 ? void 0 : (_data$devices = data.devices) === null || _data$devices === void 0 ? void 0 : _data$devices.map(function (product) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (ProductsSectionFiber_module_default()).product_container,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (ProductsSectionFiber_module_default()).product_name,
              children: product === null || product === void 0 ? void 0 : product.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: product === null || product === void 0 ? void 0 : product.image,
              alt: product === null || product === void 0 ? void 0 : product.title,
              title: product === null || product === void 0 ? void 0 : product.title,
              width: 332,
              height: 336,
              className: (ProductsSectionFiber_module_default()).img
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (ProductsSectionFiber_module_default()).description,
              children: product === null || product === void 0 ? void 0 : product.description
            })]
          }, product === null || product === void 0 ? void 0 : product.id);
        })
      })]
    })
  });
};

/* harmony default export */ var ProductsSectionFiber_ProductsSectionFiber = (ProductsSectionFiber);
// EXTERNAL MODULE: ./components/ui/StepsWithImage/index.module.scss
var StepsWithImage_index_module = __webpack_require__(51950);
var index_module_default = /*#__PURE__*/__webpack_require__.n(StepsWithImage_index_module);
;// CONCATENATED MODULE: ./components/ui/StepsWithImage/index.tsx








var StepsWithImage = function StepsWithImage(_ref) {
  var _data$steps;

  var data = _ref.data;

  var _useState = (0,react.useState)(data === null || data === void 0 ? void 0 : data.steps[0]),
      activeStep = _useState[0],
      setActiveStep = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "wrapper ".concat((index_module_default()).stepsWrapper),
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (index_module_default()).mobileTitle,
      children: data === null || data === void 0 ? void 0 : data.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).imageWrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: activeStep === null || activeStep === void 0 ? void 0 : activeStep.image,
        layout: "responsive",
        width: 670,
        height: 670,
        alt: "step image"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (index_module_default()).stepsContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).steps,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: data === null || data === void 0 ? void 0 : data.title
        }), data === null || data === void 0 ? void 0 : (_data$steps = data.steps) === null || _data$steps === void 0 ? void 0 : _data$steps.map(function (step, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onMouseEnter: function onMouseEnter() {
              setActiveStep(step);
            },
            className: classnames_default()((index_module_default()).stepItem, (0,defineProperty/* default */.Z)({}, (index_module_default()).active, (step === null || step === void 0 ? void 0 : step.title) === (activeStep === null || activeStep === void 0 ? void 0 : activeStep.title))),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (index_module_default()).left,
              children: index + 1
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (index_module_default()).right,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (index_module_default()).title,
                children: step.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: (index_module_default()).description,
                children: step.description
              })]
            })]
          }, step === null || step === void 0 ? void 0 : step.title);
        })]
      })
    })]
  });
};

/* harmony default export */ var ui_StepsWithImage = (StepsWithImage);
// EXTERNAL MODULE: ./components/ui/RightImageBanner/RightImageBanner.module.scss
var RightImageBanner_module = __webpack_require__(62172);
var RightImageBanner_module_default = /*#__PURE__*/__webpack_require__.n(RightImageBanner_module);
;// CONCATENATED MODULE: ./components/ui/RightImageBanner/RightImageBanner.js








var RightImageBanner = function RightImageBanner(_ref) {
  var data = _ref.data;

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (RightImageBanner_module_default()).rightImage_banner__wrapper,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (RightImageBanner_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (RightImageBanner_module_default()).label,
          children: data === null || data === void 0 ? void 0 : data.top_text
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (RightImageBanner_module_default()).title,
          children: data === null || data === void 0 ? void 0 : data.title
        }), (data === null || data === void 0 ? void 0 : data.button_text) && ((data === null || data === void 0 ? void 0 : data.button_slug) || (data === null || data === void 0 ? void 0 : data.external_link)) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
          size: "shortTrapezoid",
          variant: "trapezoidRed",
          href: data !== null && data !== void 0 && data.button_slug ? data === null || data === void 0 ? void 0 : data.button_slug : data === null || data === void 0 ? void 0 : data.external_link,
          Component: data !== null && data !== void 0 && data.button_slug ? 'router' : 'button',
          className: (RightImageBanner_module_default()).btn,
          "aria-label": data === null || data === void 0 ? void 0 : data.button_text,
          children: data === null || data === void 0 ? void 0 : data.button_text
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (RightImageBanner_module_default()).rightImage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: windowsX > 767 ? data === null || data === void 0 ? void 0 : data.image : data === null || data === void 0 ? void 0 : data.mobile_image,
          width: 1068,
          height: 600,
          objectFit: "cover",
          alt: "banner right image"
        })
      })]
    })
  });
};

/* harmony default export */ var RightImageBanner_RightImageBanner = (RightImageBanner);
;// CONCATENATED MODULE: ./utils/generateTimeSlots.js

var generateTimeSlots = function generateTimeSlots() {
  var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '10:00';
  var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '18:00';
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;
  var optionsHours = [];

  var _startTime$split$map = startTime.split(':').map(Number),
      _startTime$split$map2 = (0,slicedToArray/* default */.Z)(_startTime$split$map, 2),
      hours = _startTime$split$map2[0],
      minutes = _startTime$split$map2[1];

  var _endTime$split$map = endTime.split(':').map(Number),
      _endTime$split$map2 = (0,slicedToArray/* default */.Z)(_endTime$split$map, 2),
      endHours = _endTime$split$map2[0],
      endMinutes = _endTime$split$map2[1];

  while (hours < endHours || hours === endHours && minutes < endMinutes) {
    var start = "".concat(hours.toString().padStart(2, '0'), ":").concat(minutes.toString().padStart(2, '0'));
    minutes += interval;

    if (minutes >= 60) {
      hours += 1;
      minutes %= 60;
    }

    var end = "".concat(hours.toString().padStart(2, '0'), ":").concat(minutes.toString().padStart(2, '0'));
    optionsHours.push("".concat(start, " - ").concat(end));
  }

  return optionsHours;
};
// EXTERNAL MODULE: ./constants/newsFilter.js
var newsFilter = __webpack_require__(79639);
;// CONCATENATED MODULE: ./hooks/useGetWorkDays.js





var useWorkDays = function useWorkDays() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var newsFilterData = (0,newsFilter/* default */.Z)();
  var monthOptions = newsFilterData.find(function (filter) {
    return filter.name === 'month';
  }).options;
  var workDays = (0,react.useMemo)(function () {
    var today = new Date();
    return Array.from({
      length: count * 2
    }).reduce(function (days, _, i) {
      var date = new Date(today);
      date.setDate(today.getDate() + i);
      var day = date.getDay();

      if (day >= 1 && day <= 5 && days.length < count) {
        var _monthOptions$find;

        var monthNumber = date.getMonth() + 1;
        var monthName = (_monthOptions$find = monthOptions.find(function (option) {
          return option.value === monthNumber.toString();
        })) === null || _monthOptions$find === void 0 ? void 0 : _monthOptions$find.name;
        var translatedMonthName = t(monthName) || monthName;
        var formattedDate = "".concat(date.getDate().toString().padStart(2, '0'), " ").concat(translatedMonthName);
        days.push("".concat(formattedDate, ", ").concat(base/* daysOfWeek */.en[lang || 'az'][day]));
      }

      return days;
    }, []);
  }, [count, t, lang]);
  return workDays;
};

/* harmony default export */ var useGetWorkDays = (useWorkDays);
// EXTERNAL MODULE: ./components/ui/SelectDateTime/index.module.scss
var SelectDateTime_index_module = __webpack_require__(85691);
var SelectDateTime_index_module_default = /*#__PURE__*/__webpack_require__.n(SelectDateTime_index_module);
;// CONCATENATED MODULE: ./components/ui/SelectDateTime/index.js













var SelectDateTime = function SelectDateTime(_ref) {
  var _classNames;

  var formik = _ref.formik;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(''),
      selectedDate = _useState[0],
      setSelectedDate = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isDateDropdownOpen = _useState2[0],
      setIsDateDropdownOpen = _useState2[1];

  var dateDropdownRef = (0,react.useRef)(null);

  var _useState3 = (0,react.useState)(''),
      selectedHour = _useState3[0],
      setSelectedHour = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isHourDropdownOpen = _useState4[0],
      setIsHourDropdownOpen = _useState4[1];

  var hourDropdownRef = (0,react.useRef)(null);
  var isDateDropdownDisabled = !formik.values.pickup_point_id && !formik.values.address_coordinates.address;

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return state.miniMarket;
  }),
      selectedBranchId = _useSelector.selectedBranch;

  var optionsDate = useGetWorkDays();
  var optionsHours = generateTimeSlots('10:00', '18:00', 15);
  (0,react.useEffect)(function () {
    setSelectedDate(formik.values.dateType || t('numbersale:checkout.selectDate'));
    setSelectedHour(formik.values.hourType || t('numbersale:checkout.selectHour'));
  }, [formik.values.dateType, formik.values.hourType, t]);

  var handleDateOptionClick = function handleDateOptionClick(option) {
    setSelectedDate(option);
    formik.setFieldValue('dateType', option);
    setIsDateDropdownOpen(false);
  };

  var handleHourOptionClick = function handleHourOptionClick(option) {
    setSelectedHour(option);
    formik.setFieldValue('hourType', option);
    setIsHourDropdownOpen(false);
  };

  var handleDateSelectClick = function handleDateSelectClick() {
    if (!isDateDropdownDisabled) {
      setIsDateDropdownOpen(function (prev) {
        return !prev;
      });
    }
  };

  var handleHourSelectClick = function handleHourSelectClick() {
    if (selectedDate !== t('numbersale:checkout.selectDate')) {
      setIsHourDropdownOpen(function (prev) {
        return !prev;
      });
    }
  };

  (0,react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target)) {
        setIsDateDropdownOpen(false);
      }

      if (hourDropdownRef.current && !hourDropdownRef.current.contains(event.target)) {
        setIsHourDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  (0,react.useEffect)(function () {
    formik.setFieldValue('dateType', '');
    formik.setFieldValue('hourType', '');
  }, [selectedBranchId]);

  var renderOption = function renderOption(option, index) {
    var _option$split = option.split(', '),
        _option$split2 = (0,slicedToArray/* default */.Z)(_option$split, 2),
        date = _option$split2[0],
        day = _option$split2[1];

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      onClick: function onClick() {
        return handleDateOptionClick(option);
      },
      itemScope: true,
      itemType: "https://schema.org/Property",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (SelectDateTime_index_module_default()).weekDays,
        children: [date, ",\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: day
        })]
      })
    }, index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SelectDateTime_index_module_default()).selectDateTimeContainer,
    itemScope: true,
    itemType: "https://schema.org/Date",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SelectDateTime_index_module_default()).custom_select,
      ref: dateDropdownRef,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((SelectDateTime_index_module_default()).dropdown_selected, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (SelectDateTime_index_module_default()).select_arrow_active, isDateDropdownOpen), (0,defineProperty/* default */.Z)(_classNames, (SelectDateTime_index_module_default()).disabled, isDateDropdownDisabled), _classNames)),
        onClick: handleDateSelectClick,
        "data-testid": 'select-date',
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SelectDateTime_index_module_default()).innerContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: !formik.values.dateType ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CalendarNumberSale */.dB, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CheckMark */.Y_, {
              className: (SelectDateTime_index_module_default()).checkIcon
            })
          }), selectedDate]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowDown */.K5, {
          className: classnames_default()((0,defineProperty/* default */.Z)({}, (SelectDateTime_index_module_default()).arrow_right_date, isDateDropdownOpen))
        })]
      }), isDateDropdownOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SelectDateTime_index_module_default()).select_items,
        children: optionsDate.map(renderOption)
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()((SelectDateTime_index_module_default()).custom_select, (0,defineProperty/* default */.Z)({}, (SelectDateTime_index_module_default()).disabled, !formik.values.dateType)),
      ref: hourDropdownRef,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((SelectDateTime_index_module_default()).dropdown_selected, (0,defineProperty/* default */.Z)({}, (SelectDateTime_index_module_default()).select_arrow_active, isHourDropdownOpen)),
        onClick: handleHourSelectClick,
        "data-testid": 'select-hour',
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SelectDateTime_index_module_default()).innerContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: selectedHour === t('numbersale:checkout.selectHour') ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Clock */.SU, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CheckMark */.Y_, {
              className: (SelectDateTime_index_module_default()).checkIcon
            })
          }), selectedHour]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ArrowDown */.K5, {
          className: classnames_default()((0,defineProperty/* default */.Z)({}, (SelectDateTime_index_module_default()).arrow_right_hour, isHourDropdownOpen))
        })]
      }), isHourDropdownOpen && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SelectDateTime_index_module_default()).select_items,
        children: optionsHours.map(function (option, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              return handleHourOptionClick(option);
            },
            children: option
          }, index);
        })
      })]
    })]
  });
};

/* harmony default export */ var ui_SelectDateTime = (SelectDateTime);
// EXTERNAL MODULE: ./enums/numberSale.ts
var numberSale = __webpack_require__(56951);
// EXTERNAL MODULE: ./components/ui/DeliveryAddressBranch/DeliveryAddressBranch.module.scss
var DeliveryAddressBranch_module = __webpack_require__(4550);
var DeliveryAddressBranch_module_default = /*#__PURE__*/__webpack_require__.n(DeliveryAddressBranch_module);
;// CONCATENATED MODULE: ./components/ui/DeliveryAddressBranch/DeliveryAddressBranch.js










var DeliveryAddressBranch = function DeliveryAddressBranch(_ref) {
  var formik = _ref.formik,
      handleDeliveryTypeChange = _ref.handleDeliveryTypeChange,
      onButtonClick = _ref.onButtonClick,
      data = _ref.data,
      defaultBranchId = _ref.defaultBranchId;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(formik.values.pickup_point_name),
      translatedBranchName = _useState[0],
      setTranslatedBranchName = _useState[1];

  (0,react.useEffect)(function () {
    if (formik.values.pickup_point_id || defaultBranchId) {
      var selectedBranch = data === null || data === void 0 ? void 0 : data.find(function (branch) {
        return (branch === null || branch === void 0 ? void 0 : branch.id) === Number(formik.values.pickup_point_id || defaultBranchId);
      });

      if (selectedBranch) {
        setTranslatedBranchName(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.name);
      }
    }
  }, [data, formik.values.pickup_point_id, defaultBranchId]);

  var DeliveryInfo = function DeliveryInfo(_ref2) {
    var _formik$values$addres, _formik$values$addres2;

    var deliveryType = _ref2.deliveryType,
        formik = _ref2.formik;

    if (deliveryType === 'self-pickup') {
      return formik.values.pickup_point_id ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DeliveryAddressBranch_module_default()).delivery_btn,
        itemScope: true,
        itemType: "http://schema.org/Information",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CheckMark */.Y_, {
            className: (DeliveryAddressBranch_module_default()).checkIcon
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: translatedBranchName
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ChevronRightArrow */.ow, {})
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* SelectBranch */.N5, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: t('device:delivery.branchBtn')
        })]
      });
    }

    return (_formik$values$addres = formik.values.address_coordinates) !== null && _formik$values$addres !== void 0 && _formik$values$addres.address ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DeliveryAddressBranch_module_default()).delivery_btn,
      itemScope: true,
      itemType: "http://schema.org/Thing",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CheckMark */.Y_, {
          className: (DeliveryAddressBranch_module_default()).checkIcon
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (_formik$values$addres2 = formik.values.address_coordinates) === null || _formik$values$addres2 === void 0 ? void 0 : _formik$values$addres2.address
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ChevronRightArrow */.ow, {})
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* SelectBranch */.N5, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: t('device:delivery.addressBtn')
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (DeliveryAddressBranch_module_default()).wrapper,
    itemScope: true,
    itemType: "https://schema.org/DeliveryMode",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DeliveryAddressBranch_module_default()).radio_container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RadioWithTitle_RadioWithTitle, {
        onChange: function onChange() {
          return handleDeliveryTypeChange(numberSale/* DeliveryType.SELF_PICKUP */.lF.SELF_PICKUP);
        },
        checked: formik.values.delivery_type === numberSale/* DeliveryType.SELF_PICKUP */.lF.SELF_PICKUP,
        name: "type",
        className: (DeliveryAddressBranch_module_default()).radio_address,
        size: "medium",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (DeliveryAddressBranch_module_default()).inner_container,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* BranchIcon */.Nt, {
            fill: formik.values.delivery_type === numberSale/* DeliveryType.SELF_PICKUP */.lF.SELF_PICKUP ? 'var(--colorIconPrimary)' : 'var( --colorIconSecondary)'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (DeliveryAddressBranch_module_default()).btnText,
            children: t('device:delivery.branch')
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RadioWithTitle_RadioWithTitle, {
        onChange: function onChange() {
          return handleDeliveryTypeChange(numberSale/* DeliveryType.DELIVERY_TO_ADDRESS */.lF.DELIVERY_TO_ADDRESS);
        },
        checked: formik.values.delivery_type === numberSale/* DeliveryType.DELIVERY_TO_ADDRESS */.lF.DELIVERY_TO_ADDRESS,
        name: "type",
        className: (DeliveryAddressBranch_module_default()).radio_address,
        size: "medium",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (DeliveryAddressBranch_module_default()).inner_container,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* AddressIcon */.Zx, {
            fill: formik.values.delivery_type === numberSale/* DeliveryType.DELIVERY_TO_ADDRESS */.lF.DELIVERY_TO_ADDRESS ? 'var(--colorIconPrimary)' : 'var( --colorIconSecondary)'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (DeliveryAddressBranch_module_default()).btnText,
            children: t('device:delivery.address')
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
      className: (DeliveryAddressBranch_module_default()).btn_select,
      type: "button",
      onClick: onButtonClick,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryInfo, {
        deliveryType: formik.values.delivery_type,
        formik: formik
      })
    })]
  });
};

/* harmony default export */ var DeliveryAddressBranch_DeliveryAddressBranch = (DeliveryAddressBranch);
;// CONCATENATED MODULE: ./hooks/useGeoLocation.ts


function useGeoLocation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useGeoLocation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useGeoLocation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useGeoLocation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var useGeolocation = function useGeolocation() {
  var _useState = (0,react.useState)({
    latitude: null,
    longitude: null,
    error: null
  }),
      location = _useState[0],
      setLocation = _useState[1];

  (0,react.useEffect)(function () {
    if (!navigator.geolocation) {
      setLocation(function (prevState) {
        return useGeoLocation_objectSpread(useGeoLocation_objectSpread({}, prevState), {}, {
          error: 'Geolocation is not supported by your browser'
        });
      });
      return;
    }

    var onSuccess = function onSuccess(position) {
      setLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        error: null
      });
    };

    var onError = function onError(error) {
      setLocation(function (prevState) {
        return useGeoLocation_objectSpread(useGeoLocation_objectSpread({}, prevState), {}, {
          error: error.message
        });
      });
    };

    var watcher = navigator.geolocation.watchPosition(onSuccess, onError);
    return function () {
      navigator.geolocation.clearWatch(watcher);
    };
  }, []);
  return location;
};

/* harmony default export */ var useGeoLocation = (useGeolocation);
// EXTERNAL MODULE: ./node_modules/@vis.gl/react-google-maps/dist/index.modern.mjs
var index_modern = __webpack_require__(86800);
// EXTERNAL MODULE: ./components/SvgComponents/Search.js
var Search = __webpack_require__(15538);
;// CONCATENATED MODULE: ./components/SvgComponents/TickMark.js


function TickMark_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TickMark_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TickMark_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TickMark_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var TickMark = function TickMark(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", TickMark_objectSpread(TickMark_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "15",
    viewBox: "0 0 19 15",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M6.69167 14.8167L0.00750732 8.1325V4.94917L6.70001 11.6417L18 0.5L18.0542 3.55417L6.69167 14.8167Z",
      fill: "var(--colorTextBrand)"
    })
  }));
};
// EXTERNAL MODULE: ./components/ui/AddressModal/SearchList/SearchList.module.scss
var SearchList_SearchList_module = __webpack_require__(45442);
var SearchList_SearchList_module_default = /*#__PURE__*/__webpack_require__.n(SearchList_SearchList_module);
;// CONCATENATED MODULE: ./components/ui/AddressModal/SearchList/SearchItem/SearchItem.tsx







var SearchItem = function SearchItem(_ref) {
  var place = _ref.place,
      onSelect = _ref.onSelect,
      isSelected = _ref.isSelected;

  var handleClick = function handleClick() {
    onSelect(place.place_id, place.description);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    className: "".concat((SearchList_SearchList_module_default()).searchItem, " ").concat(isSelected && (SearchList_SearchList_module_default()).searchItem_active, " "),
    onClick: handleClick,
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SearchList_SearchList_module_default()).left,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Address */.kL, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SearchList_SearchList_module_default()).right,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (SearchList_SearchList_module_default()).txt,
        children: place.description
      }), isSelected && /*#__PURE__*/(0,jsx_runtime.jsx)(TickMark, {})]
    })]
  });
};

/* harmony default export */ var SearchItem_SearchItem = (/*#__PURE__*/react.memo(SearchItem));
;// CONCATENATED MODULE: ./components/ui/AddressModal/SearchList/SearchList.tsx






var SearchList_SearchList_SearchList = function SearchList(_ref) {
  var places = _ref.places,
      onSelect = _ref.onSelect,
      selectedPlaceId = _ref.selectedPlaceId,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: classnames_default()((SearchList_SearchList_module_default()).searchList, className),
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    children: places.map(function (place) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SearchItem_SearchItem, {
        place: place,
        onSelect: onSelect,
        isSelected: place.place_id === selectedPlaceId
      }, place.place_id);
    })
  });
};

/* harmony default export */ var AddressModal_SearchList_SearchList = (/*#__PURE__*/react.memo(SearchList_SearchList_SearchList));
// EXTERNAL MODULE: ./components/ui/AddressModal/GoogleMap/GoogleMap.module.scss
var GoogleMap_module = __webpack_require__(79861);
var GoogleMap_module_default = /*#__PURE__*/__webpack_require__.n(GoogleMap_module);
;// CONCATENATED MODULE: ./components/ui/AddressModal/GoogleMap/GoogleMap.tsx


function GoogleMap_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function GoogleMap_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GoogleMap_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GoogleMap_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* global google */












var GoogleMap = function GoogleMap(_ref) {
  var customMarker = _ref.customMarker,
      setMapCenter = _ref.setMapCenter,
      address = _ref.address,
      setAddress = _ref.setAddress;
  var geocodingApiLoaded = (0,index_modern/* useMapsLibrary */.kY)('geocoding');
  var placesApiLoaded = (0,index_modern/* useMapsLibrary */.kY)('places');
  var map = (0,index_modern/* useMap */.Sx)('delivery');

  var _useState = (0,react.useState)(''),
      addressValue = _useState[0],
      setAddressValue = _useState[1];

  var _useState2 = (0,react.useState)(),
      geocoding = _useState2[0],
      setGeocoding = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isCenterChanging = _useState3[0],
      setIsCenterChanging = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      searchResults = _useState4[0],
      setSearchResults = _useState4[1];

  var autocompleteRef = (0,react.useRef)(null);
  var selectedPlaceIdRef = (0,react.useRef)('');

  var handleInputChange = function handleInputChange(value) {
    var _google, _google$maps;

    if ( false || !((_google = google) !== null && _google !== void 0 && (_google$maps = _google.maps) !== null && _google$maps !== void 0 && _google$maps.places)) {
      setSearchResults([]);
      return;
    }

    var autocompleteService = new google.maps.places.AutocompleteService();
    var options = {
      componentRestrictions: {
        country: 'az'
      },
      fields: ['address_components', 'geometry', 'icon', 'name'],
      strictBounds: false
    };

    if (value) {
      autocompleteService.getPlacePredictions(GoogleMap_objectSpread({
        input: value
      }, options), function (predictions, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
          setSearchResults(predictions);
        } else {
          setSearchResults([]);
        }
      });
    } else {
      setSearchResults([]);
    }
  };

  var debounce = function debounce(func, delay) {
    var timeoutId;

    var debouncedFunction = function debouncedFunction() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(function () {
        func.apply(void 0, args);
      }, delay);
    }; // Add cancel method to the debounced function


    debouncedFunction.cancel = function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };

    return debouncedFunction;
  };

  var debouncedHandleInputChange = (0,react.useRef)(debounce(function (value) {
    handleInputChange(value);
  }, 500)).current;

  var handlePlaceSelection = function handlePlaceSelection(placeId, description) {
    debouncedHandleInputChange.cancel();

    if (map) {
      var placesService = new placesApiLoaded.PlacesService(map);
      placesService.getDetails({
        placeId: placeId
      }, function (place) {
        if (place && place.geometry) {
          selectedPlaceIdRef.current = placeId;
          map.setCenter(place.geometry.location);
          map.setZoom(15);
          setAddressValue(description || '');
          setAddress({
            address_coordinates: "https://maps.google.com/?q=".concat(place.geometry.location.lat(), ",").concat(place.geometry.location.lng()),
            address: description
          });
          setSearchResults([]);
        }
      });
    }
  };

  var handleResultClick = function handleResultClick(placeId, description) {
    handlePlaceSelection(placeId, description);
  };

  var handleClearInput = (0,react.useCallback)(function () {
    setAddress(null);
    setAddressValue('');
    selectedPlaceIdRef.current = '';
    setSearchResults([]);
  }, []);
  (0,react.useEffect)(function () {
    if (!geocodingApiLoaded) return;
    setGeocoding(new google.maps.Geocoder());
  }, [geocodingApiLoaded]);
  (0,react.useEffect)(function () {
    return function () {
      debouncedHandleInputChange.cancel();
    };
  }, [debouncedHandleInputChange]);

  var onMapDrag = function onMapDrag(event) {
    var center = event.map.getCenter().toJSON();
    setMapCenter(center);
    setIsCenterChanging(false);
    setSearchResults([]);
    geocoding.geocode({
      location: {
        lng: center.lng,
        lat: center.lat
      }
    }).then(function (data) {
      var _data$results$;

      var formattedAddress = (data === null || data === void 0 ? void 0 : (_data$results$ = data.results[0]) === null || _data$results$ === void 0 ? void 0 : _data$results$.formatted_address) || '';
      setAddressValue(formattedAddress);
      setAddress({
        address_coordinates: "https://maps.google.com/?q=".concat(center.lat, ",").concat(center.lng),
        address: formattedAddress
      });
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(GoogleMap_module_default()).inputWrapper, (0,defineProperty/* default */.Z)({}, (GoogleMap_module_default()).wrapperFullHeight, searchResults.length > 0)]),
      itemScope: true,
      itemType: "https://schema.org/GeoCoordinates",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        ref: autocompleteRef,
        className: (GoogleMap_module_default()).searchInput,
        placeholder: "Bak\u0131 \u015F\u0259h., T\u0259briz k\xFC\xE7. 108",
        value: addressValue,
        onChange: function onChange(e) {
          setAddressValue(e.target.value);
          debouncedHandleInputChange(e.target.value);
        },
        "aria-label": addressValue
      }), address ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseSquare */.s9, {
        className: (GoogleMap_module_default()).inputIcon,
        onClick: handleClearInput
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Search/* default */.Z, {
        className: (GoogleMap_module_default()).inputIcon
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AddressModal_SearchList_SearchList, {
        places: searchResults,
        onSelect: handleResultClick,
        selectedPlaceId: selectedPlaceIdRef.current
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (GoogleMap_module_default()).wrap,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_modern/* Map */.D5, {
        id: "delivery",
        defaultZoom: 12,
        defaultCenter: {
          lat: 40.409264,
          lng: 49.867092
        },
        onDragend: onMapDrag,
        disableDefaultUI: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()([(GoogleMap_module_default()).marker, (0,defineProperty/* default */.Z)({}, (GoogleMap_module_default()).isScaled, isCenterChanging)]),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: customMarker,
          alt: "marker",
          width: 45,
          height: 45
        })
      })]
    })]
  });
};

/* harmony default export */ var GoogleMap_GoogleMap = (GoogleMap);
// EXTERNAL MODULE: ./components/ui/AddressModal/AddressModal.module.scss
var AddressModal_module = __webpack_require__(62098);
var AddressModal_module_default = /*#__PURE__*/__webpack_require__.n(AddressModal_module);
;// CONCATENATED MODULE: ./components/ui/AddressModal/AddressModal.tsx









var center = {
  lat: 40.409264,
  lng: 49.867092
};

var AddressModal = function AddressModal(_ref) {
  var _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$setIsActive = _ref.setIsActive,
      setIsActive = _ref$setIsActive === void 0 ? function () {
    return null;
  } : _ref$setIsActive,
      handleNext = _ref.handleNext,
      formik = _ref.formik;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useGeolocation = useGeoLocation(),
      latitude = _useGeolocation.latitude,
      longitude = _useGeolocation.longitude,
      error = _useGeolocation.error;

  var _useState = (0,react.useState)(undefined),
      address = _useState[0],
      setAddress = _useState[1];

  var _useState2 = (0,react.useState)(center),
      mapCenter = _useState2[0],
      setMapCenter = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isDisabled = _useState3[0],
      setIsDisabled = _useState3[1];

  (0,react.useEffect)(function () {
    if (!error && latitude && longitude) {
      setMapCenter({
        lat: Number(latitude),
        lng: Number(longitude)
      });
    }
  }, [latitude, longitude, error]);
  (0,react.useEffect)(function () {
    if (!base/* validCountries.some */.pM.some(function (country) {
      var _address$address;

      return address === null || address === void 0 ? void 0 : (_address$address = address.address) === null || _address$address === void 0 ? void 0 : _address$address.includes(country);
    })) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [address]);

  var handleModalNext = function handleModalNext(address) {
    if (handleNext) {
      handleNext(address);
    }

    formik.setFieldValue('address_coordinates', address);
    formik.setFieldValue('address', address === null || address === void 0 ? void 0 : address.address);
    formik.setFieldValue('pickup_point_id', null);
    formik.setFieldValue('validPoint', true);
    setIsActive(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    itemScope: true,
    itemType: "https://schema.org/GeoCoordinates",
    children: isActive && /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal["default"], {
      active: isActive,
      setActive: setIsActive,
      className: (AddressModal_module_default()).addressModalWrapper,
      classNameInner: (AddressModal_module_default()).addressModal,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: (AddressModal_module_default()).addressModalTitle,
        children: t('device:address.ChooseDeliveryAddress')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (AddressModal_module_default()).contentWrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleMap_GoogleMap, {
          customMarker: '/assets/map/AddressMarker.svg',
          center: mapCenter,
          setMapCenter: setMapCenter,
          address: address,
          setAddress: setAddress
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
        className: (AddressModal_module_default()).nextButton,
        onClick: function onClick() {
          handleModalNext(address);
        },
        disabled: !address || isDisabled,
        children: t('common:Continue')
      })]
    })
  });
};

/* harmony default export */ var AddressModal_AddressModal = (AddressModal);
;// CONCATENATED MODULE: ./components/SvgComponents/Store.js


function Store_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Store_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Store_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Store_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var Store = function Store(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", Store_objectSpread(Store_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask0_1110_2637)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M17.616 4.90347C17.166 3.82361 16.1188 3.125 14.9486 3.125H5.05139C3.88125 3.125 2.83403 3.82292 2.38403 4.90347L1.25 7.625V8.66528C1.25 9.60972 1.92153 10.4007 2.8125 10.5847V17.5H17.1875V10.5847C18.0785 10.4007 18.75 9.60972 18.75 8.66528V7.625L17.616 4.90347ZM15.8854 5.62431L16.875 8V8.66528C16.875 8.71181 16.8368 8.75 16.7903 8.75H15.625L14.2625 5H14.9493C15.3604 5 15.7278 5.24514 15.8854 5.62431ZM9.0625 8.75H6.57708L7.79306 5H9.06319V8.75H9.0625ZM10.9375 5H12.2667L13.6292 8.75H10.9368V5H10.9375ZM3.20972 8.75C3.16319 8.75 3.125 8.71181 3.125 8.66528V8L4.11458 5.62431C4.27292 5.24514 4.64028 5 5.05069 5H5.82083L4.60486 8.75H3.20903H3.20972ZM15.3125 15.625H4.6875V10.625H15.3125V15.625Z",
        fill: "#695F5F"
      })
    })
  }));
};
// EXTERNAL MODULE: ./components/ui/BranchModal/SingleBranch/index.module.scss
var SingleBranch_index_module = __webpack_require__(66331);
var SingleBranch_index_module_default = /*#__PURE__*/__webpack_require__.n(SingleBranch_index_module);
;// CONCATENATED MODULE: ./components/ui/BranchModal/SingleBranch/index.js







var SingleBranch = function SingleBranch(_ref) {
  var branch = _ref.branch,
      adress = _ref.adress,
      onClick = _ref.onClick,
      active = _ref.active;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    onClick: onClick,
    className: classnames_default()((SingleBranch_index_module_default()).branch, (0,defineProperty/* default */.Z)({}, (SingleBranch_index_module_default()).branch__active, active)),
    itemScope: true,
    itemType: "https://schema.org/Organization",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SingleBranch_index_module_default()).left,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Store, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SingleBranch_index_module_default()).right,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SingleBranch_index_module_default()).texts,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: branch
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: adress
        })]
      }), active && /*#__PURE__*/(0,jsx_runtime.jsx)(TickMark, {})]
    })]
  });
};
// EXTERNAL MODULE: ./components/ui/BranchModal/index.module.scss
var BranchModal_index_module = __webpack_require__(49707);
var BranchModal_index_module_default = /*#__PURE__*/__webpack_require__.n(BranchModal_index_module);
;// CONCATENATED MODULE: ./components/ui/BranchModal/index.js











var BranchModal = function BranchModal(_ref) {
  var _classNames;

  var isActive = _ref.isActive,
      setIsActive = _ref.setIsActive,
      branchesData = _ref.branchesData,
      setSelectedBranchInStore = _ref.setSelectedBranchInStore,
      handleGetAddress = _ref.handleGetAddress,
      defaultBranch = _ref.defaultBranch;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var defaultCoords = {
    lat: Number(branchesData === null || branchesData === void 0 ? void 0 : branchesData[0].lat),
    lng: Number(branchesData === null || branchesData === void 0 ? void 0 : branchesData[0].lng)
  };

  var _useState = (0,react.useState)(''),
      searchText = _useState[0],
      setSearchText = _useState[1];

  var _useState2 = (0,react.useState)(branchesData),
      filteredBranches = _useState2[0],
      setFilteredBranches = _useState2[1];

  var _useState3 = (0,react.useState)(defaultBranch),
      selectedBranch = _useState3[0],
      setSelectedBranch = _useState3[1];

  var _useState4 = (0,react.useState)(defaultCoords),
      center = _useState4[0],
      setCenter = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isMobileBranches = _useState5[0],
      setIsMobileBranches = _useState5[1];

  (0,react.useEffect)(function () {
    setFilteredBranches(branchesData);

    if (!(selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.id)) {
      setCenter(defaultCoords);
    }

    updateCenterCoords(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.id);
  }, [branchesData, selectedBranch]);

  var updateCenterCoords = function updateCenterCoords(id) {
    var currentBranch = branchesData === null || branchesData === void 0 ? void 0 : branchesData.find(function (branch) {
      return (branch === null || branch === void 0 ? void 0 : branch.id) === id;
    });
    var coords = {
      lat: parseFloat(currentBranch === null || currentBranch === void 0 ? void 0 : currentBranch.lat),
      lng: parseFloat(currentBranch === null || currentBranch === void 0 ? void 0 : currentBranch.lng)
    };
    setCenter(coords);
  };

  var searchHandler = function searchHandler(value) {
    setSearchText(value);
    var filtered = branchesData === null || branchesData === void 0 ? void 0 : branchesData.filter(function (branch) {
      var _branch$name, _branch$address;

      return (branch === null || branch === void 0 ? void 0 : (_branch$name = branch.name) === null || _branch$name === void 0 ? void 0 : _branch$name.split(' ').some(function (word) {
        var _word$toLowerCase;

        return word === null || word === void 0 ? void 0 : (_word$toLowerCase = word.toLowerCase()) === null || _word$toLowerCase === void 0 ? void 0 : _word$toLowerCase.startsWith(value === null || value === void 0 ? void 0 : value.toLowerCase());
      })) || (branch === null || branch === void 0 ? void 0 : (_branch$address = branch.address) === null || _branch$address === void 0 ? void 0 : _branch$address.split(' ').some(function (word) {
        return word === null || word === void 0 ? void 0 : word.toLowerCase().startsWith(value === null || value === void 0 ? void 0 : value.toLowerCase());
      }));
    });
    setFilteredBranches(filtered);
  };

  var submitHandler = function submitHandler() {
    if (isMobileBranches) {
      setIsMobileBranches(false);
    }

    if (selectedBranch) {
      handleGetAddress(selectedBranch);
      setIsActive(false);
      setSelectedBranchInStore === null || setSelectedBranchInStore === void 0 ? void 0 : setSelectedBranchInStore(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.id);
      updateCenterCoords(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.id);
    }

    setIsActive(false);
    setCenter(defaultCoords);
  };

  var branchHandler = function branchHandler(id, name) {
    setSelectedBranch({
      id: id,
      name: name
    });
    updateCenterCoords(id);
  };

  var cancelHandler = function cancelHandler() {
    setIsMobileBranches(false);
    setIsActive(false);
  };

  (0,react.useEffect)(function () {
    if (isActive) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    return function () {
      document.body.classList.remove('modal-open');
    };
  }, [isActive]);

  var handleModalActions = function handleModalActions() {
    setSearchText('');
    setIsActive();
    setSelectedBranch(defaultBranch);
    setCenter(defaultCoords);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (BranchModal_index_module_default()).modalWrapper,
    itemScope: true,
    itemType: "https://schema.org/Organization",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal["default"], {
      active: isActive,
      setActive: handleModalActions,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        children: t('common:PickupPoint')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (BranchModal_index_module_default()).customWrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((BranchModal_index_module_default()).left, " ").concat(isMobileBranches && (BranchModal_index_module_default()).left__mobile),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (BranchModal_index_module_default()).inputWrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
              value: searchText,
              onChange: function onChange(value) {
                return searchHandler(value);
              },
              placeholder: t('device:address.branch'),
              onFocus: function onFocus() {
                return setIsMobileBranches(true);
              },
              type: "validateGeneralInput"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* Search */.HN, {
              width: 24,
              height: 24
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((BranchModal_index_module_default()).branches, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, (BranchModal_index_module_default()).branches__mobile, isMobileBranches), (0,defineProperty/* default */.Z)(_classNames, (BranchModal_index_module_default()).scrollable, (filteredBranches === null || filteredBranches === void 0 ? void 0 : filteredBranches.length) > 7), _classNames)),
            children: filteredBranches === null || filteredBranches === void 0 ? void 0 : filteredBranches.map(function (_ref2) {
              var address = _ref2.address,
                  name = _ref2.name,
                  id = _ref2.id;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(SingleBranch, {
                onClick: function onClick() {
                  return branchHandler(id, name);
                },
                active: id === (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.id),
                branch: name,
                adress: address
              }, id);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (BranchModal_index_module_default()).right,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Map, {
            branches: filteredBranches !== null && filteredBranches !== void 0 ? filteredBranches : branchesData,
            center: center,
            setCenter: setCenter,
            onMarkerClick: branchHandler,
            mobileSearch: isMobileBranches
          }), !(!selectedBranch && isMobileBranches) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            onClick: submitHandler,
            disabled: !(selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.id),
            className: (BranchModal_index_module_default()).btnContinue,
            children: t('common:Continue')
          }), !selectedBranch && isMobileBranches && /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            onClick: cancelHandler,
            className: (BranchModal_index_module_default()).mobileBtn,
            variant: "outline",
            children: t('common:Cancel')
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var ui_BranchModal = (BranchModal);
// EXTERNAL MODULE: ./constants/media.js
var media = __webpack_require__(98587);
// EXTERNAL MODULE: ./components/SvgComponents/ZoomMinusIcon.js
var ZoomMinusIcon = __webpack_require__(40318);
// EXTERNAL MODULE: ./components/SvgComponents/ZoomPlusIcon.js
var ZoomPlusIcon = __webpack_require__(26827);
// EXTERNAL MODULE: ./components/ui/Map/index.module.scss
var Map_index_module = __webpack_require__(67239);
var Map_index_module_default = /*#__PURE__*/__webpack_require__.n(Map_index_module);
;// CONCATENATED MODULE: ./components/ui/Map/index.js









function Map_GoogleMap(_ref) {
  var branches = _ref.branches,
      mobileSearch = _ref.mobileSearch,
      _ref$onMarkerClick = _ref.onMarkerClick,
      onMarkerClick = _ref$onMarkerClick === void 0 ? function () {
    return null;
  } : _ref$onMarkerClick,
      center = _ref.center;
  var map = (0,index_modern/* useMap */.Sx)('branch');

  var _useGetBreakPoints = (0,media/* useGetBreakPoints */.s)(),
      isTablet = _useGetBreakPoints.isTablet;

  var _useState = (0,react.useState)(12),
      zoomLevel = _useState[0],
      setZoomLevel = _useState[1];

  var handleMarkerClick = (0,react.useCallback)(function (markerPosition, id, name) {
    onMarkerClick(id, name);
    map === null || map === void 0 ? void 0 : map.setOptions({
      center: markerPosition
    });
  }, []);

  var handleZoom = function handleZoom(level) {
    map === null || map === void 0 ? void 0 : map.setOptions({
      zoom: level
    });
    setZoomLevel(level);
  };

  (0,react.useEffect)(function () {
    if (!center.lat) return;
    map === null || map === void 0 ? void 0 : map.setOptions({
      center: center
    });
  }, [map, center]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat((Map_index_module_default()).googleMapContainer, " ").concat(mobileSearch && (Map_index_module_default()).googleMapContainer__hidden),
    itemScope: true,
    itemType: "https://schema.org/Map",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_modern/* Map */.D5, {
      id: "branch",
      defaultCenter: {
        lat: 40.409264,
        lng: 49.867092
      },
      defaultZoom: 12,
      disableDefaultUI: true,
      children: [branches === null || branches === void 0 ? void 0 : branches.map(function (_ref2) {
        var lat = _ref2.lat,
            lng = _ref2.lng,
            id = _ref2.id,
            name = _ref2.name;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(index_modern/* Marker */.Jx, {
          position: {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          },
          icon: {
            url: '/assets/modalMarker.png'
          },
          onClick: function onClick() {
            return handleMarkerClick({
              lat: parseFloat(lat),
              lng: parseFloat(lng)
            }, id, name);
          }
        }, id);
      }), isTablet && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (Map_index_module_default()).zoomControls,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Map_index_module_default()).zoomIcon,
          onClick: function onClick() {
            return handleZoom(zoomLevel + 1);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ZoomPlusIcon/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Map_index_module_default()).zoomIcon,
          onClick: function onClick() {
            return handleZoom(zoomLevel - 1);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ZoomMinusIcon/* default */.Z, {})
        })]
      })]
    })
  });
}

/* harmony default export */ var Map = (/*#__PURE__*/(0,react.memo)(Map_GoogleMap));
// EXTERNAL MODULE: ./hooks/useCabinet.js
var useCabinet = __webpack_require__(13245);
// EXTERNAL MODULE: ./components/ui/TermsConditions/TermsConditions.module.scss
var TermsConditions_module = __webpack_require__(74857);
var TermsConditions_module_default = /*#__PURE__*/__webpack_require__.n(TermsConditions_module);
;// CONCATENATED MODULE: ./components/ui/TermsConditions/TermsConditions.js



/* eslint-disable no-unused-expressions */

/* eslint-disable react-hooks/exhaustive-deps */












var Terms = function Terms(_ref) {
  var _formik$values, _data$content;

  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$setActive = _ref.setActive,
      setActive = _ref$setActive === void 0 ? function () {
    return null;
  } : _ref$setActive,
      _ref$formikHandler = _ref.formikHandler,
      formikHandler = _ref$formikHandler === void 0 ? function () {
    return null;
  } : _ref$formikHandler,
      className = _ref.className,
      classNameInner = _ref.classNameInner,
      innerText = _ref.innerText,
      _ref$isFetching = _ref.isFetching,
      isFetching = _ref$isFetching === void 0 ? false : _ref$isFetching,
      formik = _ref.formik,
      data = _ref.data;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isCabinet = (0,useCabinet/* useIsCabinet */.g)();

  var _React$useState = react.useState(formik === null || formik === void 0 ? void 0 : (_formik$values = formik.values) === null || _formik$values === void 0 ? void 0 : _formik$values.terms),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      accepted = _React$useState2[0],
      setAccepted = _React$useState2[1];

  var outsideRef = (0,react.useRef)(null);
  react.useEffect(function () {
    if (active) {
      document.documentElement.classList.add('overflow');
    } else {
      document.documentElement.classList.remove('overflow');
    }

    return function () {
      document.documentElement.classList.remove('overflow');
    };
  }, [active]);

  var printPdf = function printPdf() {
    document.getElementById('pdfDocument').contentWindow.print();
  };

  (0,useClickOutside/* default */.Z)(outsideRef, function () {
    return handleClose();
  });

  var clickHandler = function clickHandler() {
    var _window, _window$dataLayer;

    setActive(false);
    !isCabinet && formik.setFieldValue('terms', accepted);
    isCabinet && formikHandler();
    window.dataLayer = window.dataLayer || [];
    (_window = window) === null || _window === void 0 ? void 0 : (_window$dataLayer = _window.dataLayer) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push({
      event: 'agreecontract'
    });
  };

  var handleCheck = function handleCheck() {
    setAccepted(function (accepted) {
      return !accepted;
    });
  };

  var handleClose = function handleClose() {
    if (!isCabinet) {
      formik.setFieldValue('terms', formik.values.terms === accepted ? formik.values.terms : false);
      setAccepted(formik.values.terms === accepted ? formik.values.terms : false);
      setActive(false);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()([(TermsConditions_module_default()).wrap, (0,defineProperty/* default */.Z)({}, (TermsConditions_module_default()).open, active), className]),
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: outsideRef,
      className: classnames_default()([(TermsConditions_module_default()).termsInner, classNameInner]),
      children: [!isCabinet && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseSquare */.s9, {
        className: (TermsConditions_module_default()).closeModal,
        onClick: function onClick() {
          setActive(false);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TermsConditions_module_default()).termsContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
          src: "/assets/esim/files/BKC-contract.pdf",
          id: "pdfDocument",
          style: {
            display: 'none'
          },
          title: t('esim:common.termsAndConditions')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: (TermsConditions_module_default()).title,
          children: t('esim:common.termsAndConditions')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: !innerText ? (_data$content = data === null || data === void 0 ? void 0 : data.content) !== null && _data$content !== void 0 ? _data$content : data === null || data === void 0 ? void 0 : data.text : innerText
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), !innerText && /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
          width: "100%",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
                children: [t('esim:contract.company'), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
                children: [t('esim:contract.customer'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
              children: ["( ", t('esim:contract.mark'), ") ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
              children: ["(", t('esim:contract.signature'), ") ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TermsConditions_module_default()).bottom_buttons,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxWithText/* default */.Z, {
          reverse: true,
          checked: accepted,
          onChange: handleCheck,
          titleClassName: (TermsConditions_module_default()).checkbox_label_terms,
          children: t('esim:common.readAccept')
        }), !innerText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (TermsConditions_module_default()).button_groups,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "/assets/esim/files/BKC-contract.pdf",
            download: true,
            className: (TermsConditions_module_default()).download_btn,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/assets/esim/download.svg",
              width: 16,
              height: 16,
              layout: "fixed",
              alt: "download icon",
              title: "Download Icon",
              loading: "lazy"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            onClick: function onClick() {
              return printPdf();
            },
            className: (TermsConditions_module_default()).print_btn,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/assets/esim/printer.svg",
              width: 16,
              height: 16,
              layout: "fixed",
              alt: "download icon",
              title: "Download Icon",
              loading: "lazy"
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (TermsConditions_module_default()).acceptButtons,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
          className: classnames_default()([(TermsConditions_module_default()).terms_accept_btn, (0,defineProperty/* default */.Z)({}, (TermsConditions_module_default()).terms_accept_btn_height, isCabinet)]),
          onClick: clickHandler,
          disabled: !accepted,
          children: t('cabinet:common.Accept')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
          className: classnames_default()([(TermsConditions_module_default()).terms_accept_btn, (TermsConditions_module_default()).terms_close_btn]),
          variant: "outline",
          onClick: handleClose,
          children: t('esim:checkout.actions.close')
        })]
      })]
    })
  });
};

/* harmony default export */ var TermsConditions = (Terms);
;// CONCATENATED MODULE: ./components/ui/index.js






































































































/***/ }),

/***/ 56090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ widget_wrapper_WidgetWrapper; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
// EXTERNAL MODULE: ./constants/widgets.js
var constants_widgets = __webpack_require__(70245);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/ui/MainBanner/MainBanner.jsx
var MainBanner = __webpack_require__(30979);
// EXTERNAL MODULE: ./components/ui/OurManagement/OurManagement.jsx
var OurManagement = __webpack_require__(32879);
// EXTERNAL MODULE: ./components/ui/BoardOfDirectors/BoardOfDirectors.jsx
var BoardOfDirectors = __webpack_require__(39092);
// EXTERNAL MODULE: ./components/ui/MediaInquire/MediaInquire.jsx
var MediaInquire = __webpack_require__(13212);
// EXTERNAL MODULE: ./components/ui/Company/Company.jsx
var Company = __webpack_require__(17783);
// EXTERNAL MODULE: ./components/ui/VideoBlock/VideoBlock.jsx + 1 modules
var VideoBlock = __webpack_require__(61621);
// EXTERNAL MODULE: ./components/home/BrandSlider/BrandSlider.js
var BrandSlider = __webpack_require__(25280);
// EXTERNAL MODULE: ./components/home/BookNumber/BookNumber.js
var BookNumber = __webpack_require__(65620);
// EXTERNAL MODULE: ./components/home/AppBanner/AppBanner.js
var AppBanner = __webpack_require__(21459);
// EXTERNAL MODULE: ./components/home/Tariffs/Tariffs.js
var Tariffs = __webpack_require__(7176);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(62049);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./hooks/useSlickPositioning.js
var useSlickPositioning = __webpack_require__(25367);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(2844);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(9134);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(15129);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(12420);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(4556);
// EXTERNAL MODULE: ./enums/theme.ts
var enums_theme = __webpack_require__(29128);
// EXTERNAL MODULE: ./components/device/Products/EshopItems/EshopItems.module.scss
var EshopItems_module = __webpack_require__(44357);
var EshopItems_module_default = /*#__PURE__*/__webpack_require__.n(EshopItems_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/device/Products/EshopItems/EshopItems.js















var EshopItems = function EshopItems(_ref) {
  var _product$instalment_p, _product$album, _product$album$photos, _product$instalment_p2, _product$instalment_p3, _product$labels, _product$instalment_p4, _product$monthly;

  var product = _ref.product;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useTheme = (0,index_module/* useTheme */.F)(),
      theme = _useTheme.theme;

  var _useState = (0,react.useState)(false),
      isImageLoaded = _useState[0],
      setIsImageLoaded = _useState[1];

  var months = product === null || product === void 0 ? void 0 : (_product$instalment_p = product.instalment_payment) === null || _product$instalment_p === void 0 ? void 0 : _product$instalment_p.months;
  var destinationUrl = router.query.webview ? "".concat(product === null || product === void 0 ? void 0 : product.slug, "?webview=").concat(router.query.webview) : product === null || product === void 0 ? void 0 : product.slug;

  var monthlyPayment = function monthlyPayment() {
    var price = ((product === null || product === void 0 ? void 0 : product.new_price) / (months === null || months === void 0 ? void 0 : months[(months === null || months === void 0 ? void 0 : months.length) - 1])).toFixed(2);
    return price;
  };

  var handleButtonAction = function handleButtonAction() {
    var _product$new_price;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: product === null || product === void 0 ? void 0 : product.currency,
        items: [{
          item_id: product === null || product === void 0 ? void 0 : product.id,
          item_name: product === null || product === void 0 ? void 0 : product.name,
          price: (_product$new_price = product === null || product === void 0 ? void 0 : product.new_price) !== null && _product$new_price !== void 0 ? _product$new_price : product === null || product === void 0 ? void 0 : product.old_price,
          quantity: 1
        }]
      }
    });
    router.push(destinationUrl);
  };

  var renderLabels = function renderLabels(item) {
    var _item$title;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()([(EshopItems_module_default()).small_box, (0,defineProperty/* default */.Z)({}, (EshopItems_module_default()).dark, (item === null || item === void 0 ? void 0 : item.color) === 'deep_red')]),
      itemScope: true,
      itemType: "https://schema.org/Thing",
      children: [(item === null || item === void 0 ? void 0 : item.icon) && (item === null || item === void 0 ? void 0 : item.dark_mode_icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: theme === enums_theme/* ETheme.DARK_MODE */.X.DARK_MODE ? item.dark_mode_icon : item.icon,
        alt: "label icon",
        width: 20,
        height: 20,
        loading: "lazy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (EshopItems_module_default()).desc,
        dangerouslySetInnerHTML: {
          __html: item === null || item === void 0 ? void 0 : (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.replace(/\\n/g, '<br>')
        }
      })]
    }, item === null || item === void 0 ? void 0 : item.id);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (EshopItems_module_default()).product_wrapper,
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (EshopItems_module_default()).img_box,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: product === null || product === void 0 ? void 0 : product.slug,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            children: [!isImageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
              width: 250,
              height: 250,
              style: {
                position: 'absolute',
                top: '24px'
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: product === null || product === void 0 ? void 0 : (_product$album = product.album) === null || _product$album === void 0 ? void 0 : (_product$album$photos = _product$album.photos) === null || _product$album$photos === void 0 ? void 0 : _product$album$photos[0],
              alt: product === null || product === void 0 ? void 0 : product.name,
              title: product === null || product === void 0 ? void 0 : product.name,
              width: 250,
              height: 250,
              onLoadingComplete: function onLoadingComplete() {
                return setIsImageLoaded(true);
              },
              style: {
                visibility: isImageLoaded ? 'visible' : 'hidden'
              },
              loading: "lazy"
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (EshopItems_module_default()).content_box,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: product === null || product === void 0 ? void 0 : product.slug,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (EshopItems_module_default()).product_title,
              children: product === null || product === void 0 ? void 0 : product.name
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (EshopItems_module_default()).price_box,
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (EshopItems_module_default()).price,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: product === null || product === void 0 ? void 0 : product.new_price
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (EshopItems_module_default()).currency,
                  children: product === null || product === void 0 ? void 0 : product.currency
                })]
              }), (product === null || product === void 0 ? void 0 : product.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (EshopItems_module_default()).old_price,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: product === null || product === void 0 ? void 0 : product.old_price
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "\u20BC"
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (EshopItems_module_default()).monthly_box,
              children: [(product === null || product === void 0 ? void 0 : (_product$instalment_p2 = product.instalment_payment) === null || _product$instalment_p2 === void 0 ? void 0 : _product$instalment_p2.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (EshopItems_module_default()).icon_box,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: product === null || product === void 0 ? void 0 : (_product$instalment_p3 = product.instalment_payment) === null || _product$instalment_p3 === void 0 ? void 0 : _product$instalment_p3.icon,
                  alt: "birbank icon",
                  title: "Birbank Icon",
                  width: 20,
                  height: 20,
                  className: (EshopItems_module_default()).icon,
                  loading: "lazy"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (EshopItems_module_default()).label_wrapper,
                children: product === null || product === void 0 ? void 0 : (_product$labels = product.labels) === null || _product$labels === void 0 ? void 0 : _product$labels.map(renderLabels)
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (EshopItems_module_default()).payment_container,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: monthlyPayment()
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "\u20BC"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (EshopItems_module_default()).item,
                  children: "x"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [months === null || months === void 0 ? void 0 : months[(months === null || months === void 0 ? void 0 : months.length) - 1], product === null || product === void 0 ? void 0 : (_product$instalment_p4 = product.instalment_payment) === null || _product$instalment_p4 === void 0 ? void 0 : _product$instalment_p4.unit]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (EshopItems_module_default()).item,
                  children: product === null || product === void 0 ? void 0 : (_product$monthly = product.monthly) === null || _product$monthly === void 0 ? void 0 : _product$monthly.paymentText
                })]
              })]
            })]
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
      onClick: handleButtonAction,
      className: (EshopItems_module_default()).btn,
      children: t('device:common.details')
    })]
  });
};

/* harmony default export */ var EshopItems_EshopItems = (EshopItems);
// EXTERNAL MODULE: ./components/device/Products/EshopSlider/EshopSlider.module.scss
var EshopSlider_module = __webpack_require__(36070);
var EshopSlider_module_default = /*#__PURE__*/__webpack_require__.n(EshopSlider_module);
;// CONCATENATED MODULE: ./components/device/Products/EshopSlider/EshopSlider.js











var EshopSlider = function EshopSlider(_ref) {
  var _data$product_variati;

  var data = _ref.data;
  (0,useSlickPositioning/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "wrapper section",
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (EshopSlider_module_default()).shop_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (EshopSlider_module_default()).title,
        children: data === null || data === void 0 ? void 0 : data.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: data === null || data === void 0 ? void 0 : data.slug,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          title: data === null || data === void 0 ? void 0 : data.title,
          "aria-label": data === null || data === void 0 ? void 0 : data.title,
          className: (EshopSlider_module_default()).link,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (EshopSlider_module_default()).button_container,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (EshopSlider_module_default()).link_text,
              children: data === null || data === void 0 ? void 0 : data.button_text
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/assets/Arrow.png",
              alt: "arrow icon",
              title: "Arrow Icon",
              width: 20,
              height: 20
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SliderWrapper */.h2, {
        arrows: true,
        nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* BrandArrow */.RJ, {
          width: 17
        }),
        prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* BrandArrow */.RJ, {
          width: 17
        }),
        options: {
          infinite: true,
          slidesToShow: 4
        },
        children: data === null || data === void 0 ? void 0 : (_data$product_variati = data.product_variations) === null || _data$product_variati === void 0 ? void 0 : _data$product_variati.map(function (product, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(EshopItems_EshopItems, {
            product: product
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var EshopSlider_EshopSlider = (EshopSlider);
// EXTERNAL MODULE: ./components/home/VolteBanner/VolteBanner.jsx
var VolteBanner = __webpack_require__(28883);
// EXTERNAL MODULE: ./components/news/NewsSingle/NewsSingle.js
var NewsSingle = __webpack_require__(19673);
// EXTERNAL MODULE: ./components/home/index.js + 9 modules
var home = __webpack_require__(1822);
// EXTERNAL MODULE: ./components/news/NewsList/NewsList.js
var NewsList = __webpack_require__(38703);
// EXTERNAL MODULE: ./components/roaming/index.js + 12 modules
var roaming = __webpack_require__(4538);
// EXTERNAL MODULE: ./components/TariffSliderBusiness/TariffSliderBusiness.js
var TariffSliderBusiness = __webpack_require__(82563);
// EXTERNAL MODULE: ./components/TariffSliderBusiness/TariffSliderBusinessWithoutHeader.js
var TariffSliderBusinessWithoutHeader = __webpack_require__(35819);
// EXTERNAL MODULE: ./components/common/GoogleMapsClusterer/GoogleMapsClusterer.js + 1 modules
var GoogleMapsClusterer = __webpack_require__(75482);
// EXTERNAL MODULE: ./components/common/TariffsFilter/index.js
var TariffsFilter = __webpack_require__(61024);
// EXTERNAL MODULE: ./components/partnership/Form/Form.js
var Form = __webpack_require__(97608);
// EXTERNAL MODULE: ./components/campaigns/index.js + 4 modules
var campaigns = __webpack_require__(56936);
// EXTERNAL MODULE: ./components/tariffs/index.js + 9 modules
var tariffs = __webpack_require__(44952);
// EXTERNAL MODULE: ./components/contact-us/index.js + 3 modules
var contact_us = __webpack_require__(98778);
// EXTERNAL MODULE: ./components/services/index.js + 11 modules
var services = __webpack_require__(972);
// EXTERNAL MODULE: ./components/about-us/index.js + 9 modules
var about_us = __webpack_require__(18686);
// EXTERNAL MODULE: ./components/business-join-us/index.js + 3 modules
var business_join_us = __webpack_require__(32030);
// EXTERNAL MODULE: ./components/choose-topic/ChooseTopic.jsx
var ChooseTopic = __webpack_require__(70996);
// EXTERNAL MODULE: ./components/support/index.js + 5 modules
var support = __webpack_require__(64310);
// EXTERNAL MODULE: ./components/business-calls/index.js + 1 modules
var business_calls = __webpack_require__(86828);
// EXTERNAL MODULE: ./components/find-your-number/index.js + 2 modules
var find_your_number = __webpack_require__(87776);
// EXTERNAL MODULE: ./components/business-fix-service/FixService.js + 4 modules
var FixService = __webpack_require__(88426);
// EXTERNAL MODULE: ./components/business-roaming/index.js + 9 modules
var business_roaming = __webpack_require__(47433);
// EXTERNAL MODULE: ./components/esim/index.js + 19 modules
var esim = __webpack_require__(31444);
// EXTERNAL MODULE: ./components/services/ServicesGrid/ServicesGrid.js + 1 modules
var ServicesGrid = __webpack_require__(84439);
// EXTERNAL MODULE: ./components/esim/SwapBanner/SwapBanner.module.scss
var SwapBanner_module = __webpack_require__(72067);
var SwapBanner_module_default = /*#__PURE__*/__webpack_require__.n(SwapBanner_module);
;// CONCATENATED MODULE: ./components/esim/SwapBanner/SwapBanner.js








var SwapBanner = function SwapBanner(_ref) {
  var data = _ref.data;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "wrapper swap_wrapper",
    itemScope: true,
    itemType: "https://schema.org/Advertisement",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SwapBanner_module_default()).swap_banner_wrap,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SwapBanner_module_default()).left_side,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: data === null || data === void 0 ? void 0 : data.icon,
          alt: data === null || data === void 0 ? void 0 : data.title,
          title: data === null || data === void 0 ? void 0 : data.title,
          loading: "lazy",
          width: 40,
          height: 40
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (SwapBanner_module_default()).description,
          children: data === null || data === void 0 ? void 0 : data.title
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
        onClick: function onClick() {
          router.push('esim/checkout?id=swap');
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'changeesim'
          });
        },
        className: (SwapBanner_module_default()).button,
        variant: 'transparent',
        children: data === null || data === void 0 ? void 0 : data.button_text
      })]
    })
  });
};

/* harmony default export */ var SwapBanner_SwapBanner = (SwapBanner);
// EXTERNAL MODULE: ./components/404/NotFoundPage/NotFoundPage.js
var NotFoundPage = __webpack_require__(33920);
// EXTERNAL MODULE: ./hooks/index.js + 1 modules
var hooks = __webpack_require__(59748);
// EXTERNAL MODULE: ./components/common/GoogleMaps/GoogleMaps.js
var GoogleMaps = __webpack_require__(48756);
// EXTERNAL MODULE: ./components/common/AvailableArea/AvailableArea.module.scss
var AvailableArea_module = __webpack_require__(10730);
var AvailableArea_module_default = /*#__PURE__*/__webpack_require__.n(AvailableArea_module);
;// CONCATENATED MODULE: ./components/common/AvailableArea/AvailableArea.js


/* eslint-disable import/no-named-as-default */








var AvailableArea = function AvailableArea(_ref) {
  var _data$items, _data$items2;

  var data = _ref.data;

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var zoom = (0,react.useMemo)(function () {
    if (windowsX < 768) {
      return 13;
    }

    if (windowsX < 1024) {
      return 14;
    }

    return 14;
  }, [windowsX]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "available-areas",
    className: classnames_default()((AvailableArea_module_default()).container, 'wrapper section'),
    itemScope: true,
    itemType: "https://schema.org/Place",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((AvailableArea_module_default()).areaList),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (AvailableArea_module_default()).areaListContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (AvailableArea_module_default()).areaListIconMobile,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: data === null || data === void 0 ? void 0 : data.title
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: (AvailableArea_module_default()).list,
          children: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(function (area) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: (AvailableArea_module_default()).item,
              itemScope: true,
              itemType: "https://schema.org/Place",
              children: area === null || area === void 0 ? void 0 : area.title
            }, area === null || area === void 0 ? void 0 : area.id);
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((AvailableArea_module_default()).map, 'available-area__card'),
      itemScope: true,
      itemType: "https://schema.org/GeoCoordinates",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleMaps/* default */.Z, {
        className: (AvailableArea_module_default()).five_g_map,
        customCenter: {
          lat: data === null || data === void 0 ? void 0 : data.map_center_lat,
          lng: data === null || data === void 0 ? void 0 : data.map_center_lng
        },
        customOptions: {
          minZoom: 4,
          maxZoom: zoom,
          panControl: true,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          clickableIcons: false,
          keyboardShortcuts: false,
          scrollWeel: false,
          disableDoubleClickZoom: false,
          fullscreenControl: true
        },
        markers: data === null || data === void 0 ? void 0 : (_data$items2 = data.items) === null || _data$items2 === void 0 ? void 0 : _data$items2.map(function (_ref2) {
          var lat = _ref2.lat,
              lng = _ref2.lng;
          return {
            lat: lat,
            lng: lng
          };
        }),
        customPin: data === null || data === void 0 ? void 0 : data.map_pin_icon,
        disableMarkerClick: true,
        withoutInfoWindow: true
      })
    })]
  });
};

/* harmony default export */ var AvailableArea_AvailableArea = (AvailableArea);
// EXTERNAL MODULE: ./components/common/InfoArea/InfoArea.module.scss
var InfoArea_module = __webpack_require__(77300);
var InfoArea_module_default = /*#__PURE__*/__webpack_require__.n(InfoArea_module);
;// CONCATENATED MODULE: ./components/common/InfoArea/InfoArea.js






var InfoArea = function InfoArea(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "info-area",
    className: classnames_default()((InfoArea_module_default()).container, 'wrapper section'),
    itemScope: true,
    itemType: "https://schema.org/Article",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((InfoArea_module_default()).imageContainer, 'card'),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        alt: data === null || data === void 0 ? void 0 : data.title,
        title: data === null || data === void 0 ? void 0 : data.title,
        src: data === null || data === void 0 ? void 0 : data.image,
        width: 670,
        height: 504
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()((InfoArea_module_default()).decription, 'card'),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: data === null || data === void 0 ? void 0 : data.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: data === null || data === void 0 ? void 0 : data.description
      })]
    })]
  });
};

/* harmony default export */ var InfoArea_InfoArea = (InfoArea);
// EXTERNAL MODULE: ./components/fiber/AboutUs/index.module.scss
var AboutUs_index_module = __webpack_require__(8266);
var index_module_default = /*#__PURE__*/__webpack_require__.n(AboutUs_index_module);
;// CONCATENATED MODULE: ./components/fiber/AboutUs/index.jsx





var AboutUs = function AboutUs(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (index_module_default()).aboutUs,
    itemScope: true,
    itemType: "https://schema.org/Organization",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServicesOperations */.bi, {
        data: data
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CardBlock */.qp, {
        gridValue: 4,
        data: data,
        withoutTitle: true
      })]
    })
  });
};
// EXTERNAL MODULE: ./domains/fiber/index.js + 2 modules
var fiber = __webpack_require__(67562);
// EXTERNAL MODULE: ./components/fiber/FiberOffers/FiberOfferItem/index.module.scss
var FiberOfferItem_index_module = __webpack_require__(84384);
var FiberOfferItem_index_module_default = /*#__PURE__*/__webpack_require__.n(FiberOfferItem_index_module);
;// CONCATENATED MODULE: ./components/fiber/FiberOffers/FiberOfferItem/index.js









var renderIncludes = function renderIncludes(item, index) {
  var _item$sections;

  return item === null || item === void 0 ? void 0 : (_item$sections = item.sections) === null || _item$sections === void 0 ? void 0 : _item$sections.map(function (i) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FiberOfferItem_index_module_default()).includingItem,
      itemScope: true,
      itemType: "https://schema.org/ImageObject",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/fiber".concat(i === null || i === void 0 ? void 0 : i.icon),
        width: 24,
        height: 24,
        alt: i === null || i === void 0 ? void 0 : i.text,
        title: i === null || i === void 0 ? void 0 : i.text
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: i === null || i === void 0 ? void 0 : i.text
      })]
    }, i === null || i === void 0 ? void 0 : i.text);
  });
};

var FiberOfferItem = function FiberOfferItem(_ref) {
  var offerItem = _ref.offerItem;
  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var handleRoute = function handleRoute() {
    router.push("/fiber-check?tariff=".concat(offerItem === null || offerItem === void 0 ? void 0 : offerItem.key));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (FiberOfferItem_index_module_default()).cardWrapper,
    itemScope: true,
    itemType: "https://schema.org/ListItem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (FiberOfferItem_index_module_default()).headingText,
      children: offerItem === null || offerItem === void 0 ? void 0 : offerItem.heading_text
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FiberOfferItem_index_module_default()).speedContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: offerItem === null || offerItem === void 0 ? void 0 : offerItem.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (FiberOfferItem_index_module_default()).rectangle
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FiberOfferItem_index_module_default()).priceContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: offerItem === null || offerItem === void 0 ? void 0 : offerItem.price
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: ["\u20BC/", t('esim:common.monthly')]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
      onClick: handleRoute,
      children: offerItem === null || offerItem === void 0 ? void 0 : offerItem.button_text
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FiberOfferItem_index_module_default()).includes,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: t('fiber:tariff.includes')
      }), renderIncludes(offerItem)]
    })]
  }, offerItem === null || offerItem === void 0 ? void 0 : offerItem.key);
};

/* harmony default export */ var FiberOffers_FiberOfferItem = (FiberOfferItem);
// EXTERNAL MODULE: ./components/fiber/FiberOffers/index.module.scss
var FiberOffers_index_module = __webpack_require__(55231);
var FiberOffers_index_module_default = /*#__PURE__*/__webpack_require__.n(FiberOffers_index_module);
;// CONCATENATED MODULE: ./components/fiber/FiberOffers/index.js










var FiberOffers = function FiberOffers(_ref) {
  var data = _ref.data;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      lang = _useTranslation.lang;

  var _fiberHooks$useFiberT = fiber/* hooks.useFiberTariffs */.PT.useFiberTariffs({
    lang: lang
  }),
      fiberTariffs = _fiberHooks$useFiberT.data;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()('wrapper', (FiberOffers_index_module_default()).offerWrapper),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
      children: [data === null || data === void 0 ? void 0 : data.title, fiberTariffs === null || fiberTariffs === void 0 ? void 0 : fiberTariffs.title]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SliderWrapper */.h2, {
      arrows: true,
      options: {
        infinite: (fiberTariffs === null || fiberTariffs === void 0 ? void 0 : fiberTariffs.length) > 4,
        slidesToShow: 4
      },
      className: '',
      nextArrow: true,
      prevArrow: true,
      shadow: null,
      children: fiberTariffs === null || fiberTariffs === void 0 ? void 0 : fiberTariffs.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(FiberOffers_FiberOfferItem, {
          offerItem: item
        }, item === null || item === void 0 ? void 0 : item.key);
      })
    })]
  });
};

/* harmony default export */ var fiber_FiberOffers = (FiberOffers);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/index.mjs
var usehooks_ts_dist = __webpack_require__(2969);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(53431);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(48740);
// EXTERNAL MODULE: ./components/ui/Modals/Success/SuccessModal.js + 1 modules
var SuccessModal = __webpack_require__(81086);
// EXTERNAL MODULE: ./utils/formatPhoneNumber.js
var formatPhoneNumber = __webpack_require__(53836);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(97043);
// EXTERNAL MODULE: ./components/fiber/RequestNewAddressModal/RequestNewAddress.module.scss
var RequestNewAddress_module = __webpack_require__(49404);
var RequestNewAddress_module_default = /*#__PURE__*/__webpack_require__.n(RequestNewAddress_module);
;// CONCATENATED MODULE: ./components/fiber/RequestNewAddressModal/RequestNewAddress.js





/* eslint-disable react-hooks/exhaustive-deps */
















var RequestNewAddress = function RequestNewAddress(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$closeModalAction = _ref.closeModalAction,
      closeModalAction = _ref$closeModalAction === void 0 ? function () {
    return null;
  } : _ref$closeModalAction,
      className = _ref.className,
      classNameInner = _ref.classNameInner,
      city = _ref.city,
      street = _ref.street,
      house = _ref.house;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var _useState = (0,react.useState)(''),
      captcha = _useState[0],
      setCaptcha = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showError = _useState2[0],
      setShowError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showSuccess = _useState3[0],
      setShowSuccess = _useState3[1];

  var closeModal = function closeModal(event) {
    if (event.key === 'Escape') {
      closeModalAction();
    }
  };

  react.useEffect(function () {
    document.addEventListener('keydown', closeModal);
    return function () {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);

  var _fiberHooks$useFiberC = fiber/* hooks.useFiberConnectionRequest */.PT.useFiberConnectionRequest(),
      _fiberHooks$useFiberC2 = (0,slicedToArray/* default */.Z)(_fiberHooks$useFiberC, 1),
      connectionRequest = _fiberHooks$useFiberC2[0];

  var validationSchema = es/* object */.Ry({
    name: es/* string */.Z_().required(t('common:Required')),
    phone: es/* string */.Z_().required(t('common:Required')).length(9, t('common:Required'))
  });
  var houseDetailed = "".concat(city === null || city === void 0 ? void 0 : city.name, ", ").concat(street, ", ").concat(house);
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      name: '',
      phone: ''
    },
    validationSchema: validationSchema,
    validateOnMount: true,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
        var data;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = {
                  address: houseDetailed,
                  name: values.name,
                  type: 'individual',
                  platform: 'bakcell_web',
                  phone_number: values.phone,
                  'g-recaptcha-response': captcha
                };
                _context.next = 4;
                return connectionRequest({
                  data: data
                }).unwrap();

              case 4:
                setShowSuccess(true);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                setShowError(true);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });
  (0,react.useEffect)(function () {
    formik.resetForm();
    setCaptcha('');

    if ( true && window.grecaptcha) {
      window.grecaptcha.reset();
    }
  }, [active]);

  var onChange = function onChange(value) {
    formik.setFieldValue('captcha', value);
    setCaptcha(value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(RequestNewAddress_module_default()).wrap, (0,defineProperty/* default */.Z)({}, (RequestNewAddress_module_default()).open, active), className]),
    itemScope: true,
    itemType: "https://schema.org/Action",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()([(RequestNewAddress_module_default()).pinInner, classNameInner]),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (RequestNewAddress_module_default()).pinContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (RequestNewAddress_module_default()).title,
          children: t('fiber:modals.requestAddressTitle')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (RequestNewAddress_module_default()).description,
          dangerouslySetInnerHTML: {
            __html: t('fiber:modals.requestAddressText')
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (RequestNewAddress_module_default()).address,
          children: houseDetailed
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (RequestNewAddress_module_default()).form_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            onBlur: formik.handleBlur('name'),
            error: formik.touched.name && formik.errors.name,
            value: formik.values.name,
            onChange: function onChange(value) {
              formik.setFieldValue('name', value);
            },
            label: t('common:Fullname'),
            iconClass: (RequestNewAddress_module_default()).pin_input,
            "data-testid": "requestAdress-name-input"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            onBlur: formik.handleBlur('phone'),
            error: formik.touched.phone && formik.errors.phone,
            value: formik.values.phone,
            onChange: function onChange(value) {
              var _formatPhoneNumber;

              var formattedPhone = (_formatPhoneNumber = (0,formatPhoneNumber/* formatPhoneNumber */.u)(value)) === null || _formatPhoneNumber === void 0 ? void 0 : _formatPhoneNumber.replace(/[+-]/g, '').replace('994', '');
              formik.setFieldValue('phone', formattedPhone.replace('994', ''));
            },
            label: t('common:Phone'),
            placeholder: '+994-XX-XXX-XX-XX',
            mask: '+\\9\\9\\4-99-999-99-99',
            iconClass: (RequestNewAddress_module_default()).pin_input,
            "data-testid": "requestAdress-phone-input"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (RequestNewAddress_module_default()).terms_text,
          children: t('fiber:modals.modalTerms')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (RequestNewAddress_module_default()).close,
          onClick: closeModalAction,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (RequestNewAddress_module_default()).recaptcha,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
            sitekey: constants/* envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY */.ie.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default',
            onChange: onChange,
            hl: lang
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: formik.handleSubmit,
          variant: "normal",
          disabled: !formik.isValid || !captcha,
          children: t('common:Apply')
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      active: showError,
      icon: "/assets/error.png",
      setActive: function setActive() {
        return setShowError(false);
      },
      children: t('esim:common.errorTitle')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessModal/* SuccessModal */.i, {
      active: showSuccess,
      title: t('fiber:modals.successTitle'),
      description: t('fiber:modals.successText'),
      setSuccessModal: function setSuccessModal() {
        return setShowSuccess(false);
      },
      children: t('esim:common.successMessage')
    })]
  });
};

/* harmony default export */ var RequestNewAddressModal_RequestNewAddress = (RequestNewAddress);
// EXTERNAL MODULE: ./components/fiber/CheckConnection/CheckConnection.module.scss
var CheckConnection_module = __webpack_require__(6992);
var CheckConnection_module_default = /*#__PURE__*/__webpack_require__.n(CheckConnection_module);
;// CONCATENATED MODULE: ./components/fiber/CheckConnection/CheckConnection.js















var CheckConnection = function CheckConnection(_ref) {
  var data = _ref.data;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var router = (0,next_router.useRouter)();
  var param = router.query;

  var _useState = (0,react.useState)(),
      city = _useState[0],
      setCity = _useState[1];

  var _useState2 = (0,react.useState)(),
      street = _useState2[0],
      setStreet = _useState2[1];

  var _useState3 = (0,react.useState)(),
      house = _useState3[0],
      setHouse = _useState3[1];

  var _useToggle = (0,usehooks_ts_dist/* useToggle */.OT)(false),
      _useToggle2 = (0,slicedToArray/* default */.Z)(_useToggle, 2),
      notFoundDialog = _useToggle2[0],
      setNotFoundDialog = _useToggle2[1];

  var _useState4 = (0,react.useState)(false),
      showCheckAddress = _useState4[0],
      setShowCheckAddress = _useState4[1];

  var _fiberHooks$useFiberC = fiber/* hooks.useFiberCities */.PT.useFiberCities({
    lang: lang
  }),
      fiberCities = _fiberHooks$useFiberC.data;

  var findDefaultCity = fiberCities === null || fiberCities === void 0 ? void 0 : fiberCities.find(function (el) {
    return (el === null || el === void 0 ? void 0 : el.key) === '1';
  });

  var _fiberHooks$useFiberS = fiber/* hooks.useFiberStreets */.PT.useFiberStreets({
    cityId: (city === null || city === void 0 ? void 0 : city.key) || (findDefaultCity === null || findDefaultCity === void 0 ? void 0 : findDefaultCity.key),
    lang: lang
  }, {
    skip: !(city || findDefaultCity)
  }),
      fiberStreets = _fiberHooks$useFiberS.data;

  var filteredStreet = fiberStreets === null || fiberStreets === void 0 ? void 0 : fiberStreets.find(function (el) {
    return (el === null || el === void 0 ? void 0 : el.name) === (street || (el === null || el === void 0 ? void 0 : el.key) === param.street);
  });

  var _fiberHooks$useFiberH = fiber/* hooks.useFiberHouses */.PT.useFiberHouses({
    streetId: filteredStreet === null || filteredStreet === void 0 ? void 0 : filteredStreet.key,
    lang: lang
  }, {
    skip: !filteredStreet
  }),
      fiberHouses = _fiberHooks$useFiberH.data;

  var filteredHouse = fiberHouses === null || fiberHouses === void 0 ? void 0 : fiberHouses.find(function (el) {
    return (el === null || el === void 0 ? void 0 : el.name) === house || (el === null || el === void 0 ? void 0 : el.key) === param.house;
  });

  var cityHandle = function cityHandle(value) {
    setCity(value);
    setStreet('');
    setHouse('');
  };

  var streetHandle = function streetHandle(value) {
    setStreet(value);
    setHouse('');
  };

  var handleCheckout = function handleCheckout() {
    if (!filteredHouse) {
      setNotFoundDialog();
    } else {
      router.push({
        pathname: '/fiber-check',
        query: {
          cityKey: (city === null || city === void 0 ? void 0 : city.key) || (findDefaultCity === null || findDefaultCity === void 0 ? void 0 : findDefaultCity.key),
          cityName: (city === null || city === void 0 ? void 0 : city.name) || (findDefaultCity === null || findDefaultCity === void 0 ? void 0 : findDefaultCity.name),
          streetKey: filteredStreet === null || filteredStreet === void 0 ? void 0 : filteredStreet.key,
          houseKey: filteredHouse === null || filteredHouse === void 0 ? void 0 : filteredHouse.key,
          houseName: filteredHouse === null || filteredHouse === void 0 ? void 0 : filteredHouse.name,
          streetName: filteredStreet === null || filteredStreet === void 0 ? void 0 : filteredStreet.name
        }
      });
    }
  };

  var closeHandle = function closeHandle() {
    setCity(findDefaultCity);
    setStreet('');
    setHouse('');
    setShowCheckAddress(!showCheckAddress);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()(['wrapper', (CheckConnection_module_default()).check__connection, (0,defineProperty/* default */.Z)({}, (CheckConnection_module_default()).activeMobile, showCheckAddress)]),
    itemScope: true,
    itemType: "https://schema.org/Action",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CheckConnection_module_default()).top,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {
        className: (CheckConnection_module_default()).close_btn,
        onClick: closeHandle
      }), (data === null || data === void 0 ? void 0 : data.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        titleModify: "title--large",
        children: data === null || data === void 0 ? void 0 : data.title
      }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: classnames_default()('text--small'),
        isHtml: true,
        children: data.description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      className: (CheckConnection_module_default()).check__form,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Select */.Ph, {
        value: city || findDefaultCity,
        data: fiberCities,
        label: t('common:city'),
        onChange: cityHandle,
        className: (CheckConnection_module_default()).select,
        withoutIcon: true,
        "data-testid": 'checkConnection-city'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InputAutoCompleteForCheckout */.WK, {
        label: t('common:street'),
        setValue: streetHandle,
        value: street,
        models: fiberStreets,
        classname: (CheckConnection_module_default()).fiber__input,
        id: "street",
        required: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InputAutoCompleteForCheckout */.WK, {
        label: t('common:home'),
        setValue: setHouse,
        value: house,
        models: fiberHouses,
        classname: (CheckConnection_module_default()).fiber__input,
        id: "house",
        disabled: !street,
        dataTestId: 'checkConnection-house'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
        type: "button",
        size: "normal",
        className: (CheckConnection_module_default()).button,
        disabled: !house,
        onClick: handleCheckout,
        "data-testid": 'checkConnection-button',
        children: data === null || data === void 0 ? void 0 : data.button_text
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequestNewAddressModal_RequestNewAddress, {
      closeModalAction: setNotFoundDialog,
      active: notFoundDialog,
      city: city || findDefaultCity,
      street: street,
      house: house
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CheckConnection_module_default()).mobile__btns,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CheckConnection_module_default()).form__btns,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          variant: "transparent",
          className: (CheckConnection_module_default()).cancel,
          onClick: closeHandle,
          children: t('fiber:form.card.cancel')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          onClick: handleCheckout,
          disabled: !house,
          className: (CheckConnection_module_default()).check,
          children: t('fiber:form.card.check')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
        className: (CheckConnection_module_default()).form_btn,
        onClick: function onClick() {
          return setShowCheckAddress(true);
        },
        children: t('fiber:form.card.checkAddress')
      })]
    })]
  });
};

/* harmony default export */ var CheckConnection_CheckConnection = (CheckConnection);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(648);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(16814);
;// CONCATENATED MODULE: ./components/SvgComponents/Reminder.js

var Reminder = function Reminder() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask0_595_2384)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M2 10.0002C2 8.33353 2.37083 6.80436 3.1125 5.4127C3.85417 4.02103 4.85 2.86686 6.1 1.9502L7.275 3.5502C6.275 4.28353 5.47917 5.20853 4.8875 6.3252C4.29583 7.44186 4 8.66686 4 10.0002H2ZM20 10.0002C20 8.66686 19.7042 7.44186 19.1125 6.3252C18.5208 5.20853 17.725 4.28353 16.725 3.5502L17.9 1.9502C19.15 2.86686 20.1458 4.02103 20.8875 5.4127C21.6292 6.80436 22 8.33353 22 10.0002H20ZM4 19.0002V17.0002H6V10.0002C6 8.61686 6.41667 7.3877 7.25 6.3127C8.08333 5.2377 9.16667 4.53353 10.5 4.2002V3.5002C10.5 3.08353 10.6458 2.72936 10.9375 2.4377C11.2292 2.14603 11.5833 2.0002 12 2.0002C12.4167 2.0002 12.7708 2.14603 13.0625 2.4377C13.3542 2.72936 13.5 3.08353 13.5 3.5002V4.2002C14.8333 4.53353 15.9167 5.2377 16.75 6.3127C17.5833 7.3877 18 8.61686 18 10.0002V17.0002H20V19.0002H4ZM12 22.0002C11.45 22.0002 10.9792 21.8044 10.5875 21.4127C10.1958 21.021 10 20.5502 10 20.0002H14C14 20.5502 13.8042 21.021 13.4125 21.4127C13.0208 21.8044 12.55 22.0002 12 22.0002ZM8 17.0002H16V10.0002C16 8.9002 15.6083 7.95853 14.825 7.1752C14.0417 6.39186 13.1 6.0002 12 6.0002C10.9 6.0002 9.95833 6.39186 9.175 7.1752C8.39167 7.95853 8 8.9002 8 10.0002V17.0002Z",
        fill: "#1C1B1F"
      })
    })
  });
};
;// CONCATENATED MODULE: ./components/SvgComponents/GalleryArrow.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var GalleryArrow = function GalleryArrow(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      mask: "url(#mask0_736_851)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M16.4937 5.25833L9.80199 11.8583C9.71865 11.9417 9.71865 12.075 9.80199 12.15L16.4937 18.75L13.227 18.75L8.21865 13.7417C7.26032 12.7833 7.26032 11.225 8.21865 10.2667L13.227 5.25833L16.4937 5.25833Z",
        fill: "#200000"
      })
    })
  }));
};
// EXTERNAL MODULE: ./domains/mini-market/index.js + 3 modules
var mini_market = __webpack_require__(897);
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceImages/index.module.scss
var DeviceImages_index_module = __webpack_require__(98042);
var DeviceImages_index_module_default = /*#__PURE__*/__webpack_require__.n(DeviceImages_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceImages/index.js


/* eslint-disable react/no-unknown-property */







var DeviceImages = function DeviceImages(_ref) {
  var images = _ref.images;
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();

  var _useSelector = (0,react_redux_es/* useSelector */.v9)(mini_market/* selectors.selectMiniMarket */.wl.K),
      selectedImage = _useSelector.selectedImage;

  (0,react.useEffect)(function () {
    dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(images === null || images === void 0 ? void 0 : images[0]));
  }, []);

  var handleClick = function handleClick(image) {
    dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(image));
  };

  return images.map(function (image) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      dataImageId: image,
      onClick: function onClick() {
        return handleClick(image);
      },
      className: classnames_default()((DeviceImages_index_module_default()).singleImage, (0,defineProperty/* default */.Z)({}, (DeviceImages_index_module_default()).singleImage__active, selectedImage === image)),
      itemScope: true,
      itemType: "https://schema.org/ImageObject",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        objectFit: "contain",
        alt: "device small image",
        title: "Device Small Image",
        src: image,
        width: 64,
        height: 64
      })
    }, image);
  });
};
// EXTERNAL MODULE: ./components/device/DeviceDetails/ImageModal/index.module.scss
var ImageModal_index_module = __webpack_require__(90153);
var ImageModal_index_module_default = /*#__PURE__*/__webpack_require__.n(ImageModal_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/ImageModal/index.js
















var ImageModal = function ImageModal(_ref) {
  var _device$album6, _device$album6$photos, _device$album7, _device$album9, _device$album12;

  var modalActive = _ref.modalActive,
      isMobileView = _ref.isMobileView,
      device = _ref.device,
      setModalActive = _ref.setModalActive,
      setReminderModalActive = _ref.setReminderModalActive;
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();

  var _useSelector = (0,react_redux_es/* useSelector */.v9)(mini_market/* selectors.selectMiniMarket */.wl.K),
      selectedImage = _useSelector.selectedImage,
      buttonDisabled = _useSelector.buttonDisabled;

  var router = (0,next_router.useRouter)();

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var scrollableDivRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      initialized = _useState[0],
      setInitialized = _useState[1];

  var handleNextArrowClick = function handleNextArrowClick() {
    if (scrollableDivRef.current && !buttonDisabled) {
      var _device$album, _device$album$photos, _device$album2, _device$album2$photos;

      var currentIndex = device === null || device === void 0 ? void 0 : (_device$album = device.album) === null || _device$album === void 0 ? void 0 : (_device$album$photos = _device$album.photos) === null || _device$album$photos === void 0 ? void 0 : _device$album$photos.findIndex(function (i) {
        return i === selectedImage;
      });

      if (currentIndex !== (device === null || device === void 0 ? void 0 : (_device$album2 = device.album) === null || _device$album2 === void 0 ? void 0 : (_device$album2$photos = _device$album2.photos) === null || _device$album2$photos === void 0 ? void 0 : _device$album2$photos.length) - 1) {
        var _device$album3;

        dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(device === null || device === void 0 ? void 0 : (_device$album3 = device.album) === null || _device$album3 === void 0 ? void 0 : _device$album3.photos[currentIndex + 1]));
      }

      var scrollContainer = scrollableDivRef.current;
      var selectedImageElement = scrollContainer.querySelector("[dataImageId='".concat(selectedImage, "']"));

      if (selectedImageElement) {
        var scrollContainerRect = scrollContainer.getBoundingClientRect();
        var selectedImageRect = selectedImageElement.getBoundingClientRect();

        if (selectedImageRect.right > scrollContainerRect.right) {
          scrollContainer.scrollBy({
            left: 160,
            behavior: 'smooth'
          });
        }
      }
    }
  };

  var handlePrevArrowClick = function handlePrevArrowClick() {
    if (scrollableDivRef.current && !buttonDisabled) {
      var _device$album4, _device$album4$photos;

      var currentIndex = device === null || device === void 0 ? void 0 : (_device$album4 = device.album) === null || _device$album4 === void 0 ? void 0 : (_device$album4$photos = _device$album4.photos) === null || _device$album4$photos === void 0 ? void 0 : _device$album4$photos.findIndex(function (i) {
        return i === selectedImage;
      });

      if (currentIndex !== 0) {
        var _device$album5;

        dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(device === null || device === void 0 ? void 0 : (_device$album5 = device.album) === null || _device$album5 === void 0 ? void 0 : _device$album5.photos[currentIndex - 1]));
      }

      var scrollContainer = scrollableDivRef.current;
      var selectedImageElement = scrollContainer.querySelector("[dataImageId='".concat(selectedImage, "']"));

      if (selectedImageElement) {
        var scrollContainerRect = scrollContainer.getBoundingClientRect();
        var selectedImageRect = selectedImageElement.getBoundingClientRect();

        if (selectedImageRect.left < scrollContainerRect.left) {
          scrollContainer.scrollBy({
            left: -160,
            behavior: 'smooth'
          });
        }
      }
    }
  };

  var sliderRef = (0,react.useRef)(null);
  var index = device === null || device === void 0 ? void 0 : (_device$album6 = device.album) === null || _device$album6 === void 0 ? void 0 : (_device$album6$photos = _device$album6.photos) === null || _device$album6$photos === void 0 ? void 0 : _device$album6$photos.findIndex(function (image) {
    return image === selectedImage;
  });
  (0,react.useEffect)(function () {
    sliderRef.current.slickGoTo(index);
  }, [index]);

  var reminderHandler = function reminderHandler() {
    setReminderModalActive(true);
    setModalActive(false);
  };

  var routeToOrder = function routeToOrder() {
    router.push({
      pathname: '/order',
      query: {
        itemId: router.query.dynamicPage[0],
        webview: router.query.webview
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Modal */.u_, {
    className: (ImageModal_index_module_default()).customModal,
    active: modalActive,
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ImageModal_index_module_default()).top,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ImageModal_index_module_default()).firstTitle,
        children: device === null || device === void 0 ? void 0 : (_device$album7 = device.album) === null || _device$album7 === void 0 ? void 0 : _device$album7.name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ImageModal_index_module_default()).right,
        children: [!isMobileView && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ImageModal_index_module_default()).modalPrice,
            children: device !== null && device !== void 0 && device.new_price ? (device === null || device === void 0 ? void 0 : device.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [' ', /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (ImageModal_index_module_default()).discountPrice,
                children: [device === null || device === void 0 ? void 0 : device.old_price, "\u20BC"]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: (ImageModal_index_module_default()).price,
                children: [device === null || device === void 0 ? void 0 : device.new_price, " \u20BC"]
              })]
            }) : (device === null || device === void 0 ? void 0 : device.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (ImageModal_index_module_default()).price,
              children: [device === null || device === void 0 ? void 0 : device.old_price, " \u20BC"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ImageModal_index_module_default()).btn,
            children: device !== null && device !== void 0 && device.in_stock ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              onClick: function onClick() {
                return routeToOrder();
              },
              id: "testingId",
              children: t('common:OrderNow')
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
              onClick: reminderHandler,
              variant: "outline",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Reminder, {}), " ", t('common:RemindMe')]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {
          onClick: function onClick() {
            return setModalActive(false);
          }
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ImageModal_index_module_default()).bottom,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ImageModal_index_module_default()).imageWrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (ImageModal_index_module_default()).mainImage,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SliderWrapper */.h2, {
            className: (ImageModal_index_module_default()).customSlider,
            arrows: false,
            options: {
              infinite: false,
              slidesToShow: 1,
              autoplay: false,
              dots: false,
              speed: 300,
              afterChange: function afterChange(index) {
                var _device$album8, _device$album8$photos;

                dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(device === null || device === void 0 ? void 0 : (_device$album8 = device.album) === null || _device$album8 === void 0 ? void 0 : (_device$album8$photos = _device$album8.photos) === null || _device$album8$photos === void 0 ? void 0 : _device$album8$photos[index]));
                dispatch(mini_market/* actions.setButtonDisabled */.Nw.setButtonDisabled(false));
                setInitialized(true);
              },
              beforeChange: function beforeChange() {
                if (initialized) {
                  dispatch(mini_market/* actions.setButtonDisabled */.Nw.setButtonDisabled(true));
                }
              },
              responsive: [{
                breakpoint: 1025,
                settings: {
                  infinite: false,
                  arrows: false,
                  dots: false,
                  slidesToShow: 1
                }
              }, {
                breakpoint: 767,
                settings: {
                  infinite: false,
                  arrows: false,
                  dots: false,
                  slidesToShow: 1
                }
              }]
            },
            ref: sliderRef,
            children: device === null || device === void 0 ? void 0 : (_device$album9 = device.album) === null || _device$album9 === void 0 ? void 0 : _device$album9.photos.map(function (image) {
              var _device$album10, _device$album11;

              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: selectedImage && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: (ImageModal_index_module_default()).sliderImage,
                  src: selectedImage,
                  alt: device === null || device === void 0 ? void 0 : (_device$album10 = device.album) === null || _device$album10 === void 0 ? void 0 : _device$album10.name,
                  title: device === null || device === void 0 ? void 0 : (_device$album11 = device.album) === null || _device$album11 === void 0 ? void 0 : _device$album11.name,
                  width: 590,
                  height: 590
                })
              }, image);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ImageModal_index_module_default()).images,
          children: [!isMobileView && /*#__PURE__*/(0,jsx_runtime.jsx)(GalleryArrow, {
            onClick: handlePrevArrowClick,
            className: (ImageModal_index_module_default()).prev
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (ImageModal_index_module_default()).overflowWrapper,
            ref: scrollableDivRef,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeviceImages, {
              images: device === null || device === void 0 ? void 0 : (_device$album12 = device.album) === null || _device$album12 === void 0 ? void 0 : _device$album12.photos
            })
          }), !isMobileView && /*#__PURE__*/(0,jsx_runtime.jsx)(GalleryArrow, {
            onClick: handleNextArrowClick,
            className: (ImageModal_index_module_default()).next
          })]
        })]
      })
    })]
  });
};
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceOptions/index.module.scss
var DeviceOptions_index_module = __webpack_require__(25341);
var DeviceOptions_index_module_default = /*#__PURE__*/__webpack_require__.n(DeviceOptions_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceOptions/index.js








var DeviceOptions = function DeviceOptions(_ref) {
  var capacities = _ref.capacities,
      colors = _ref.colors,
      selectedCapacity = _ref.selectedCapacity,
      selectedColor = _ref.selectedColor,
      variations = _ref.variations;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var capacityHandler = function capacityHandler(id) {
    var _variations$find;

    var slug = variations === null || variations === void 0 ? void 0 : (_variations$find = variations.find(function (variation) {
      return (variation === null || variation === void 0 ? void 0 : variation.storage_id) === id && (variation === null || variation === void 0 ? void 0 : variation.color_id) === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.id);
    })) === null || _variations$find === void 0 ? void 0 : _variations$find.slug;
    router.push(slug);
  };

  var colorHandler = function colorHandler(id) {
    var _variations$find2;

    var slug = variations === null || variations === void 0 ? void 0 : (_variations$find2 = variations.find(function (variation) {
      return (variation === null || variation === void 0 ? void 0 : variation.color_id) === id && (variation === null || variation === void 0 ? void 0 : variation.storage_id) === (selectedCapacity === null || selectedCapacity === void 0 ? void 0 : selectedCapacity.id);
    })) === null || _variations$find2 === void 0 ? void 0 : _variations$find2.slug;
    router.push(slug);
  };

  var splitVariationsByStorage = function splitVariationsByStorage() {
    var _variations$filter;

    var storageIds = variations === null || variations === void 0 ? void 0 : (_variations$filter = variations.filter(function (variation) {
      return (variation === null || variation === void 0 ? void 0 : variation.color_id) === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.id);
    })) === null || _variations$filter === void 0 ? void 0 : _variations$filter.map(function (variation) {
      return variation === null || variation === void 0 ? void 0 : variation.storage_id;
    });
    var filteredCapacities = capacities.filter(function (storage) {
      return storageIds === null || storageIds === void 0 ? void 0 : storageIds.includes(storage === null || storage === void 0 ? void 0 : storage.id);
    });
    return filteredCapacities;
  };

  var splitVariationsByColor = function splitVariationsByColor() {
    return colors === null || colors === void 0 ? void 0 : colors.filter(function (color) {
      return variations.find(function (variation) {
        return (variation === null || variation === void 0 ? void 0 : variation.color_id) === (color === null || color === void 0 ? void 0 : color.id) && (variation === null || variation === void 0 ? void 0 : variation.storage_id) === (selectedCapacity === null || selectedCapacity === void 0 ? void 0 : selectedCapacity.id);
      });
    });
  };

  var filteredColors = splitVariationsByColor();
  var filteredStorages = splitVariationsByStorage();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!!(filteredStorages !== null && filteredStorages !== void 0 && filteredStorages.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (DeviceOptions_index_module_default()).capacityContainer,
      itemScope: true,
      itemType: "https://schema.org/Thing",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (DeviceOptions_index_module_default()).selected,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [t('common:Storage'), ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [selectedCapacity === null || selectedCapacity === void 0 ? void 0 : selectedCapacity.size, " ", selectedCapacity === null || selectedCapacity === void 0 ? void 0 : selectedCapacity.unit]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (DeviceOptions_index_module_default()).options,
          children: filteredStorages === null || filteredStorages === void 0 ? void 0 : filteredStorages.map(function (capacityItem) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              onClick: function onClick() {
                return capacityHandler(capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.id);
              },
              className: classnames_default()((DeviceOptions_index_module_default()).option, (0,defineProperty/* default */.Z)({}, (DeviceOptions_index_module_default()).option__active, (capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.id) === (selectedCapacity === null || selectedCapacity === void 0 ? void 0 : selectedCapacity.id))),
              children: [capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.size, " ", capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.unit]
            }, capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.id);
          })
        })]
      })
    }), (filteredColors === null || filteredColors === void 0 ? void 0 : filteredColors.length) > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (DeviceOptions_index_module_default()).colorContainer,
      itemScope: true,
      itemType: "https://schema.org/Thing",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (DeviceOptions_index_module_default()).selected,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [t('common:Color'), ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [" ", selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.title]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (DeviceOptions_index_module_default()).options,
          children: filteredColors === null || filteredColors === void 0 ? void 0 : filteredColors.map(function (color) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onClick: function onClick() {
                return colorHandler(color === null || color === void 0 ? void 0 : color.id);
              },
              className: classnames_default()([(DeviceOptions_index_module_default()).colorOption, (0,defineProperty/* default */.Z)({}, (DeviceOptions_index_module_default()).colorOption__active, (color === null || color === void 0 ? void 0 : color.id) === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.id))]),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (DeviceOptions_index_module_default()).inside,
                style: {
                  backgroundColor: color === null || color === void 0 ? void 0 : color.hex_code
                }
              })
            }, color === null || color === void 0 ? void 0 : color.id);
          })
        })]
      })
    })]
  });
};
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceCharacteristics/SingleCharacteristic/index.module.scss
var SingleCharacteristic_index_module = __webpack_require__(44195);
var SingleCharacteristic_index_module_default = /*#__PURE__*/__webpack_require__.n(SingleCharacteristic_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceCharacteristics/SingleCharacteristic/index.js





var SingleCharacteristic = function SingleCharacteristic(_ref) {
  var title = _ref.title,
      value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SingleCharacteristic_index_module_default()).value,
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SingleCharacteristic_index_module_default()).value__texts,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: value
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (SingleCharacteristic_index_module_default()).value__hr
    })]
  });
};

/* harmony default export */ var DeviceCharacteristics_SingleCharacteristic = (SingleCharacteristic);
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceCharacteristics/CharacteristicsItem/index.module.scss
var CharacteristicsItem_index_module = __webpack_require__(30585);
var CharacteristicsItem_index_module_default = /*#__PURE__*/__webpack_require__.n(CharacteristicsItem_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceCharacteristics/CharacteristicsItem/index.js





var CharacteristicsItem = function CharacteristicsItem(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      values = _ref.values;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (CharacteristicsItem_index_module_default()).singleCharacteristics,
    itemScope: true,
    itemType: "https://schema.org/ItemList",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CharacteristicsItem_index_module_default()).singleCharacteristics__top,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CharacteristicsItem_index_module_default()).iconHolder,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: icon,
          width: 24,
          height: 24,
          alt: title,
          title: title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [" ", title]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CharacteristicsItem_index_module_default()).singleCharacteristics__bottom,
      children: values === null || values === void 0 ? void 0 : values.map(function (characteristicValue) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DeviceCharacteristics_SingleCharacteristic, {
          title: characteristicValue === null || characteristicValue === void 0 ? void 0 : characteristicValue.key,
          value: characteristicValue === null || characteristicValue === void 0 ? void 0 : characteristicValue.value
        }, characteristicValue === null || characteristicValue === void 0 ? void 0 : characteristicValue.key);
      })
    })]
  });
};
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceCharacteristics/index.module.scss
var DeviceCharacteristics_index_module = __webpack_require__(29075);
var DeviceCharacteristics_index_module_default = /*#__PURE__*/__webpack_require__.n(DeviceCharacteristics_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceCharacteristics/index.js





var DeviceCharacteristics = function DeviceCharacteristics(_ref) {
  var _data$specification, _data$specification2, _data$specification2$, _data$additional_spec, _data$additional_spec2;

  var data = _ref.data;
  var theme = (0,index_module/* useTheme */.F)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (DeviceCharacteristics_index_module_default()).bottom,
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: data === null || data === void 0 ? void 0 : (_data$specification = data.specification) === null || _data$specification === void 0 ? void 0 : _data$specification.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DeviceCharacteristics_index_module_default()).characteristics,
      children: [data === null || data === void 0 ? void 0 : (_data$specification2 = data.specification) === null || _data$specification2 === void 0 ? void 0 : (_data$specification2$ = _data$specification2.boxes) === null || _data$specification2$ === void 0 ? void 0 : _data$specification2$.map(function (characteristic) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CharacteristicsItem, {
          icon: (theme === null || theme === void 0 ? void 0 : theme.resolvedTheme) === 'dark' && characteristic !== null && characteristic !== void 0 && characteristic.dark_mode_icon ? characteristic === null || characteristic === void 0 ? void 0 : characteristic.dark_mode_icon : characteristic === null || characteristic === void 0 ? void 0 : characteristic.icon,
          title: characteristic === null || characteristic === void 0 ? void 0 : characteristic.title,
          values: characteristic === null || characteristic === void 0 ? void 0 : characteristic.lines
        }, characteristic === null || characteristic === void 0 ? void 0 : characteristic.id);
      }), data === null || data === void 0 ? void 0 : (_data$additional_spec = data.additional_specification) === null || _data$additional_spec === void 0 ? void 0 : (_data$additional_spec2 = _data$additional_spec.boxes) === null || _data$additional_spec2 === void 0 ? void 0 : _data$additional_spec2.map(function (characteristic) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CharacteristicsItem, {
          icon: (theme === null || theme === void 0 ? void 0 : theme.resolvedTheme) === 'dark' && characteristic !== null && characteristic !== void 0 && characteristic.dark_mode_icon ? characteristic === null || characteristic === void 0 ? void 0 : characteristic.dark_mode_icon : characteristic === null || characteristic === void 0 ? void 0 : characteristic.icon,
          title: characteristic === null || characteristic === void 0 ? void 0 : characteristic.title,
          values: characteristic === null || characteristic === void 0 ? void 0 : characteristic.lines
        }, characteristic === null || characteristic === void 0 ? void 0 : characteristic.id);
      })]
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(24666);
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceOffers/OfferItem/index.module.scss
var OfferItem_index_module = __webpack_require__(59598);
var OfferItem_index_module_default = /*#__PURE__*/__webpack_require__.n(OfferItem_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceOffers/OfferItem/index.js




var OfferItem = function OfferItem(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      value = _ref.value;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (OfferItem_index_module_default()).offer,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (OfferItem_index_module_default()).iconHolder,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: icon,
        width: 24,
        height: 24,
        alt: title,
        title: title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OfferItem_index_module_default()).texts,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: value
      })]
    })]
  });
};
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceOffers/MonthOption/index.module.scss
var MonthOption_index_module = __webpack_require__(90648);
var MonthOption_index_module_default = /*#__PURE__*/__webpack_require__.n(MonthOption_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceOffers/MonthOption/index.js




var MonthOption = function MonthOption(_ref) {
  var option = _ref.option,
      selectedMonth = _ref.selectedMonth,
      setSelectedMonth = _ref.setSelectedMonth,
      unit = _ref.unit;

  var clickHandler = function clickHandler() {
    if (selectedMonth === option) {
      setSelectedMonth(null);
    } else {
      setSelectedMonth(option);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    onClick: clickHandler,
    className: classnames_default()((MonthOption_index_module_default()).option, (0,defineProperty/* default */.Z)({}, (MonthOption_index_module_default()).option__active, option === selectedMonth)),
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [option, " ", unit]
  });
};
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceOffers/index.module.scss
var DeviceOffers_index_module = __webpack_require__(94152);
var DeviceOffers_index_module_default = /*#__PURE__*/__webpack_require__.n(DeviceOffers_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceOffers/index.js











var DeviceOffers = function DeviceOffers(_ref) {
  var _data$instalment_paym, _data$offer, _data$offer2, _data$offer2$inclusio, _data$instalment_paym4, _data$instalment_paym5, _data$instalment_paym6, _data$instalment_paym7, _data$instalment_paym8, _data$instalment_paym9, _data$instalment_paym10;

  var data = _ref.data;

  var _useState = (0,react.useState)(Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(data === null || data === void 0 ? void 0 : (_data$instalment_paym = data.instalment_payment) === null || _data$instalment_paym === void 0 ? void 0 : _data$instalment_paym.months))),
      selectedMonth = _useState[0],
      setSelectedMonth = _useState[1];

  var _useTheme = (0,index_module/* useTheme */.F)(),
      theme = _useTheme.theme;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var installmentIcon = function installmentIcon() {
    var _data$instalment_paym2, _data$instalment_paym3;

    return theme === enums_theme/* ETheme.DARK_MODE */.X.DARK_MODE ? data === null || data === void 0 ? void 0 : (_data$instalment_paym2 = data.instalment_payment) === null || _data$instalment_paym2 === void 0 ? void 0 : _data$instalment_paym2.dark_mode_icon : data === null || data === void 0 ? void 0 : (_data$instalment_paym3 = data.instalment_payment) === null || _data$instalment_paym3 === void 0 ? void 0 : _data$instalment_paym3.icon;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (DeviceOffers_index_module_default()).right,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: data === null || data === void 0 ? void 0 : (_data$offer = data.offer) === null || _data$offer === void 0 ? void 0 : _data$offer.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (DeviceOffers_index_module_default()).offerIncludes,
      children: data === null || data === void 0 ? void 0 : (_data$offer2 = data.offer) === null || _data$offer2 === void 0 ? void 0 : (_data$offer2$inclusio = _data$offer2.inclusions) === null || _data$offer2$inclusio === void 0 ? void 0 : _data$offer2$inclusio.map(function (offer) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(OfferItem, {
          icon: offer === null || offer === void 0 ? void 0 : offer.icon,
          value: offer === null || offer === void 0 ? void 0 : offer.description,
          title: offer === null || offer === void 0 ? void 0 : offer.title
        }, offer);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (DeviceOffers_index_module_default()).birbankMonths,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DeviceOffers_index_module_default()).title,
        children: [(data === null || data === void 0 ? void 0 : (_data$instalment_paym4 = data.instalment_payment) === null || _data$instalment_paym4 === void 0 ? void 0 : _data$instalment_paym4.icon) && (data === null || data === void 0 ? void 0 : (_data$instalment_paym5 = data.instalment_payment) === null || _data$instalment_paym5 === void 0 ? void 0 : _data$instalment_paym5.dark_mode_icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: data === null || data === void 0 ? void 0 : (_data$instalment_paym6 = data.instalment_payment) === null || _data$instalment_paym6 === void 0 ? void 0 : _data$instalment_paym6.title,
          title: data === null || data === void 0 ? void 0 : (_data$instalment_paym7 = data.instalment_payment) === null || _data$instalment_paym7 === void 0 ? void 0 : _data$instalment_paym7.title,
          width: 24,
          height: 24,
          src: installmentIcon(),
          className: (DeviceOffers_index_module_default()).icon
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: data === null || data === void 0 ? void 0 : (_data$instalment_paym8 = data.instalment_payment) === null || _data$instalment_paym8 === void 0 ? void 0 : _data$instalment_paym8.title
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (DeviceOffers_index_module_default()).monthlyOptions,
        children: data === null || data === void 0 ? void 0 : (_data$instalment_paym9 = data.instalment_payment) === null || _data$instalment_paym9 === void 0 ? void 0 : (_data$instalment_paym10 = _data$instalment_paym9.months) === null || _data$instalment_paym10 === void 0 ? void 0 : _data$instalment_paym10.map(function (monthOption) {
          var _data$instalment_paym11;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(MonthOption, {
            option: monthOption,
            selectedMonth: selectedMonth,
            setSelectedMonth: setSelectedMonth,
            unit: data === null || data === void 0 ? void 0 : (_data$instalment_paym11 = data.instalment_payment) === null || _data$instalment_paym11 === void 0 ? void 0 : _data$instalment_paym11.unit
          }, monthOption);
        })
      }), selectedMonth && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DeviceOffers_index_module_default()).calculator,
        children: [lang !== 'en' && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: t('common:perMonth')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (DeviceOffers_index_module_default()).calculator__bold,
          children: [data !== null && data !== void 0 && data.new_price ? ((data === null || data === void 0 ? void 0 : data.new_price) / Number(selectedMonth)).toFixed(2) : ((data === null || data === void 0 ? void 0 : data.old_price) / Number(selectedMonth)).toFixed(2), data === null || data === void 0 ? void 0 : data.currency]
        }), lang === 'en' && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: t('common:perMonth')
        })]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceImages/MainImage/index.js




var MainImage = function MainImage(_ref) {
  var isModal = _ref.isModal,
      setModalActive = _ref.setModalActive,
      data = _ref.data;

  var _useSelector = (0,react_redux_es/* useSelector */.v9)(mini_market/* selectors.selectMiniMarket */.wl.K),
      selectedImage = _useSelector.selectedImage;

  return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
    alt: data === null || data === void 0 ? void 0 : data.name,
    title: data === null || data === void 0 ? void 0 : data.name,
    onClick: function onClick() {
      return setModalActive(true);
    },
    src: selectedImage,
    width: !isModal ? 450 : 590,
    height: !isModal ? 466 : 590,
    objectFit: "contain",
    itemScope: true,
    itemType: "https://schema.org/ImageObject"
  });
};
// EXTERNAL MODULE: ./components/device/DeviceDetails/DeviceImages/ImageSlider/index.module.scss
var ImageSlider_index_module = __webpack_require__(40246);
var ImageSlider_index_module_default = /*#__PURE__*/__webpack_require__.n(ImageSlider_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/DeviceImages/ImageSlider/index.js






var ImageSlider = function ImageSlider(_ref) {
  var images = _ref.images,
      setModalActive = _ref.setModalActive,
      data = _ref.data;
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();

  var clickHandler = function clickHandler(image) {
    setModalActive(true);
    dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(image));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SliderWrapper */.h2, {
    className: (ImageSlider_index_module_default()).customSlider,
    arrows: true,
    options: {
      infinite: true
    },
    itemScope: true,
    itemType: "https://schema.org/ImageGallery",
    children: images.map(function (image) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onClick: function onClick() {
          return clickHandler(image);
        },
        className: (ImageSlider_index_module_default()).sliderImage,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: image,
          width: 475,
          height: 475,
          alt: data === null || data === void 0 ? void 0 : data.name,
          title: data === null || data === void 0 ? void 0 : data.name
        })
      }, image);
    })
  });
};
// EXTERNAL MODULE: ./components/device/DeviceDetails/index.module.scss
var DeviceDetails_index_module = __webpack_require__(73892);
var DeviceDetails_index_module_default = /*#__PURE__*/__webpack_require__.n(DeviceDetails_index_module);
;// CONCATENATED MODULE: ./components/device/DeviceDetails/index.js

































var DeviceDetails = function DeviceDetails(_ref) {
  var _data$labels, _data$album8, _data$album9, _data$album10, _data$album11, _data$album12, _data$labels2, _data$highlights;

  var data = _ref.data;
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(''),
      captcha = _useState[0],
      setCaptcha = _useState[1];

  var _hooks$useCompleteOrd = mini_market/* hooks.useCompleteOrder */.PT.useCompleteOrder({
    captcha: captcha
  }),
      _hooks$useCompleteOrd2 = (0,slicedToArray/* default */.Z)(_hooks$useCompleteOrd, 2),
      reminderTrigger = _hooks$useCompleteOrd2[0],
      _hooks$useCompleteOrd3 = _hooks$useCompleteOrd2[1],
      error = _hooks$useCompleteOrd3.error,
      isLoading = _hooks$useCompleteOrd3.isLoading;

  var _useState2 = (0,react.useState)(false),
      buttonVisible = _useState2[0],
      setButtonVisible = _useState2[1];

  var _useWindowSize = (0,useWindowSize/* default */.Z)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var _useState3 = (0,react.useState)(false),
      modalActive = _useState3[0],
      setModalActive = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      reminderModalActive = _useState4[0],
      _setReminderModalActive = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showSuccess = _useState5[0],
      setShowSuccess = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      showError = _useState6[0],
      setShowError = _useState6[1];

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var FormSchema = es/* object */.Ry().shape({
    phone: es/* string */.Z_().matches(/^\+994-\d{2}-\d{3}-\d{2}-\d{2}$/, t('common:Required')).required(t('common:Required')),
    'g-recaptcha-response': es/* string */.Z_().required('Please complete the reCAPTCHA')
  });
  var captchaRef = (0,react.useRef)(null);
  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      phone: '',
      product_id: data === null || data === void 0 ? void 0 : data.id
    },
    validationSchema: FormSchema,
    isInitialValid: false,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
        var requestData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestData = {
                  phone: values === null || values === void 0 ? void 0 : values.phone.replace(/[-]/g, ''),
                  product_id: data === null || data === void 0 ? void 0 : data.id,
                  'g-recaptcha-response': values['g-recaptcha-response']
                };
                _context.prev = 1;
                _context.next = 4;
                return reminderTrigger({
                  lang: lang,
                  data: requestData
                }).unwrap();

              case 4:
                setShowSuccess(true);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                setShowError(true);

              case 10:
                _context.prev = 10;
                formik.resetForm();
                return _context.finish(10);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 7, 10, 13]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var submitHandler = function submitHandler(e) {
    e.preventDefault();
    formik.handleSubmit();

    _setReminderModalActive(false);
  };

  var handleOrderClick = function handleOrderClick() {
    router.push({
      pathname: '/order',
      query: {
        itemId: router.query.dynamicPage[0],
        webview: router.query.webview
      }
    });
  };

  if (!reminderModalActive) {
    var _captchaRef$current;

    captchaRef === null || captchaRef === void 0 ? void 0 : (_captchaRef$current = captchaRef.current) === null || _captchaRef$current === void 0 ? void 0 : _captchaRef$current.reset();
  }

  (0,react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var _window = window,
          scrollY = _window.scrollY;

      if (scrollY > 155) {
        setButtonVisible(true);
      } else {
        setButtonVisible(false);
      }
    };

    if (true) {
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  var _useSelector = (0,react_redux_es/* useSelector */.v9)(mini_market/* selectors.selectMiniMarket */.wl.K),
      selectedImage = _useSelector.selectedImage;

  (0,react.useEffect)(function () {
    var _data$album, _data$album$photos;

    dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(data === null || data === void 0 ? void 0 : (_data$album = data.album) === null || _data$album === void 0 ? void 0 : (_data$album$photos = _data$album.photos) === null || _data$album$photos === void 0 ? void 0 : _data$album$photos[0]));
  }, []);

  var modalCloser = function modalCloser() {
    _setReminderModalActive(false);

    formik.resetForm();
  };

  (0,react.useEffect)(function () {
    var _data$album2, _data$album2$photos;

    dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(data === null || data === void 0 ? void 0 : (_data$album2 = data.album) === null || _data$album2 === void 0 ? void 0 : (_data$album2$photos = _data$album2.photos) === null || _data$album2$photos === void 0 ? void 0 : _data$album2$photos[0]));
  }, [router.asPath]);
  var scrollableDivRef = (0,react.useRef)(null);

  var _useState7 = (0,react.useState)(false),
      buttonDisabled = _useState7[0],
      setButtonDisabled = _useState7[1];

  var handleNextArrowClick = function handleNextArrowClick() {
    if (buttonDisabled) return;
    setButtonDisabled(true);

    if (scrollableDivRef.current) {
      var _data$album3, _data$album3$photos, _data$album4, _data$album4$photos;

      var currentIndex = data === null || data === void 0 ? void 0 : (_data$album3 = data.album) === null || _data$album3 === void 0 ? void 0 : (_data$album3$photos = _data$album3.photos) === null || _data$album3$photos === void 0 ? void 0 : _data$album3$photos.findIndex(function (i) {
        return i === selectedImage;
      });

      if (currentIndex !== (data === null || data === void 0 ? void 0 : (_data$album4 = data.album) === null || _data$album4 === void 0 ? void 0 : (_data$album4$photos = _data$album4.photos) === null || _data$album4$photos === void 0 ? void 0 : _data$album4$photos.length) - 1) {
        var _data$album5;

        dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(data === null || data === void 0 ? void 0 : (_data$album5 = data.album) === null || _data$album5 === void 0 ? void 0 : _data$album5.photos[currentIndex + 1]));
      }

      var scrollContainer = scrollableDivRef.current;
      var selectedImageElement = scrollContainer.querySelector("[dataImageId='".concat(selectedImage, "']"));

      if (selectedImageElement) {
        var scrollContainerRect = scrollContainer.getBoundingClientRect();
        var selectedImageRect = selectedImageElement.getBoundingClientRect();

        if (selectedImageRect.bottom > scrollContainerRect.bottom) {
          scrollContainer.scrollBy({
            top: 160,
            behavior: 'smooth'
          });
        }
      }
    } // Re-enable the button after 500ms


    setTimeout(function () {
      setButtonDisabled(false);
    }, 500);
  };

  var handlePrevArrowClick = function handlePrevArrowClick() {
    if (buttonDisabled) return;
    setButtonDisabled(true);

    if (scrollableDivRef.current) {
      var _data$album6, _data$album6$photos;

      setButtonDisabled(true);
      var currentIndex = data === null || data === void 0 ? void 0 : (_data$album6 = data.album) === null || _data$album6 === void 0 ? void 0 : (_data$album6$photos = _data$album6.photos) === null || _data$album6$photos === void 0 ? void 0 : _data$album6$photos.findIndex(function (i) {
        return i === selectedImage;
      });

      if (currentIndex !== 0) {
        var _data$album7;

        dispatch(mini_market/* actions.setSelectedImage */.Nw.setSelectedImage(data === null || data === void 0 ? void 0 : (_data$album7 = data.album) === null || _data$album7 === void 0 ? void 0 : _data$album7.photos[currentIndex - 1]));
      }

      var scrollContainer = scrollableDivRef.current;
      var selectedImageElement = scrollContainer.querySelector("[dataImageId='".concat(selectedImage, "']"));

      if (selectedImageElement) {
        var scrollContainerRect = scrollContainer.getBoundingClientRect();
        var selectedImageRect = selectedImageElement.getBoundingClientRect();

        if (selectedImageRect.top < scrollContainerRect.top) {
          scrollContainer.scrollBy({
            top: -160,
            behavior: 'smooth'
          });
        }
      }
    }

    setTimeout(function () {
      setButtonDisabled(false);
    }, 500);
  };

  var breadcrumbData = [{
    text: t('common:Home'),
    slug: 'home'
  }, {
    text: t('common:Shop'),
    slug: 'bakcell-shop'
  }, {
    text: data === null || data === void 0 ? void 0 : data.name,
    slug: data === null || data === void 0 ? void 0 : data.name
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Breadcrumbs */.Oo, {
      data: breadcrumbData,
      className: (DeviceDetails_index_module_default()).customBreadcrumbs
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wrapper section",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (DeviceDetails_index_module_default()).firstTitle,
        children: data === null || data === void 0 ? void 0 : data.name
      }), windowsX < 768 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (DeviceDetails_index_module_default()).mobileBadges,
          itemScope: true,
          itemType: "https://schema.org/Product",
          children: data === null || data === void 0 ? void 0 : (_data$labels = data.labels) === null || _data$labels === void 0 ? void 0 : _data$labels.map(function (label) {
            var _label$title, _cleanedStr, _ref2;

            var cleanedStr = label === null || label === void 0 ? void 0 : (_label$title = label.title) === null || _label$title === void 0 ? void 0 : _label$title.replace(/<\/?b>/g, '');
            cleanedStr = (_cleanedStr = cleanedStr) === null || _cleanedStr === void 0 ? void 0 : _cleanedStr.replace(/\\n/g, ' ').replace(/<\/?br>/g, '');
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()([(DeviceDetails_index_module_default()).singleBadge, (_ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, (DeviceDetails_index_module_default()).singleBadge__deep_red, (label === null || label === void 0 ? void 0 : label.color) === 'deep_red'), (0,defineProperty/* default */.Z)(_ref2, (DeviceDetails_index_module_default()).singleBadge__lighter_red, (label === null || label === void 0 ? void 0 : label.color) === 'lighter_red'), _ref2)]),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                alt: "small icon",
                title: "Small Icon",
                src: label === null || label === void 0 ? void 0 : label.icon,
                width: 24,
                height: 24
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: cleanedStr
              })]
            }, label === null || label === void 0 ? void 0 : label.id);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageSlider, {
          images: data === null || data === void 0 ? void 0 : (_data$album8 = data.album) === null || _data$album8 === void 0 ? void 0 : _data$album8.photos,
          setModalActive: setModalActive
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (DeviceDetails_index_module_default()).customWrapper,
        itemScope: true,
        itemType: "https://schema.org/Product",
        children: [windowsX >= 768 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (DeviceDetails_index_module_default()).left,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (DeviceDetails_index_module_default()).imageWrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (DeviceDetails_index_module_default()).images,
              children: [(data === null || data === void 0 ? void 0 : (_data$album9 = data.album) === null || _data$album9 === void 0 ? void 0 : _data$album9.photos.length) > 5 && /*#__PURE__*/(0,jsx_runtime.jsx)(GalleryArrow, {
                onClick: handlePrevArrowClick,
                className: (DeviceDetails_index_module_default()).prev
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (DeviceDetails_index_module_default()).overflower,
                ref: scrollableDivRef,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeviceImages, {
                  images: data === null || data === void 0 ? void 0 : (_data$album10 = data.album) === null || _data$album10 === void 0 ? void 0 : _data$album10.photos
                })
              }), (data === null || data === void 0 ? void 0 : (_data$album11 = data.album) === null || _data$album11 === void 0 ? void 0 : _data$album11.photos.length) > 5 && /*#__PURE__*/(0,jsx_runtime.jsx)(GalleryArrow, {
                onClick: handleNextArrowClick,
                className: (DeviceDetails_index_module_default()).next
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (DeviceDetails_index_module_default()).mainImage,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MainImage, {
                isModal: false,
                photos: data === null || data === void 0 ? void 0 : (_data$album12 = data.album) === null || _data$album12 === void 0 ? void 0 : _data$album12.photos,
                setModalActive: setModalActive,
                data: data
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (DeviceDetails_index_module_default()).badges,
                children: data === null || data === void 0 ? void 0 : (_data$labels2 = data.labels) === null || _data$labels2 === void 0 ? void 0 : _data$labels2.map(function (label) {
                  var _label$title2;

                  var regex = /\\n/g;
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "".concat((DeviceDetails_index_module_default()).singleBadge, " ").concat((label === null || label === void 0 ? void 0 : label.color) === 'deep_red' && (DeviceDetails_index_module_default()).singleBadge__deep_red, " ").concat((label === null || label === void 0 ? void 0 : label.color) === 'lighter_red' && (DeviceDetails_index_module_default()).singleBadge__lighter_red),
                    children: [(label === null || label === void 0 ? void 0 : label.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      alt: "small icon",
                      title: "Small Icon",
                      src: label === null || label === void 0 ? void 0 : label.icon,
                      width: 24,
                      height: 24
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      dangerouslySetInnerHTML: {
                        __html: label === null || label === void 0 ? void 0 : (_label$title2 = label.title) === null || _label$title2 === void 0 ? void 0 : _label$title2.replace(regex, '<br>')
                      }
                    })]
                  }, label === null || label === void 0 ? void 0 : label.id);
                })
              })]
            })]
          }), buttonVisible && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: " ".concat((DeviceDetails_index_module_default()).buttonVisible, " ").concat(buttonVisible && (DeviceDetails_index_module_default()).buttonVisible__visible),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (DeviceDetails_index_module_default()).priceContainer,
              children: data !== null && data !== void 0 && data.new_price ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [(data === null || data === void 0 ? void 0 : data.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  className: (DeviceDetails_index_module_default()).discountPrice,
                  children: [data === null || data === void 0 ? void 0 : data.old_price, data === null || data === void 0 ? void 0 : data.currency]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  children: [data === null || data === void 0 ? void 0 : data.new_price, " ", data === null || data === void 0 ? void 0 : data.currency]
                })]
              }) : (data === null || data === void 0 ? void 0 : data.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [data === null || data === void 0 ? void 0 : data.old_price, " ", data === null || data === void 0 ? void 0 : data.currency]
              })
            }), data !== null && data !== void 0 && data.in_stock ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              id: "testingId",
              onClick: handleOrderClick,
              children: t('common:OrderNow')
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
              onClick: function onClick() {
                return _setReminderModalActive(true);
              },
              variant: "outline",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Reminder, {}), " ", t('common:RemindMe')]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (DeviceDetails_index_module_default()).right,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (DeviceDetails_index_module_default()).top,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (DeviceDetails_index_module_default()).leftWrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (DeviceDetails_index_module_default()).left,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: (DeviceDetails_index_module_default()).buttons,
                  children: [data !== null && data !== void 0 && data.in_stock ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (DeviceDetails_index_module_default()).inStock,
                    children: t('common:inStock')
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (DeviceDetails_index_module_default()).outStock,
                    children: t('common:outOfStock')
                  }), data === null || data === void 0 ? void 0 : (_data$highlights = data.highlights) === null || _data$highlights === void 0 ? void 0 : _data$highlights.map(function (highlightItem) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: (DeviceDetails_index_module_default()).edv,
                      children: [(highlightItem === null || highlightItem === void 0 ? void 0 : highlightItem.icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        width: 20,
                        height: 20,
                        alt: highlightItem === null || highlightItem === void 0 ? void 0 : highlightItem.title,
                        title: highlightItem === null || highlightItem === void 0 ? void 0 : highlightItem.title,
                        src: highlightItem === null || highlightItem === void 0 ? void 0 : highlightItem.icon
                      }), ' ', highlightItem === null || highlightItem === void 0 ? void 0 : highlightItem.title]
                    }, highlightItem === null || highlightItem === void 0 ? void 0 : highlightItem.id);
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (DeviceDetails_index_module_default()).priceContainer,
                  children: data !== null && data !== void 0 && data.new_price ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [(data === null || data === void 0 ? void 0 : data.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                      className: (DeviceDetails_index_module_default()).discountPrice,
                      children: [data === null || data === void 0 ? void 0 : data.old_price, data === null || data === void 0 ? void 0 : data.currency]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                      children: [data === null || data === void 0 ? void 0 : data.new_price, " ", data === null || data === void 0 ? void 0 : data.currency]
                    })]
                  }) : (data === null || data === void 0 ? void 0 : data.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    children: [data === null || data === void 0 ? void 0 : data.old_price, " ", data === null || data === void 0 ? void 0 : data.currency]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: (DeviceDetails_index_module_default()).description,
                  children: data === null || data === void 0 ? void 0 : data.description
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeviceOptions, {
                  capacities: data === null || data === void 0 ? void 0 : data.storages,
                  selectedCapacity: data === null || data === void 0 ? void 0 : data.storage,
                  colors: data === null || data === void 0 ? void 0 : data.colors,
                  selectedColor: data === null || data === void 0 ? void 0 : data.color,
                  variations: data === null || data === void 0 ? void 0 : data.all_variations
                }), !buttonVisible && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (DeviceDetails_index_module_default()).buttonContainer,
                  children: data !== null && data !== void 0 && data.in_stock ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
                    onClick: handleOrderClick,
                    children: t('common:OrderNow')
                  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
                    onClick: function onClick() {
                      return _setReminderModalActive(true);
                    },
                    variant: "outline",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Reminder, {}), " ", t('common:RemindMe')]
                  })
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeviceOffers, {
              data: data
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DeviceCharacteristics, {
            data: data
          })]
        })]
      })]
    }), windowsX < 768 && !reminderModalActive && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (DeviceDetails_index_module_default()).mobileFixed,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "".concat((DeviceDetails_index_module_default()).custom, " wrapper"),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (DeviceDetails_index_module_default()).priceMobile,
          children: data !== null && data !== void 0 && data.new_price ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [(data === null || data === void 0 ? void 0 : data.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (DeviceDetails_index_module_default()).discountPrice,
              children: [data === null || data === void 0 ? void 0 : data.old_price, data === null || data === void 0 ? void 0 : data.currency]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (DeviceDetails_index_module_default()).price,
              children: [data === null || data === void 0 ? void 0 : data.new_price, " ", data === null || data === void 0 ? void 0 : data.currency]
            })]
          }) : (data === null || data === void 0 ? void 0 : data.old_price) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (DeviceDetails_index_module_default()).price,
            children: [data === null || data === void 0 ? void 0 : data.old_price, " ", data === null || data === void 0 ? void 0 : data.currency]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (DeviceDetails_index_module_default()).btn,
          children: data !== null && data !== void 0 && data.in_stock ? /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            onClick: handleOrderClick,
            children: t('common:OrderNow')
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
            onClick: function onClick() {
              return _setReminderModalActive(true);
            },
            variant: "outline",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Reminder, {}), " ", t('common:RemindMe')]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImageModal, {
      device: data,
      modalActive: modalActive,
      isMobileView: windowsX < 768,
      setModalActive: setModalActive,
      setReminderModalActive: function setReminderModalActive() {
        return _setReminderModalActive(true);
      },
      itemScope: true,
      itemType: "https://schema.org/ImageGallery"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (DeviceDetails_index_module_default()).remindModal,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Modal */.u_, {
        active: reminderModalActive,
        setActive: modalCloser,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          children: t('common:RemindMe')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: t('common:ReminderText')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
          onSubmit: function onSubmit(e) {
            return submitHandler(e);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
            className: (DeviceDetails_index_module_default()).input,
            onBlur: formik.handleBlur('phone'),
            error: formik.touched.phone && formik.errors.phone,
            value: formik.values.phone,
            type: "tel",
            onChange: function onChange(value) {
              var formattedPhone = (0,formatPhoneNumber/* formatPhoneNumber */.u)(value);
              formik.setFieldValue('phone', formattedPhone);
            },
            label: t('common:Phone'),
            placeholder: '+994-XX-XXX-XX-XX',
            mask: '+\\9\\9\\4-99-999-99-99'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
            sitekey: constants/* envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY */.ie.NEXT_PUBLIC_RECAPTCHA_API_KEY || 'default',
            onChange: function onChange(recaptcha) {
              return formik.setFieldValue('g-recaptcha-response', recaptcha);
            },
            error: formik.touched['g-recaptcha-response'] && formik.errors['g-recaptcha-response'],
            ref: captchaRef,
            hl: lang
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
            disabled: !formik.isValid,
            children: t('common:Continue')
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessModal/* SuccessModal */.i, {
      active: showSuccess,
      setSuccessModal: function setSuccessModal() {
        return setShowSuccess(false);
      },
      title: t('common:ReminderSuccessTitle'),
      description: t('common:ReminderSuccessText'),
      itemScope: true,
      itemType: "https://schema.org/Thing"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      icon: "/assets/error.png",
      active: showError,
      setActive: function setActive() {
        return setShowError(false);
      },
      itemScope: true,
      itemType: "https://schema.org/Thing",
      children: error === null || error === void 0 ? void 0 : error.message
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ScreenLoader */.v$, {
      visible: isLoading,
      itemScope: true,
      itemType: "https://schema.org/Thing"
    })]
  });
};
// EXTERNAL MODULE: ./components/device/Products/Filter/ProductFilter.module.scss
var ProductFilter_module = __webpack_require__(37724);
var ProductFilter_module_default = /*#__PURE__*/__webpack_require__.n(ProductFilter_module);
;// CONCATENATED MODULE: ./components/device/Products/Filter/ProductFilter.js




function ProductFilter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ProductFilter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductFilter_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductFilter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var ProductFilter = function ProductFilter() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      _useWindowSize2 = (0,slicedToArray/* default */.Z)(_useWindowSize, 1),
      windowsX = _useWindowSize2[0];

  var router = (0,next_router.useRouter)();

  var _miniMarketHooks$useG = mini_market/* hooks.useGetBrands */.PT.useGetBrands({
    lang: lang
  }),
      brands = _miniMarketHooks$useG.data;

  var _miniMarketHooks$useG2 = mini_market/* hooks.useGetColors */.PT.useGetColors({
    lang: lang
  }),
      colors = _miniMarketHooks$useG2.data;

  var _miniMarketHooks$useG3 = mini_market/* hooks.useGetStorages */.PT.useGetStorages({
    lang: lang
  }),
      storages = _miniMarketHooks$useG3.data;

  var _useState = (0,react.useState)(false),
      mobileActive = _useState[0],
      setMobileActive = _useState[1];

  var _useState2 = (0,react.useState)([]),
      selectedBrands = _useState2[0],
      setSelectedBrands = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      selectedColors = _useState3[0],
      setSelectedColors = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      selectedStorages = _useState4[0],
      setSelectedStorages = _useState4[1];

  var dispatch = (0,react_redux_es/* useDispatch */.I0)();

  var handleBrandClick = function handleBrandClick(name) {
    setSelectedBrands(function (prev) {
      return prev.includes(name) ? prev.filter(function (brandName) {
        return brandName !== name;
      }) : [].concat((0,toConsumableArray/* default */.Z)(prev), [name]);
    });
  };

  var handleColorClick = function handleColorClick(name) {
    setSelectedColors(function (prev) {
      return prev.includes(name) ? prev.filter(function (colorName) {
        return colorName !== name;
      }) : [].concat((0,toConsumableArray/* default */.Z)(prev), [name]);
    });
  };

  var handleStorageClick = function handleStorageClick(name) {
    setSelectedStorages(function (prev) {
      return prev.includes(name) ? prev.filter(function (storageName) {
        return storageName !== name;
      }) : [].concat((0,toConsumableArray/* default */.Z)(prev), [name]);
    });
  };

  var resetFilters = function resetFilters() {
    setSelectedBrands([]);
    setSelectedColors([]);
    setSelectedStorages([]);
  };

  (0,react.useEffect)(function () {
    dispatch(mini_market/* actions.setFilterBrands */.Nw.setFilterBrands(selectedBrands));
    dispatch(mini_market/* actions.setFilterColors */.Nw.setFilterColors(selectedColors));
    dispatch(mini_market/* actions.setFilterStorages */.Nw.setFilterStorages(selectedStorages));
  }, [selectedBrands, selectedColors, selectedStorages]);
  (0,react.useEffect)(function () {
    var query = ProductFilter_objectSpread({}, router.query);

    if (selectedBrands.length > 0) {
      query.brands = selectedBrands.join(',');
    } else {
      delete query.brands;
    }

    if (selectedColors.length > 0) {
      query.colors = selectedColors.join(',');
    } else {
      delete query.colors;
    }

    if (selectedStorages.length > 0) {
      query.storages = selectedStorages.join(',');
    } else {
      delete query.storages;
    }

    router.push({
      pathname: router.pathname,
      query: query
    }, undefined, {
      shallow: true
    });
  }, [selectedBrands, selectedColors, selectedStorages]);
  (0,react.useEffect)(function () {
    var _router$query = router.query,
        brands = _router$query.brands,
        colors = _router$query.colors,
        storages = _router$query.storages;

    if (brands) {
      setSelectedBrands(brands.split(','));
    }

    if (colors) {
      setSelectedColors(colors.split(','));
    }

    if (storages) {
      setSelectedStorages(storages.split(','));
    }
  }, []);

  var renderColor = function renderColor(item) {
    var isActive = selectedColors.includes(item.title);
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: classnames_default()((ProductFilter_module_default()).color_box, (0,defineProperty/* default */.Z)({}, (ProductFilter_module_default()).active, isActive)),
      style: {
        background: item.hex_code
      },
      onClick: function onClick() {
        return handleColorClick(item.title);
      }
    }, item.id);
  };

  var renderList = function renderList(item) {
    var selectedArray;
    var handleClick;

    if (item.type === 'brand') {
      selectedArray = selectedBrands;
      handleClick = handleBrandClick;
    } else if (item.type === 'storage') {
      selectedArray = selectedStorages;
      handleClick = handleStorageClick;
    } else {
      selectedArray = selectedColors;
      handleClick = handleColorClick;
    }

    var isActive = selectedArray.includes(item.name);
    return mobileActive ? /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: classnames_default()((ProductFilter_module_default()).label, (0,defineProperty/* default */.Z)({}, (ProductFilter_module_default()).active, isActive)),
      onClick: function onClick() {
        return handleClick(item.name);
      },
      children: [item.name, isActive && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (ProductFilter_module_default()).icon,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
      })]
    }, item.id) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ProductFilter_module_default()).list,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CheckboxWithText */.EG, {
        size: "large",
        checked: isActive,
        onChange: function onChange() {
          return handleClick(item.name);
        },
        className: (ProductFilter_module_default()).checkbox,
        children: item.name
      })
    }, item.id);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()([(ProductFilter_module_default()).product_filter__wrapper, (0,defineProperty/* default */.Z)({}, (ProductFilter_module_default()).active, mobileActive)]),
    itemScope: true,
    itemType: "https://schema.org/Filter",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductFilter_module_default()).content_cover,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductFilter_module_default()).top,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (ProductFilter_module_default()).title,
          children: t('common:filter')
        }), mobileActive ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {
          onClick: function onClick() {
            return setMobileActive(!mobileActive);
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* ProductFilterSVG */.eR, ProductFilter_objectSpread({}, windowsX <= 900 && {
          onClick: function onClick() {
            return setMobileActive(true);
          }
        }))]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductFilter_module_default()).filter_box,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (ProductFilter_module_default()).title,
          children: t('device:brand')
        }), brands === null || brands === void 0 ? void 0 : brands.map(function (brand) {
          return renderList(ProductFilter_objectSpread(ProductFilter_objectSpread({}, brand), {}, {
            type: 'brand'
          }));
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductFilter_module_default()).filter_box,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (ProductFilter_module_default()).title,
          children: t('device:color')
        }), colors === null || colors === void 0 ? void 0 : colors.map(renderColor)]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ProductFilter_module_default()).filter_box,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: (ProductFilter_module_default()).title,
          children: t('device:storage')
        }), storages === null || storages === void 0 ? void 0 : storages.map(function (storage) {
          return renderList(ProductFilter_objectSpread(ProductFilter_objectSpread({}, storage), {}, {
            type: 'storage'
          }));
        })]
      })]
    }), mobileActive && windowsX <= 900 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ProductFilter_module_default()).mobile_buttons,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
        className: (ProductFilter_module_default()).cancleBtn,
        variant: "transparent",
        onClick: function onClick() {
          resetFilters();
          router.push({
            pathname: router.pathname,
            query: {}
          }, undefined, {
            shallow: true
          });
        },
        children: t('device:common.btnReset')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
        className: (ProductFilter_module_default()).applyBtn,
        onClick: function onClick() {
          return setMobileActive(!mobileActive);
        },
        children: t('device:common.btnApply')
      })]
    })]
  });
};

/* harmony default export */ var Filter_ProductFilter = (ProductFilter);
// EXTERNAL MODULE: ./components/device/Products/EshopCard/EshopCard.module.scss
var EshopCard_module = __webpack_require__(67757);
var EshopCard_module_default = /*#__PURE__*/__webpack_require__.n(EshopCard_module);
;// CONCATENATED MODULE: ./components/device/Products/EshopCard/EshopCard.js












var EshopCard = function EshopCard() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      lang = _useTranslation.lang;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(1),
      page = _useState[0],
      setPage = _useState[1];

  var _useState2 = (0,react.useState)([]),
      products = _useState2[0],
      setProducts = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasMore = _useState3[0],
      setHasMore = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      resetting = _useState5[0],
      setResetting = _useState5[1];

  var observer = (0,react.useRef)(null);
  var loadMoreRef = (0,react.useRef)(null);
  var limitPerPage = 6;

  var _miniMarketHooks$useG = mini_market/* hooks.useGetProductList */.PT.useGetProductList({
    lang: lang,
    limit: limitPerPage,
    page: page,
    brands: router.query.brands,
    colors: router.query.colors,
    storages: router.query.storages
  }),
      data = _miniMarketHooks$useG.data,
      isLoading = _miniMarketHooks$useG.isLoading;

  (0,react.useEffect)(function () {
    setResetting(true);
    setProducts([]);
    setPage(1);
  }, [router.query.brands, router.query.colors, router.query.storages]);
  (0,react.useEffect)(function () {
    if (page === 1) {
      setProducts(data);
    } else {
      setProducts(function (prev) {
        return [].concat((0,toConsumableArray/* default */.Z)(prev), (0,toConsumableArray/* default */.Z)(data));
      });
    }

    setHasMore((data === null || data === void 0 ? void 0 : data.length) >= limitPerPage);
    setLoading(isLoading);

    if (resetting) {
      setResetting(false);
    }
  }, [data, isLoading]);
  (0,react.useEffect)(function () {
    if (loading || resetting) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && hasMore) {
        setPage(function (prev) {
          return prev + 1;
        });
      }
    });

    if (loadMoreRef.current) {
      observer.current.observe(loadMoreRef.current);
    }

    return function () {
      if (observer.current) observer.current.disconnect();
    };
  }, [loading, hasMore, resetting]);
  (0,react.useEffect)(function () {
    setResetting(false);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()(['wrapper', (EshopCard_module_default()).products_container]),
    itemScope: true,
    itemType: "https://schema.org/Thing",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (EshopCard_module_default()).content_wrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Filter_ProductFilter, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (EshopCard_module_default()).card_wrapper,
        children: products === null || products === void 0 ? void 0 : products.map(function (product) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(EshopItems_EshopItems, {
            product: product
          }, product.id);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: loadMoreRef
    })]
  });
};

/* harmony default export */ var EshopCard_EshopCard = (EshopCard);
// EXTERNAL MODULE: ./components/ui/CreateOwnPhoneInput/CreateOwnPhoneInput.js
var CreateOwnPhoneInput = __webpack_require__(94033);
// EXTERNAL MODULE: ./domains/number-sale/index.js + 4 modules
var number_sale = __webpack_require__(98248);
;// CONCATENATED MODULE: ./utils/simNumberPattern.js
var patternMaker = function patternMaker(array) {
  var arr = array.slice();

  for (var i = 0; i < arr.length; i++) {
    if (arr[i] === '') {
      arr[i] = '*';
    }
  }

  return arr;
};
// EXTERNAL MODULE: ./constants/base.js + 1 modules
var base = __webpack_require__(58165);
// EXTERNAL MODULE: ./enums/numberSale.ts
var numberSale = __webpack_require__(56951);
// EXTERNAL MODULE: ./components/number-sale/FindYourSimNumber/index.module.scss
var FindYourSimNumber_index_module = __webpack_require__(25855);
var FindYourSimNumber_index_module_default = /*#__PURE__*/__webpack_require__.n(FindYourSimNumber_index_module);
;// CONCATENATED MODULE: ./components/number-sale/FindYourSimNumber/index.js



function FindYourSimNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FindYourSimNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FindYourSimNumber_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FindYourSimNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var FindYourSimNumber = function FindYourSimNumber(_ref) {
  var data = _ref.data;
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();

  var _useSelector = (0,react_redux_es/* useSelector */.v9)(number_sale/* selectors.selectNumberSale */.wl.Q),
      activeTab = _useSelector.activeTab,
      page = _useSelector.page;

  var _useState = (0,react.useState)(Array(7).fill('')),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = (0,react.useState)(Array(7).fill('')),
      submittedValue = _useState2[0],
      setSubmittedValue = _useState2[1];

  var _useState3 = (0,react.useState)(base/* numberSalePrefixes */.xt === null || base/* numberSalePrefixes */.xt === void 0 ? void 0 : base/* numberSalePrefixes.0 */.xt[0]),
      prefix = _useState3[0],
      setPrefix = _useState3[1];

  var _useState4 = (0,react.useState)(base/* numberSalePrefixes */.xt === null || base/* numberSalePrefixes */.xt === void 0 ? void 0 : base/* numberSalePrefixes.0 */.xt[0]),
      submittedPrefix = _useState4[0],
      setSubmittedPrefix = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      sortedData = _useState5[0],
      setSortedData = _useState5[1];

  (0,react.useEffect)(function () {
    setSortedData([]);
    dispatch(number_sale/* actions.setPage */.Nw.setPage(1));
  }, [activeTab.value]);

  var _numberSaleHooks$useG = number_sale/* hooks.useGetNumbers */.PT.useGetNumbers({
    data: FindYourSimNumber_objectSpread({
      page: page,
      size: 12,
      prefix: submittedPrefix.id === numberSale/* NumberSalePrefixIds.All */.S$.All ? null : submittedPrefix.name,
      numberPattern: patternMaker(submittedValue).join('')
    }, (activeTab === null || activeTab === void 0 ? void 0 : activeTab.value) && {
      numberLevels: activeTab.value
    })
  }),
      numbersData = _numberSaleHooks$useG.data,
      isFetching = _numberSaleHooks$useG.isFetching;

  (0,react.useEffect)(function () {
    var _numbersData$numbers;

    if (numbersData !== null && numbersData !== void 0 && (_numbersData$numbers = numbersData.numbers) !== null && _numbersData$numbers !== void 0 && _numbersData$numbers.length) {
      setSortedData(function (prevData) {
        return [].concat((0,toConsumableArray/* default */.Z)(prevData), (0,toConsumableArray/* default */.Z)(numbersData === null || numbersData === void 0 ? void 0 : numbersData.numbers));
      });
    } else {
      setSortedData([]);
    }
  }, [numbersData]);
  (0,react.useEffect)(function () {
    dispatch(number_sale/* actions.setActiveTab */.Nw.setActiveTab(base/* numberLevels.0 */.g7[0]));
  }, []);

  var loadMore = function loadMore() {
    dispatch(number_sale/* actions.setPage */.Nw.setPage(page + 1));
  };

  var searchHandler = function searchHandler() {
    if (prefix !== submittedPrefix || JSON.stringify(value) !== JSON.stringify(submittedValue)) {
      setSortedData([]);
      dispatch(number_sale/* actions.setPage */.Nw.setPage(1));
      setSubmittedPrefix(prefix);
      setSubmittedValue(value);
    }
  };

  var resetHandler = function resetHandler() {
    dispatch(number_sale/* actions.setPage */.Nw.setPage(1));
    dispatch(number_sale/* actions.setActiveTab */.Nw.setActiveTab(base/* defaultTab */.uk));
    setPrefix(base/* numberSalePrefixes */.xt === null || base/* numberSalePrefixes */.xt === void 0 ? void 0 : base/* numberSalePrefixes.0 */.xt[0]);
    setSubmittedPrefix(base/* numberSalePrefixes */.xt === null || base/* numberSalePrefixes */.xt === void 0 ? void 0 : base/* numberSalePrefixes.0 */.xt[0]);
    setValue(Array(7).fill(''));
    setSubmittedValue(Array(7).fill(''));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'wrapper section',
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FindYourSimNumber_index_module_default()).intro,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        className: (FindYourSimNumber_index_module_default()).title,
        titleModify: 'title--large',
        children: data === null || data === void 0 ? void 0 : data.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: classnames_default()(['text--large', (FindYourSimNumber_index_module_default()).description]),
        children: data === null || data === void 0 ? void 0 : data.description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateOwnPhoneInput/* default */.Z, {
      tabs: base/* numberLevels */.g7,
      sortValue: prefix,
      detail: data,
      onChange: function onChange(val) {
        setValue(val);
      },
      isEsim: false,
      resetFields: resetHandler,
      value: value,
      onSubmit: searchHandler,
      sortData: base/* numberSalePrefixes */.xt,
      data: sortedData,
      loadMore: loadMore,
      onSelect: setPrefix,
      totalPage: sortedData === null || sortedData === void 0 ? void 0 : sortedData.length,
      isLoading: isFetching
    })]
  });
};

FindYourSimNumber.displayName = 'FindYourSimNumber';
/* harmony default export */ var number_sale_FindYourSimNumber = (FindYourSimNumber);
;// CONCATENATED MODULE: ./utils/downloadBlobFile.ts
var downloadBlobFile = function downloadBlobFile(data, fileName) {
  var url = URL.createObjectURL(data);
  var link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
;// CONCATENATED MODULE: ./components/number-sale/Checkout/SuccessBanner/index.tsx












var SuccessBanner = function SuccessBanner(_ref) {
  var data = _ref.data;

  var _hooks$useGetLazyNumb = number_sale/* hooks.useGetLazyNumberContract */.PT.useGetLazyNumberContract(),
      _hooks$useGetLazyNumb2 = (0,slicedToArray/* default */.Z)(_hooks$useGetLazyNumb, 2),
      getContract = _hooks$useGetLazyNumb2[0],
      _hooks$useGetLazyNumb3 = _hooks$useGetLazyNumb2[1],
      error = _hooks$useGetLazyNumb3.error,
      isFetching = _hooks$useGetLazyNumb3.isFetching;

  var _useState = (0,react.useState)(false),
      showError = _useState[0],
      setShowError = _useState[1];

  var router = (0,next_router.useRouter)();
  var paymentStatus = router.query.paymentStatus;
  var isSuccess = paymentStatus === numberSale/* PaymentStatus.SUCCESS */.bG.SUCCESS;

  var clickHandler = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var trackId, _data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isSuccess) {
                _context.next = 16;
                break;
              }

              _context.prev = 1;
              trackId =  true ? sessionStorage.getItem('nsTrackId') : 0;

              if (trackId) {
                _context.next = 5;
                break;
              }

              throw new Error('Track ID not found in localStorage');

            case 5:
              _context.next = 7;
              return getContract({
                trackId: trackId
              }).unwrap();

            case 7:
              _data = _context.sent;
              downloadBlobFile(_data, 'Contract.pdf');
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              setShowError(true);

            case 14:
              _context.next = 17;
              break;

            case 16:
              router.push('/home');

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function clickHandler() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "section",
    itemScope: true,
    itemType: "https://schema.org/Alret",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "wrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ScreenLoader */.v$, {
        visible: isFetching
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* InformationBlock */.fW, {
        icon: isSuccess && (data === null || data === void 0 ? void 0 : data.success_icon) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: data === null || data === void 0 ? void 0 : data.success_icon,
          alt: data === null || data === void 0 ? void 0 : data.success_title,
          title: data === null || data === void 0 ? void 0 : data.success_title,
          width: 60,
          height: 60
        }),
        secondary: false,
        content: {
          title: isSuccess ? data === null || data === void 0 ? void 0 : data.success_title : data === null || data === void 0 ? void 0 : data.error_title,
          text: isSuccess ? data === null || data === void 0 ? void 0 : data.success_description : data === null || data === void 0 ? void 0 : data.error_description,
          buttonText: isSuccess ? data === null || data === void 0 ? void 0 : data.success_button_text : data === null || data === void 0 ? void 0 : data.error_button_text,
          buttonIcon: isSuccess && (data === null || data === void 0 ? void 0 : data.success_button_icon)
        },
        onClick: clickHandler
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
        active: showError,
        icon: "/assets/error.png",
        setActive: function setActive() {
          setShowError(false);
        },
        children: error === null || error === void 0 ? void 0 : error.message
      })]
    })
  });
};
// EXTERNAL MODULE: ./components/ui/InformationBlock/InformationBlock.js
var InformationBlock = __webpack_require__(31111);
;// CONCATENATED MODULE: ./components/number-sale/Checkout/ErrorBanner/index.tsx




var ErrorBanner = function ErrorBanner(_ref) {
  var data = _ref.data;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "section",
    itemScope: true,
    itemType: "https://schema.org/Alret",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "wrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(InformationBlock/* default */.Z, {
        secondary: false,
        onClick: function onClick() {
          router.push('/');
        },
        content: {
          title: data === null || data === void 0 ? void 0 : data.title,
          text: data === null || data === void 0 ? void 0 : data.description,
          buttonText: data === null || data === void 0 ? void 0 : data.button_text
        },
        icon: ''
      })
    })
  });
};
// EXTERNAL MODULE: ./enums/button.ts
var enums_button = __webpack_require__(52325);
// EXTERNAL MODULE: ./domains/esim/order/index.js + 3 modules
var order = __webpack_require__(31863);
// EXTERNAL MODULE: ./enums/esim.ts
var enums_esim = __webpack_require__(24204);
// EXTERNAL MODULE: ./components/esim/Qr/Qr.js
var Qr = __webpack_require__(31480);
// EXTERNAL MODULE: ./components/esim/Modals/SalesError/SalesError.js
var SalesError = __webpack_require__(41050);
// EXTERNAL MODULE: ./components/esim/SuccessBanner/index.module.scss
var SuccessBanner_index_module = __webpack_require__(32131);
var SuccessBanner_index_module_default = /*#__PURE__*/__webpack_require__.n(SuccessBanner_index_module);
;// CONCATENATED MODULE: ./components/esim/SuccessBanner/index.js
















var SuccessBanner_SuccessBanner = function SuccessBanner(_ref) {
  var data = _ref.data;

  var _useTheme = (0,index_module/* useTheme */.F)(),
      theme = _useTheme.theme;

  var router = (0,next_router.useRouter)();
  var qrCodeRef = (0,react.useRef)(null);
  var checkWindow = true;

  var _useState = (0,react.useState)(false),
      salesError = _useState[0],
      setSalesError = _useState[1];

  var _useState2 = (0,react.useState)(),
      dataBanner = _useState2[0],
      setDataBanner = _useState2[1];

  var trackId = checkWindow && localStorage.getItem('esimTID');
  var offerId = checkWindow && localStorage.getItem('planID');
  var customerPhone = checkWindow && localStorage.getItem('tel');
  var statusPrefix = router.query.paymentStatus === 'SUCCESS' ? 'success' : 'error';

  var _orderHooks$usePostSa = order/* hooks.usePostSales */.PT.usePostSales(),
      _orderHooks$usePostSa2 = (0,slicedToArray/* default */.Z)(_orderHooks$usePostSa, 2),
      salesMutation = _orderHooks$usePostSa2[0],
      salesLoading = _orderHooks$usePostSa2[1].isLoading;

  var handleScroll = function handleScroll() {
    var section = document.getElementById(data === null || data === void 0 ? void 0 : data["".concat(statusPrefix, "_top_link_scroll_to")]);

    if (section) {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  (0,react.useEffect)(function () {
    if (router.query.paymentStatus === enums_esim/* EsimPaymentBannerStatus.SUCCESS */.In.SUCCESS) {
      salesMutation({
        trackId: trackId,
        offerId: offerId
      }).unwrap().then(function (res) {
        setDataBanner(res === null || res === void 0 ? void 0 : res.data);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'purchase'
        });
      })["catch"](function (error) {
        setSalesError(true);
      })["finally"](function () {
        localStorage.removeItem('tel');
        localStorage.removeItem('esimTID');
        localStorage.removeItem('planID');
      });
    }
  }, [router.query]);

  if (salesLoading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Loader */.aN, {
      fullScreen: true
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "section",
      itemScope: true,
      itemType: "https://schema.org/Message",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()([(SuccessBanner_index_module_default()).container]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/assets/".concat(theme === 'light' ? 'Shapes.png' : 'ShapesDark.png'),
            layout: "fill",
            className: (SuccessBanner_index_module_default()).img,
            alt: "img",
            loading: "lazy"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/assets/".concat(theme === 'light' ? 'ShapesMobile.png' : 'ShapesMobileDark.png'),
            layout: "fill",
            className: (SuccessBanner_index_module_default()).mobileImg,
            alt: "img",
            loading: "lazy"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (SuccessBanner_index_module_default()).content,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: (SuccessBanner_index_module_default()).title,
              children: data === null || data === void 0 ? void 0 : data["".concat(statusPrefix, "_title")]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              onClick: handleScroll,
              className: (SuccessBanner_index_module_default()).activate,
              children: data === null || data === void 0 ? void 0 : data["".concat(statusPrefix, "_top_link_text")]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (SuccessBanner_index_module_default()).yourNumber,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (SuccessBanner_index_module_default()).text,
                children: data === null || data === void 0 ? void 0 : data["".concat(statusPrefix, "_text_before_number")]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: classnames_default()([(SuccessBanner_index_module_default()).text__bold, (SuccessBanner_index_module_default()).text]),
                children: customerPhone
              })]
            }), (dataBanner === null || dataBanner === void 0 ? void 0 : dataBanner.qrCode) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (SuccessBanner_index_module_default()).qrBlock,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (SuccessBanner_index_module_default()).qr,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Qr/* default */.Z, {
                  qrRef: qrCodeRef,
                  size: 160,
                  qrCode: dataBanner === null || dataBanner === void 0 ? void 0 : dataBanner.qrCode
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (SuccessBanner_index_module_default()).qrInfo,
              children: data === null || data === void 0 ? void 0 : data["".concat(statusPrefix, "_qr_description")]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              Component: "router",
              href: data === null || data === void 0 ? void 0 : data["".concat(statusPrefix, "_bottom_link_slug")],
              variant: enums_button/* Variants.outline */.tr.outline,
              children: data === null || data === void 0 ? void 0 : data["".concat(statusPrefix, "_bottom_link_text")]
            })]
          })]
        })
      })
    }), salesError && /*#__PURE__*/(0,jsx_runtime.jsx)(SalesError/* default */.Z, {
      active: salesError,
      setActive: function setActive() {
        return setSalesError(!salesError);
      }
    })]
  });
};
// EXTERNAL MODULE: ./components/documents/Documents.module.scss
var Documents_module = __webpack_require__(10640);
var Documents_module_default = /*#__PURE__*/__webpack_require__.n(Documents_module);
;// CONCATENATED MODULE: ./components/documents/Documents.js









var Documents = function Documents(_ref) {
  var _data$tabs;

  var data = _ref.data;

  var _useState = (0,react.useState)(0),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var renderTab = function renderTab(item, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Tab */.OK, {
      className: classnames_default()([(Documents_module_default()).tab, (0,defineProperty/* default */.Z)({}, (Documents_module_default()).active, activeTab === index)]),
      onClick: function onClick() {
        setActiveTab(index);
      },
      children: item === null || item === void 0 ? void 0 : item.title
    }, item === null || item === void 0 ? void 0 : item.id);
  };

  var renderTabContent = function renderTabContent(item) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SectionTitle */.NZ, {
        className: (Documents_module_default()).title,
        titleModify: "title--large",
        children: item === null || item === void 0 ? void 0 : item.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TextBlock */.al, {
        className: (Documents_module_default()).text,
        isHtml: true,
        children: item === null || item === void 0 ? void 0 : item.content
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "wrapper section",
    itemScope: true,
    itemType: "https://schema.org/Property",
    children: (data === null || data === void 0 ? void 0 : (_data$tabs = data.tabs) === null || _data$tabs === void 0 ? void 0 : _data$tabs.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Tabs */.mQ, {
      active: activeTab,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabPanel */.x4, {
        className: (Documents_module_default()).tabToggles,
        children: data.tabs.map(renderTab)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabContent */.I5, {
        children: data.tabs.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TabContentItem */.Wp, {
            className: (Documents_module_default()).activeTabContentItem,
            active: activeTab === (item === null || item === void 0 ? void 0 : item.id),
            children: renderTabContent(item)
          }, item === null || item === void 0 ? void 0 : item.id);
        })
      })]
    })
  });
};

/* harmony default export */ var documents_Documents = (Documents);
;// CONCATENATED MODULE: ./components/widget-wrapper/WidgetWrapper.jsx

























































var LazyWidget = function LazyWidget(_ref) {
  var children = _ref.children,
      index = _ref.index,
      loadTriggerIndex = _ref.loadTriggerIndex;
  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)(index < loadTriggerIndex),
      visible = _useState[0],
      setVisible = _useState[1];

  (0,react.useEffect)(function () {
    if (visible || !ref.current) return;
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
          entry = _ref3[0];

      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, {
      rootMargin: '200px'
    });
    observer.observe(ref.current);
    return function () {
      return observer.disconnect();
    };
  }, [visible]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    ref: ref,
    style: {
      minHeight: '100px'
    },
    children: visible ? children : null
  });
};

var WidgetWrapper = function WidgetWrapper(_ref4) {
  var widgets = _ref4.widgets;

  var renderWidgets = function renderWidgets(name, data) {
    var _data$cards;

    switch (name) {
      case constants_widgets/* widgetOptions.VOLTE_BANNER_NEW */.Y.VOLTE_BANNER_NEW:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(VolteBanner/* default */.Z, {
          item: data
        });

      case constants_widgets/* widgetOptions.RIGHT_IMAGE_BANNER */.Y.RIGHT_IMAGE_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* RightImageBanner */.hD, {
          data: data
        });

      case constants_widgets/* widgetOptions.SLIDER */.Y.SLIDER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(BrandSlider/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.BEAUTIFUL_NUMBERS */.Y.BEAUTIFUL_NUMBERS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(BookNumber/* default */.Z, {
          tabs: data
        });

      case constants_widgets/* widgetOptions.RED_BANNER */.Y.RED_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Banner */.jL, {
          item: data,
          type: "red_banner"
        });

      case constants_widgets/* widgetOptions.BLACK_BANNER */.Y.BLACK_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Banner */.jL, {
          item: data,
          type: "black_banner"
        });

      case constants_widgets/* widgetOptions.IMAGE_BANNER */.Y.IMAGE_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Banner */.jL, {
          item: data
        });

      case constants_widgets/* widgetOptions.APPLICATION_BANNER */.Y.APPLICATION_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(AppBanner/* default */.Z, {
          className: "wrapper section",
          item: data
        });

      case constants_widgets/* widgetOptions.NEWS_SLIDER */.Y.NEWS_SLIDER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(home/* NewsList */.pY, {
          className: "wrapper section",
          data: data
        });

      case constants_widgets/* widgetOptions.GRAY_BANNER */.Y.GRAY_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Banner */.jL, {
          className: "wrapper section",
          item: data,
          type: data === null || data === void 0 ? void 0 : data.type
        });

      case constants_widgets/* widgetOptions.TARIFF_SLIDER */.Y.TARIFF_SLIDER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Tariffs/* default */.Z, {
          data: data,
          footerData: data === null || data === void 0 ? void 0 : data.tags,
          title: data === null || data === void 0 ? void 0 : data.title,
          buttonText: data === null || data === void 0 ? void 0 : data.button_text
        });

      case constants_widgets/* widgetOptions.GENERAL_SERVICE */.Y.GENERAL_SERVICE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(roaming/* GeneralServices */.kO, {
          services: data
        });

      case constants_widgets/* widgetOptions.IMPORTANT_STEP */.Y.IMPORTANT_STEP:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(roaming/* Steps */.Rg, {
          data: data
        });

      case constants_widgets/* widgetOptions.FOR_FOREIGN_GUEST */.Y.FOR_FOREIGN_GUEST:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(roaming/* BannerAzer */.jS, {
          data: data
        });

      case constants_widgets/* widgetOptions.ACCORDION */.Y.ACCORDION:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(roaming/* Questions */.Gw, {
          questions: data,
          className: "wrapper",
          titleModify: "title--large"
        });

      case constants_widgets/* widgetOptions.HEADER */.Y.HEADER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MainBanner/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.ROAMING_COUNTRY_SEARCH */.Y.ROAMING_COUNTRY_SEARCH:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SearchTravel */.Ym, {
          data: data
        });

      case constants_widgets/* widgetOptions.HOTSPOT_MAP */.Y.HOTSPOT_MAP:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleMapsClusterer/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.NEW_CAMPAIGN */.Y.NEW_CAMPAIGN:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(campaigns/* CampaignList */.Ir, {
          data: data
        });

      case constants_widgets/* widgetOptions.TARIFF_DETAILS */.Y.TARIFF_DETAILS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(tariffs/* SingleTariffsContent */.Gn, {
          data: data
        });

      case constants_widgets/* widgetOptions.FIND_OUR_OFFICE */.Y.FIND_OUR_OFFICE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(contact_us/* OfficesList */.T, {
          data: data
        });

      case constants_widgets/* widgetOptions.HEADER_LINKS */.Y.HEADER_LINKS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(tariffs/* SingleTariffsTabs */.YF, {
          tabs: data.links
        });

      case constants_widgets/* widgetOptions.TARIFF_CHOICE */.Y.TARIFF_CHOICE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(tariffs/* FindBundle */.Kp, {
          data: data
        });

      case constants_widgets/* widgetOptions.TARIFF_FILTER */.Y.TARIFF_FILTER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TariffsFilter/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.ADVANTAGEOUS_PRICE */.Y.ADVANTAGEOUS_PRICE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Advantageous */.KU, {
          advantageousData: data
        });

      case constants_widgets/* widgetOptions.FIND_YOUR_NUMBER_ESIM */.Y.FIND_YOUR_NUMBER_ESIM:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(esim/* FindYourEsimFlow */.HR, {
          detail: data
        });

      case constants_widgets/* widgetOptions.ABOUT_ACTIVATION */.Y.ABOUT_ACTIVATION:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ProductStatus */.Pt, {
          statusData: data,
          className: "wrapper small-margin",
          isBlock: true,
          titleModify: "title--large",
          Icon: SvgComponents/* InfoQuestion */.gz
        });

      case constants_widgets/* widgetOptions.OPERATION_LIST */.Y.OPERATION_LIST:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServicesOperations */.bi, {
          className: "wrapper small-margin",
          data: data
        });

      case constants_widgets/* widgetOptions.GENERAL_INFORMATION */.Y.GENERAL_INFORMATION:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServiceReverse */.er, {
          data: data,
          className: "wrapper section",
          background: data === null || data === void 0 ? void 0 : data.background
        });

      case constants_widgets/* widgetOptions.VIDEO */.Y.VIDEO:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServiceVideo */.am, {
          className: "wrapper section",
          data: data
        });

      case constants_widgets/* widgetOptions.SIMPLE_APPLICATION_BANNER */.Y.SIMPLE_APPLICATION_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Banner */.jL, {
          item: data,
          type: 'image_banner',
          href: '/1212',
          buttonHide: true,
          dangerTitle: true
        });

      case constants_widgets/* widgetOptions.WHITE_CARDS */.Y.WHITE_CARDS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* CardBlock */.qp, {
          className: "small-margin wrapper",
          data: data,
          gridValue: data === null || data === void 0 ? void 0 : (_data$cards = data.cards) === null || _data$cards === void 0 ? void 0 : _data$cards.length
        });

      case constants_widgets/* widgetOptions.VOLTE_BANNER */.Y.VOLTE_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* StepsBannerWithTabsVolte */.HE, {
          className: "section wrapper",
          data: data
        });

      case constants_widgets/* widgetOptions.HORIZONTAL_TABLE */.Y.HORIZONTAL_TABLE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(campaigns/* CampaignTable */.rc, {
          data: data,
          className: "wrapper small-margin",
          isHorisontal: true
        });

      case constants_widgets/* widgetOptions.VERTICAL_TABLE */.Y.VERTICAL_TABLE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(campaigns/* CampaignTable */.rc, {
          data: data,
          Icon: SvgComponents/* Flash */.Tx,
          className: "wrapper small-margin"
        });

      case constants_widgets/* widgetOptions.VOLTE_DEVICE_SEARCH */.Y.VOLTE_DEVICE_SEARCH:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(services/* CheckCompatibility */.HG, {
          data: data,
          className: "section wrapper"
        });

      case constants_widgets/* widgetOptions.COMPANY_AWARD */.Y.COMPANY_AWARD:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(about_us/* Awards */.pR, {
          data: data,
          className: "wrapper small-margin"
        });

      case constants_widgets/* widgetOptions.COLOR_CARD */.Y.COLOR_CARD:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(about_us/* ColorCards */.WX, {
          data: data,
          className: "wrapper section"
        });

      case constants_widgets/* widgetOptions.KEY_MILESTONE */.Y.KEY_MILESTONE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(about_us/* Milestones */.Vh, {
          className: "wrapper small-margin",
          data: data,
          isSmall: true
        });

      case constants_widgets/* widgetOptions.OPEN_POSITION */.Y.OPEN_POSITION:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(about_us/* Vacancies */.ZK, {
          data: data,
          className: "wrapper small-margin"
        });

      case constants_widgets/* widgetOptions.CORPORATE_SOCIAL_RESPONSIBILITY */.Y.CORPORATE_SOCIAL_RESPONSIBILITY:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(about_us/* TitleBlock */.Eq, {
          data: data,
          className: "section wrapper"
        });

      case constants_widgets/* widgetOptions.SMALL_CONTENT_BLOCK */.Y.SMALL_CONTENT_BLOCK:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServiceContent */.B$, {
          data: data,
          className: "wrapper"
        });

      case constants_widgets/* widgetOptions.GALLERY */.Y.GALLERY:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServiceSlider */.yi, {
          data: data,
          className: "wrapper section"
        });

      case constants_widgets/* widgetOptions.OUR_MANAGEMENT */.Y.OUR_MANAGEMENT:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(OurManagement/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.BOARD_OF_DIRECTORS */.Y.BOARD_OF_DIRECTORS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(BoardOfDirectors/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.MEDIA_INQUIRE */.Y.MEDIA_INQUIRE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MediaInquire/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.SUSTAINABILITY */.Y.SUSTAINABILITY:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* DocumentCard */.z4, {
          data: data,
          className: 'wrapper section'
        });

      case constants_widgets/* widgetOptions.ADDRESS_CARDS */.Y.ADDRESS_CARDS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* AddressCards */.d5, {
          data: data,
          className: 'wrapper section'
        });

      case constants_widgets/* widgetOptions.COMPANY */.Y.COMPANY:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Company/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.PAYMENT_SYSTEMS */.Y.PAYMENT_SYSTEMS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* PaymentCards */.fP, {
          data: data,
          className: 'wrapper section'
        });

      case constants_widgets/* widgetOptions.PARTNERSHIP_REQUEST */.Y.PARTNERSHIP_REQUEST:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.LATEST_NEWS */.Y.LATEST_NEWS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NewsList/* default */.Z, {
          title: data === null || data === void 0 ? void 0 : data.title
        });

      case constants_widgets/* widgetOptions.CHOOSE_TOPIC_SECTION */.Y.CHOOSE_TOPIC_SECTION:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ChooseTopic/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.POST_WIDGET */.Y.POST_WIDGET:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSingle/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.TOPIC_GROUPS */.Y.TOPIC_GROUPS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(support/* ChooseCategory */.Ho, {
          data: data,
          className: 'wrapper section'
        });

      case constants_widgets/* widgetOptions.INFO_BLOCK */.Y.INFO_BLOCK:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(business_calls/* InfoBlock */.U, {
          className: "wrapper section",
          data: data
        });

      case constants_widgets/* widgetOptions.WHY_BAKCELL */.Y.WHY_BAKCELL:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(business_join_us/* WhyBlock */.CJ, {
          data: data,
          className: "wrapper section"
        });

      case constants_widgets/* widgetOptions.INFO_BOX */.Y.INFO_BOX:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* BusinessSectionBannersWithIcon */.CW, {
          data: data,
          className: 'wrapper section'
        });

      case constants_widgets/* widgetOptions.FIND_YOUR_NUMBER */.Y.FIND_YOUR_NUMBER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(find_your_number/* FindYourNumberFlow */.d, {
          data: data
        });

      case constants_widgets/* widgetOptions.BUSINNES_CARD */.Y.BUSINNES_CARD:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(business_join_us/* BusinessJoinUs */.jt, {
          data: data
        });

      case constants_widgets/* widgetOptions.VIDEO_BLOG */.Y.VIDEO_BLOG:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(VideoBlock/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.FIX_SERVICE */.Y.FIX_SERVICE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(home/* FixServices */.U7, {
          data: data
        });

      case constants_widgets/* widgetOptions.TECHNICAL_SOLUTION */.Y.TECHNICAL_SOLUTION:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(home/* TechnicalSolutions */.BP, {
          data: data
        });

      case constants_widgets/* widgetOptions.PRICING_TABLE */.Y.PRICING_TABLE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(FixService/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.TARIFF_SLIDER_BUSINESS */.Y.TARIFF_SLIDER_BUSINESS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TariffSliderBusiness/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.M2M_BUNDLES */.Y.M2M_BUNDLES:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Bundles */.gl, {
          data: data,
          className: "wrapper card-margin"
        });

      case constants_widgets/* widgetOptions.BUSINESS_ADVANTAGEOUS_PRICE */.Y.BUSINESS_ADVANTAGEOUS_PRICE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(business_roaming/* Advantageous */.KU, {
          data: data
        });

      case constants_widgets/* widgetOptions.INTERNET_ACTIVATION */.Y.INTERNET_ACTIVATION:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(roaming/* InternetActivation */.YN, {
          data: data
        });

      case constants_widgets/* widgetOptions.ROAMING_ACTIVATION_BUSINESS */.Y.ROAMING_ACTIVATION_BUSINESS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(roaming/* RoamingActivation */.Dw, {
          data: data
        });

      case constants_widgets/* widgetOptions.ROAMING_COUNTRY_SEARCH_BUSINESS */.Y.ROAMING_COUNTRY_SEARCH_BUSINESS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SearchTravel */.Ym, {
          data: data
        });

      case constants_widgets/* widgetOptions.SERVICES */.Y.SERVICES:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ServicesGrid/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.ESIM_SWAP */.Y.ESIM_SWAP:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SwapBanner_SwapBanner, {
          data: data
        });

      case constants_widgets/* widgetOptions.TARIFF_SLIDER_BUSINESS_WITHOUT_HEADER */.Y.TARIFF_SLIDER_BUSINESS_WITHOUT_HEADER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TariffSliderBusinessWithoutHeader/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.TECHNICAL_BANNER */.Y.TECHNICAL_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NotFoundPage/* default */.Z, {
          data: data
        });

      case constants_widgets/* widgetOptions.FIVE_G_BANNER */.Y.FIVE_G_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(services/* ServiceFiveGOperations */.Su, {
          data: data,
          className: "wrapper small-margin"
        });

      case constants_widgets/* widgetOptions.FIVE_G_COVERAGE_AREA */.Y.FIVE_G_COVERAGE_AREA:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(AvailableArea_AvailableArea, {
          data: data
        });

      case constants_widgets/* widgetOptions.WHO_WE_ARE */.Y.WHO_WE_ARE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* WhoWeAre */.mx, {
          data: data
        });

      case constants_widgets/* widgetOptions.FIVE_G_COLOR_CARDS */.Y.FIVE_G_COLOR_CARDS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(InfoArea_InfoArea, {
          data: data
        });

      case constants_widgets/* widgetOptions.FULL_BANNER */.Y.FULL_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* FullBanner */.Q1, {
          data: data
        });

      case constants_widgets/* widgetOptions.SEARCH_RESULT_WIDGET */.Y.SEARCH_RESULT_WIDGET:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* SearchList */.Dl, {
          data: data
        });

      case constants_widgets/* widgetOptions.FIBER_OFFERS */.Y.FIBER_OFFERS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(fiber_FiberOffers, {
          data: data
        });

      case constants_widgets/* widgetOptions.STEPS_WITH_IMAGE */.Y.STEPS_WITH_IMAGE:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* StepsWithImage */.zC, {
          data: data
        });

      case constants_widgets/* widgetOptions.FIBER_INFO_BLOCK */.Y.FIBER_INFO_BLOCK:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(AboutUs, {
          data: data
        });

      case constants_widgets/* widgetOptions.BACKDROP_TEXT_WIDGET */.Y.BACKDROP_TEXT_WIDGET:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* TitledBanner */.Gi, {
          data: data
        });

      case constants_widgets/* widgetOptions.FIBER_DEVICE_WIDGET */.Y.FIBER_DEVICE_WIDGET:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ProductsSectionFiber */.uN, {
          data: data
        });

      case constants_widgets/* widgetOptions.CHECK_CONNECTION */.Y.CHECK_CONNECTION:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckConnection_CheckConnection, {
          data: data
        });

      case constants_widgets/* widgetOptions.PRODUCT_HIGHLIGHT */.Y.PRODUCT_HIGHLIGHT:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(EshopSlider_EshopSlider, {
          data: data
        });

      case constants_widgets/* widgetOptions.PRODUCT_DETAIL */.Y.PRODUCT_DETAIL:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DeviceDetails, {
          data: data
        });

      case constants_widgets/* widgetOptions.PRODUCT_LIST */.Y.PRODUCT_LIST:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(EshopCard_EshopCard, {});

      case constants_widgets/* widgetOptions.FIND_YOUR_NUMBER_SIM */.Y.FIND_YOUR_NUMBER_SIM:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(number_sale_FindYourSimNumber, {
          data: data
        });

      case constants_widgets/* widgetOptions.RESULT_BANNER */.Y.RESULT_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessBanner, {
          data: data
        });

      case constants_widgets/* widgetOptions.ERROR_BANNER */.Y.ERROR_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorBanner, {
          data: data
        });

      case constants_widgets/* widgetOptions.ESIM_BANNER */.Y.ESIM_BANNER:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessBanner_SuccessBanner, {
          data: data
        });

      case constants_widgets/* widgetOptions.CONTENT_TABS */.Y.CONTENT_TABS:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(documents_Documents, {
          data: data
        });

      default:
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "wrapper",
          children: [name, " not found"]
        });
    }
  };

  return widgets === null || widgets === void 0 ? void 0 : widgets.map(function (item, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(LazyWidget, {
      index: i,
      loadTriggerIndex: 2,
      children: renderWidgets(item === null || item === void 0 ? void 0 : item.type, item)
    }, i);
  });
};

/* harmony default export */ var widget_wrapper_WidgetWrapper = (WidgetWrapper);

/***/ }),

/***/ 98587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useGetBreakPoints; }
/* harmony export */ });
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2969);


var useGetBreakPoints = function useGetBreakPoints() {
  var _useWindowSize = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_0__/* .useWindowSize */ .iP)(),
      width = _useWindowSize.width;

  return {
    isMobile: width < 768,
    isTablet: width >= 768,
    isDesktop: width >= 1024,
    isSmallDesktop: width < 1024
  };
};



/***/ }),

/***/ 79639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24666);

var years = Array.from(Array(new Date().getFullYear() - 2002), function (_, i) {
  return (i + 2003).toString();
}).reverse();
var yearsSelect = years.map(function (item) {
  return {
    name: item,
    value: item
  };
});

var newsFilter = function newsFilter() {
  return [{
    name: 'month',
    label: 'Month',
    options: [{
      name: 'common:All',
      value: 'all'
    }, {
      name: 'common:january',
      value: '1'
    }, {
      name: 'common:february',
      value: '2'
    }, {
      name: 'common:march',
      value: '3'
    }, {
      name: 'common:april',
      value: '4'
    }, {
      name: 'common:may',
      value: '5'
    }, {
      name: 'common:june',
      value: '6'
    }, {
      name: 'common:july',
      value: '7'
    }, {
      name: 'common:august',
      value: '8'
    }, {
      name: 'common:september',
      value: '9'
    }, {
      name: 'common:october',
      value: '10'
    }, {
      name: 'common:november',
      value: '11'
    }, {
      name: 'common:december',
      value: '12'
    }]
  }, {
    name: 'year',
    label: 'Year',
    options: [{
      name: 'common:All',
      value: 'all'
    }].concat((0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(yearsSelect))
  }];
};

/* harmony default export */ __webpack_exports__["Z"] = (newsFilter);

/***/ }),

/***/ 70245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ widgetOptions; }
/* harmony export */ });
var widgetOptions = {
  SLIDER: 'slider',
  BEAUTIFUL_NUMBERS: 'beautiful_numbers',
  RED_BANNER: 'red_banner',
  APPLICATION_BANNER: 'application_banner',
  NEWS_SLIDER: 'news_slider',
  GRAY_BANNER: 'gray_banner',
  VOLTE_BANNER_NEW: 'volte_banner_simple',
  TARIFF_SLIDER: 'tariff_slider',
  GENERAL_SERVICE: 'general_service',
  IMPORTANT_STEP: 'important_step',
  FOR_FOREIGN_GUEST: 'for_foreign_guest',
  ACCORDION: 'accordion',
  HEADER: 'header',
  ROAMING_COUNTRY_SEARCH: 'roaming_country_search',
  HOTSPOT_MAP: 'hotspot_map',
  NEW_CAMPAIGN: 'new_campaign',
  TARIFF_DETAILS: 'tariff_details',
  FIND_OUR_OFFICE: 'find_our_office',
  HEADER_LINKS: 'header_links',
  TARIFF_FILTER: 'tariff_filter',
  ABOUT_ACTIVATION: 'about_activation',
  ADVANTAGEOUS_PRICE: 'advatageous_price',
  SERVICES: 'services',
  VERTICAL_TABLE: 'vertical_table',
  TARIFF_CHOICE: 'tariff_choice',
  OPERATION_LIST: 'operation_list',
  GENERAL_INFORMATION: 'general_information',
  VIDEO: 'video',
  SIMPLE_APPLICATION_BANNER: 'simple_application_banner',
  WHITE_CARDS: 'white_cards',
  VOLTE_BANNER: 'volte_banner',
  SUSTAINABILITY: 'sustainability',
  ADDRESS_CARDS: 'address_cards',
  PAYMENT_SYSTEMS: 'payment_systems',
  SMALL_CONTENT_BLOCK: 'small_content_block',
  GALLERY: 'gallery',
  HORIZONTAL_TABLE: 'horizontal_table',
  COLOR_CARD: 'color_card',
  CORPORATE_SOCIAL_RESPONSIBILITY: 'corporate_social_responsibility',
  VOLTE_DEVICE_SEARCH: 'volte_device_search',
  COMPANY_AWARD: 'company_award',
  COMPANY: 'company',
  KEY_MILESTONE: 'key_milestone',
  OPEN_POSITION: 'open_position',
  OUR_MANAGEMENT: 'our_management',
  BOARD_OF_DIRECTORS: 'board_of_directors',
  MEDIA_INQUIRE: 'media_inquire',
  PARTNERSHIP_REQUEST: 'partnership_request',
  TOPIC_GROUPS: 'topic_groups',
  LATEST_NEWS: 'latest_news',
  CHOOSE_TOPIC_SECTION: 'choose_topic_section',
  POST_WIDGET: 'post_widget',
  WHY_BAKCELL: 'why_bakcell',
  INFO_BOX: 'info_box',
  BUSINNES_CARD: 'businnes_card',
  INFO_BLOCK: 'info_block',
  FIND_YOUR_NUMBER: 'find_your_number',
  VIDEO_BLOG: 'video_blog',
  FIX_SERVICE: 'fix_service',
  TECHNICAL_SOLUTION: 'technical_solution',
  PRICING_TABLE: 'pricing_table',
  M2M_BUNDLES: 'm2m_bundles',
  TARIFF_SLIDER_BUSINESS: 'tariff_slider_business',
  BUSINESS_ADVANTAGEOUS_PRICE: 'business_advantageous_price',
  FIND_YOUR_NUMBER_ESIM: 'find_your_number_esim',
  INTERNET_ACTIVATION: 'internet_activation',
  ROAMING_ACTIVATION_BUSINESS: 'roaming_activation_business',
  ROAMING_COUNTRY_SEARCH_BUSINESS: 'roaming_country_search_business',
  ESIM_SWAP: 'esim_swap',
  TARIFF_SLIDER_BUSINESS_WITHOUT_HEADER: 'tariff_slider_business_without_header',
  IMAGE_BANNER: 'image_banner',
  BLACK_BANNER: 'black_banner',
  TECHNICAL_BANNER: 'technical_banner',
  FIVE_G_BANNER: 'five_g_banner',
  FIVE_G_COVERAGE_AREA: 'five_g_coverage_area',
  FIVE_G_COLOR_CARDS: 'five_g_color_cards',
  WHO_WE_ARE: 'who_we_are',
  FULL_BANNER: 'full_banner',
  SEARCH_RESULT_WIDGET: 'searchResultWidget',
  FIBER_OFFERS: 'offers_widget',
  STEPS_WITH_IMAGE: 'steps_with_image',
  FIBER_ABOUT_US: 'fiberAboutUs',
  FIBER_TITELED_BANNER: 'fiberTiteledBanner',
  FIBER_PRODUCTS_SECTION: 'fiberProductSection',
  BACKDROP_TEXT_WIDGET: 'backdrop_text_widget',
  FIBER_DEVICE_WIDGET: 'fiber_device_widget',
  FIBER_INFO_BLOCK: 'fiber_info_block',
  CHECK_CONNECTION: 'check_connection',
  PRODUCT_HIGHLIGHT: 'product_highlight',
  PRODUCT_DETAIL: 'product_detail',
  RIGHT_IMAGE_BANNER: 'right_image_banner',
  PRODUCT_LIST: 'product_list',
  FIND_YOUR_NUMBER_SIM: 'find_your_number_sale',
  RESULT_BANNER: 'result_banner',
  ERROR_BANNER: 'error_banner',
  ESIM_BANNER: 'esim_banner',
  CONTENT_TABS: 'content_tabs'
};

/***/ }),

/***/ 52325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yz": function() { return /* binding */ ComponentVariants; },
/* harmony export */   "tr": function() { return /* binding */ Variants; }
/* harmony export */ });
/* unused harmony export Size */
var Variants;

(function (Variants) {
  Variants["pill"] = "pill";
  Variants["secondary"] = "secondary";
  Variants["outline"] = "outline";
  Variants["text"] = "text";
  Variants["white"] = "white";
  Variants["gray"] = "gray";
  Variants["border"] = "border";
  Variants["black"] = "black";
  Variants["transparent"] = "transparent";
})(Variants || (Variants = {}));

var ComponentVariants;

(function (ComponentVariants) {
  ComponentVariants["button"] = "button";
  ComponentVariants["a"] = "a";
  ComponentVariants["router"] = "router";
})(ComponentVariants || (ComponentVariants = {}));

var Size;

(function (Size) {
  Size["normal"] = "normal";
  Size["small"] = "small";
})(Size || (Size = {}));

/***/ }),

/***/ 24204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "In": function() { return /* binding */ EsimPaymentBannerStatus; },
/* harmony export */   "ZY": function() { return /* binding */ EsimSwapStep; },
/* harmony export */   "kz": function() { return /* binding */ EsimFlowType; },
/* harmony export */   "wb": function() { return /* binding */ EsimOrderStep; }
/* harmony export */ });
var EsimFlowType;

(function (EsimFlowType) {
  EsimFlowType["ESIM"] = "esim";
  EsimFlowType["SWAP"] = "swap";
})(EsimFlowType || (EsimFlowType = {}));

var EsimOrderStep;

(function (EsimOrderStep) {
  EsimOrderStep[EsimOrderStep["PERSONAL"] = 0] = "PERSONAL";
  EsimOrderStep[EsimOrderStep["TARIFF"] = 1] = "TARIFF";
  EsimOrderStep[EsimOrderStep["FINAL"] = 2] = "FINAL";
})(EsimOrderStep || (EsimOrderStep = {}));

var EsimSwapStep;

(function (EsimSwapStep) {
  EsimSwapStep[EsimSwapStep["PERSONAL"] = 0] = "PERSONAL";
  EsimSwapStep[EsimSwapStep["FINAL"] = 1] = "FINAL";
})(EsimSwapStep || (EsimSwapStep = {}));

var EsimPaymentBannerStatus;

(function (EsimPaymentBannerStatus) {
  EsimPaymentBannerStatus["SUCCESS"] = "SUCCESS";
  EsimPaymentBannerStatus["FAILED"] = "FAILED";
})(EsimPaymentBannerStatus || (EsimPaymentBannerStatus = {}));

/***/ }),

/***/ 48038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ RedirectUrls; },
/* harmony export */   "z": function() { return /* binding */ TermsTypes; }
/* harmony export */ });
var TermsTypes;

(function (TermsTypes) {
  TermsTypes["NUMBER_SALES_FACE_RECOG_CONTRACT"] = "NUMBER_SALES_FACE_RECOG_CONTRACT";
  TermsTypes["NUMBER_SALES_CONTRACT"] = "NUMBER_SALES_CONTRACT";
})(TermsTypes || (TermsTypes = {}));

var RedirectUrls;

(function (RedirectUrls) {
  RedirectUrls["NUMBER_SALE_PAYMENT_REDIRECT"] = "https://cabinet.bakcell.com/number-sale-result";
  RedirectUrls["ESIM_PAYMENT_REDIRECT"] = "https://www.bakcell.com/esim-result";
})(RedirectUrls || (RedirectUrls = {}));

/***/ }),

/***/ 83136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ EModalType; }
/* harmony export */ });
var EModalType;

(function (EModalType) {
  EModalType["SUCCESS"] = "success";
  EModalType["ERROR"] = "error";
  EModalType["WARNING"] = "warning";
  EModalType["INFO"] = "info";
})(EModalType || (EModalType = {}));

/***/ }),

/***/ 29128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ETheme; }
/* harmony export */ });
var ETheme;

(function (ETheme) {
  ETheme["LIGHT_MODE"] = "light";
  ETheme["DARK_MODE"] = "dark";
})(ETheme || (ETheme = {}));

/***/ }),

/***/ 97367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useBusiness; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);


var useBusiness = function useBusiness() {
  var route = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isBusiness = _useState[0],
      setIsBusiness = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var isBusinessPage = route.pathname.startsWith('/business');
    setIsBusiness(isBusinessPage);

    if (isBusinessPage) {
      document.documentElement.classList.add('business');
    } else {
      document.documentElement.classList.remove('business');
    }
  }, [route.pathname]);
  return isBusiness;
};

/***/ }),

/***/ 13245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useIsCabinet; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(648);
/* harmony import */ var _domains_cabinet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3519);




var useIsCabinet = function useIsCabinet() {
  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_domains_cabinet__WEBPACK_IMPORTED_MODULE_3__/* .selectors.selectCabinet */ .wl.O),
      isLoginTerms = _useSelector.isLoginTerms;

  var route = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isCabinet = _useState[0],
      setIsCabinet = _useState[1];

  var isCabinetPage = route.pathname.startsWith('/login') || route.pathname.startsWith('/cabinet') || isLoginTerms;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setIsCabinet(isCabinetPage);
  }, [isCabinetPage]);
  return isCabinet;
};

/***/ }),

/***/ 45204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useCabinetMenu; },
/* harmony export */   "y": function() { return /* binding */ CabinetProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57611);


var CabinetContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
var useCabinetMenu = function useCabinetMenu() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CabinetContext);
};
var CabinetProvider = function CabinetProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      activeMenu = _useState[0],
      setActiveMenu = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      activeAddAccount = _useState2[0],
      setActiveAddAccount = _useState2[1];

  var handleTabClick = function handleTabClick(index) {
    setActiveMenu(index);
    setActiveAddAccount(false);
  };

  var value = {
    activeMenu: activeMenu,
    activeAddAccount: activeAddAccount,
    handleTabClick: handleTabClick,
    setActiveAddAccount: setActiveAddAccount,
    setActiveMenu: setActiveMenu
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CabinetContext.Provider, {
    value: value,
    children: children
  });
};

/***/ }),

/***/ 66972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35835);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98431);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34587);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61395);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(648);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2969);
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24278);
/* harmony import */ var ua_parser_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(ua_parser_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _domains_cabinet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3519);
/* harmony import */ var _utils_languageFormat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16955);











var useOtpVerification = function useOtpVerification(_ref) {
  var isPopup = _ref.isPopup;
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .selectors.selectCabinet */ .wl.O),
      phoneNumber = _useSelector.phoneNumber,
      uuid = _useSelector.uuid;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      otpRequested = _useState[0],
      setOtpRequested = _useState[1];

  var parser = new (ua_parser_js__WEBPACK_IMPORTED_MODULE_4___default())();
  var result = parser.getResult();

  var _useCountdown = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_6__/* .useCountdown */ .au)({
    countStart: 180,
    intervalMs: 1000
  }),
      _useCountdown2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useCountdown, 2),
      count = _useCountdown2[0],
      _useCountdown2$ = _useCountdown2[1],
      startCountdown = _useCountdown2$.startCountdown,
      resetCountdown = _useCountdown2$.resetCountdown;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    startCountdown();
  }, []);

  if (count === 0) {
    setOtpRequested(false);
    resetCountdown();
  }

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      lang = _useTranslation.lang;

  var formattedLang = (0,_utils_languageFormat__WEBPACK_IMPORTED_MODULE_8__/* .langFormatter */ .u)({
    lang: lang
  });

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      wrongOtp = _useState2[0],
      setWrongOtp = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showError = _useState3[0],
      setShowError = _useState3[1];

  var _cabinetHooks$useOtpR = _domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .hooks.useOtpRequest */ .PT.useOtpRequest(),
      _cabinetHooks$useOtpR2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_cabinetHooks$useOtpR, 1),
      otpTrigger = _cabinetHooks$useOtpR2[0];

  var _cabinetHooks$useSign = _domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .hooks.useSignUp */ .PT.useSignUp(),
      _cabinetHooks$useSign2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_cabinetHooks$useSign, 2),
      signUpTrigger = _cabinetHooks$useSign2[0],
      isLoading = _cabinetHooks$useSign2[1].isLoading;

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(['', '', '', '']),
      otpValue = _useState4[0],
      setOtpValue = _useState4[1];

  var _cabinetHooks$useGetA = _domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .hooks.useGetAccounts */ .PT.useGetAccounts(),
      _cabinetHooks$useGetA2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_cabinetHooks$useGetA, 2),
      getAccountsTrigger = _cabinetHooks$useGetA2[0],
      accountsFetching = _cabinetHooks$useGetA2[1].isFetching;

  var popUpConfirmHandler = /*#__PURE__*/function () {
    var _ref2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
      var response;
      return _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch(_domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .actions.setAccessToken */ .Nw.setAccessToken(data.accessToken));
              _context.next = 4;
              return getAccountsTrigger({
                lang: formattedLang,
                accessToken: data.accessToken,
                oneTime: isPopup
              }).unwrap();

            case 4:
              response = _context.sent;
              dispatch(_domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .actions.setPopUpConfirm */ .Nw.setPopUpConfirm(true));
              dispatch(_domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .actions.setPopupAccount */ .Nw.setPopupAccount(response[0]));
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              setShowError(true);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function popUpConfirmHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSubmitOtpForm = /*#__PURE__*/function () {
    var _ref3 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(value) {
      var _result$device, _result$device$model, _result$device2, _result$os, _result$os2, _result$os3;

      var requestBody, data, _window, _window$location;

      return _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              requestBody = {
                uuid: uuid,
                code: value.join(''),
                msisdn: phoneNumber,
                isEdit: false,
                deviceType: 'WEB',
                firebaseInstallationId: null,
                deviceVendor: result === null || result === void 0 ? void 0 : (_result$device = result.device) === null || _result$device === void 0 ? void 0 : _result$device.vendor,
                deviceModel: (_result$device$model = result === null || result === void 0 ? void 0 : (_result$device2 = result.device) === null || _result$device2 === void 0 ? void 0 : _result$device2.model) !== null && _result$device$model !== void 0 ? _result$device$model : result === null || result === void 0 ? void 0 : (_result$os = result.os) === null || _result$os === void 0 ? void 0 : _result$os.name,
                osName: result === null || result === void 0 ? void 0 : (_result$os2 = result.os) === null || _result$os2 === void 0 ? void 0 : _result$os2.name,
                osVersion: result === null || result === void 0 ? void 0 : (_result$os3 = result.os) === null || _result$os3 === void 0 ? void 0 : _result$os3.version,
                oneTime: isPopup
              };
              _context2.prev = 1;
              _context2.next = 4;
              return signUpTrigger({
                data: requestBody
              }).unwrap();

            case 4:
              data = _context2.sent;

              if (isPopup) {
                popUpConfirmHandler(data);
              } else {
                sessionStorage.setItem('accessToken', data.accessToken);
                sessionStorage.setItem('refreshToken', data.refreshToken);
                dispatch(_domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .actions.prevStep */ .Nw.prevStep());
                (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.assign('/cabinet');
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'Cabinet_login'
                });
              }

              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              setWrongOtp(true);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }));

    return function handleSubmitOtpForm(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var resendHandler = /*#__PURE__*/function () {
    var _ref4 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
      var data;
      return _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return otpTrigger({
                phoneNumber: phoneNumber
              }).unwrap();

            case 3:
              data = _context3.sent;
              dispatch(_domains_cabinet__WEBPACK_IMPORTED_MODULE_5__/* .actions.setUuId */ .Nw.setUuId(data.uuid));
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              setShowError(true);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 7]]);
    }));

    return function resendHandler() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleOtpRequest = function handleOtpRequest() {
    setOtpRequested(true);
    startCountdown();
  };

  var checkArray = function checkArray(value) {
    return value.every(function (code) {
      return code.trim() !== '';
    });
  };

  var submitHandler = function submitHandler(e) {
    e.preventDefault();

    if (!otpRequested) {
      handleOtpRequest();
      resendHandler();
    }
  };

  var handleChangeOtpInput = function handleChangeOtpInput(value) {
    setOtpValue(value);

    if (checkArray(value)) {
      handleSubmitOtpForm(value);
    }
  };

  var formatPhoneNumber = function formatPhoneNumber(phoneNumber) {
    var numericPhoneNumber = phoneNumber.replace(/\D/g, '');
    var formattedPhoneNumber = "+".concat(numericPhoneNumber.slice(0, 3), " ").concat(numericPhoneNumber.slice(3, 5), " ").concat(numericPhoneNumber.slice(5, 8), " ").concat(numericPhoneNumber.slice(8, 10), " ").concat(numericPhoneNumber.slice(10));
    return formattedPhoneNumber;
  };

  return {
    isLoading: isLoading,
    wrongOtp: wrongOtp,
    showError: showError,
    otpRequested: otpRequested,
    otpValue: otpValue,
    submitHandler: submitHandler,
    handleChangeOtpInput: handleChangeOtpInput,
    closeError: function closeError() {
      return setShowError(false);
    },
    formatPhoneNumber: formatPhoneNumber,
    count: count,
    startCountdown: startCountdown,
    accountsFetching: accountsFetching
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useOtpVerification);

/***/ }),

/***/ 27577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);



var usePaginatedData = function usePaginatedData(fullData, perPage) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1),
      currentPage = _useState[0],
      setCurrentPage = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var page = router.query.page;
    var pageNumber = parseInt(page, 10) || 1;
    setCurrentPage(pageNumber);
  }, [router.query.page]);
  var start = (currentPage - 1) * perPage;
  var end = start + perPage;
  var slicedData = fullData === null || fullData === void 0 ? void 0 : fullData.slice(start, end);
  return {
    slicedData: slicedData
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (usePaginatedData);

/***/ }),

/***/ 25367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);



var adjustPositions = function adjustPositions() {
  var dotsElements = document.querySelectorAll('.slick-dots');
  var prevElements = document.querySelectorAll('.slick-prev');
  var nextElements = document.querySelectorAll('.slick-next');
  dotsElements.forEach(function (dotElement, index) {
    var dotWidth = dotElement.offsetWidth;
    var rightPosition = "calc(50% - calc(".concat(dotWidth, "px + 100px) / 1.8)");
    var leftPosition = "calc(50% - calc(".concat(dotWidth, "px + 100px) / 1.8)");
    var prevElement = prevElements[index];

    if (prevElement) {
      prevElement.style.left = leftPosition;
    }

    var nextElement = nextElements[index];

    if (nextElement) {
      nextElement.style.right = rightPosition;
    }
  });
};

var useSlickPositioning = function useSlickPositioning() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    adjustPositions();
    window.addEventListener('resize', adjustPositions);
    router.events.on('routeChangeComplete', adjustPositions);
    return function () {
      window.removeEventListener('resize', adjustPositions);
      router.events.off('routeChangeComplete', adjustPositions);
    };
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useSlickPositioning);

/***/ }),

/***/ 82373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75640);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97043);


var Axios = axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].create */ .Z.create({
  // admin panel integrated url:  http://digitalsales-01.azerconnect.az:8601
  // test url: http://134.122.125.111:8000
  baseURL: _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .CLIENT_URL */ .$p,
  // baseURL: 'http://134.122.125.111:8000',
  headers: {
    'Content-Type': 'application/json'
  }
}); // FOR SERVER SIDE RENDERING BASE URL SHOULD BE http://digitalsales-01.azerconnect.az:8080/api
// FOR FRONTEND SIDE RENDERING BASE URL SHOULD BE https://new.bakcell.com/api/bkc-web/api
// FOR MEDIA https://new.bakcell.com/media/uploads/.....

/* harmony default export */ __webpack_exports__["Z"] = (Axios);

/***/ }),

/***/ 15392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ processDeviceData; }
/* harmony export */ });
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24666);

var processDeviceData = function processDeviceData(deviceData, translateFn) {
  if (!(deviceData !== null && deviceData !== void 0 && deviceData.data)) return [];
  var filteredDevices = deviceData.data.filter(function (object) {
    return (object === null || object === void 0 ? void 0 : object.id) !== 4;
  });
  var iphoneDevices = deviceData.data.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.id) === 4;
  }).map(function (object) {
    return {
      id: 0,
      name: object === null || object === void 0 ? void 0 : object.name,
      supportedDevicesResponseList: object === null || object === void 0 ? void 0 : object.supportedDevicesResponseList
    };
  });
  var slicedDevices = filteredDevices.map(function (item, index) {
    return {
      id: index + 1,
      name: item === null || item === void 0 ? void 0 : item.name,
      supportedDevicesResponseList: item === null || item === void 0 ? void 0 : item.supportedDevicesResponseList
    };
  });
  var fullDevices = [].concat((0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(iphoneDevices), (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(slicedDevices));
  var translatedIndex = fullDevices.findIndex(function (item) {
    var _item$name;

    return (item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase()) === 'other';
  });

  if (translatedIndex >= 0) {
    fullDevices[translatedIndex].name = translateFn('esim:common.other');
  }

  return fullDevices;
};

/***/ }),

/***/ 53836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ formatPhoneNumber; }
/* harmony export */ });
var formatPhoneNumber = function formatPhoneNumber(inputValue) {
  var numericValue = inputValue.replace(/\D/g, '');

  if (!numericValue.startsWith('994')) {
    return inputValue;
  }

  return "+".concat(numericValue.slice(0, 3), "-").concat(numericValue.slice(3, 5), "-").concat(numericValue.slice(5, 8), "-").concat(numericValue.slice(8, 10), "-").concat(numericValue.slice(10));
};

/***/ }),

/***/ 32238:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var formatPhoneNumberNew = function formatPhoneNumberNew(inputNumber) {
  var withCountryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var formattedNumber = '';

  if (withCountryCode) {
    formattedNumber = inputNumber === null || inputNumber === void 0 ? void 0 : inputNumber.toString().replace(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
  } else {
    formattedNumber = inputNumber === null || inputNumber === void 0 ? void 0 : inputNumber.toString().replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
  }

  return formattedNumber;
};

/* harmony default export */ __webpack_exports__["Z"] = (formatPhoneNumberNew);

/***/ }),

/***/ 67352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ formatTimer; }
/* harmony export */ });
var formatTimer = function formatTimer(time) {
  var minutes = Math.floor(time / 60);
  var seconds = time % 60;
  return "".concat(minutes.toString().padStart(2, '0'), ":").concat(seconds.toString().padStart(2, '0'));
};

/***/ }),

/***/ 3937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15835);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_0__);


var generateInitialToken = function generateInitialToken(phoneNumber, deviceId) {
  var secretKey = 'c3VwZXJfYXBwX2Jha2NlbGxfc2VjcmV0';
  var now = new Date(Date.now()); // Back end needs the phone number in the format of XX XXX XX XX

  var formattedNumber = "".concat(phoneNumber.slice(3, 5), " ").concat(phoneNumber.slice(5, 8), " ").concat(phoneNumber.slice(8, 10), " ").concat(phoneNumber.slice(10, 12));
  var ivParameter = "994".concat(formattedNumber).split('').reverse().join('') + formatDate(now, 'ddMM').split('').reverse().join('');
  var trimmedIVParameter = ivParameter.replace(/\s/g, '');
  return encryptData("".concat(deviceId, "$$").concat(formattedNumber), secretKey, trimmedIVParameter);
};

function encryptData(data, secretKey, globalSalt) {
  var key = crypto_js__WEBPACK_IMPORTED_MODULE_0___default().enc.Utf8.parse(secretKey);
  var iv = crypto_js__WEBPACK_IMPORTED_MODULE_0___default().enc.Utf8.parse(globalSalt);
  var encrypted = crypto_js__WEBPACK_IMPORTED_MODULE_0___default().AES.encrypt(data, key, {
    iv: iv,
    mode: (crypto_js__WEBPACK_IMPORTED_MODULE_0___default().mode.CTR)
  });
  return encrypted.toString();
}

var formatDate = function formatDate(date, format) {
  var options = {
    day: '2-digit',
    month: '2-digit'
  };
  var formattedDate = date.toLocaleDateString('en-US', options);

  if (format === 'ddMM') {
    return formattedDate.slice(3, 5) + formattedDate.slice(0, 2); // Rearrange the format
  }

  return formattedDate.replace(/\//g, '');
};

/* harmony default export */ __webpack_exports__["Z"] = (generateInitialToken);

/***/ }),

/***/ 88929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ validateGeneral; },
/* harmony export */   "t": function() { return /* binding */ handleCheckKeyForMail; }
/* harmony export */ });
/**
 * @param event - The keyboard event triggered by the user's key press.
 * @param regex - The regular expression to test the allowed characters.
 */
var handleCheckKey = function handleCheckKey(event, regex) {
  if (!regex.test(event.key) && event.key !== 'Backspace') {
    event.preventDefault();
  }
};

var handleCheckKeyForMail = function handleCheckKeyForMail(event) {
  var mailRegex = /^[a-zA-Z0-9@.]/;
  handleCheckKey(event, mailRegex);
};
var validateGeneral = function validateGeneral(event) {
  var generalRegex = /^[a-zA-Zа-яА-ЯəöğüşçƏÖĞÜŞÇıİ0-9\s,.:"'_;()-]*$/;
  handleCheckKey(event, generalRegex);
};

/***/ }),

/***/ 16955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ langFormatter; }
/* harmony export */ });
var langFormatter = function langFormatter(_ref) {
  var lang = _ref.lang;

  if (lang === 'az') {
    return 'AZE';
  }

  if (lang === 'ru') {
    return 'RU';
  }

  if (lang === 'en') {
    return 'ENG';
  }
};

/***/ }),

/***/ 327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ scrollToTop; }
/* harmony export */ });
var scrollToTop = function scrollToTop(ref) {
  if (true) {
    if (ref !== null && ref !== void 0 && ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};

/***/ }),

/***/ 77057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFoundPage_container__f0Ai2"};

/***/ }),

/***/ 93226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"awards__title":"Awards_awards__title__kuHo_","awards__inner":"Awards_awards__inner__f_nAb","custom":"Awards_custom__57tN_","awards-item":"Awards_awards-item__VEXtP","year":"Awards_year__2sbHz","awards-item__list":"Awards_awards-item__list__Yp5yy","awards-element":"Awards_awards-element__jyP78","awards-element__icon":"Awards_awards-element__icon__MP_0y","awards-element__text":"Awards_awards-element__text__HRURK"};

/***/ }),

/***/ 55565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"color-cards__title":"ColorCards_color-cards__title__5MrhL","color-cards__inner":"ColorCards_color-cards__inner__FzVVS","color-card":"ColorCards_color-card__UleQp","color-card__icon":"ColorCards_color-card__icon___0Itn","color-card__icon-wrapper":"ColorCards_color-card__icon-wrapper__S5kPl","color-card__title":"ColorCards_color-card__title__nyrQb","color-card__desc":"ColorCards_color-card__desc__ClTSD","color-card__button":"ColorCards_color-card__button__e0JsI","color-card__button--link":"ColorCards_color-card__button--link__1G7hK","color-card__bg":"ColorCards_color-card__bg__oxmcU"};

/***/ }),

/***/ 37885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"directorItem":"DirectorItem_directorItem__BRHz_","director_img":"DirectorItem_director_img__ai36l","image":"DirectorItem_image__HNqet","info":"DirectorItem_info__x72Ic","name":"DirectorItem_name__1cv4B","position":"DirectorItem_position__u_D1k","button":"DirectorItem_button__ejKdT"};

/***/ }),

/***/ 64199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"milestones":"Milestones_milestones__thTsi","milestones__title":"Milestones_milestones__title__aH_oi","milestones__three":"Milestones_milestones__three__vNZ3l","milestones__line":"Milestones_milestones__line__9mm7Z","milestones-item-container":"Milestones_milestones-item-container__Bnx_8","milestones-item-container_connector":"Milestones_milestones-item-container_connector__MBZoW","milestones-item_square":"Milestones_milestones-item_square__toTko","milestones-item":"Milestones_milestones-item__SfuqM","milestones-item_connector":"Milestones_milestones-item_connector__N7opS","milestones-item_square_small":"Milestones_milestones-item_square_small__Ab1oz","milestones-item__year":"Milestones_milestones-item__year__oneTn","milestones-item__list":"Milestones_milestones-item__list__OBDy2"};

/***/ }),

/***/ 24300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title-block__title":"TitleBlock_title-block__title__10bKO","title-block__inner":"TitleBlock_title-block__inner__zBR_i","title-block":"TitleBlock_title-block__eDANO","title-card":"TitleBlock_title-card__SZHNt","title-card__counter":"TitleBlock_title-card__counter__YE8h4","title-card__content":"TitleBlock_title-card__content__qxCvp","title-card__title":"TitleBlock_title-card__title__temzP","title-card__desc":"TitleBlock_title-card__desc__jOvU4"};

/***/ }),

/***/ 46571:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Vacancies_title__ayEqe","content_wrapper":"Vacancies_content_wrapper__EQ3b_","titleWrapper":"Vacancies_titleWrapper__MAAtD","sorts":"Vacancies_sorts__R3fs1","modalContent":"Vacancies_modalContent__g3s1f","field":"Vacancies_field__H_zRm","half":"Vacancies_half__2kHhH","fileTitle":"Vacancies_fileTitle__5tJ4B","modalContentSuccess":"Vacancies_modalContentSuccess__jLvDr","svg":"Vacancies_svg__VUxYT","button":"Vacancies_button__IV0yG","vacancies":"Vacancies_vacancies___19T_","vacancies__list":"Vacancies_vacancies__list__fzXvC","show":"Vacancies_show__Q2nxU","checkbox":"Vacancies_checkbox__uhfOA","link":"Vacancies_link__dkdf4","vacancy-item":"Vacancies_vacancy-item__3jH_Q","vacancy-item--active":"Vacancies_vacancy-item--active__v6cAf","vacancy-info":"Vacancies_vacancy-info__glMRq","vacancy-item__arrow":"Vacancies_vacancy-item__arrow__GIpkL","vacancy-item__head":"Vacancies_vacancy-item__head__gQtsn","vacancy-item__city":"Vacancies_vacancy-item__city__f5H7Z","vacancy-item__additional":"Vacancies_vacancy-item__additional__hO95k","vacancy-item__content":"Vacancies_vacancy-item__content__s6xXZ","vacancy-item__category":"Vacancies_vacancy-item__category__KdxX5","vacancy-item__city-text":"Vacancies_vacancy-item__city-text__tOFiX","vacancy-item__city-icon":"Vacancies_vacancy-item__city-icon__3JcR8","vacancy-item__button":"Vacancies_vacancy-item__button__5BpfQ","vacancy-info__subtitle":"Vacancies_vacancy-info__subtitle__ZF2Sf","vacancy-info__desc":"Vacancies_vacancy-info__desc__5by9k","num-list":"Vacancies_num-list__Go7j7","num-list__subtitle":"Vacancies_num-list__subtitle__fMlji","unordered-list":"Vacancies_unordered-list__wW97m","vacancies-opener":"Vacancies_vacancies-opener__n4xOr","hide":"Vacancies_hide__ObsHn","vacancies-opener__text":"Vacancies_vacancies-opener__text__qdPuG"};

/***/ }),

/***/ 75044:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info-block":"InfoBlock_info-block__KTp_J","info-block__title":"InfoBlock_info-block__title__E3PEf","info-block__inner":"InfoBlock_info-block__inner__Wnewf","info__text":"InfoBlock_info__text__HvyZP","info__buttons":"InfoBlock_info__buttons__O0ove","info__sub-text":"InfoBlock_info__sub-text__x2a9s","info__button":"InfoBlock_info__button__baNjD","info__add-text":"InfoBlock_info__add-text__1FZGb","img-block":"InfoBlock_img-block__p2Yso","img-block__elem":"InfoBlock_img-block__elem__Vm2m3"};

/***/ }),

/***/ 25190:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tables":"FixService_tables__88EWN","tables__item":"FixService_tables__item__csOb0"};

/***/ }),

/***/ 59354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content-cards":"BusinessJoinUs_content-cards__XBJEV","content-cards__title":"BusinessJoinUs_content-cards__title__P4Hco","content-cards__inner":"BusinessJoinUs_content-cards__inner__YM5Gx","card":"BusinessJoinUs_card__W62co","card__img":"BusinessJoinUs_card__img__t1Gfj","card__img-wrapper":"BusinessJoinUs_card__img-wrapper__qHV_Z","card__content":"BusinessJoinUs_card__content__Xde2j","card__title":"BusinessJoinUs_card__title__Z9i30","card__text":"BusinessJoinUs_card__text__hirYN","card__button":"BusinessJoinUs_card__button__fxUGW"};

/***/ }),

/***/ 80455:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content-list":"ContentList_content-list__tSZuE","content-list__title":"ContentList_content-list__title__cn8_e","content-list__grid":"ContentList_content-list__grid__1jKDl","content-list__text":"ContentList_content-list__text__6CwIR","content-list__values":"ContentList_content-list__values__QMe_n","links":"ContentList_links__nSzNU","links__title":"ContentList_links__title__Sv3TA","links__list":"ContentList_links__list__rML0Y","img-block":"ContentList_img-block__7Fu_v","img-block__elem":"ContentList_img-block__elem__54ohv"};

/***/ }),

/***/ 49807:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"why-block":"WhyBlock_why-block__EAao7","topWrapper":"WhyBlock_topWrapper__9zOwk","why-block__text":"WhyBlock_why-block__text__udfS7","why-block__title":"WhyBlock_why-block__title__hvZly","why-block__content":"WhyBlock_why-block__content__Ky4VJ","why":"WhyBlock_why__Bfz6o","why__item":"WhyBlock_why__item__BLQJZ","why__value":"WhyBlock_why__value__ts5NP","why__name":"WhyBlock_why__name__HFxcH","why__text":"WhyBlock_why__text__wmUDS","why__subtext":"WhyBlock_why__subtext__JG_hQ"};

/***/ }),

/***/ 14138:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"Advantageous_text__omUkY","button":"Advantageous_button__yuB1U"};

/***/ }),

/***/ 56798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info-table":"InfoTable_info-table__EmHuI","info-table--dark":"InfoTable_info-table--dark__BsuZn","info-table__title":"InfoTable_info-table__title__ZXoAD","info-table__text":"InfoTable_info-table__text__T7GIl","info-table__button":"InfoTable_info-table__button__j_1kh","table":"InfoTable_table__FqvwW","table__inner":"InfoTable_table__inner__dhilx","table__column":"InfoTable_table__column__c8EPP","table__title":"InfoTable_table__title__k8CO_","table__values":"InfoTable_table__values__xVuL4","table__element":"InfoTable_table__element__HelTx","gray":"InfoTable_gray__8d_vP"};

/***/ }),

/***/ 9246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tariffs-title":"BusinessTariffs_tariffs-title__HXlny","slider":"BusinessTariffs_slider__Olsu9"};

/***/ }),

/***/ 87570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"person":"PersonCard_person__T46Be","image":"PersonCard_image__6sfHK","play":"PersonCard_play__CtcmG","name":"PersonCard_name__ZxFO6","position":"PersonCard_position__tGmBA","description":"PersonCard_description__fKmDc"};

/***/ }),

/***/ 23484:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customTopupModal":"top-up-modal_customTopupModal__Zt8c4","redLine":"top-up-modal_redLine__zFonV","selections":"top-up-modal_selections__hDIB_","existNumber":"top-up-modal_existNumber__Ow0gu","otherNumber":"top-up-modal_otherNumber__cCKl4","existNumber__active":"top-up-modal_existNumber__active__9L8LJ","otherNumber__active":"top-up-modal_otherNumber__active__50n9W","top":"top-up-modal_top__zu8lh","bottom":"top-up-modal_bottom__sQT1d","title":"top-up-modal_title__KK5Pt","amount":"top-up-modal_amount__TUkpK","otherNumberInput":"top-up-modal_otherNumberInput__0t7gz","amountInput":"top-up-modal_amountInput__xXE4R","amountInput__main":"top-up-modal_amountInput__main__GeSCI","amountOptions":"top-up-modal_amountOptions__xbCtG"};

/***/ }),

/***/ 48734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsItem":"Campaign_newsItem__ADDZj","contentWrapper":"Campaign_contentWrapper___h_64","link":"Campaign_link__buXQL","goToPost":"Campaign_goToPost__bCHuB","arrow":"Campaign_arrow__SzBEw","imageContainer":"Campaign_imageContainer__0baIy","textWrapper":"Campaign_textWrapper__R8Jfl","title":"Campaign_title__qR6fv","description":"Campaign_description__jHtEN"};

/***/ }),

/***/ 96725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CampaignList_wrapper__uhCni","titleWrapper":"CampaignList_titleWrapper__vk42q","title":"CampaignList_title__OgiMU","select":"CampaignList_select__xQN6B"};

/***/ }),

/***/ 88583:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"campaign-table":"CampaignTable_campaign-table__YMRIW","campaign-table__title":"CampaignTable_campaign-table__title__6CB6E","campaign-table__text":"CampaignTable_campaign-table__text__LVXUI"};

/***/ }),

/***/ 10730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"five_g_map":"AvailableArea_five_g_map__Cz8oS","container":"AvailableArea_container__PwsRL","areaList":"AvailableArea_areaList__u0sWG","list":"AvailableArea_list__G9yHP","item":"AvailableArea_item__F1Jaw","map":"AvailableArea_map__2gh3E","areaListIcon":"AvailableArea_areaListIcon__VJEcQ"};

/***/ }),

/***/ 45151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckoutHeader_wrapper__0Qrm7","header":"CheckoutHeader_header__iy09Q","logo":"CheckoutHeader_logo__dY3KD","support":"CheckoutHeader_support__GYWeq"};

/***/ }),

/***/ 36192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__Jqiqm","footer__business":"footer_footer__business__C8O7U","divider":"footer_divider__okgoF","rightBox":"footer_rightBox__Vn9IL","list":"footer_list__kYSv1","logo":"footer_logo__SnCj9","bottomLeftBox":"footer_bottomLeftBox__Du0vo","text":"footer_text__PA2Jw","additionalBlock":"footer_additionalBlock__qa5Sa","toTop":"footer_toTop__rW6mu","button":"footer_button__VhPN6","leftBox":"footer_leftBox__FKbc_","fistList":"footer_fistList__00ZL_","topBox":"footer_topBox__Jz0_s","bottomBox":"footer_bottomBox__LzlG0","infoItem":"footer_infoItem__X3P_L","underLink":"footer_underLink__154BH","container":"footer_container__DicVE","bottomRightBox":"footer_bottomRightBox__n35Lk","footerBottomWrapper":"footer_footerBottomWrapper__Z8dWY","footerBtmImg":"footer_footerBtmImg__4MDdt","dark":"footer_dark__5AAjh"};

/***/ }),

/***/ 4821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"google-maps_wrap__GmbCo","map":"google-maps_map__84Ul5","infoWindow":"google-maps_infoWindow__UVb6Q","infoWindowCity":"google-maps_infoWindowCity__go3no","infoWindowStreet":"google-maps_infoWindowStreet__h_8sE","infoWindowCoverage":"google-maps_infoWindowCoverage__n791C","infoWindowButton":"google-maps_infoWindowButton__0aggg","infoWindowTitle":"google-maps_infoWindowTitle__tgyhn","infoWindowAddress":"google-maps_infoWindowAddress___Oa9q","infoWindowBlock":"google-maps_infoWindowBlock__N4QQV","label":"google-maps_label__cLc5z","value":"google-maps_value__rx5bM","hours":"google-maps_hours__JBrEG"};

/***/ }),

/***/ 64834:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ZEgk","current":"styles_current__Mirik","languageList":"styles_languageList__k0tK6","active":"styles_active__DE14X"};

/***/ }),

/***/ 80183:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchField_wrapper__ncAok","active":"SearchField_active__XcMfQ","input":"SearchField_input__y92TP","red_icon":"SearchField_red_icon__5oBdc","content":"SearchField_content__cQfTy","button":"SearchField_button__nPvDJ"};

/***/ }),

/***/ 38817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arrowSvg":"styles_arrowSvg__fxmRY","gray_icon":"styles_gray_icon__VVWpA","header":"styles_header__K5_Vj","open":"styles_open__aPIpu","wrapper":"styles_wrapper__1SI3_","top":"styles_top__vSN7U","list":"styles_list__ZqD04","buttons":"styles_buttons__1EChh","bottom":"styles_bottom__Rcpo_","search":"styles_search__A0OYj","menu":"styles_menu__beUwS","navButton":"styles_navButton__IbIHu","dFlex":"styles_dFlex__Pxxup","arrow":"styles_arrow__l1DSp","joinBakcell":"styles_joinBakcell__gOQSA","left":"styles_left__tfOCN","logo":"styles_logo__YB5G1","joinUs":"styles_joinUs__Z4Cw4","navBar":"styles_navBar__ZS6RE","item":"styles_item__pUnPj","active":"styles_active__mYvnH","nav":"styles_nav__DR3k8","navItem":"styles_navItem__E4Vcz","right":"styles_right__KwpQG","contacts":"styles_contacts__j_p3g","userIcon":"styles_userIcon__ffFuk","userIconDiv":"styles_userIconDiv__9NYpn","arrowDiv":"styles_arrowDiv__hvPHD","singIn":"styles_singIn__iTU3j","pageSwitch":"styles_pageSwitch__Urp7O","closeMobile":"styles_closeMobile__pPLjq","mobileWrapper":"styles_mobileWrapper__PVviq","mobileButtons":"styles_mobileButtons__2T24M","button":"styles_button__Fr8uL","topCabinetPage":"styles_topCabinetPage__PgPZs","leftCabinet":"styles_leftCabinet__bvcmg","topContent":"styles_topContent__ZF9zw","cabinetPage":"styles_cabinetPage__eWsle","bakcell_logo":"styles_bakcell_logo__wLx1B","cabinet":"styles_cabinet__ErlJJ","header__content":"styles_header__content__3T7Jb","navContent":"styles_navContent___IXvl","mobile":"styles_mobile__1Mas5","burgerHolder":"styles_burgerHolder__gUF9R","burger":"styles_burger__udwS_","introWrapper":"styles_introWrapper__gpOAX","intro":"styles_intro___Pm_e","marquee":"styles_marquee__MC_d7","intro__item":"styles_intro__item__rqmpN","text":"styles_text__aXGbW","business":"styles_business__2X473","mobile_input":"styles_mobile_input__9nHLl","disabled":"styles_disabled__0qyEw"};

/***/ }),

/***/ 77300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoArea_container__XHmAb","imageContainer":"InfoArea_imageContainer__moQyU","decription":"InfoArea_decription__QGQR1"};

/***/ }),

/***/ 89906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsItem":"NewsItem_newsItem__HvkI8","category":"NewsItem_category__HlEgT","imageContainer":"NewsItem_imageContainer__hGu4C","textWrapper":"NewsItem_textWrapper__7ZW8J","theme":"NewsItem_theme__b_vtv","title":"NewsItem_title__D6CoI","description":"NewsItem_description__N9HAa","date":"NewsItem_date__kadnX","see_more__btn":"NewsItem_see_more__btn__NgI9l"};

/***/ }),

/***/ 44575:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"face_timer":"RecordModal_face_timer__qD4XA","sima_loader":"RecordModal_sima_loader__zes6A","face_rule_wrapper":"RecordModal_face_rule_wrapper___ahKR","detail":"RecordModal_detail__sT6p6","face_progress_bar":"RecordModal_face_progress_bar__b3Kxh","start_face_btn":"RecordModal_start_face_btn__zYCSz","wrap":"RecordModal_wrap__Wgyta","big":"RecordModal_big__Opp9z","open":"RecordModal_open__pKL5M","faceInfoInner":"RecordModal_faceInfoInner__GT5C3","close_btn":"RecordModal_close_btn__MK6LV","faceInfoContent":"RecordModal_faceInfoContent__2STqV","webcam":"RecordModal_webcam__d9wIs","timer":"RecordModal_timer__hOe2C","title":"RecordModal_title__u_SMR","description":"RecordModal_description__MnUFU","flexed_imgs":"RecordModal_flexed_imgs__94hNc","close":"RecordModal_close__MA5jW","camera_wrap":"RecordModal_camera_wrap__qWqcp","sima_wrap":"RecordModal_sima_wrap__Evh8j","text":"RecordModal_text__Ckz0_","bottom":"RecordModal_bottom__yKnlE","sima_btn__wrapper":"RecordModal_sima_btn__wrapper__Sr3B1"};

/***/ }),

/***/ 23964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"SliderContainer_title__7snOR","slider":"SliderContainer_slider__a7uOj","arrowBlock":"SliderContainer_arrowBlock__QVbck"};

/***/ }),

/***/ 93706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"social-network_list__Qa2pS","item":"social-network_item__G72n1","icon":"social-network_icon___tNv_"};

/***/ }),

/***/ 2903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mt_2":"ToolBar_mt_2__3ELUs","wrapper":"ToolBar_wrapper__sHD5x","header":"ToolBar_header__mh_uD","close":"ToolBar_close__S7Exq","active":"ToolBar_active__nL_ua","container":"ToolBar_container__TKmEc","title":"ToolBar_title__NkIhk","grid":"ToolBar_grid__v91bM"};

/***/ }),

/***/ 37688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Service_container__Ai_DX","intro":"Service_intro__sZ9JK","imageWrapper":"Service_imageWrapper__aJKDY","image":"Service_image__Gyxvn","title":"Service_title__d6ppq"};

/***/ }),

/***/ 86577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Filters_wrap__W_Hsq","filtersBlock":"Filters_filtersBlock__EGzCJ","block":"Filters_block__3YA5F","action":"Filters_action__JytiP","filter":"Filters_filter__jSBdB","buttons":"Filters_buttons__iBfLW","button":"Filters_button__cpHjd","active":"Filters_active__i3wAZ","selects":"Filters_selects__T0MSR","select":"Filters_select__f8KdM"};

/***/ }),

/***/ 38974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Map_wrap__iAPCN","map":"Map_map__oxS_3","infoWindow":"Map_infoWindow__LREQf","infoWindowCity":"Map_infoWindowCity__US683","infoWindowStreet":"Map_infoWindowStreet__omJNe","infoWindowCoverage":"Map_infoWindowCoverage__uykBz","infoWindowButton":"Map_infoWindowButton__YxwiQ","infoWindowTitle":"Map_infoWindowTitle__Zq6jM","infoWindowAddress":"Map_infoWindowAddress__zxpro","infoWindowBlock":"Map_infoWindowBlock__ExXVY","label":"Map_label__ZC0ET","value":"Map_value__fNc2u","hours":"Map_hours__bNEJf"};

/***/ }),

/***/ 98098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"OfficesList_wrap__jN0ao","filterWrap":"OfficesList_filterWrap__U6iOx","filterWrapMap":"OfficesList_filterWrapMap__S6jGC","list":"OfficesList_list__v5BuE","item":"OfficesList_item__YJBP4","col":"OfficesList_col__4Yt4D","label":"OfficesList_label__sG_v1","value":"OfficesList_value__GS_cu","title":"OfficesList_title__b2lVp","hours":"OfficesList_hours__QF_Xd","link":"OfficesList_link__FK9mk"};

/***/ }),

/***/ 30585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"singleCharacteristics":"CharacteristicsItem_singleCharacteristics__gR_OW","singleCharacteristics__top":"CharacteristicsItem_singleCharacteristics__top____K6g"};

/***/ }),

/***/ 44195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"value__texts":"SingleCharacteristic_value__texts__EeuVS","value":"SingleCharacteristic_value__RBHV6","value__hr":"SingleCharacteristic_value__hr__fqrPs"};

/***/ }),

/***/ 29075:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bottom":"DeviceCharacteristics_bottom__4vPIJ"};

/***/ }),

/***/ 40246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customSlider":"ImageSlider_customSlider__3AdTc","sliderImage":"ImageSlider_sliderImage__fJIHS"};

/***/ }),

/***/ 98042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"singleImage":"DeviceImages_singleImage__RLwvR","singleImage__active":"DeviceImages_singleImage__active__HsM4F"};

/***/ }),

/***/ 90648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"MonthOption_option__bOBL9","option__active":"MonthOption_option__active__3pnCg"};

/***/ }),

/***/ 59598:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offer":"OfferItem_offer__LNmLJ","iconHolder":"OfferItem_iconHolder__QXXnJ","texts":"OfferItem_texts__aC0p9"};

/***/ }),

/***/ 94152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"right":"DeviceOffers_right__jSKpr","birbankMonths":"DeviceOffers_birbankMonths__pHIMb","title":"DeviceOffers_title__VSED7","icon":"DeviceOffers_icon__uYMPa","monthlyOptions":"DeviceOffers_monthlyOptions__DATEL","calculator":"DeviceOffers_calculator___oVgZ","calculator__bold":"DeviceOffers_calculator__bold__pztD6"};

/***/ }),

/***/ 25341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"capacityContainer":"DeviceOptions_capacityContainer__GHvo9","selected":"DeviceOptions_selected__L4NWi","options":"DeviceOptions_options__jMa5v","option":"DeviceOptions_option__YF6Cw","option__active":"DeviceOptions_option__active__LHFTO","colorContainer":"DeviceOptions_colorContainer__tPpXl","colorOption":"DeviceOptions_colorOption__ca28y","colorOption__active":"DeviceOptions_colorOption__active__KRUlA","inside":"DeviceOptions_inside__0k9u0"};

/***/ }),

/***/ 90153:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customModal":"ImageModal_customModal__afyIT","firstTitle":"ImageModal_firstTitle__KtQjE","images":"ImageModal_images___xXmg","overflowWrapper":"ImageModal_overflowWrapper__Qh9Xd","next":"ImageModal_next__SXzrF","mainImage":"ImageModal_mainImage__lHdcE","sliderImage":"ImageModal_sliderImage__8Eyvj","top":"ImageModal_top___RZhF","right":"ImageModal_right__i_ILJ","discountPrice":"ImageModal_discountPrice__PtUam","price":"ImageModal_price__jl_RP","modalPrice":"ImageModal_modalPrice__YS3Q7","bottom":"ImageModal_bottom__ozaXU","imageWrapper":"ImageModal_imageWrapper__IJpjJ"};

/***/ }),

/***/ 73892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"remindModal":"DeviceDetails_remindModal__t3cI2","firstTitle":"DeviceDetails_firstTitle__S15wp","mobileBadges":"DeviceDetails_mobileBadges__ct7__","singleBadge":"DeviceDetails_singleBadge__MpBLL","singleBadge__deep_red":"DeviceDetails_singleBadge__deep_red__gNVPY","singleBadge__lighter_red":"DeviceDetails_singleBadge__lighter_red__KcrMk","mobileFixed":"DeviceDetails_mobileFixed__L2DoD","custom":"DeviceDetails_custom__3zQ8_","priceMobile":"DeviceDetails_priceMobile__JCuqy","price":"DeviceDetails_price__8wAVK","discountPrice":"DeviceDetails_discountPrice__BCOb8","btn":"DeviceDetails_btn__BwIH2","customWrapper":"DeviceDetails_customWrapper__bv5C3","left":"DeviceDetails_left__sPU1v","imageWrapper":"DeviceDetails_imageWrapper__p3sWh","buttonVisible":"DeviceDetails_buttonVisible__jv4bB","priceContainer":"DeviceDetails_priceContainer__KEaq6","buttonVisible__visible":"DeviceDetails_buttonVisible__visible__32VAS","images":"DeviceDetails_images__byNyp","prev":"DeviceDetails_prev__uHYps","next":"DeviceDetails_next__hd0N5","overflower":"DeviceDetails_overflower__5aoU0","mainImage":"DeviceDetails_mainImage__NIuvk","badges":"DeviceDetails_badges__b5uou","bonusNet":"DeviceDetails_bonusNet__RajXd","right":"DeviceDetails_right__fYEOO","top":"DeviceDetails_top__vmbnT","leftWrapper":"DeviceDetails_leftWrapper__jdBQ1","buttons":"DeviceDetails_buttons__7MzYT","edv":"DeviceDetails_edv__L2sWW","inStock":"DeviceDetails_inStock__I2Rei","outStock":"DeviceDetails_outStock__uEeRD","description":"DeviceDetails_description__R5k1o","buttonContainer":"DeviceDetails_buttonContainer__YHErj"};

/***/ }),

/***/ 67757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"products_container":"EshopCard_products_container__asxFg","content_wrapper":"EshopCard_content_wrapper__KURQO","card_wrapper":"EshopCard_card_wrapper__PHDxa"};

/***/ }),

/***/ 44357:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_wrapper":"EshopItems_product_wrapper__WJkV5","img_box":"EshopItems_img_box__CL9FT","label_wrapper":"EshopItems_label_wrapper__vNOjb","small_box":"EshopItems_small_box__hg9p7","dark":"EshopItems_dark__7C7Tq","desc":"EshopItems_desc__8_7J3","content_box":"EshopItems_content_box__TYJsd","product_title":"EshopItems_product_title__yr3sj","price_box":"EshopItems_price_box__dWXlB","price":"EshopItems_price__ZecE7","old_price":"EshopItems_old_price__h1lrS","currency":"EshopItems_currency__4pqFX","monthly_box":"EshopItems_monthly_box__vWlo8","icon_box":"EshopItems_icon_box__tkLF6","icon":"EshopItems_icon__DRS4m","payment_container":"EshopItems_payment_container__k3VKP","item":"EshopItems_item__Lwsqq","btn":"EshopItems_btn__Ute66"};

/***/ }),

/***/ 36070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shop_wrapper":"EshopSlider_shop_wrapper__JoE6X","title":"EshopSlider_title__QknQI","link":"EshopSlider_link__6gMOQ","button_container":"EshopSlider_button_container__tFGwG","link_text":"EshopSlider_link_text__3FwuI"};

/***/ }),

/***/ 37724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_filter__wrapper":"ProductFilter_product_filter__wrapper__IaTxT","top":"ProductFilter_top__oJ5u7","title":"ProductFilter_title__o4Ck1","filter_box":"ProductFilter_filter_box__he8bU","checkbox":"ProductFilter_checkbox__9pmTg","label":"ProductFilter_label__LXNVb","icon":"ProductFilter_icon__i4ct2","active":"ProductFilter_active__2CJBK","color_box":"ProductFilter_color_box__Mcpjo","content_cover":"ProductFilter_content_cover__l7gO_","mobile_buttons":"ProductFilter_mobile_buttons__7GIXU","cancleBtn":"ProductFilter_cancleBtn__VmOqd","applyBtn":"ProductFilter_applyBtn__Vshgb"};

/***/ }),

/***/ 10640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab":"Documents_tab___cUSf","active":"Documents_active__7lmmU","activeTabContentItem":"Documents_activeTabContentItem__lAi8n","title":"Documents_title__PgYhN","text":"Documents_text__G_Q_z"};

/***/ }),

/***/ 12153:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Checkout_title__38sS7","cards-esim_link":"Checkout_cards-esim_link__Vb_1I","card_external_link":"Checkout_card_external_link__lqxXF","pin_input":"Checkout_pin_input__UEDbb","tabContent":"Checkout_tabContent__X7ial","cardsTitle":"Checkout_cardsTitle__RsY_0","customSelect":"Checkout_customSelect__3lEZa","cards":"Checkout_cards__vYyZA","planTabPanel":"Checkout_planTabPanel__QqFDN","activePlan":"Checkout_activePlan__6nE7Z","errorModal":"Checkout_errorModal__sQhmu","closeContainer":"Checkout_closeContainer__Yg_hS","close":"Checkout_close___tnK4","banner":"Checkout_banner__swxx8","bannerText":"Checkout_bannerText__k1UGT","qrBlock":"Checkout_qrBlock__k_A8U","text":"Checkout_text__v2JUY","qr":"Checkout_qr__ZJeKL","image":"Checkout_image__j_meE","wrong_otp":"Checkout_wrong_otp__mTwVO","optInputContainer":"Checkout_optInputContainer__b6KLQ","button":"Checkout_button__I3n28","opt":"Checkout_opt__nEZek","resend":"Checkout_resend__owEZ2","optInput":"Checkout_optInput__Imho4","modalPanel":"Checkout_modalPanel__nZBnp","input":"Checkout_input__QbFkh","selectError":"Checkout_selectError__pYquc","checkout":"Checkout_checkout__x8DZQ","tab":"Checkout_tab__WFpQd","active":"Checkout_active__l4i_w","content":"Checkout_content___CHno","list":"Checkout_list__59q51","value":"Checkout_value__zT7Qn","bottom":"Checkout_bottom__dod9r","totalTitle":"Checkout_totalTitle__Jf0sT","total":"Checkout_total__lWMGG","nextStep":"Checkout_nextStep__HQiPF","rightContent":"Checkout_rightContent__80Rlc","download_qr_btn":"Checkout_download_qr_btn__72VYj","icon":"Checkout_icon__3zjnI","qr_detail_info":"Checkout_qr_detail_info__9a9lI","info":"Checkout_info__IrIpL","text_red":"Checkout_text_red__q_5Zu","number":"Checkout_number__yfqe0","grid":"Checkout_grid__NQN9d","tabContentItem":"Checkout_tabContentItem__NXn7D","tabIndex":"Checkout_tabIndex__vujGB","done":"Checkout_done__fmLeV","left":"Checkout_left__vRQYT","right":"Checkout_right__MxNPP"};

/***/ }),

/***/ 24485:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"FindYourEsimFlow_intro__NkYk6","title":"FindYourEsimFlow_title__sp1QX","description":"FindYourEsimFlow_description__FcBYK"};

/***/ }),

/***/ 9870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FaceRecognationInfo_wrap__Uk9Yc","btn_groups":"FaceRecognationInfo_btn_groups__aC_Yr","big":"FaceRecognationInfo_big__LM5Wh","open":"FaceRecognationInfo_open__kxHFS","faceInfoInner":"FaceRecognationInfo_faceInfoInner__tdier","close_btn":"FaceRecognationInfo_close_btn__D4U_W","faceInfoContent":"FaceRecognationInfo_faceInfoContent__hEzPp","title":"FaceRecognationInfo_title__g6vi_","legal_text_box":"FaceRecognationInfo_legal_text_box__jJYs8","description":"FaceRecognationInfo_description__0g_Dn","text_red":"FaceRecognationInfo_text_red__YOGKv","list":"FaceRecognationInfo_list__re3CD","actiivate_store_btn":"FaceRecognationInfo_actiivate_store_btn__EE3iw","btn":"FaceRecognationInfo_btn__PfA22","close":"FaceRecognationInfo_close__yjyK0"};

/***/ }),

/***/ 8492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon_img":"NotCustomer_icon_img___Cj6I","wrap":"NotCustomer_wrap__9ZUjc","big":"NotCustomer_big__VZK3n","open":"NotCustomer_open__bpULr","pinInner":"NotCustomer_pinInner__0_PZJ","close_btn":"NotCustomer_close_btn__aDo5F","pinContent":"NotCustomer_pinContent__Z0egT","title":"NotCustomer_title__e9DPZ","description":"NotCustomer_description__PDKUn","flexed_imgs":"NotCustomer_flexed_imgs__kkV27","close":"NotCustomer_close__aKwe0"};

/***/ }),

/***/ 37050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NotInList_wrap__wxQM1","big":"NotInList_big__Y8yge","open":"NotInList_open__m8yop","notInListInner":"NotInList_notInListInner__I_AD0","close_btn":"NotInList_close_btn__3k5MV","notInListContent":"NotInList_notInListContent__B1kFL","title_list":"NotInList_title_list__8QW_w","flexed_content":"NotInList_flexed_content__MoNYx","eid_img":"NotInList_eid_img__unGBl","content_text":"NotInList_content_text__EW3My","red_text":"NotInList_red_text__47xcj","close":"NotInList_close__oepdO"};

/***/ }),

/***/ 23314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon_img":"OtpError_icon_img__DPDDC","wrap":"OtpError_wrap__yLd_L","big":"OtpError_big__Yhw6i","open":"OtpError_open__C2QKN","pinInner":"OtpError_pinInner__Yzk6D","close_btn":"OtpError_close_btn__9nRdx","pinContent":"OtpError_pinContent__ALd_S","title":"OtpError_title__4wi99","description":"OtpError_description__gZCk0","flexed_imgs":"OtpError_flexed_imgs__CMQUS","close":"OtpError_close__DSzDf"};

/***/ }),

/***/ 60018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PinModal_wrap__1kjFI","big":"PinModal_big__w0YgG","open":"PinModal_open__UGPaW","pinInner":"PinModal_pinInner__TmYep","close_btn":"PinModal_close_btn__M45Jq","pinContent":"PinModal_pinContent__21Dgj","title":"PinModal_title___jwca","description":"PinModal_description__RXoTC","flexed_imgs":"PinModal_flexed_imgs__5dVxL","close":"PinModal_close__3wwnx"};

/***/ }),

/***/ 75958:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon_img":"SalesError_icon_img__jvTmD","wrap":"SalesError_wrap__AktPO","big":"SalesError_big__w23Si","open":"SalesError_open__138Eg","pinInner":"SalesError_pinInner__PgPKT","close_btn":"SalesError_close_btn__2Sivr","pinContent":"SalesError_pinContent__ygb16","title":"SalesError_title__VAriU","description":"SalesError_description__R7Su1","flexed_imgs":"SalesError_flexed_imgs__qS9OV","close":"SalesError_close__kSV_8"};

/***/ }),

/***/ 72868:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SwapError_wrap__fUNdr","big":"SwapError_big__mQK24","open":"SwapError_open__KedsZ","pinInner":"SwapError_pinInner__ikRe3","close_btn":"SwapError_close_btn___a2D1","pinContent":"SwapError_pinContent__bXBjy","title":"SwapError_title__tBx2_","description":"SwapError_description__4KuRa","flexed_imgs":"SwapError_flexed_imgs__SdI1S","close":"SwapError_close__u7XXB"};

/***/ }),

/***/ 49757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SwapInformation_wrap__8_v9T","big":"SwapInformation_big__5E_Zn","open":"SwapInformation_open__U4bTj","pinInner":"SwapInformation_pinInner__2DPCK","close_btn":"SwapInformation_close_btn__ge_PH","pinContent":"SwapInformation_pinContent__qpQ_e","title":"SwapInformation_title__Ti3Mf","description":"SwapInformation_description__xmKsA","flexed_imgs":"SwapInformation_flexed_imgs__kHD_V","close":"SwapInformation_close__6r_aJ"};

/***/ }),

/***/ 31692:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Success_container__YY__P","newsSlider":"Success_newsSlider__n3FJR"};

/***/ }),

/***/ 32131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessBanner_container__8gZ2t","img":"SuccessBanner_img__tg269","mobileImg":"SuccessBanner_mobileImg__N_V1e","customBtn":"SuccessBanner_customBtn__oIHIa","content":"SuccessBanner_content__J32_h","title":"SuccessBanner_title__vGf8B","yourNumber":"SuccessBanner_yourNumber__qGrQp","text":"SuccessBanner_text__xAXvc","text__bold":"SuccessBanner_text__bold__R07RY","qr":"SuccessBanner_qr__CfQha","qrInfo":"SuccessBanner_qrInfo__zbN2_","activate":"SuccessBanner_activate__dS3w9"};

/***/ }),

/***/ 72067:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swap_banner_wrap":"SwapBanner_swap_banner_wrap__e3t5e","left_side":"SwapBanner_left_side__nuxOG","description":"SwapBanner_description__5pKz6","button":"SwapBanner_button__HcVM7"};

/***/ }),

/***/ 8266:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aboutUs":"AboutUs_aboutUs__DA1Il"};

/***/ }),

/***/ 6992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"check__connection":"CheckConnection_check__connection__WEHWj","top":"CheckConnection_top__vGFno","mobile__btns":"CheckConnection_mobile__btns__LC9c6","form_btn":"CheckConnection_form_btn__8tpZG","form__btns":"CheckConnection_form__btns__D_p9f","close_btn":"CheckConnection_close_btn__KY45U","check__form":"CheckConnection_check__form__4FBvr","select":"CheckConnection_select__f486k","button":"CheckConnection_button__NrQzf","cancel":"CheckConnection_cancel__9eJZx","activeMobile":"CheckConnection_activeMobile__IZe8c"};

/***/ }),

/***/ 84384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"FiberOfferItem_cardWrapper__1m00i","headingText":"FiberOfferItem_headingText__qmPaT","speedContainer":"FiberOfferItem_speedContainer__EQJ6g","rectangle":"FiberOfferItem_rectangle__40QKR","priceContainer":"FiberOfferItem_priceContainer__xDZJx","includes":"FiberOfferItem_includes__5N_Ot","includingItem":"FiberOfferItem_includingItem__MBI13"};

/***/ }),

/***/ 55231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offerWrapper":"FiberOffers_offerWrapper__VbaYi"};

/***/ }),

/***/ 49404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RequestNewAddress_wrap__Sd3T2","big":"RequestNewAddress_big__zhvPB","open":"RequestNewAddress_open__Ui_TK","pinInner":"RequestNewAddress_pinInner__qXggu","close_btn":"RequestNewAddress_close_btn__ZCbdT","pinContent":"RequestNewAddress_pinContent__siLsu","title":"RequestNewAddress_title__wRIai","description":"RequestNewAddress_description__jUFXR","address":"RequestNewAddress_address__0B_0W","form_wrapper":"RequestNewAddress_form_wrapper__VvF1c","recaptcha":"RequestNewAddress_recaptcha__T5H0Z","terms_text":"RequestNewAddress_terms_text__c8Q4L","flexed_imgs":"RequestNewAddress_flexed_imgs__Cnkjg","close":"RequestNewAddress_close__0oJcH"};

/***/ }),

/***/ 65151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"FindYourNumberFlow_intro__9iJkI","title":"FindYourNumberFlow_title__dxOji","modalContentSuccess":"FindYourNumberFlow_modalContentSuccess__6tCfk","svg":"FindYourNumberFlow_svg___lggJ","button":"FindYourNumberFlow_button__u5fnK","modalContent":"FindYourNumberFlow_modalContent__WeaBD","input":"FindYourNumberFlow_input__lbb6g"};

/***/ }),

/***/ 5662:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4UBKQ","top":"styles_top__vVPwH","logo":"styles_logo__AtFuM","subTitle":"styles_subTitle__0BfjT","title":"styles_title__drk8L","bottom":"styles_bottom__8XcV3","bottomWrapper":"styles_bottomWrapper__VNdIf","slider":"styles_slider__Jsce5","buttons":"styles_buttons__1dEq0","buttonWrapper":"styles_buttonWrapper__gQ41Z","previous":"styles_previous__FiN4S","next":"styles_next__9JiB9","imageWrapper":"styles_imageWrapper__SJMsv"};

/***/ }),

/***/ 79809:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__ZK4x0","isBusiness":"styles_isBusiness__QtwYv","content":"styles_content__ltjzA","qrblock":"styles_qrblock__LGIU6","black":"styles_black__fwMAr","button":"styles_button__xF39F","white":"styles_white__dwX3C","note":"styles_note__5BmDT","title":"styles_title__AklMy","text":"styles_text__HrZM_","imaged":"styles_imaged__mRNGx","top":"styles_top__wILx2","imageContainer":"styles_imageContainer__WluAi","red":"styles_red__FJTPu","gray":"styles_gray__AEQ1Y","dark":"styles_dark__EK7aW","app":"styles_app__vHdZb","iconWrapper":"styles_iconWrapper__J7j6Y","redBanner":"styles_redBanner__dsGSC","skeletonWrapper":"styles_skeletonWrapper__AcEnL","skeleton":"styles_skeleton__5Dt8V","center":"styles_center__jU3Lj"};

/***/ }),

/***/ 83596:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small_icon":"styles_small_icon__trATV","red_icon":"styles_red_icon__DORYy","left":"styles_left__eoZQ_","info":"styles_info__uHcg4","content":"styles_content__TCVry","text":"styles_text__2ohmf","header":"styles_header__fq4uZ","title":"styles_title__jRUMk","red":"styles_red__XlXz_","viewAll":"styles_viewAll__2blHG","tabs":"styles_tabs__1MS_U","numbers":"styles_numbers__hi6GL","bookNumber":"styles_bookNumber__F1BIi","button":"styles_button__gGvJE","slider":"styles_slider__wRuh1","item":"styles_item__zbIKq","price":"styles_price__yPaPR","discount":"styles_discount__Zc7d9","currentPrice":"styles_currentPrice__vk9jy","number":"styles_number__Bgpbw","right":"styles_right__apgiE","image":"styles_image__evW95","container":"styles_container__qumCa"};

/***/ }),

/***/ 61003:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"branSlider_wrapper":"BrandSlider_branSlider_wrapper__TKo5x","content":"BrandSlider_content__NmtG4","midPosition":"BrandSlider_midPosition__BpucD","label":"BrandSlider_label__ig_vf","title":"BrandSlider_title__Ld0C3","slide_img":"BrandSlider_slide_img__V52g3","wrapperDiv":"BrandSlider_wrapperDiv__xCwR_","skeleton":"BrandSlider_skeleton__MFoah","skeletonContainer":"BrandSlider_skeletonContainer__lmi4O","slide_img__hidden":"BrandSlider_slide_img__hidden___1Lk4","shape_wrapper":"BrandSlider_shape_wrapper__uwtEL"};

/***/ }),

/***/ 61972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rotatedArrow":"FixServices_rotatedArrow__RvGSl","scrolly":"FixServices_scrolly__Qt8Rm","grid":"FixServices_grid__3BiAJ","card-item":"FixServices_card-item__Ya6Zz","link":"FixServices_link__e9iCB","card-item__icon-wrapper":"FixServices_card-item__icon-wrapper__ZAw7m","card-item__content":"FixServices_card-item__content__h_T9n","card-item__title":"FixServices_card-item__title__JYbfh","card-item__desc":"FixServices_card-item__desc__GaXbf"};

/***/ }),

/***/ 71384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"news_slider":"news_news_slider__aGXP9","skeleton":"news_skeleton__7JaIF","skeletonInner":"news_skeletonInner__PFnY5","slider":"news_slider__PHOkm","content_box":"news_content_box__oXcYL","top":"news_top__oPQpO","title":"news_title__W8VxZ","content_title":"news_content_title__Jluvr","content_description":"news_content_description__v1DTi","read_more":"news_read_more__1OPYJ","buttons":"news_buttons__6pB7e","buttonWrapper":"news_buttonWrapper__Yvd0W","disabled":"news_disabled__tGU0D","previous":"news_previous___3HFz","next":"news_next__uZ0Vo","imageWrapper":"news_imageWrapper__1Xxe1"};

/***/ }),

/***/ 84834:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"panner":"styles_panner__2qmEe","sliderItem":"styles_sliderItem__v3oFc","buttonTariffsMobile":"styles_buttonTariffsMobile__k_eZ4","tariffSliderWrapper":"styles_tariffSliderWrapper__FBpiQ"};

/***/ }),

/***/ 59617:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"TechnicalSolutions_grid__x_8NR"};

/***/ }),

/***/ 52844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__8zxWj","wrapper":"styles_wrapper__OPETQ","top":"styles_top__pgFOc","title":"styles_title__IwV_Y","description":"styles_description__Ro0_D"};

/***/ }),

/***/ 78557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"NewsList_titleWrapper__RcbTC","filters":"NewsList_filters__DIh6o","list":"NewsList_list__a1chi"};

/***/ }),

/***/ 43407:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NewsSingle_wrap__rl6Ez","titleWrap":"NewsSingle_titleWrap__rk8P9","date":"NewsSingle_date__FjzYf","slider":"NewsSingle_slider__ztONP","arrowBlock":"NewsSingle_arrowBlock__x27Hs","content":"NewsSingle_content__BDJgW"};

/***/ }),

/***/ 25855:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"FindYourSimNumber_intro__cWe9g","title":"FindYourSimNumber_title__WL61P","description":"FindYourSimNumber_description__S0eXg"};

/***/ }),

/***/ 94540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"Form_mainWrapper__v9HE2","wrapper":"Form_wrapper__PjMDf","question":"Form_question__58n_j","text":"Form_text__bjQSX","form":"Form_form__vVE36","submit":"Form_submit__tz0Ip","grid":"Form_grid__5hzNs","information":"Form_information__n5g1G","grid3":"Form_grid3__dXTwJ","item":"Form_item__otNWH"};

/***/ }),

/***/ 31209:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner-guest":"BannerAzer_banner-guest__gXlG0","banner-guest__content":"BannerAzer_banner-guest__content__oFRh7","banner-guest__text":"BannerAzer_banner-guest__text__yWyhl","banner-guest__title":"BannerAzer_banner-guest__title__9W9p4","banner-guest__desc":"BannerAzer_banner-guest__desc__uRmps","banner-guest__subtitle":"BannerAzer_banner-guest__subtitle__iYXep","banner-guest__tarrif":"BannerAzer_banner-guest__tarrif__q11Zc"};

/***/ }),

/***/ 70410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"general-service__title-block":"GeneralServices_general-service__title-block__YtqGc","general-service__inner":"GeneralServices_general-service__inner__LHvHK","item":"GeneralServices_item__jxwk6","service-item-own":"GeneralServices_service-item-own__YQkFI","service-item-own__caption":"GeneralServices_service-item-own__caption__sNQpK","service-item-own__content":"GeneralServices_service-item-own__content__40F0e","service-item-own__iconContainer":"GeneralServices_service-item-own__iconContainer__Clg1q","service-item-own__iconContainer__icon":"GeneralServices_service-item-own__iconContainer__icon__6U8tn","service-item-own__title":"GeneralServices_service-item-own__title__FS23c","service-item-own__button":"GeneralServices_service-item-own__button__69wlE","button":"GeneralServices_button__fWzZT","btnWrapper":"GeneralServices_btnWrapper__AcHEm","service-item":"GeneralServices_service-item__bTFxI","service-item__content":"GeneralServices_service-item__content__AbMf2","service-item__content__iconContainer":"GeneralServices_service-item__content__iconContainer__paXPc","service-item__content__iconContainer__icon":"GeneralServices_service-item__content__iconContainer__icon__5IsXd","service-item__icon":"GeneralServices_service-item__icon__E9mMJ","service-item__title":"GeneralServices_service-item__title__aPqTc","service-item__button":"GeneralServices_service-item__button__W0bGi"};

/***/ }),

/***/ 7338:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"InternetActivation_title__0ePFz","text":"InternetActivation_text__W9dVc","videoSlider":"InternetActivation_videoSlider__xz9dB","video":"InternetActivation_video__VU8I_","steps":"InternetActivation_steps__VJaC_","step":"InternetActivation_step__uIqzI","image":"InternetActivation_image__ex7fs","imageWrapper":"InternetActivation_imageWrapper__U4J6f","img":"InternetActivation_img__sxfE2"};

/***/ }),

/***/ 91431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"questions":"Questions_questions__D2ZpK","questions_faq__title":"Questions_questions_faq__title__5lHho","question-item":"Questions_question-item__s3_Df","active":"Questions_active__xvE5V","question-item__caption":"Questions_question-item__caption__91cKF","question-item__desc":"Questions_question-item__desc__ha_2j","question-item__title-block":"Questions_question-item__title-block__w2h23","question-item__title":"Questions_question-item__title__KHzjE","question-item--small":"Questions_question-item--small__fArC6"};

/***/ }),

/***/ 5379:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"roaming_activation":"RoamingActivation_roaming_activation__jha7c","title":"RoamingActivation_title__AzE0p","productStatus":"RoamingActivation_productStatus__9QB7X","customTab":"RoamingActivation_customTab__kaexl"};

/***/ }),

/***/ 35969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"steps--dark":"Steps_steps--dark__U2fkK","step-item":"Steps_step-item__1Ha9C","steps--fill":"Steps_steps--fill__Ilo_E","step-item__number":"Steps_step-item__number__bs4FU","steps__head":"Steps_steps__head__JODEf","steps__title":"Steps_steps__title__NFFTM","steps__text":"Steps_steps__text__iIw_N","steps__inner":"Steps_steps__inner__ixZxE","step-item__number-count":"Steps_step-item__number-count__xMqPa","step-item__img-wrapper":"Steps_step-item__img-wrapper__Jhvtb","step-item__activate":"Steps_step-item__activate__dJ9O1","step-item__content":"Steps_step-item__content__VAJ5g","step-item__activate-text":"Steps_step-item__activate-text__JiAPj","step-item__activate-iconContainer":"Steps_step-item__activate-iconContainer__7pTJA","step-item__activate-icon":"Steps_step-item__activate-icon__iz4qq"};

/***/ }),

/***/ 35414:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckCompatibility_container__qDiOp","find":"CheckCompatibility_find__gRvyA","available":"CheckCompatibility_available___5zTU","notAvailable":"CheckCompatibility_notAvailable__dKRt4","content":"CheckCompatibility_content__KVvJF","title":"CheckCompatibility_title__QYOGg","active_check":"CheckCompatibility_active_check__I_VXt","close":"CheckCompatibility_close__p3c1d","inputLabel":"CheckCompatibility_inputLabel__CFGMn","input":"CheckCompatibility_input__Sri_k","button":"CheckCompatibility_button__Oudsg","text":"CheckCompatibility_text__SMIjm","volte__search":"CheckCompatibility_volte__search__ffixR","volte__search__title":"CheckCompatibility_volte__search__title__FJMr_"};

/***/ }),

/***/ 33242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list_item":"ServiceContent_list_item__pfIm1","service-content":"ServiceContent_service-content__p04H8","callPage":"ServiceContent_callPage__XUu_r","service-content__head":"ServiceContent_service-content__head__8r5jw","service-content__wrapper--row":"ServiceContent_service-content__wrapper--row__bW7IK","service-content__title":"ServiceContent_service-content__title__2LVYp","service-content__text":"ServiceContent_service-content__text__2nrSp","service-content__mnp":"ServiceContent_service-content__mnp__jE3ZU","service-content__num-list":"ServiceContent_service-content__num-list__x5yN5","service-content__img":"ServiceContent_service-content__img__OTQ5h","service-content__img-wrapper":"ServiceContent_service-content__img-wrapper__z0HXs"};

/***/ }),

/***/ 94253:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"operations":"ServiceFiveGOperations_operations__52ijZ","operations__title":"ServiceFiveGOperations_operations__title__Prybr","operations__text":"ServiceFiveGOperations_operations__text__IKHpt","operations__list":"ServiceFiveGOperations_operations__list__Ok1qy","operations__element":"ServiceFiveGOperations_operations__element__UCVeM"};

/***/ }),

/***/ 44684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"services_button":"ServiceReverse_services_button__aAWnb","service-reverse__title":"ServiceReverse_service-reverse__title__TXkES","service-reverse__inner":"ServiceReverse_service-reverse__inner__LT2C0","reverse-item":"ServiceReverse_reverse-item__FTB7I","reverse-item__title":"ServiceReverse_reverse-item__title__E2e_R","reverse-item__content":"ServiceReverse_reverse-item__content__B79tU","description":"ServiceReverse_description__0_qM4","reverse-item__category":"ServiceReverse_reverse-item__category__8VDEC","reverse-item__bg":"ServiceReverse_reverse-item__bg__IFTsJ","business":"ServiceReverse_business__aLG4f","reverse-item__img-wrap":"ServiceReverse_reverse-item__img-wrap__4_3bI","background":"ServiceReverse_background__RSjU3","reverse-item__img":"ServiceReverse_reverse-item__img__PwNiL","dark":"ServiceReverse_dark__9dLMv","reverse-item__inner":"ServiceReverse_reverse-item__inner__CiDUA"};

/***/ }),

/***/ 74568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"service-slider__title":"ServiceSlider_service-slider__title__MJQmG","service-slider__inner":"ServiceSlider_service-slider__inner__Q6Rqw","arrowBlock":"ServiceSlider_arrowBlock__94bNY"};

/***/ }),

/***/ 65978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customWrapper":"ServiceVideo_customWrapper__FCCmc","cover_youtube_video":"ServiceVideo_cover_youtube_video__WN9tu","videoWrapper":"ServiceVideo_videoWrapper__ztiiS","hidden":"ServiceVideo_hidden__vtcbH","controls":"ServiceVideo_controls__VOEbf","title":"ServiceVideo_title__9n0Gd"};

/***/ }),

/***/ 62717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"ServicesGrid_grid__j1PmG","service":"ServicesGrid_service__aBrND","popular":"ServicesGrid_popular__d7ZIe","content":"ServicesGrid_content__DqUv_","title":"ServicesGrid_title__zZ2X9","text":"ServicesGrid_text___iuOI","button":"ServicesGrid_button__bodY_","image":"ServicesGrid_image__8vn05","link":"ServicesGrid_link__5JElq","arrow":"ServicesGrid_arrow__h9wMn","mix":"ServicesGrid_mix___MwwY","row":"ServicesGrid_row__Mr0Ab","baseGrid":"ServicesGrid_baseGrid__LUDiS"};

/***/ }),

/***/ 29617:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"operations":"ServicesOperations_operations__HK8oe","operations__title":"ServicesOperations_operations__title__rL5VW","operations__top_text":"ServicesOperations_operations__top_text__ytQ4g","operations__text":"ServicesOperations_operations__text__CNnGz","operations__list":"ServicesOperations_operations__list__JY8Ek","operations__element":"ServicesOperations_operations__element___CMaD"};

/***/ }),

/***/ 62978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"ServicesTable_table__n8IoH","table__title":"ServicesTable_table__title__s_R8Y","table__inner":"ServicesTable_table__inner__Pry7F","table--horisontal":"ServicesTable_table--horisontal__cCy5b","table__column":"ServicesTable_table__column___IbL1","table__head":"ServicesTable_table__head__ZPOLb","table__elem":"ServicesTable_table__elem__Mb7x0","table__items":"ServicesTable_table__items__53DSE"};

/***/ }),

/***/ 57259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"ChooseCategory_title__k5ZJO","list":"ChooseCategory_list__AOGBD","dark":"ChooseCategory_dark__dQy4Q","item":"ChooseCategory_item__4_zvX","titleBlock":"ChooseCategory_titleBlock__J1LG0","icon":"ChooseCategory_icon__z4GRf","name":"ChooseCategory_name__3_ckl","link":"ChooseCategory_link___CNMr","categories":"ChooseCategory_categories__d7pfo","category":"ChooseCategory_category__ANMz3","arrow":"ChooseCategory_arrow__mpJpF"};

/***/ }),

/***/ 71434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"ChooseTopic_title__3LWhp","container":"ChooseTopic_container__SW9bH","categories":"ChooseTopic_categories__le8AI","item":"ChooseTopic_item__iXVoX","dark":"ChooseTopic_dark__oW0A_","list":"ChooseTopic_list__cQl3s","link":"ChooseTopic_link__MGGed","active":"ChooseTopic_active__iAwlr","content":"ChooseTopic_content__eKkpo","text":"ChooseTopic_text__E0E4V","contentInner":"ChooseTopic_contentInner__oZhUX","emptyBlock":"ChooseTopic_emptyBlock__GxqqF","icon":"ChooseTopic_icon__DE8_p","videoSlider":"ChooseTopic_videoSlider__wjm9R","video":"ChooseTopic_video__5FzHz","slider":"ChooseTopic_slider__STP3k","arrowBlock":"ChooseTopic_arrowBlock___OGUA","steps":"ChooseTopic_steps__6m1fP","step":"ChooseTopic_step__W7OiD","image":"ChooseTopic_image__7zwuj"};

/***/ }),

/***/ 29931:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"SupportBanner_modalContent__T1AXR","checkboxContainer":"SupportBanner_checkboxContainer__OjV8G","error":"SupportBanner_error__gEoS6","checkbox":"SupportBanner_checkbox__9xyZv","field":"SupportBanner_field__NZPRy","half":"SupportBanner_half__efAC3","textarea":"SupportBanner_textarea__JFkvy"};

/***/ }),

/***/ 91265:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__99sH4","filters":"styles_filters__POVx5","modal":"styles_modal__kdcUe","active":"styles_active__pGrE1","content":"styles_content__JDtl2","priceRange":"styles_priceRange__4JiDV","subtitle":"styles_subtitle__411ve","buttons":"styles_buttons__5HLBK","close":"styles_close__wuKpm","dropdown":"styles_dropdown__6QGib","title":"styles_title__dQzn_","separator":"styles_separator__pS3rT","reset":"styles_reset__v5_Iv"};

/***/ }),

/***/ 12514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Gl3et","image":"styles_image__QbjSU","button":"styles_button__PzZH1","tariff":"styles_tariff__9nD7x","slider":"styles_slider___OlVn","question":"styles_question__C2eLs","content":"styles_content___er7l","title":"styles_title__Gpf_W","input":"styles_input__1_gDd","red":"styles_red__FvJ3i","form":"styles_form__6A_sb"};

/***/ }),

/***/ 64357:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InternetBlock_wrapper__p4i03","nonDesktop":"InternetBlock_nonDesktop__bPWax","internetBlock":"InternetBlock_internetBlock___A0u_","internetImage":"InternetBlock_internetImage__6BtTn","button":"InternetBlock_button__IaDiQ","internetInfo":"InternetBlock_internetInfo__oPD7e","internetTitle":"InternetBlock_internetTitle__yAnbR","internetDescription":"InternetBlock_internetDescription__3su1j"};

/***/ }),

/***/ 35239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__7kMX_","title":"styles_title__4tqYR"};

/***/ }),

/***/ 58470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__HfWZM","containerTitle":"styles_containerTitle__c9s1G","block":"styles_block__erI2C","infoBlock":"styles_infoBlock__dIq9M","characteristicsList":"styles_characteristicsList__UR9lc","characteristicsList--small":"styles_characteristicsList--small__iM0Wt","internetBlock":"styles_internetBlock__MpTdL","internetInfo":"styles_internetInfo__Wbx7I","internetDescription":"styles_internetDescription__jaM3o","internetImage":"styles_internetImage__y_plI","caption-block__title":"styles_caption-block__title__WLKwk","caption-block__text":"styles_caption-block__text__DkGJb"};

/***/ }),

/***/ 41288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__CCiO8","list":"styles_list__W27IG","item":"styles_item__D3Ovw","active":"styles_active__7n0lD"};

/***/ }),

/***/ 92341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivateBlock_container__ybR0s","containerTitle":"ActivateBlock_containerTitle__wVk2U","title":"ActivateBlock_title__U62mF","block":"ActivateBlock_block__q9edd","payment":"ActivateBlock_payment__PIJGd","price":"ActivateBlock_price__V4Gdw","codeBlock":"ActivateBlock_codeBlock___FKqK","note-inline":"ActivateBlock_note-inline__Tw7YE","note":"ActivateBlock_note__Bvycz","code":"ActivateBlock_code__CoK9F","action":"ActivateBlock_action__Ddqk_","qrCodeBlock":"ActivateBlock_qrCodeBlock__4MNRt","qrTooltip":"ActivateBlock_qrTooltip__dTbCH","text":"ActivateBlock_text__8_JpK","mobileLinks":"ActivateBlock_mobileLinks__iouLQ","logo":"ActivateBlock_logo__ygBhg","qrCode":"ActivateBlock_qrCode__iWCr8","image":"ActivateBlock_image__apJIk"};

/***/ }),

/***/ 98260:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"characteristics":"AdditionalInformation_characteristics__3fZik","containerTitle":"AdditionalInformation_containerTitle__MGC_n","list":"AdditionalInformation_list__AOJZV","item":"AdditionalInformation_item__VtwLP","full":"AdditionalInformation_full__8Al4R","icon":"AdditionalInformation_icon__k0J1v","tooltip":"AdditionalInformation_tooltip__LnitW","nameBlock":"AdditionalInformation_nameBlock__ROJiD","name":"AdditionalInformation_name__E8PT4","tooltipIcon":"AdditionalInformation_tooltipIcon__ocYpF","tooltipContent":"AdditionalInformation_tooltipContent__b2AZG","value":"AdditionalInformation_value__Mt_uw","right_text":"AdditionalInformation_right_text__8LehO","socIcon":"AdditionalInformation_socIcon__EopRS"};

/***/ }),

/***/ 9472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"address-cards__title":"AddressCards_address-cards__title__2Q80t","address-cards__inner":"AddressCards_address-cards__inner__N1mi_","address-card":"AddressCards_address-card__CKaN2","address-card__content":"AddressCards_address-card__content__3bKIv","address-card__links":"AddressCards_address-card__links__yFp4C","address-card__icon":"AddressCards_address-card__icon__mJkA1","address-card__title":"AddressCards_address-card__title__p_EkO","address-card__path":"AddressCards_address-card__path__tWFXI","address-card__link":"AddressCards_address-card__link___h4Ea","address-card__path-icon":"AddressCards_address-card__path-icon__QUcQ_","address-card__link-icon":"AddressCards_address-card__link-icon__1Kj49","address-card__path-text":"AddressCards_address-card__path-text__3eYJ6","address-card__row":"AddressCards_address-card__row__9nL6g"};

/***/ }),

/***/ 62098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addressModal":"AddressModal_addressModal__soKSA","addressModalTitle":"AddressModal_addressModalTitle__meeDk","contentWrapper":"AddressModal_contentWrapper__bsZSO","nextButton":"AddressModal_nextButton__SLubC","addressModalWrapper":"AddressModal_addressModalWrapper__V_5CV"};

/***/ }),

/***/ 79861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"GoogleMap_inputWrapper__J4qr1","wrapperFullHeight":"GoogleMap_wrapperFullHeight__EOUKm","searchInput":"GoogleMap_searchInput__WU7cF","inputIcon":"GoogleMap_inputIcon__xFQl8","mapContainer":"GoogleMap_mapContainer__lAvu2","wrap":"GoogleMap_wrap__WS08U","map":"GoogleMap_map__9oFyZ","gmnoprint":"GoogleMap_gmnoprint__KWNIY","gm-style-cc":"GoogleMap_gm-style-cc__kB4Gx","gm-fullscreen-control":"GoogleMap_gm-fullscreen-control__8InLG","marker":"GoogleMap_marker__4M94O","isScaled":"GoogleMap_isScaled__W0qHO"};

/***/ }),

/***/ 45442:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchList":"SearchList_searchList__lsLQ8","searchItem":"SearchList_searchItem__ip_nl","searchItem_active":"SearchList_searchItem_active__p15EC","left":"SearchList_left__jMPN_","right":"SearchList_right__xq8ZH","txt":"SearchList_txt__LvFNf"};

/***/ }),

/***/ 29573:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"advantageous__title-block":"Advantageous_advantageous__title-block__eLcxb","advantageous__title":"Advantageous_advantageous__title__9dcYQ","advantageous__text":"Advantageous_advantageous__text__6_r8F","advantageous__inner":"Advantageous_advantageous__inner__YAkUs","advantageous-card":"Advantageous_advantageous-card__MNh_U","advantageous-card__icon-wrapper":"Advantageous_advantageous-card__icon-wrapper__kWFwm","advantageous-card__content":"Advantageous_advantageous-card__content__KHTHd","advantageous-card__title":"Advantageous_advantageous-card__title__y_zsV","advantageous-card__text":"Advantageous_advantageous-card__text__jSbhf"};

/***/ }),

/***/ 38857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"AttachFiles_dropzone__M34vb","files":"AttachFiles_files__2rt6y","content":"AttachFiles_content__aUv86","text":"AttachFiles_text__Kmm9a","button":"AttachFiles_button__TLq8A","desc":"AttachFiles_desc__a59Iz"};

/***/ }),

/***/ 66331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"branch":"SingleBranch_branch__stYZK","branch__active":"SingleBranch_branch__active__iT3mg","left":"SingleBranch_left__3hvPJ","right":"SingleBranch_right__YMHp4"};

/***/ }),

/***/ 49707:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"BranchModal_modalWrapper___XbKb","customWrapper":"BranchModal_customWrapper__kzFqb","left":"BranchModal_left__v27GR","inputWrapper":"BranchModal_inputWrapper__7Oe8n","branches":"BranchModal_branches__KayiQ","branches__mobile":"BranchModal_branches__mobile__T3eOl","scrollable":"BranchModal_scrollable__4yCrh","left__mobile":"BranchModal_left__mobile__J0r0N","right":"BranchModal_right__kd8I_","btnContinue":"BranchModal_btnContinue__qAA9S","mobileBtn":"BranchModal_mobileBtn__xpEzk"};

/***/ }),

/***/ 48999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__eqcub","icon":"Breadcrumbs_icon__mbVPT","wrapper":"Breadcrumbs_wrapper__eUZTw","item":"Breadcrumbs_item__Zld4B"};

/***/ }),

/***/ 33025:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bundles__title":"Bundles_bundles__title__tZwrb","bundles__inner":"Bundles_bundles__inner__GpeY7","table":"Bundles_table__2EbcG","mounthly":"Bundles_mounthly__OwxWV","table__title":"Bundles_table__title__G8A31","table__text":"Bundles_table__text__yKs_F","table__inner":"Bundles_table__inner__1s6RM","table__th":"Bundles_table__th__JVi7W","table__td":"Bundles_table__td__94Dog","table__column":"Bundles_table__column__xYOR_","mounthly__inner":"Bundles_mounthly__inner__VkSTK","mounthly__title":"Bundles_mounthly__title__ZivGk","mounthly__button":"Bundles_mounthly__button__nAoCd","mounthly-table":"Bundles_mounthly-table__2n9ks","mounthly-table__row":"Bundles_mounthly-table__row__zZgnC","mounthly-table__item":"Bundles_mounthly-table__item__TruU3","mounthly-table__title":"Bundles_mounthly-table__title__c66c3","mounthly-table__currency":"Bundles_mounthly-table__currency__LySkT","mounthly-table__period":"Bundles_mounthly-table__period__jtp9n","mounthly-table__period-icon":"Bundles_mounthly-table__period-icon__XtPfU","mounthly-table__period-text":"Bundles_mounthly-table__period-text__sXWQJ"};

/***/ }),

/***/ 44114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"ContactForm_content__ZA8_L","error":"ContactForm_error__TIeL5","employees":"ContactForm_employees__vgp61","active":"ContactForm_active__3iMyo","checkbox":"ContactForm_checkbox__Va81T","textarea":"ContactForm_textarea__wlHue","buttonHolder":"ContactForm_buttonHolder__PQUjD","button":"ContactForm_button___gNgi"};

/***/ }),

/***/ 70704:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-block__title":"BusinessSectionBannersWithIcon_card-block__title__Nhqzw","card-block__inner":"BusinessSectionBannersWithIcon_card-block__inner__A2rtr","card-item":"BusinessSectionBannersWithIcon_card-item__0dzWv","content":"BusinessSectionBannersWithIcon_content__HyaTV","image":"BusinessSectionBannersWithIcon_image__y_zNK","button":"BusinessSectionBannersWithIcon_button__faUCY","card-item__icon-wrapper":"BusinessSectionBannersWithIcon_card-item__icon-wrapper__H5Bqe","card-item__content":"BusinessSectionBannersWithIcon_card-item__content__NxiPV","card-item__title":"BusinessSectionBannersWithIcon_card-item__title__tHvnR","card-item__desc":"BusinessSectionBannersWithIcon_card-item__desc__V5Pxt","card-item__circleIcon":"BusinessSectionBannersWithIcon_card-item__circleIcon__JKU6z","inner":"BusinessSectionBannersWithIcon_inner__Hh1xn"};

/***/ }),

/***/ 40892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-item":"BusinessServicesCardWithImage_card-item__DREz6","shape":"BusinessServicesCardWithImage_shape__lcY2l","image":"BusinessServicesCardWithImage_image__V3NOO","content":"BusinessServicesCardWithImage_content__YJ63c","link":"BusinessServicesCardWithImage_link__spaJ7","card-item__icon-wrapper":"BusinessServicesCardWithImage_card-item__icon-wrapper__MX3tU","card-item__content":"BusinessServicesCardWithImage_card-item__content__belFZ","card-item__title":"BusinessServicesCardWithImage_card-item__title__YwR_6","card-item__desc":"BusinessServicesCardWithImage_card-item__desc__DxHd_","inner":"BusinessServicesCardWithImage_inner__dyO__"};

/***/ }),

/***/ 51323:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cellContainer":"styles_cellContainer__RMnc7","info":"styles_info__WfOdg","tariff":"styles_tariff__oSgse","numbers":"styles_numbers___AVgK","tariff-head":"styles_tariff-head__J_J50","tariff-head__content":"styles_tariff-head__content__ypog0","price-box":"styles_price-box__r_PCA","price-box__content":"styles_price-box__content__UT1Q_","title":"styles_title__MBXfx","price-box__content__hidden":"styles_price-box__content__hidden__lzjeG","price":"styles_price__5Rcf9","all":"styles_all__CYAmK","currency":"styles_currency__gol4h","details-button":"styles_details-button__s8asC","topWrapper":"styles_topWrapper___Zwh3","rectangle":"styles_rectangle__mjS7G","label":"styles_label__lkRDw","tariff__content":"styles_tariff__content__dv3cg","additional":"styles_additional__4QqvS","additional__price":"styles_additional__price__0JlDe","content-head":"styles_content-head__U3QGR","cell":"styles_cell__xBcbC","text":"styles_text__BuK6I","icons":"styles_icons__qyK6y","details__content":"styles_details__content__OWuxu","details":"styles_details__nWpA0","description":"styles_description___A7OG","bottom":"styles_bottom__JSfpl","bottom__content":"styles_bottom__content__1jNkN","price-box__title":"styles_price-box__title__rk3E8","active":"styles_active__5JoR9","button":"styles_button__aG6i0","icon_container":"styles_icon_container__mVbmi","line":"styles_line__DTyu3"};

/***/ }),

/***/ 38662:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"BusinessTechnicalSolution_container__8f0wi","icon-wrapper":"BusinessTechnicalSolution_icon-wrapper__cdvyQ","list":"BusinessTechnicalSolution_list__nn5pW","top":"BusinessTechnicalSolution_top__hz4S3","title":"BusinessTechnicalSolution_title__9MAWl"};

/***/ }),

/***/ 9536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__I5DID","black":"Button_black__9NMMM","blocked":"Button_blocked__13QUT","gray":"Button_gray__vt3tr","white":"Button_white__r1aMU","pill":"Button_pill__ZciHV","trapezoid":"Button_trapezoid__EfWYi","trapezoidLong":"Button_trapezoidLong__ZCmCG","trapezoidShort":"Button_trapezoidShort__lhRZH","trapezoidWhite":"Button_trapezoidWhite__LgHu2","trapezoidRed":"Button_trapezoidRed__RhXt1","textVariant":"Button_textVariant__DWfal","transparent":"Button_transparent__MG7q5","secondary":"Button_secondary__moz03","outline":"Button_outline__tyEKY","border":"Button_border__Nzss0","small":"Button_small__J7J7X","normal":"Button_normal__19XHG","big":"Button_big__1ckws","text":"Button_text___dMJ_","icon":"Button_icon__Nwf_h","textContent":"Button_textContent__cQl3y","textIcon":"Button_textIcon__pfxKj"};

/***/ }),

/***/ 49226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"indicator__container":"styles_indicator__container__kz8tG","indicator__list":"styles_indicator__list__w6bf7","active":"styles_active__P7czK","indicator":"styles_indicator__2gPgs"};

/***/ }),

/***/ 64866:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CallBlock_container__s4dJ7","item":"CallBlock_item__PpDzC","title":"CallBlock_title__3kvmZ","call":"CallBlock_call__IAhoK","numbers":"CallBlock_numbers__Xp43d","number":"CallBlock_number__2rupK"};

/***/ }),

/***/ 44752:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gray_icon_wrapper":"CardBlock_gray_icon_wrapper__uslcw","icons_wrapper":"CardBlock_icons_wrapper__iecPd","card_external_link":"CardBlock_card_external_link__7b61M","linkClassName":"CardBlock_linkClassName__5cM8_","card-block":"CardBlock_card-block__44LyC","card-block__title":"CardBlock_card-block__title__3Fwtq","centered":"CardBlock_centered__DSyPH","card-block__inner":"CardBlock_card-block__inner__EYYgK","card-block__inner--three":"CardBlock_card-block__inner--three__3mB8R","card-item__title":"CardBlock_card-item__title__tRe6l","card-item__desc":"CardBlock_card-item__desc__AgPkY","card-block__inner--three_title_desc":"CardBlock_card-block__inner--three_title_desc__Q6p1P","card-block__inner--four":"CardBlock_card-block__inner--four__4jiB4","card-item":"CardBlock_card-item__Ia9o3","card-item__content":"CardBlock_card-item__content__jzJx5"};

/***/ }),

/***/ 99170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"characteristics":"Characteristics_characteristics__HcOvZ","containerTitle":"Characteristics_containerTitle__0_1sj","list":"Characteristics_list__okli1","item":"Characteristics_item__Lx1Ew","full":"Characteristics_full__0pg0U","icon":"Characteristics_icon__PNHqq","tooltip":"Characteristics_tooltip__5APU3","nameBlock":"Characteristics_nameBlock__4qOt7","name":"Characteristics_name__DMTz2","tooltipIcon":"Characteristics_tooltipIcon__7SN_F","tooltipContent":"Characteristics_tooltipContent__bXZIc","value":"Characteristics_value__ZzSA1","socIcon":"Characteristics_socIcon__JqzHM"};

/***/ }),

/***/ 73137:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio":"CheckboxWithText_radio__I_mFS","checkBoxTitle":"CheckboxWithText_checkBoxTitle__FgpBz","large":"CheckboxWithText_large__9FFDm"};

/***/ }),

/***/ 86099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio":"CheckboxWithTitle_radio__oUHal","reverse":"CheckboxWithTitle_reverse__PBuOL","title":"CheckboxWithTitle_title__TgAET"};

/***/ }),

/***/ 32388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"circle-icon__wrapper":"CircleIcon_circle-icon__wrapper__FczPE","circle-icon__text":"CircleIcon_circle-icon__text__8qs_B","small":"CircleIcon_small__l47p1","circle-icon":"CircleIcon_circle-icon__UKy50"};

/***/ }),

/***/ 13445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"CollapsibleItem_item__QNbqH","open":"CollapsibleItem_open___pHxH","toggle":"CollapsibleItem_toggle__5Y1pb","right":"CollapsibleItem_right__F8azU","icon":"CollapsibleItem_icon__XxCEM","label":"CollapsibleItem_label__uRLPi","content":"CollapsibleItem_content__vbaAH","contentInner":"CollapsibleItem_contentInner__6bPEq"};

/***/ }),

/***/ 35751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Company_title__q7sKO","note":"Company_note__ZloDn","text":"Company_text__sXxn3","companyBlock":"Company_companyBlock__p6sFZ","tab":"Company_tab__kEmwB","active":"Company_active__5I2hK","tabToggles":"Company_tabToggles__ZKzYm","bannerSlider":"Company_bannerSlider__xdL7J","info":"Company_info__NZRrX","image":"Company_image__9o332","sustainabilityBlock":"Company_sustainabilityBlock__6Rccv","directors":"Company_directors__tuT17"};

/***/ }),

/***/ 88155:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"CompatibleDevicesModal_modal___M_GP","panel":"CompatibleDevicesModal_panel__T5dfz","tab":"CompatibleDevicesModal_tab__dS7Xq","tab__notFound":"CompatibleDevicesModal_tab__notFound__zPW1e","content":"CompatibleDevicesModal_content__VFPOt","item":"CompatibleDevicesModal_item__t__9E"};

/***/ }),

/***/ 44680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"Search_searchInput__hj8Nj"};

/***/ }),

/***/ 41242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"CompatibleDevicesModalVolte_modal__F1vLK","panel":"CompatibleDevicesModalVolte_panel__Gg3K2","tab":"CompatibleDevicesModalVolte_tab__d5eUf","content":"CompatibleDevicesModalVolte_content__vqF8F","item":"CompatibleDevicesModalVolte_item__p8478","available_device":"CompatibleDevicesModalVolte_available_device__XbGQn","description":"CompatibleDevicesModalVolte_description__EDZFc","find":"CompatibleDevicesModalVolte_find__PqXg7","available":"CompatibleDevicesModalVolte_available__iAipz","notAvailable":"CompatibleDevicesModalVolte_notAvailable__JwRoN","title":"CompatibleDevicesModalVolte_title__sNJeO","inputLabel":"CompatibleDevicesModalVolte_inputLabel__NFlrq","close":"CompatibleDevicesModalVolte_close__Hq1WQ","input":"CompatibleDevicesModalVolte_input__jlNm0","button":"CompatibleDevicesModalVolte_button__Sc6HQ"};

/***/ }),

/***/ 4147:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactUs":"ContactUs_contactUs__8ae5n","contactItems":"ContactUs_contactItems__WoT2q","title":"ContactUs_title__jqltG","contactListWrapper":"ContactUs_contactListWrapper__1Lz8X","contactList":"ContactUs_contactList__miqjs","country":"ContactUs_country__yFfMy"};

/***/ }),

/***/ 76823:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateOwnPhoneInput_container__qIp75","search_input_number":"CreateOwnPhoneInput_search_input_number__VwzOb","sortContainer":"CreateOwnPhoneInput_sortContainer__3qhRA","sortInput":"CreateOwnPhoneInput_sortInput__B6XC5","buttons":"CreateOwnPhoneInput_buttons__Lyjts","refresh":"CreateOwnPhoneInput_refresh__rKjhc","select":"CreateOwnPhoneInput_select__t3eIf"};

/***/ }),

/***/ 29305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aZ5wt","indicator":"styles_indicator__lMLnK","active":"styles_active__nNGEH","button":"styles_button__fIKac","cart":"styles_cart__3c0rX"};

/***/ }),

/***/ 4550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"delivery_btn":"DeliveryAddressBranch_delivery_btn__8zKIc","wrapper":"DeliveryAddressBranch_wrapper__8Gah6","radio_container":"DeliveryAddressBranch_radio_container__jb1my","inner_container":"DeliveryAddressBranch_inner_container__U0LMH","btnText":"DeliveryAddressBranch_btnText___OtDX","radio_address":"DeliveryAddressBranch_radio_address__X5Cui","btn_select":"DeliveryAddressBranch_btn_select__wy76r","checkIcon":"DeliveryAddressBranch_checkIcon__lA_6Y","inputContainer":"DeliveryAddressBranch_inputContainer__mJKie"};

/***/ }),

/***/ 8283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"document-cards":"DocumentCard_document-cards__w2cWS","tabPanel":"DocumentCard_tabPanel__kishR","document-cards__slider":"DocumentCard_document-cards__slider__5bYKC","button":"DocumentCard_button__e6yT1","document-card":"DocumentCard_document-card__RGLVW","document-card__content":"DocumentCard_document-card__content__W2muX","document-card__buttons":"DocumentCard_document-card__buttons__K8wLs","document-card__year":"DocumentCard_document-card__year__NWhzH","document-card__desc":"DocumentCard_document-card__desc__LaI8K","documentIcon":"DocumentCard_documentIcon__brPmL","arrowIcon":"DocumentCard_arrowIcon__9a1Aq","text":"DocumentCard_text__oY09W","arrow":"DocumentCard_arrow__r04I2"};

/***/ }),

/***/ 8314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"download_app_wrapper":"DownloadApplication_download_app_wrapper__dHb5K","none":"DownloadApplication_none__PIlf0","dark":"DownloadApplication_dark__shRwx","content":"DownloadApplication_content__nrwht","close_app":"DownloadApplication_close_app__PL3K4","download_app_logo":"DownloadApplication_download_app_logo___RMf4","title":"DownloadApplication_title__mBxHU","description":"DownloadApplication_description__Q_Azf","download_app_btn":"DownloadApplication_download_app_btn__na1es"};

/***/ }),

/***/ 2849:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__zR_Pf","title":"styles_title__uCm5c","input":"styles_input__5i4TH","panel":"styles_panel__omD7O","tab":"styles_tab__0Gk2a","clear":"styles_clear__zW5fZ","icon":"styles_icon__wDxEp","active":"styles_active__kdz5L"};

/***/ }),

/***/ 67886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown_container":"Dropdown_dropdown_container__v78HJ","list":"Dropdown_list__4kUC8","toggle":"Dropdown_toggle__sgit4","disabled":"Dropdown_disabled__AyNz_","detail_box":"Dropdown_detail_box__0ii5D","number_detail":"Dropdown_number_detail__uWITS","number":"Dropdown_number__fgdcU","label":"Dropdown_label__c5yIa","balance":"Dropdown_balance__kFl57","status":"Dropdown_status__lEFHz","add_icon":"Dropdown_add_icon__WuREK","add_new":"Dropdown_add_new__mDxnx"};

/***/ }),

/***/ 14883:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Faq_wrap__9v4gK"};

/***/ }),

/***/ 56245:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FindYourTariffModal_container__IdeOk","tariff":"FindYourTariffModal_tariff__BWaQu","tariffCard":"FindYourTariffModal_tariffCard__9dHsc","findAnother":"FindYourTariffModal_findAnother__9QJf0","button":"FindYourTariffModal_button__Ar_dF","slider":"FindYourTariffModal_slider__X3nQg","question":"FindYourTariffModal_question__iP3s_","content":"FindYourTariffModal_content__Uq9VR","title":"FindYourTariffModal_title__gioI0","input":"FindYourTariffModal_input__gcYcx","inputTitle":"FindYourTariffModal_inputTitle__SgF3q","red":"FindYourTariffModal_red__Zvjxw"};

/***/ }),

/***/ 56974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"FooterLink_listItem__JdBKm","write_us":"FooterLink_write_us__CoKU_","link":"FooterLink_link__4BZY6","linkContainer":"FooterLink_linkContainer__pmENp","content":"FooterLink_content__gnrEi"};

/***/ }),

/***/ 85258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"full_banner_wrapper":"FullBanner_full_banner_wrapper__t_l7W","content":"FullBanner_content__K3JoR","top_text":"FullBanner_top_text__BOUDn","title":"FullBanner_title__6PvAX","description":"FullBanner_description__Mz2rp","content_btn":"FullBanner_content_btn__fjzBM"};

/***/ }),

/***/ 21784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"goBack":"GoBack_goBack__hHBHA"};

/***/ }),

/***/ 95177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"GridProducts_grid__l_78w"};

/***/ }),

/***/ 50234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HiddenList_wrap__f3jZ7","inner":"HiddenList_inner__pIb_d","list":"HiddenList_list__2v5hG","item":"HiddenList_item__qtAk2","showAll":"HiddenList_showAll__KkHrd","open":"HiddenList_open__T2dJs"};

/***/ }),

/***/ 73069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"InformationBlock_container__BYN5M","customBtn":"InformationBlock_customBtn__YWKuO","secondary":"InformationBlock_secondary__UPh5j","content":"InformationBlock_content__MO1xR","title":"InformationBlock_title__outzY","text":"InformationBlock_text__CdBNL","img":"InformationBlock_img__wGKW_","mobileImg":"InformationBlock_mobileImg__vTp5K"};

/***/ }),

/***/ 74113:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"successPopup":"InformationModal_successPopup__7lyhf","icon":"InformationModal_icon__4yzsu","white":"InformationModal_white__mK4gl","title":"InformationModal_title__AhoyL","text":"InformationModal_text__2LrG5","button":"InformationModal_button__HFlPc"};

/***/ }),

/***/ 28834:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputField":"Input_inputField__vRhsn","placeholderMask":"Input_placeholderMask__lOQl2","icon":"Input_icon__Pa1iX","iconWithTitle":"Input_iconWithTitle__fzXzk","title":"Input_title__KiwNk","inputLabel":"Input_inputLabel__pR5J2","animated__label":"Input_animated__label__MOP1O","inputFieldItem":"Input_inputFieldItem__gfyZ5","errorInput":"Input_errorInput__1dpHC","rightIcon":"Input_rightIcon__h6Lrk","error":"Input_error__HLgwr"};

/***/ }),

/***/ 4523:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputDropDown":"InputAutoComplete_inputDropDown__weDC1","inputWrapper":"InputAutoComplete_inputWrapper__yGetS","btnsWrapper":"InputAutoComplete_btnsWrapper__Id8un","close":"InputAutoComplete_close__TRHX5","input":"InputAutoComplete_input__MmPcs","active":"InputAutoComplete_active__TYoew","dropDown":"InputAutoComplete_dropDown__TdlFD","info":"InputAutoComplete_info__fvnoY","animated__label":"InputAutoComplete_animated__label__jnB1F","inputLabel":"InputAutoComplete_inputLabel__fm3rN","title":"InputAutoComplete_title__8XF8u","popularBox":"InputAutoComplete_popularBox__kw_I9","country":"InputAutoComplete_country__w2BsU","searchContentList":"InputAutoComplete_searchContentList__f_trX","searchContentList__loader":"InputAutoComplete_searchContentList__loader__FXXsW","hidden":"InputAutoComplete_hidden__vYQLj"};

/***/ }),

/***/ 85070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchSelect":"InputWithSelect_searchSelect__o0_Gs","input":"InputWithSelect_input__L9sJS","list":"InputWithSelect_list__rwfBy","value":"InputWithSelect_value__Kpmi9","selectList":"InputWithSelect_selectList__OgK1i","searchSelect__selectActive":"InputWithSelect_searchSelect__selectActive__GfF0H"};

/***/ }),

/***/ 1354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"InternetBanner_banner__NWiw4","redBanner":"InternetBanner_redBanner__Wm3Ep","children":"InternetBanner_children__Dv_IO","image":"InternetBanner_image__fQ8UI","big":"InternetBanner_big__Op9_h","medium":"InternetBanner_medium__v6FbE","small":"InternetBanner_small__mVMoI","content":"InternetBanner_content__gkDh1","topText":"InternetBanner_topText__rT8pC","bottomText":"InternetBanner_bottomText__mmNQb","title":"InternetBanner_title__QFr3a","roamingImage":"InternetBanner_roamingImage__cMnLj"};

/***/ }),

/***/ 30844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"JoinBackcellModal_title__oO5SN","modal":"JoinBackcellModal_modal__eeXA0","text":"JoinBackcellModal_text__PiKde","form":"JoinBackcellModal_form__sXskd"};

/***/ }),

/***/ 59557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link-numbers":"LinkNumbers_link-numbers__TcVzd","inner-container":"LinkNumbers_inner-container__0OjKu","link-numbers--light":"LinkNumbers_link-numbers--light__XQGH_","link-numbers__item":"LinkNumbers_link-numbers__item__pMCNk","link-numbers__item--blurred":"LinkNumbers_link-numbers__item--blurred__0YhqR","dark":"LinkNumbers_dark__HnVIs","link-numbers__full":"LinkNumbers_link-numbers__full__7yGmN"};

/***/ }),

/***/ 73926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__DRZjd"};

/***/ }),

/***/ 12988:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader_wrap":"Loader_loader_wrap__sPqLq","loader":"Loader_loader__Ne8_J","fullScreen":"Loader_fullScreen__LFbak"};

/***/ }),

/***/ 48044:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"LoginModal_title__Wusbx","modal":"LoginModal_modal__liYjU","error":"LoginModal_error__IjTv8","form":"LoginModal_form__SWv8v","signUpContainer":"LoginModal_signUpContainer__yLwJr","signUp":"LoginModal_signUp__V3WGp","code":"LoginModal_code__Nweoa","codeAgain":"LoginModal_codeAgain__ILQZR","login":"LoginModal_login__3jcZB","password":"LoginModal_password__UcVtB","loginCode":"LoginModal_loginCode__wTsjR","reCAPTCHA":"LoginModal_reCAPTCHA__pIazn","text":"LoginModal_text__AoZUx","forgotPassword":"LoginModal_forgotPassword__wk_MI","button":"LoginModal_button__Cto1_"};

/***/ }),

/***/ 7944:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Banner_inputContainer__3fpPj","input":"Banner_input__W8XIT"};

/***/ }),

/***/ 67239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"googleMapContainer":"Map_googleMapContainer__7cb89","googleMapContainer__hidden":"Map_googleMapContainer__hidden__OEmtR","zoomControls":"Map_zoomControls__d4mKS","zoomIcon":"Map_zoomIcon__Hclm_"};

/***/ }),

/***/ 15996:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"MediaInquire_title__Dc20M","image":"MediaInquire_image__bgD20","imageWrapper":"MediaInquire_imageWrapper__1VCpB","skeleton":"MediaInquire_skeleton__e7ZpL","reverse":"MediaInquire_reverse__zN361","infoBlock":"MediaInquire_infoBlock__Chc6T","info":"MediaInquire_info__FOXIH","note":"MediaInquire_note__4ktLI","button":"MediaInquire_button__pDUPO"};

/***/ }),

/***/ 77011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Modal_wrap__9jqZI","big":"Modal_big__NenCO","open":"Modal_open__uTMSL","inner":"Modal_inner__QKMph","content":"Modal_content__h9my9","close":"Modal_close__dxiZj"};

/***/ }),

/***/ 97542:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon_img":"ErrorModal_icon_img__L39Fj","wrap":"ErrorModal_wrap__mzPN_","errorText":"ErrorModal_errorText__UB5wW","big":"ErrorModal_big__mSNga","open":"ErrorModal_open__zAxcb","errorInner":"ErrorModal_errorInner__Ya9IE","errorContent":"ErrorModal_errorContent__uUk5R","title":"ErrorModal_title__96tFc","description":"ErrorModal_description__j__A0","close":"ErrorModal_close__ZGtF2"};

/***/ }),

/***/ 17005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalCustom":"SuccessModal_modalCustom__bRSqd","successModal":"SuccessModal_successModal__vJXVe","successModal__buttons":"SuccessModal_successModal__buttons__rjgHs","successModal__innerDiv":"SuccessModal_successModal__innerDiv__zOxDz"};

/***/ }),

/***/ 16980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"num-list":"NumList_num-list__VOUb8"};

/***/ }),

/***/ 47998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"background":"OurManagement_background__5ERJx","managment_btn":"OurManagement_managment_btn__lbv9B","container":"OurManagement_container__HlImz","title":"OurManagement_title__aqXIS","name":"OurManagement_name__k0K3E","description":"OurManagement_description__XoAzI","imageWrapper":"OurManagement_imageWrapper__GzcyG","skeleton":"OurManagement_skeleton__wcbM1","managmentTitle":"OurManagement_managmentTitle__U_ayZ","bannerSlider":"OurManagement_bannerSlider__6_7kd"};

/***/ }),

/***/ 20218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OwnPhoneInput_container__AwG48","separator":"OwnPhoneInput_separator__PIOIA","inputContainer":"OwnPhoneInput_inputContainer__Qq_19","active":"OwnPhoneInput_active___2z6a","input":"OwnPhoneInput_input__scQek","cabinetInput":"OwnPhoneInput_cabinetInput__ucYag"};

/***/ }),

/***/ 10607:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__lAcAm","item":"Pagination_item__fhhFK","active":"Pagination_active__7zGLD","nav":"Pagination_nav__Bs2BH","disabled":"Pagination_disabled__Dtmz9","icon":"Pagination_icon__YsScq","prev":"Pagination_prev__neSTY"};

/***/ }),

/***/ 3366:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"payments-cards__title":"PaymentCards_payments-cards__title__ROePI","payments-cards__inner":"PaymentCards_payments-cards__inner__Dne6R","payments-card":"PaymentCards_payments-card__GIweX","payments-card__logo":"PaymentCards_payments-card__logo__VCKl7","payments-card__logo-wrap":"PaymentCards_payments-card__logo-wrap__WHN2B","payments-card__content":"PaymentCards_payments-card__content__F34VK","payments-card__icon":"PaymentCards_payments-card__icon__wCzhR"};

/***/ }),

/***/ 19290:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__X62Xq","left":"styles_left__96zC_","active":"styles_active__mqRpF","listWrapper":"styles_listWrapper__G0ljw","container":"styles_container__Fb3xs","business":"styles_business__C_DBH","user":"styles_user__S31Wc","svgCurrency":"styles_svgCurrency__nCiJk","list":"styles_list__0cet3","signOut":"styles_signOut__YvZ1q","svg":"styles_svg__iLIwF","content":"styles_content__hX12q","price":"styles_price__4EL1C"};

/***/ }),

/***/ 73904:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirmModalOuter":"PopUpConfirm_confirmModalOuter__Tsbtm","confirmModal":"PopUpConfirm_confirmModal__3hDtZ","confirmModal__buttons":"PopUpConfirm_confirmModal__buttons__o1Qqa","confirmModal__innerDiv":"PopUpConfirm_confirmModal__innerDiv__WgvKY"};

/***/ }),

/***/ 11929:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"PopUpList_listWrapper__N0NCn","title":"PopUpList_title__2Zf7v","buttons":"PopUpList_buttons__HZFJL","list":"PopUpList_list__1vNUF","disabled":"PopUpList_disabled__WJptK","detail_box":"PopUpList_detail_box__jflCv","number_detail":"PopUpList_number_detail__GD0uw","number":"PopUpList_number__6w_47","label":"PopUpList_label__YYuIj","balance":"PopUpList_balance__jpaio","status":"PopUpList_status__vj4HA","add_icon":"PopUpList_add_icon__GfASf","add_new":"PopUpList_add_new__19gpU"};

/***/ }),

/***/ 64908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newLogin":"PopUpLogin_newLogin__epvRp","belongsText":"PopUpLogin_belongsText__x52su","belongsText__inside":"PopUpLogin_belongsText__inside___Eors","buttonGoBack":"PopUpLogin_buttonGoBack__NQon_","buttonWrapper":"PopUpLogin_buttonWrapper__kmBe9","buttonContinue":"PopUpLogin_buttonContinue__wDriQ"};

/***/ }),

/***/ 89194:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"otpVerify":"PopUpOtp_otpVerify__L9CuS","wrong_otp":"PopUpOtp_wrong_otp__d5jZD","disabled":"PopUpOtp_disabled__Hp47m","confirmButton":"PopUpOtp_confirmButton__Wo_6s"};

/***/ }),

/***/ 23804:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product-status":"ProductStatus_product-status__ASL5y","product-status__inner--block":"ProductStatus_product-status__inner--block__TeM1g","bottomContent":"ProductStatus_bottomContent__T6JQ5","product-status__content":"ProductStatus_product-status__content__N7Cvq","product-status__table":"ProductStatus_product-status__table__7ecsm","product-status__title":"ProductStatus_product-status__title__y1aB8","product-status__text":"ProductStatus_product-status__text__Bdx3z","productStatusTableBusiness":"ProductStatus_productStatusTableBusiness__uQ9oc","ussdCode":"ProductStatus_ussdCode__4VXuD","status-item":"ProductStatus_status-item__Fj5hz","status-item__img":"ProductStatus_status-item__img__WxdEt","status-item__content":"ProductStatus_status-item__content__RwABM","status-item__icon":"ProductStatus_status-item__icon__Nb32X","status-item__content__ussdCode":"ProductStatus_status-item__content__ussdCode__JRif2"};

/***/ }),

/***/ 35126:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inner_wrapper":"ProductsSectionFiber_inner_wrapper__dxbOr","top_wrapper":"ProductsSectionFiber_top_wrapper__lE1XZ","title_container":"ProductsSectionFiber_title_container__ih4Bx","titles":"ProductsSectionFiber_titles__XEPqH","info_text":"ProductsSectionFiber_info_text__aiFKC","bottom_wrapper":"ProductsSectionFiber_bottom_wrapper__1ybA4","product_container":"ProductsSectionFiber_product_container__WgE5b","product_name":"ProductsSectionFiber_product_name__7YONu","description":"ProductsSectionFiber_description__ncW_b"};

/***/ }),

/***/ 46979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"qr":"Qr_qr__GVzFB","qr__inner":"Qr_qr__inner__cP6r2","qr__links":"Qr_qr__links__T4OzT","qr-link":"Qr_qr-link__JZTYD","qr-link__logo":"Qr_qr-link__logo__Diarh","qr-item":"Qr_qr-item__Ne11O","qr-item__pic":"Qr_qr-item__pic__zBWyH"};

/***/ }),

/***/ 72503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__Ctet5","reverse":"styles_reverse___GERP","title":"styles_title__pZKqQ","medium":"styles_medium__h5Cdt"};

/***/ }),

/***/ 62172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rightImage":"RightImageBanner_rightImage__2gnKe","rightImage_banner__wrapper":"RightImageBanner_rightImage_banner__wrapper__qOx9G","content":"RightImageBanner_content__YV0tv","label":"RightImageBanner_label__zhH4k","title":"RightImageBanner_title__c9RDr","btn":"RightImageBanner_btn__jzLtH"};

/***/ }),

/***/ 16988:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"SEOText_content__jPWXI"};

/***/ }),

/***/ 30220:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ScreenLoader_container__1ADxK","visible":"ScreenLoader_visible__M6ubE","loader":"ScreenLoader_loader__0kr2n","loading":"ScreenLoader_loading__X3Kd2"};

/***/ }),

/***/ 43175:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search_wrapper":"SearchList_search_wrapper__jO_3j","list_item":"SearchList_list_item__f5kI8","list_item__title":"SearchList_list_item__title__2HGcf","list_item__desc":"SearchList_list_item__desc__tb7uz","search_breadcrumbs":"SearchList_search_breadcrumbs__JG4SC","arrow":"SearchList_arrow__JG2xO"};

/***/ }),

/***/ 78852:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"travel":"SearchTravel_travel__7m6UB","bottom_country_box":"SearchTravel_bottom_country_box__2owUy","travel__desc":"SearchTravel_travel__desc__GfGb2","travel__title":"SearchTravel_travel__title__4SvUi","travel__text":"SearchTravel_travel__text__HmV3K","travel__content":"SearchTravel_travel__content__azlRi","travel__form":"SearchTravel_travel__form__EJoiD","travel__popular":"SearchTravel_travel__popular__WkKJb","travel__button":"SearchTravel_travel__button__aBxKR","travel__popular-label":"SearchTravel_travel__popular-label__Ll__h","travel__popular-list":"SearchTravel_travel__popular-list__yX3we","travel__popular-item":"SearchTravel_travel__popular-item__PzgTw","travel__input":"SearchTravel_travel__input__toJPX","country-block":"SearchTravel_country-block__t7Rmb","country-block__inner":"SearchTravel_country-block__inner__VYZS3","country-block__caption":"SearchTravel_country-block__caption__3PS09","country-block__bottom":"SearchTravel_country-block__bottom__eukPB","country-block__text":"SearchTravel_country-block__text__S1jD6","country-block__icon":"SearchTravel_country-block__icon__gUHLP","country-block__warning":"SearchTravel_country-block__warning__bes7_","country-block__arrow":"SearchTravel_country-block__arrow__yWt6D","arrow-slide":"SearchTravel_arrow-slide__i2_7g","country-block__subtitle":"SearchTravel_country-block__subtitle__FW9PB","country-table":"SearchTravel_country-table__MP16K","country-table__row":"SearchTravel_country-table__row__kbdnm","country-table__item":"SearchTravel_country-table__item__swdVM","country-table__values":"SearchTravel_country-table__values__p8brq","country-table__item--big":"SearchTravel_country-table__item--big__2j42S","country-table__item-icon":"SearchTravel_country-table__item-icon__tIcjX","country-table__scrolled":"SearchTravel_country-table__scrolled__dxM_a","roamingResultTable":"SearchTravel_roamingResultTable__l335d","types":"SearchTravel_types__nF0nK","firstType":"SearchTravel_firstType__ohP01","item":"SearchTravel_item__HzWu5","typesSecondary":"SearchTravel_typesSecondary__vgIKd","scrollable":"SearchTravel_scrollable__6dtR1","header":"SearchTravel_header__XAMOK","prices":"SearchTravel_prices__F4zvK"};

/***/ }),

/***/ 82740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description":"description_description__t9jG1"};

/***/ }),

/***/ 73160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__Xag1D","title__container":"styles_title__container__EjB36","title__inner":"styles_title__inner__ThRNg","title__icon":"styles_title__icon__3uFwr","button":"styles_button__jca67"};

/***/ }),

/***/ 63686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchSelect":"Select_searchSelect__84Pj_","disabled":"Select_disabled__vtXLT","searchSelectField":"Select_searchSelectField__TBRkU","inputLabel":"Select_inputLabel__EjGIr","errorLabel":"Select_errorLabel__A9_Iy","input":"Select_input__wVdKW","selectList":"Select_selectList__7JgsX","notFound":"Select_notFound__NnH11","selectActive":"Select_selectActive__YGGEC"};

/***/ }),

/***/ 85691:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectDateTimeContainer":"SelectDateTime_selectDateTimeContainer__FlbOY","custom_select":"SelectDateTime_custom_select__j6Kds","dropdown_selected":"SelectDateTime_dropdown_selected__mYKh2","innerContainer":"SelectDateTime_innerContainer__B8dqo","select_items":"SelectDateTime_select_items__m2rGJ","weekDays":"SelectDateTime_weekDays__ys3G_","arrow_right_date":"SelectDateTime_arrow_right_date__ehJIs","arrow_right_hour":"SelectDateTime_arrow_right_hour__EOCdD","disabled":"SelectDateTime_disabled__UxSyu"};

/***/ }),

/***/ 10983:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrows_arrow__OpaK5","arrowBlock":"Arrows_arrowBlock__YxMHl"};

/***/ }),

/***/ 72719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__6Tusx","arrows":"styles_arrows__Tfggl","shadow":"styles_shadow__ZOjgi","slider__wrapper":"styles_slider__wrapper__JcOLC"};

/***/ }),

/***/ 44708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs":"StepsBanner_tabs__0Du1I","volte_modal_inner":"StepsBanner_volte_modal_inner__D3LSW","step-banner":"StepsBanner_step-banner___QkK6","step-banner__wrapper":"StepsBanner_step-banner__wrapper__5Eh1s","step-banner__content":"StepsBanner_step-banner__content__MrN2n","step-banner__head":"StepsBanner_step-banner__head__2nRch","step-banner__steps":"StepsBanner_step-banner__steps__f_4tS","step_banner_title":"StepsBanner_step_banner_title__uEBoV","step-banner__link":"StepsBanner_step-banner__link__5U5AD","step-banner__buttons":"StepsBanner_step-banner__buttons__V0qbV","steps_btn":"StepsBanner_steps_btn__DxQS3","step-banner__phone":"StepsBanner_step-banner__phone__IFZ2u","step-banner__phone-screen":"StepsBanner_step-banner__phone-screen__8V3Ib","step-banner__phone-frame":"StepsBanner_step-banner__phone-frame__cMofI","step-banner__phone-wrapper":"StepsBanner_step-banner__phone-wrapper__TXnYT","step-item":"StepsBanner_step-item__aTsUB","step-item--active":"StepsBanner_step-item--active__DS1Ep","step-item__count":"StepsBanner_step-item__count__Ydi_U"};

/***/ }),

/***/ 51950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stepsWrapper":"StepsWithImage_stepsWrapper__ZeWE6","mobileTitle":"StepsWithImage_mobileTitle__4DjaO","imageWrapper":"StepsWithImage_imageWrapper__HMEJC","stepsContainer":"StepsWithImage_stepsContainer__qqfkk","steps":"StepsWithImage_steps__dtg5n","stepItem":"StepsWithImage_stepItem___E2RR","left":"StepsWithImage_left__AkQGf","right":"StepsWithImage_right__shkPv","title":"StepsWithImage_title__kYGUu","description":"StepsWithImage_description__pBzsx","active":"StepsWithImage_active__56jda"};

/***/ }),

/***/ 53510:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"store-list_list__V0TdM","link":"store-list_link__a_RTE"};

/***/ }),

/***/ 91983:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subscribeWrapper":"Subscribe_subscribeWrapper__cqqzW","title":"Subscribe_title__jxwAQ","description":"Subscribe_description__HK0QK","subscribe":"Subscribe_subscribe__f2HwN","mailForm":"Subscribe_mailForm__V_iUX","mailForm__button":"Subscribe_mailForm__button__henD8","mailForm__input":"Subscribe_mailForm__input__jCC_T","error":"Subscribe_error__ATB8N","mailForm__label":"Subscribe_mailForm__label__Kopod"};

/***/ }),

/***/ 64973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__gqr3G","active":"styles_active__LRibM","panel":"styles_panel__DEzOK","content":"styles_content__gHJnK","activeContent":"styles_activeContent__UHE6z"};

/***/ }),

/***/ 7802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__DE_C_","contentBottom":"styles_contentBottom__Zi0e9","seeMore":"styles_seeMore__9jP7C","contentBottom__popUp":"styles_contentBottom__popUp__zW_ro","button":"styles_button__pA0X1","button__tariffButton":"styles_button__tariffButton__Ohf_v","icon":"styles_icon__Cdd2E","itemIcon":"styles_itemIcon__egOHD","icons":"styles_icons__T4CuN","infoText":"styles_infoText__zNDVz","itemContent":"styles_itemContent__Io690","info":"styles_info__H54wV","text":"styles_text__HalGM","tariff":"styles_tariff__2sSrG"};

/***/ }),

/***/ 14188:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tariffModal":"styles_tariffModal__ocSwO","backgroundWrapper":"styles_backgroundWrapper__lDw4F","top":"styles_top__6_FVR","titleTop":"styles_titleTop__pPXKc","rectangle":"styles_rectangle__rHRyg","priceContainer":"styles_priceContainer__cd36T","price":"styles_price__TqWuu","currency":"styles_currency__dNBRm","profitableText":"styles_profitableText__Sf6L2","text":"styles_text__peuYK","popular":"styles_popular__jpfIA","number":"styles_number__LBAUe","title":"styles_title__kAQe7","card":"styles_card__vyQRr","buttonContainer":"styles_buttonContainer__8pZ1E","tag":"styles_tag__7dt_4","ussd_label":"styles_ussd_label___aQRO","plus":"styles_plus__B5Ii2","black":"styles_black__asGMb","content":"styles_content__I0_Z_","list":"styles_list__Ds8to","itemContent":"styles_itemContent__r9wK4","info":"styles_info__b0WK8","item":"styles_item__d9d38","hot":"styles_hot__e_8ts","hotIcon":"styles_hotIcon__uojb2","mascotSmall":"styles_mascotSmall__BDM74","mascot":"styles_mascot__ESnfE","mascotMiddle":"styles_mascotMiddle__RD5lE","mascotBottom":"styles_mascotBottom__WtHL2","profitableCorner":"styles_profitableCorner__5coxl"};

/***/ }),

/***/ 98458:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__UBdon","content":"styles_content__K4tE6","list":"styles_list__0w1lD","icons":"styles_icons__2jo0y","value":"styles_value__Dvllo","top":"styles_top__V8pOS","price":"styles_price__1f4Ir","link":"styles_link__Cgxak","title":"styles_title__XQJhZ"};

/***/ }),

/***/ 74857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TermsConditions_wrap__vLwc_","closeModal":"TermsConditions_closeModal__kJM07","big":"TermsConditions_big__NXMlb","open":"TermsConditions_open__QgyN7","acceptButtons":"TermsConditions_acceptButtons__UIesd","termsInner":"TermsConditions_termsInner__wRRua","checkbox_label_terms":"TermsConditions_checkbox_label_terms__rytDK","centered_text":"TermsConditions_centered_text__Cnu7K","title":"TermsConditions_title__x6AuY","bottom_buttons":"TermsConditions_bottom_buttons__xJ5IL","button_groups":"TermsConditions_button_groups__VeWvd","download_btn":"TermsConditions_download_btn__xTZGo","print_btn":"TermsConditions_print_btn__9CMAB","terms_accept_btn":"TermsConditions_terms_accept_btn__dBg5e","terms_close_btn":"TermsConditions_terms_close_btn__qC4aZ","termsContent":"TermsConditions_termsContent__54IMa","close":"TermsConditions_close__ZLpcZ"};

/***/ }),

/***/ 72179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputField":"Textarea_inputField__gJI7A","title":"Textarea_title__yNYyZ","inputLabel":"Textarea_inputLabel__qEQI1","inputFieldItem":"Textarea_inputFieldItem__VJa0O","errorInput":"Textarea_errorInput___dYOl","error":"Textarea_error__fyAra"};

/***/ }),

/***/ 14733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titled_banner":"TitledBanner_titled_banner__fl4RB","content_wrapper":"TitledBanner_content_wrapper__crkig","title":"TitledBanner_title__yxb17","description":"TitledBanner_description__bm_5W","containers":"TitledBanner_containers__NT6cF"};

/***/ }),

/***/ 72493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ToolbarSectionTitle_container__iRrny","title":"ToolbarSectionTitle_title__WEyEF"};

/***/ }),

/***/ 95289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"tooltip_block__dRP5m","tip":"tooltip_tip__nAEpR"};

/***/ }),

/***/ 86401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalInner":"TopUpBalanceModal_modalInner__gA0cA","modalContent":"TopUpBalanceModal_modalContent__NdOJc","warning":"TopUpBalanceModal_warning__IQXrV","icon":"TopUpBalanceModal_icon__oycRd","text":"TopUpBalanceModal_text__ER0lt","red":"TopUpBalanceModal_red__CkcmP","klassKreditInfo":"TopUpBalanceModal_klassKreditInfo__rxFne","contentKlassKreditInfo":"TopUpBalanceModal_contentKlassKreditInfo__qe7e4","banner":"TopUpBalanceModal_banner__by9T6","amountTitle":"TopUpBalanceModal_amountTitle__CaWci","amounts":"TopUpBalanceModal_amounts__160H_","amount":"TopUpBalanceModal_amount__y04KI","amountSelect":"TopUpBalanceModal_amountSelect__2ai_p","content":"TopUpBalanceModal_content__cWzWV","contentUser":"TopUpBalanceModal_contentUser__9HK0C","contentCinKredit":"TopUpBalanceModal_contentCinKredit__cgUlu","price":"TopUpBalanceModal_price__wLctM","contentOnlinePayment":"TopUpBalanceModal_contentOnlinePayment__Obuvk","first":"TopUpBalanceModal_first__3oHkS","second":"TopUpBalanceModal_second__Ht0IR","third":"TopUpBalanceModal_third__XHfHa","goBack":"TopUpBalanceModal_goBack___q9nO","actions":"TopUpBalanceModal_actions__n6sO_","action":"TopUpBalanceModal_action____6I3","separation":"TopUpBalanceModal_separation__fIHt_","button":"TopUpBalanceModal_button__RJtZ2"};

/***/ }),

/***/ 78390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Video_wrap__8VxJH","show":"Video_show__BA_ti","title":"Video_title__zRWOu","time":"Video_time__4gE_b","img":"Video_img__S06S0","frame":"Video_frame__ZzNdo","playIcon":"Video_playIcon__Rxzvm","play":"Video_play__jh_Pd"};

/***/ }),

/***/ 3866:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-title":"VideoBlock_page-title__svDiP","page-text":"VideoBlock_page-text__QKv2e","peoplesList":"VideoBlock_peoplesList__IoCh6","video":"VideoBlock_video__z9DqX","videoContent":"VideoBlock_videoContent__DsBP3","close":"VideoBlock_close__mIbdc","videoItem":"VideoBlock_videoItem__qfUqY"};

/***/ }),

/***/ 49958:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoModal_video__EBspT","videoContent":"VideoModal_videoContent__WJUDJ","close":"VideoModal_close__Wp_g1","videoItem":"VideoModal_videoItem__hxXeB"};

/***/ }),

/***/ 10812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"who_we_are":"WhoWeAre_who_we_are__D8d7u","content":"WhoWeAre_content__BAxxa","decorated_title":"WhoWeAre_decorated_title__9Mos3","text_item":"WhoWeAre_text_item__Rzzf0","imageWrapper":"WhoWeAre_imageWrapper__CdSW4","btn_box":"WhoWeAre_btn_box__OuZcw"};

/***/ }),

/***/ 93545:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notFound":"YourNumberList_notFound___Ak77","container":"YourNumberList_container__BTqy5","panel":"YourNumberList_panel__zdBm_","red":"YourNumberList_red__CEh1m","left_side":"YourNumberList_left_side__7mMiE","tabs":"YourNumberList_tabs__UIur0","loadMoreContainer":"YourNumberList_loadMoreContainer__nhADN","loadMore":"YourNumberList_loadMore__Vi1nN","item":"YourNumberList_item__jYYmq","item__sim":"YourNumberList_item__sim__bWUaC","simLabels":"YourNumberList_simLabels__HONV0","rectangle":"YourNumberList_rectangle__16zCN","rectangle__freeDelivery":"YourNumberList_rectangle__freeDelivery__rzw1V","type":"YourNumberList_type__00e8P","type__sim__monthly":"YourNumberList_type__sim__monthly__eCvTa","simLabelsMobile":"YourNumberList_simLabelsMobile___vLTi","type__sim":"YourNumberList_type__sim__HPayq","info":"YourNumberList_info__6huHX","button":"YourNumberList_button__dz6rW","discount":"YourNumberList_discount__sumHM","price":"YourNumberList_price__UwljX","number":"YourNumberList_number__Hmdqa","selected":"YourNumberList_selected__USjLE","info__sim":"YourNumberList_info__sim__CURp9"};

/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

}]);